[
  {
    "id": "I0OS",
    "x": 16.608,
    "y": 3.234,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.0021535,
      "w": 1
    },
    "layers": [],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 0,
      "unknownStockCount": 0
    },
    "name": "I0OS",
    "leftNeighborShelfId": "26S4"
  },
  {
    "id": "26S4",
    "x": 17.607,
    "y": 3.2329,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0013391,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab63",
        "height": 0.18585,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab62",
        "height": 0.92043,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e8e",
            "leftCorner": {
              "x": 17.607,
              "y": 3.2447,
              "z": 0.92043
            },
            "rightCorner": {
              "x": 17.963,
              "y": 3.2457,
              "z": 0.92043
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506341"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e90",
            "leftCorner": {
              "x": 17.963,
              "y": 3.2457,
              "z": 0.92043
            },
            "rightCorner": {
              "x": 18.416,
              "y": 3.2469,
              "z": 0.92043
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506310"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e91",
            "leftCorner": {
              "x": 18.416,
              "y": 3.2469,
              "z": 0.92043
            },
            "rightCorner": {
              "x": 18.825,
              "y": 3.248,
              "z": 0.92043
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000001"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab64",
        "height": 1.5532,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e99",
            "leftCorner": {
              "x": 17.607,
              "y": 3.2434,
              "z": 1.5532
            },
            "rightCorner": {
              "x": 18.226,
              "y": 3.2451,
              "z": 1.5532
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447751017"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e9b",
            "leftCorner": {
              "x": 18.226,
              "y": 3.2451,
              "z": 1.5532
            },
            "rightCorner": {
              "x": 18.681,
              "y": 3.2463,
              "z": 1.5532
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322541459691"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 0,
      "unknownStockCount": 5
    },
    "name": "26S4",
    "leftNeighborShelfId": "3XA5",
    "rightNeighborShelfId": "I0OS"
  },
  {
    "id": "3XA5",
    "x": 18.614,
    "y": 3.229,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0062302,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab66",
        "height": 0.19083,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab67",
        "height": 0.92148,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e92",
            "leftCorner": {
              "x": 18.831,
              "y": 3.2476,
              "z": 0.92148
            },
            "rightCorner": {
              "x": 19.211,
              "y": 3.2523,
              "z": 0.92148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447787733"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e8f",
            "leftCorner": {
              "x": 19.211,
              "y": 3.2523,
              "z": 0.92148
            },
            "rightCorner": {
              "x": 19.613,
              "y": 3.2573,
              "z": 0.92148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447787672"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab65",
        "height": 1.5548,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e9c",
            "leftCorner": {
              "x": 18.687,
              "y": 3.2466,
              "z": 1.5548
            },
            "rightCorner": {
              "x": 18.945,
              "y": 3.2499,
              "z": 1.5548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541411828"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e9d",
            "leftCorner": {
              "x": 18.945,
              "y": 3.2499,
              "z": 1.5548
            },
            "rightCorner": {
              "x": 19.179,
              "y": 3.2528,
              "z": 1.5548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541147741"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e9a",
            "leftCorner": {
              "x": 19.179,
              "y": 3.2528,
              "z": 1.5548
            },
            "rightCorner": {
              "x": 19.613,
              "y": 3.2582,
              "z": 1.5548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000001"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 2,
      "unknownStockCount": 3
    },
    "name": "3XA5",
    "leftNeighborShelfId": "L5PL",
    "rightNeighborShelfId": "26S4"
  },
  {
    "id": "L5PL",
    "x": 19.583,
    "y": 3.2352,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0051392,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab6d",
        "height": 0.19437,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e93",
            "leftCorner": {
              "x": 19.69,
              "y": 3.1395,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 19.837,
              "y": 3.141,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000001"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e94",
            "leftCorner": {
              "x": 19.837,
              "y": 3.141,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 19.98,
              "y": 3.1425,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172927928"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e95",
            "leftCorner": {
              "x": 19.98,
              "y": 3.1425,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 20.115,
              "y": 3.1439,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172927928"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e96",
            "leftCorner": {
              "x": 20.115,
              "y": 3.1439,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 20.254,
              "y": 3.1453,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374773"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e97",
            "leftCorner": {
              "x": 20.254,
              "y": 3.1453,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 20.432,
              "y": 3.1471,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374797"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e98",
            "leftCorner": {
              "x": 20.432,
              "y": 3.1471,
              "z": 0.19437
            },
            "rightCorner": {
              "x": 20.582,
              "y": 3.1487,
              "z": 0.19437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374797"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab69",
        "height": 0.54566,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ea5",
            "leftCorner": {
              "x": 19.582,
              "y": 3.2487,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 19.744,
              "y": 3.2503,
              "z": 0.54566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172928024"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea7",
            "leftCorner": {
              "x": 19.744,
              "y": 3.2503,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 19.933,
              "y": 3.2523,
              "z": 0.54566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172928024"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea8",
            "leftCorner": {
              "x": 19.933,
              "y": 3.2523,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 20.1,
              "y": 3.254,
              "z": 0.54566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172928000"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea9",
            "leftCorner": {
              "x": 20.1,
              "y": 3.254,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 20.271,
              "y": 3.2558,
              "z": 0.54566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355486691"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eaa",
            "leftCorner": {
              "x": 20.271,
              "y": 3.2558,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 20.449,
              "y": 3.2576,
              "z": 0.54566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172928062"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea6",
            "leftCorner": {
              "x": 20.449,
              "y": 3.2576,
              "z": 0.54566
            },
            "rightCorner": {
              "x": 20.582,
              "y": 3.259,
              "z": 0.54566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172928086"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab6b",
        "height": 0.8378,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4eb2",
            "leftCorner": {
              "x": 19.582,
              "y": 3.2543,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 19.77,
              "y": 3.2562,
              "z": 0.8378
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447375138"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb4",
            "leftCorner": {
              "x": 19.77,
              "y": 3.2562,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 19.942,
              "y": 3.258,
              "z": 0.8378
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375152"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb5",
            "leftCorner": {
              "x": 19.942,
              "y": 3.258,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.08,
              "y": 3.2594,
              "z": 0.8378
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb6",
            "leftCorner": {
              "x": 20.08,
              "y": 3.2594,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.223,
              "y": 3.2609,
              "z": 0.8378
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447756548"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb7",
            "leftCorner": {
              "x": 20.223,
              "y": 3.2609,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.33,
              "y": 3.262,
              "z": 0.8378
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb8",
            "leftCorner": {
              "x": 20.33,
              "y": 3.262,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.362,
              "y": 3.2623,
              "z": 0.8378
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb9",
            "leftCorner": {
              "x": 20.362,
              "y": 3.2623,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.499,
              "y": 3.2637,
              "z": 0.8378
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000001"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb3",
            "leftCorner": {
              "x": 20.499,
              "y": 3.2637,
              "z": 0.8378
            },
            "rightCorner": {
              "x": 20.582,
              "y": 3.2646,
              "z": 0.8378
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172997105"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab6a",
        "height": 1.135,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4eab",
            "leftCorner": {
              "x": 19.582,
              "y": 3.2587,
              "z": 1.135
            },
            "rightCorner": {
              "x": 19.694,
              "y": 3.2599,
              "z": 1.135
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355274595"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eac",
            "leftCorner": {
              "x": 19.694,
              "y": 3.2599,
              "z": 1.135
            },
            "rightCorner": {
              "x": 19.871,
              "y": 3.2617,
              "z": 1.135
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260344220595"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ead",
            "leftCorner": {
              "x": 19.871,
              "y": 3.2617,
              "z": 1.135
            },
            "rightCorner": {
              "x": 20.054,
              "y": 3.2636,
              "z": 1.135
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260344220717"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eae",
            "leftCorner": {
              "x": 20.054,
              "y": 3.2636,
              "z": 1.135
            },
            "rightCorner": {
              "x": 20.232,
              "y": 3.2654,
              "z": 1.135
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260344220588"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eaf",
            "leftCorner": {
              "x": 20.232,
              "y": 3.2654,
              "z": 1.135
            },
            "rightCorner": {
              "x": 20.402,
              "y": 3.2671,
              "z": 1.135
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5029053575148"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb0",
            "leftCorner": {
              "x": 20.402,
              "y": 3.2671,
              "z": 1.135
            },
            "rightCorner": {
              "x": 20.55,
              "y": 3.2687,
              "z": 1.135
            },
            "stockLevel": "NO_STOCK",
            "gtin": "5029053579672"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eb1",
            "leftCorner": {
              "x": 20.55,
              "y": 3.2687,
              "z": 1.135
            },
            "rightCorner": {
              "x": 20.596,
              "y": 3.2691,
              "z": 1.135
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053575292"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab68",
        "height": 1.4298,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4e9e",
            "leftCorner": {
              "x": 19.582,
              "y": 3.2581,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 19.761,
              "y": 3.2599,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322542162132"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea0",
            "leftCorner": {
              "x": 19.761,
              "y": 3.2599,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 19.912,
              "y": 3.2615,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540907520"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea1",
            "leftCorner": {
              "x": 19.912,
              "y": 3.2615,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 20.068,
              "y": 3.2631,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541803418"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea2",
            "leftCorner": {
              "x": 20.068,
              "y": 3.2631,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 20.219,
              "y": 3.2647,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541420493"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea3",
            "leftCorner": {
              "x": 20.219,
              "y": 3.2647,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 20.377,
              "y": 3.2663,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5029053575179"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ea4",
            "leftCorner": {
              "x": 20.377,
              "y": 3.2663,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 20.537,
              "y": 3.2679,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000002"
          },
          {
            "id": "679afb3c3d9bab0f83ff4e9f",
            "leftCorner": {
              "x": 20.537,
              "y": 3.2679,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 20.582,
              "y": 3.2684,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4262368580303"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab6c",
        "height": 1.7257,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4eba",
            "leftCorner": {
              "x": 19.582,
              "y": 3.26,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 19.767,
              "y": 3.2619,
              "z": 1.7257
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322541208251"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ebc",
            "leftCorner": {
              "x": 19.767,
              "y": 3.2619,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 19.922,
              "y": 3.2635,
              "z": 1.7257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540907551"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ebd",
            "leftCorner": {
              "x": 19.922,
              "y": 3.2635,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 20.073,
              "y": 3.265,
              "z": 1.7257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540952841"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ebe",
            "leftCorner": {
              "x": 20.073,
              "y": 3.265,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 20.222,
              "y": 3.2665,
              "z": 1.7257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541102092"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ebf",
            "leftCorner": {
              "x": 20.222,
              "y": 3.2665,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 20.387,
              "y": 3.2682,
              "z": 1.7257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322542461556"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec0",
            "leftCorner": {
              "x": 20.387,
              "y": 3.2682,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 20.537,
              "y": 3.2698,
              "z": 1.7257
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322541208381"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ebb",
            "leftCorner": {
              "x": 20.537,
              "y": 3.2698,
              "z": 1.7257
            },
            "rightCorner": {
              "x": 20.582,
              "y": 3.2702,
              "z": 1.7257
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4170000037668"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 28,
      "unknownStockCount": 12
    },
    "name": "L5PL",
    "leftNeighborShelfId": "KVLU",
    "rightNeighborShelfId": "3XA5"
  },
  {
    "id": "KVLU",
    "x": 20.618,
    "y": 3.2443,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0014679,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab70",
        "height": 0.19452,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab6f",
        "height": 0.79812,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab71",
        "height": 1.1372,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab6e",
        "height": 1.593,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ec1",
            "leftCorner": {
              "x": 20.618,
              "y": 3.2536,
              "z": 1.593
            },
            "rightCorner": {
              "x": 20.868,
              "y": 3.2543,
              "z": 1.593
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000002"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec2",
            "leftCorner": {
              "x": 20.868,
              "y": 3.2543,
              "z": 1.593
            },
            "rightCorner": {
              "x": 21.097,
              "y": 3.255,
              "z": 1.593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541458960"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec3",
            "leftCorner": {
              "x": 21.097,
              "y": 3.255,
              "z": 1.593
            },
            "rightCorner": {
              "x": 21.471,
              "y": 3.2561,
              "z": 1.593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540973044"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 2,
      "unknownStockCount": 1
    },
    "name": "KVLU",
    "leftNeighborShelfId": "UD1F",
    "rightNeighborShelfId": "L5PL"
  },
  {
    "id": "5FV2",
    "x": 46.499,
    "y": 10.184,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.87665,
      "w": -0.48114
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab77",
        "height": 0.1632,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f16",
            "leftCorner": {
              "x": 46.405,
              "y": 10.236,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.363,
              "y": 10.17,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563160461"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f17",
            "leftCorner": {
              "x": 46.363,
              "y": 10.17,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.327,
              "y": 10.114,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563160461"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f18",
            "leftCorner": {
              "x": 46.327,
              "y": 10.114,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.313,
              "y": 10.092,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "1000015889"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f19",
            "leftCorner": {
              "x": 46.313,
              "y": 10.092,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.297,
              "y": 10.066,
              "z": 0.1632
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5054563193414"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1a",
            "leftCorner": {
              "x": 46.297,
              "y": 10.066,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.273,
              "y": 10.029,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563193414"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1b",
            "leftCorner": {
              "x": 46.273,
              "y": 10.029,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.237,
              "y": 9.9724,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563193445"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1c",
            "leftCorner": {
              "x": 46.237,
              "y": 9.9724,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.204,
              "y": 9.9196,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260486334051"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1d",
            "leftCorner": {
              "x": 46.204,
              "y": 9.9196,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.186,
              "y": 9.8912,
              "z": 0.1632
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260486334051"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1e",
            "leftCorner": {
              "x": 46.186,
              "y": 9.8912,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.127,
              "y": 9.7993,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181501456"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f1f",
            "leftCorner": {
              "x": 46.127,
              "y": 9.7993,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.1,
              "y": 9.7562,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277548"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f20",
            "leftCorner": {
              "x": 46.1,
              "y": 9.7562,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 46.056,
              "y": 9.6878,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447190311"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f21",
            "leftCorner": {
              "x": 46.056,
              "y": 9.6878,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 45.991,
              "y": 9.5855,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447717648"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f22",
            "leftCorner": {
              "x": 45.991,
              "y": 9.5855,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 45.921,
              "y": 9.4753,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447719123"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f23",
            "leftCorner": {
              "x": 45.921,
              "y": 9.4753,
              "z": 0.1632
            },
            "rightCorner": {
              "x": 45.821,
              "y": 9.3187,
              "z": 0.1632
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab75",
        "height": 0.46593,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ee2",
            "leftCorner": {
              "x": 46.503,
              "y": 10.182,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.46,
              "y": 10.114,
              "z": 0.46593
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7610108060252"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee3",
            "leftCorner": {
              "x": 46.46,
              "y": 10.114,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.426,
              "y": 10.061,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108060252"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee4",
            "leftCorner": {
              "x": 46.426,
              "y": 10.061,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.374,
              "y": 9.9792,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000003"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee5",
            "leftCorner": {
              "x": 46.374,
              "y": 9.9792,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.324,
              "y": 9.901,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4007965146008"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee6",
            "leftCorner": {
              "x": 46.324,
              "y": 9.901,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.285,
              "y": 9.8398,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951271234"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee7",
            "leftCorner": {
              "x": 46.285,
              "y": 9.8398,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.27,
              "y": 9.8151,
              "z": 0.46593
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee8",
            "leftCorner": {
              "x": 46.27,
              "y": 9.8151,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.228,
              "y": 9.7491,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951582378"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee9",
            "leftCorner": {
              "x": 46.228,
              "y": 9.7491,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.202,
              "y": 9.7087,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563219657"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eea",
            "leftCorner": {
              "x": 46.202,
              "y": 9.7087,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.178,
              "y": 9.6712,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563219657"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eeb",
            "leftCorner": {
              "x": 46.178,
              "y": 9.6712,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.155,
              "y": 9.6349,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563219206"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eec",
            "leftCorner": {
              "x": 46.155,
              "y": 9.6349,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.105,
              "y": 9.5564,
              "z": 0.46593
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008666812247"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eed",
            "leftCorner": {
              "x": 46.105,
              "y": 9.5564,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 46.011,
              "y": 9.4092,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666812162"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eee",
            "leftCorner": {
              "x": 46.011,
              "y": 9.4092,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 45.983,
              "y": 9.3651,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638081863"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eef",
            "leftCorner": {
              "x": 45.983,
              "y": 9.3651,
              "z": 0.46593
            },
            "rightCorner": {
              "x": 45.962,
              "y": 9.3321,
              "z": 0.46593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638081863"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab74",
        "height": 0.7193,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ec8",
            "leftCorner": {
              "x": 46.51,
              "y": 10.177,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.46,
              "y": 10.099,
              "z": 0.7193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448213512"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eca",
            "leftCorner": {
              "x": 46.46,
              "y": 10.099,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.407,
              "y": 10.016,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448213512"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ecb",
            "leftCorner": {
              "x": 46.407,
              "y": 10.016,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.348,
              "y": 9.9233,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563091970"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ecc",
            "leftCorner": {
              "x": 46.348,
              "y": 9.9233,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.278,
              "y": 9.813,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447749526"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ecd",
            "leftCorner": {
              "x": 46.278,
              "y": 9.813,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.215,
              "y": 9.7132,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447749540"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ece",
            "leftCorner": {
              "x": 46.215,
              "y": 9.7132,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.155,
              "y": 9.6204,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448038900"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ecf",
            "leftCorner": {
              "x": 46.155,
              "y": 9.6204,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.095,
              "y": 9.525,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172063466"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed0",
            "leftCorner": {
              "x": 46.095,
              "y": 9.525,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 46.035,
              "y": 9.4313,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447776539"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed1",
            "leftCorner": {
              "x": 46.035,
              "y": 9.4313,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 45.999,
              "y": 9.3753,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4026600851503"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed2",
            "leftCorner": {
              "x": 45.999,
              "y": 9.3753,
              "z": 0.7193
            },
            "rightCorner": {
              "x": 45.966,
              "y": 9.3229,
              "z": 0.7193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001478456760"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab76",
        "height": 0.9681,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4eff",
            "leftCorner": {
              "x": 46.51,
              "y": 10.177,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.438,
              "y": 10.064,
              "z": 0.9681
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540314951"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f00",
            "leftCorner": {
              "x": 46.438,
              "y": 10.064,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.424,
              "y": 10.042,
              "z": 0.9681
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f01",
            "leftCorner": {
              "x": 46.424,
              "y": 10.042,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.331,
              "y": 9.8966,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540315033"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f02",
            "leftCorner": {
              "x": 46.331,
              "y": 9.8966,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.28,
              "y": 9.8161,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540314791"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f03",
            "leftCorner": {
              "x": 46.28,
              "y": 9.8161,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.246,
              "y": 9.7628,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540314791"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f04",
            "leftCorner": {
              "x": 46.246,
              "y": 9.7628,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.232,
              "y": 9.7409,
              "z": 0.9681
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f05",
            "leftCorner": {
              "x": 46.232,
              "y": 9.7409,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.159,
              "y": 9.6265,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f06",
            "leftCorner": {
              "x": 46.159,
              "y": 9.6265,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.069,
              "y": 9.4843,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932002171"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f07",
            "leftCorner": {
              "x": 46.069,
              "y": 9.4843,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 46.022,
              "y": 9.4106,
              "z": 0.9681
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932002218"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f08",
            "leftCorner": {
              "x": 46.022,
              "y": 9.4106,
              "z": 0.9681
            },
            "rightCorner": {
              "x": 45.952,
              "y": 9.3012,
              "z": 0.9681
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5054563074300"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab78",
        "height": 1.3352,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab72",
        "height": 1.5284,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 38,
      "unknownStockCount": 10
    },
    "name": "5FV2",
    "rightNeighborShelfId": "3R6D"
  },
  {
    "id": "UD1F",
    "x": 21.596,
    "y": 3.2523,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.0059483,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab7b",
        "height": 0.19397,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab79",
        "height": 0.79978,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ec7",
            "leftCorner": {
              "x": 21.703,
              "y": 3.2614,
              "z": 0.79978
            },
            "rightCorner": {
              "x": 22.596,
              "y": 3.2508,
              "z": 0.79978
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447484519"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab7c",
        "height": 1.1336,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab7a",
        "height": 1.5973,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ec4",
            "leftCorner": {
              "x": 21.471,
              "y": 3.2561,
              "z": 1.593
            },
            "rightCorner": {
              "x": 21.867,
              "y": 3.2572,
              "z": 1.593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000003"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec5",
            "leftCorner": {
              "x": 21.845,
              "y": 3.2696,
              "z": 1.5973
            },
            "rightCorner": {
              "x": 22.188,
              "y": 3.2655,
              "z": 1.5973
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000005"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec6",
            "leftCorner": {
              "x": 22.188,
              "y": 3.2655,
              "z": 1.5973
            },
            "rightCorner": {
              "x": 22.593,
              "y": 3.2607,
              "z": 1.5973
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322540973235"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 1,
      "unknownStockCount": 3
    },
    "name": "UD1F",
    "leftNeighborShelfId": "TNRU",
    "rightNeighborShelfId": "KVLU"
  },
  {
    "id": "8K9F",
    "x": 23.672,
    "y": 4.7179,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": 0.001407
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab7f",
        "height": 0.19672,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f7a",
            "leftCorner": {
              "x": 23.672,
              "y": 4.8248,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.624,
              "y": 4.8249,
              "z": 0.19672
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f7b",
            "leftCorner": {
              "x": 23.624,
              "y": 4.8249,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.559,
              "y": 4.8251,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f7c",
            "leftCorner": {
              "x": 23.559,
              "y": 4.8251,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.528,
              "y": 4.8252,
              "z": 0.19672
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447580297"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f7d",
            "leftCorner": {
              "x": 23.528,
              "y": 4.8252,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.436,
              "y": 4.8254,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447580297"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f7e",
            "leftCorner": {
              "x": 23.436,
              "y": 4.8254,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.345,
              "y": 4.8257,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f7f",
            "leftCorner": {
              "x": 23.345,
              "y": 4.8257,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.255,
              "y": 4.8259,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f80",
            "leftCorner": {
              "x": 23.255,
              "y": 4.8259,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.166,
              "y": 4.8262,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f81",
            "leftCorner": {
              "x": 23.166,
              "y": 4.8262,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 23.077,
              "y": 4.8264,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621427"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f82",
            "leftCorner": {
              "x": 23.077,
              "y": 4.8264,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 22.99,
              "y": 4.8267,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621427"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f83",
            "leftCorner": {
              "x": 22.99,
              "y": 4.8267,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 22.888,
              "y": 4.827,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621342"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f84",
            "leftCorner": {
              "x": 22.888,
              "y": 4.827,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 22.791,
              "y": 4.8272,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216621342"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f85",
            "leftCorner": {
              "x": 22.791,
              "y": 4.8272,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 22.695,
              "y": 4.8275,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f86",
            "leftCorner": {
              "x": 22.695,
              "y": 4.8275,
              "z": 0.19672
            },
            "rightCorner": {
              "x": 22.625,
              "y": 4.8277,
              "z": 0.19672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab7d",
        "height": 0.54582,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f33",
            "leftCorner": {
              "x": 23.672,
              "y": 4.715,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.636,
              "y": 4.7151,
              "z": 0.54582
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f34",
            "leftCorner": {
              "x": 23.636,
              "y": 4.7151,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.537,
              "y": 4.7153,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447228830"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f35",
            "leftCorner": {
              "x": 23.537,
              "y": 4.7153,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.467,
              "y": 4.7155,
              "z": 0.54582
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000003"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f36",
            "leftCorner": {
              "x": 23.467,
              "y": 4.7155,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.44,
              "y": 4.7156,
              "z": 0.54582
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f37",
            "leftCorner": {
              "x": 23.44,
              "y": 4.7156,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.341,
              "y": 4.7159,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f38",
            "leftCorner": {
              "x": 23.341,
              "y": 4.7159,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.251,
              "y": 4.7161,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447352269"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f39",
            "leftCorner": {
              "x": 23.251,
              "y": 4.7161,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.164,
              "y": 4.7164,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447352269"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3a",
            "leftCorner": {
              "x": 23.164,
              "y": 4.7164,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23.063,
              "y": 4.7167,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447352269"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3b",
            "leftCorner": {
              "x": 23.063,
              "y": 4.7167,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 23,
              "y": 4.7169,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162033294"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3c",
            "leftCorner": {
              "x": 23,
              "y": 4.7169,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 22.935,
              "y": 4.717,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162033294"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3d",
            "leftCorner": {
              "x": 22.935,
              "y": 4.717,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 22.859,
              "y": 4.7173,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045607001018"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3e",
            "leftCorner": {
              "x": 22.859,
              "y": 4.7173,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 22.785,
              "y": 4.7175,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447706741"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f3f",
            "leftCorner": {
              "x": 22.785,
              "y": 4.7175,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 22.674,
              "y": 4.7178,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447706789"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f40",
            "leftCorner": {
              "x": 22.674,
              "y": 4.7178,
              "z": 0.54582
            },
            "rightCorner": {
              "x": 22.626,
              "y": 4.7179,
              "z": 0.54582
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447706789"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab82",
        "height": 0.83774,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fc9",
            "leftCorner": {
              "x": 23.672,
              "y": 4.7131,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.614,
              "y": 4.7133,
              "z": 0.83774
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447322545"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fcb",
            "leftCorner": {
              "x": 23.614,
              "y": 4.7133,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.48,
              "y": 4.7137,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447322545"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fcc",
            "leftCorner": {
              "x": 23.48,
              "y": 4.7137,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.453,
              "y": 4.7137,
              "z": 0.83774
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fcd",
            "leftCorner": {
              "x": 23.453,
              "y": 4.7137,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.356,
              "y": 4.714,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783452"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fce",
            "leftCorner": {
              "x": 23.356,
              "y": 4.714,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.256,
              "y": 4.7143,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783452"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fcf",
            "leftCorner": {
              "x": 23.256,
              "y": 4.7143,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.164,
              "y": 4.7146,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783452"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd0",
            "leftCorner": {
              "x": 23.164,
              "y": 4.7146,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 23.067,
              "y": 4.7148,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783452"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd1",
            "leftCorner": {
              "x": 23.067,
              "y": 4.7148,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 22.965,
              "y": 4.7151,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd2",
            "leftCorner": {
              "x": 22.965,
              "y": 4.7151,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 22.865,
              "y": 4.7154,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783438"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd3",
            "leftCorner": {
              "x": 22.865,
              "y": 4.7154,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 22.758,
              "y": 4.7157,
              "z": 0.83774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783438"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fca",
            "leftCorner": {
              "x": 22.758,
              "y": 4.7157,
              "z": 0.83774
            },
            "rightCorner": {
              "x": 22.672,
              "y": 4.7159,
              "z": 0.83774
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab80",
        "height": 1.1315,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fb4",
            "leftCorner": {
              "x": 23.64,
              "y": 4.7111,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.542,
              "y": 4.7113,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb5",
            "leftCorner": {
              "x": 23.542,
              "y": 4.7113,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.474,
              "y": 4.7115,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054774"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb6",
            "leftCorner": {
              "x": 23.474,
              "y": 4.7115,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.448,
              "y": 4.7116,
              "z": 1.1315
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb7",
            "leftCorner": {
              "x": 23.448,
              "y": 4.7116,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.344,
              "y": 4.7119,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb8",
            "leftCorner": {
              "x": 23.344,
              "y": 4.7119,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.253,
              "y": 4.7121,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447437188"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb9",
            "leftCorner": {
              "x": 23.253,
              "y": 4.7121,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.157,
              "y": 4.7124,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447437188"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fba",
            "leftCorner": {
              "x": 23.157,
              "y": 4.7124,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 23.066,
              "y": 4.7127,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447437188"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fbb",
            "leftCorner": {
              "x": 23.066,
              "y": 4.7127,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 22.975,
              "y": 4.7129,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447437171"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fbc",
            "leftCorner": {
              "x": 22.975,
              "y": 4.7129,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 22.865,
              "y": 4.7132,
              "z": 1.1315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447437171"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fbd",
            "leftCorner": {
              "x": 22.865,
              "y": 4.7132,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 22.762,
              "y": 4.7135,
              "z": 1.1315
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447366914"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb3",
            "leftCorner": {
              "x": 22.762,
              "y": 4.7135,
              "z": 1.1315
            },
            "rightCorner": {
              "x": 22.672,
              "y": 4.7138,
              "z": 1.1315
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447366914"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab7e",
        "height": 1.4257,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f6f",
            "leftCorner": {
              "x": 23.653,
              "y": 4.7089,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.547,
              "y": 4.7092,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f70",
            "leftCorner": {
              "x": 23.547,
              "y": 4.7092,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.476,
              "y": 4.7094,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000005"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f71",
            "leftCorner": {
              "x": 23.476,
              "y": 4.7094,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.451,
              "y": 4.7095,
              "z": 1.4257
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f72",
            "leftCorner": {
              "x": 23.451,
              "y": 4.7095,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.358,
              "y": 4.7097,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499964510"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f73",
            "leftCorner": {
              "x": 23.358,
              "y": 4.7097,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.269,
              "y": 4.71,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499963506"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f74",
            "leftCorner": {
              "x": 23.269,
              "y": 4.71,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.18,
              "y": 4.7102,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499964558"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f75",
            "leftCorner": {
              "x": 23.18,
              "y": 4.7102,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.096,
              "y": 4.7105,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499964541"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f76",
            "leftCorner": {
              "x": 23.096,
              "y": 4.7105,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 23.008,
              "y": 4.7107,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499964541"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f77",
            "leftCorner": {
              "x": 23.008,
              "y": 4.7107,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 22.9,
              "y": 4.711,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499938313"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f78",
            "leftCorner": {
              "x": 22.9,
              "y": 4.711,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 22.818,
              "y": 4.7112,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162023967"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f79",
            "leftCorner": {
              "x": 22.818,
              "y": 4.7112,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 22.737,
              "y": 4.7115,
              "z": 1.4257
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162023929"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f6e",
            "leftCorner": {
              "x": 22.737,
              "y": 4.7115,
              "z": 1.4257
            },
            "rightCorner": {
              "x": 22.672,
              "y": 4.7116,
              "z": 1.4257
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5412533416862"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab81",
        "height": 1.7627,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fbf",
            "leftCorner": {
              "x": 23.656,
              "y": 4.7096,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.566,
              "y": 4.7098,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034652"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc0",
            "leftCorner": {
              "x": 23.566,
              "y": 4.7098,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.478,
              "y": 4.7101,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034669"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc1",
            "leftCorner": {
              "x": 23.478,
              "y": 4.7101,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.388,
              "y": 4.7103,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034669"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc2",
            "leftCorner": {
              "x": 23.388,
              "y": 4.7103,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.294,
              "y": 4.7106,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034522"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc3",
            "leftCorner": {
              "x": 23.294,
              "y": 4.7106,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.203,
              "y": 4.7108,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034522"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc4",
            "leftCorner": {
              "x": 23.203,
              "y": 4.7108,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.118,
              "y": 4.7111,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034508"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc5",
            "leftCorner": {
              "x": 23.118,
              "y": 4.7111,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 23.029,
              "y": 4.7113,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034539"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc6",
            "leftCorner": {
              "x": 23.029,
              "y": 4.7113,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 22.934,
              "y": 4.7116,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034515"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc7",
            "leftCorner": {
              "x": 22.934,
              "y": 4.7116,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 22.838,
              "y": 4.7119,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200034515"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fc8",
            "leftCorner": {
              "x": 22.838,
              "y": 4.7119,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 22.733,
              "y": 4.7122,
              "z": 1.7627
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200032757"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fbe",
            "leftCorner": {
              "x": 22.733,
              "y": 4.7122,
              "z": 1.7627
            },
            "rightCorner": {
              "x": 22.672,
              "y": 4.7123,
              "z": 1.7627
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200032771"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 58,
      "unknownStockCount": 13
    },
    "name": "8K9F",
    "leftNeighborShelfId": "1SKP",
    "rightNeighborShelfId": "B4C6"
  },
  {
    "id": "B4C6",
    "x": 22.655,
    "y": 4.7227,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.0029478
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab86",
        "height": 0.19513,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f87",
            "leftCorner": {
              "x": 22.607,
              "y": 4.8294,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.574,
              "y": 4.8292,
              "z": 0.19513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216621380"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f88",
            "leftCorner": {
              "x": 22.574,
              "y": 4.8292,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.524,
              "y": 4.8289,
              "z": 0.19513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216621380"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f89",
            "leftCorner": {
              "x": 22.524,
              "y": 4.8289,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.486,
              "y": 4.8287,
              "z": 0.19513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216621380"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8a",
            "leftCorner": {
              "x": 22.486,
              "y": 4.8287,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.448,
              "y": 4.8285,
              "z": 0.19513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8b",
            "leftCorner": {
              "x": 22.448,
              "y": 4.8285,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.397,
              "y": 4.8282,
              "z": 0.19513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8714789952581"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8c",
            "leftCorner": {
              "x": 22.397,
              "y": 4.8282,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.31,
              "y": 4.8277,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789952581"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8d",
            "leftCorner": {
              "x": 22.31,
              "y": 4.8277,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.215,
              "y": 4.8271,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090973290"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8e",
            "leftCorner": {
              "x": 22.215,
              "y": 4.8271,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 22.089,
              "y": 4.8264,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090974136"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f8f",
            "leftCorner": {
              "x": 22.089,
              "y": 4.8264,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 21.959,
              "y": 4.8256,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090974136"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f90",
            "leftCorner": {
              "x": 21.959,
              "y": 4.8256,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 21.843,
              "y": 4.8249,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000960847"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f91",
            "leftCorner": {
              "x": 21.843,
              "y": 4.8249,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 21.749,
              "y": 4.8244,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231441"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f92",
            "leftCorner": {
              "x": 21.749,
              "y": 4.8244,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 21.665,
              "y": 4.8239,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231441"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab84",
        "height": 0.54334,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f41",
            "leftCorner": {
              "x": 22.61,
              "y": 4.7214,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.529,
              "y": 4.7209,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499960178"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f42",
            "leftCorner": {
              "x": 22.529,
              "y": 4.7209,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.436,
              "y": 4.7204,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499960178"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f43",
            "leftCorner": {
              "x": 22.436,
              "y": 4.7204,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.389,
              "y": 4.7201,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f44",
            "leftCorner": {
              "x": 22.389,
              "y": 4.7201,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.349,
              "y": 4.7198,
              "z": 0.54334
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f45",
            "leftCorner": {
              "x": 22.349,
              "y": 4.7198,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.257,
              "y": 4.7193,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489302"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f46",
            "leftCorner": {
              "x": 22.257,
              "y": 4.7193,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.171,
              "y": 4.7188,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f47",
            "leftCorner": {
              "x": 22.171,
              "y": 4.7188,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 22.039,
              "y": 4.718,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758404657"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f48",
            "leftCorner": {
              "x": 22.039,
              "y": 4.718,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 21.945,
              "y": 4.7175,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260006920009"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f49",
            "leftCorner": {
              "x": 21.945,
              "y": 4.7175,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 21.857,
              "y": 4.717,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758407054"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f4a",
            "leftCorner": {
              "x": 21.857,
              "y": 4.717,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 21.757,
              "y": 4.7164,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448077640"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f4b",
            "leftCorner": {
              "x": 21.757,
              "y": 4.7164,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 21.693,
              "y": 4.716,
              "z": 0.54334
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448077640"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab83",
        "height": 0.9174,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fd4",
            "leftCorner": {
              "x": 22.655,
              "y": 4.7128,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.544,
              "y": 4.7121,
              "z": 0.9174
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001499960161"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd6",
            "leftCorner": {
              "x": 22.544,
              "y": 4.7121,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.441,
              "y": 4.7115,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499960161"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd7",
            "leftCorner": {
              "x": 22.441,
              "y": 4.7115,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.397,
              "y": 4.7113,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499192791"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd8",
            "leftCorner": {
              "x": 22.397,
              "y": 4.7113,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.353,
              "y": 4.711,
              "z": 0.9174
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001499192791"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd9",
            "leftCorner": {
              "x": 22.353,
              "y": 4.711,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.268,
              "y": 4.7105,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499140648"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fda",
            "leftCorner": {
              "x": 22.268,
              "y": 4.7105,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.174,
              "y": 4.71,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961502"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fdb",
            "leftCorner": {
              "x": 22.174,
              "y": 4.71,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 22.076,
              "y": 4.7094,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961526"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fdc",
            "leftCorner": {
              "x": 22.076,
              "y": 4.7094,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 21.977,
              "y": 4.7088,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289619"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fdd",
            "leftCorner": {
              "x": 21.977,
              "y": 4.7088,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 21.879,
              "y": 4.7082,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289619"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fde",
            "leftCorner": {
              "x": 21.879,
              "y": 4.7082,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 21.785,
              "y": 4.7077,
              "z": 0.9174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185762"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fd5",
            "leftCorner": {
              "x": 21.785,
              "y": 4.7077,
              "z": 0.9174
            },
            "rightCorner": {
              "x": 21.656,
              "y": 4.7069,
              "z": 0.9174
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172185762"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab85",
        "height": 1.297,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fdf",
            "leftCorner": {
              "x": 22.655,
              "y": 4.7176,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.534,
              "y": 4.7169,
              "z": 1.297
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000970921"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe1",
            "leftCorner": {
              "x": 22.534,
              "y": 4.7169,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.418,
              "y": 4.7162,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000970921"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe2",
            "leftCorner": {
              "x": 22.418,
              "y": 4.7162,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.309,
              "y": 4.7156,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000970921"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe3",
            "leftCorner": {
              "x": 22.309,
              "y": 4.7156,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.213,
              "y": 4.715,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090973238"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe4",
            "leftCorner": {
              "x": 22.213,
              "y": 4.715,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.115,
              "y": 4.7144,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499926143"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe5",
            "leftCorner": {
              "x": 22.115,
              "y": 4.7144,
              "z": 1.297
            },
            "rightCorner": {
              "x": 22.034,
              "y": 4.7139,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455603117"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe6",
            "leftCorner": {
              "x": 22.034,
              "y": 4.7139,
              "z": 1.297
            },
            "rightCorner": {
              "x": 21.937,
              "y": 4.7134,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355139825"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe7",
            "leftCorner": {
              "x": 21.937,
              "y": 4.7134,
              "z": 1.297
            },
            "rightCorner": {
              "x": 21.863,
              "y": 4.7129,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517767"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe8",
            "leftCorner": {
              "x": 21.863,
              "y": 4.7129,
              "z": 1.297
            },
            "rightCorner": {
              "x": 21.788,
              "y": 4.7125,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517767"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe9",
            "leftCorner": {
              "x": 21.788,
              "y": 4.7125,
              "z": 1.297
            },
            "rightCorner": {
              "x": 21.733,
              "y": 4.7122,
              "z": 1.297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355055774"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fe0",
            "leftCorner": {
              "x": 21.733,
              "y": 4.7122,
              "z": 1.297
            },
            "rightCorner": {
              "x": 21.655,
              "y": 4.7117,
              "z": 1.297
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000004"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab87",
        "height": 1.6763,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fea",
            "leftCorner": {
              "x": 22.655,
              "y": 4.7158,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.501,
              "y": 4.7149,
              "z": 1.6763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000969734"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fec",
            "leftCorner": {
              "x": 22.501,
              "y": 4.7149,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.406,
              "y": 4.7143,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961465"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fed",
            "leftCorner": {
              "x": 22.406,
              "y": 4.7143,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.31,
              "y": 4.7138,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961465"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fee",
            "leftCorner": {
              "x": 22.31,
              "y": 4.7138,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.199,
              "y": 4.7131,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499953958"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fef",
            "leftCorner": {
              "x": 22.199,
              "y": 4.7131,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.106,
              "y": 4.7126,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489241"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff0",
            "leftCorner": {
              "x": 22.106,
              "y": 4.7126,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 22.01,
              "y": 4.712,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489241"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff1",
            "leftCorner": {
              "x": 22.01,
              "y": 4.712,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 21.914,
              "y": 4.7114,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489241"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff2",
            "leftCorner": {
              "x": 21.914,
              "y": 4.7114,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 21.853,
              "y": 4.7111,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172924583"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff3",
            "leftCorner": {
              "x": 21.853,
              "y": 4.7111,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 21.794,
              "y": 4.7107,
              "z": 1.6763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172924583"
          },
          {
            "id": "679afb3c3d9bab0f83ff4feb",
            "leftCorner": {
              "x": 21.794,
              "y": 4.7107,
              "z": 1.6763
            },
            "rightCorner": {
              "x": 21.655,
              "y": 4.7099,
              "z": 1.6763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447090925"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 42,
      "unknownStockCount": 13
    },
    "name": "B4C6",
    "leftNeighborShelfId": "8K9F",
    "rightNeighborShelfId": "6C02"
  },
  {
    "id": "6C02",
    "x": 21.694,
    "y": 4.7208,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": 0.002506
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab8a",
        "height": 0.19631,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f93",
            "leftCorner": {
              "x": 21.665,
              "y": 4.8239,
              "z": 0.19513
            },
            "rightCorner": {
              "x": 21.562,
              "y": 4.8233,
              "z": 0.19513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231427"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f94",
            "leftCorner": {
              "x": 21.602,
              "y": 4.8246,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.516,
              "y": 4.825,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231427"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f95",
            "leftCorner": {
              "x": 21.516,
              "y": 4.825,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.44,
              "y": 4.8254,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f96",
            "leftCorner": {
              "x": 21.44,
              "y": 4.8254,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.352,
              "y": 4.8259,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355247261"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f97",
            "leftCorner": {
              "x": 21.352,
              "y": 4.8259,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.264,
              "y": 4.8263,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355247261"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f98",
            "leftCorner": {
              "x": 21.264,
              "y": 4.8263,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.137,
              "y": 4.827,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499181085"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f99",
            "leftCorner": {
              "x": 21.137,
              "y": 4.827,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 21.01,
              "y": 4.8276,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499944734"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f9a",
            "leftCorner": {
              "x": 21.01,
              "y": 4.8276,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 20.882,
              "y": 4.8282,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499944710"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f9b",
            "leftCorner": {
              "x": 20.882,
              "y": 4.8282,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 20.754,
              "y": 4.8289,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499944697"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f9c",
            "leftCorner": {
              "x": 20.754,
              "y": 4.8289,
              "z": 0.19631
            },
            "rightCorner": {
              "x": 20.673,
              "y": 4.8293,
              "z": 0.19631
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758404633"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab8d",
        "height": 0.54344,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f4c",
            "leftCorner": {
              "x": 21.693,
              "y": 4.716,
              "z": 0.54334
            },
            "rightCorner": {
              "x": 21.605,
              "y": 4.7155,
              "z": 0.54334
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008455048413"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f4d",
            "leftCorner": {
              "x": 21.644,
              "y": 4.7167,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.587,
              "y": 4.717,
              "z": 0.54344
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008455048413"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f4e",
            "leftCorner": {
              "x": 21.587,
              "y": 4.717,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.537,
              "y": 4.7172,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f4f",
            "leftCorner": {
              "x": 21.537,
              "y": 4.7172,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.468,
              "y": 4.7176,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185540"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f50",
            "leftCorner": {
              "x": 21.468,
              "y": 4.7176,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.402,
              "y": 4.7179,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185540"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f51",
            "leftCorner": {
              "x": 21.402,
              "y": 4.7179,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.338,
              "y": 4.7182,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185540"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f52",
            "leftCorner": {
              "x": 21.338,
              "y": 4.7182,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.222,
              "y": 4.7188,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054897"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f53",
            "leftCorner": {
              "x": 21.222,
              "y": 4.7188,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.108,
              "y": 4.7194,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054897"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f54",
            "leftCorner": {
              "x": 21.108,
              "y": 4.7194,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 21.002,
              "y": 4.7199,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447216233"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f55",
            "leftCorner": {
              "x": 21.002,
              "y": 4.7199,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 20.879,
              "y": 4.7205,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447216219"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f56",
            "leftCorner": {
              "x": 20.879,
              "y": 4.7205,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 20.782,
              "y": 4.721,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011200652902"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f57",
            "leftCorner": {
              "x": 20.782,
              "y": 4.721,
              "z": 0.54344
            },
            "rightCorner": {
              "x": 20.704,
              "y": 4.7214,
              "z": 0.54344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011200652902"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab8c",
        "height": 0.87604,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5015",
            "leftCorner": {
              "x": 21.694,
              "y": 4.7124,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.608,
              "y": 4.7128,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002832001190"
          },
          {
            "id": "679afb3c3d9bab0f83ff5017",
            "leftCorner": {
              "x": 21.608,
              "y": 4.7128,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.556,
              "y": 4.7131,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff5018",
            "leftCorner": {
              "x": 21.556,
              "y": 4.7131,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.522,
              "y": 4.7133,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff5019",
            "leftCorner": {
              "x": 21.522,
              "y": 4.7133,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.47,
              "y": 4.7135,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355335616"
          },
          {
            "id": "679afb3c3d9bab0f83ff501a",
            "leftCorner": {
              "x": 21.47,
              "y": 4.7135,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.382,
              "y": 4.714,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355335616"
          },
          {
            "id": "679afb3c3d9bab0f83ff501b",
            "leftCorner": {
              "x": 21.382,
              "y": 4.714,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.308,
              "y": 4.7143,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181239892"
          },
          {
            "id": "679afb3c3d9bab0f83ff501c",
            "leftCorner": {
              "x": 21.308,
              "y": 4.7143,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.237,
              "y": 4.7147,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181239892"
          },
          {
            "id": "679afb3c3d9bab0f83ff501d",
            "leftCorner": {
              "x": 21.237,
              "y": 4.7147,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.16,
              "y": 4.7151,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181239878"
          },
          {
            "id": "679afb3c3d9bab0f83ff501e",
            "leftCorner": {
              "x": 21.16,
              "y": 4.7151,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 21.087,
              "y": 4.7154,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499139796"
          },
          {
            "id": "679afb3c3d9bab0f83ff501f",
            "leftCorner": {
              "x": 21.087,
              "y": 4.7154,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 20.998,
              "y": 4.7159,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355485953"
          },
          {
            "id": "679afb3c3d9bab0f83ff5020",
            "leftCorner": {
              "x": 20.998,
              "y": 4.7159,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 20.907,
              "y": 4.7163,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355485953"
          },
          {
            "id": "679afb3c3d9bab0f83ff5021",
            "leftCorner": {
              "x": 20.907,
              "y": 4.7163,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 20.82,
              "y": 4.7168,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355485953"
          },
          {
            "id": "679afb3c3d9bab0f83ff5022",
            "leftCorner": {
              "x": 20.82,
              "y": 4.7168,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 20.744,
              "y": 4.7172,
              "z": 0.87604
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000010320"
          },
          {
            "id": "679afb3c3d9bab0f83ff5016",
            "leftCorner": {
              "x": 20.744,
              "y": 4.7172,
              "z": 0.87604
            },
            "rightCorner": {
              "x": 20.694,
              "y": 4.7174,
              "z": 0.87604
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000010320"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab89",
        "height": 1.2132,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5000",
            "leftCorner": {
              "x": 21.694,
              "y": 4.712,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 21.495,
              "y": 4.713,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40737584"
          },
          {
            "id": "679afb3c3d9bab0f83ff5002",
            "leftCorner": {
              "x": 21.495,
              "y": 4.713,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 21.336,
              "y": 4.7138,
              "z": 1.2132
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062196082235"
          },
          {
            "id": "679afb3c3d9bab0f83ff5003",
            "leftCorner": {
              "x": 21.336,
              "y": 4.7138,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 21.266,
              "y": 4.7142,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455028712"
          },
          {
            "id": "679afb3c3d9bab0f83ff5004",
            "leftCorner": {
              "x": 21.266,
              "y": 4.7142,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 21.174,
              "y": 4.7146,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062196310529"
          },
          {
            "id": "679afb3c3d9bab0f83ff5005",
            "leftCorner": {
              "x": 21.174,
              "y": 4.7146,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 21.07,
              "y": 4.7151,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610243002667"
          },
          {
            "id": "679afb3c3d9bab0f83ff5006",
            "leftCorner": {
              "x": 21.07,
              "y": 4.7151,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 20.995,
              "y": 4.7155,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413380"
          },
          {
            "id": "679afb3c3d9bab0f83ff5007",
            "leftCorner": {
              "x": 20.995,
              "y": 4.7155,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 20.908,
              "y": 4.716,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413380"
          },
          {
            "id": "679afb3c3d9bab0f83ff5008",
            "leftCorner": {
              "x": 20.908,
              "y": 4.716,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 20.803,
              "y": 4.7165,
              "z": 1.2132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447195156"
          },
          {
            "id": "679afb3c3d9bab0f83ff5001",
            "leftCorner": {
              "x": 20.803,
              "y": 4.7165,
              "z": 1.2132
            },
            "rightCorner": {
              "x": 20.694,
              "y": 4.717,
              "z": 1.2132
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447413403"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab88",
        "height": 1.5088,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ff4",
            "leftCorner": {
              "x": 21.694,
              "y": 4.7126,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.623,
              "y": 4.713,
              "z": 1.5088
            },
            "stockLevel": "UNKNOWN",
            "gtin": "40161822"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff6",
            "leftCorner": {
              "x": 21.623,
              "y": 4.713,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.556,
              "y": 4.7133,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161822"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff7",
            "leftCorner": {
              "x": 21.556,
              "y": 4.7133,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.491,
              "y": 4.7136,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161808"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff8",
            "leftCorner": {
              "x": 21.491,
              "y": 4.7136,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.411,
              "y": 4.714,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4016100810117"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff9",
            "leftCorner": {
              "x": 21.411,
              "y": 4.714,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.328,
              "y": 4.7144,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448006473"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ffa",
            "leftCorner": {
              "x": 21.328,
              "y": 4.7144,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.254,
              "y": 4.7148,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236101"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ffb",
            "leftCorner": {
              "x": 21.254,
              "y": 4.7148,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.178,
              "y": 4.7152,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172348952"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ffc",
            "leftCorner": {
              "x": 21.178,
              "y": 4.7152,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 21.099,
              "y": 4.7156,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172348952"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ffd",
            "leftCorner": {
              "x": 21.099,
              "y": 4.7156,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 20.998,
              "y": 4.7161,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236262"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ffe",
            "leftCorner": {
              "x": 20.998,
              "y": 4.7161,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 20.88,
              "y": 4.7167,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455029719"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fff",
            "leftCorner": {
              "x": 20.88,
              "y": 4.7167,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 20.773,
              "y": 4.7172,
              "z": 1.5088
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161938"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ff5",
            "leftCorner": {
              "x": 20.773,
              "y": 4.7172,
              "z": 1.5088
            },
            "rightCorner": {
              "x": 20.694,
              "y": 4.7176,
              "z": 1.5088
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008455029115"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab8b",
        "height": 1.7629,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5009",
            "leftCorner": {
              "x": 21.694,
              "y": 4.7074,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.597,
              "y": 4.7079,
              "z": 1.7629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "40161181"
          },
          {
            "id": "679afb3c3d9bab0f83ff500b",
            "leftCorner": {
              "x": 21.597,
              "y": 4.7079,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.543,
              "y": 4.7082,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161112"
          },
          {
            "id": "679afb3c3d9bab0f83ff500c",
            "leftCorner": {
              "x": 21.543,
              "y": 4.7082,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.466,
              "y": 4.7085,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161112"
          },
          {
            "id": "679afb3c3d9bab0f83ff500d",
            "leftCorner": {
              "x": 21.466,
              "y": 4.7085,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.409,
              "y": 4.7088,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161334"
          },
          {
            "id": "679afb3c3d9bab0f83ff500e",
            "leftCorner": {
              "x": 21.409,
              "y": 4.7088,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.352,
              "y": 4.7091,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000004"
          },
          {
            "id": "679afb3c3d9bab0f83ff500f",
            "leftCorner": {
              "x": 21.352,
              "y": 4.7091,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.244,
              "y": 4.7097,
              "z": 1.7629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "40161747"
          },
          {
            "id": "679afb3c3d9bab0f83ff5010",
            "leftCorner": {
              "x": 21.244,
              "y": 4.7097,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.157,
              "y": 4.7101,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40161754"
          },
          {
            "id": "679afb3c3d9bab0f83ff5011",
            "leftCorner": {
              "x": 21.157,
              "y": 4.7101,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 21.043,
              "y": 4.7107,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016659"
          },
          {
            "id": "679afb3c3d9bab0f83ff5012",
            "leftCorner": {
              "x": 21.043,
              "y": 4.7107,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 20.984,
              "y": 4.711,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185564"
          },
          {
            "id": "679afb3c3d9bab0f83ff5013",
            "leftCorner": {
              "x": 20.984,
              "y": 4.711,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 20.886,
              "y": 4.7114,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4016100245001"
          },
          {
            "id": "679afb3c3d9bab0f83ff5014",
            "leftCorner": {
              "x": 20.886,
              "y": 4.7114,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 20.757,
              "y": 4.7121,
              "z": 1.7629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172924682"
          },
          {
            "id": "679afb3c3d9bab0f83ff500a",
            "leftCorner": {
              "x": 20.757,
              "y": 4.7121,
              "z": 1.7629
            },
            "rightCorner": {
              "x": 20.694,
              "y": 4.7124,
              "z": 1.7629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355127235"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 54,
      "unknownStockCount": 15
    },
    "name": "6C02",
    "leftNeighborShelfId": "B4C6",
    "rightNeighborShelfId": "H1EM"
  },
  {
    "id": "H1EM",
    "x": 20.668,
    "y": 4.7325,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": -0.003519
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab92",
        "height": 0.19998,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f9d",
            "leftCorner": {
              "x": 20.645,
              "y": 4.833,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.526,
              "y": 4.8322,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448140368"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f9e",
            "leftCorner": {
              "x": 20.526,
              "y": 4.8322,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.446,
              "y": 4.8316,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182432360"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f9f",
            "leftCorner": {
              "x": 20.446,
              "y": 4.8316,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.365,
              "y": 4.8311,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182432360"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa0",
            "leftCorner": {
              "x": 20.365,
              "y": 4.8311,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.283,
              "y": 4.8305,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182432377"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa1",
            "leftCorner": {
              "x": 20.283,
              "y": 4.8305,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.202,
              "y": 4.8299,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182432377"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa2",
            "leftCorner": {
              "x": 20.202,
              "y": 4.8299,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.115,
              "y": 4.8293,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000973892"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa3",
            "leftCorner": {
              "x": 20.115,
              "y": 4.8293,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 20.016,
              "y": 4.8286,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000973885"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa4",
            "leftCorner": {
              "x": 20.016,
              "y": 4.8286,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 19.912,
              "y": 4.8279,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204096705"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa5",
            "leftCorner": {
              "x": 19.912,
              "y": 4.8279,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 19.818,
              "y": 4.8272,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204096705"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa6",
            "leftCorner": {
              "x": 19.818,
              "y": 4.8272,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 19.714,
              "y": 4.8265,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204096927"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa7",
            "leftCorner": {
              "x": 19.714,
              "y": 4.8265,
              "z": 0.19998
            },
            "rightCorner": {
              "x": 19.617,
              "y": 4.8258,
              "z": 0.19998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204096927"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab8f",
        "height": 0.54544,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f58",
            "leftCorner": {
              "x": 20.678,
              "y": 4.7227,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.586,
              "y": 4.7221,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185649"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f59",
            "leftCorner": {
              "x": 20.586,
              "y": 4.7221,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.477,
              "y": 4.7213,
              "z": 0.54544
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172185649"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5a",
            "leftCorner": {
              "x": 20.477,
              "y": 4.7213,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.361,
              "y": 4.7205,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499969287"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5b",
            "leftCorner": {
              "x": 20.361,
              "y": 4.7205,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.22,
              "y": 4.7195,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499969270"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5c",
            "leftCorner": {
              "x": 20.22,
              "y": 4.7195,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.136,
              "y": 4.7189,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204150735"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5d",
            "leftCorner": {
              "x": 20.136,
              "y": 4.7189,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 20.047,
              "y": 4.7183,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204150735"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5e",
            "leftCorner": {
              "x": 20.047,
              "y": 4.7183,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 19.949,
              "y": 4.7176,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204150735"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f5f",
            "leftCorner": {
              "x": 19.949,
              "y": 4.7176,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 19.855,
              "y": 4.717,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204150735"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f60",
            "leftCorner": {
              "x": 19.855,
              "y": 4.717,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 19.77,
              "y": 4.7164,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233698"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f61",
            "leftCorner": {
              "x": 19.77,
              "y": 4.7164,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 19.707,
              "y": 4.7159,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447080773"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f62",
            "leftCorner": {
              "x": 19.707,
              "y": 4.7159,
              "z": 0.54544
            },
            "rightCorner": {
              "x": 19.648,
              "y": 4.7155,
              "z": 0.54544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447080773"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab90",
        "height": 0.92096,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff502c",
            "leftCorner": {
              "x": 20.668,
              "y": 4.7188,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.595,
              "y": 4.7183,
              "z": 0.92096
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447289596"
          },
          {
            "id": "679afb3c3d9bab0f83ff502e",
            "leftCorner": {
              "x": 20.595,
              "y": 4.7183,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.523,
              "y": 4.7178,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289596"
          },
          {
            "id": "679afb3c3d9bab0f83ff502f",
            "leftCorner": {
              "x": 20.523,
              "y": 4.7178,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.455,
              "y": 4.7173,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289596"
          },
          {
            "id": "679afb3c3d9bab0f83ff5030",
            "leftCorner": {
              "x": 20.455,
              "y": 4.7173,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.347,
              "y": 4.7166,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447324082"
          },
          {
            "id": "679afb3c3d9bab0f83ff5031",
            "leftCorner": {
              "x": 20.347,
              "y": 4.7166,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.246,
              "y": 4.7158,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366587"
          },
          {
            "id": "679afb3c3d9bab0f83ff5032",
            "leftCorner": {
              "x": 20.246,
              "y": 4.7158,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.157,
              "y": 4.7152,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366587"
          },
          {
            "id": "679afb3c3d9bab0f83ff5033",
            "leftCorner": {
              "x": 20.157,
              "y": 4.7152,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 20.056,
              "y": 4.7145,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366587"
          },
          {
            "id": "679afb3c3d9bab0f83ff5034",
            "leftCorner": {
              "x": 20.056,
              "y": 4.7145,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 19.931,
              "y": 4.7136,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448033943"
          },
          {
            "id": "679afb3c3d9bab0f83ff5035",
            "leftCorner": {
              "x": 19.931,
              "y": 4.7136,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 19.826,
              "y": 4.7129,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489616"
          },
          {
            "id": "679afb3c3d9bab0f83ff5036",
            "leftCorner": {
              "x": 19.826,
              "y": 4.7129,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 19.731,
              "y": 4.7122,
              "z": 0.92096
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489616"
          },
          {
            "id": "679afb3c3d9bab0f83ff5037",
            "leftCorner": {
              "x": 19.731,
              "y": 4.7122,
              "z": 0.92096
            },
            "rightCorner": {
              "x": 19.66,
              "y": 4.7117,
              "z": 0.92096
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004666000493"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab8e",
        "height": 1.3,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5023",
            "leftCorner": {
              "x": 20.668,
              "y": 4.7148,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.538,
              "y": 4.7139,
              "z": 1.3
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000314886"
          },
          {
            "id": "679afb3c3d9bab0f83ff5025",
            "leftCorner": {
              "x": 20.538,
              "y": 4.7139,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.434,
              "y": 4.7132,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000314886"
          },
          {
            "id": "679afb3c3d9bab0f83ff5026",
            "leftCorner": {
              "x": 20.434,
              "y": 4.7132,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.324,
              "y": 4.7124,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182315182"
          },
          {
            "id": "679afb3c3d9bab0f83ff5027",
            "leftCorner": {
              "x": 20.324,
              "y": 4.7124,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.218,
              "y": 4.7117,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961472"
          },
          {
            "id": "679afb3c3d9bab0f83ff5028",
            "leftCorner": {
              "x": 20.218,
              "y": 4.7117,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.103,
              "y": 4.7108,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499953866"
          },
          {
            "id": "679afb3c3d9bab0f83ff5029",
            "leftCorner": {
              "x": 20.103,
              "y": 4.7108,
              "z": 1.3
            },
            "rightCorner": {
              "x": 20.001,
              "y": 4.7101,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499961519"
          },
          {
            "id": "679afb3c3d9bab0f83ff502a",
            "leftCorner": {
              "x": 20.001,
              "y": 4.7101,
              "z": 1.3
            },
            "rightCorner": {
              "x": 19.889,
              "y": 4.7093,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355490797"
          },
          {
            "id": "679afb3c3d9bab0f83ff502b",
            "leftCorner": {
              "x": 19.889,
              "y": 4.7093,
              "z": 1.3
            },
            "rightCorner": {
              "x": 19.764,
              "y": 4.7085,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447706765"
          },
          {
            "id": "679afb3c3d9bab0f83ff5024",
            "leftCorner": {
              "x": 19.764,
              "y": 4.7085,
              "z": 1.3
            },
            "rightCorner": {
              "x": 19.668,
              "y": 4.7078,
              "z": 1.3
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004666000851"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab91",
        "height": 1.6811,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff503f",
            "leftCorner": {
              "x": 20.668,
              "y": 4.7125,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.552,
              "y": 4.7117,
              "z": 1.6811
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447673401"
          },
          {
            "id": "679afb3c3d9bab0f83ff5041",
            "leftCorner": {
              "x": 20.552,
              "y": 4.7117,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.448,
              "y": 4.7109,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000971157"
          },
          {
            "id": "679afb3c3d9bab0f83ff5042",
            "leftCorner": {
              "x": 20.448,
              "y": 4.7109,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.333,
              "y": 4.7101,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000971157"
          },
          {
            "id": "679afb3c3d9bab0f83ff5043",
            "leftCorner": {
              "x": 20.333,
              "y": 4.7101,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.222,
              "y": 4.7093,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540171202"
          },
          {
            "id": "679afb3c3d9bab0f83ff5044",
            "leftCorner": {
              "x": 20.222,
              "y": 4.7093,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.115,
              "y": 4.7086,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540171172"
          },
          {
            "id": "679afb3c3d9bab0f83ff5045",
            "leftCorner": {
              "x": 20.115,
              "y": 4.7086,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 20.008,
              "y": 4.7078,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540171172"
          },
          {
            "id": "679afb3c3d9bab0f83ff5046",
            "leftCorner": {
              "x": 20.008,
              "y": 4.7078,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 19.888,
              "y": 4.707,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090972934"
          },
          {
            "id": "679afb3c3d9bab0f83ff5047",
            "leftCorner": {
              "x": 19.888,
              "y": 4.707,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 19.786,
              "y": 4.7063,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090972934"
          },
          {
            "id": "679afb3c3d9bab0f83ff5040",
            "leftCorner": {
              "x": 19.786,
              "y": 4.7063,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 19.668,
              "y": 4.7054,
              "z": 1.6811
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251758404459"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 45,
      "unknownStockCount": 6
    },
    "name": "H1EM",
    "leftNeighborShelfId": "6C02",
    "rightNeighborShelfId": "IT8V"
  },
  {
    "id": "IT8V",
    "x": 19.664,
    "y": 4.7283,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": 0.0021076
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab97",
        "height": 0.19593,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4fa8",
            "leftCorner": {
              "x": 19.615,
              "y": 4.8282,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.524,
              "y": 4.8285,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499954986"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fa9",
            "leftCorner": {
              "x": 19.524,
              "y": 4.8285,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.426,
              "y": 4.829,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499954993"
          },
          {
            "id": "679afb3c3d9bab0f83ff4faa",
            "leftCorner": {
              "x": 19.426,
              "y": 4.829,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.335,
              "y": 4.8293,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499185267"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fab",
            "leftCorner": {
              "x": 19.335,
              "y": 4.8293,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.243,
              "y": 4.8297,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355490759"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fac",
            "leftCorner": {
              "x": 19.243,
              "y": 4.8297,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.159,
              "y": 4.8301,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355490773"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fad",
            "leftCorner": {
              "x": 19.159,
              "y": 4.8301,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 19.07,
              "y": 4.8305,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355490599"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fae",
            "leftCorner": {
              "x": 19.07,
              "y": 4.8305,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 18.967,
              "y": 4.8309,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355490599"
          },
          {
            "id": "679afb3c3d9bab0f83ff4faf",
            "leftCorner": {
              "x": 18.967,
              "y": 4.8309,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 18.863,
              "y": 4.8313,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355485397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb0",
            "leftCorner": {
              "x": 18.863,
              "y": 4.8313,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 18.767,
              "y": 4.8317,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355485397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb1",
            "leftCorner": {
              "x": 18.767,
              "y": 4.8317,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 18.711,
              "y": 4.832,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216238977"
          },
          {
            "id": "679afb3c3d9bab0f83ff4fb2",
            "leftCorner": {
              "x": 18.711,
              "y": 4.832,
              "z": 0.19593
            },
            "rightCorner": {
              "x": 18.666,
              "y": 4.8322,
              "z": 0.19593
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216239080"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab93",
        "height": 0.54514,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f63",
            "leftCorner": {
              "x": 19.644,
              "y": 4.7172,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.577,
              "y": 4.7174,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f64",
            "leftCorner": {
              "x": 19.577,
              "y": 4.7174,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.455,
              "y": 4.718,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172047152"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f65",
            "leftCorner": {
              "x": 19.455,
              "y": 4.718,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.38,
              "y": 4.7183,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172047251"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f66",
            "leftCorner": {
              "x": 19.38,
              "y": 4.7183,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.278,
              "y": 4.7187,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355488558"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f67",
            "leftCorner": {
              "x": 19.278,
              "y": 4.7187,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.177,
              "y": 4.7191,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355488558"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f68",
            "leftCorner": {
              "x": 19.177,
              "y": 4.7191,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 19.073,
              "y": 4.7196,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796093957"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f69",
            "leftCorner": {
              "x": 19.073,
              "y": 4.7196,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 18.938,
              "y": 4.7201,
              "z": 0.54514
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008455097114"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f6a",
            "leftCorner": {
              "x": 18.938,
              "y": 4.7201,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 18.868,
              "y": 4.7204,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519808"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f6b",
            "leftCorner": {
              "x": 18.868,
              "y": 4.7204,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 18.802,
              "y": 4.7207,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519808"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f6c",
            "leftCorner": {
              "x": 18.802,
              "y": 4.7207,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 18.73,
              "y": 4.721,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204549256"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f6d",
            "leftCorner": {
              "x": 18.73,
              "y": 4.721,
              "z": 0.54514
            },
            "rightCorner": {
              "x": 18.657,
              "y": 4.7213,
              "z": 0.54514
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204549256"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab96",
        "height": 0.91907,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5038",
            "leftCorner": {
              "x": 19.655,
              "y": 4.7119,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 19.52,
              "y": 4.7125,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289336"
          },
          {
            "id": "679afb3c3d9bab0f83ff5039",
            "leftCorner": {
              "x": 19.52,
              "y": 4.7125,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 19.388,
              "y": 4.713,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289312"
          },
          {
            "id": "679afb3c3d9bab0f83ff503a",
            "leftCorner": {
              "x": 19.388,
              "y": 4.713,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 19.252,
              "y": 4.7136,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289299"
          },
          {
            "id": "679afb3c3d9bab0f83ff503b",
            "leftCorner": {
              "x": 19.252,
              "y": 4.7136,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 19.116,
              "y": 4.7142,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447289275"
          },
          {
            "id": "679afb3c3d9bab0f83ff503c",
            "leftCorner": {
              "x": 19.116,
              "y": 4.7142,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 18.994,
              "y": 4.7147,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355488916"
          },
          {
            "id": "679afb3c3d9bab0f83ff503d",
            "leftCorner": {
              "x": 18.994,
              "y": 4.7147,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 18.88,
              "y": 4.7152,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447352245"
          },
          {
            "id": "679afb3c3d9bab0f83ff503e",
            "leftCorner": {
              "x": 18.88,
              "y": 4.7152,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 18.747,
              "y": 4.7157,
              "z": 0.91907
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447789034"
          },
          {
            "id": "679afb3c3d9bab0f83ff502d",
            "leftCorner": {
              "x": 18.747,
              "y": 4.7157,
              "z": 0.91907
            },
            "rightCorner": {
              "x": 18.664,
              "y": 4.7161,
              "z": 0.91907
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447756333"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab94",
        "height": 1.2155,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5048",
            "leftCorner": {
              "x": 19.664,
              "y": 4.7131,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 19.522,
              "y": 4.7137,
              "z": 1.2155
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000969550"
          },
          {
            "id": "679afb3c3d9bab0f83ff5049",
            "leftCorner": {
              "x": 19.522,
              "y": 4.7137,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 19.383,
              "y": 4.7143,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969536"
          },
          {
            "id": "679afb3c3d9bab0f83ff504a",
            "leftCorner": {
              "x": 19.383,
              "y": 4.7143,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 19.255,
              "y": 4.7148,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204198782"
          },
          {
            "id": "679afb3c3d9bab0f83ff504b",
            "leftCorner": {
              "x": 19.255,
              "y": 4.7148,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 19.165,
              "y": 4.7152,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204199550"
          },
          {
            "id": "679afb3c3d9bab0f83ff504c",
            "leftCorner": {
              "x": 19.165,
              "y": 4.7152,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 19.068,
              "y": 4.7156,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204369106"
          },
          {
            "id": "679afb3c3d9bab0f83ff504d",
            "leftCorner": {
              "x": 19.068,
              "y": 4.7156,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 18.976,
              "y": 4.716,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204369137"
          },
          {
            "id": "679afb3c3d9bab0f83ff504e",
            "leftCorner": {
              "x": 18.976,
              "y": 4.716,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 18.883,
              "y": 4.7164,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204668995"
          },
          {
            "id": "679afb3c3d9bab0f83ff504f",
            "leftCorner": {
              "x": 18.883,
              "y": 4.7164,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 18.81,
              "y": 4.7167,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8719992617234"
          },
          {
            "id": "679afb3c3d9bab0f83ff5050",
            "leftCorner": {
              "x": 18.81,
              "y": 4.7167,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 18.738,
              "y": 4.717,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720929322190"
          },
          {
            "id": "679afb3c3d9bab0f83ff5051",
            "leftCorner": {
              "x": 18.738,
              "y": 4.717,
              "z": 1.2155
            },
            "rightCorner": {
              "x": 18.669,
              "y": 4.7173,
              "z": 1.2155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720929322220"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab95",
        "height": 1.4691,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5052",
            "leftCorner": {
              "x": 19.664,
              "y": 4.7101,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 19.529,
              "y": 4.7106,
              "z": 1.4691
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000969451"
          },
          {
            "id": "679afb3c3d9bab0f83ff5053",
            "leftCorner": {
              "x": 19.529,
              "y": 4.7106,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 19.397,
              "y": 4.7112,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000973366"
          },
          {
            "id": "679afb3c3d9bab0f83ff5054",
            "leftCorner": {
              "x": 19.397,
              "y": 4.7112,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 19.264,
              "y": 4.7118,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969628"
          },
          {
            "id": "679afb3c3d9bab0f83ff5055",
            "leftCorner": {
              "x": 19.264,
              "y": 4.7118,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 19.128,
              "y": 4.7123,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969635"
          },
          {
            "id": "679afb3c3d9bab0f83ff5056",
            "leftCorner": {
              "x": 19.128,
              "y": 4.7123,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 18.982,
              "y": 4.7129,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181264023"
          },
          {
            "id": "679afb3c3d9bab0f83ff5057",
            "leftCorner": {
              "x": 18.982,
              "y": 4.7129,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 18.856,
              "y": 4.7135,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181133558"
          },
          {
            "id": "679afb3c3d9bab0f83ff5058",
            "leftCorner": {
              "x": 18.856,
              "y": 4.7135,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 18.729,
              "y": 4.714,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720182885678"
          },
          {
            "id": "679afb3c3d9bab0f83ff5059",
            "leftCorner": {
              "x": 18.729,
              "y": 4.714,
              "z": 1.4691
            },
            "rightCorner": {
              "x": 18.656,
              "y": 4.7143,
              "z": 1.4691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8719992617128"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab98",
        "height": 1.7651,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff505a",
            "leftCorner": {
              "x": 19.664,
              "y": 4.7107,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 19.507,
              "y": 4.7114,
              "z": 1.7651
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015000969925"
          },
          {
            "id": "679afb3c3d9bab0f83ff505c",
            "leftCorner": {
              "x": 19.507,
              "y": 4.7114,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 19.374,
              "y": 4.712,
              "z": 1.7651
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015200032818"
          },
          {
            "id": "679afb3c3d9bab0f83ff505d",
            "leftCorner": {
              "x": 19.374,
              "y": 4.712,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 19.237,
              "y": 4.7125,
              "z": 1.7651
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200032627"
          },
          {
            "id": "679afb3c3d9bab0f83ff505e",
            "leftCorner": {
              "x": 19.237,
              "y": 4.7125,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 19.1,
              "y": 4.7131,
              "z": 1.7651
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969574"
          },
          {
            "id": "679afb3c3d9bab0f83ff505f",
            "leftCorner": {
              "x": 19.1,
              "y": 4.7131,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 18.961,
              "y": 4.7137,
              "z": 1.7651
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969499"
          },
          {
            "id": "679afb3c3d9bab0f83ff5060",
            "leftCorner": {
              "x": 18.961,
              "y": 4.7137,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 18.832,
              "y": 4.7142,
              "z": 1.7651
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969598"
          },
          {
            "id": "679afb3c3d9bab0f83ff5061",
            "leftCorner": {
              "x": 18.832,
              "y": 4.7142,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 18.704,
              "y": 4.7148,
              "z": 1.7651
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000969611"
          },
          {
            "id": "679afb3c3d9bab0f83ff505b",
            "leftCorner": {
              "x": 18.704,
              "y": 4.7148,
              "z": 1.7651
            },
            "rightCorner": {
              "x": 18.664,
              "y": 4.715,
              "z": 1.7651
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 49,
      "unknownStockCount": 5
    },
    "name": "IT8V",
    "leftNeighborShelfId": "H1EM"
  },
  {
    "id": "6EOH",
    "x": 47.557,
    "y": 11.9,
    "width": 1,
    "height": 2,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.8805,
      "w": -0.47405
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab9a",
        "height": 0.15898,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5062",
            "leftCorner": {
              "x": 47.478,
              "y": 11.952,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 47.424,
              "y": 11.871,
              "z": 0.15898
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447398809"
          },
          {
            "id": "679afb3c3d9bab0f83ff5064",
            "leftCorner": {
              "x": 47.424,
              "y": 11.871,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 47.315,
              "y": 11.705,
              "z": 0.15898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447398809"
          },
          {
            "id": "679afb3c3d9bab0f83ff5065",
            "leftCorner": {
              "x": 47.315,
              "y": 11.705,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 47.255,
              "y": 11.614,
              "z": 0.15898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff5066",
            "leftCorner": {
              "x": 47.255,
              "y": 11.614,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 47.197,
              "y": 11.526,
              "z": 0.15898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000005"
          },
          {
            "id": "679afb3c3d9bab0f83ff5067",
            "leftCorner": {
              "x": 47.197,
              "y": 11.526,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 47.149,
              "y": 11.454,
              "z": 0.15898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff5063",
            "leftCorner": {
              "x": 47.149,
              "y": 11.454,
              "z": 0.15898
            },
            "rightCorner": {
              "x": 46.927,
              "y": 11.117,
              "z": 0.15898
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab9b",
        "height": 0.45342,
        "facings": []
      },
      {
        "id": "679aebda1f3fd8b81ad3ab9c",
        "height": 1.1838,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5068",
            "leftCorner": {
              "x": 47.566,
              "y": 11.894,
              "z": 1.1838
            },
            "rightCorner": {
              "x": 47.476,
              "y": 11.757,
              "z": 1.1838
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540772409"
          },
          {
            "id": "679afb3c3d9bab0f83ff506a",
            "leftCorner": {
              "x": 47.476,
              "y": 11.757,
              "z": 1.1838
            },
            "rightCorner": {
              "x": 47.449,
              "y": 11.716,
              "z": 1.1838
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff506b",
            "leftCorner": {
              "x": 47.449,
              "y": 11.716,
              "z": 1.1838
            },
            "rightCorner": {
              "x": 47.41,
              "y": 11.657,
              "z": 1.1838
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216012935"
          },
          {
            "id": "679afb3c3d9bab0f83ff5069",
            "leftCorner": {
              "x": 47.41,
              "y": 11.657,
              "z": 1.1838
            },
            "rightCorner": {
              "x": 47.016,
              "y": 11.059,
              "z": 1.1838
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 4,
      "unknownStockCount": 6
    },
    "name": "6EOH",
    "rightNeighborShelfId": "DNB2"
  },
  {
    "id": "2ZMB",
    "x": 19.654,
    "y": 6.7705,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.00067143,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3ab9e",
        "height": 0.19574,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff5078",
            "leftCorner": {
              "x": 19.654,
              "y": 6.6701,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 19.769,
              "y": 6.6699,
              "z": 0.19574
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447016574"
          },
          {
            "id": "679afb3c3d9bab0f83ff5079",
            "leftCorner": {
              "x": 19.769,
              "y": 6.6699,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 19.876,
              "y": 6.6698,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016574"
          },
          {
            "id": "679afb3c3d9bab0f83ff507a",
            "leftCorner": {
              "x": 19.876,
              "y": 6.6698,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 19.985,
              "y": 6.6696,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016574"
          },
          {
            "id": "679afb3d3d9bab0f83ff507b",
            "leftCorner": {
              "x": 19.985,
              "y": 6.6696,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.089,
              "y": 6.6695,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff507c",
            "leftCorner": {
              "x": 20.089,
              "y": 6.6695,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.218,
              "y": 6.6693,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff507d",
            "leftCorner": {
              "x": 20.218,
              "y": 6.6693,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.324,
              "y": 6.6692,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016611"
          },
          {
            "id": "679afb3d3d9bab0f83ff507e",
            "leftCorner": {
              "x": 20.324,
              "y": 6.6692,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.436,
              "y": 6.669,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff507f",
            "leftCorner": {
              "x": 20.436,
              "y": 6.669,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.527,
              "y": 6.6689,
              "z": 0.19574
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5080",
            "leftCorner": {
              "x": 20.527,
              "y": 6.6689,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.64,
              "y": 6.6688,
              "z": 0.19574
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447448382"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba0",
        "height": 0.45906,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5098",
            "leftCorner": {
              "x": 19.654,
              "y": 6.7845,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 19.788,
              "y": 6.7844,
              "z": 0.45906
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172924668"
          },
          {
            "id": "679afb3d3d9bab0f83ff509a",
            "leftCorner": {
              "x": 19.788,
              "y": 6.7844,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 19.918,
              "y": 6.7842,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172924620"
          },
          {
            "id": "679afb3d3d9bab0f83ff509b",
            "leftCorner": {
              "x": 19.918,
              "y": 6.7842,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.032,
              "y": 6.784,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172924620"
          },
          {
            "id": "679afb3d3d9bab0f83ff509c",
            "leftCorner": {
              "x": 20.032,
              "y": 6.784,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.16,
              "y": 6.7839,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447091038"
          },
          {
            "id": "679afb3d3d9bab0f83ff509d",
            "leftCorner": {
              "x": 20.16,
              "y": 6.7839,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.265,
              "y": 6.7837,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447088106"
          },
          {
            "id": "679afb3d3d9bab0f83ff509e",
            "leftCorner": {
              "x": 20.265,
              "y": 6.7837,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.368,
              "y": 6.7836,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447088106"
          },
          {
            "id": "679afb3d3d9bab0f83ff509f",
            "leftCorner": {
              "x": 20.368,
              "y": 6.7836,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.462,
              "y": 6.7834,
              "z": 0.45906
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447088106"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a0",
            "leftCorner": {
              "x": 20.462,
              "y": 6.7834,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.565,
              "y": 6.7833,
              "z": 0.45906
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447088106"
          },
          {
            "id": "679afb3d3d9bab0f83ff5099",
            "leftCorner": {
              "x": 20.565,
              "y": 6.7833,
              "z": 0.45906
            },
            "rightCorner": {
              "x": 20.654,
              "y": 6.7832,
              "z": 0.45906
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447088106"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba1",
        "height": 0.75315,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50a1",
            "leftCorner": {
              "x": 19.654,
              "y": 6.7881,
              "z": 0.75315
            },
            "rightCorner": {
              "x": 20.015,
              "y": 6.7876,
              "z": 0.75315
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5413149750425"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a3",
            "leftCorner": {
              "x": 20.015,
              "y": 6.7876,
              "z": 0.75315
            },
            "rightCorner": {
              "x": 20.358,
              "y": 6.7871,
              "z": 0.75315
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841276113"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a4",
            "leftCorner": {
              "x": 20.358,
              "y": 6.7871,
              "z": 0.75315
            },
            "rightCorner": {
              "x": 20.508,
              "y": 6.7869,
              "z": 0.75315
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5410076545476"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a2",
            "leftCorner": {
              "x": 20.508,
              "y": 6.7869,
              "z": 0.75315
            },
            "rightCorner": {
              "x": 20.654,
              "y": 6.7867,
              "z": 0.75315
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5410076545476"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab9f",
        "height": 1.0011,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff508f",
            "leftCorner": {
              "x": 19.654,
              "y": 6.7887,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 19.793,
              "y": 6.7885,
              "z": 1.0011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5091",
            "leftCorner": {
              "x": 19.793,
              "y": 6.7885,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 19.898,
              "y": 6.7884,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283359"
          },
          {
            "id": "679afb3d3d9bab0f83ff5092",
            "leftCorner": {
              "x": 19.898,
              "y": 6.7884,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.008,
              "y": 6.7882,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283359"
          },
          {
            "id": "679afb3d3d9bab0f83ff5093",
            "leftCorner": {
              "x": 20.008,
              "y": 6.7882,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.118,
              "y": 6.7881,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5094",
            "leftCorner": {
              "x": 20.118,
              "y": 6.7881,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.247,
              "y": 6.7879,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000006"
          },
          {
            "id": "679afb3d3d9bab0f83ff5095",
            "leftCorner": {
              "x": 20.247,
              "y": 6.7879,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.351,
              "y": 6.7878,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283335"
          },
          {
            "id": "679afb3d3d9bab0f83ff5096",
            "leftCorner": {
              "x": 20.351,
              "y": 6.7878,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.459,
              "y": 6.7876,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5097",
            "leftCorner": {
              "x": 20.459,
              "y": 6.7876,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.567,
              "y": 6.7875,
              "z": 1.0011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283298"
          },
          {
            "id": "679afb3d3d9bab0f83ff5090",
            "leftCorner": {
              "x": 20.567,
              "y": 6.7875,
              "z": 1.0011
            },
            "rightCorner": {
              "x": 20.654,
              "y": 6.7874,
              "z": 1.0011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216283298"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba2",
        "height": 1.3837,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50a6",
            "leftCorner": {
              "x": 19.658,
              "y": 6.7884,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 19.762,
              "y": 6.7883,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216282963"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a7",
            "leftCorner": {
              "x": 19.762,
              "y": 6.7883,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 19.864,
              "y": 6.7882,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216282963"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a8",
            "leftCorner": {
              "x": 19.864,
              "y": 6.7882,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 19.957,
              "y": 6.788,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216282956"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a9",
            "leftCorner": {
              "x": 19.957,
              "y": 6.788,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.048,
              "y": 6.7879,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216282956"
          },
          {
            "id": "679afb3d3d9bab0f83ff50aa",
            "leftCorner": {
              "x": 20.048,
              "y": 6.7879,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.156,
              "y": 6.7878,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283533"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ab",
            "leftCorner": {
              "x": 20.156,
              "y": 6.7878,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.253,
              "y": 6.7876,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283533"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ac",
            "leftCorner": {
              "x": 20.253,
              "y": 6.7876,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.348,
              "y": 6.7875,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283014"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ad",
            "leftCorner": {
              "x": 20.348,
              "y": 6.7875,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.448,
              "y": 6.7874,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216283014"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ae",
            "leftCorner": {
              "x": 20.448,
              "y": 6.7874,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.564,
              "y": 6.7872,
              "z": 1.3837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5412533420180"
          },
          {
            "id": "679afb3d3d9bab0f83ff50a5",
            "leftCorner": {
              "x": 20.564,
              "y": 6.7872,
              "z": 1.3837
            },
            "rightCorner": {
              "x": 20.654,
              "y": 6.7871,
              "z": 1.3837
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5412533420166"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3ab9d",
        "height": 1.7634,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff506c",
            "leftCorner": {
              "x": 19.654,
              "y": 6.7891,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 19.741,
              "y": 6.789,
              "z": 1.7634
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540923238"
          },
          {
            "id": "679afb3c3d9bab0f83ff506e",
            "leftCorner": {
              "x": 19.741,
              "y": 6.789,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 19.818,
              "y": 6.7889,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540923306"
          },
          {
            "id": "679afb3c3d9bab0f83ff506f",
            "leftCorner": {
              "x": 19.818,
              "y": 6.7889,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 19.891,
              "y": 6.7888,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540923221"
          },
          {
            "id": "679afb3c3d9bab0f83ff5070",
            "leftCorner": {
              "x": 19.891,
              "y": 6.7888,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 19.964,
              "y": 6.7887,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540923269"
          },
          {
            "id": "679afb3c3d9bab0f83ff5071",
            "leftCorner": {
              "x": 19.964,
              "y": 6.7887,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.034,
              "y": 6.7886,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540923177"
          },
          {
            "id": "679afb3c3d9bab0f83ff5072",
            "leftCorner": {
              "x": 20.034,
              "y": 6.7886,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.115,
              "y": 6.7885,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540968284"
          },
          {
            "id": "679afb3c3d9bab0f83ff5073",
            "leftCorner": {
              "x": 20.115,
              "y": 6.7885,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.211,
              "y": 6.7884,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236286"
          },
          {
            "id": "679afb3c3d9bab0f83ff5074",
            "leftCorner": {
              "x": 20.211,
              "y": 6.7884,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.305,
              "y": 6.7883,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236286"
          },
          {
            "id": "679afb3c3d9bab0f83ff5075",
            "leftCorner": {
              "x": 20.305,
              "y": 6.7883,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.385,
              "y": 6.7881,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236187"
          },
          {
            "id": "679afb3c3d9bab0f83ff5076",
            "leftCorner": {
              "x": 20.385,
              "y": 6.7881,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.468,
              "y": 6.788,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236187"
          },
          {
            "id": "679afb3c3d9bab0f83ff5077",
            "leftCorner": {
              "x": 20.468,
              "y": 6.788,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.582,
              "y": 6.7879,
              "z": 1.7634
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090747723"
          },
          {
            "id": "679afb3c3d9bab0f83ff506d",
            "leftCorner": {
              "x": 20.582,
              "y": 6.7879,
              "z": 1.7634
            },
            "rightCorner": {
              "x": 20.654,
              "y": 6.7878,
              "z": 1.7634
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172348754"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 40,
      "unknownStockCount": 13
    },
    "name": "2ZMB",
    "leftNeighborShelfId": "DJBZ"
  },
  {
    "id": "DJBZ",
    "x": 20.658,
    "y": 6.7639,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0036389,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3aba7",
        "height": 0.19496,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5081",
            "leftCorner": {
              "x": 20.64,
              "y": 6.6688,
              "z": 0.19574
            },
            "rightCorner": {
              "x": 20.814,
              "y": 6.6685,
              "z": 0.19574
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172216053"
          },
          {
            "id": "679afb3d3d9bab0f83ff5082",
            "leftCorner": {
              "x": 20.819,
              "y": 6.6664,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 20.922,
              "y": 6.6671,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5083",
            "leftCorner": {
              "x": 20.922,
              "y": 6.6671,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 20.951,
              "y": 6.6674,
              "z": 0.19496
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447161076"
          },
          {
            "id": "679afb3d3d9bab0f83ff5084",
            "leftCorner": {
              "x": 20.951,
              "y": 6.6674,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 21.072,
              "y": 6.6682,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447161076"
          },
          {
            "id": "679afb3d3d9bab0f83ff5085",
            "leftCorner": {
              "x": 21.072,
              "y": 6.6682,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 21.208,
              "y": 6.6692,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5086",
            "leftCorner": {
              "x": 21.208,
              "y": 6.6692,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 21.357,
              "y": 6.6703,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172216091"
          },
          {
            "id": "679afb3d3d9bab0f83ff5087",
            "leftCorner": {
              "x": 21.357,
              "y": 6.6703,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 21.635,
              "y": 6.6723,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755347"
          },
          {
            "id": "679afb3d3d9bab0f83ff5088",
            "leftCorner": {
              "x": 21.635,
              "y": 6.6723,
              "z": 0.19496
            },
            "rightCorner": {
              "x": 21.74,
              "y": 6.6731,
              "z": 0.19496
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755347"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba4",
        "height": 0.54117,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50c0",
            "leftCorner": {
              "x": 20.658,
              "y": 6.7762,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 20.793,
              "y": 6.7772,
              "z": 0.54117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951581807"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c1",
            "leftCorner": {
              "x": 20.793,
              "y": 6.7772,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 20.881,
              "y": 6.7778,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951581807"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c2",
            "leftCorner": {
              "x": 20.881,
              "y": 6.7778,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 20.912,
              "y": 6.778,
              "z": 0.54117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000006"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c3",
            "leftCorner": {
              "x": 20.912,
              "y": 6.778,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 20.985,
              "y": 6.7786,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c4",
            "leftCorner": {
              "x": 20.985,
              "y": 6.7786,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.025,
              "y": 6.7789,
              "z": 0.54117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951580381"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c5",
            "leftCorner": {
              "x": 21.025,
              "y": 6.7789,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.133,
              "y": 6.7796,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951580381"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c6",
            "leftCorner": {
              "x": 21.133,
              "y": 6.7796,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.246,
              "y": 6.7805,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951580411"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c7",
            "leftCorner": {
              "x": 21.246,
              "y": 6.7805,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.35,
              "y": 6.7812,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489289"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c8",
            "leftCorner": {
              "x": 21.35,
              "y": 6.7812,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.453,
              "y": 6.782,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489289"
          },
          {
            "id": "679afb3d3d9bab0f83ff50c9",
            "leftCorner": {
              "x": 21.453,
              "y": 6.782,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.551,
              "y": 6.7827,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489265"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ca",
            "leftCorner": {
              "x": 21.551,
              "y": 6.7827,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.651,
              "y": 6.7834,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355489265"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba3",
        "height": 0.91566,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50af",
            "leftCorner": {
              "x": 20.658,
              "y": 6.7766,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 20.773,
              "y": 6.7775,
              "z": 0.91566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200033600"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b1",
            "leftCorner": {
              "x": 20.773,
              "y": 6.7775,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 20.87,
              "y": 6.7782,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033600"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b2",
            "leftCorner": {
              "x": 20.87,
              "y": 6.7782,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 20.969,
              "y": 6.7789,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033532"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b3",
            "leftCorner": {
              "x": 20.969,
              "y": 6.7789,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.028,
              "y": 6.7793,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033532"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b4",
            "leftCorner": {
              "x": 21.028,
              "y": 6.7793,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.063,
              "y": 6.7796,
              "z": 0.91566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b5",
            "leftCorner": {
              "x": 21.063,
              "y": 6.7796,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.154,
              "y": 6.7803,
              "z": 0.91566
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4013162035502"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b6",
            "leftCorner": {
              "x": 21.154,
              "y": 6.7803,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.24,
              "y": 6.7809,
              "z": 0.91566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013162035489"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b7",
            "leftCorner": {
              "x": 21.24,
              "y": 6.7809,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.331,
              "y": 6.7815,
              "z": 0.91566
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013162035489"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b8",
            "leftCorner": {
              "x": 21.331,
              "y": 6.7815,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.458,
              "y": 6.7825,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499968464"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b9",
            "leftCorner": {
              "x": 21.458,
              "y": 6.7825,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.569,
              "y": 6.7833,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499957536"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ba",
            "leftCorner": {
              "x": 21.569,
              "y": 6.7833,
              "z": 0.91566
            },
            "rightCorner": {
              "x": 21.668,
              "y": 6.784,
              "z": 0.91566
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499957536"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba5",
        "height": 1.2951,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50d4",
            "leftCorner": {
              "x": 20.658,
              "y": 6.7785,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 20.773,
              "y": 6.7793,
              "z": 1.2951
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200033570"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d6",
            "leftCorner": {
              "x": 20.773,
              "y": 6.7793,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 20.878,
              "y": 6.7801,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033570"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d7",
            "leftCorner": {
              "x": 20.878,
              "y": 6.7801,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 20.981,
              "y": 6.7808,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033556"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d8",
            "leftCorner": {
              "x": 20.981,
              "y": 6.7808,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.075,
              "y": 6.7815,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033556"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d9",
            "leftCorner": {
              "x": 21.075,
              "y": 6.7815,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.169,
              "y": 6.7822,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033563"
          },
          {
            "id": "679afb3d3d9bab0f83ff50da",
            "leftCorner": {
              "x": 21.169,
              "y": 6.7822,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.264,
              "y": 6.7829,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033563"
          },
          {
            "id": "679afb3d3d9bab0f83ff50db",
            "leftCorner": {
              "x": 21.264,
              "y": 6.7829,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.368,
              "y": 6.7837,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033563"
          },
          {
            "id": "679afb3d3d9bab0f83ff50dc",
            "leftCorner": {
              "x": 21.368,
              "y": 6.7837,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.472,
              "y": 6.7844,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033587"
          },
          {
            "id": "679afb3d3d9bab0f83ff50dd",
            "leftCorner": {
              "x": 21.472,
              "y": 6.7844,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.567,
              "y": 6.7851,
              "z": 1.2951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033525"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d5",
            "leftCorner": {
              "x": 21.567,
              "y": 6.7851,
              "z": 1.2951
            },
            "rightCorner": {
              "x": 21.658,
              "y": 6.7858,
              "z": 1.2951
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200033525"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba6",
        "height": 1.6756,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50de",
            "leftCorner": {
              "x": 20.658,
              "y": 6.7823,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 20.818,
              "y": 6.7835,
              "z": 1.6756
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172174728"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e0",
            "leftCorner": {
              "x": 20.818,
              "y": 6.7835,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 20.907,
              "y": 6.7842,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540728437"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e1",
            "leftCorner": {
              "x": 20.907,
              "y": 6.7842,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 20.961,
              "y": 6.7845,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540728468"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e2",
            "leftCorner": {
              "x": 20.961,
              "y": 6.7845,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 20.999,
              "y": 6.7848,
              "z": 1.6756
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540728468"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e3",
            "leftCorner": {
              "x": 20.999,
              "y": 6.7848,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.069,
              "y": 6.7853,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758404220"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e4",
            "leftCorner": {
              "x": 21.069,
              "y": 6.7853,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.139,
              "y": 6.7858,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758404220"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e5",
            "leftCorner": {
              "x": 21.139,
              "y": 6.7858,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.231,
              "y": 6.7865,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172767869"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e6",
            "leftCorner": {
              "x": 21.231,
              "y": 6.7865,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.332,
              "y": 6.7872,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172767869"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e7",
            "leftCorner": {
              "x": 21.332,
              "y": 6.7872,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.423,
              "y": 6.7879,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172767869"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e8",
            "leftCorner": {
              "x": 21.423,
              "y": 6.7879,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.521,
              "y": 6.7886,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172767869"
          },
          {
            "id": "679afb3d3d9bab0f83ff50e9",
            "leftCorner": {
              "x": 21.521,
              "y": 6.7886,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.613,
              "y": 6.7893,
              "z": 1.6756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447580303"
          },
          {
            "id": "679afb3d3d9bab0f83ff50df",
            "leftCorner": {
              "x": 21.613,
              "y": 6.7893,
              "z": 1.6756
            },
            "rightCorner": {
              "x": 21.658,
              "y": 6.7896,
              "z": 1.6756
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355489395"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 37,
      "unknownStockCount": 13
    },
    "name": "DJBZ",
    "leftNeighborShelfId": "UH8F",
    "rightNeighborShelfId": "2ZMB"
  },
  {
    "id": "UH8F",
    "x": 21.668,
    "y": 6.7759,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.0028246,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abab",
        "height": 0.19618,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5089",
            "leftCorner": {
              "x": 21.749,
              "y": 6.6697,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 21.875,
              "y": 6.669,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755361"
          },
          {
            "id": "679afb3d3d9bab0f83ff508a",
            "leftCorner": {
              "x": 21.875,
              "y": 6.669,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 21.986,
              "y": 6.6684,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755361"
          },
          {
            "id": "679afb3d3d9bab0f83ff508b",
            "leftCorner": {
              "x": 21.986,
              "y": 6.6684,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 22.135,
              "y": 6.6676,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200031750"
          },
          {
            "id": "679afb3d3d9bab0f83ff508c",
            "leftCorner": {
              "x": 22.135,
              "y": 6.6676,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 22.278,
              "y": 6.6667,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200030746"
          },
          {
            "id": "679afb3d3d9bab0f83ff508d",
            "leftCorner": {
              "x": 22.278,
              "y": 6.6667,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 22.527,
              "y": 6.6653,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033648"
          },
          {
            "id": "679afb3d3d9bab0f83ff508e",
            "leftCorner": {
              "x": 22.527,
              "y": 6.6653,
              "z": 0.19618
            },
            "rightCorner": {
              "x": 22.635,
              "y": 6.6647,
              "z": 0.19618
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000007"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba8",
        "height": 0.542,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50cb",
            "leftCorner": {
              "x": 21.651,
              "y": 6.7834,
              "z": 0.54117
            },
            "rightCorner": {
              "x": 21.778,
              "y": 6.7843,
              "z": 0.54117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758404503"
          },
          {
            "id": "679afb3d3d9bab0f83ff50cc",
            "leftCorner": {
              "x": 21.788,
              "y": 6.7739,
              "z": 0.542
            },
            "rightCorner": {
              "x": 21.885,
              "y": 6.7734,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455096216"
          },
          {
            "id": "679afb3d3d9bab0f83ff50cd",
            "leftCorner": {
              "x": 21.885,
              "y": 6.7734,
              "z": 0.542
            },
            "rightCorner": {
              "x": 21.994,
              "y": 6.7728,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ce",
            "leftCorner": {
              "x": 21.994,
              "y": 6.7728,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.107,
              "y": 6.7721,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447518016"
          },
          {
            "id": "679afb3d3d9bab0f83ff50cf",
            "leftCorner": {
              "x": 22.107,
              "y": 6.7721,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.23,
              "y": 6.7714,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447518016"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d0",
            "leftCorner": {
              "x": 22.23,
              "y": 6.7714,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.336,
              "y": 6.7708,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447518016"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d1",
            "leftCorner": {
              "x": 22.336,
              "y": 6.7708,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.443,
              "y": 6.7702,
              "z": 0.542
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447016536"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d2",
            "leftCorner": {
              "x": 22.443,
              "y": 6.7702,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.55,
              "y": 6.7696,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016536"
          },
          {
            "id": "679afb3d3d9bab0f83ff50d3",
            "leftCorner": {
              "x": 22.55,
              "y": 6.7696,
              "z": 0.542
            },
            "rightCorner": {
              "x": 22.642,
              "y": 6.7691,
              "z": 0.542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172215858"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abac",
        "height": 0.91639,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50bb",
            "leftCorner": {
              "x": 21.678,
              "y": 6.775,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 21.848,
              "y": 6.774,
              "z": 0.91639
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216240932"
          },
          {
            "id": "679afb3d3d9bab0f83ff50bc",
            "leftCorner": {
              "x": 21.848,
              "y": 6.774,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 21.989,
              "y": 6.7732,
              "z": 0.91639
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216240963"
          },
          {
            "id": "679afb3d3d9bab0f83ff50bd",
            "leftCorner": {
              "x": 21.989,
              "y": 6.7732,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 22.13,
              "y": 6.7724,
              "z": 0.91639
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216292733"
          },
          {
            "id": "679afb3d3d9bab0f83ff50be",
            "leftCorner": {
              "x": 22.13,
              "y": 6.7724,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 22.277,
              "y": 6.7716,
              "z": 0.91639
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216292757"
          },
          {
            "id": "679afb3d3d9bab0f83ff50bf",
            "leftCorner": {
              "x": 22.277,
              "y": 6.7716,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 22.473,
              "y": 6.7705,
              "z": 0.91639
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033365"
          },
          {
            "id": "679afb3d3d9bab0f83ff50b0",
            "leftCorner": {
              "x": 22.473,
              "y": 6.7705,
              "z": 0.91639
            },
            "rightCorner": {
              "x": 22.668,
              "y": 6.7694,
              "z": 0.91639
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200033655"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3aba9",
        "height": 1.1708,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50ea",
            "leftCorner": {
              "x": 21.668,
              "y": 6.7705,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 21.835,
              "y": 6.7696,
              "z": 1.1708
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447236248"
          },
          {
            "id": "679afb3d3d9bab0f83ff50eb",
            "leftCorner": {
              "x": 21.835,
              "y": 6.7696,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 21.982,
              "y": 6.7687,
              "z": 1.1708
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236224"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ec",
            "leftCorner": {
              "x": 21.982,
              "y": 6.7687,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 22.174,
              "y": 6.7676,
              "z": 1.1708
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755385"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ed",
            "leftCorner": {
              "x": 22.174,
              "y": 6.7676,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 22.36,
              "y": 6.7666,
              "z": 1.1708
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755385"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ee",
            "leftCorner": {
              "x": 22.36,
              "y": 6.7666,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 22.545,
              "y": 6.7655,
              "z": 1.1708
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172755408"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ef",
            "leftCorner": {
              "x": 22.545,
              "y": 6.7655,
              "z": 1.1708
            },
            "rightCorner": {
              "x": 22.676,
              "y": 6.7648,
              "z": 1.1708
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447763164"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abaa",
        "height": 1.4655,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50f0",
            "leftCorner": {
              "x": 21.668,
              "y": 6.7742,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 21.78,
              "y": 6.7735,
              "z": 1.4655
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001499933301"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f1",
            "leftCorner": {
              "x": 21.78,
              "y": 6.7735,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 21.899,
              "y": 6.7729,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499959844"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f2",
            "leftCorner": {
              "x": 21.899,
              "y": 6.7729,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 21.996,
              "y": 6.7723,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216240727"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f3",
            "leftCorner": {
              "x": 21.996,
              "y": 6.7723,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 22.097,
              "y": 6.7718,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216240727"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f4",
            "leftCorner": {
              "x": 22.097,
              "y": 6.7718,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 22.287,
              "y": 6.7707,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216240697"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f5",
            "leftCorner": {
              "x": 22.287,
              "y": 6.7707,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 22.476,
              "y": 6.7696,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216088893"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f6",
            "leftCorner": {
              "x": 22.476,
              "y": 6.7696,
              "z": 1.4655
            },
            "rightCorner": {
              "x": 22.66,
              "y": 6.7686,
              "z": 1.4655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216088893"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abad",
        "height": 1.7628,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff50f7",
            "leftCorner": {
              "x": 21.668,
              "y": 6.7759,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 21.771,
              "y": 6.7753,
              "z": 1.7628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4100280092019"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f9",
            "leftCorner": {
              "x": 21.771,
              "y": 6.7753,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 21.874,
              "y": 6.7747,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4100280092019"
          },
          {
            "id": "679afb3d3d9bab0f83ff50fa",
            "leftCorner": {
              "x": 21.874,
              "y": 6.7747,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 21.965,
              "y": 6.7742,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448034605"
          },
          {
            "id": "679afb3d3d9bab0f83ff50fb",
            "leftCorner": {
              "x": 21.965,
              "y": 6.7742,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.054,
              "y": 6.7737,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448027102"
          },
          {
            "id": "679afb3d3d9bab0f83ff50fc",
            "leftCorner": {
              "x": 22.054,
              "y": 6.7737,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.145,
              "y": 6.7732,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448034544"
          },
          {
            "id": "679afb3d3d9bab0f83ff50fd",
            "leftCorner": {
              "x": 22.145,
              "y": 6.7732,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.248,
              "y": 6.7726,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062196101486"
          },
          {
            "id": "679afb3d3d9bab0f83ff50fe",
            "leftCorner": {
              "x": 22.248,
              "y": 6.7726,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.399,
              "y": 6.7717,
              "z": 1.7628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448034506"
          },
          {
            "id": "679afb3d3d9bab0f83ff50ff",
            "leftCorner": {
              "x": 22.399,
              "y": 6.7717,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.588,
              "y": 6.7707,
              "z": 1.7628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008455095714"
          },
          {
            "id": "679afb3d3d9bab0f83ff50f8",
            "leftCorner": {
              "x": 22.588,
              "y": 6.7707,
              "z": 1.7628
            },
            "rightCorner": {
              "x": 22.668,
              "y": 6.7702,
              "z": 1.7628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 36,
      "unknownStockCount": 7
    },
    "name": "UH8F",
    "leftNeighborShelfId": "ABBX",
    "rightNeighborShelfId": "DJBZ"
  },
  {
    "id": "ABBX",
    "x": 23.649,
    "y": 6.759,
    "width": 1,
    "height": 1.8,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.0052639,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abb0",
        "height": 0.19426,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5110",
            "leftCorner": {
              "x": 23.648,
              "y": 6.6605,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 23.765,
              "y": 6.6593,
              "z": 0.19426
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015200033662"
          },
          {
            "id": "679afb3d3d9bab0f83ff5112",
            "leftCorner": {
              "x": 23.765,
              "y": 6.6593,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 23.92,
              "y": 6.6577,
              "z": 0.19426
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033709"
          },
          {
            "id": "679afb3d3d9bab0f83ff5113",
            "leftCorner": {
              "x": 23.92,
              "y": 6.6577,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 24.072,
              "y": 6.6561,
              "z": 0.19426
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033778"
          },
          {
            "id": "679afb3d3d9bab0f83ff5114",
            "leftCorner": {
              "x": 24.072,
              "y": 6.6561,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 24.212,
              "y": 6.6546,
              "z": 0.19426
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033679"
          },
          {
            "id": "679afb3d3d9bab0f83ff5115",
            "leftCorner": {
              "x": 24.212,
              "y": 6.6546,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 24.359,
              "y": 6.653,
              "z": 0.19426
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033679"
          },
          {
            "id": "679afb3d3d9bab0f83ff5116",
            "leftCorner": {
              "x": 24.359,
              "y": 6.653,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 24.524,
              "y": 6.6513,
              "z": 0.19426
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200033723"
          },
          {
            "id": "679afb3d3d9bab0f83ff5111",
            "leftCorner": {
              "x": 24.524,
              "y": 6.6513,
              "z": 0.19426
            },
            "rightCorner": {
              "x": 24.648,
              "y": 6.65,
              "z": 0.19426
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181327063"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abaf",
        "height": 0.54107,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5108",
            "leftCorner": {
              "x": 23.649,
              "y": 6.7697,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 23.696,
              "y": 6.7692,
              "z": 0.54107
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff510a",
            "leftCorner": {
              "x": 23.696,
              "y": 6.7692,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 23.827,
              "y": 6.7678,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966620"
          },
          {
            "id": "679afb3d3d9bab0f83ff510b",
            "leftCorner": {
              "x": 23.827,
              "y": 6.7678,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 23.965,
              "y": 6.7664,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966651"
          },
          {
            "id": "679afb3d3d9bab0f83ff510c",
            "leftCorner": {
              "x": 23.965,
              "y": 6.7664,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 24.099,
              "y": 6.7649,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966613"
          },
          {
            "id": "679afb3d3d9bab0f83ff510d",
            "leftCorner": {
              "x": 24.099,
              "y": 6.7649,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 24.246,
              "y": 6.7634,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966637"
          },
          {
            "id": "679afb3d3d9bab0f83ff510e",
            "leftCorner": {
              "x": 24.246,
              "y": 6.7634,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 24.387,
              "y": 6.7619,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966637"
          },
          {
            "id": "679afb3d3d9bab0f83ff510f",
            "leftCorner": {
              "x": 24.387,
              "y": 6.7619,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 24.53,
              "y": 6.7604,
              "z": 0.54107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499966644"
          },
          {
            "id": "679afb3d3d9bab0f83ff5109",
            "leftCorner": {
              "x": 24.53,
              "y": 6.7604,
              "z": 0.54107
            },
            "rightCorner": {
              "x": 24.649,
              "y": 6.7592,
              "z": 0.54107
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5412533420128"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb1",
        "height": 0.83499,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5117",
            "leftCorner": {
              "x": 23.649,
              "y": 6.7704,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 23.84,
              "y": 6.7684,
              "z": 0.83499
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001499960208"
          },
          {
            "id": "679afb3d3d9bab0f83ff5119",
            "leftCorner": {
              "x": 23.84,
              "y": 6.7684,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 23.972,
              "y": 6.767,
              "z": 0.83499
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000026"
          },
          {
            "id": "679afb3d3d9bab0f83ff511a",
            "leftCorner": {
              "x": 23.972,
              "y": 6.767,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 24.129,
              "y": 6.7653,
              "z": 0.83499
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216285643"
          },
          {
            "id": "679afb3d3d9bab0f83ff511b",
            "leftCorner": {
              "x": 24.129,
              "y": 6.7653,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 24.28,
              "y": 6.7637,
              "z": 0.83499
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216285605"
          },
          {
            "id": "679afb3d3d9bab0f83ff511c",
            "leftCorner": {
              "x": 24.28,
              "y": 6.7637,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 24.428,
              "y": 6.7622,
              "z": 0.83499
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216285582"
          },
          {
            "id": "679afb3d3d9bab0f83ff511d",
            "leftCorner": {
              "x": 24.428,
              "y": 6.7622,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 24.546,
              "y": 6.7609,
              "z": 0.83499
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000007"
          },
          {
            "id": "679afb3d3d9bab0f83ff5118",
            "leftCorner": {
              "x": 24.546,
              "y": 6.7609,
              "z": 0.83499
            },
            "rightCorner": {
              "x": 24.649,
              "y": 6.7598,
              "z": 0.83499
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5412533424553"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb2",
        "height": 1.1733,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff511e",
            "leftCorner": {
              "x": 23.649,
              "y": 6.7661,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 23.741,
              "y": 6.7651,
              "z": 1.1733
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5120",
            "leftCorner": {
              "x": 23.741,
              "y": 6.7651,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 23.909,
              "y": 6.7633,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216197304"
          },
          {
            "id": "679afb3d3d9bab0f83ff5121",
            "leftCorner": {
              "x": 23.909,
              "y": 6.7633,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.051,
              "y": 6.7618,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216197281"
          },
          {
            "id": "679afb3d3d9bab0f83ff5122",
            "leftCorner": {
              "x": 24.051,
              "y": 6.7618,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.179,
              "y": 6.7605,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200031910"
          },
          {
            "id": "679afb3d3d9bab0f83ff5123",
            "leftCorner": {
              "x": 24.179,
              "y": 6.7605,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.311,
              "y": 6.7591,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200031668"
          },
          {
            "id": "679afb3d3d9bab0f83ff5124",
            "leftCorner": {
              "x": 24.311,
              "y": 6.7591,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.459,
              "y": 6.7575,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015200031934"
          },
          {
            "id": "679afb3d3d9bab0f83ff5125",
            "leftCorner": {
              "x": 24.459,
              "y": 6.7575,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.564,
              "y": 6.7564,
              "z": 1.1733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172216176"
          },
          {
            "id": "679afb3d3d9bab0f83ff511f",
            "leftCorner": {
              "x": 24.564,
              "y": 6.7564,
              "z": 1.1733
            },
            "rightCorner": {
              "x": 24.649,
              "y": 6.7555,
              "z": 1.1733
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172216152"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abae",
        "height": 1.5493,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5100",
            "leftCorner": {
              "x": 23.649,
              "y": 6.7671,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 23.803,
              "y": 6.7655,
              "z": 1.5493
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062196211116"
          },
          {
            "id": "679afb3d3d9bab0f83ff5102",
            "leftCorner": {
              "x": 23.803,
              "y": 6.7655,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 23.924,
              "y": 6.7642,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455060811"
          },
          {
            "id": "679afb3d3d9bab0f83ff5103",
            "leftCorner": {
              "x": 23.924,
              "y": 6.7642,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.028,
              "y": 6.7631,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355487162"
          },
          {
            "id": "679afb3d3d9bab0f83ff5104",
            "leftCorner": {
              "x": 24.028,
              "y": 6.7631,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.14,
              "y": 6.7619,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447218510"
          },
          {
            "id": "679afb3d3d9bab0f83ff5105",
            "leftCorner": {
              "x": 24.14,
              "y": 6.7619,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.255,
              "y": 6.7607,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455061511"
          },
          {
            "id": "679afb3d3d9bab0f83ff5106",
            "leftCorner": {
              "x": 24.255,
              "y": 6.7607,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.386,
              "y": 6.7593,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455061511"
          },
          {
            "id": "679afb3d3d9bab0f83ff5107",
            "leftCorner": {
              "x": 24.386,
              "y": 6.7593,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.491,
              "y": 6.7582,
              "z": 1.5493
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355487964"
          },
          {
            "id": "679afb3d3d9bab0f83ff5101",
            "leftCorner": {
              "x": 24.491,
              "y": 6.7582,
              "z": 1.5493
            },
            "rightCorner": {
              "x": 24.649,
              "y": 6.7565,
              "z": 1.5493
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355487988"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb3",
        "height": 1.803,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5126",
            "leftCorner": {
              "x": 23.649,
              "y": 6.7721,
              "z": 1.803
            },
            "rightCorner": {
              "x": 23.79,
              "y": 6.7706,
              "z": 1.803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008455047614"
          },
          {
            "id": "679afb3d3d9bab0f83ff5128",
            "leftCorner": {
              "x": 23.79,
              "y": 6.7706,
              "z": 1.803
            },
            "rightCorner": {
              "x": 23.868,
              "y": 6.7698,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796167177"
          },
          {
            "id": "679afb3d3d9bab0f83ff5129",
            "leftCorner": {
              "x": 23.868,
              "y": 6.7698,
              "z": 1.803
            },
            "rightCorner": {
              "x": 23.938,
              "y": 6.769,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796167177"
          },
          {
            "id": "679afb3d3d9bab0f83ff512a",
            "leftCorner": {
              "x": 23.938,
              "y": 6.769,
              "z": 1.803
            },
            "rightCorner": {
              "x": 24.044,
              "y": 6.7679,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172185526"
          },
          {
            "id": "679afb3d3d9bab0f83ff512b",
            "leftCorner": {
              "x": 24.044,
              "y": 6.7679,
              "z": 1.803
            },
            "rightCorner": {
              "x": 24.237,
              "y": 6.7659,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447184280"
          },
          {
            "id": "679afb3d3d9bab0f83ff512c",
            "leftCorner": {
              "x": 24.237,
              "y": 6.7659,
              "z": 1.803
            },
            "rightCorner": {
              "x": 24.388,
              "y": 6.7643,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564334"
          },
          {
            "id": "679afb3d3d9bab0f83ff512d",
            "leftCorner": {
              "x": 24.388,
              "y": 6.7643,
              "z": 1.803
            },
            "rightCorner": {
              "x": 24.585,
              "y": 6.7622,
              "z": 1.803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758410764"
          },
          {
            "id": "679afb3d3d9bab0f83ff5127",
            "leftCorner": {
              "x": 24.585,
              "y": 6.7622,
              "z": 1.803
            },
            "rightCorner": {
              "x": 24.649,
              "y": 6.7615,
              "z": 1.803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448084655"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 34,
      "unknownStockCount": 12
    },
    "name": "ABBX",
    "leftNeighborShelfId": "EFUM",
    "rightNeighborShelfId": "UH8F"
  },
  {
    "id": "5R7C",
    "x": 27.582,
    "y": 6.2493,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.37449,
      "w": 0.92723
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abba",
        "height": 0.19997,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff516e",
            "leftCorner": {
              "x": 27.648,
              "y": 6.1799,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 27.735,
              "y": 6.2632,
              "z": 0.19997
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172309212"
          },
          {
            "id": "679afb3d3d9bab0f83ff5170",
            "leftCorner": {
              "x": 27.735,
              "y": 6.2632,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 27.769,
              "y": 6.2965,
              "z": 0.19997
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5171",
            "leftCorner": {
              "x": 27.769,
              "y": 6.2965,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 27.871,
              "y": 6.395,
              "z": 0.19997
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172310157"
          },
          {
            "id": "679afb3d3d9bab0f83ff5172",
            "leftCorner": {
              "x": 27.871,
              "y": 6.395,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 27.98,
              "y": 6.4998,
              "z": 0.19997
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447228250"
          },
          {
            "id": "679afb3d3d9bab0f83ff5173",
            "leftCorner": {
              "x": 27.98,
              "y": 6.4998,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 28.097,
              "y": 6.6129,
              "z": 0.19997
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447072983"
          },
          {
            "id": "679afb3d3d9bab0f83ff5174",
            "leftCorner": {
              "x": 28.097,
              "y": 6.6129,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 28.212,
              "y": 6.7236,
              "z": 0.19997
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309137"
          },
          {
            "id": "679afb3d3d9bab0f83ff5175",
            "leftCorner": {
              "x": 28.212,
              "y": 6.7236,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 28.329,
              "y": 6.8366,
              "z": 0.19997
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447045901"
          },
          {
            "id": "679afb3d3d9bab0f83ff516f",
            "leftCorner": {
              "x": 28.329,
              "y": 6.8366,
              "z": 0.19997
            },
            "rightCorner": {
              "x": 28.368,
              "y": 6.8744,
              "z": 0.19997
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb9",
        "height": 0.42563,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5165",
            "leftCorner": {
              "x": 27.575,
              "y": 6.2562,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 27.663,
              "y": 6.3412,
              "z": 0.42563
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172309755"
          },
          {
            "id": "679afb3d3d9bab0f83ff5167",
            "leftCorner": {
              "x": 27.663,
              "y": 6.3412,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 27.692,
              "y": 6.3692,
              "z": 0.42563
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5168",
            "leftCorner": {
              "x": 27.692,
              "y": 6.3692,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 27.775,
              "y": 6.4494,
              "z": 0.42563
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447212143"
          },
          {
            "id": "679afb3d3d9bab0f83ff5169",
            "leftCorner": {
              "x": 27.775,
              "y": 6.4494,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 27.798,
              "y": 6.4716,
              "z": 0.42563
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff516a",
            "leftCorner": {
              "x": 27.798,
              "y": 6.4716,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 27.908,
              "y": 6.5776,
              "z": 0.42563
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447212167"
          },
          {
            "id": "679afb3d3d9bab0f83ff516b",
            "leftCorner": {
              "x": 27.908,
              "y": 6.5776,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 28.024,
              "y": 6.6894,
              "z": 0.42563
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447212167"
          },
          {
            "id": "679afb3d3d9bab0f83ff516c",
            "leftCorner": {
              "x": 28.024,
              "y": 6.6894,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 28.137,
              "y": 6.7992,
              "z": 0.42563
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172308116"
          },
          {
            "id": "679afb3d3d9bab0f83ff516d",
            "leftCorner": {
              "x": 28.137,
              "y": 6.7992,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 28.256,
              "y": 6.9135,
              "z": 0.42563
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447212129"
          },
          {
            "id": "679afb3d3d9bab0f83ff5166",
            "leftCorner": {
              "x": 28.256,
              "y": 6.9135,
              "z": 0.42563
            },
            "rightCorner": {
              "x": 28.294,
              "y": 6.9507,
              "z": 0.42563
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172309892"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb7",
        "height": 0.67722,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5151",
            "leftCorner": {
              "x": 27.571,
              "y": 6.2603,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.613,
              "y": 6.3011,
              "z": 0.67722
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172970146"
          },
          {
            "id": "679afb3d3d9bab0f83ff5153",
            "leftCorner": {
              "x": 27.613,
              "y": 6.3011,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.646,
              "y": 6.3328,
              "z": 0.67722
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5154",
            "leftCorner": {
              "x": 27.646,
              "y": 6.3328,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.727,
              "y": 6.4107,
              "z": 0.67722
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172308710"
          },
          {
            "id": "679afb3d3d9bab0f83ff5155",
            "leftCorner": {
              "x": 27.727,
              "y": 6.4107,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.752,
              "y": 6.4349,
              "z": 0.67722
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5156",
            "leftCorner": {
              "x": 27.752,
              "y": 6.4349,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.858,
              "y": 6.5371,
              "z": 0.67722
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308314"
          },
          {
            "id": "679afb3d3d9bab0f83ff5157",
            "leftCorner": {
              "x": 27.858,
              "y": 6.5371,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 27.974,
              "y": 6.6496,
              "z": 0.67722
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309694"
          },
          {
            "id": "679afb3d3d9bab0f83ff5158",
            "leftCorner": {
              "x": 27.974,
              "y": 6.6496,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 28.088,
              "y": 6.7594,
              "z": 0.67722
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308550"
          },
          {
            "id": "679afb3d3d9bab0f83ff5159",
            "leftCorner": {
              "x": 28.088,
              "y": 6.7594,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 28.203,
              "y": 6.8707,
              "z": 0.67722
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517866"
          },
          {
            "id": "679afb3d3d9bab0f83ff5152",
            "leftCorner": {
              "x": 28.203,
              "y": 6.8707,
              "z": 0.67722
            },
            "rightCorner": {
              "x": 28.29,
              "y": 6.9548,
              "z": 0.67722
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796070279"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb4",
        "height": 0.92911,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff512e",
            "leftCorner": {
              "x": 27.57,
              "y": 6.2618,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.614,
              "y": 6.3045,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447521382"
          },
          {
            "id": "679afb3d3d9bab0f83ff5130",
            "leftCorner": {
              "x": 27.614,
              "y": 6.3045,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.645,
              "y": 6.3347,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447521382"
          },
          {
            "id": "679afb3d3d9bab0f83ff5131",
            "leftCorner": {
              "x": 27.645,
              "y": 6.3347,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.672,
              "y": 6.3604,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447518351"
          },
          {
            "id": "679afb3d3d9bab0f83ff5132",
            "leftCorner": {
              "x": 27.672,
              "y": 6.3604,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.699,
              "y": 6.3864,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447518351"
          },
          {
            "id": "679afb3d3d9bab0f83ff5133",
            "leftCorner": {
              "x": 27.699,
              "y": 6.3864,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.732,
              "y": 6.4185,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796072983"
          },
          {
            "id": "679afb3d3d9bab0f83ff5134",
            "leftCorner": {
              "x": 27.732,
              "y": 6.4185,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.756,
              "y": 6.4416,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5135",
            "leftCorner": {
              "x": 27.756,
              "y": 6.4416,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.863,
              "y": 6.5455,
              "z": 0.92911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342819"
          },
          {
            "id": "679afb3d3d9bab0f83ff5136",
            "leftCorner": {
              "x": 27.863,
              "y": 6.5455,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 27.983,
              "y": 6.661,
              "z": 0.92911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308673"
          },
          {
            "id": "679afb3d3d9bab0f83ff5137",
            "leftCorner": {
              "x": 27.983,
              "y": 6.661,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 28.096,
              "y": 6.77,
              "z": 0.92911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000007"
          },
          {
            "id": "679afb3d3d9bab0f83ff5138",
            "leftCorner": {
              "x": 28.096,
              "y": 6.77,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 28.169,
              "y": 6.8402,
              "z": 0.92911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137009138"
          },
          {
            "id": "679afb3d3d9bab0f83ff5139",
            "leftCorner": {
              "x": 28.169,
              "y": 6.8402,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 28.242,
              "y": 6.9107,
              "z": 0.92911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137009145"
          },
          {
            "id": "679afb3d3d9bab0f83ff512f",
            "leftCorner": {
              "x": 28.242,
              "y": 6.9107,
              "z": 0.92911
            },
            "rightCorner": {
              "x": 28.289,
              "y": 6.9562,
              "z": 0.92911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137002948"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb8",
        "height": 1.1832,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff515a",
            "leftCorner": {
              "x": 27.573,
              "y": 6.2578,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.647,
              "y": 6.3292,
              "z": 1.1832
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137002429"
          },
          {
            "id": "679afb3d3d9bab0f83ff515c",
            "leftCorner": {
              "x": 27.647,
              "y": 6.3292,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.677,
              "y": 6.3576,
              "z": 1.1832
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff515d",
            "leftCorner": {
              "x": 27.677,
              "y": 6.3576,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.73,
              "y": 6.4094,
              "z": 1.1832
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137002955"
          },
          {
            "id": "679afb3d3d9bab0f83ff515e",
            "leftCorner": {
              "x": 27.73,
              "y": 6.4094,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.754,
              "y": 6.4325,
              "z": 1.1832
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff515f",
            "leftCorner": {
              "x": 27.754,
              "y": 6.4325,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.836,
              "y": 6.5109,
              "z": 1.1832
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002658"
          },
          {
            "id": "679afb3d3d9bab0f83ff5160",
            "leftCorner": {
              "x": 27.836,
              "y": 6.5109,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 27.921,
              "y": 6.5935,
              "z": 1.1832
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137007721"
          },
          {
            "id": "679afb3d3d9bab0f83ff5161",
            "leftCorner": {
              "x": 27.921,
              "y": 6.5935,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 28.012,
              "y": 6.6808,
              "z": 1.1832
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002153"
          },
          {
            "id": "679afb3d3d9bab0f83ff5162",
            "leftCorner": {
              "x": 28.012,
              "y": 6.6808,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 28.095,
              "y": 6.761,
              "z": 1.1832
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008137002238"
          },
          {
            "id": "679afb3d3d9bab0f83ff5163",
            "leftCorner": {
              "x": 28.095,
              "y": 6.761,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 28.14,
              "y": 6.8052,
              "z": 1.1832
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002894"
          },
          {
            "id": "679afb3d3d9bab0f83ff5164",
            "leftCorner": {
              "x": 28.14,
              "y": 6.8052,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 28.231,
              "y": 6.8927,
              "z": 1.1832
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002603"
          },
          {
            "id": "679afb3d3d9bab0f83ff515b",
            "leftCorner": {
              "x": 28.231,
              "y": 6.8927,
              "z": 1.1832
            },
            "rightCorner": {
              "x": 28.293,
              "y": 6.9523,
              "z": 1.1832
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137007905"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb5",
        "height": 1.433,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff513a",
            "leftCorner": {
              "x": 27.57,
              "y": 6.261,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.634,
              "y": 6.3228,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137015078"
          },
          {
            "id": "679afb3d3d9bab0f83ff513c",
            "leftCorner": {
              "x": 27.634,
              "y": 6.3228,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.667,
              "y": 6.3547,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137015177"
          },
          {
            "id": "679afb3d3d9bab0f83ff513d",
            "leftCorner": {
              "x": 27.667,
              "y": 6.3547,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.695,
              "y": 6.3812,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137015177"
          },
          {
            "id": "679afb3d3d9bab0f83ff513e",
            "leftCorner": {
              "x": 27.695,
              "y": 6.3812,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.724,
              "y": 6.4093,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff513f",
            "leftCorner": {
              "x": 27.724,
              "y": 6.4093,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.783,
              "y": 6.4665,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137015047"
          },
          {
            "id": "679afb3d3d9bab0f83ff5140",
            "leftCorner": {
              "x": 27.783,
              "y": 6.4665,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.847,
              "y": 6.528,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137015139"
          },
          {
            "id": "679afb3d3d9bab0f83ff5141",
            "leftCorner": {
              "x": 27.847,
              "y": 6.528,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.912,
              "y": 6.5904,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137015146"
          },
          {
            "id": "679afb3d3d9bab0f83ff5142",
            "leftCorner": {
              "x": 27.912,
              "y": 6.5904,
              "z": 1.433
            },
            "rightCorner": {
              "x": 27.976,
              "y": 6.6522,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137015085"
          },
          {
            "id": "679afb3d3d9bab0f83ff5143",
            "leftCorner": {
              "x": 27.976,
              "y": 6.6522,
              "z": 1.433
            },
            "rightCorner": {
              "x": 28.038,
              "y": 6.7129,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137015016"
          },
          {
            "id": "679afb3d3d9bab0f83ff5144",
            "leftCorner": {
              "x": 28.038,
              "y": 6.7129,
              "z": 1.433
            },
            "rightCorner": {
              "x": 28.123,
              "y": 6.7941,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002207"
          },
          {
            "id": "679afb3d3d9bab0f83ff5145",
            "leftCorner": {
              "x": 28.123,
              "y": 6.7941,
              "z": 1.433
            },
            "rightCorner": {
              "x": 28.21,
              "y": 6.8786,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002351"
          },
          {
            "id": "679afb3d3d9bab0f83ff513b",
            "leftCorner": {
              "x": 28.21,
              "y": 6.8786,
              "z": 1.433
            },
            "rightCorner": {
              "x": 28.29,
              "y": 6.9554,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137002528"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abb6",
        "height": 1.6425,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5146",
            "leftCorner": {
              "x": 27.568,
              "y": 6.2633,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.627,
              "y": 6.3203,
              "z": 1.6425
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137009312"
          },
          {
            "id": "679afb3d3d9bab0f83ff5148",
            "leftCorner": {
              "x": 27.627,
              "y": 6.3203,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.673,
              "y": 6.3647,
              "z": 1.6425
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137009428"
          },
          {
            "id": "679afb3d3d9bab0f83ff5149",
            "leftCorner": {
              "x": 27.673,
              "y": 6.3647,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.713,
              "y": 6.4037,
              "z": 1.6425
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137009428"
          },
          {
            "id": "679afb3d3d9bab0f83ff514a",
            "leftCorner": {
              "x": 27.713,
              "y": 6.4037,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.77,
              "y": 6.4581,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137009350"
          },
          {
            "id": "679afb3d3d9bab0f83ff514b",
            "leftCorner": {
              "x": 27.77,
              "y": 6.4581,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.831,
              "y": 6.5175,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137009442"
          },
          {
            "id": "679afb3d3d9bab0f83ff514c",
            "leftCorner": {
              "x": 27.831,
              "y": 6.5175,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.894,
              "y": 6.5783,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137009343"
          },
          {
            "id": "679afb3d3d9bab0f83ff514d",
            "leftCorner": {
              "x": 27.894,
              "y": 6.5783,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 27.958,
              "y": 6.6399,
              "z": 1.6425
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008137009336"
          },
          {
            "id": "679afb3d3d9bab0f83ff514e",
            "leftCorner": {
              "x": 27.958,
              "y": 6.6399,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 28.046,
              "y": 6.7243,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002474"
          },
          {
            "id": "679afb3d3d9bab0f83ff514f",
            "leftCorner": {
              "x": 28.046,
              "y": 6.7243,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 28.131,
              "y": 6.8071,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002498"
          },
          {
            "id": "679afb3d3d9bab0f83ff5150",
            "leftCorner": {
              "x": 28.131,
              "y": 6.8071,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 28.219,
              "y": 6.8919,
              "z": 1.6425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137002306"
          },
          {
            "id": "679afb3d3d9bab0f83ff5147",
            "leftCorner": {
              "x": 28.219,
              "y": 6.8919,
              "z": 1.6425
            },
            "rightCorner": {
              "x": 28.288,
              "y": 6.9578,
              "z": 1.6425
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137002443"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 35,
      "unknownStockCount": 33
    },
    "name": "5R7C",
    "leftNeighborShelfId": "RA6K"
  },
  {
    "id": "68B1",
    "x": 29.032,
    "y": 7.6436,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.37435,
      "w": 0.92729
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abc1",
        "height": 0.19968,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51e3",
            "leftCorner": {
              "x": 29.104,
              "y": 7.5694,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.168,
              "y": 7.6318,
              "z": 0.19968
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001257160000"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e4",
            "leftCorner": {
              "x": 29.168,
              "y": 7.6318,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.19,
              "y": 7.6525,
              "z": 0.19968
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e5",
            "leftCorner": {
              "x": 29.19,
              "y": 7.6525,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.299,
              "y": 7.7583,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001257152005"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e6",
            "leftCorner": {
              "x": 29.299,
              "y": 7.7583,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.407,
              "y": 7.8623,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001257214109"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e7",
            "leftCorner": {
              "x": 29.407,
              "y": 7.8623,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.429,
              "y": 7.8837,
              "z": 0.19968
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e8",
            "leftCorner": {
              "x": 29.429,
              "y": 7.8837,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.482,
              "y": 7.9342,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001257218503"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e9",
            "leftCorner": {
              "x": 29.482,
              "y": 7.9342,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.537,
              "y": 7.9878,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001257218404"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ea",
            "leftCorner": {
              "x": 29.537,
              "y": 7.9878,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.594,
              "y": 8.0424,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221037984"
          },
          {
            "id": "679afb3d3d9bab0f83ff51eb",
            "leftCorner": {
              "x": 29.594,
              "y": 8.0424,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.651,
              "y": 8.0969,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221040069"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ec",
            "leftCorner": {
              "x": 29.651,
              "y": 8.0969,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.704,
              "y": 8.1489,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221040045"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ed",
            "leftCorner": {
              "x": 29.704,
              "y": 8.1489,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.762,
              "y": 8.2045,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221051294"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ee",
            "leftCorner": {
              "x": 29.762,
              "y": 8.2045,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.82,
              "y": 8.2602,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221030275"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ef",
            "leftCorner": {
              "x": 29.82,
              "y": 8.2602,
              "z": 0.19968
            },
            "rightCorner": {
              "x": 29.896,
              "y": 8.3333,
              "z": 0.19968
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abbc",
        "height": 0.4215,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5184",
            "leftCorner": {
              "x": 29.026,
              "y": 7.6502,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.066,
              "y": 7.6895,
              "z": 0.4215
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5186",
            "leftCorner": {
              "x": 29.066,
              "y": 7.6895,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.162,
              "y": 7.7818,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221030053"
          },
          {
            "id": "679afb3d3d9bab0f83ff5187",
            "leftCorner": {
              "x": 29.162,
              "y": 7.7818,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.184,
              "y": 7.8029,
              "z": 0.4215
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5188",
            "leftCorner": {
              "x": 29.184,
              "y": 7.8029,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.262,
              "y": 7.8778,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002221030152"
          },
          {
            "id": "679afb3d3d9bab0f83ff5189",
            "leftCorner": {
              "x": 29.262,
              "y": 7.8778,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.325,
              "y": 7.9387,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080229"
          },
          {
            "id": "679afb3d3d9bab0f83ff518a",
            "leftCorner": {
              "x": 29.325,
              "y": 7.9387,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.362,
              "y": 7.9747,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080236"
          },
          {
            "id": "679afb3d3d9bab0f83ff518b",
            "leftCorner": {
              "x": 29.362,
              "y": 7.9747,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.385,
              "y": 7.9968,
              "z": 0.4215
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008137080236"
          },
          {
            "id": "679afb3d3d9bab0f83ff518c",
            "leftCorner": {
              "x": 29.385,
              "y": 7.9968,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.439,
              "y": 8.0488,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080212"
          },
          {
            "id": "679afb3d3d9bab0f83ff518d",
            "leftCorner": {
              "x": 29.439,
              "y": 8.0488,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.495,
              "y": 8.1031,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080205"
          },
          {
            "id": "679afb3d3d9bab0f83ff518e",
            "leftCorner": {
              "x": 29.495,
              "y": 8.1031,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.552,
              "y": 8.1577,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080250"
          },
          {
            "id": "679afb3d3d9bab0f83ff518f",
            "leftCorner": {
              "x": 29.552,
              "y": 8.1577,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.608,
              "y": 8.2123,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008137080243"
          },
          {
            "id": "679afb3d3d9bab0f83ff5190",
            "leftCorner": {
              "x": 29.608,
              "y": 8.2123,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.666,
              "y": 8.2679,
              "z": 0.4215
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991944208"
          },
          {
            "id": "679afb3d3d9bab0f83ff5185",
            "leftCorner": {
              "x": 29.666,
              "y": 8.2679,
              "z": 0.4215
            },
            "rightCorner": {
              "x": 29.745,
              "y": 8.3445,
              "z": 0.4215
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5021991939051"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abbd",
        "height": 0.67342,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5191",
            "leftCorner": {
              "x": 29.024,
              "y": 7.6524,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.064,
              "y": 7.6918,
              "z": 0.67342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5021991945007"
          },
          {
            "id": "679afb3d3d9bab0f83ff5193",
            "leftCorner": {
              "x": 29.064,
              "y": 7.6918,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.119,
              "y": 7.7447,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000008"
          },
          {
            "id": "679afb3d3d9bab0f83ff5194",
            "leftCorner": {
              "x": 29.119,
              "y": 7.7447,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.178,
              "y": 7.8019,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991939648"
          },
          {
            "id": "679afb3d3d9bab0f83ff5195",
            "leftCorner": {
              "x": 29.178,
              "y": 7.8019,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.24,
              "y": 7.8613,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991939044"
          },
          {
            "id": "679afb3d3d9bab0f83ff5196",
            "leftCorner": {
              "x": 29.24,
              "y": 7.8613,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.304,
              "y": 7.9227,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991943133"
          },
          {
            "id": "679afb3d3d9bab0f83ff5197",
            "leftCorner": {
              "x": 29.304,
              "y": 7.9227,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.368,
              "y": 7.9846,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991939020"
          },
          {
            "id": "679afb3d3d9bab0f83ff5198",
            "leftCorner": {
              "x": 29.368,
              "y": 7.9846,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.428,
              "y": 8.0427,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991940231"
          },
          {
            "id": "679afb3d3d9bab0f83ff5199",
            "leftCorner": {
              "x": 29.428,
              "y": 8.0427,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.489,
              "y": 8.1015,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991941207"
          },
          {
            "id": "679afb3d3d9bab0f83ff519a",
            "leftCorner": {
              "x": 29.489,
              "y": 8.1015,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.546,
              "y": 8.1561,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991940934"
          },
          {
            "id": "679afb3d3d9bab0f83ff519b",
            "leftCorner": {
              "x": 29.546,
              "y": 8.1561,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.607,
              "y": 8.2149,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991940460"
          },
          {
            "id": "679afb3d3d9bab0f83ff519c",
            "leftCorner": {
              "x": 29.607,
              "y": 8.2149,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.664,
              "y": 8.2701,
              "z": 0.67342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5021991944789"
          },
          {
            "id": "679afb3d3d9bab0f83ff5192",
            "leftCorner": {
              "x": 29.664,
              "y": 8.2701,
              "z": 0.67342
            },
            "rightCorner": {
              "x": 29.743,
              "y": 8.3467,
              "z": 0.67342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5021991944765"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abbb",
        "height": 0.92302,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5176",
            "leftCorner": {
              "x": 29.022,
              "y": 7.6543,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.066,
              "y": 7.6966,
              "z": 0.92302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012824401648"
          },
          {
            "id": "679afb3d3d9bab0f83ff5178",
            "leftCorner": {
              "x": 29.066,
              "y": 7.6966,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.117,
              "y": 7.7461,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401396"
          },
          {
            "id": "679afb3d3d9bab0f83ff5179",
            "leftCorner": {
              "x": 29.117,
              "y": 7.7461,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.173,
              "y": 7.8004,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401396"
          },
          {
            "id": "679afb3d3d9bab0f83ff517a",
            "leftCorner": {
              "x": 29.173,
              "y": 7.8004,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.228,
              "y": 7.8535,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824403185"
          },
          {
            "id": "679afb3d3d9bab0f83ff517b",
            "leftCorner": {
              "x": 29.228,
              "y": 7.8535,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.292,
              "y": 7.9147,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824404243"
          },
          {
            "id": "679afb3d3d9bab0f83ff517c",
            "leftCorner": {
              "x": 29.292,
              "y": 7.9147,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.353,
              "y": 7.9736,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401303"
          },
          {
            "id": "679afb3d3d9bab0f83ff517d",
            "leftCorner": {
              "x": 29.353,
              "y": 7.9736,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.411,
              "y": 8.0298,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824404120"
          },
          {
            "id": "679afb3d3d9bab0f83ff517e",
            "leftCorner": {
              "x": 29.411,
              "y": 8.0298,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.467,
              "y": 8.0835,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401686"
          },
          {
            "id": "679afb3d3d9bab0f83ff517f",
            "leftCorner": {
              "x": 29.467,
              "y": 8.0835,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.527,
              "y": 8.1415,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401464"
          },
          {
            "id": "679afb3d3d9bab0f83ff5180",
            "leftCorner": {
              "x": 29.527,
              "y": 8.1415,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.585,
              "y": 8.1971,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824400016"
          },
          {
            "id": "679afb3d3d9bab0f83ff5181",
            "leftCorner": {
              "x": 29.585,
              "y": 8.1971,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.637,
              "y": 8.2476,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401921"
          },
          {
            "id": "679afb3d3d9bab0f83ff5182",
            "leftCorner": {
              "x": 29.637,
              "y": 8.2476,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.69,
              "y": 8.2991,
              "z": 0.92302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824401211"
          },
          {
            "id": "679afb3d3d9bab0f83ff5183",
            "leftCorner": {
              "x": 29.69,
              "y": 8.2991,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.716,
              "y": 8.324,
              "z": 0.92302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012824401211"
          },
          {
            "id": "679afb3d3d9bab0f83ff5177",
            "leftCorner": {
              "x": 29.716,
              "y": 8.324,
              "z": 0.92302
            },
            "rightCorner": {
              "x": 29.741,
              "y": 8.3485,
              "z": 0.92302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012824405493"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abbe",
        "height": 1.1784,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff519e",
            "leftCorner": {
              "x": 29.036,
              "y": 7.6607,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.08,
              "y": 7.7034,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447424089"
          },
          {
            "id": "679afb3d3d9bab0f83ff519f",
            "leftCorner": {
              "x": 29.08,
              "y": 7.7034,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.135,
              "y": 7.7564,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5063270102022"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a0",
            "leftCorner": {
              "x": 29.135,
              "y": 7.7564,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.193,
              "y": 7.812,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060229014146"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a1",
            "leftCorner": {
              "x": 29.193,
              "y": 7.812,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.212,
              "y": 7.831,
              "z": 1.1784
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a2",
            "leftCorner": {
              "x": 29.212,
              "y": 7.831,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.255,
              "y": 7.8723,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060519145482"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a3",
            "leftCorner": {
              "x": 29.255,
              "y": 7.8723,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.3,
              "y": 7.9157,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060519144126"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a4",
            "leftCorner": {
              "x": 29.3,
              "y": 7.9157,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.325,
              "y": 7.9393,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060519144126"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a5",
            "leftCorner": {
              "x": 29.325,
              "y": 7.9393,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.387,
              "y": 7.9992,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060229014122"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a6",
            "leftCorner": {
              "x": 29.387,
              "y": 7.9992,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.449,
              "y": 8.0592,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060229014290"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a7",
            "leftCorner": {
              "x": 29.449,
              "y": 8.0592,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.508,
              "y": 8.1168,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060229014160"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a8",
            "leftCorner": {
              "x": 29.508,
              "y": 8.1168,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.568,
              "y": 8.1741,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060229014351"
          },
          {
            "id": "679afb3d3d9bab0f83ff51a9",
            "leftCorner": {
              "x": 29.568,
              "y": 8.1741,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.629,
              "y": 8.2332,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060519148322"
          },
          {
            "id": "679afb3d3d9bab0f83ff51aa",
            "leftCorner": {
              "x": 29.629,
              "y": 8.2332,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.69,
              "y": 8.2914,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012824406285"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ab",
            "leftCorner": {
              "x": 29.69,
              "y": 8.2914,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.715,
              "y": 8.3156,
              "z": 1.1784
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff519d",
            "leftCorner": {
              "x": 29.715,
              "y": 8.3156,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 29.745,
              "y": 8.3449,
              "z": 1.1784
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012824401730"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc0",
        "height": 1.4314,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51cb",
            "leftCorner": {
              "x": 29.031,
              "y": 7.6622,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.082,
              "y": 7.7113,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447477238"
          },
          {
            "id": "679afb3d3d9bab0f83ff51cc",
            "leftCorner": {
              "x": 29.082,
              "y": 7.7113,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.137,
              "y": 7.7646,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346223209"
          },
          {
            "id": "679afb3d3d9bab0f83ff51cd",
            "leftCorner": {
              "x": 29.137,
              "y": 7.7646,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.172,
              "y": 7.7982,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346222301"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ce",
            "leftCorner": {
              "x": 29.172,
              "y": 7.7982,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.195,
              "y": 7.8203,
              "z": 1.4314
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012346222301"
          },
          {
            "id": "679afb3d3d9bab0f83ff51cf",
            "leftCorner": {
              "x": 29.195,
              "y": 7.8203,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.25,
              "y": 7.8737,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346222509"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d0",
            "leftCorner": {
              "x": 29.25,
              "y": 7.8737,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.346,
              "y": 7.9664,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346222400"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d1",
            "leftCorner": {
              "x": 29.346,
              "y": 7.9664,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.433,
              "y": 8.0498,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346222608"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d2",
            "leftCorner": {
              "x": 29.433,
              "y": 8.0498,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.491,
              "y": 8.1061,
              "z": 1.4314
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012346204505"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d3",
            "leftCorner": {
              "x": 29.491,
              "y": 8.1061,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.548,
              "y": 8.161,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346209302"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d4",
            "leftCorner": {
              "x": 29.548,
              "y": 8.161,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.604,
              "y": 8.2152,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346204604"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d5",
            "leftCorner": {
              "x": 29.604,
              "y": 8.2152,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.659,
              "y": 8.268,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346222905"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d6",
            "leftCorner": {
              "x": 29.659,
              "y": 8.268,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.716,
              "y": 8.3227,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346205700"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d7",
            "leftCorner": {
              "x": 29.716,
              "y": 8.3227,
              "z": 1.4314
            },
            "rightCorner": {
              "x": 29.753,
              "y": 8.3584,
              "z": 1.4314
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346204208"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abbf",
        "height": 1.6387,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51ad",
            "leftCorner": {
              "x": 29.041,
              "y": 7.6742,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.118,
              "y": 7.7485,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346001531"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ae",
            "leftCorner": {
              "x": 29.118,
              "y": 7.7485,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.144,
              "y": 7.7738,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346525105"
          },
          {
            "id": "679afb3d3d9bab0f83ff51af",
            "leftCorner": {
              "x": 29.144,
              "y": 7.7738,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.169,
              "y": 7.7976,
              "z": 1.6387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b0",
            "leftCorner": {
              "x": 29.169,
              "y": 7.7976,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.214,
              "y": 7.8415,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346527000"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b1",
            "leftCorner": {
              "x": 29.214,
              "y": 7.8415,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.234,
              "y": 7.8605,
              "z": 1.6387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012346000602"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b2",
            "leftCorner": {
              "x": 29.234,
              "y": 7.8605,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.265,
              "y": 7.8908,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346000602"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b3",
            "leftCorner": {
              "x": 29.265,
              "y": 7.8908,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.323,
              "y": 7.946,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346000107"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b4",
            "leftCorner": {
              "x": 29.323,
              "y": 7.946,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.376,
              "y": 7.9974,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346286303"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b5",
            "leftCorner": {
              "x": 29.376,
              "y": 7.9974,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.426,
              "y": 8.046,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346261508"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b6",
            "leftCorner": {
              "x": 29.426,
              "y": 8.046,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.475,
              "y": 8.093,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346282602"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b7",
            "leftCorner": {
              "x": 29.475,
              "y": 8.093,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.526,
              "y": 8.1419,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346000404"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b8",
            "leftCorner": {
              "x": 29.526,
              "y": 8.1419,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.575,
              "y": 8.1891,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346000404"
          },
          {
            "id": "679afb3d3d9bab0f83ff51b9",
            "leftCorner": {
              "x": 29.575,
              "y": 8.1891,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.624,
              "y": 8.2363,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346277004"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ba",
            "leftCorner": {
              "x": 29.624,
              "y": 8.2363,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.674,
              "y": 8.2844,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346277608"
          },
          {
            "id": "679afb3d3d9bab0f83ff51bb",
            "leftCorner": {
              "x": 29.674,
              "y": 8.2844,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.699,
              "y": 8.3089,
              "z": 1.6387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4012346278001"
          },
          {
            "id": "679afb3d3d9bab0f83ff51bc",
            "leftCorner": {
              "x": 29.699,
              "y": 8.3089,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.724,
              "y": 8.333,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346278001"
          },
          {
            "id": "679afb3d3d9bab0f83ff51bd",
            "leftCorner": {
              "x": 29.724,
              "y": 8.333,
              "z": 1.6387
            },
            "rightCorner": {
              "x": 29.755,
              "y": 8.363,
              "z": 1.6387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4012346509303"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 77,
      "unknownStockCount": 20
    },
    "name": "68B1",
    "leftNeighborShelfId": "3LN7",
    "rightNeighborShelfId": "VAD1"
  },
  {
    "id": "KFT1",
    "x": 29.771,
    "y": 8.3475,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.37563,
      "w": 0.92677
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abc3",
        "height": 0.19919,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51f0",
            "leftCorner": {
              "x": 29.912,
              "y": 8.3466,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 29.935,
              "y": 8.3691,
              "z": 0.19919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008258130018"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f1",
            "leftCorner": {
              "x": 29.935,
              "y": 8.3691,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.027,
              "y": 8.4578,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258130018"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f2",
            "leftCorner": {
              "x": 30.027,
              "y": 8.4578,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.122,
              "y": 8.5501,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258252062"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f3",
            "leftCorner": {
              "x": 30.122,
              "y": 8.5501,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.142,
              "y": 8.5694,
              "z": 0.19919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f4",
            "leftCorner": {
              "x": 30.142,
              "y": 8.5694,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.24,
              "y": 8.6648,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258460009"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f5",
            "leftCorner": {
              "x": 30.24,
              "y": 8.6648,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.361,
              "y": 8.7819,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258147009"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f6",
            "leftCorner": {
              "x": 30.361,
              "y": 8.7819,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.463,
              "y": 8.8806,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258324110"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f7",
            "leftCorner": {
              "x": 30.463,
              "y": 8.8806,
              "z": 0.19919
            },
            "rightCorner": {
              "x": 30.555,
              "y": 8.9704,
              "z": 0.19919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258358047"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc5",
        "height": 0.46589,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51ff",
            "leftCorner": {
              "x": 29.761,
              "y": 8.3581,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 29.874,
              "y": 8.4677,
              "z": 0.46589
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008258051030"
          },
          {
            "id": "679afb3d3d9bab0f83ff5200",
            "leftCorner": {
              "x": 29.874,
              "y": 8.4677,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 29.979,
              "y": 8.5693,
              "z": 0.46589
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258157008"
          },
          {
            "id": "679afb3d3d9bab0f83ff5201",
            "leftCorner": {
              "x": 29.979,
              "y": 8.5693,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 30.082,
              "y": 8.6689,
              "z": 0.46589
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008258154229"
          },
          {
            "id": "679afb3d3d9bab0f83ff5202",
            "leftCorner": {
              "x": 30.082,
              "y": 8.6689,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 30.17,
              "y": 8.7542,
              "z": 0.46589
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258526064"
          },
          {
            "id": "679afb3d3d9bab0f83ff5203",
            "leftCorner": {
              "x": 30.17,
              "y": 8.7542,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 30.271,
              "y": 8.853,
              "z": 0.46589
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258014004"
          },
          {
            "id": "679afb3d3d9bab0f83ff5204",
            "leftCorner": {
              "x": 30.271,
              "y": 8.853,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 30.376,
              "y": 8.9548,
              "z": 0.46589
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258014004"
          },
          {
            "id": "679afb3d3d9bab0f83ff5205",
            "leftCorner": {
              "x": 30.376,
              "y": 8.9548,
              "z": 0.46589
            },
            "rightCorner": {
              "x": 30.474,
              "y": 9.0497,
              "z": 0.46589
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258276006"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc4",
        "height": 0.75884,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51f8",
            "leftCorner": {
              "x": 29.759,
              "y": 8.3608,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 29.881,
              "y": 8.4796,
              "z": 0.75884
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008258120002"
          },
          {
            "id": "679afb3d3d9bab0f83ff51fa",
            "leftCorner": {
              "x": 29.881,
              "y": 8.4796,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 29.969,
              "y": 8.565,
              "z": 0.75884
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008258024003"
          },
          {
            "id": "679afb3d3d9bab0f83ff51fb",
            "leftCorner": {
              "x": 29.969,
              "y": 8.565,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 30.07,
              "y": 8.6629,
              "z": 0.75884
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258065082"
          },
          {
            "id": "679afb3d3d9bab0f83ff51fc",
            "leftCorner": {
              "x": 30.07,
              "y": 8.6629,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 30.176,
              "y": 8.7658,
              "z": 0.75884
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258158005"
          },
          {
            "id": "679afb3d3d9bab0f83ff51fd",
            "leftCorner": {
              "x": 30.176,
              "y": 8.7658,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 30.28,
              "y": 8.8661,
              "z": 0.75884
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258150092"
          },
          {
            "id": "679afb3d3d9bab0f83ff51fe",
            "leftCorner": {
              "x": 30.28,
              "y": 8.8661,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 30.382,
              "y": 8.9654,
              "z": 0.75884
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008258020043"
          },
          {
            "id": "679afb3d3d9bab0f83ff51f9",
            "leftCorner": {
              "x": 30.382,
              "y": 8.9654,
              "z": 0.75884
            },
            "rightCorner": {
              "x": 30.476,
              "y": 9.057,
              "z": 0.75884
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008258107010"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc8",
        "height": 1.0065,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5213",
            "leftCorner": {
              "x": 29.758,
              "y": 8.3611,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 29.823,
              "y": 8.4243,
              "z": 1.0065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447674729"
          },
          {
            "id": "679afb3d3d9bab0f83ff5215",
            "leftCorner": {
              "x": 29.823,
              "y": 8.4243,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 29.868,
              "y": 8.4678,
              "z": 1.0065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447674729"
          },
          {
            "id": "679afb3d3d9bab0f83ff5216",
            "leftCorner": {
              "x": 29.868,
              "y": 8.4678,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 29.889,
              "y": 8.4879,
              "z": 1.0065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5217",
            "leftCorner": {
              "x": 29.889,
              "y": 8.4879,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 29.95,
              "y": 8.5468,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674767"
          },
          {
            "id": "679afb3d3d9bab0f83ff5218",
            "leftCorner": {
              "x": 29.95,
              "y": 8.5468,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.01,
              "y": 8.6055,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674767"
          },
          {
            "id": "679afb3d3d9bab0f83ff5219",
            "leftCorner": {
              "x": 30.01,
              "y": 8.6055,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.071,
              "y": 8.665,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674767"
          },
          {
            "id": "679afb3d3d9bab0f83ff521a",
            "leftCorner": {
              "x": 30.071,
              "y": 8.665,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.133,
              "y": 8.7247,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674767"
          },
          {
            "id": "679afb3d3d9bab0f83ff521b",
            "leftCorner": {
              "x": 30.133,
              "y": 8.7247,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.197,
              "y": 8.7869,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413427"
          },
          {
            "id": "679afb3d3d9bab0f83ff521c",
            "leftCorner": {
              "x": 30.197,
              "y": 8.7869,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.26,
              "y": 8.8483,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602586"
          },
          {
            "id": "679afb3d3d9bab0f83ff521d",
            "leftCorner": {
              "x": 30.26,
              "y": 8.8483,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.327,
              "y": 8.913,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602586"
          },
          {
            "id": "679afb3d3d9bab0f83ff521e",
            "leftCorner": {
              "x": 30.327,
              "y": 8.913,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.383,
              "y": 8.967,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615869"
          },
          {
            "id": "679afb3d3d9bab0f83ff521f",
            "leftCorner": {
              "x": 30.383,
              "y": 8.967,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.437,
              "y": 9.0195,
              "z": 1.0065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615869"
          },
          {
            "id": "679afb3d3d9bab0f83ff5214",
            "leftCorner": {
              "x": 30.437,
              "y": 9.0195,
              "z": 1.0065
            },
            "rightCorner": {
              "x": 30.476,
              "y": 9.0574,
              "z": 1.0065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447672725"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc7",
        "height": 1.219,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5206",
            "leftCorner": {
              "x": 29.759,
              "y": 8.3601,
              "z": 1.219
            },
            "rightCorner": {
              "x": 29.837,
              "y": 8.4353,
              "z": 1.219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447614404"
          },
          {
            "id": "679afb3d3d9bab0f83ff5208",
            "leftCorner": {
              "x": 29.837,
              "y": 8.4353,
              "z": 1.219
            },
            "rightCorner": {
              "x": 29.885,
              "y": 8.4821,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447614404"
          },
          {
            "id": "679afb3d3d9bab0f83ff5209",
            "leftCorner": {
              "x": 29.885,
              "y": 8.4821,
              "z": 1.219
            },
            "rightCorner": {
              "x": 29.907,
              "y": 8.5036,
              "z": 1.219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff520a",
            "leftCorner": {
              "x": 29.907,
              "y": 8.5036,
              "z": 1.219
            },
            "rightCorner": {
              "x": 29.983,
              "y": 8.5768,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602661"
          },
          {
            "id": "679afb3d3d9bab0f83ff520b",
            "leftCorner": {
              "x": 29.983,
              "y": 8.5768,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.055,
              "y": 8.6466,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602661"
          },
          {
            "id": "679afb3d3d9bab0f83ff520c",
            "leftCorner": {
              "x": 30.055,
              "y": 8.6466,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.123,
              "y": 8.7128,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615913"
          },
          {
            "id": "679afb3d3d9bab0f83ff520d",
            "leftCorner": {
              "x": 30.123,
              "y": 8.7128,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.189,
              "y": 8.7771,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615913"
          },
          {
            "id": "679afb3d3d9bab0f83ff520e",
            "leftCorner": {
              "x": 30.189,
              "y": 8.7771,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.246,
              "y": 8.8327,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602678"
          },
          {
            "id": "679afb3d3d9bab0f83ff520f",
            "leftCorner": {
              "x": 30.246,
              "y": 8.8327,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.302,
              "y": 8.8862,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602623"
          },
          {
            "id": "679afb3d3d9bab0f83ff5210",
            "leftCorner": {
              "x": 30.302,
              "y": 8.8862,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.359,
              "y": 8.9417,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602623"
          },
          {
            "id": "679afb3d3d9bab0f83ff5211",
            "leftCorner": {
              "x": 30.359,
              "y": 8.9417,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.406,
              "y": 8.9871,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447490787"
          },
          {
            "id": "679afb3d3d9bab0f83ff5212",
            "leftCorner": {
              "x": 30.406,
              "y": 8.9871,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.441,
              "y": 9.0214,
              "z": 1.219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615760"
          },
          {
            "id": "679afb3d3d9bab0f83ff5207",
            "leftCorner": {
              "x": 30.441,
              "y": 9.0214,
              "z": 1.219
            },
            "rightCorner": {
              "x": 30.477,
              "y": 9.0564,
              "z": 1.219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447615777"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc2",
        "height": 1.4318,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51d8",
            "leftCorner": {
              "x": 29.768,
              "y": 8.3726,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 29.835,
              "y": 8.4375,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447490800"
          },
          {
            "id": "679afb3d3d9bab0f83ff51d9",
            "leftCorner": {
              "x": 29.835,
              "y": 8.4375,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 29.873,
              "y": 8.4751,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447490824"
          },
          {
            "id": "679afb3d3d9bab0f83ff51da",
            "leftCorner": {
              "x": 29.873,
              "y": 8.4751,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 29.896,
              "y": 8.4973,
              "z": 1.4318
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447490824"
          },
          {
            "id": "679afb3d3d9bab0f83ff51db",
            "leftCorner": {
              "x": 29.896,
              "y": 8.4973,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 29.951,
              "y": 8.5502,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000027"
          },
          {
            "id": "679afb3d3d9bab0f83ff51dc",
            "leftCorner": {
              "x": 29.951,
              "y": 8.5502,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.002,
              "y": 8.5993,
              "z": 1.4318
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447615845"
          },
          {
            "id": "679afb3d3d9bab0f83ff51dd",
            "leftCorner": {
              "x": 30.002,
              "y": 8.5993,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.06,
              "y": 8.6557,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615845"
          },
          {
            "id": "679afb3d3d9bab0f83ff51de",
            "leftCorner": {
              "x": 30.06,
              "y": 8.6557,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.111,
              "y": 8.706,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447148275"
          },
          {
            "id": "679afb3d3d9bab0f83ff51df",
            "leftCorner": {
              "x": 30.111,
              "y": 8.706,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.174,
              "y": 8.7665,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602647"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e0",
            "leftCorner": {
              "x": 30.174,
              "y": 8.7665,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.255,
              "y": 8.8449,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796185676"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e1",
            "leftCorner": {
              "x": 30.255,
              "y": 8.8449,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.332,
              "y": 8.9194,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796185676"
          },
          {
            "id": "679afb3d3d9bab0f83ff51e2",
            "leftCorner": {
              "x": 30.332,
              "y": 8.9194,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.397,
              "y": 8.9828,
              "z": 1.4318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615906"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ca",
            "leftCorner": {
              "x": 30.397,
              "y": 8.9828,
              "z": 1.4318
            },
            "rightCorner": {
              "x": 30.475,
              "y": 9.0585,
              "z": 1.4318
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447615906"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc6",
        "height": 1.6385,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff51be",
            "leftCorner": {
              "x": 29.768,
              "y": 8.3792,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 29.833,
              "y": 8.4417,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615821"
          },
          {
            "id": "679afb3d3d9bab0f83ff51bf",
            "leftCorner": {
              "x": 29.833,
              "y": 8.4417,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 29.87,
              "y": 8.4777,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615821"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c0",
            "leftCorner": {
              "x": 29.87,
              "y": 8.4777,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 29.892,
              "y": 8.4989,
              "z": 1.6385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c1",
            "leftCorner": {
              "x": 29.892,
              "y": 8.4989,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 29.948,
              "y": 8.5535,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447148213"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c2",
            "leftCorner": {
              "x": 29.948,
              "y": 8.5535,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.017,
              "y": 8.6202,
              "z": 1.6385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796069815"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c3",
            "leftCorner": {
              "x": 30.017,
              "y": 8.6202,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.082,
              "y": 8.683,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069853"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c4",
            "leftCorner": {
              "x": 30.082,
              "y": 8.683,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.147,
              "y": 8.7461,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069853"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c5",
            "leftCorner": {
              "x": 30.147,
              "y": 8.7461,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.205,
              "y": 8.803,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447602562"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c6",
            "leftCorner": {
              "x": 30.205,
              "y": 8.803,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.268,
              "y": 8.864,
              "z": 1.6385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447602562"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c7",
            "leftCorner": {
              "x": 30.268,
              "y": 8.864,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.324,
              "y": 8.918,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447345186"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c8",
            "leftCorner": {
              "x": 30.324,
              "y": 8.918,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.381,
              "y": 8.9736,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447148473"
          },
          {
            "id": "679afb3d3d9bab0f83ff51c9",
            "leftCorner": {
              "x": 30.381,
              "y": 8.9736,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.431,
              "y": 9.022,
              "z": 1.6385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447615852"
          },
          {
            "id": "679afb3d3d9bab0f83ff51ac",
            "leftCorner": {
              "x": 30.431,
              "y": 9.022,
              "z": 1.6385
            },
            "rightCorner": {
              "x": 30.472,
              "y": 9.0617,
              "z": 1.6385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796015003"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 52,
      "unknownStockCount": 19
    },
    "name": "KFT1",
    "leftNeighborShelfId": "V2K7",
    "rightNeighborShelfId": "5PXX"
  },
  {
    "id": "84HF",
    "x": 31.19,
    "y": 9.7252,
    "width": 0.625,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.39823,
      "w": 0.91728
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abce",
        "height": 0.19473,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff523d",
            "leftCorner": {
              "x": 31.278,
              "y": 9.6423,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.33,
              "y": 9.6969,
              "z": 0.19473
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172772412"
          },
          {
            "id": "679afb3d3d9bab0f83ff523f",
            "leftCorner": {
              "x": 31.33,
              "y": 9.6969,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.394,
              "y": 9.7657,
              "z": 0.19473
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172772412"
          },
          {
            "id": "679afb3d3d9bab0f83ff5240",
            "leftCorner": {
              "x": 31.394,
              "y": 9.7657,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.462,
              "y": 9.839,
              "z": 0.19473
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447615968"
          },
          {
            "id": "679afb3d3d9bab0f83ff5241",
            "leftCorner": {
              "x": 31.462,
              "y": 9.839,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.534,
              "y": 9.9159,
              "z": 0.19473
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172464522"
          },
          {
            "id": "679afb3d3d9bab0f83ff5242",
            "leftCorner": {
              "x": 31.534,
              "y": 9.9159,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.59,
              "y": 9.9754,
              "z": 0.19473
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172307065"
          },
          {
            "id": "679afb3d3d9bab0f83ff5243",
            "leftCorner": {
              "x": 31.59,
              "y": 9.9754,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.668,
              "y": 10.059,
              "z": 0.19473
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff523e",
            "leftCorner": {
              "x": 31.668,
              "y": 10.059,
              "z": 0.19473
            },
            "rightCorner": {
              "x": 31.705,
              "y": 10.099,
              "z": 0.19473
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abca",
        "height": 0.5046,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5226",
            "leftCorner": {
              "x": 31.206,
              "y": 9.7388,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.273,
              "y": 9.8104,
              "z": 0.5046
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447435115"
          },
          {
            "id": "679afb3d3d9bab0f83ff5227",
            "leftCorner": {
              "x": 31.273,
              "y": 9.8104,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.33,
              "y": 9.872,
              "z": 0.5046
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447435115"
          },
          {
            "id": "679afb3d3d9bab0f83ff5228",
            "leftCorner": {
              "x": 31.33,
              "y": 9.872,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.401,
              "y": 9.9476,
              "z": 0.5046
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796065008"
          },
          {
            "id": "679afb3d3d9bab0f83ff5229",
            "leftCorner": {
              "x": 31.401,
              "y": 9.9476,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.474,
              "y": 10.026,
              "z": 0.5046
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796065008"
          },
          {
            "id": "679afb3d3d9bab0f83ff522a",
            "leftCorner": {
              "x": 31.474,
              "y": 10.026,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.562,
              "y": 10.12,
              "z": 0.5046
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5225",
            "leftCorner": {
              "x": 31.562,
              "y": 10.12,
              "z": 0.5046
            },
            "rightCorner": {
              "x": 31.618,
              "y": 10.18,
              "z": 0.5046
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447123142"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abcd",
        "height": 0.79322,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5237",
            "leftCorner": {
              "x": 31.216,
              "y": 9.7471,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.281,
              "y": 9.8167,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175820"
          },
          {
            "id": "679afb3d3d9bab0f83ff5238",
            "leftCorner": {
              "x": 31.281,
              "y": 9.8167,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.339,
              "y": 9.8788,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175820"
          },
          {
            "id": "679afb3d3d9bab0f83ff5239",
            "leftCorner": {
              "x": 31.339,
              "y": 9.8788,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.401,
              "y": 9.946,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175820"
          },
          {
            "id": "679afb3d3d9bab0f83ff523a",
            "leftCorner": {
              "x": 31.401,
              "y": 9.946,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.477,
              "y": 10.026,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307461"
          },
          {
            "id": "679afb3d3d9bab0f83ff523b",
            "leftCorner": {
              "x": 31.477,
              "y": 10.026,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.545,
              "y": 10.1,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307461"
          },
          {
            "id": "679afb3d3d9bab0f83ff523c",
            "leftCorner": {
              "x": 31.545,
              "y": 10.1,
              "z": 0.79322
            },
            "rightCorner": {
              "x": 31.617,
              "y": 10.177,
              "z": 0.79322
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307485"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abcc",
        "height": 1.0871,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5231",
            "leftCorner": {
              "x": 31.188,
              "y": 9.7269,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.219,
              "y": 9.7607,
              "z": 1.0871
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5232",
            "leftCorner": {
              "x": 31.219,
              "y": 9.7607,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.297,
              "y": 9.8434,
              "z": 1.0871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530209"
          },
          {
            "id": "679afb3d3d9bab0f83ff5233",
            "leftCorner": {
              "x": 31.297,
              "y": 9.8434,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.368,
              "y": 9.9196,
              "z": 1.0871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530209"
          },
          {
            "id": "679afb3d3d9bab0f83ff5234",
            "leftCorner": {
              "x": 31.368,
              "y": 9.9196,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.45,
              "y": 10.007,
              "z": 1.0871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000283"
          },
          {
            "id": "679afb3d3d9bab0f83ff5235",
            "leftCorner": {
              "x": 31.45,
              "y": 10.007,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.527,
              "y": 10.09,
              "z": 1.0871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000283"
          },
          {
            "id": "679afb3d3d9bab0f83ff5236",
            "leftCorner": {
              "x": 31.527,
              "y": 10.09,
              "z": 1.0871
            },
            "rightCorner": {
              "x": 31.606,
              "y": 10.174,
              "z": 1.0871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000283"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abc9",
        "height": 1.3425,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5220",
            "leftCorner": {
              "x": 31.196,
              "y": 9.7348,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 31.278,
              "y": 9.8223,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447656879"
          },
          {
            "id": "679afb3d3d9bab0f83ff5221",
            "leftCorner": {
              "x": 31.278,
              "y": 9.8223,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 31.36,
              "y": 9.9104,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447656879"
          },
          {
            "id": "679afb3d3d9bab0f83ff5222",
            "leftCorner": {
              "x": 31.36,
              "y": 9.9104,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 31.438,
              "y": 9.9939,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447575583"
          },
          {
            "id": "679afb3d3d9bab0f83ff5223",
            "leftCorner": {
              "x": 31.438,
              "y": 9.9939,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 31.519,
              "y": 10.081,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447370058"
          },
          {
            "id": "679afb3d3d9bab0f83ff5224",
            "leftCorner": {
              "x": 31.519,
              "y": 10.081,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 31.613,
              "y": 10.181,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447370072"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abcb",
        "height": 1.6363,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff522c",
            "leftCorner": {
              "x": 31.181,
              "y": 9.7318,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.241,
              "y": 9.7961,
              "z": 1.6363
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260467420094"
          },
          {
            "id": "679afb3d3d9bab0f83ff522d",
            "leftCorner": {
              "x": 31.241,
              "y": 9.7961,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.297,
              "y": 9.856,
              "z": 1.6363
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260467420094"
          },
          {
            "id": "679afb3d3d9bab0f83ff522e",
            "leftCorner": {
              "x": 31.297,
              "y": 9.856,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.352,
              "y": 9.9145,
              "z": 1.6363
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260467420117"
          },
          {
            "id": "679afb3d3d9bab0f83ff522f",
            "leftCorner": {
              "x": 31.352,
              "y": 9.9145,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.411,
              "y": 9.9775,
              "z": 1.6363
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000009"
          },
          {
            "id": "679afb3d3d9bab0f83ff5230",
            "leftCorner": {
              "x": 31.411,
              "y": 9.9775,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.523,
              "y": 10.098,
              "z": 1.6363
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447677003"
          },
          {
            "id": "679afb3d3d9bab0f83ff522b",
            "leftCorner": {
              "x": 31.523,
              "y": 10.098,
              "z": 1.6363
            },
            "rightCorner": {
              "x": 31.609,
              "y": 10.189,
              "z": 1.6363
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447184303"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 27,
      "unknownStockCount": 9
    },
    "name": "84HF",
    "leftNeighborShelfId": "7YAR",
    "rightNeighborShelfId": "ASWH"
  },
  {
    "id": "S8LF",
    "x": 31.896,
    "y": 10.406,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.35624,
      "w": 0.93439
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abd3",
        "height": 0.19528,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5277",
            "leftCorner": {
              "x": 31.964,
              "y": 10.329,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.013,
              "y": 10.373,
              "z": 0.19528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447200225"
          },
          {
            "id": "679afb3d3d9bab0f83ff5279",
            "leftCorner": {
              "x": 32.013,
              "y": 10.373,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.106,
              "y": 10.456,
              "z": 0.19528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447200225"
          },
          {
            "id": "679afb3d3d9bab0f83ff527a",
            "leftCorner": {
              "x": 32.106,
              "y": 10.456,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.207,
              "y": 10.546,
              "z": 0.19528
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447663075"
          },
          {
            "id": "679afb3d3d9bab0f83ff527b",
            "leftCorner": {
              "x": 32.207,
              "y": 10.546,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.29,
              "y": 10.62,
              "z": 0.19528
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447663075"
          },
          {
            "id": "679afb3d3d9bab0f83ff527c",
            "leftCorner": {
              "x": 32.29,
              "y": 10.62,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.371,
              "y": 10.692,
              "z": 0.19528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307348"
          },
          {
            "id": "679afb3d3d9bab0f83ff527d",
            "leftCorner": {
              "x": 32.371,
              "y": 10.692,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.453,
              "y": 10.766,
              "z": 0.19528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307348"
          },
          {
            "id": "679afb3d3d9bab0f83ff527e",
            "leftCorner": {
              "x": 32.453,
              "y": 10.766,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.542,
              "y": 10.845,
              "z": 0.19528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172307348"
          },
          {
            "id": "679afb3d3d9bab0f83ff527f",
            "leftCorner": {
              "x": 32.542,
              "y": 10.845,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.613,
              "y": 10.908,
              "z": 0.19528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607598"
          },
          {
            "id": "679afb3d3d9bab0f83ff5280",
            "leftCorner": {
              "x": 32.613,
              "y": 10.908,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.645,
              "y": 10.937,
              "z": 0.19528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447607598"
          },
          {
            "id": "679afb3d3d9bab0f83ff5278",
            "leftCorner": {
              "x": 32.645,
              "y": 10.937,
              "z": 0.19528
            },
            "rightCorner": {
              "x": 32.71,
              "y": 10.995,
              "z": 0.19528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd1",
        "height": 0.50051,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5260",
            "leftCorner": {
              "x": 31.895,
              "y": 10.409,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 31.972,
              "y": 10.479,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172890444"
          },
          {
            "id": "679afb3d3d9bab0f83ff5261",
            "leftCorner": {
              "x": 31.972,
              "y": 10.479,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.042,
              "y": 10.541,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172890444"
          },
          {
            "id": "679afb3d3d9bab0f83ff5262",
            "leftCorner": {
              "x": 32.042,
              "y": 10.541,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.118,
              "y": 10.608,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000009"
          },
          {
            "id": "679afb3d3d9bab0f83ff5263",
            "leftCorner": {
              "x": 32.118,
              "y": 10.608,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.191,
              "y": 10.673,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607567"
          },
          {
            "id": "679afb3d3d9bab0f83ff5264",
            "leftCorner": {
              "x": 32.191,
              "y": 10.673,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.263,
              "y": 10.738,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607567"
          },
          {
            "id": "679afb3d3d9bab0f83ff5265",
            "leftCorner": {
              "x": 32.263,
              "y": 10.738,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.341,
              "y": 10.808,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447524772"
          },
          {
            "id": "679afb3d3d9bab0f83ff5266",
            "leftCorner": {
              "x": 32.341,
              "y": 10.808,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.421,
              "y": 10.879,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447524772"
          },
          {
            "id": "679afb3d3d9bab0f83ff5267",
            "leftCorner": {
              "x": 32.421,
              "y": 10.879,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.504,
              "y": 10.952,
              "z": 0.50051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447524413"
          },
          {
            "id": "679afb3d3d9bab0f83ff5268",
            "leftCorner": {
              "x": 32.504,
              "y": 10.952,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.531,
              "y": 10.977,
              "z": 0.50051
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447524413"
          },
          {
            "id": "679afb3d3d9bab0f83ff5269",
            "leftCorner": {
              "x": 32.531,
              "y": 10.977,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.579,
              "y": 11.019,
              "z": 0.50051
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff526a",
            "leftCorner": {
              "x": 32.579,
              "y": 11.019,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.611,
              "y": 11.048,
              "z": 0.50051
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff525f",
            "leftCorner": {
              "x": 32.611,
              "y": 11.048,
              "z": 0.50051
            },
            "rightCorner": {
              "x": 32.64,
              "y": 11.074,
              "z": 0.50051
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd2",
        "height": 0.79685,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff526b",
            "leftCorner": {
              "x": 31.891,
              "y": 10.411,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 31.938,
              "y": 10.452,
              "z": 0.79685
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172861635"
          },
          {
            "id": "679afb3d3d9bab0f83ff526d",
            "leftCorner": {
              "x": 31.938,
              "y": 10.452,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.021,
              "y": 10.527,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172861635"
          },
          {
            "id": "679afb3d3d9bab0f83ff526e",
            "leftCorner": {
              "x": 32.021,
              "y": 10.527,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.111,
              "y": 10.607,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265231"
          },
          {
            "id": "679afb3d3d9bab0f83ff526f",
            "leftCorner": {
              "x": 32.111,
              "y": 10.607,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.188,
              "y": 10.676,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265231"
          },
          {
            "id": "679afb3d3d9bab0f83ff5270",
            "leftCorner": {
              "x": 32.188,
              "y": 10.676,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.273,
              "y": 10.751,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265231"
          },
          {
            "id": "679afb3d3d9bab0f83ff5271",
            "leftCorner": {
              "x": 32.273,
              "y": 10.751,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.342,
              "y": 10.813,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607550"
          },
          {
            "id": "679afb3d3d9bab0f83ff5272",
            "leftCorner": {
              "x": 32.342,
              "y": 10.813,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.406,
              "y": 10.87,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607550"
          },
          {
            "id": "679afb3d3d9bab0f83ff5273",
            "leftCorner": {
              "x": 32.406,
              "y": 10.87,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.478,
              "y": 10.935,
              "z": 0.79685
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796010398"
          },
          {
            "id": "679afb3d3d9bab0f83ff5274",
            "leftCorner": {
              "x": 32.478,
              "y": 10.935,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.503,
              "y": 10.957,
              "z": 0.79685
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796010398"
          },
          {
            "id": "679afb3d3d9bab0f83ff5275",
            "leftCorner": {
              "x": 32.503,
              "y": 10.957,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.549,
              "y": 10.998,
              "z": 0.79685
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5276",
            "leftCorner": {
              "x": 32.549,
              "y": 10.998,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.576,
              "y": 11.021,
              "z": 0.79685
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172629471"
          },
          {
            "id": "679afb3d3d9bab0f83ff526c",
            "leftCorner": {
              "x": 32.576,
              "y": 11.021,
              "z": 0.79685
            },
            "rightCorner": {
              "x": 32.637,
              "y": 11.077,
              "z": 0.79685
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172629471"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd0",
        "height": 1.0878,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff524f",
            "leftCorner": {
              "x": 31.892,
              "y": 10.41,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 31.955,
              "y": 10.467,
              "z": 1.0878
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447345353"
          },
          {
            "id": "679afb3d3d9bab0f83ff5251",
            "leftCorner": {
              "x": 31.955,
              "y": 10.467,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.027,
              "y": 10.531,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447345353"
          },
          {
            "id": "679afb3d3d9bab0f83ff5252",
            "leftCorner": {
              "x": 32.027,
              "y": 10.531,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.071,
              "y": 10.57,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087055"
          },
          {
            "id": "679afb3d3d9bab0f83ff5253",
            "leftCorner": {
              "x": 32.071,
              "y": 10.57,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.118,
              "y": 10.612,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447369526"
          },
          {
            "id": "679afb3d3d9bab0f83ff5254",
            "leftCorner": {
              "x": 32.118,
              "y": 10.612,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.166,
              "y": 10.655,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796196313"
          },
          {
            "id": "679afb3d3d9bab0f83ff5255",
            "leftCorner": {
              "x": 32.166,
              "y": 10.655,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.219,
              "y": 10.702,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087130"
          },
          {
            "id": "679afb3d3d9bab0f83ff5256",
            "leftCorner": {
              "x": 32.219,
              "y": 10.702,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.254,
              "y": 10.734,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796072945"
          },
          {
            "id": "679afb3d3d9bab0f83ff5257",
            "leftCorner": {
              "x": 32.254,
              "y": 10.734,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.29,
              "y": 10.766,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771510"
          },
          {
            "id": "679afb3d3d9bab0f83ff5258",
            "leftCorner": {
              "x": 32.29,
              "y": 10.766,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.325,
              "y": 10.797,
              "z": 1.0878
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447087086"
          },
          {
            "id": "679afb3d3d9bab0f83ff5259",
            "leftCorner": {
              "x": 32.325,
              "y": 10.797,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.366,
              "y": 10.833,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087147"
          },
          {
            "id": "679afb3d3d9bab0f83ff525a",
            "leftCorner": {
              "x": 32.366,
              "y": 10.833,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.429,
              "y": 10.889,
              "z": 1.0878
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447087123"
          },
          {
            "id": "679afb3d3d9bab0f83ff525b",
            "leftCorner": {
              "x": 32.429,
              "y": 10.889,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.494,
              "y": 10.948,
              "z": 1.0878
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087123"
          },
          {
            "id": "679afb3d3d9bab0f83ff525c",
            "leftCorner": {
              "x": 32.494,
              "y": 10.948,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.52,
              "y": 10.971,
              "z": 1.0878
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447087109"
          },
          {
            "id": "679afb3d3d9bab0f83ff525d",
            "leftCorner": {
              "x": 32.52,
              "y": 10.971,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.555,
              "y": 11.002,
              "z": 1.0878
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447087109"
          },
          {
            "id": "679afb3d3d9bab0f83ff525e",
            "leftCorner": {
              "x": 32.555,
              "y": 11.002,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.588,
              "y": 11.031,
              "z": 1.0878
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5250",
            "leftCorner": {
              "x": 32.588,
              "y": 11.031,
              "z": 1.0878
            },
            "rightCorner": {
              "x": 32.638,
              "y": 11.076,
              "z": 1.0878
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abcf",
        "height": 1.385,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5244",
            "leftCorner": {
              "x": 31.891,
              "y": 10.411,
              "z": 1.385
            },
            "rightCorner": {
              "x": 31.968,
              "y": 10.48,
              "z": 1.385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5246",
            "leftCorner": {
              "x": 31.968,
              "y": 10.48,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.025,
              "y": 10.531,
              "z": 1.385
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447087215"
          },
          {
            "id": "679afb3d3d9bab0f83ff5247",
            "leftCorner": {
              "x": 32.025,
              "y": 10.531,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.075,
              "y": 10.576,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087161"
          },
          {
            "id": "679afb3d3d9bab0f83ff5248",
            "leftCorner": {
              "x": 32.075,
              "y": 10.576,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.139,
              "y": 10.633,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087192"
          },
          {
            "id": "679afb3d3d9bab0f83ff5249",
            "leftCorner": {
              "x": 32.139,
              "y": 10.633,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.19,
              "y": 10.678,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447121490"
          },
          {
            "id": "679afb3d3d9bab0f83ff524a",
            "leftCorner": {
              "x": 32.19,
              "y": 10.678,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.267,
              "y": 10.746,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447399141"
          },
          {
            "id": "679afb3d3d9bab0f83ff524b",
            "leftCorner": {
              "x": 32.267,
              "y": 10.746,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.374,
              "y": 10.842,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087208"
          },
          {
            "id": "679afb3d3d9bab0f83ff524c",
            "leftCorner": {
              "x": 32.374,
              "y": 10.842,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.437,
              "y": 10.899,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001907"
          },
          {
            "id": "679afb3d3d9bab0f83ff524d",
            "leftCorner": {
              "x": 32.437,
              "y": 10.899,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.485,
              "y": 10.941,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000382"
          },
          {
            "id": "679afb3d3d9bab0f83ff524e",
            "leftCorner": {
              "x": 32.485,
              "y": 10.941,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.539,
              "y": 10.989,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000382"
          },
          {
            "id": "679afb3d3d9bab0f83ff5245",
            "leftCorner": {
              "x": 32.539,
              "y": 10.989,
              "z": 1.385
            },
            "rightCorner": {
              "x": 32.637,
              "y": 11.077,
              "z": 1.385
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413540"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd4",
        "height": 1.6353,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5281",
            "leftCorner": {
              "x": 31.889,
              "y": 10.414,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 31.992,
              "y": 10.506,
              "z": 1.6353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796003505"
          },
          {
            "id": "679afb3d3d9bab0f83ff5283",
            "leftCorner": {
              "x": 31.992,
              "y": 10.506,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.054,
              "y": 10.562,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257748"
          },
          {
            "id": "679afb3d3d9bab0f83ff5284",
            "leftCorner": {
              "x": 32.054,
              "y": 10.562,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.098,
              "y": 10.601,
              "z": 1.6353
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447087246"
          },
          {
            "id": "679afb3d3d9bab0f83ff5285",
            "leftCorner": {
              "x": 32.098,
              "y": 10.601,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.141,
              "y": 10.639,
              "z": 1.6353
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447087246"
          },
          {
            "id": "679afb3d3d9bab0f83ff5286",
            "leftCorner": {
              "x": 32.141,
              "y": 10.639,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.194,
              "y": 10.687,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000021"
          },
          {
            "id": "679afb3d3d9bab0f83ff5287",
            "leftCorner": {
              "x": 32.194,
              "y": 10.687,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.243,
              "y": 10.73,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670554"
          },
          {
            "id": "679afb3d3d9bab0f83ff5288",
            "leftCorner": {
              "x": 32.243,
              "y": 10.73,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.331,
              "y": 10.809,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002249"
          },
          {
            "id": "679afb3d3d9bab0f83ff5289",
            "leftCorner": {
              "x": 32.331,
              "y": 10.809,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.412,
              "y": 10.881,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087314"
          },
          {
            "id": "679afb3d3d9bab0f83ff528a",
            "leftCorner": {
              "x": 32.412,
              "y": 10.881,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.486,
              "y": 10.947,
              "z": 1.6353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087314"
          },
          {
            "id": "679afb3d3d9bab0f83ff528b",
            "leftCorner": {
              "x": 32.486,
              "y": 10.947,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.513,
              "y": 10.971,
              "z": 1.6353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff528c",
            "leftCorner": {
              "x": 32.513,
              "y": 10.971,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.56,
              "y": 11.013,
              "z": 1.6353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff528d",
            "leftCorner": {
              "x": 32.56,
              "y": 11.013,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.591,
              "y": 11.041,
              "z": 1.6353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5282",
            "leftCorner": {
              "x": 32.591,
              "y": 11.041,
              "z": 1.6353
            },
            "rightCorner": {
              "x": 32.635,
              "y": 11.08,
              "z": 1.6353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 6,
      "hasStockCount": 43,
      "unknownStockCount": 25
    },
    "name": "S8LF",
    "leftNeighborShelfId": "FR98",
    "rightNeighborShelfId": "4DL3"
  },
  {
    "id": "DNB2",
    "x": 31.709,
    "y": 12.022,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92516,
      "w": -0.37958
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abda",
        "height": 0.18527,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52d9",
            "leftCorner": {
              "x": 31.632,
              "y": 12.101,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.591,
              "y": 12.061,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52db",
            "leftCorner": {
              "x": 31.591,
              "y": 12.061,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.573,
              "y": 12.043,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447814354"
          },
          {
            "id": "679afb3d3d9bab0f83ff52dc",
            "leftCorner": {
              "x": 31.573,
              "y": 12.043,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.544,
              "y": 12.015,
              "z": 0.18527
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447814354"
          },
          {
            "id": "679afb3d3d9bab0f83ff52dd",
            "leftCorner": {
              "x": 31.544,
              "y": 12.015,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.5,
              "y": 11.972,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172927492"
          },
          {
            "id": "679afb3d3d9bab0f83ff52de",
            "leftCorner": {
              "x": 31.5,
              "y": 11.972,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.452,
              "y": 11.923,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172927492"
          },
          {
            "id": "679afb3d3d9bab0f83ff52df",
            "leftCorner": {
              "x": 31.452,
              "y": 11.923,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.401,
              "y": 11.874,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172927492"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e0",
            "leftCorner": {
              "x": 31.401,
              "y": 11.874,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.346,
              "y": 11.819,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172927492"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e1",
            "leftCorner": {
              "x": 31.346,
              "y": 11.819,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.299,
              "y": 11.773,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172927515"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e2",
            "leftCorner": {
              "x": 31.299,
              "y": 11.773,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.256,
              "y": 11.73,
              "z": 0.18527
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e3",
            "leftCorner": {
              "x": 31.256,
              "y": 11.73,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.198,
              "y": 11.673,
              "z": 0.18527
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e4",
            "leftCorner": {
              "x": 31.198,
              "y": 11.673,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 31.02,
              "y": 11.497,
              "z": 0.18527
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172927553"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e5",
            "leftCorner": {
              "x": 31.02,
              "y": 11.497,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 30.965,
              "y": 11.443,
              "z": 0.18527
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172927577"
          },
          {
            "id": "679afb3d3d9bab0f83ff52da",
            "leftCorner": {
              "x": 30.965,
              "y": 11.443,
              "z": 0.18527
            },
            "rightCorner": {
              "x": 30.92,
              "y": 11.399,
              "z": 0.18527
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172927577"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd7",
        "height": 0.53071,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff529d",
            "leftCorner": {
              "x": 31.711,
              "y": 12.021,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.663,
              "y": 11.974,
              "z": 0.53071
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000029"
          },
          {
            "id": "679afb3d3d9bab0f83ff529e",
            "leftCorner": {
              "x": 31.663,
              "y": 11.974,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.642,
              "y": 11.952,
              "z": 0.53071
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447497298"
          },
          {
            "id": "679afb3d3d9bab0f83ff529f",
            "leftCorner": {
              "x": 31.642,
              "y": 11.952,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.616,
              "y": 11.927,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a0",
            "leftCorner": {
              "x": 31.616,
              "y": 11.927,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.572,
              "y": 11.883,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506952"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a1",
            "leftCorner": {
              "x": 31.572,
              "y": 11.883,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.524,
              "y": 11.836,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506952"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a2",
            "leftCorner": {
              "x": 31.524,
              "y": 11.836,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.474,
              "y": 11.786,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064377"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a3",
            "leftCorner": {
              "x": 31.474,
              "y": 11.786,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.425,
              "y": 11.738,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506976"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a4",
            "leftCorner": {
              "x": 31.425,
              "y": 11.738,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.378,
              "y": 11.692,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506976"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a5",
            "leftCorner": {
              "x": 31.378,
              "y": 11.692,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.33,
              "y": 11.644,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506938"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a6",
            "leftCorner": {
              "x": 31.33,
              "y": 11.644,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.282,
              "y": 11.597,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506938"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a7",
            "leftCorner": {
              "x": 31.282,
              "y": 11.597,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.233,
              "y": 11.549,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260556672892"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a8",
            "leftCorner": {
              "x": 31.233,
              "y": 11.549,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.184,
              "y": 11.501,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260556672892"
          },
          {
            "id": "679afb3d3d9bab0f83ff52a9",
            "leftCorner": {
              "x": 31.184,
              "y": 11.501,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.14,
              "y": 11.457,
              "z": 0.53071
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260556672892"
          },
          {
            "id": "679afb3d3d9bab0f83ff52aa",
            "leftCorner": {
              "x": 31.14,
              "y": 11.457,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.091,
              "y": 11.408,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260556672892"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ab",
            "leftCorner": {
              "x": 31.091,
              "y": 11.408,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 31.045,
              "y": 11.363,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260556672878"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ac",
            "leftCorner": {
              "x": 31.045,
              "y": 11.363,
              "z": 0.53071
            },
            "rightCorner": {
              "x": 30.999,
              "y": 11.318,
              "z": 0.53071
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260556672878"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd8",
        "height": 0.8224,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52ad",
            "leftCorner": {
              "x": 31.714,
              "y": 12.018,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.665,
              "y": 11.97,
              "z": 0.8224
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172917899"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ae",
            "leftCorner": {
              "x": 31.665,
              "y": 11.97,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.621,
              "y": 11.927,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562620"
          },
          {
            "id": "679afb3d3d9bab0f83ff52af",
            "leftCorner": {
              "x": 31.621,
              "y": 11.927,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.579,
              "y": 11.885,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219777"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b0",
            "leftCorner": {
              "x": 31.579,
              "y": 11.885,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.533,
              "y": 11.84,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219777"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b1",
            "leftCorner": {
              "x": 31.533,
              "y": 11.84,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.483,
              "y": 11.791,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219791"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b2",
            "leftCorner": {
              "x": 31.483,
              "y": 11.791,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.435,
              "y": 11.743,
              "z": 0.8224
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172227646"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b3",
            "leftCorner": {
              "x": 31.435,
              "y": 11.743,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.39,
              "y": 11.699,
              "z": 0.8224
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172227646"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b4",
            "leftCorner": {
              "x": 31.39,
              "y": 11.699,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.341,
              "y": 11.651,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227622"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b5",
            "leftCorner": {
              "x": 31.341,
              "y": 11.651,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.295,
              "y": 11.606,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227622"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b6",
            "leftCorner": {
              "x": 31.295,
              "y": 11.606,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.253,
              "y": 11.563,
              "z": 0.8224
            },
            "stockLevel": "NO_STOCK",
            "gtin": "703387"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b7",
            "leftCorner": {
              "x": 31.253,
              "y": 11.563,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.206,
              "y": 11.517,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9008700230186"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b8",
            "leftCorner": {
              "x": 31.206,
              "y": 11.517,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.158,
              "y": 11.47,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9008700230223"
          },
          {
            "id": "679afb3d3d9bab0f83ff52b9",
            "leftCorner": {
              "x": 31.158,
              "y": 11.47,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.113,
              "y": 11.426,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9008700230247"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ba",
            "leftCorner": {
              "x": 31.113,
              "y": 11.426,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.065,
              "y": 11.378,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52bb",
            "leftCorner": {
              "x": 31.065,
              "y": 11.378,
              "z": 0.8224
            },
            "rightCorner": {
              "x": 31.02,
              "y": 11.334,
              "z": 0.8224
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "90097287"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd5",
        "height": 1.1204,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff528e",
            "leftCorner": {
              "x": 31.716,
              "y": 12.016,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.661,
              "y": 11.962,
              "z": 1.1204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9009700306604"
          },
          {
            "id": "679afb3d3d9bab0f83ff5290",
            "leftCorner": {
              "x": 31.661,
              "y": 11.962,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.638,
              "y": 11.94,
              "z": 1.1204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5291",
            "leftCorner": {
              "x": 31.638,
              "y": 11.94,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.607,
              "y": 11.909,
              "z": 1.1204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000009"
          },
          {
            "id": "679afb3d3d9bab0f83ff5292",
            "leftCorner": {
              "x": 31.607,
              "y": 11.909,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.558,
              "y": 11.86,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "483136"
          },
          {
            "id": "679afb3d3d9bab0f83ff5293",
            "leftCorner": {
              "x": 31.558,
              "y": 11.86,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.502,
              "y": 11.805,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5294",
            "leftCorner": {
              "x": 31.502,
              "y": 11.805,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.445,
              "y": 11.75,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "422378"
          },
          {
            "id": "679afb3d3d9bab0f83ff5295",
            "leftCorner": {
              "x": 31.445,
              "y": 11.75,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.392,
              "y": 11.697,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9009700311400"
          },
          {
            "id": "679afb3d3d9bab0f83ff5296",
            "leftCorner": {
              "x": 31.392,
              "y": 11.697,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.343,
              "y": 11.648,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "90280443"
          },
          {
            "id": "679afb3d3d9bab0f83ff5297",
            "leftCorner": {
              "x": 31.343,
              "y": 11.648,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.297,
              "y": 11.603,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "90280443"
          },
          {
            "id": "679afb3d3d9bab0f83ff5298",
            "leftCorner": {
              "x": 31.297,
              "y": 11.603,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.247,
              "y": 11.553,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260339815072"
          },
          {
            "id": "679afb3d3d9bab0f83ff5299",
            "leftCorner": {
              "x": 31.247,
              "y": 11.553,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.199,
              "y": 11.507,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260339815072"
          },
          {
            "id": "679afb3d3d9bab0f83ff529a",
            "leftCorner": {
              "x": 31.199,
              "y": 11.507,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.147,
              "y": 11.455,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260339815171"
          },
          {
            "id": "679afb3d3d9bab0f83ff529b",
            "leftCorner": {
              "x": 31.147,
              "y": 11.455,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.096,
              "y": 11.405,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172637292"
          },
          {
            "id": "679afb3d3d9bab0f83ff529c",
            "leftCorner": {
              "x": 31.096,
              "y": 11.405,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.047,
              "y": 11.356,
              "z": 1.1204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172637292"
          },
          {
            "id": "679afb3d3d9bab0f83ff528f",
            "leftCorner": {
              "x": 31.047,
              "y": 11.356,
              "z": 1.1204
            },
            "rightCorner": {
              "x": 31.004,
              "y": 11.314,
              "z": 1.1204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172637292"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abd9",
        "height": 1.4275,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52bc",
            "leftCorner": {
              "x": 31.716,
              "y": 12.015,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.657,
              "y": 11.957,
              "z": 1.4275
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172631979"
          },
          {
            "id": "679afb3d3d9bab0f83ff52be",
            "leftCorner": {
              "x": 31.657,
              "y": 11.957,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.61,
              "y": 11.91,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395020"
          },
          {
            "id": "679afb3d3d9bab0f83ff52bf",
            "leftCorner": {
              "x": 31.61,
              "y": 11.91,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.562,
              "y": 11.863,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395020"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c0",
            "leftCorner": {
              "x": 31.562,
              "y": 11.863,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.508,
              "y": 11.809,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395020"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c1",
            "leftCorner": {
              "x": 31.508,
              "y": 11.809,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.454,
              "y": 11.757,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395020"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c2",
            "leftCorner": {
              "x": 31.454,
              "y": 11.757,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.402,
              "y": 11.706,
              "z": 1.4275
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4067796068221"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c3",
            "leftCorner": {
              "x": 31.402,
              "y": 11.706,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.357,
              "y": 11.661,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343083"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c4",
            "leftCorner": {
              "x": 31.357,
              "y": 11.661,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.313,
              "y": 11.617,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001471"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c5",
            "leftCorner": {
              "x": 31.313,
              "y": 11.617,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.265,
              "y": 11.57,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001471"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c6",
            "leftCorner": {
              "x": 31.265,
              "y": 11.57,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.223,
              "y": 11.529,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447356007"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c7",
            "leftCorner": {
              "x": 31.223,
              "y": 11.529,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.179,
              "y": 11.486,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447356007"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c8",
            "leftCorner": {
              "x": 31.179,
              "y": 11.486,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.141,
              "y": 11.448,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048517718946"
          },
          {
            "id": "679afb3d3d9bab0f83ff52c9",
            "leftCorner": {
              "x": 31.141,
              "y": 11.448,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.105,
              "y": 11.412,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048517718946"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ca",
            "leftCorner": {
              "x": 31.105,
              "y": 11.412,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.07,
              "y": 11.377,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048517718922"
          },
          {
            "id": "679afb3d3d9bab0f83ff52cb",
            "leftCorner": {
              "x": 31.07,
              "y": 11.377,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 31.032,
              "y": 11.341,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048517718922"
          },
          {
            "id": "679afb3d3d9bab0f83ff52cc",
            "leftCorner": {
              "x": 31.032,
              "y": 11.341,
              "z": 1.4275
            },
            "rightCorner": {
              "x": 30.99,
              "y": 11.299,
              "z": 1.4275
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048517718953"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abdc",
        "height": 1.6788,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52e6",
            "leftCorner": {
              "x": 31.718,
              "y": 12.014,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.67,
              "y": 11.966,
              "z": 1.6788
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015533055447"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e8",
            "leftCorner": {
              "x": 31.67,
              "y": 11.966,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.633,
              "y": 11.929,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533055447"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e9",
            "leftCorner": {
              "x": 31.633,
              "y": 11.929,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.593,
              "y": 11.89,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533055447"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ea",
            "leftCorner": {
              "x": 31.593,
              "y": 11.89,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.554,
              "y": 11.851,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533055447"
          },
          {
            "id": "679afb3d3d9bab0f83ff52eb",
            "leftCorner": {
              "x": 31.554,
              "y": 11.851,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.471,
              "y": 11.77,
              "z": 1.6788
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015533055461"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ec",
            "leftCorner": {
              "x": 31.471,
              "y": 11.77,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.388,
              "y": 11.688,
              "z": 1.6788
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260407954436"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ed",
            "leftCorner": {
              "x": 31.388,
              "y": 11.688,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.348,
              "y": 11.649,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407951909"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ee",
            "leftCorner": {
              "x": 31.348,
              "y": 11.649,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.308,
              "y": 11.609,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407951909"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ef",
            "leftCorner": {
              "x": 31.308,
              "y": 11.609,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.267,
              "y": 11.569,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407953774"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f0",
            "leftCorner": {
              "x": 31.267,
              "y": 11.569,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.227,
              "y": 11.529,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407953774"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f1",
            "leftCorner": {
              "x": 31.227,
              "y": 11.529,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.186,
              "y": 11.489,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407951954"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f2",
            "leftCorner": {
              "x": 31.186,
              "y": 11.489,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.146,
              "y": 11.449,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407951954"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f3",
            "leftCorner": {
              "x": 31.146,
              "y": 11.449,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.105,
              "y": 11.408,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070194"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f4",
            "leftCorner": {
              "x": 31.105,
              "y": 11.408,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.061,
              "y": 11.365,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070194"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f5",
            "leftCorner": {
              "x": 31.061,
              "y": 11.365,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 31.02,
              "y": 11.325,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227424"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f6",
            "leftCorner": {
              "x": 31.02,
              "y": 11.325,
              "z": 1.6788
            },
            "rightCorner": {
              "x": 30.964,
              "y": 11.269,
              "z": 1.6788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227424"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 13,
      "hasStockCount": 64,
      "unknownStockCount": 14
    },
    "name": "DNB2",
    "leftNeighborShelfId": "6EOH",
    "rightNeighborShelfId": "HMHR"
  },
  {
    "id": "QUSR",
    "x": 31.003,
    "y": 11.327,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92529,
      "w": -0.37926
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abe0",
        "height": 0.19547,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5348",
            "leftCorner": {
              "x": 30.915,
              "y": 11.377,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.862,
              "y": 11.325,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191502103"
          },
          {
            "id": "679afb3d3d9bab0f83ff5349",
            "leftCorner": {
              "x": 30.862,
              "y": 11.325,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.803,
              "y": 11.267,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000009"
          },
          {
            "id": "679afb3d3d9bab0f83ff534a",
            "leftCorner": {
              "x": 30.803,
              "y": 11.267,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.743,
              "y": 11.207,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191502028"
          },
          {
            "id": "679afb3d3d9bab0f83ff534b",
            "leftCorner": {
              "x": 30.743,
              "y": 11.207,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.69,
              "y": 11.156,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191502011"
          },
          {
            "id": "679afb3d3d9bab0f83ff534c",
            "leftCorner": {
              "x": 30.69,
              "y": 11.156,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.635,
              "y": 11.101,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191501434"
          },
          {
            "id": "679afb3d3d9bab0f83ff534d",
            "leftCorner": {
              "x": 30.635,
              "y": 11.101,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.582,
              "y": 11.049,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191505296"
          },
          {
            "id": "679afb3d3d9bab0f83ff534e",
            "leftCorner": {
              "x": 30.582,
              "y": 11.049,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.522,
              "y": 10.99,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191500017"
          },
          {
            "id": "679afb3d3d9bab0f83ff534f",
            "leftCorner": {
              "x": 30.522,
              "y": 10.99,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.468,
              "y": 10.936,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191505821"
          },
          {
            "id": "679afb3d3d9bab0f83ff5350",
            "leftCorner": {
              "x": 30.468,
              "y": 10.936,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.413,
              "y": 10.882,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191500086"
          },
          {
            "id": "679afb3d3d9bab0f83ff5351",
            "leftCorner": {
              "x": 30.413,
              "y": 10.882,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.365,
              "y": 10.835,
              "z": 0.19547
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4004191500086"
          },
          {
            "id": "679afb3d3d9bab0f83ff5352",
            "leftCorner": {
              "x": 30.365,
              "y": 10.835,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.308,
              "y": 10.778,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9008700193634"
          },
          {
            "id": "679afb3d3d9bab0f83ff5353",
            "leftCorner": {
              "x": 30.308,
              "y": 10.778,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.256,
              "y": 10.728,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9008700193634"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abdd",
        "height": 0.54691,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5329",
            "leftCorner": {
              "x": 31.011,
              "y": 11.318,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.952,
              "y": 11.26,
              "z": 0.54691
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260739992953"
          },
          {
            "id": "679afb3d3d9bab0f83ff532b",
            "leftCorner": {
              "x": 30.952,
              "y": 11.26,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.911,
              "y": 11.219,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227707"
          },
          {
            "id": "679afb3d3d9bab0f83ff532c",
            "leftCorner": {
              "x": 30.911,
              "y": 11.219,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.869,
              "y": 11.178,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227707"
          },
          {
            "id": "679afb3d3d9bab0f83ff532d",
            "leftCorner": {
              "x": 30.869,
              "y": 11.178,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.829,
              "y": 11.139,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627842"
          },
          {
            "id": "679afb3d3d9bab0f83ff532e",
            "leftCorner": {
              "x": 30.829,
              "y": 11.139,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.79,
              "y": 11.1,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627842"
          },
          {
            "id": "679afb3d3d9bab0f83ff532f",
            "leftCorner": {
              "x": 30.79,
              "y": 11.1,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.743,
              "y": 11.054,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447477153"
          },
          {
            "id": "679afb3d3d9bab0f83ff5330",
            "leftCorner": {
              "x": 30.743,
              "y": 11.054,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.699,
              "y": 11.011,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627781"
          },
          {
            "id": "679afb3d3d9bab0f83ff5331",
            "leftCorner": {
              "x": 30.699,
              "y": 11.011,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.656,
              "y": 10.968,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172243059"
          },
          {
            "id": "679afb3d3d9bab0f83ff5332",
            "leftCorner": {
              "x": 30.656,
              "y": 10.968,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.607,
              "y": 10.919,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172243059"
          },
          {
            "id": "679afb3d3d9bab0f83ff5333",
            "leftCorner": {
              "x": 30.607,
              "y": 10.919,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.562,
              "y": 10.875,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627743"
          },
          {
            "id": "679afb3d3d9bab0f83ff5334",
            "leftCorner": {
              "x": 30.562,
              "y": 10.875,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.539,
              "y": 10.853,
              "z": 0.54691
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447517309"
          },
          {
            "id": "679afb3d3d9bab0f83ff5335",
            "leftCorner": {
              "x": 30.539,
              "y": 10.853,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.517,
              "y": 10.831,
              "z": 0.54691
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447517309"
          },
          {
            "id": "679afb3d3d9bab0f83ff5336",
            "leftCorner": {
              "x": 30.517,
              "y": 10.831,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.47,
              "y": 10.785,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002157"
          },
          {
            "id": "679afb3d3d9bab0f83ff5337",
            "leftCorner": {
              "x": 30.47,
              "y": 10.785,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.429,
              "y": 10.745,
              "z": 0.54691
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4067796000412"
          },
          {
            "id": "679afb3d3d9bab0f83ff5338",
            "leftCorner": {
              "x": 30.429,
              "y": 10.745,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.384,
              "y": 10.7,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227943"
          },
          {
            "id": "679afb3d3d9bab0f83ff5339",
            "leftCorner": {
              "x": 30.384,
              "y": 10.7,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.338,
              "y": 10.655,
              "z": 0.54691
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227943"
          },
          {
            "id": "679afb3d3d9bab0f83ff532a",
            "leftCorner": {
              "x": 30.338,
              "y": 10.655,
              "z": 0.54691
            },
            "rightCorner": {
              "x": 30.299,
              "y": 10.616,
              "z": 0.54691
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172623677"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abdf",
        "height": 0.83696,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff533a",
            "leftCorner": {
              "x": 31.013,
              "y": 11.316,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.978,
              "y": 11.282,
              "z": 0.83696
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff533c",
            "leftCorner": {
              "x": 30.978,
              "y": 11.282,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.922,
              "y": 11.227,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332773"
          },
          {
            "id": "679afb3d3d9bab0f83ff533d",
            "leftCorner": {
              "x": 30.922,
              "y": 11.227,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.868,
              "y": 11.173,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343045"
          },
          {
            "id": "679afb3d3d9bab0f83ff533e",
            "leftCorner": {
              "x": 30.868,
              "y": 11.173,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.805,
              "y": 11.111,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343045"
          },
          {
            "id": "679afb3d3d9bab0f83ff533f",
            "leftCorner": {
              "x": 30.805,
              "y": 11.111,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.75,
              "y": 11.057,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343021"
          },
          {
            "id": "679afb3d3d9bab0f83ff5340",
            "leftCorner": {
              "x": 30.75,
              "y": 11.057,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.687,
              "y": 10.996,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343069"
          },
          {
            "id": "679afb3d3d9bab0f83ff5341",
            "leftCorner": {
              "x": 30.687,
              "y": 10.996,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.633,
              "y": 10.942,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355987"
          },
          {
            "id": "679afb3d3d9bab0f83ff5342",
            "leftCorner": {
              "x": 30.633,
              "y": 10.942,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.57,
              "y": 10.88,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355987"
          },
          {
            "id": "679afb3d3d9bab0f83ff5343",
            "leftCorner": {
              "x": 30.57,
              "y": 10.88,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.508,
              "y": 10.819,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533053849"
          },
          {
            "id": "679afb3d3d9bab0f83ff5344",
            "leftCorner": {
              "x": 30.508,
              "y": 10.819,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.461,
              "y": 10.772,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533053306"
          },
          {
            "id": "679afb3d3d9bab0f83ff5345",
            "leftCorner": {
              "x": 30.461,
              "y": 10.772,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.41,
              "y": 10.722,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533051807"
          },
          {
            "id": "679afb3d3d9bab0f83ff5346",
            "leftCorner": {
              "x": 30.41,
              "y": 10.722,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.358,
              "y": 10.671,
              "z": 0.83696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533051821"
          },
          {
            "id": "679afb3d3d9bab0f83ff533b",
            "leftCorner": {
              "x": 30.358,
              "y": 10.671,
              "z": 0.83696
            },
            "rightCorner": {
              "x": 30.301,
              "y": 10.615,
              "z": 0.83696
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015533055508"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe2",
        "height": 1.1756,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5382",
            "leftCorner": {
              "x": 31.014,
              "y": 11.316,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.944,
              "y": 11.247,
              "z": 1.1756
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172218149"
          },
          {
            "id": "679afb3d3d9bab0f83ff5384",
            "leftCorner": {
              "x": 30.944,
              "y": 11.247,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.89,
              "y": 11.193,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172218149"
          },
          {
            "id": "679afb3d3d9bab0f83ff5385",
            "leftCorner": {
              "x": 30.89,
              "y": 11.193,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.832,
              "y": 11.136,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172932526"
          },
          {
            "id": "679afb3d3d9bab0f83ff5386",
            "leftCorner": {
              "x": 30.832,
              "y": 11.136,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.777,
              "y": 11.082,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064292"
          },
          {
            "id": "679afb3d3d9bab0f83ff5387",
            "leftCorner": {
              "x": 30.777,
              "y": 11.082,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.72,
              "y": 11.026,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796087376"
          },
          {
            "id": "679afb3d3d9bab0f83ff5388",
            "leftCorner": {
              "x": 30.72,
              "y": 11.026,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.668,
              "y": 10.975,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001129"
          },
          {
            "id": "679afb3d3d9bab0f83ff5389",
            "leftCorner": {
              "x": 30.668,
              "y": 10.975,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.617,
              "y": 10.924,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001129"
          },
          {
            "id": "679afb3d3d9bab0f83ff538a",
            "leftCorner": {
              "x": 30.617,
              "y": 10.924,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.563,
              "y": 10.871,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001129"
          },
          {
            "id": "679afb3d3d9bab0f83ff538b",
            "leftCorner": {
              "x": 30.563,
              "y": 10.871,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.503,
              "y": 10.812,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084948"
          },
          {
            "id": "679afb3d3d9bab0f83ff538c",
            "leftCorner": {
              "x": 30.503,
              "y": 10.812,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.451,
              "y": 10.761,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084948"
          },
          {
            "id": "679afb3d3d9bab0f83ff538d",
            "leftCorner": {
              "x": 30.451,
              "y": 10.761,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.391,
              "y": 10.702,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff538e",
            "leftCorner": {
              "x": 30.391,
              "y": 10.702,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.343,
              "y": 10.654,
              "z": 1.1756
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001181"
          },
          {
            "id": "679afb3d3d9bab0f83ff5383",
            "leftCorner": {
              "x": 30.343,
              "y": 10.654,
              "z": 1.1756
            },
            "rightCorner": {
              "x": 30.302,
              "y": 10.614,
              "z": 1.1756
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796001181"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abde",
        "height": 1.4289,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52cd",
            "leftCorner": {
              "x": 31.002,
              "y": 11.299,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.945,
              "y": 11.243,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001143"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ce",
            "leftCorner": {
              "x": 30.945,
              "y": 11.243,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.889,
              "y": 11.187,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001143"
          },
          {
            "id": "679afb3d3d9bab0f83ff52cf",
            "leftCorner": {
              "x": 30.889,
              "y": 11.187,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.832,
              "y": 11.131,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001143"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d0",
            "leftCorner": {
              "x": 30.832,
              "y": 11.131,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.776,
              "y": 11.076,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d1",
            "leftCorner": {
              "x": 30.776,
              "y": 11.076,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.722,
              "y": 11.023,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084993"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d2",
            "leftCorner": {
              "x": 30.722,
              "y": 11.023,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.662,
              "y": 10.963,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084993"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d3",
            "leftCorner": {
              "x": 30.662,
              "y": 10.963,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.612,
              "y": 10.915,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084993"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d4",
            "leftCorner": {
              "x": 30.612,
              "y": 10.915,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.565,
              "y": 10.868,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796084993"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d5",
            "leftCorner": {
              "x": 30.565,
              "y": 10.868,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.511,
              "y": 10.814,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d6",
            "leftCorner": {
              "x": 30.511,
              "y": 10.814,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.46,
              "y": 10.764,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d7",
            "leftCorner": {
              "x": 30.46,
              "y": 10.764,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.403,
              "y": 10.709,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52d8",
            "leftCorner": {
              "x": 30.403,
              "y": 10.709,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.346,
              "y": 10.652,
              "z": 1.4289
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001051"
          },
          {
            "id": "679afb3d3d9bab0f83ff52bd",
            "leftCorner": {
              "x": 30.346,
              "y": 10.652,
              "z": 1.4289
            },
            "rightCorner": {
              "x": 30.304,
              "y": 10.611,
              "z": 1.4289
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe1",
        "height": 1.6779,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff52f7",
            "leftCorner": {
              "x": 30.977,
              "y": 11.268,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.935,
              "y": 11.226,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227448"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f8",
            "leftCorner": {
              "x": 30.935,
              "y": 11.226,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.887,
              "y": 11.179,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172227448"
          },
          {
            "id": "679afb3d3d9bab0f83ff52f9",
            "leftCorner": {
              "x": 30.887,
              "y": 11.179,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.842,
              "y": 11.135,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627767"
          },
          {
            "id": "679afb3d3d9bab0f83ff52fa",
            "leftCorner": {
              "x": 30.842,
              "y": 11.135,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.799,
              "y": 11.092,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172627767"
          },
          {
            "id": "679afb3d3d9bab0f83ff52fb",
            "leftCorner": {
              "x": 30.799,
              "y": 11.092,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.756,
              "y": 11.05,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52fc",
            "leftCorner": {
              "x": 30.756,
              "y": 11.05,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.714,
              "y": 11.008,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff52fd",
            "leftCorner": {
              "x": 30.714,
              "y": 11.008,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.674,
              "y": 10.969,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796108064"
          },
          {
            "id": "679afb3d3d9bab0f83ff52fe",
            "leftCorner": {
              "x": 30.674,
              "y": 10.969,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.633,
              "y": 10.929,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796108064"
          },
          {
            "id": "679afb3d3d9bab0f83ff52ff",
            "leftCorner": {
              "x": 30.633,
              "y": 10.929,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.518,
              "y": 10.815,
              "z": 1.6779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015533051043"
          },
          {
            "id": "679afb3d3d9bab0f83ff5300",
            "leftCorner": {
              "x": 30.518,
              "y": 10.815,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.386,
              "y": 10.685,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015533051029"
          },
          {
            "id": "679afb3d3d9bab0f83ff5301",
            "leftCorner": {
              "x": 30.386,
              "y": 10.685,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.335,
              "y": 10.635,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5302",
            "leftCorner": {
              "x": 30.335,
              "y": 10.635,
              "z": 1.6779
            },
            "rightCorner": {
              "x": 30.29,
              "y": 10.591,
              "z": 1.6779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 68,
      "unknownStockCount": 8
    },
    "name": "QUSR",
    "leftNeighborShelfId": "6267",
    "rightNeighborShelfId": "ZZOW"
  },
  {
    "id": "YOAF",
    "x": 19.715,
    "y": 8.2158,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99998,
      "w": -0.0058188
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abe9",
        "height": 0.19754,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53de",
            "leftCorner": {
              "x": 19.718,
              "y": 8.3187,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.69,
              "y": 8.3184,
              "z": 0.19754
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff53df",
            "leftCorner": {
              "x": 19.69,
              "y": 8.3184,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.612,
              "y": 8.3175,
              "z": 0.19754
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251758434340"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e0",
            "leftCorner": {
              "x": 19.612,
              "y": 8.3175,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.568,
              "y": 8.317,
              "z": 0.19754
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e1",
            "leftCorner": {
              "x": 19.568,
              "y": 8.317,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.487,
              "y": 8.3161,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448134640"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e2",
            "leftCorner": {
              "x": 19.487,
              "y": 8.3161,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.4,
              "y": 8.3151,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448134640"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e3",
            "leftCorner": {
              "x": 19.4,
              "y": 8.3151,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.275,
              "y": 8.3136,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758434562"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e4",
            "leftCorner": {
              "x": 19.275,
              "y": 8.3136,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.186,
              "y": 8.3126,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e5",
            "leftCorner": {
              "x": 19.186,
              "y": 8.3126,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.101,
              "y": 8.3116,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377361"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e6",
            "leftCorner": {
              "x": 19.101,
              "y": 8.3116,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 19.022,
              "y": 8.3106,
              "z": 0.19754
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355154"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e7",
            "leftCorner": {
              "x": 19.022,
              "y": 8.3106,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 18.862,
              "y": 8.3088,
              "z": 0.19754
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690018"
          },
          {
            "id": "679afb3d3d9bab0f83ff53e8",
            "leftCorner": {
              "x": 18.862,
              "y": 8.3088,
              "z": 0.19754
            },
            "rightCorner": {
              "x": 18.719,
              "y": 8.3071,
              "z": 0.19754
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447716702"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe3",
        "height": 0.46193,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff538f",
            "leftCorner": {
              "x": 19.715,
              "y": 8.2106,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.642,
              "y": 8.2098,
              "z": 0.46193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447235869"
          },
          {
            "id": "679afb3d3d9bab0f83ff5391",
            "leftCorner": {
              "x": 19.642,
              "y": 8.2098,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.609,
              "y": 8.2094,
              "z": 0.46193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5392",
            "leftCorner": {
              "x": 19.609,
              "y": 8.2094,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.553,
              "y": 8.2087,
              "z": 0.46193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796075403"
          },
          {
            "id": "679afb3d3d9bab0f83ff5393",
            "leftCorner": {
              "x": 19.553,
              "y": 8.2087,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.505,
              "y": 8.2082,
              "z": 0.46193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796075403"
          },
          {
            "id": "679afb3d3d9bab0f83ff5394",
            "leftCorner": {
              "x": 19.505,
              "y": 8.2082,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.398,
              "y": 8.2069,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172936098"
          },
          {
            "id": "679afb3d3d9bab0f83ff5395",
            "leftCorner": {
              "x": 19.398,
              "y": 8.2069,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.286,
              "y": 8.2056,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172936128"
          },
          {
            "id": "679afb3d3d9bab0f83ff5396",
            "leftCorner": {
              "x": 19.286,
              "y": 8.2056,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.18,
              "y": 8.2044,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467673"
          },
          {
            "id": "679afb3d3d9bab0f83ff5397",
            "leftCorner": {
              "x": 19.18,
              "y": 8.2044,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 19.099,
              "y": 8.2034,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447364125"
          },
          {
            "id": "679afb3d3d9bab0f83ff5398",
            "leftCorner": {
              "x": 19.099,
              "y": 8.2034,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 18.976,
              "y": 8.202,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447363197"
          },
          {
            "id": "679afb3d3d9bab0f83ff5399",
            "leftCorner": {
              "x": 18.976,
              "y": 8.202,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 18.893,
              "y": 8.201,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704310"
          },
          {
            "id": "679afb3d3d9bab0f83ff539a",
            "leftCorner": {
              "x": 18.893,
              "y": 8.201,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 18.81,
              "y": 8.2001,
              "z": 0.46193
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447735086"
          },
          {
            "id": "679afb3d3d9bab0f83ff5390",
            "leftCorner": {
              "x": 18.81,
              "y": 8.2001,
              "z": 0.46193
            },
            "rightCorner": {
              "x": 18.716,
              "y": 8.199,
              "z": 0.46193
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678369"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe4",
        "height": 0.7154,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff539b",
            "leftCorner": {
              "x": 19.715,
              "y": 8.2079,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.634,
              "y": 8.207,
              "z": 0.7154
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4030651047471"
          },
          {
            "id": "679afb3d3d9bab0f83ff539d",
            "leftCorner": {
              "x": 19.634,
              "y": 8.207,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.598,
              "y": 8.2065,
              "z": 0.7154
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff539e",
            "leftCorner": {
              "x": 19.598,
              "y": 8.2065,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.554,
              "y": 8.206,
              "z": 0.7154
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4030651041783"
          },
          {
            "id": "679afb3d3d9bab0f83ff539f",
            "leftCorner": {
              "x": 19.554,
              "y": 8.206,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.505,
              "y": 8.2055,
              "z": 0.7154
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4030651041783"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a0",
            "leftCorner": {
              "x": 19.505,
              "y": 8.2055,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.399,
              "y": 8.2042,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030651046047"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a1",
            "leftCorner": {
              "x": 19.399,
              "y": 8.2042,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.336,
              "y": 8.2035,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030651053083"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a2",
            "leftCorner": {
              "x": 19.336,
              "y": 8.2035,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.231,
              "y": 8.2023,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030651051720"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a3",
            "leftCorner": {
              "x": 19.231,
              "y": 8.2023,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.167,
              "y": 8.2015,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447730418"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a4",
            "leftCorner": {
              "x": 19.167,
              "y": 8.2015,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 19.074,
              "y": 8.2004,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447678406"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a5",
            "leftCorner": {
              "x": 19.074,
              "y": 8.2004,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 18.972,
              "y": 8.1993,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447570342"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a6",
            "leftCorner": {
              "x": 18.972,
              "y": 8.1993,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 18.868,
              "y": 8.1981,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447570342"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a7",
            "leftCorner": {
              "x": 18.868,
              "y": 8.1981,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 18.781,
              "y": 8.197,
              "z": 0.7154
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382969"
          },
          {
            "id": "679afb3d3d9bab0f83ff539c",
            "leftCorner": {
              "x": 18.781,
              "y": 8.197,
              "z": 0.7154
            },
            "rightCorner": {
              "x": 18.716,
              "y": 8.1963,
              "z": 0.7154
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447756869"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe6",
        "height": 0.96572,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53b4",
            "leftCorner": {
              "x": 19.715,
              "y": 8.2089,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.668,
              "y": 8.2083,
              "z": 0.96572
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491111843"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b6",
            "leftCorner": {
              "x": 19.668,
              "y": 8.2083,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.632,
              "y": 8.2079,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491111843"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b7",
            "leftCorner": {
              "x": 19.632,
              "y": 8.2079,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.57,
              "y": 8.2072,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491101387"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b8",
            "leftCorner": {
              "x": 19.57,
              "y": 8.2072,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.503,
              "y": 8.2064,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491106252"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b9",
            "leftCorner": {
              "x": 19.503,
              "y": 8.2064,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.395,
              "y": 8.2052,
              "z": 0.96572
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000010"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ba",
            "leftCorner": {
              "x": 19.395,
              "y": 8.2052,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.275,
              "y": 8.2038,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233176420"
          },
          {
            "id": "679afb3d3d9bab0f83ff53bb",
            "leftCorner": {
              "x": 19.275,
              "y": 8.2038,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.168,
              "y": 8.2025,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233176697"
          },
          {
            "id": "679afb3d3d9bab0f83ff53bc",
            "leftCorner": {
              "x": 19.168,
              "y": 8.2025,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 19.064,
              "y": 8.2013,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233174488"
          },
          {
            "id": "679afb3d3d9bab0f83ff53bd",
            "leftCorner": {
              "x": 19.064,
              "y": 8.2013,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 18.964,
              "y": 8.2002,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059779050934"
          },
          {
            "id": "679afb3d3d9bab0f83ff53be",
            "leftCorner": {
              "x": 18.964,
              "y": 8.2002,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 18.864,
              "y": 8.199,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059779039854"
          },
          {
            "id": "679afb3d3d9bab0f83ff53bf",
            "leftCorner": {
              "x": 18.864,
              "y": 8.199,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 18.775,
              "y": 8.198,
              "z": 0.96572
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059779050781"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b5",
            "leftCorner": {
              "x": 18.775,
              "y": 8.198,
              "z": 0.96572
            },
            "rightCorner": {
              "x": 18.716,
              "y": 8.1973,
              "z": 0.96572
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4059779052327"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe5",
        "height": 1.2183,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53a8",
            "leftCorner": {
              "x": 19.715,
              "y": 8.213,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.656,
              "y": 8.2123,
              "z": 1.2183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491109932"
          },
          {
            "id": "679afb3d3d9bab0f83ff53aa",
            "leftCorner": {
              "x": 19.656,
              "y": 8.2123,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.623,
              "y": 8.212,
              "z": 1.2183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491109932"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ab",
            "leftCorner": {
              "x": 19.623,
              "y": 8.212,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.567,
              "y": 8.2113,
              "z": 1.2183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491100229"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ac",
            "leftCorner": {
              "x": 19.567,
              "y": 8.2113,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.519,
              "y": 8.2107,
              "z": 1.2183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491100229"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ad",
            "leftCorner": {
              "x": 19.519,
              "y": 8.2107,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.414,
              "y": 8.2095,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491130646"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ae",
            "leftCorner": {
              "x": 19.414,
              "y": 8.2095,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.299,
              "y": 8.2082,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491130608"
          },
          {
            "id": "679afb3d3d9bab0f83ff53af",
            "leftCorner": {
              "x": 19.299,
              "y": 8.2082,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.192,
              "y": 8.2069,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491107792"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b0",
            "leftCorner": {
              "x": 19.192,
              "y": 8.2069,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 19.09,
              "y": 8.2058,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491126878"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b1",
            "leftCorner": {
              "x": 19.09,
              "y": 8.2058,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 18.988,
              "y": 8.2046,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491100182"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b2",
            "leftCorner": {
              "x": 18.988,
              "y": 8.2046,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 18.921,
              "y": 8.2038,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491103596"
          },
          {
            "id": "679afb3d3d9bab0f83ff53b3",
            "leftCorner": {
              "x": 18.921,
              "y": 8.2038,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 18.81,
              "y": 8.2025,
              "z": 1.2183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331002839"
          },
          {
            "id": "679afb3d3d9bab0f83ff53a9",
            "leftCorner": {
              "x": 18.81,
              "y": 8.2025,
              "z": 1.2183
            },
            "rightCorner": {
              "x": 18.716,
              "y": 8.2014,
              "z": 1.2183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331001481"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe7",
        "height": 1.4763,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53c0",
            "leftCorner": {
              "x": 19.715,
              "y": 8.2111,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.656,
              "y": 8.2104,
              "z": 1.4763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429022"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c2",
            "leftCorner": {
              "x": 19.656,
              "y": 8.2104,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.621,
              "y": 8.21,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429022"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c3",
            "leftCorner": {
              "x": 19.621,
              "y": 8.21,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.552,
              "y": 8.2092,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428988"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c4",
            "leftCorner": {
              "x": 19.552,
              "y": 8.2092,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.482,
              "y": 8.2084,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428988"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c5",
            "leftCorner": {
              "x": 19.482,
              "y": 8.2084,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.408,
              "y": 8.2075,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428964"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c6",
            "leftCorner": {
              "x": 19.408,
              "y": 8.2075,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.329,
              "y": 8.2066,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429169"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c7",
            "leftCorner": {
              "x": 19.329,
              "y": 8.2066,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.258,
              "y": 8.2058,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001306"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c8",
            "leftCorner": {
              "x": 19.258,
              "y": 8.2058,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.19,
              "y": 8.205,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001221"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c9",
            "leftCorner": {
              "x": 19.19,
              "y": 8.205,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.123,
              "y": 8.2042,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001085"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ca",
            "leftCorner": {
              "x": 19.123,
              "y": 8.2042,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 19.047,
              "y": 8.2033,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001207"
          },
          {
            "id": "679afb3d3d9bab0f83ff53cb",
            "leftCorner": {
              "x": 19.047,
              "y": 8.2033,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 18.979,
              "y": 8.2026,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331004482"
          },
          {
            "id": "679afb3d3d9bab0f83ff53cc",
            "leftCorner": {
              "x": 18.979,
              "y": 8.2026,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 18.91,
              "y": 8.2017,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331002815"
          },
          {
            "id": "679afb3d3d9bab0f83ff53cd",
            "leftCorner": {
              "x": 18.91,
              "y": 8.2017,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 18.836,
              "y": 8.2009,
              "z": 1.4763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331002792"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ce",
            "leftCorner": {
              "x": 18.836,
              "y": 8.2009,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 18.757,
              "y": 8.2,
              "z": 1.4763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331003669"
          },
          {
            "id": "679afb3d3d9bab0f83ff53c1",
            "leftCorner": {
              "x": 18.757,
              "y": 8.2,
              "z": 1.4763
            },
            "rightCorner": {
              "x": 18.716,
              "y": 8.1995,
              "z": 1.4763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331003683"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abe8",
        "height": 1.7234,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53cf",
            "leftCorner": {
              "x": 19.716,
              "y": 8.2039,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.654,
              "y": 8.2032,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429046"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d0",
            "leftCorner": {
              "x": 19.654,
              "y": 8.2032,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.62,
              "y": 8.2027,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429046"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d1",
            "leftCorner": {
              "x": 19.62,
              "y": 8.2027,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.585,
              "y": 8.2023,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429060"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d2",
            "leftCorner": {
              "x": 19.585,
              "y": 8.2023,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.547,
              "y": 8.2019,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429060"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d3",
            "leftCorner": {
              "x": 19.547,
              "y": 8.2019,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.467,
              "y": 8.201,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447438642"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d4",
            "leftCorner": {
              "x": 19.467,
              "y": 8.201,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.409,
              "y": 8.2003,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467635"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d5",
            "leftCorner": {
              "x": 19.409,
              "y": 8.2003,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.354,
              "y": 8.1997,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467659"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d6",
            "leftCorner": {
              "x": 19.354,
              "y": 8.1997,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.306,
              "y": 8.1991,
              "z": 1.7234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447467710"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d7",
            "leftCorner": {
              "x": 19.306,
              "y": 8.1991,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.225,
              "y": 8.1982,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100721843"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d8",
            "leftCorner": {
              "x": 19.225,
              "y": 8.1982,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.142,
              "y": 8.1972,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542460347"
          },
          {
            "id": "679afb3d3d9bab0f83ff53d9",
            "leftCorner": {
              "x": 19.142,
              "y": 8.1972,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 19.055,
              "y": 8.1962,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542463386"
          },
          {
            "id": "679afb3d3d9bab0f83ff53da",
            "leftCorner": {
              "x": 19.055,
              "y": 8.1962,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 18.976,
              "y": 8.1953,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001160"
          },
          {
            "id": "679afb3d3d9bab0f83ff53db",
            "leftCorner": {
              "x": 18.976,
              "y": 8.1953,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 18.905,
              "y": 8.1944,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900936059"
          },
          {
            "id": "679afb3d3d9bab0f83ff53dc",
            "leftCorner": {
              "x": 18.905,
              "y": 8.1944,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 18.829,
              "y": 8.1935,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235847"
          },
          {
            "id": "679afb3d3d9bab0f83ff53dd",
            "leftCorner": {
              "x": 18.829,
              "y": 8.1935,
              "z": 1.7234
            },
            "rightCorner": {
              "x": 18.728,
              "y": 8.1924,
              "z": 1.7234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661444123"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 58,
      "unknownStockCount": 32
    },
    "name": "YOAF",
    "leftNeighborShelfId": "JZYK",
    "rightNeighborShelfId": "8FP9"
  },
  {
    "id": "4DL3",
    "x": 30.288,
    "y": 10.613,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92394,
      "w": -0.38254
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abee",
        "height": 0.19673,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5354",
            "leftCorner": {
              "x": 30.256,
              "y": 10.728,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 30.166,
              "y": 10.639,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698004838"
          },
          {
            "id": "679afb3d3d9bab0f83ff5355",
            "leftCorner": {
              "x": 30.151,
              "y": 10.638,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 30.052,
              "y": 10.539,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698004869"
          },
          {
            "id": "679afb3d3d9bab0f83ff5356",
            "leftCorner": {
              "x": 30.052,
              "y": 10.539,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.962,
              "y": 10.449,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698004869"
          },
          {
            "id": "679afb3d3d9bab0f83ff5357",
            "leftCorner": {
              "x": 29.962,
              "y": 10.449,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.877,
              "y": 10.363,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537410426"
          },
          {
            "id": "679afb3d3d9bab0f83ff5358",
            "leftCorner": {
              "x": 29.877,
              "y": 10.363,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.803,
              "y": 10.29,
              "z": 0.19673
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015537475029"
          },
          {
            "id": "679afb3d3d9bab0f83ff5359",
            "leftCorner": {
              "x": 29.803,
              "y": 10.29,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.722,
              "y": 10.209,
              "z": 0.19673
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015537442328"
          },
          {
            "id": "679afb3d3d9bab0f83ff535a",
            "leftCorner": {
              "x": 29.722,
              "y": 10.209,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.665,
              "y": 10.152,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143673377"
          },
          {
            "id": "679afb3d3d9bab0f83ff535b",
            "leftCorner": {
              "x": 29.665,
              "y": 10.152,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.578,
              "y": 10.064,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143673360"
          },
          {
            "id": "679afb3d3d9bab0f83ff535c",
            "leftCorner": {
              "x": 29.578,
              "y": 10.064,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.502,
              "y": 9.9894,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143673384"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abeb",
        "height": 0.46053,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53f0",
            "leftCorner": {
              "x": 30.284,
              "y": 10.617,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 30.195,
              "y": 10.528,
              "z": 0.46053
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008698001059"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f2",
            "leftCorner": {
              "x": 30.195,
              "y": 10.528,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 30.156,
              "y": 10.489,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698012857"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f3",
            "leftCorner": {
              "x": 30.156,
              "y": 10.489,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 30.134,
              "y": 10.467,
              "z": 0.46053
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f4",
            "leftCorner": {
              "x": 30.134,
              "y": 10.467,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 30.065,
              "y": 10.398,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698035245"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f5",
            "leftCorner": {
              "x": 30.065,
              "y": 10.398,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.994,
              "y": 10.327,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698002070"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f6",
            "leftCorner": {
              "x": 29.994,
              "y": 10.327,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.918,
              "y": 10.252,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698002070"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f7",
            "leftCorner": {
              "x": 29.918,
              "y": 10.252,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.822,
              "y": 10.155,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698011294"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f8",
            "leftCorner": {
              "x": 29.822,
              "y": 10.155,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.754,
              "y": 10.087,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698010259"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f9",
            "leftCorner": {
              "x": 29.754,
              "y": 10.087,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.654,
              "y": 9.9869,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698010259"
          },
          {
            "id": "679afb3d3d9bab0f83ff53fa",
            "leftCorner": {
              "x": 29.654,
              "y": 9.9869,
              "z": 0.46053
            },
            "rightCorner": {
              "x": 29.566,
              "y": 9.8995,
              "z": 0.46053
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698013175"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abea",
        "height": 0.71365,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53e9",
            "leftCorner": {
              "x": 30.288,
              "y": 10.613,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 30.206,
              "y": 10.531,
              "z": 0.71365
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008698026281"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ea",
            "leftCorner": {
              "x": 30.206,
              "y": 10.531,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 30.121,
              "y": 10.446,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698015988"
          },
          {
            "id": "679afb3d3d9bab0f83ff53eb",
            "leftCorner": {
              "x": 30.121,
              "y": 10.446,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 29.955,
              "y": 10.28,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698011683"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ec",
            "leftCorner": {
              "x": 29.955,
              "y": 10.28,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 29.85,
              "y": 10.175,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698029060"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ed",
            "leftCorner": {
              "x": 29.85,
              "y": 10.175,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 29.732,
              "y": 10.057,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698028315"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ee",
            "leftCorner": {
              "x": 29.732,
              "y": 10.057,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 29.659,
              "y": 9.9843,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4022993045406"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ef",
            "leftCorner": {
              "x": 29.659,
              "y": 9.9843,
              "z": 0.71365
            },
            "rightCorner": {
              "x": 29.583,
              "y": 9.9084,
              "z": 0.71365
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000010"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf0",
        "height": 0.96108,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff541d",
            "leftCorner": {
              "x": 30.288,
              "y": 10.613,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 30.202,
              "y": 10.526,
              "z": 0.96108
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008698027400"
          },
          {
            "id": "679afb3d3d9bab0f83ff541f",
            "leftCorner": {
              "x": 30.202,
              "y": 10.526,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 30.121,
              "y": 10.445,
              "z": 0.96108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5420",
            "leftCorner": {
              "x": 30.121,
              "y": 10.445,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 30.044,
              "y": 10.369,
              "z": 0.96108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698027424"
          },
          {
            "id": "679afb3d3d9bab0f83ff5421",
            "leftCorner": {
              "x": 30.044,
              "y": 10.369,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.959,
              "y": 10.284,
              "z": 0.96108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698027424"
          },
          {
            "id": "679afb3d3d9bab0f83ff5422",
            "leftCorner": {
              "x": 29.959,
              "y": 10.284,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.878,
              "y": 10.203,
              "z": 0.96108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008698027424"
          },
          {
            "id": "679afb3d3d9bab0f83ff5423",
            "leftCorner": {
              "x": 29.878,
              "y": 10.203,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.806,
              "y": 10.13,
              "z": 0.96108
            },
            "stockLevel": "NO_STOCK",
            "gtin": "8008698038734"
          },
          {
            "id": "679afb3d3d9bab0f83ff5424",
            "leftCorner": {
              "x": 29.806,
              "y": 10.13,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.728,
              "y": 10.053,
              "z": 0.96108
            },
            "stockLevel": "NO_STOCK",
            "gtin": "8008698038734"
          },
          {
            "id": "679afb3d3d9bab0f83ff5425",
            "leftCorner": {
              "x": 29.728,
              "y": 10.053,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.657,
              "y": 9.982,
              "z": 0.96108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4022993300208"
          },
          {
            "id": "679afb3d3d9bab0f83ff541e",
            "leftCorner": {
              "x": 29.657,
              "y": 9.982,
              "z": 0.96108
            },
            "rightCorner": {
              "x": 29.581,
              "y": 9.9058,
              "z": 0.96108
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4022993047066"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abec",
        "height": 1.2573,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff540b",
            "leftCorner": {
              "x": 30.289,
              "y": 10.612,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 30.185,
              "y": 10.507,
              "z": 1.2573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015537001235"
          },
          {
            "id": "679afb3d3d9bab0f83ff540d",
            "leftCorner": {
              "x": 30.185,
              "y": 10.507,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 30.084,
              "y": 10.406,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537001235"
          },
          {
            "id": "679afb3d3d9bab0f83ff540e",
            "leftCorner": {
              "x": 30.084,
              "y": 10.406,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 30.02,
              "y": 10.343,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537002744"
          },
          {
            "id": "679afb3d3d9bab0f83ff540f",
            "leftCorner": {
              "x": 30.02,
              "y": 10.343,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 29.96,
              "y": 10.282,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537002720"
          },
          {
            "id": "679afb3d3d9bab0f83ff5410",
            "leftCorner": {
              "x": 29.96,
              "y": 10.282,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 29.874,
              "y": 10.197,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537001365"
          },
          {
            "id": "679afb3d3d9bab0f83ff5411",
            "leftCorner": {
              "x": 29.874,
              "y": 10.197,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 29.776,
              "y": 10.099,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537002478"
          },
          {
            "id": "679afb3d3d9bab0f83ff5412",
            "leftCorner": {
              "x": 29.776,
              "y": 10.099,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 29.687,
              "y": 10.01,
              "z": 1.2573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537149999"
          },
          {
            "id": "679afb3d3d9bab0f83ff540c",
            "leftCorner": {
              "x": 29.687,
              "y": 10.01,
              "z": 1.2573
            },
            "rightCorner": {
              "x": 29.582,
              "y": 9.9048,
              "z": 1.2573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015537149999"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abef",
        "height": 1.4698,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5413",
            "leftCorner": {
              "x": 30.289,
              "y": 10.612,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 30.192,
              "y": 10.515,
              "z": 1.4698
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796007602"
          },
          {
            "id": "679afb3d3d9bab0f83ff5415",
            "leftCorner": {
              "x": 30.192,
              "y": 10.515,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 30.127,
              "y": 10.45,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422801"
          },
          {
            "id": "679afb3d3d9bab0f83ff5416",
            "leftCorner": {
              "x": 30.127,
              "y": 10.45,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 30.073,
              "y": 10.396,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422801"
          },
          {
            "id": "679afb3d3d9bab0f83ff5417",
            "leftCorner": {
              "x": 30.073,
              "y": 10.396,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 30.009,
              "y": 10.332,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422887"
          },
          {
            "id": "679afb3d3d9bab0f83ff5418",
            "leftCorner": {
              "x": 30.009,
              "y": 10.332,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.945,
              "y": 10.268,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422887"
          },
          {
            "id": "679afb3d3d9bab0f83ff5419",
            "leftCorner": {
              "x": 29.945,
              "y": 10.268,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.874,
              "y": 10.197,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422948"
          },
          {
            "id": "679afb3d3d9bab0f83ff541a",
            "leftCorner": {
              "x": 29.874,
              "y": 10.197,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.818,
              "y": 10.141,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422924"
          },
          {
            "id": "679afb3d3d9bab0f83ff541b",
            "leftCorner": {
              "x": 29.818,
              "y": 10.141,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.758,
              "y": 10.081,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422924"
          },
          {
            "id": "679afb3d3d9bab0f83ff541c",
            "leftCorner": {
              "x": 29.758,
              "y": 10.081,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.68,
              "y": 10.003,
              "z": 1.4698
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015537002836"
          },
          {
            "id": "679afb3d3d9bab0f83ff5414",
            "leftCorner": {
              "x": 29.68,
              "y": 10.003,
              "z": 1.4698
            },
            "rightCorner": {
              "x": 29.582,
              "y": 9.905,
              "z": 1.4698
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015537002348"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abed",
        "height": 1.6806,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5303",
            "leftCorner": {
              "x": 30.274,
              "y": 10.593,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 30.206,
              "y": 10.525,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422900"
          },
          {
            "id": "679afb3d3d9bab0f83ff5304",
            "leftCorner": {
              "x": 30.206,
              "y": 10.525,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 30.134,
              "y": 10.454,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422788"
          },
          {
            "id": "679afb3d3d9bab0f83ff5305",
            "leftCorner": {
              "x": 30.134,
              "y": 10.454,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 30.061,
              "y": 10.381,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422986"
          },
          {
            "id": "679afb3d3d9bab0f83ff5306",
            "leftCorner": {
              "x": 30.061,
              "y": 10.381,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.994,
              "y": 10.313,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422986"
          },
          {
            "id": "679afb3d3d9bab0f83ff5307",
            "leftCorner": {
              "x": 29.994,
              "y": 10.313,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.921,
              "y": 10.24,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422764"
          },
          {
            "id": "679afb3d3d9bab0f83ff5308",
            "leftCorner": {
              "x": 29.921,
              "y": 10.24,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.854,
              "y": 10.174,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422825"
          },
          {
            "id": "679afb3d3d9bab0f83ff5309",
            "leftCorner": {
              "x": 29.854,
              "y": 10.174,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.794,
              "y": 10.114,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422825"
          },
          {
            "id": "679afb3d3d9bab0f83ff530a",
            "leftCorner": {
              "x": 29.794,
              "y": 10.114,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.746,
              "y": 10.066,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422849"
          },
          {
            "id": "679afb3d3d9bab0f83ff530b",
            "leftCorner": {
              "x": 29.746,
              "y": 10.066,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.693,
              "y": 10.013,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422849"
          },
          {
            "id": "679afb3d3d9bab0f83ff530c",
            "leftCorner": {
              "x": 29.693,
              "y": 10.013,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.621,
              "y": 9.9409,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422863"
          },
          {
            "id": "679afb3d3d9bab0f83ff530d",
            "leftCorner": {
              "x": 29.621,
              "y": 9.9409,
              "z": 1.6806
            },
            "rightCorner": {
              "x": 29.566,
              "y": 9.8861,
              "z": 1.6806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447422962"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 51,
      "unknownStockCount": 9
    },
    "name": "4DL3",
    "leftNeighborShelfId": "S8LF",
    "rightNeighborShelfId": "AQ5L"
  },
  {
    "id": "ASWH",
    "x": 29.571,
    "y": 9.9021,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92423,
      "w": -0.38184
    },
    "layers": [
      {
        "id": "679aebda1f3fd8b81ad3abf5",
        "height": 0.19871,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff535d",
            "leftCorner": {
              "x": 29.502,
              "y": 9.9894,
              "z": 0.19673
            },
            "rightCorner": {
              "x": 29.433,
              "y": 9.9201,
              "z": 0.19673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234787"
          },
          {
            "id": "679afb3d3d9bab0f83ff535e",
            "leftCorner": {
              "x": 29.433,
              "y": 9.9063,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 29.354,
              "y": 9.8276,
              "z": 0.19871
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447600889"
          },
          {
            "id": "679afb3d3d9bab0f83ff535f",
            "leftCorner": {
              "x": 29.354,
              "y": 9.8276,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 29.286,
              "y": 9.7601,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530629"
          },
          {
            "id": "679afb3d3d9bab0f83ff5360",
            "leftCorner": {
              "x": 29.286,
              "y": 9.7601,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 29.196,
              "y": 9.6702,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484823"
          },
          {
            "id": "679afb3d3d9bab0f83ff5361",
            "leftCorner": {
              "x": 29.196,
              "y": 9.6702,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 29.106,
              "y": 9.5801,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484809"
          },
          {
            "id": "679afb3d3d9bab0f83ff5362",
            "leftCorner": {
              "x": 29.106,
              "y": 9.5801,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 29.019,
              "y": 9.494,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484809"
          },
          {
            "id": "679afb3d3d9bab0f83ff5363",
            "leftCorner": {
              "x": 29.019,
              "y": 9.494,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 28.946,
              "y": 9.4211,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447603293"
          },
          {
            "id": "679afb3d3d9bab0f83ff5364",
            "leftCorner": {
              "x": 28.946,
              "y": 9.4211,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 28.862,
              "y": 9.3373,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447603293"
          },
          {
            "id": "679afb3d3d9bab0f83ff5365",
            "leftCorner": {
              "x": 28.862,
              "y": 9.3373,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 28.789,
              "y": 9.2646,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447603330"
          },
          {
            "id": "679afb3d3d9bab0f83ff5366",
            "leftCorner": {
              "x": 28.789,
              "y": 9.2646,
              "z": 0.19871
            },
            "rightCorner": {
              "x": 28.723,
              "y": 9.1986,
              "z": 0.19871
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf4",
        "height": 0.46079,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff53fb",
            "leftCorner": {
              "x": 29.564,
              "y": 9.8876,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.514,
              "y": 9.8375,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260363487368"
          },
          {
            "id": "679afb3d3d9bab0f83ff53fc",
            "leftCorner": {
              "x": 29.514,
              "y": 9.8375,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.43,
              "y": 9.7536,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260363488402"
          },
          {
            "id": "679afb3d3d9bab0f83ff53fd",
            "leftCorner": {
              "x": 29.43,
              "y": 9.7536,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.36,
              "y": 9.6842,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250519665573"
          },
          {
            "id": "679afb3d3d9bab0f83ff53fe",
            "leftCorner": {
              "x": 29.36,
              "y": 9.6842,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.281,
              "y": 9.6052,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250519665573"
          },
          {
            "id": "679afb3d3d9bab0f83ff53ff",
            "leftCorner": {
              "x": 29.281,
              "y": 9.6052,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.201,
              "y": 9.5259,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250519665573"
          },
          {
            "id": "679afb3d3d9bab0f83ff5400",
            "leftCorner": {
              "x": 29.201,
              "y": 9.5259,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.119,
              "y": 9.4441,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4255719301641"
          },
          {
            "id": "679afb3d3d9bab0f83ff5401",
            "leftCorner": {
              "x": 29.119,
              "y": 9.4441,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 29.015,
              "y": 9.3406,
              "z": 0.46079
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4255719301115"
          },
          {
            "id": "679afb3d3d9bab0f83ff5402",
            "leftCorner": {
              "x": 29.015,
              "y": 9.3406,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 28.94,
              "y": 9.2657,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674057"
          },
          {
            "id": "679afb3d3d9bab0f83ff5403",
            "leftCorner": {
              "x": 28.94,
              "y": 9.2657,
              "z": 0.46079
            },
            "rightCorner": {
              "x": 28.841,
              "y": 9.1671,
              "z": 0.46079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530582"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf1",
        "height": 0.75701,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5426",
            "leftCorner": {
              "x": 29.578,
              "y": 9.8948,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.51,
              "y": 9.8267,
              "z": 0.75701
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260701927150"
          },
          {
            "id": "679afb3d3d9bab0f83ff5428",
            "leftCorner": {
              "x": 29.51,
              "y": 9.8267,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.432,
              "y": 9.7489,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260363482370"
          },
          {
            "id": "679afb3d3d9bab0f83ff5429",
            "leftCorner": {
              "x": 29.432,
              "y": 9.7489,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.337,
              "y": 9.6549,
              "z": 0.75701
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260701927136"
          },
          {
            "id": "679afb3d3d9bab0f83ff542a",
            "leftCorner": {
              "x": 29.337,
              "y": 9.6549,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.25,
              "y": 9.5675,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005394200490"
          },
          {
            "id": "679afb3d3d9bab0f83ff542b",
            "leftCorner": {
              "x": 29.25,
              "y": 9.5675,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.168,
              "y": 9.4856,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005394200513"
          },
          {
            "id": "679afb3d3d9bab0f83ff542c",
            "leftCorner": {
              "x": 29.168,
              "y": 9.4856,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 29.086,
              "y": 9.4048,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005394200520"
          },
          {
            "id": "679afb3d3d9bab0f83ff542d",
            "leftCorner": {
              "x": 29.086,
              "y": 9.4048,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 28.998,
              "y": 9.3169,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447569902"
          },
          {
            "id": "679afb3d3d9bab0f83ff542e",
            "leftCorner": {
              "x": 28.998,
              "y": 9.3169,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 28.925,
              "y": 9.2442,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447569902"
          },
          {
            "id": "679afb3d3d9bab0f83ff542f",
            "leftCorner": {
              "x": 28.925,
              "y": 9.2442,
              "z": 0.75701
            },
            "rightCorner": {
              "x": 28.855,
              "y": 9.1747,
              "z": 0.75701
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447569889"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf2",
        "height": 1.0048,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5445",
            "leftCorner": {
              "x": 29.579,
              "y": 9.8939,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 29.514,
              "y": 9.8296,
              "z": 1.0048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172890284"
          },
          {
            "id": "679afb3d3d9bab0f83ff5447",
            "leftCorner": {
              "x": 29.514,
              "y": 9.8296,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 29.418,
              "y": 9.7339,
              "z": 1.0048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006643240373"
          },
          {
            "id": "679afb3d3d9bab0f83ff5448",
            "leftCorner": {
              "x": 29.418,
              "y": 9.7339,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 29.324,
              "y": 9.6395,
              "z": 1.0048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006643240175"
          },
          {
            "id": "679afb3d3d9bab0f83ff5449",
            "leftCorner": {
              "x": 29.324,
              "y": 9.6395,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 29.207,
              "y": 9.5235,
              "z": 1.0048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250519646534"
          },
          {
            "id": "679afb3d3d9bab0f83ff544a",
            "leftCorner": {
              "x": 29.207,
              "y": 9.5235,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 29.1,
              "y": 9.4168,
              "z": 1.0048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250519647890"
          },
          {
            "id": "679afb3d3d9bab0f83ff544b",
            "leftCorner": {
              "x": 29.1,
              "y": 9.4168,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 28.979,
              "y": 9.2959,
              "z": 1.0048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250519646527"
          },
          {
            "id": "679afb3d3d9bab0f83ff544c",
            "leftCorner": {
              "x": 28.979,
              "y": 9.2959,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 28.877,
              "y": 9.1944,
              "z": 1.0048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257649"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf7",
        "height": 1.1782,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff546f",
            "leftCorner": {
              "x": 29.577,
              "y": 9.8957,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 29.487,
              "y": 9.8058,
              "z": 1.1782
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260044269337"
          },
          {
            "id": "679afb3d3d9bab0f83ff5471",
            "leftCorner": {
              "x": 29.487,
              "y": 9.8058,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 29.393,
              "y": 9.7117,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260044260471"
          },
          {
            "id": "679afb3d3d9bab0f83ff5472",
            "leftCorner": {
              "x": 29.393,
              "y": 9.7117,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 29.29,
              "y": 9.6095,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260044269498"
          },
          {
            "id": "679afb3d3d9bab0f83ff5473",
            "leftCorner": {
              "x": 29.29,
              "y": 9.6095,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 29.176,
              "y": 9.4964,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7340001806649"
          },
          {
            "id": "679afb3d3d9bab0f83ff5474",
            "leftCorner": {
              "x": 29.176,
              "y": 9.4964,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 29.064,
              "y": 9.3847,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7340001803617"
          },
          {
            "id": "679afb3d3d9bab0f83ff5475",
            "leftCorner": {
              "x": 29.064,
              "y": 9.3847,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 28.948,
              "y": 9.2683,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7340001803600"
          },
          {
            "id": "679afb3d3d9bab0f83ff5476",
            "leftCorner": {
              "x": 28.948,
              "y": 9.2683,
              "z": 1.1782
            },
            "rightCorner": {
              "x": 28.845,
              "y": 9.1662,
              "z": 1.1782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7340001805512"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf6",
        "height": 1.3458,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5461",
            "leftCorner": {
              "x": 29.58,
              "y": 9.8929,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 29.484,
              "y": 9.7978,
              "z": 1.3458
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260044268026"
          },
          {
            "id": "679afb3d3d9bab0f83ff5463",
            "leftCorner": {
              "x": 29.484,
              "y": 9.7978,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 29.387,
              "y": 9.7002,
              "z": 1.3458
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250031354917"
          },
          {
            "id": "679afb3d3d9bab0f83ff5464",
            "leftCorner": {
              "x": 29.387,
              "y": 9.7002,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 29.29,
              "y": 9.604,
              "z": 1.3458
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4250031354900"
          },
          {
            "id": "679afb3d3d9bab0f83ff5465",
            "leftCorner": {
              "x": 29.29,
              "y": 9.604,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 29.172,
              "y": 9.4864,
              "z": 1.3458
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260701927600"
          },
          {
            "id": "679afb3d3d9bab0f83ff5466",
            "leftCorner": {
              "x": 29.172,
              "y": 9.4864,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 29.06,
              "y": 9.375,
              "z": 1.3458
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260701924920"
          },
          {
            "id": "679afb3d3d9bab0f83ff5467",
            "leftCorner": {
              "x": 29.06,
              "y": 9.375,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 28.944,
              "y": 9.259,
              "z": 1.3458
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260363480871"
          },
          {
            "id": "679afb3d3d9bab0f83ff5468",
            "leftCorner": {
              "x": 28.944,
              "y": 9.259,
              "z": 1.3458
            },
            "rightCorner": {
              "x": 28.844,
              "y": 9.1598,
              "z": 1.3458
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260644585554"
          }
        ]
      },
      {
        "id": "679aebda1f3fd8b81ad3abf3",
        "height": 1.5138,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5453",
            "leftCorner": {
              "x": 29.578,
              "y": 9.8946,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 29.482,
              "y": 9.7984,
              "z": 1.5138
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447614749"
          },
          {
            "id": "679afb3d3d9bab0f83ff5455",
            "leftCorner": {
              "x": 29.482,
              "y": 9.7984,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 29.389,
              "y": 9.7059,
              "z": 1.5138
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796105711"
          },
          {
            "id": "679afb3d3d9bab0f83ff5456",
            "leftCorner": {
              "x": 29.389,
              "y": 9.7059,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 29.29,
              "y": 9.6076,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447083972"
          },
          {
            "id": "679afb3d3d9bab0f83ff5457",
            "leftCorner": {
              "x": 29.29,
              "y": 9.6076,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 29.196,
              "y": 9.5136,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257588"
          },
          {
            "id": "679afb3d3d9bab0f83ff5458",
            "leftCorner": {
              "x": 29.196,
              "y": 9.5136,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 29.088,
              "y": 9.406,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447083996"
          },
          {
            "id": "679afb3d3d9bab0f83ff5459",
            "leftCorner": {
              "x": 29.088,
              "y": 9.406,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 28.974,
              "y": 9.2926,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172969447"
          },
          {
            "id": "679afb3d3d9bab0f83ff545a",
            "leftCorner": {
              "x": 28.974,
              "y": 9.2926,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 28.873,
              "y": 9.192,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447731453"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abf8",
        "height": 1.6857,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff530e",
            "leftCorner": {
              "x": 29.564,
              "y": 9.8741,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 29.459,
              "y": 9.7694,
              "z": 1.6857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447319637"
          },
          {
            "id": "679afb3d3d9bab0f83ff530f",
            "leftCorner": {
              "x": 29.459,
              "y": 9.7694,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 29.362,
              "y": 9.6732,
              "z": 1.6857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447600988"
          },
          {
            "id": "679afb3d3d9bab0f83ff5310",
            "leftCorner": {
              "x": 29.362,
              "y": 9.6732,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 29.263,
              "y": 9.5739,
              "z": 1.6857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600964"
          },
          {
            "id": "679afb3d3d9bab0f83ff5311",
            "leftCorner": {
              "x": 29.263,
              "y": 9.5739,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 29.161,
              "y": 9.4727,
              "z": 1.6857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172969386"
          },
          {
            "id": "679afb3d3d9bab0f83ff5312",
            "leftCorner": {
              "x": 29.161,
              "y": 9.4727,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 29.061,
              "y": 9.3727,
              "z": 1.6857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172969362"
          },
          {
            "id": "679afb3d3d9bab0f83ff5313",
            "leftCorner": {
              "x": 29.061,
              "y": 9.3727,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 28.952,
              "y": 9.2641,
              "z": 1.6857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447319576"
          },
          {
            "id": "679afb3d3d9bab0f83ff5314",
            "leftCorner": {
              "x": 28.952,
              "y": 9.2641,
              "z": 1.6857
            },
            "rightCorner": {
              "x": 28.851,
              "y": 9.1641,
              "z": 1.6857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447319590"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 46,
      "unknownStockCount": 13
    },
    "name": "ASWH",
    "leftNeighborShelfId": "84HF",
    "rightNeighborShelfId": "FPWP"
  },
  {
    "id": "U1ST",
    "x": 28.855,
    "y": 9.1886,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92656,
      "w": -0.37613
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3abfc",
        "height": 0.19758,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5367",
            "leftCorner": {
              "x": 28.714,
              "y": 9.1936,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.643,
              "y": 9.124,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447603316"
          },
          {
            "id": "679afb3d3d9bab0f83ff5368",
            "leftCorner": {
              "x": 28.643,
              "y": 9.124,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.561,
              "y": 9.0446,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447423082"
          },
          {
            "id": "679afb3d3d9bab0f83ff5369",
            "leftCorner": {
              "x": 28.561,
              "y": 9.0446,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.471,
              "y": 8.9567,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796100471"
          },
          {
            "id": "679afb3d3d9bab0f83ff536a",
            "leftCorner": {
              "x": 28.471,
              "y": 8.9567,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.403,
              "y": 8.8909,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447496963"
          },
          {
            "id": "679afb3d3d9bab0f83ff536b",
            "leftCorner": {
              "x": 28.403,
              "y": 8.8909,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.353,
              "y": 8.8427,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530605"
          },
          {
            "id": "679afb3d3d9bab0f83ff536c",
            "leftCorner": {
              "x": 28.353,
              "y": 8.8427,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.307,
              "y": 8.7978,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447530605"
          },
          {
            "id": "679afb3d3d9bab0f83ff536d",
            "leftCorner": {
              "x": 28.307,
              "y": 8.7978,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.242,
              "y": 8.734,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172969546"
          },
          {
            "id": "679afb3d3d9bab0f83ff536e",
            "leftCorner": {
              "x": 28.242,
              "y": 8.734,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.2,
              "y": 8.6939,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447414837"
          },
          {
            "id": "679afb3d3d9bab0f83ff536f",
            "leftCorner": {
              "x": 28.2,
              "y": 8.6939,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.16,
              "y": 8.6548,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447414837"
          },
          {
            "id": "679afb3d3d9bab0f83ff5370",
            "leftCorner": {
              "x": 28.16,
              "y": 8.6548,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.115,
              "y": 8.611,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484861"
          },
          {
            "id": "679afb3d3d9bab0f83ff5371",
            "leftCorner": {
              "x": 28.115,
              "y": 8.611,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28.071,
              "y": 8.568,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484847"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abfe",
        "height": 0.46449,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5404",
            "leftCorner": {
              "x": 28.83,
              "y": 9.1633,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.75,
              "y": 9.086,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257564"
          },
          {
            "id": "679afb3d3d9bab0f83ff5405",
            "leftCorner": {
              "x": 28.75,
              "y": 9.086,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.647,
              "y": 8.9858,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447788075"
          },
          {
            "id": "679afb3d3d9bab0f83ff5406",
            "leftCorner": {
              "x": 28.647,
              "y": 8.9858,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.542,
              "y": 8.8837,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447247138"
          },
          {
            "id": "679afb3d3d9bab0f83ff5407",
            "leftCorner": {
              "x": 28.542,
              "y": 8.8837,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.462,
              "y": 8.8058,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447051933"
          },
          {
            "id": "679afb3d3d9bab0f83ff5408",
            "leftCorner": {
              "x": 28.462,
              "y": 8.8058,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.372,
              "y": 8.7184,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600926"
          },
          {
            "id": "679afb3d3d9bab0f83ff5409",
            "leftCorner": {
              "x": 28.372,
              "y": 8.7184,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.284,
              "y": 8.6333,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447735192"
          },
          {
            "id": "679afb3d3d9bab0f83ff540a",
            "leftCorner": {
              "x": 28.284,
              "y": 8.6333,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.205,
              "y": 8.5566,
              "z": 0.46449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447735215"
          },
          {
            "id": "679afb3d3d9bab0f83ff53f1",
            "leftCorner": {
              "x": 28.205,
              "y": 8.5566,
              "z": 0.46449
            },
            "rightCorner": {
              "x": 28.138,
              "y": 8.4913,
              "z": 0.46449
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796084481"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abf9",
        "height": 0.75909,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5430",
            "leftCorner": {
              "x": 28.844,
              "y": 9.1706,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.77,
              "y": 9.0981,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5431",
            "leftCorner": {
              "x": 28.77,
              "y": 9.0981,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.699,
              "y": 9.0294,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250529300006"
          },
          {
            "id": "679afb3d3d9bab0f83ff5432",
            "leftCorner": {
              "x": 28.699,
              "y": 9.0294,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.626,
              "y": 8.9588,
              "z": 0.75909
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4250752203273"
          },
          {
            "id": "679afb3d3d9bab0f83ff5433",
            "leftCorner": {
              "x": 28.626,
              "y": 8.9588,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.56,
              "y": 8.8946,
              "z": 0.75909
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260699232441"
          },
          {
            "id": "679afb3d3d9bab0f83ff5434",
            "leftCorner": {
              "x": 28.56,
              "y": 8.8946,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.497,
              "y": 8.8326,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554705333"
          },
          {
            "id": "679afb3d3d9bab0f83ff5435",
            "leftCorner": {
              "x": 28.497,
              "y": 8.8326,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.431,
              "y": 8.7686,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554705340"
          },
          {
            "id": "679afb3d3d9bab0f83ff5436",
            "leftCorner": {
              "x": 28.431,
              "y": 8.7686,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.369,
              "y": 8.7081,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554705340"
          },
          {
            "id": "679afb3d3d9bab0f83ff5437",
            "leftCorner": {
              "x": 28.369,
              "y": 8.7081,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.3,
              "y": 8.6414,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554705357"
          },
          {
            "id": "679afb3d3d9bab0f83ff5438",
            "leftCorner": {
              "x": 28.3,
              "y": 8.6414,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.236,
              "y": 8.5787,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554705357"
          },
          {
            "id": "679afb3d3d9bab0f83ff5439",
            "leftCorner": {
              "x": 28.236,
              "y": 8.5787,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.185,
              "y": 8.5296,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554704336"
          },
          {
            "id": "679afb3d3d9bab0f83ff543a",
            "leftCorner": {
              "x": 28.185,
              "y": 8.5296,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.143,
              "y": 8.4886,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554704343"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abfb",
        "height": 1.0081,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff544d",
            "leftCorner": {
              "x": 28.877,
              "y": 9.1944,
              "z": 1.0048
            },
            "rightCorner": {
              "x": 28.784,
              "y": 9.1022,
              "z": 1.0048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257625"
          },
          {
            "id": "679afb3d3d9bab0f83ff544e",
            "leftCorner": {
              "x": 28.769,
              "y": 9.1018,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.671,
              "y": 9.0059,
              "z": 1.0081
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4029679678750"
          },
          {
            "id": "679afb3d3d9bab0f83ff544f",
            "leftCorner": {
              "x": 28.671,
              "y": 9.0059,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.563,
              "y": 8.9015,
              "z": 1.0081
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679854796"
          },
          {
            "id": "679afb3d3d9bab0f83ff5450",
            "leftCorner": {
              "x": 28.563,
              "y": 8.9015,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.461,
              "y": 8.8022,
              "z": 1.0081
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "722252387479"
          },
          {
            "id": "679afb3d3d9bab0f83ff5451",
            "leftCorner": {
              "x": 28.461,
              "y": 8.8022,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.358,
              "y": 8.7021,
              "z": 1.0081
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "722252387578"
          },
          {
            "id": "679afb3d3d9bab0f83ff5452",
            "leftCorner": {
              "x": 28.358,
              "y": 8.7021,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.243,
              "y": 8.5899,
              "z": 1.0081
            },
            "stockLevel": "UNKNOWN",
            "gtin": "722252387530"
          },
          {
            "id": "679afb3d3d9bab0f83ff5446",
            "leftCorner": {
              "x": 28.243,
              "y": 8.5899,
              "z": 1.0081
            },
            "rightCorner": {
              "x": 28.14,
              "y": 8.4897,
              "z": 1.0081
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260697376352"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac00",
        "height": 1.1811,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5477",
            "leftCorner": {
              "x": 28.831,
              "y": 9.1653,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.73,
              "y": 9.067,
              "z": 1.1811
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5391532121710"
          },
          {
            "id": "679afb3d3d9bab0f83ff5478",
            "leftCorner": {
              "x": 28.73,
              "y": 9.067,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.625,
              "y": 8.9655,
              "z": 1.1811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5391532124162"
          },
          {
            "id": "679afb3d3d9bab0f83ff5479",
            "leftCorner": {
              "x": 28.625,
              "y": 8.9655,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.521,
              "y": 8.8645,
              "z": 1.1811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff547a",
            "leftCorner": {
              "x": 28.521,
              "y": 8.8645,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.417,
              "y": 8.7626,
              "z": 1.1811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260697372491"
          },
          {
            "id": "679afb3d3d9bab0f83ff547b",
            "leftCorner": {
              "x": 28.417,
              "y": 8.7626,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.315,
              "y": 8.6638,
              "z": 1.1811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260697372309"
          },
          {
            "id": "679afb3d3d9bab0f83ff547c",
            "leftCorner": {
              "x": 28.315,
              "y": 8.6638,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.223,
              "y": 8.5743,
              "z": 1.1811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260697371487"
          },
          {
            "id": "679afb3d3d9bab0f83ff5470",
            "leftCorner": {
              "x": 28.223,
              "y": 8.5743,
              "z": 1.1811
            },
            "rightCorner": {
              "x": 28.138,
              "y": 8.4917,
              "z": 1.1811
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260697371487"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abff",
        "height": 1.349,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5469",
            "leftCorner": {
              "x": 28.829,
              "y": 9.1592,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.732,
              "y": 9.0643,
              "z": 1.349
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260446586148"
          },
          {
            "id": "679afb3d3d9bab0f83ff546a",
            "leftCorner": {
              "x": 28.732,
              "y": 9.0643,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.63,
              "y": 8.9658,
              "z": 1.349
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260446586223"
          },
          {
            "id": "679afb3d3d9bab0f83ff546b",
            "leftCorner": {
              "x": 28.63,
              "y": 8.9658,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.529,
              "y": 8.8675,
              "z": 1.349
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260644585233"
          },
          {
            "id": "679afb3d3d9bab0f83ff546c",
            "leftCorner": {
              "x": 28.529,
              "y": 8.8675,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.427,
              "y": 8.7681,
              "z": 1.349
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260644585509"
          },
          {
            "id": "679afb3d3d9bab0f83ff546d",
            "leftCorner": {
              "x": 28.427,
              "y": 8.7681,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.328,
              "y": 8.672,
              "z": 1.349
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036554703629"
          },
          {
            "id": "679afb3d3d9bab0f83ff546e",
            "leftCorner": {
              "x": 28.328,
              "y": 8.672,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.228,
              "y": 8.5747,
              "z": 1.349
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036554703674"
          },
          {
            "id": "679afb3d3d9bab0f83ff5462",
            "leftCorner": {
              "x": 28.228,
              "y": 8.5747,
              "z": 1.349
            },
            "rightCorner": {
              "x": 28.14,
              "y": 8.4892,
              "z": 1.349
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036554703582"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abfd",
        "height": 1.5157,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff545b",
            "leftCorner": {
              "x": 28.873,
              "y": 9.192,
              "z": 1.5138
            },
            "rightCorner": {
              "x": 28.789,
              "y": 9.1085,
              "z": 1.5138
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796093995"
          },
          {
            "id": "679afb3d3d9bab0f83ff545c",
            "leftCorner": {
              "x": 28.773,
              "y": 9.1103,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.679,
              "y": 9.019,
              "z": 1.5157
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447575569"
          },
          {
            "id": "679afb3d3d9bab0f83ff545d",
            "leftCorner": {
              "x": 28.679,
              "y": 9.019,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.566,
              "y": 8.9095,
              "z": 1.5157
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447124132"
          },
          {
            "id": "679afb3d3d9bab0f83ff545e",
            "leftCorner": {
              "x": 28.566,
              "y": 8.9095,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.46,
              "y": 8.8061,
              "z": 1.5157
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447083958"
          },
          {
            "id": "679afb3d3d9bab0f83ff545f",
            "leftCorner": {
              "x": 28.46,
              "y": 8.8061,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.353,
              "y": 8.7021,
              "z": 1.5157
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260654789119"
          },
          {
            "id": "679afb3d3d9bab0f83ff5460",
            "leftCorner": {
              "x": 28.353,
              "y": 8.7021,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.24,
              "y": 8.5927,
              "z": 1.5157
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4255582800487"
          },
          {
            "id": "679afb3d3d9bab0f83ff5454",
            "leftCorner": {
              "x": 28.24,
              "y": 8.5927,
              "z": 1.5157
            },
            "rightCorner": {
              "x": 28.137,
              "y": 8.4925,
              "z": 1.5157
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260718295884"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3abfa",
        "height": 1.6854,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5315",
            "leftCorner": {
              "x": 28.836,
              "y": 9.1639,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.721,
              "y": 9.0514,
              "z": 1.6854
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4029679675414"
          },
          {
            "id": "679afb3d3d9bab0f83ff5316",
            "leftCorner": {
              "x": 28.721,
              "y": 9.0514,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.608,
              "y": 8.9416,
              "z": 1.6854
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679680708"
          },
          {
            "id": "679afb3d3d9bab0f83ff5317",
            "leftCorner": {
              "x": 28.608,
              "y": 8.9416,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.494,
              "y": 8.8312,
              "z": 1.6854
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679680142"
          },
          {
            "id": "679afb3d3d9bab0f83ff5318",
            "leftCorner": {
              "x": 28.494,
              "y": 8.8312,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.382,
              "y": 8.722,
              "z": 1.6854
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679996885"
          },
          {
            "id": "679afb3d3d9bab0f83ff5319",
            "leftCorner": {
              "x": 28.382,
              "y": 8.722,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.265,
              "y": 8.6088,
              "z": 1.6854
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679900042"
          },
          {
            "id": "679afb3d3d9bab0f83ff531a",
            "leftCorner": {
              "x": 28.265,
              "y": 8.6088,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.146,
              "y": 8.4926,
              "z": 1.6854
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4029679669826"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 46,
      "unknownStockCount": 16
    },
    "name": "U1ST",
    "leftNeighborShelfId": "VYWH"
  },
  {
    "id": "V2K7",
    "x": 32.382,
    "y": 8.116,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.91823,
      "w": -0.39605
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac02",
        "height": 0.19697,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff547e",
            "leftCorner": {
              "x": 32.288,
              "y": 8.1618,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 32.234,
              "y": 8.104,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447009040"
          },
          {
            "id": "679afb3d3d9bab0f83ff547f",
            "leftCorner": {
              "x": 32.234,
              "y": 8.104,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 32.178,
              "y": 8.0454,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447009040"
          },
          {
            "id": "679afb3d3d9bab0f83ff5480",
            "leftCorner": {
              "x": 32.178,
              "y": 8.0454,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 32.121,
              "y": 7.9845,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447009040"
          },
          {
            "id": "679afb3d3d9bab0f83ff5481",
            "leftCorner": {
              "x": 32.121,
              "y": 7.9845,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 32.069,
              "y": 7.9298,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447123111"
          },
          {
            "id": "679afb3d3d9bab0f83ff5482",
            "leftCorner": {
              "x": 32.069,
              "y": 7.9298,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 32.008,
              "y": 7.865,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447123111"
          },
          {
            "id": "679afb3d3d9bab0f83ff5483",
            "leftCorner": {
              "x": 32.008,
              "y": 7.865,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.954,
              "y": 7.8078,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000207"
          },
          {
            "id": "679afb3d3d9bab0f83ff5484",
            "leftCorner": {
              "x": 31.954,
              "y": 7.8078,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.899,
              "y": 7.7499,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000207"
          },
          {
            "id": "679afb3d3d9bab0f83ff5485",
            "leftCorner": {
              "x": 31.899,
              "y": 7.7499,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.85,
              "y": 7.6971,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002003"
          },
          {
            "id": "679afb3d3d9bab0f83ff5486",
            "leftCorner": {
              "x": 31.85,
              "y": 7.6971,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.795,
              "y": 7.6389,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002003"
          },
          {
            "id": "679afb3d3d9bab0f83ff5487",
            "leftCorner": {
              "x": 31.795,
              "y": 7.6389,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.74,
              "y": 7.5814,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002003"
          },
          {
            "id": "679afb3d3d9bab0f83ff5488",
            "leftCorner": {
              "x": 31.74,
              "y": 7.5814,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.687,
              "y": 7.5246,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002003"
          },
          {
            "id": "679afb3d3d9bab0f83ff5489",
            "leftCorner": {
              "x": 31.687,
              "y": 7.5246,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.633,
              "y": 7.4674,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac08",
        "height": 0.45454,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54ec",
            "leftCorner": {
              "x": 32.388,
              "y": 8.1105,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.33,
              "y": 8.0487,
              "z": 0.45454
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447159141"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ed",
            "leftCorner": {
              "x": 32.33,
              "y": 8.0487,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.276,
              "y": 7.9923,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447159141"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ee",
            "leftCorner": {
              "x": 32.276,
              "y": 7.9923,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.221,
              "y": 7.9337,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447159141"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ef",
            "leftCorner": {
              "x": 32.221,
              "y": 7.9337,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.166,
              "y": 7.8751,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231571"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f0",
            "leftCorner": {
              "x": 32.166,
              "y": 7.8751,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.111,
              "y": 7.8174,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231571"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f1",
            "leftCorner": {
              "x": 32.111,
              "y": 7.8174,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.056,
              "y": 7.7589,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231571"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f2",
            "leftCorner": {
              "x": 32.056,
              "y": 7.7589,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 32.003,
              "y": 7.702,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447051384"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f3",
            "leftCorner": {
              "x": 32.003,
              "y": 7.702,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.949,
              "y": 7.6451,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447051384"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f4",
            "leftCorner": {
              "x": 31.949,
              "y": 7.6451,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.893,
              "y": 7.5855,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447051384"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f5",
            "leftCorner": {
              "x": 31.893,
              "y": 7.5855,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.838,
              "y": 7.5276,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f6",
            "leftCorner": {
              "x": 31.838,
              "y": 7.5276,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.796,
              "y": 7.4827,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447120615"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f7",
            "leftCorner": {
              "x": 31.796,
              "y": 7.4827,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.737,
              "y": 7.4205,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447120615"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac04",
        "height": 0.7546,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54ab",
            "leftCorner": {
              "x": 32.391,
              "y": 8.1076,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 32.366,
              "y": 8.0811,
              "z": 0.7546
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ad",
            "leftCorner": {
              "x": 32.366,
              "y": 8.0811,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 32.269,
              "y": 7.9782,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42462972"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ae",
            "leftCorner": {
              "x": 32.269,
              "y": 7.9782,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 32.162,
              "y": 7.8649,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42462965"
          },
          {
            "id": "679afb3d3d9bab0f83ff54af",
            "leftCorner": {
              "x": 32.162,
              "y": 7.8649,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 32.107,
              "y": 7.807,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7394376616501"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b0",
            "leftCorner": {
              "x": 32.107,
              "y": 7.807,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 32.051,
              "y": 7.7471,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7394376616501"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b1",
            "leftCorner": {
              "x": 32.051,
              "y": 7.7471,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.995,
              "y": 7.688,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7394376616501"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b2",
            "leftCorner": {
              "x": 31.995,
              "y": 7.688,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.943,
              "y": 7.6332,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7394376621680"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b3",
            "leftCorner": {
              "x": 31.943,
              "y": 7.6332,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.886,
              "y": 7.572,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b4",
            "leftCorner": {
              "x": 31.886,
              "y": 7.572,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.835,
              "y": 7.5184,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375025928"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b5",
            "leftCorner": {
              "x": 31.835,
              "y": 7.5184,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.781,
              "y": 7.4609,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375025928"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b6",
            "leftCorner": {
              "x": 31.781,
              "y": 7.4609,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.727,
              "y": 7.4043,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9020200031391"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b7",
            "leftCorner": {
              "x": 31.727,
              "y": 7.4043,
              "z": 0.7546
            },
            "rightCorner": {
              "x": 31.674,
              "y": 7.3476,
              "z": 0.7546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9020200031391"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac03",
        "height": 1.0449,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5495",
            "leftCorner": {
              "x": 32.392,
              "y": 8.1067,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 32.281,
              "y": 7.9887,
              "z": 1.0449
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447199598"
          },
          {
            "id": "679afb3d3d9bab0f83ff5497",
            "leftCorner": {
              "x": 32.281,
              "y": 7.9887,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 32.17,
              "y": 7.8709,
              "z": 1.0449
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447199598"
          },
          {
            "id": "679afb3d3d9bab0f83ff5498",
            "leftCorner": {
              "x": 32.17,
              "y": 7.8709,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 32.054,
              "y": 7.7486,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447608960"
          },
          {
            "id": "679afb3d3d9bab0f83ff5499",
            "leftCorner": {
              "x": 32.054,
              "y": 7.7486,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.941,
              "y": 7.6282,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796017427"
          },
          {
            "id": "679afb3d3d9bab0f83ff549a",
            "leftCorner": {
              "x": 31.941,
              "y": 7.6282,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.903,
              "y": 7.5883,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003246"
          },
          {
            "id": "679afb3d3d9bab0f83ff549b",
            "leftCorner": {
              "x": 31.903,
              "y": 7.5883,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.869,
              "y": 7.5524,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003246"
          },
          {
            "id": "679afb3d3d9bab0f83ff549c",
            "leftCorner": {
              "x": 31.869,
              "y": 7.5524,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.834,
              "y": 7.515,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003246"
          },
          {
            "id": "679afb3d3d9bab0f83ff549d",
            "leftCorner": {
              "x": 31.834,
              "y": 7.515,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.8,
              "y": 7.4794,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003246"
          },
          {
            "id": "679afb3d3d9bab0f83ff549e",
            "leftCorner": {
              "x": 31.8,
              "y": 7.4794,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.766,
              "y": 7.4428,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003222"
          },
          {
            "id": "679afb3d3d9bab0f83ff549f",
            "leftCorner": {
              "x": 31.766,
              "y": 7.4428,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.728,
              "y": 7.4031,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796003222"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a0",
            "leftCorner": {
              "x": 31.728,
              "y": 7.4031,
              "z": 1.0449
            },
            "rightCorner": {
              "x": 31.675,
              "y": 7.3467,
              "z": 1.0449
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac05",
        "height": 1.2974,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54c3",
            "leftCorner": {
              "x": 32.392,
              "y": 8.1069,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 32.303,
              "y": 8.0133,
              "z": 1.2974
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447522440"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c5",
            "leftCorner": {
              "x": 32.303,
              "y": 8.0133,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 32.216,
              "y": 7.9204,
              "z": 1.2974
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447522440"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c6",
            "leftCorner": {
              "x": 32.216,
              "y": 7.9204,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 32.144,
              "y": 7.8444,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447522464"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c7",
            "leftCorner": {
              "x": 32.144,
              "y": 7.8444,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 32.074,
              "y": 7.77,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447522464"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c8",
            "leftCorner": {
              "x": 32.074,
              "y": 7.77,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 32.018,
              "y": 7.7104,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447088281"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c9",
            "leftCorner": {
              "x": 32.018,
              "y": 7.7104,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 31.926,
              "y": 7.613,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172487255"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ca",
            "leftCorner": {
              "x": 31.926,
              "y": 7.613,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 31.843,
              "y": 7.5253,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172487255"
          },
          {
            "id": "679afb3d3d9bab0f83ff54cb",
            "leftCorner": {
              "x": 31.843,
              "y": 7.5253,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 31.757,
              "y": 7.4345,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172487255"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac06",
        "height": 1.6343,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54d4",
            "leftCorner": {
              "x": 32.393,
              "y": 8.1054,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 32.324,
              "y": 8.0322,
              "z": 1.6343
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447373127"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d6",
            "leftCorner": {
              "x": 32.324,
              "y": 8.0322,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 32.27,
              "y": 7.9751,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375800"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d7",
            "leftCorner": {
              "x": 32.27,
              "y": 7.9751,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 32.213,
              "y": 7.9139,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375800"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d8",
            "leftCorner": {
              "x": 32.213,
              "y": 7.9139,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 32.139,
              "y": 7.8352,
              "z": 1.6343
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447375848"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d9",
            "leftCorner": {
              "x": 32.139,
              "y": 7.8352,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 32.068,
              "y": 7.7607,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395440"
          },
          {
            "id": "679afb3d3d9bab0f83ff54da",
            "leftCorner": {
              "x": 32.068,
              "y": 7.7607,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.993,
              "y": 7.6809,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671803"
          },
          {
            "id": "679afb3d3d9bab0f83ff54db",
            "leftCorner": {
              "x": 31.993,
              "y": 7.6809,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.923,
              "y": 7.6069,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671803"
          },
          {
            "id": "679afb3d3d9bab0f83ff54dc",
            "leftCorner": {
              "x": 31.923,
              "y": 7.6069,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.864,
              "y": 7.5442,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447703863"
          },
          {
            "id": "679afb3d3d9bab0f83ff54dd",
            "leftCorner": {
              "x": 31.864,
              "y": 7.5442,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.809,
              "y": 7.4858,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447304954"
          },
          {
            "id": "679afb3d3d9bab0f83ff54de",
            "leftCorner": {
              "x": 31.809,
              "y": 7.4858,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.743,
              "y": 7.4159,
              "z": 1.6343
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447304954"
          },
          {
            "id": "679afb3d3d9bab0f83ff54df",
            "leftCorner": {
              "x": 31.743,
              "y": 7.4159,
              "z": 1.6343
            },
            "rightCorner": {
              "x": 31.685,
              "y": 7.3549,
              "z": 1.6343
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260614530034"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 57,
      "unknownStockCount": 7
    },
    "name": "V2K7",
    "leftNeighborShelfId": "R1N8",
    "rightNeighborShelfId": "KFT1"
  },
  {
    "id": "5PXX",
    "x": 28.137,
    "y": 8.4904,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.92469,
      "w": -0.38072
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac0b",
        "height": 0.1963,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5372",
            "leftCorner": {
              "x": 28.071,
              "y": 8.568,
              "z": 0.19758
            },
            "rightCorner": {
              "x": 28,
              "y": 8.4991,
              "z": 0.19758
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172314414"
          },
          {
            "id": "679afb3d3d9bab0f83ff5373",
            "leftCorner": {
              "x": 27.997,
              "y": 8.4986,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.93,
              "y": 8.4324,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172314445"
          },
          {
            "id": "679afb3d3d9bab0f83ff5374",
            "leftCorner": {
              "x": 27.93,
              "y": 8.4324,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.859,
              "y": 8.362,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796148824"
          },
          {
            "id": "679afb3d3d9bab0f83ff5375",
            "leftCorner": {
              "x": 27.859,
              "y": 8.362,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.783,
              "y": 8.2873,
              "z": 0.1963
            },
            "stockLevel": "UNKNOWN",
            "gtin": "96060636"
          },
          {
            "id": "679afb3d3d9bab0f83ff5376",
            "leftCorner": {
              "x": 27.783,
              "y": 8.2873,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.709,
              "y": 8.2136,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "50357437"
          },
          {
            "id": "679afb3d3d9bab0f83ff5377",
            "leftCorner": {
              "x": 27.709,
              "y": 8.2136,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.627,
              "y": 8.1323,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "50836383"
          },
          {
            "id": "679afb3d3d9bab0f83ff5378",
            "leftCorner": {
              "x": 27.627,
              "y": 8.1323,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.545,
              "y": 8.0509,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "50357260"
          },
          {
            "id": "679afb3d3d9bab0f83ff5379",
            "leftCorner": {
              "x": 27.545,
              "y": 8.0509,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.461,
              "y": 7.9678,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "50357826"
          },
          {
            "id": "679afb3d3d9bab0f83ff537a",
            "leftCorner": {
              "x": 27.461,
              "y": 7.9678,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.388,
              "y": 7.8947,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "96130780"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac0c",
        "height": 0.41729,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff550f",
            "leftCorner": {
              "x": 28.141,
              "y": 8.4858,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 28.058,
              "y": 8.4033,
              "z": 0.41729
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447607413"
          },
          {
            "id": "679afb3d3d9bab0f83ff5511",
            "leftCorner": {
              "x": 28.058,
              "y": 8.4033,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.975,
              "y": 8.3209,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607437"
          },
          {
            "id": "679afb3d3d9bab0f83ff5512",
            "leftCorner": {
              "x": 27.975,
              "y": 8.3209,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.896,
              "y": 8.2429,
              "z": 0.41729
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447668193"
          },
          {
            "id": "679afb3d3d9bab0f83ff5513",
            "leftCorner": {
              "x": 27.896,
              "y": 8.2429,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.815,
              "y": 8.1626,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668193"
          },
          {
            "id": "679afb3d3d9bab0f83ff5514",
            "leftCorner": {
              "x": 27.815,
              "y": 8.1626,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.73,
              "y": 8.0775,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668179"
          },
          {
            "id": "679afb3d3d9bab0f83ff5515",
            "leftCorner": {
              "x": 27.73,
              "y": 8.0775,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.645,
              "y": 7.9938,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668179"
          },
          {
            "id": "679afb3d3d9bab0f83ff5516",
            "leftCorner": {
              "x": 27.645,
              "y": 7.9938,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.573,
              "y": 7.9221,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42163930"
          },
          {
            "id": "679afb3d3d9bab0f83ff5517",
            "leftCorner": {
              "x": 27.573,
              "y": 7.9221,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.503,
              "y": 7.8528,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40468709"
          },
          {
            "id": "679afb3d3d9bab0f83ff5518",
            "leftCorner": {
              "x": 27.503,
              "y": 7.8528,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.434,
              "y": 7.7842,
              "z": 0.41729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40468259"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac09",
        "height": 0.59117,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5506",
            "leftCorner": {
              "x": 28.14,
              "y": 8.4868,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 28.065,
              "y": 8.4121,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5745000121014"
          },
          {
            "id": "679afb3d3d9bab0f83ff5508",
            "leftCorner": {
              "x": 28.065,
              "y": 8.4121,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.904,
              "y": 8.2526,
              "z": 0.59117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5745000121588"
          },
          {
            "id": "679afb3d3d9bab0f83ff5509",
            "leftCorner": {
              "x": 27.904,
              "y": 8.2526,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.822,
              "y": 8.171,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009900447300"
          },
          {
            "id": "679afb3d3d9bab0f83ff550a",
            "leftCorner": {
              "x": 27.822,
              "y": 8.171,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.742,
              "y": 8.0916,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff550b",
            "leftCorner": {
              "x": 27.742,
              "y": 8.0916,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.66,
              "y": 8.011,
              "z": 0.59117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009900447249"
          },
          {
            "id": "679afb3d3d9bab0f83ff550c",
            "leftCorner": {
              "x": 27.66,
              "y": 8.011,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.581,
              "y": 7.9326,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447763201"
          },
          {
            "id": "679afb3d3d9bab0f83ff550d",
            "leftCorner": {
              "x": 27.581,
              "y": 7.9326,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.512,
              "y": 7.864,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447763225"
          },
          {
            "id": "679afb3d3d9bab0f83ff550e",
            "leftCorner": {
              "x": 27.512,
              "y": 7.864,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.468,
              "y": 7.8201,
              "z": 0.59117
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42214663"
          },
          {
            "id": "679afb3d3d9bab0f83ff5507",
            "leftCorner": {
              "x": 27.468,
              "y": 7.8201,
              "z": 0.59117
            },
            "rightCorner": {
              "x": 27.43,
              "y": 7.7828,
              "z": 0.59117
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42214663"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac0a",
        "height": 0.75835,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff543b",
            "leftCorner": {
              "x": 28.143,
              "y": 8.4886,
              "z": 0.75909
            },
            "rightCorner": {
              "x": 28.068,
              "y": 8.4161,
              "z": 0.75909
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976140078"
          },
          {
            "id": "679afb3d3d9bab0f83ff543c",
            "leftCorner": {
              "x": 28.07,
              "y": 8.4124,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.993,
              "y": 8.3368,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976140009"
          },
          {
            "id": "679afb3d3d9bab0f83ff543d",
            "leftCorner": {
              "x": 27.993,
              "y": 8.3368,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.939,
              "y": 8.2829,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002590705354"
          },
          {
            "id": "679afb3d3d9bab0f83ff543e",
            "leftCorner": {
              "x": 27.939,
              "y": 8.2829,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.879,
              "y": 8.2231,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002590705354"
          },
          {
            "id": "679afb3d3d9bab0f83ff543f",
            "leftCorner": {
              "x": 27.879,
              "y": 8.2231,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.821,
              "y": 8.1658,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002590140124"
          },
          {
            "id": "679afb3d3d9bab0f83ff5440",
            "leftCorner": {
              "x": 27.821,
              "y": 8.1658,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.759,
              "y": 8.1045,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002590140124"
          },
          {
            "id": "679afb3d3d9bab0f83ff5441",
            "leftCorner": {
              "x": 27.759,
              "y": 8.1045,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.696,
              "y": 8.0415,
              "z": 0.75835
            },
            "stockLevel": "NO_STOCK",
            "gtin": "84199485"
          },
          {
            "id": "679afb3d3d9bab0f83ff5442",
            "leftCorner": {
              "x": 27.696,
              "y": 8.0415,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.623,
              "y": 7.9693,
              "z": 0.75835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "84155634"
          },
          {
            "id": "679afb3d3d9bab0f83ff5443",
            "leftCorner": {
              "x": 27.623,
              "y": 7.9693,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.557,
              "y": 7.9043,
              "z": 0.75835
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8723400798880"
          },
          {
            "id": "679afb3d3d9bab0f83ff5444",
            "leftCorner": {
              "x": 27.557,
              "y": 7.9043,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.491,
              "y": 7.8386,
              "z": 0.75835
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8723400795438"
          },
          {
            "id": "679afb3d3d9bab0f83ff5427",
            "leftCorner": {
              "x": 27.491,
              "y": 7.8386,
              "z": 0.75835
            },
            "rightCorner": {
              "x": 27.432,
              "y": 7.7805,
              "z": 0.75835
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8723400799412"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac10",
        "height": 0.92214,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5534",
            "leftCorner": {
              "x": 28.144,
              "y": 8.4829,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 28.076,
              "y": 8.415,
              "z": 0.92214
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff5536",
            "leftCorner": {
              "x": 28.076,
              "y": 8.415,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 28.012,
              "y": 8.3522,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff5537",
            "leftCorner": {
              "x": 28.012,
              "y": 8.3522,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.948,
              "y": 8.288,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff5538",
            "leftCorner": {
              "x": 27.948,
              "y": 8.288,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.885,
              "y": 8.2264,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff5539",
            "leftCorner": {
              "x": 27.885,
              "y": 8.2264,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.818,
              "y": 8.16,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff553a",
            "leftCorner": {
              "x": 27.818,
              "y": 8.16,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.749,
              "y": 8.091,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932228284"
          },
          {
            "id": "679afb3d3d9bab0f83ff553b",
            "leftCorner": {
              "x": 27.749,
              "y": 8.091,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.681,
              "y": 8.024,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932229335"
          },
          {
            "id": "679afb3d3d9bab0f83ff553c",
            "leftCorner": {
              "x": 27.681,
              "y": 8.024,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.608,
              "y": 7.9518,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932229335"
          },
          {
            "id": "679afb3d3d9bab0f83ff553d",
            "leftCorner": {
              "x": 27.608,
              "y": 7.9518,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.546,
              "y": 7.89,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932229335"
          },
          {
            "id": "679afb3d3d9bab0f83ff553e",
            "leftCorner": {
              "x": 27.546,
              "y": 7.89,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.481,
              "y": 7.8258,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932229335"
          },
          {
            "id": "679afb3d3d9bab0f83ff553f",
            "leftCorner": {
              "x": 27.481,
              "y": 7.8258,
              "z": 0.92214
            },
            "rightCorner": {
              "x": 27.427,
              "y": 7.7719,
              "z": 0.92214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932229335"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac0d",
        "height": 1.0936,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5520",
            "leftCorner": {
              "x": 28.145,
              "y": 8.4824,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 28.072,
              "y": 8.4105,
              "z": 1.0936
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011932236012"
          },
          {
            "id": "679afb3d3d9bab0f83ff5522",
            "leftCorner": {
              "x": 28.072,
              "y": 8.4105,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 28.009,
              "y": 8.3477,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932236012"
          },
          {
            "id": "679afb3d3d9bab0f83ff5523",
            "leftCorner": {
              "x": 28.009,
              "y": 8.3477,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.943,
              "y": 8.283,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000030"
          },
          {
            "id": "679afb3d3d9bab0f83ff5524",
            "leftCorner": {
              "x": 27.943,
              "y": 8.283,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.878,
              "y": 8.2176,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932236012"
          },
          {
            "id": "679afb3d3d9bab0f83ff5525",
            "leftCorner": {
              "x": 27.878,
              "y": 8.2176,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.809,
              "y": 8.1496,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011932236012"
          },
          {
            "id": "679afb3d3d9bab0f83ff5526",
            "leftCorner": {
              "x": 27.809,
              "y": 8.1496,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.732,
              "y": 8.0737,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447086706"
          },
          {
            "id": "679afb3d3d9bab0f83ff5527",
            "leftCorner": {
              "x": 27.732,
              "y": 8.0737,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.658,
              "y": 7.9999,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5528",
            "leftCorner": {
              "x": 27.658,
              "y": 7.9999,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.574,
              "y": 7.9167,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447638783"
          },
          {
            "id": "679afb3d3d9bab0f83ff5529",
            "leftCorner": {
              "x": 27.574,
              "y": 7.9167,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.499,
              "y": 7.8419,
              "z": 1.0936
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447638820"
          },
          {
            "id": "679afb3d3d9bab0f83ff5521",
            "leftCorner": {
              "x": 27.499,
              "y": 7.8419,
              "z": 1.0936
            },
            "rightCorner": {
              "x": 27.434,
              "y": 7.7783,
              "z": 1.0936
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447638806"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac0f",
        "height": 1.2603,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff552a",
            "leftCorner": {
              "x": 28.144,
              "y": 8.483,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 28.051,
              "y": 8.3908,
              "z": 1.2603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7610700946008"
          },
          {
            "id": "679afb3d3d9bab0f83ff552c",
            "leftCorner": {
              "x": 28.051,
              "y": 8.3908,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.968,
              "y": 8.3088,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700946053"
          },
          {
            "id": "679afb3d3d9bab0f83ff552d",
            "leftCorner": {
              "x": 27.968,
              "y": 8.3088,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.885,
              "y": 8.2261,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700018545"
          },
          {
            "id": "679afb3d3d9bab0f83ff552e",
            "leftCorner": {
              "x": 27.885,
              "y": 8.2261,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.838,
              "y": 8.1794,
              "z": 1.2603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7610700014134"
          },
          {
            "id": "679afb3d3d9bab0f83ff552f",
            "leftCorner": {
              "x": 27.838,
              "y": 8.1794,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.749,
              "y": 8.0916,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700946398"
          },
          {
            "id": "679afb3d3d9bab0f83ff5530",
            "leftCorner": {
              "x": 27.749,
              "y": 8.0916,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.662,
              "y": 8.0048,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700946442"
          },
          {
            "id": "679afb3d3d9bab0f83ff5531",
            "leftCorner": {
              "x": 27.662,
              "y": 8.0048,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.572,
              "y": 7.9158,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700946541"
          },
          {
            "id": "679afb3d3d9bab0f83ff5532",
            "leftCorner": {
              "x": 27.572,
              "y": 7.9158,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.525,
              "y": 7.8689,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700022764"
          },
          {
            "id": "679afb3d3d9bab0f83ff5533",
            "leftCorner": {
              "x": 27.525,
              "y": 7.8689,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.478,
              "y": 7.8231,
              "z": 1.2603
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700022764"
          },
          {
            "id": "679afb3d3d9bab0f83ff552b",
            "leftCorner": {
              "x": 27.478,
              "y": 7.8231,
              "z": 1.2603
            },
            "rightCorner": {
              "x": 27.434,
              "y": 7.7789,
              "z": 1.2603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260137743836"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac11",
        "height": 1.4312,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5548",
            "leftCorner": {
              "x": 28.141,
              "y": 8.4856,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 28.072,
              "y": 8.4165,
              "z": 1.4312
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7610700600054"
          },
          {
            "id": "679afb3d3d9bab0f83ff554a",
            "leftCorner": {
              "x": 28.072,
              "y": 8.4165,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 28.018,
              "y": 8.3634,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700600054"
          },
          {
            "id": "679afb3d3d9bab0f83ff554b",
            "leftCorner": {
              "x": 28.018,
              "y": 8.3634,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.93,
              "y": 8.2756,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945001"
          },
          {
            "id": "679afb3d3d9bab0f83ff554c",
            "leftCorner": {
              "x": 27.93,
              "y": 8.2756,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.839,
              "y": 8.1855,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945087"
          },
          {
            "id": "679afb3d3d9bab0f83ff554d",
            "leftCorner": {
              "x": 27.839,
              "y": 8.1855,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.743,
              "y": 8.0906,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700947753"
          },
          {
            "id": "679afb3d3d9bab0f83ff554e",
            "leftCorner": {
              "x": 27.743,
              "y": 8.0906,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.654,
              "y": 8.0023,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945117"
          },
          {
            "id": "679afb3d3d9bab0f83ff554f",
            "leftCorner": {
              "x": 27.654,
              "y": 8.0023,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.554,
              "y": 7.9029,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077026070"
          },
          {
            "id": "679afb3d3d9bab0f83ff5550",
            "leftCorner": {
              "x": 27.554,
              "y": 7.9029,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.467,
              "y": 7.8168,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077026094"
          },
          {
            "id": "679afb3d3d9bab0f83ff5551",
            "leftCorner": {
              "x": 27.467,
              "y": 7.8168,
              "z": 1.4312
            },
            "rightCorner": {
              "x": 27.386,
              "y": 7.7367,
              "z": 1.4312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077026117"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac0e",
        "height": 1.6851,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff531b",
            "leftCorner": {
              "x": 28.146,
              "y": 8.4926,
              "z": 1.6854
            },
            "rightCorner": {
              "x": 28.06,
              "y": 8.4092,
              "z": 1.6854
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945131"
          },
          {
            "id": "679afb3d3d9bab0f83ff531c",
            "leftCorner": {
              "x": 28.063,
              "y": 8.4041,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.971,
              "y": 8.3132,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700018675"
          },
          {
            "id": "679afb3d3d9bab0f83ff531d",
            "leftCorner": {
              "x": 27.971,
              "y": 8.3132,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.886,
              "y": 8.2284,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700015766"
          },
          {
            "id": "679afb3d3d9bab0f83ff531e",
            "leftCorner": {
              "x": 27.886,
              "y": 8.2284,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.791,
              "y": 8.1347,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945834"
          },
          {
            "id": "679afb3d3d9bab0f83ff531f",
            "leftCorner": {
              "x": 27.791,
              "y": 8.1347,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.698,
              "y": 8.0425,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700014189"
          },
          {
            "id": "679afb3d3d9bab0f83ff5320",
            "leftCorner": {
              "x": 27.698,
              "y": 8.0425,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.605,
              "y": 7.9497,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945070"
          },
          {
            "id": "679afb3d3d9bab0f83ff5321",
            "leftCorner": {
              "x": 27.605,
              "y": 7.9497,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.509,
              "y": 7.8545,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700945759"
          },
          {
            "id": "679afb3d3d9bab0f83ff5322",
            "leftCorner": {
              "x": 27.509,
              "y": 7.8545,
              "z": 1.6851
            },
            "rightCorner": {
              "x": 27.429,
              "y": 7.7755,
              "z": 1.6851
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610700022825"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 69,
      "unknownStockCount": 16
    },
    "name": "5PXX",
    "leftNeighborShelfId": "KFT1",
    "rightNeighborShelfId": "T4J1"
  },
  {
    "id": "RI2E",
    "x": 46.553,
    "y": 3.8842,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.00070663
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac12",
        "height": 0.16174,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55a6",
            "leftCorner": {
              "x": 46.512,
              "y": 3.978,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.461,
              "y": 3.9779,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376852"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a7",
            "leftCorner": {
              "x": 46.461,
              "y": 3.9779,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.412,
              "y": 3.9779,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376814"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a8",
            "leftCorner": {
              "x": 46.412,
              "y": 3.9779,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.357,
              "y": 3.9778,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376814"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a9",
            "leftCorner": {
              "x": 46.357,
              "y": 3.9778,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.312,
              "y": 3.9777,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847887"
          },
          {
            "id": "679afb3d3d9bab0f83ff55aa",
            "leftCorner": {
              "x": 46.312,
              "y": 3.9777,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.265,
              "y": 3.9777,
              "z": 0.16174
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4064666847955"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ab",
            "leftCorner": {
              "x": 46.265,
              "y": 3.9777,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.219,
              "y": 3.9776,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847955"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ac",
            "leftCorner": {
              "x": 46.219,
              "y": 3.9776,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.17,
              "y": 3.9775,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847931"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ad",
            "leftCorner": {
              "x": 46.17,
              "y": 3.9775,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.123,
              "y": 3.9775,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847863"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ae",
            "leftCorner": {
              "x": 46.123,
              "y": 3.9775,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.075,
              "y": 3.9774,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847863"
          },
          {
            "id": "679afb3d3d9bab0f83ff55af",
            "leftCorner": {
              "x": 46.075,
              "y": 3.9774,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 46.012,
              "y": 3.9773,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006945447"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b0",
            "leftCorner": {
              "x": 46.012,
              "y": 3.9773,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.938,
              "y": 3.9772,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006943450"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b1",
            "leftCorner": {
              "x": 45.938,
              "y": 3.9772,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.861,
              "y": 3.9771,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006945478"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b2",
            "leftCorner": {
              "x": 45.861,
              "y": 3.9771,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.801,
              "y": 3.977,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006943474"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b3",
            "leftCorner": {
              "x": 45.801,
              "y": 3.977,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.741,
              "y": 3.9769,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006943481"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b4",
            "leftCorner": {
              "x": 45.741,
              "y": 3.9769,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.651,
              "y": 3.9768,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006945454"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b5",
            "leftCorner": {
              "x": 45.651,
              "y": 3.9768,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.563,
              "y": 3.9767,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "810006943405"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b6",
            "leftCorner": {
              "x": 45.563,
              "y": 3.9767,
              "z": 0.16174
            },
            "rightCorner": {
              "x": 45.486,
              "y": 3.9766,
              "z": 0.16174
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac16",
        "height": 0.46559,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff567b",
            "leftCorner": {
              "x": 46.519,
              "y": 3.8612,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.464,
              "y": 3.8611,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749840"
          },
          {
            "id": "679afb3d3d9bab0f83ff567c",
            "leftCorner": {
              "x": 46.464,
              "y": 3.8611,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.412,
              "y": 3.861,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749840"
          },
          {
            "id": "679afb3d3d9bab0f83ff567d",
            "leftCorner": {
              "x": 46.412,
              "y": 3.861,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.36,
              "y": 3.8609,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749529"
          },
          {
            "id": "679afb3d3d9bab0f83ff567e",
            "leftCorner": {
              "x": 46.36,
              "y": 3.8609,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.314,
              "y": 3.8609,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749680"
          },
          {
            "id": "679afb3d3d9bab0f83ff567f",
            "leftCorner": {
              "x": 46.314,
              "y": 3.8609,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.265,
              "y": 3.8608,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749680"
          },
          {
            "id": "679afb3d3d9bab0f83ff5680",
            "leftCorner": {
              "x": 46.265,
              "y": 3.8608,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.22,
              "y": 3.8607,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749727"
          },
          {
            "id": "679afb3d3d9bab0f83ff5681",
            "leftCorner": {
              "x": 46.22,
              "y": 3.8607,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.174,
              "y": 3.8607,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749765"
          },
          {
            "id": "679afb3d3d9bab0f83ff5682",
            "leftCorner": {
              "x": 46.174,
              "y": 3.8607,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.126,
              "y": 3.8606,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749765"
          },
          {
            "id": "679afb3d3d9bab0f83ff5683",
            "leftCorner": {
              "x": 46.126,
              "y": 3.8606,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.078,
              "y": 3.8605,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728668"
          },
          {
            "id": "679afb3d3d9bab0f83ff5684",
            "leftCorner": {
              "x": 46.078,
              "y": 3.8605,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 46.028,
              "y": 3.8605,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728606"
          },
          {
            "id": "679afb3d3d9bab0f83ff5685",
            "leftCorner": {
              "x": 46.028,
              "y": 3.8605,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 45.895,
              "y": 3.8603,
              "z": 0.46559
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100190496"
          },
          {
            "id": "679afb3d3d9bab0f83ff5686",
            "leftCorner": {
              "x": 45.895,
              "y": 3.8603,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 45.783,
              "y": 3.8601,
              "z": 0.46559
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002753283057"
          },
          {
            "id": "679afb3d3d9bab0f83ff5687",
            "leftCorner": {
              "x": 45.783,
              "y": 3.8601,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 45.738,
              "y": 3.8601,
              "z": 0.46559
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4002753283064"
          },
          {
            "id": "679afb3d3d9bab0f83ff5688",
            "leftCorner": {
              "x": 45.738,
              "y": 3.8601,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 45.612,
              "y": 3.8599,
              "z": 0.46559
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162033447"
          },
          {
            "id": "679afb3d3d9bab0f83ff5689",
            "leftCorner": {
              "x": 45.612,
              "y": 3.8599,
              "z": 0.46559
            },
            "rightCorner": {
              "x": 45.439,
              "y": 3.8596,
              "z": 0.46559
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013162030965"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac17",
        "height": 0.79788,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56d5",
            "leftCorner": {
              "x": 46.548,
              "y": 3.8602,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.495,
              "y": 3.8602,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600521575543"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d6",
            "leftCorner": {
              "x": 46.495,
              "y": 3.8602,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.45,
              "y": 3.8601,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383881"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d7",
            "leftCorner": {
              "x": 46.45,
              "y": 3.8601,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.401,
              "y": 3.86,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383881"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d8",
            "leftCorner": {
              "x": 46.401,
              "y": 3.86,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.351,
              "y": 3.86,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342253"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d9",
            "leftCorner": {
              "x": 46.351,
              "y": 3.86,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.302,
              "y": 3.8599,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342253"
          },
          {
            "id": "679afb3d3d9bab0f83ff56da",
            "leftCorner": {
              "x": 46.302,
              "y": 3.8599,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.254,
              "y": 3.8598,
              "z": 0.79788
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447342253"
          },
          {
            "id": "679afb3d3d9bab0f83ff56db",
            "leftCorner": {
              "x": 46.254,
              "y": 3.8598,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.2,
              "y": 3.8598,
              "z": 0.79788
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447342253"
          },
          {
            "id": "679afb3d3d9bab0f83ff56dc",
            "leftCorner": {
              "x": 46.2,
              "y": 3.8598,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.14,
              "y": 3.8597,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384642"
          },
          {
            "id": "679afb3d3d9bab0f83ff56dd",
            "leftCorner": {
              "x": 46.14,
              "y": 3.8597,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.077,
              "y": 3.8596,
              "z": 0.79788
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff56de",
            "leftCorner": {
              "x": 46.077,
              "y": 3.8596,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 46.025,
              "y": 3.8595,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff56df",
            "leftCorner": {
              "x": 46.025,
              "y": 3.8595,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.947,
              "y": 3.8594,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240399"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e0",
            "leftCorner": {
              "x": 45.947,
              "y": 3.8594,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.856,
              "y": 3.8593,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810769"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e1",
            "leftCorner": {
              "x": 45.856,
              "y": 3.8593,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.78,
              "y": 3.8592,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591606"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e2",
            "leftCorner": {
              "x": 45.78,
              "y": 3.8592,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.733,
              "y": 3.8591,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591606"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e3",
            "leftCorner": {
              "x": 45.733,
              "y": 3.8591,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.672,
              "y": 3.859,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342291"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e4",
            "leftCorner": {
              "x": 45.672,
              "y": 3.859,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.599,
              "y": 3.8589,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342291"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e5",
            "leftCorner": {
              "x": 45.599,
              "y": 3.8589,
              "z": 0.79788
            },
            "rightCorner": {
              "x": 45.553,
              "y": 3.8588,
              "z": 0.79788
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282243"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac13",
        "height": 1.1352,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5601",
            "leftCorner": {
              "x": 46.557,
              "y": 3.8626,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.504,
              "y": 3.8625,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810349"
          },
          {
            "id": "679afb3d3d9bab0f83ff5602",
            "leftCorner": {
              "x": 46.504,
              "y": 3.8625,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.458,
              "y": 3.8625,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668339"
          },
          {
            "id": "679afb3d3d9bab0f83ff5603",
            "leftCorner": {
              "x": 46.458,
              "y": 3.8625,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.411,
              "y": 3.8624,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812176"
          },
          {
            "id": "679afb3d3d9bab0f83ff5604",
            "leftCorner": {
              "x": 46.411,
              "y": 3.8624,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.368,
              "y": 3.8623,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812152"
          },
          {
            "id": "679afb3d3d9bab0f83ff5605",
            "leftCorner": {
              "x": 46.368,
              "y": 3.8623,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.321,
              "y": 3.8623,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069679"
          },
          {
            "id": "679afb3d3d9bab0f83ff5606",
            "leftCorner": {
              "x": 46.321,
              "y": 3.8623,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.269,
              "y": 3.8622,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815627"
          },
          {
            "id": "679afb3d3d9bab0f83ff5607",
            "leftCorner": {
              "x": 46.269,
              "y": 3.8622,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.223,
              "y": 3.8621,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800081"
          },
          {
            "id": "679afb3d3d9bab0f83ff5608",
            "leftCorner": {
              "x": 46.223,
              "y": 3.8621,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.172,
              "y": 3.8621,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540314623"
          },
          {
            "id": "679afb3d3d9bab0f83ff5609",
            "leftCorner": {
              "x": 46.172,
              "y": 3.8621,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.125,
              "y": 3.862,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540349120"
          },
          {
            "id": "679afb3d3d9bab0f83ff560a",
            "leftCorner": {
              "x": 46.125,
              "y": 3.862,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.077,
              "y": 3.8619,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439205"
          },
          {
            "id": "679afb3d3d9bab0f83ff560b",
            "leftCorner": {
              "x": 46.077,
              "y": 3.8619,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 46.025,
              "y": 3.8619,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439205"
          },
          {
            "id": "679afb3d3d9bab0f83ff560c",
            "leftCorner": {
              "x": 46.025,
              "y": 3.8619,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.975,
              "y": 3.8618,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438949"
          },
          {
            "id": "679afb3d3d9bab0f83ff560d",
            "leftCorner": {
              "x": 45.975,
              "y": 3.8618,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.904,
              "y": 3.8617,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069556"
          },
          {
            "id": "679afb3d3d9bab0f83ff560e",
            "leftCorner": {
              "x": 45.904,
              "y": 3.8617,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.827,
              "y": 3.8616,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600155"
          },
          {
            "id": "679afb3d3d9bab0f83ff560f",
            "leftCorner": {
              "x": 45.827,
              "y": 3.8616,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.778,
              "y": 3.8615,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600155"
          },
          {
            "id": "679afb3d3d9bab0f83ff5610",
            "leftCorner": {
              "x": 45.778,
              "y": 3.8615,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.683,
              "y": 3.8614,
              "z": 1.1352
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376630"
          },
          {
            "id": "679afb3d3d9bab0f83ff5611",
            "leftCorner": {
              "x": 45.683,
              "y": 3.8614,
              "z": 1.1352
            },
            "rightCorner": {
              "x": 45.588,
              "y": 3.8612,
              "z": 1.1352
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447439182"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac14",
        "height": 1.4293,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5623",
            "leftCorner": {
              "x": 46.552,
              "y": 3.8642,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.5,
              "y": 3.8642,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384154"
          },
          {
            "id": "679afb3d3d9bab0f83ff5624",
            "leftCorner": {
              "x": 46.5,
              "y": 3.8642,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.448,
              "y": 3.8641,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467574"
          },
          {
            "id": "679afb3d3d9bab0f83ff5625",
            "leftCorner": {
              "x": 46.448,
              "y": 3.8641,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.401,
              "y": 3.864,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376555"
          },
          {
            "id": "679afb3d3d9bab0f83ff5626",
            "leftCorner": {
              "x": 46.401,
              "y": 3.864,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.354,
              "y": 3.864,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376555"
          },
          {
            "id": "679afb3d3d9bab0f83ff5627",
            "leftCorner": {
              "x": 46.354,
              "y": 3.864,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.305,
              "y": 3.8639,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376579"
          },
          {
            "id": "679afb3d3d9bab0f83ff5628",
            "leftCorner": {
              "x": 46.305,
              "y": 3.8639,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.257,
              "y": 3.8638,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376579"
          },
          {
            "id": "679afb3d3d9bab0f83ff5629",
            "leftCorner": {
              "x": 46.257,
              "y": 3.8638,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.211,
              "y": 3.8638,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600131"
          },
          {
            "id": "679afb3d3d9bab0f83ff562a",
            "leftCorner": {
              "x": 46.211,
              "y": 3.8638,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.166,
              "y": 3.8637,
              "z": 1.4293
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447600131"
          },
          {
            "id": "679afb3d3d9bab0f83ff562b",
            "leftCorner": {
              "x": 46.166,
              "y": 3.8637,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.121,
              "y": 3.8636,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376593"
          },
          {
            "id": "679afb3d3d9bab0f83ff562c",
            "leftCorner": {
              "x": 46.121,
              "y": 3.8636,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.073,
              "y": 3.8636,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376593"
          },
          {
            "id": "679afb3d3d9bab0f83ff562d",
            "leftCorner": {
              "x": 46.073,
              "y": 3.8636,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 46.025,
              "y": 3.8635,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438789"
          },
          {
            "id": "679afb3d3d9bab0f83ff562e",
            "leftCorner": {
              "x": 46.025,
              "y": 3.8635,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.94,
              "y": 3.8634,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438789"
          },
          {
            "id": "679afb3d3d9bab0f83ff562f",
            "leftCorner": {
              "x": 45.94,
              "y": 3.8634,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.875,
              "y": 3.8633,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438789"
          },
          {
            "id": "679afb3d3d9bab0f83ff5630",
            "leftCorner": {
              "x": 45.875,
              "y": 3.8633,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.826,
              "y": 3.8632,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376494"
          },
          {
            "id": "679afb3d3d9bab0f83ff5631",
            "leftCorner": {
              "x": 45.826,
              "y": 3.8632,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.776,
              "y": 3.8632,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5632",
            "leftCorner": {
              "x": 45.776,
              "y": 3.8632,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.666,
              "y": 3.863,
              "z": 1.4293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376456"
          },
          {
            "id": "679afb3d3d9bab0f83ff5613",
            "leftCorner": {
              "x": 45.666,
              "y": 3.863,
              "z": 1.4293
            },
            "rightCorner": {
              "x": 45.553,
              "y": 3.8628,
              "z": 1.4293
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447376470"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac15",
        "height": 1.7252,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff564c",
            "leftCorner": {
              "x": 46.549,
              "y": 3.8628,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.495,
              "y": 3.8627,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069716"
          },
          {
            "id": "679afb3d3d9bab0f83ff564d",
            "leftCorner": {
              "x": 46.495,
              "y": 3.8627,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.449,
              "y": 3.8626,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447069082"
          },
          {
            "id": "679afb3d3d9bab0f83ff564e",
            "leftCorner": {
              "x": 46.449,
              "y": 3.8626,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.403,
              "y": 3.8626,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447069082"
          },
          {
            "id": "679afb3d3d9bab0f83ff564f",
            "leftCorner": {
              "x": 46.403,
              "y": 3.8626,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.355,
              "y": 3.8625,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069730"
          },
          {
            "id": "679afb3d3d9bab0f83ff5650",
            "leftCorner": {
              "x": 46.355,
              "y": 3.8625,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.307,
              "y": 3.8624,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724002148"
          },
          {
            "id": "679afb3d3d9bab0f83ff5651",
            "leftCorner": {
              "x": 46.307,
              "y": 3.8624,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.256,
              "y": 3.8624,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5010724527375"
          },
          {
            "id": "679afb3d3d9bab0f83ff5652",
            "leftCorner": {
              "x": 46.256,
              "y": 3.8624,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.203,
              "y": 3.8623,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724526798"
          },
          {
            "id": "679afb3d3d9bab0f83ff5653",
            "leftCorner": {
              "x": 46.203,
              "y": 3.8623,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.157,
              "y": 3.8622,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724527467"
          },
          {
            "id": "679afb3d3d9bab0f83ff5654",
            "leftCorner": {
              "x": 46.157,
              "y": 3.8622,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.109,
              "y": 3.8622,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724003824"
          },
          {
            "id": "679afb3d3d9bab0f83ff5655",
            "leftCorner": {
              "x": 46.109,
              "y": 3.8622,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 46.063,
              "y": 3.8621,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724527474"
          },
          {
            "id": "679afb3d3d9bab0f83ff5656",
            "leftCorner": {
              "x": 46.063,
              "y": 3.8621,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 45.936,
              "y": 3.8619,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5010724532966"
          },
          {
            "id": "679afb3d3d9bab0f83ff5657",
            "leftCorner": {
              "x": 45.936,
              "y": 3.8619,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 45.82,
              "y": 3.8617,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5010724527481"
          },
          {
            "id": "679afb3d3d9bab0f83ff5658",
            "leftCorner": {
              "x": 45.82,
              "y": 3.8617,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 45.769,
              "y": 3.8617,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800227"
          },
          {
            "id": "679afb3d3d9bab0f83ff5659",
            "leftCorner": {
              "x": 45.769,
              "y": 3.8617,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 45.668,
              "y": 3.8615,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900756015"
          },
          {
            "id": "679afb3d3d9bab0f83ff5634",
            "leftCorner": {
              "x": 45.668,
              "y": 3.8615,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 45.553,
              "y": 3.8614,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4072600721704"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 6,
      "hasStockCount": 83,
      "unknownStockCount": 9
    },
    "name": "RI2E",
    "leftNeighborShelfId": "R92R",
    "rightNeighborShelfId": "DIVG"
  },
  {
    "id": "VAD1",
    "x": 27.416,
    "y": 7.775,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.93095,
      "w": -0.36514
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac1d",
        "height": 0.19414,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff537b",
            "leftCorner": {
              "x": 27.388,
              "y": 7.8947,
              "z": 0.1963
            },
            "rightCorner": {
              "x": 27.296,
              "y": 7.8036,
              "z": 0.1963
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308796"
          },
          {
            "id": "679afb3d3d9bab0f83ff537c",
            "leftCorner": {
              "x": 27.295,
              "y": 7.7865,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 27.204,
              "y": 7.7023,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308772"
          },
          {
            "id": "679afb3d3d9bab0f83ff537d",
            "leftCorner": {
              "x": 27.204,
              "y": 7.7023,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 27.109,
              "y": 7.614,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172308734"
          },
          {
            "id": "679afb3d3d9bab0f83ff537e",
            "leftCorner": {
              "x": 27.109,
              "y": 7.614,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 27.019,
              "y": 7.5302,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607451"
          },
          {
            "id": "679afb3d3d9bab0f83ff537f",
            "leftCorner": {
              "x": 27.019,
              "y": 7.5302,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 26.922,
              "y": 7.4405,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447607475"
          },
          {
            "id": "679afb3d3d9bab0f83ff5380",
            "leftCorner": {
              "x": 26.922,
              "y": 7.4405,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 26.814,
              "y": 7.3403,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260680634933"
          },
          {
            "id": "679afb3d3d9bab0f83ff5381",
            "leftCorner": {
              "x": 26.814,
              "y": 7.3403,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 26.714,
              "y": 7.2477,
              "z": 0.19414
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260680634896"
          },
          {
            "id": "679afb3d3d9bab0f83ff5347",
            "leftCorner": {
              "x": 26.714,
              "y": 7.2477,
              "z": 0.19414
            },
            "rightCorner": {
              "x": 26.621,
              "y": 7.1616,
              "z": 0.19414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260680634919"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac1b",
        "height": 0.41686,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5519",
            "leftCorner": {
              "x": 27.434,
              "y": 7.7842,
              "z": 0.41729
            },
            "rightCorner": {
              "x": 27.361,
              "y": 7.7123,
              "z": 0.41729
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447399103"
          },
          {
            "id": "679afb3d3d9bab0f83ff551a",
            "leftCorner": {
              "x": 27.362,
              "y": 7.6891,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 27.272,
              "y": 7.6061,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725216"
          },
          {
            "id": "679afb3d3d9bab0f83ff551b",
            "leftCorner": {
              "x": 27.272,
              "y": 7.6061,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 27.171,
              "y": 7.5125,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725230"
          },
          {
            "id": "679afb3d3d9bab0f83ff551c",
            "leftCorner": {
              "x": 27.171,
              "y": 7.5125,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 27.071,
              "y": 7.4198,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725230"
          },
          {
            "id": "679afb3d3d9bab0f83ff551d",
            "leftCorner": {
              "x": 27.071,
              "y": 7.4198,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 26.987,
              "y": 7.342,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796072334"
          },
          {
            "id": "679afb3d3d9bab0f83ff551e",
            "leftCorner": {
              "x": 26.987,
              "y": 7.342,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 26.887,
              "y": 7.2489,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447398823"
          },
          {
            "id": "679afb3d3d9bab0f83ff551f",
            "leftCorner": {
              "x": 26.887,
              "y": 7.2489,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 26.79,
              "y": 7.1591,
              "z": 0.41686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447614381"
          },
          {
            "id": "679afb3d3d9bab0f83ff5510",
            "leftCorner": {
              "x": 26.79,
              "y": 7.1591,
              "z": 0.41686
            },
            "rightCorner": {
              "x": 26.7,
              "y": 7.0762,
              "z": 0.41686
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260024450281"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac1a",
        "height": 0.67018,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5702",
            "leftCorner": {
              "x": 27.435,
              "y": 7.7545,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 27.373,
              "y": 7.6973,
              "z": 0.67018
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3609200003070"
          },
          {
            "id": "679afb3d3d9bab0f83ff5704",
            "leftCorner": {
              "x": 27.373,
              "y": 7.6973,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 27.299,
              "y": 7.6284,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3609200003087"
          },
          {
            "id": "679afb3d3d9bab0f83ff5705",
            "leftCorner": {
              "x": 27.299,
              "y": 7.6284,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 27.226,
              "y": 7.5606,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3609200003087"
          },
          {
            "id": "679afb3d3d9bab0f83ff5706",
            "leftCorner": {
              "x": 27.226,
              "y": 7.5606,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 27.15,
              "y": 7.4899,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3609200008495"
          },
          {
            "id": "679afb3d3d9bab0f83ff5707",
            "leftCorner": {
              "x": 27.15,
              "y": 7.4899,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 27.062,
              "y": 7.4089,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4054411260627"
          },
          {
            "id": "679afb3d3d9bab0f83ff5708",
            "leftCorner": {
              "x": 27.062,
              "y": 7.4089,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 26.978,
              "y": 7.3312,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4054411260504"
          },
          {
            "id": "679afb3d3d9bab0f83ff5709",
            "leftCorner": {
              "x": 26.978,
              "y": 7.3312,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 26.888,
              "y": 7.247,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4054411260801"
          },
          {
            "id": "679afb3d3d9bab0f83ff570a",
            "leftCorner": {
              "x": 26.888,
              "y": 7.247,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 26.793,
              "y": 7.1591,
              "z": 0.67018
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260024450861"
          },
          {
            "id": "679afb3d3d9bab0f83ff5703",
            "leftCorner": {
              "x": 26.793,
              "y": 7.1591,
              "z": 0.67018
            },
            "rightCorner": {
              "x": 26.702,
              "y": 7.0747,
              "z": 0.67018
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260024451103"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac19",
        "height": 0.91915,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5540",
            "leftCorner": {
              "x": 27.425,
              "y": 7.7509,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 27.361,
              "y": 7.6915,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077020122"
          },
          {
            "id": "679afb3d3d9bab0f83ff5541",
            "leftCorner": {
              "x": 27.361,
              "y": 7.6915,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 27.295,
              "y": 7.6302,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077020559"
          },
          {
            "id": "679afb3d3d9bab0f83ff5542",
            "leftCorner": {
              "x": 27.295,
              "y": 7.6302,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 27.226,
              "y": 7.5659,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077020856"
          },
          {
            "id": "679afb3d3d9bab0f83ff5543",
            "leftCorner": {
              "x": 27.226,
              "y": 7.5659,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 27.142,
              "y": 7.4887,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030300022125"
          },
          {
            "id": "679afb3d3d9bab0f83ff5544",
            "leftCorner": {
              "x": 27.142,
              "y": 7.4887,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 27.064,
              "y": 7.4157,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077081208"
          },
          {
            "id": "679afb3d3d9bab0f83ff5545",
            "leftCorner": {
              "x": 27.064,
              "y": 7.4157,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 26.963,
              "y": 7.3229,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260278363108"
          },
          {
            "id": "679afb3d3d9bab0f83ff5546",
            "leftCorner": {
              "x": 26.963,
              "y": 7.3229,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 26.869,
              "y": 7.2354,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260278363139"
          },
          {
            "id": "679afb3d3d9bab0f83ff5547",
            "leftCorner": {
              "x": 26.869,
              "y": 7.2354,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 26.777,
              "y": 7.1498,
              "z": 0.91915
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260278366116"
          },
          {
            "id": "679afb3d3d9bab0f83ff5535",
            "leftCorner": {
              "x": 26.777,
              "y": 7.1498,
              "z": 0.91915
            },
            "rightCorner": {
              "x": 26.699,
              "y": 7.0777,
              "z": 0.91915
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009077555235"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac1c",
        "height": 1.1762,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff570b",
            "leftCorner": {
              "x": 27.432,
              "y": 7.7579,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 27.355,
              "y": 7.6863,
              "z": 1.1762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3663458005828"
          },
          {
            "id": "679afb3d3d9bab0f83ff570d",
            "leftCorner": {
              "x": 27.355,
              "y": 7.6863,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 27.249,
              "y": 7.5885,
              "z": 1.1762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3663458006788"
          },
          {
            "id": "679afb3d3d9bab0f83ff570e",
            "leftCorner": {
              "x": 27.249,
              "y": 7.5885,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 27.148,
              "y": 7.495,
              "z": 1.1762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3663458006429"
          },
          {
            "id": "679afb3d3d9bab0f83ff570f",
            "leftCorner": {
              "x": 27.148,
              "y": 7.495,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 27.061,
              "y": 7.4144,
              "z": 1.1762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4030300022033"
          },
          {
            "id": "679afb3d3d9bab0f83ff5710",
            "leftCorner": {
              "x": 27.061,
              "y": 7.4144,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 26.969,
              "y": 7.3284,
              "z": 1.1762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030300022088"
          },
          {
            "id": "679afb3d3d9bab0f83ff5711",
            "leftCorner": {
              "x": 26.969,
              "y": 7.3284,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 26.883,
              "y": 7.2486,
              "z": 1.1762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030300022880"
          },
          {
            "id": "679afb3d3d9bab0f83ff5712",
            "leftCorner": {
              "x": 26.883,
              "y": 7.2486,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 26.801,
              "y": 7.1733,
              "z": 1.1762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4030300573122"
          },
          {
            "id": "679afb3d3d9bab0f83ff570c",
            "leftCorner": {
              "x": 26.801,
              "y": 7.1733,
              "z": 1.1762
            },
            "rightCorner": {
              "x": 26.699,
              "y": 7.0781,
              "z": 1.1762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009077555020"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac18",
        "height": 1.4284,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5552",
            "leftCorner": {
              "x": 27.389,
              "y": 7.7107,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 27.295,
              "y": 7.6239,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024151"
          },
          {
            "id": "679afb3d3d9bab0f83ff5553",
            "leftCorner": {
              "x": 27.295,
              "y": 7.6239,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 27.185,
              "y": 7.522,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024007"
          },
          {
            "id": "679afb3d3d9bab0f83ff5554",
            "leftCorner": {
              "x": 27.185,
              "y": 7.522,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 27.092,
              "y": 7.4354,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024106"
          },
          {
            "id": "679afb3d3d9bab0f83ff5555",
            "leftCorner": {
              "x": 27.092,
              "y": 7.4354,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 26.999,
              "y": 7.349,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077031562"
          },
          {
            "id": "679afb3d3d9bab0f83ff5556",
            "leftCorner": {
              "x": 26.999,
              "y": 7.349,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 26.898,
              "y": 7.2553,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077031371"
          },
          {
            "id": "679afb3d3d9bab0f83ff5557",
            "leftCorner": {
              "x": 26.898,
              "y": 7.2553,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 26.806,
              "y": 7.1708,
              "z": 1.4284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077031388"
          },
          {
            "id": "679afb3d3d9bab0f83ff5549",
            "leftCorner": {
              "x": 26.806,
              "y": 7.1708,
              "z": 1.4284
            },
            "rightCorner": {
              "x": 26.702,
              "y": 7.0742,
              "z": 1.4284
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009077031562"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac1e",
        "height": 1.6807,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5323",
            "leftCorner": {
              "x": 27.433,
              "y": 7.7486,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 27.338,
              "y": 7.6611,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009077024458"
          },
          {
            "id": "679afb3d3d9bab0f83ff5324",
            "leftCorner": {
              "x": 27.338,
              "y": 7.6611,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 27.237,
              "y": 7.5674,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024762"
          },
          {
            "id": "679afb3d3d9bab0f83ff5325",
            "leftCorner": {
              "x": 27.237,
              "y": 7.5674,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 27.123,
              "y": 7.4616,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024656"
          },
          {
            "id": "679afb3d3d9bab0f83ff5326",
            "leftCorner": {
              "x": 27.123,
              "y": 7.4616,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 27.023,
              "y": 7.3691,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024601"
          },
          {
            "id": "679afb3d3d9bab0f83ff5327",
            "leftCorner": {
              "x": 27.023,
              "y": 7.3691,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 26.923,
              "y": 7.2766,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077026018"
          },
          {
            "id": "679afb3d3d9bab0f83ff5328",
            "leftCorner": {
              "x": 26.923,
              "y": 7.2766,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 26.827,
              "y": 7.1876,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009077024304"
          },
          {
            "id": "679afb3d3d9bab0f83ff52e7",
            "leftCorner": {
              "x": 26.827,
              "y": 7.1876,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 26.704,
              "y": 7.0728,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 43,
      "unknownStockCount": 13
    },
    "name": "VAD1",
    "leftNeighborShelfId": "68B1",
    "rightNeighborShelfId": "JZYK"
  },
  {
    "id": "8FP9",
    "x": 17.728,
    "y": 8.1731,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.000084186
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac23",
        "height": 0.19573,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5745",
            "leftCorner": {
              "x": 17.71,
              "y": 8.2677,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 17.675,
              "y": 8.2677,
              "z": 0.19573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5746",
            "leftCorner": {
              "x": 17.675,
              "y": 8.2677,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 17.507,
              "y": 8.2676,
              "z": 0.19573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300445543"
          },
          {
            "id": "679afb3d3d9bab0f83ff5747",
            "leftCorner": {
              "x": 17.507,
              "y": 8.2676,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 17.296,
              "y": 8.2676,
              "z": 0.19573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5099514003565"
          },
          {
            "id": "679afb3d3d9bab0f83ff5748",
            "leftCorner": {
              "x": 17.296,
              "y": 8.2676,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 17.102,
              "y": 8.2676,
              "z": 0.19573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841077949"
          },
          {
            "id": "679afb3d3d9bab0f83ff5749",
            "leftCorner": {
              "x": 17.102,
              "y": 8.2676,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 16.903,
              "y": 8.2675,
              "z": 0.19573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841062624"
          },
          {
            "id": "679afb3d3d9bab0f83ff5744",
            "leftCorner": {
              "x": 16.903,
              "y": 8.2675,
              "z": 0.19573
            },
            "rightCorner": {
              "x": 16.728,
              "y": 8.2675,
              "z": 0.19573
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540556139"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac24",
        "height": 0.50269,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff574a",
            "leftCorner": {
              "x": 17.728,
              "y": 8.1613,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 17.685,
              "y": 8.1613,
              "z": 0.50269
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff574c",
            "leftCorner": {
              "x": 17.685,
              "y": 8.1613,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 17.482,
              "y": 8.1613,
              "z": 0.50269
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796061437"
          },
          {
            "id": "679afb3d3d9bab0f83ff574d",
            "leftCorner": {
              "x": 17.482,
              "y": 8.1613,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 17.255,
              "y": 8.1612,
              "z": 0.50269
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796061598"
          },
          {
            "id": "679afb3d3d9bab0f83ff574e",
            "leftCorner": {
              "x": 17.255,
              "y": 8.1612,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 17.083,
              "y": 8.1612,
              "z": 0.50269
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796061598"
          },
          {
            "id": "679afb3d3d9bab0f83ff574f",
            "leftCorner": {
              "x": 17.083,
              "y": 8.1612,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 16.898,
              "y": 8.1612,
              "z": 0.50269
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260678845075"
          },
          {
            "id": "679afb3d3d9bab0f83ff574b",
            "leftCorner": {
              "x": 16.898,
              "y": 8.1612,
              "z": 0.50269
            },
            "rightCorner": {
              "x": 16.728,
              "y": 8.1611,
              "z": 0.50269
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260678845037"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac21",
        "height": 0.79459,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5729",
            "leftCorner": {
              "x": 17.728,
              "y": 8.1563,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.641,
              "y": 8.1563,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447710281"
          },
          {
            "id": "679afb3d3d9bab0f83ff572b",
            "leftCorner": {
              "x": 17.641,
              "y": 8.1563,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.529,
              "y": 8.1563,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447710045"
          },
          {
            "id": "679afb3d3d9bab0f83ff572c",
            "leftCorner": {
              "x": 17.529,
              "y": 8.1563,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.449,
              "y": 8.1563,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671285"
          },
          {
            "id": "679afb3d3d9bab0f83ff572d",
            "leftCorner": {
              "x": 17.449,
              "y": 8.1563,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.354,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447712995"
          },
          {
            "id": "679afb3d3d9bab0f83ff572e",
            "leftCorner": {
              "x": 17.354,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.287,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709902"
          },
          {
            "id": "679afb3d3d9bab0f83ff572f",
            "leftCorner": {
              "x": 17.287,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.219,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709926"
          },
          {
            "id": "679afb3d3d9bab0f83ff5730",
            "leftCorner": {
              "x": 17.219,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.163,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709940"
          },
          {
            "id": "679afb3d3d9bab0f83ff5731",
            "leftCorner": {
              "x": 17.163,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.105,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709827"
          },
          {
            "id": "679afb3d3d9bab0f83ff5732",
            "leftCorner": {
              "x": 17.105,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.057,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447518054"
          },
          {
            "id": "679afb3d3d9bab0f83ff5733",
            "leftCorner": {
              "x": 17.057,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 17.007,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709780"
          },
          {
            "id": "679afb3d3d9bab0f83ff5734",
            "leftCorner": {
              "x": 17.007,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 16.947,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674637"
          },
          {
            "id": "679afb3d3d9bab0f83ff5735",
            "leftCorner": {
              "x": 16.947,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 16.891,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674637"
          },
          {
            "id": "679afb3d3d9bab0f83ff5736",
            "leftCorner": {
              "x": 16.891,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 16.79,
              "y": 8.1562,
              "z": 0.79459
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011448001104"
          },
          {
            "id": "679afb3d3d9bab0f83ff572a",
            "leftCorner": {
              "x": 16.79,
              "y": 8.1562,
              "z": 0.79459
            },
            "rightCorner": {
              "x": 16.728,
              "y": 8.1561,
              "z": 0.79459
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011448007007"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac22",
        "height": 1.0857,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5737",
            "leftCorner": {
              "x": 17.728,
              "y": 8.1537,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.668,
              "y": 8.1537,
              "z": 1.0857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331001542"
          },
          {
            "id": "679afb3d3d9bab0f83ff5739",
            "leftCorner": {
              "x": 17.668,
              "y": 8.1537,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.605,
              "y": 8.1537,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001542"
          },
          {
            "id": "679afb3d3d9bab0f83ff573a",
            "leftCorner": {
              "x": 17.605,
              "y": 8.1537,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.572,
              "y": 8.1537,
              "z": 1.0857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331001542"
          },
          {
            "id": "679afb3d3d9bab0f83ff573b",
            "leftCorner": {
              "x": 17.572,
              "y": 8.1537,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.486,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000330"
          },
          {
            "id": "679afb3d3d9bab0f83ff573c",
            "leftCorner": {
              "x": 17.486,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.398,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000323"
          },
          {
            "id": "679afb3d3d9bab0f83ff573d",
            "leftCorner": {
              "x": 17.398,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.321,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000781"
          },
          {
            "id": "679afb3d3d9bab0f83ff573e",
            "leftCorner": {
              "x": 17.321,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.249,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000026"
          },
          {
            "id": "679afb3d3d9bab0f83ff573f",
            "leftCorner": {
              "x": 17.249,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.164,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000064"
          },
          {
            "id": "679afb3d3d9bab0f83ff5740",
            "leftCorner": {
              "x": 17.164,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 17.081,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000033"
          },
          {
            "id": "679afb3d3d9bab0f83ff5741",
            "leftCorner": {
              "x": 17.081,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 16.997,
              "y": 8.1536,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331000040"
          },
          {
            "id": "679afb3d3d9bab0f83ff5742",
            "leftCorner": {
              "x": 16.997,
              "y": 8.1536,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 16.933,
              "y": 8.1535,
              "z": 1.0857
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4065331000019"
          },
          {
            "id": "679afb3d3d9bab0f83ff5743",
            "leftCorner": {
              "x": 16.933,
              "y": 8.1535,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 16.821,
              "y": 8.1535,
              "z": 1.0857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331004215"
          },
          {
            "id": "679afb3d3d9bab0f83ff5738",
            "leftCorner": {
              "x": 16.821,
              "y": 8.1535,
              "z": 1.0857
            },
            "rightCorner": {
              "x": 16.728,
              "y": 8.1535,
              "z": 1.0857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000012"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac20",
        "height": 1.4228,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5720",
            "leftCorner": {
              "x": 17.728,
              "y": 8.1542,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 17.592,
              "y": 8.1541,
              "z": 1.4228
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661264431"
          },
          {
            "id": "679afb3d3d9bab0f83ff5721",
            "leftCorner": {
              "x": 17.592,
              "y": 8.1541,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 17.296,
              "y": 8.1541,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661474939"
          },
          {
            "id": "679afb3d3d9bab0f83ff5722",
            "leftCorner": {
              "x": 17.296,
              "y": 8.1541,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 17.198,
              "y": 8.1541,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661474960"
          },
          {
            "id": "679afb3d3d9bab0f83ff5723",
            "leftCorner": {
              "x": 17.198,
              "y": 8.1541,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 17.105,
              "y": 8.1541,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661500553"
          },
          {
            "id": "679afb3d3d9bab0f83ff5724",
            "leftCorner": {
              "x": 17.105,
              "y": 8.1541,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 17.014,
              "y": 8.154,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661606026"
          },
          {
            "id": "679afb3d3d9bab0f83ff5725",
            "leftCorner": {
              "x": 17.014,
              "y": 8.154,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 16.919,
              "y": 8.154,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661606040"
          },
          {
            "id": "679afb3d3d9bab0f83ff5726",
            "leftCorner": {
              "x": 16.919,
              "y": 8.154,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 16.858,
              "y": 8.154,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661727073"
          },
          {
            "id": "679afb3d3d9bab0f83ff5727",
            "leftCorner": {
              "x": 16.858,
              "y": 8.154,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 16.797,
              "y": 8.154,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331004239"
          },
          {
            "id": "679afb3d3d9bab0f83ff5728",
            "leftCorner": {
              "x": 16.797,
              "y": 8.154,
              "z": 1.4228
            },
            "rightCorner": {
              "x": 16.741,
              "y": 8.154,
              "z": 1.4228
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331004239"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac1f",
        "height": 1.7201,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5714",
            "leftCorner": {
              "x": 17.724,
              "y": 8.1515,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.594,
              "y": 8.1515,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419346"
          },
          {
            "id": "679afb3d3d9bab0f83ff5715",
            "leftCorner": {
              "x": 17.594,
              "y": 8.1515,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.497,
              "y": 8.1515,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42241317"
          },
          {
            "id": "679afb3d3d9bab0f83ff5716",
            "leftCorner": {
              "x": 17.497,
              "y": 8.1515,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.428,
              "y": 8.1515,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419377"
          },
          {
            "id": "679afb3d3d9bab0f83ff5717",
            "leftCorner": {
              "x": 17.428,
              "y": 8.1515,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.306,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42241287"
          },
          {
            "id": "679afb3d3d9bab0f83ff5718",
            "leftCorner": {
              "x": 17.306,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.214,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419391"
          },
          {
            "id": "679afb3d3d9bab0f83ff5719",
            "leftCorner": {
              "x": 17.214,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.135,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419421"
          },
          {
            "id": "679afb3d3d9bab0f83ff571a",
            "leftCorner": {
              "x": 17.135,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.071,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419445"
          },
          {
            "id": "679afb3d3d9bab0f83ff571b",
            "leftCorner": {
              "x": 17.071,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 17.035,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300419414"
          },
          {
            "id": "679afb3d3d9bab0f83ff571c",
            "leftCorner": {
              "x": 17.035,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 16.999,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528082985"
          },
          {
            "id": "679afb3d3d9bab0f83ff571d",
            "leftCorner": {
              "x": 16.999,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 16.918,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000034201"
          },
          {
            "id": "679afb3d3d9bab0f83ff571e",
            "leftCorner": {
              "x": 16.918,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 16.858,
              "y": 8.1514,
              "z": 1.7201
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4006000028262"
          },
          {
            "id": "679afb3d3d9bab0f83ff571f",
            "leftCorner": {
              "x": 16.858,
              "y": 8.1514,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 16.774,
              "y": 8.1513,
              "z": 1.7201
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000028767"
          },
          {
            "id": "679afb3d3d9bab0f83ff5713",
            "leftCorner": {
              "x": 16.774,
              "y": 8.1513,
              "z": 1.7201
            },
            "rightCorner": {
              "x": 16.728,
              "y": 8.1513,
              "z": 1.7201
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42439516"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 46,
      "unknownStockCount": 12
    },
    "name": "8FP9",
    "leftNeighborShelfId": "YOAF"
  },
  {
    "id": "T4J1",
    "x": 23.726,
    "y": 8.2403,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.00061681
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac28",
        "height": 0.18715,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5771",
            "leftCorner": {
              "x": 23.726,
              "y": 8.3353,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 23.688,
              "y": 8.3352,
              "z": 0.18715
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5773",
            "leftCorner": {
              "x": 23.688,
              "y": 8.3352,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 23.471,
              "y": 8.335,
              "z": 0.18715
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366228"
          },
          {
            "id": "679afb3d3d9bab0f83ff5774",
            "leftCorner": {
              "x": 23.471,
              "y": 8.335,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 23.274,
              "y": 8.3347,
              "z": 0.18715
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366228"
          },
          {
            "id": "679afb3d3d9bab0f83ff5775",
            "leftCorner": {
              "x": 23.274,
              "y": 8.3347,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 23.089,
              "y": 8.3345,
              "z": 0.18715
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447366228"
          },
          {
            "id": "679afb3d3d9bab0f83ff5776",
            "leftCorner": {
              "x": 23.089,
              "y": 8.3345,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 23.046,
              "y": 8.3344,
              "z": 0.18715
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5777",
            "leftCorner": {
              "x": 23.046,
              "y": 8.3344,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 22.841,
              "y": 8.3342,
              "z": 0.18715
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366242"
          },
          {
            "id": "679afb3d3d9bab0f83ff5772",
            "leftCorner": {
              "x": 22.841,
              "y": 8.3342,
              "z": 0.18715
            },
            "rightCorner": {
              "x": 22.726,
              "y": 8.334,
              "z": 0.18715
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447366242"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac29",
        "height": 0.54925,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5778",
            "leftCorner": {
              "x": 23.707,
              "y": 8.2302,
              "z": 0.54925
            },
            "rightCorner": {
              "x": 23.524,
              "y": 8.23,
              "z": 0.54925
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7322542285398"
          },
          {
            "id": "679afb3d3d9bab0f83ff5779",
            "leftCorner": {
              "x": 23.524,
              "y": 8.23,
              "z": 0.54925
            },
            "rightCorner": {
              "x": 23.336,
              "y": 8.2298,
              "z": 0.54925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540574876"
          },
          {
            "id": "679afb3d3d9bab0f83ff577a",
            "leftCorner": {
              "x": 23.336,
              "y": 8.2298,
              "z": 0.54925
            },
            "rightCorner": {
              "x": 23.181,
              "y": 8.2296,
              "z": 0.54925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540574876"
          },
          {
            "id": "679afb3d3d9bab0f83ff577b",
            "leftCorner": {
              "x": 23.181,
              "y": 8.2296,
              "z": 0.54925
            },
            "rightCorner": {
              "x": 22.929,
              "y": 8.2293,
              "z": 0.54925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322542075104"
          },
          {
            "id": "679afb3d3d9bab0f83ff577c",
            "leftCorner": {
              "x": 22.929,
              "y": 8.2293,
              "z": 0.54925
            },
            "rightCorner": {
              "x": 22.722,
              "y": 8.229,
              "z": 0.54925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322542146989"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac2a",
        "height": 0.88151,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff577d",
            "leftCorner": {
              "x": 23.698,
              "y": 8.2261,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.533,
              "y": 8.2259,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff577e",
            "leftCorner": {
              "x": 23.533,
              "y": 8.2259,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.421,
              "y": 8.2258,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff577f",
            "leftCorner": {
              "x": 23.421,
              "y": 8.2258,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.297,
              "y": 8.2256,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009408040522"
          },
          {
            "id": "679afb3d3d9bab0f83ff5780",
            "leftCorner": {
              "x": 23.297,
              "y": 8.2256,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.205,
              "y": 8.2255,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009408040522"
          },
          {
            "id": "679afb3d3d9bab0f83ff5781",
            "leftCorner": {
              "x": 23.205,
              "y": 8.2255,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.098,
              "y": 8.2254,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5782",
            "leftCorner": {
              "x": 23.098,
              "y": 8.2254,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 23.011,
              "y": 8.2253,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5783",
            "leftCorner": {
              "x": 23.011,
              "y": 8.2253,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 22.97,
              "y": 8.2252,
              "z": 0.88151
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447085013"
          },
          {
            "id": "679afb3d3d9bab0f83ff5784",
            "leftCorner": {
              "x": 22.97,
              "y": 8.2252,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 22.903,
              "y": 8.2251,
              "z": 0.88151
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447085013"
          },
          {
            "id": "679afb3d3d9bab0f83ff5785",
            "leftCorner": {
              "x": 22.903,
              "y": 8.2251,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 22.856,
              "y": 8.2251,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5786",
            "leftCorner": {
              "x": 22.856,
              "y": 8.2251,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 22.794,
              "y": 8.225,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5787",
            "leftCorner": {
              "x": 22.794,
              "y": 8.225,
              "z": 0.88151
            },
            "rightCorner": {
              "x": 22.723,
              "y": 8.2249,
              "z": 0.88151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447085051"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac25",
        "height": 1.1793,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5750",
            "leftCorner": {
              "x": 23.719,
              "y": 8.2219,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.638,
              "y": 8.2218,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322542327500"
          },
          {
            "id": "679afb3d3d9bab0f83ff5751",
            "leftCorner": {
              "x": 23.638,
              "y": 8.2218,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.557,
              "y": 8.2217,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322542327500"
          },
          {
            "id": "679afb3d3d9bab0f83ff5752",
            "leftCorner": {
              "x": 23.557,
              "y": 8.2217,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.469,
              "y": 8.2216,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447122787"
          },
          {
            "id": "679afb3d3d9bab0f83ff5753",
            "leftCorner": {
              "x": 23.469,
              "y": 8.2216,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.332,
              "y": 8.2214,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447122800"
          },
          {
            "id": "679afb3d3d9bab0f83ff5754",
            "leftCorner": {
              "x": 23.332,
              "y": 8.2214,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.207,
              "y": 8.2213,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447122800"
          },
          {
            "id": "679afb3d3d9bab0f83ff5755",
            "leftCorner": {
              "x": 23.207,
              "y": 8.2213,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 23.081,
              "y": 8.2211,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000013"
          },
          {
            "id": "679afb3d3d9bab0f83ff5756",
            "leftCorner": {
              "x": 23.081,
              "y": 8.2211,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 22.958,
              "y": 8.221,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796000665"
          },
          {
            "id": "679afb3d3d9bab0f83ff5757",
            "leftCorner": {
              "x": 22.958,
              "y": 8.221,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 22.905,
              "y": 8.2209,
              "z": 1.1793
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5758",
            "leftCorner": {
              "x": 22.905,
              "y": 8.2209,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 22.857,
              "y": 8.2208,
              "z": 1.1793
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5759",
            "leftCorner": {
              "x": 22.857,
              "y": 8.2208,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 22.82,
              "y": 8.2208,
              "z": 1.1793
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009408040904"
          },
          {
            "id": "679afb3d3d9bab0f83ff575a",
            "leftCorner": {
              "x": 22.82,
              "y": 8.2208,
              "z": 1.1793
            },
            "rightCorner": {
              "x": 22.731,
              "y": 8.2207,
              "z": 1.1793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009408040904"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac27",
        "height": 1.4742,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5763",
            "leftCorner": {
              "x": 23.726,
              "y": 8.2175,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.688,
              "y": 8.2175,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5765",
            "leftCorner": {
              "x": 23.688,
              "y": 8.2175,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.606,
              "y": 8.2174,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541079967"
          },
          {
            "id": "679afb3d3d9bab0f83ff5766",
            "leftCorner": {
              "x": 23.606,
              "y": 8.2174,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.522,
              "y": 8.2172,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5767",
            "leftCorner": {
              "x": 23.522,
              "y": 8.2172,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.418,
              "y": 8.2171,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541079677"
          },
          {
            "id": "679afb3d3d9bab0f83ff5768",
            "leftCorner": {
              "x": 23.418,
              "y": 8.2171,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.325,
              "y": 8.217,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322541079677"
          },
          {
            "id": "679afb3d3d9bab0f83ff5769",
            "leftCorner": {
              "x": 23.325,
              "y": 8.217,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.253,
              "y": 8.2169,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540738955"
          },
          {
            "id": "679afb3d3d9bab0f83ff576a",
            "leftCorner": {
              "x": 23.253,
              "y": 8.2169,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.184,
              "y": 8.2168,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540738900"
          },
          {
            "id": "679afb3d3d9bab0f83ff576b",
            "leftCorner": {
              "x": 23.184,
              "y": 8.2168,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.101,
              "y": 8.2167,
              "z": 1.4742
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540738900"
          },
          {
            "id": "679afb3d3d9bab0f83ff576c",
            "leftCorner": {
              "x": 23.101,
              "y": 8.2167,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.06,
              "y": 8.2167,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff576d",
            "leftCorner": {
              "x": 23.06,
              "y": 8.2167,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 23.003,
              "y": 8.2166,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216178976"
          },
          {
            "id": "679afb3d3d9bab0f83ff576e",
            "leftCorner": {
              "x": 23.003,
              "y": 8.2166,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 22.948,
              "y": 8.2165,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216178976"
          },
          {
            "id": "679afb3d3d9bab0f83ff576f",
            "leftCorner": {
              "x": 22.948,
              "y": 8.2165,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 22.84,
              "y": 8.2164,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216179430"
          },
          {
            "id": "679afb3d3d9bab0f83ff5770",
            "leftCorner": {
              "x": 22.84,
              "y": 8.2164,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 22.8,
              "y": 8.2164,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5764",
            "leftCorner": {
              "x": 22.8,
              "y": 8.2164,
              "z": 1.4742
            },
            "rightCorner": {
              "x": 22.726,
              "y": 8.2163,
              "z": 1.4742
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac26",
        "height": 1.7686,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff575c",
            "leftCorner": {
              "x": 23.703,
              "y": 8.2118,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 23.497,
              "y": 8.2115,
              "z": 1.7686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172991684"
          },
          {
            "id": "679afb3d3d9bab0f83ff575d",
            "leftCorner": {
              "x": 23.497,
              "y": 8.2115,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 23.392,
              "y": 8.2114,
              "z": 1.7686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172991684"
          },
          {
            "id": "679afb3d3d9bab0f83ff575e",
            "leftCorner": {
              "x": 23.392,
              "y": 8.2114,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 23.232,
              "y": 8.2112,
              "z": 1.7686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540887624"
          },
          {
            "id": "679afb3d3d9bab0f83ff575f",
            "leftCorner": {
              "x": 23.232,
              "y": 8.2112,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 23.087,
              "y": 8.211,
              "z": 1.7686
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540887648"
          },
          {
            "id": "679afb3d3d9bab0f83ff5760",
            "leftCorner": {
              "x": 23.087,
              "y": 8.211,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 23.042,
              "y": 8.211,
              "z": 1.7686
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5761",
            "leftCorner": {
              "x": 23.042,
              "y": 8.211,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 22.914,
              "y": 8.2108,
              "z": 1.7686
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5762",
            "leftCorner": {
              "x": 22.914,
              "y": 8.2108,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 22.866,
              "y": 8.2107,
              "z": 1.7686
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff575b",
            "leftCorner": {
              "x": 22.866,
              "y": 8.2107,
              "z": 1.7686
            },
            "rightCorner": {
              "x": 22.726,
              "y": 8.2106,
              "z": 1.7686
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009408039373"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 35,
      "unknownStockCount": 21
    },
    "name": "T4J1",
    "leftNeighborShelfId": "VAD1",
    "rightNeighborShelfId": "YOAF"
  },
  {
    "id": "JZYK",
    "x": 21.733,
    "y": 8.2379,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.00066922
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac2d",
        "height": 0.20003,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff579c",
            "leftCorner": {
              "x": 21.733,
              "y": 8.3392,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 21.68,
              "y": 8.3391,
              "z": 0.20003
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff579e",
            "leftCorner": {
              "x": 21.68,
              "y": 8.3391,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 21.475,
              "y": 8.3388,
              "z": 0.20003
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5029053563497"
          },
          {
            "id": "679afb3d3d9bab0f83ff579f",
            "leftCorner": {
              "x": 21.475,
              "y": 8.3388,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 21.309,
              "y": 8.3386,
              "z": 0.20003
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447166712"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a0",
            "leftCorner": {
              "x": 21.309,
              "y": 8.3386,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 21.184,
              "y": 8.3384,
              "z": 0.20003
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447166712"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a1",
            "leftCorner": {
              "x": 21.184,
              "y": 8.3384,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 21.002,
              "y": 8.3382,
              "z": 0.20003
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a2",
            "leftCorner": {
              "x": 21.002,
              "y": 8.3382,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 20.821,
              "y": 8.338,
              "z": 0.20003
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447166699"
          },
          {
            "id": "679afb3d3d9bab0f83ff579d",
            "leftCorner": {
              "x": 20.821,
              "y": 8.338,
              "z": 0.20003
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.3378,
              "z": 0.20003
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac2b",
        "height": 0.55034,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5789",
            "leftCorner": {
              "x": 21.727,
              "y": 8.2262,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.635,
              "y": 8.2261,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540451991"
          },
          {
            "id": "679afb3d3d9bab0f83ff578a",
            "leftCorner": {
              "x": 21.635,
              "y": 8.2261,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.545,
              "y": 8.2259,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540451991"
          },
          {
            "id": "679afb3d3d9bab0f83ff578b",
            "leftCorner": {
              "x": 21.545,
              "y": 8.2259,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.464,
              "y": 8.2258,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540451991"
          },
          {
            "id": "679afb3d3d9bab0f83ff578c",
            "leftCorner": {
              "x": 21.464,
              "y": 8.2258,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.339,
              "y": 8.2257,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540538227"
          },
          {
            "id": "679afb3d3d9bab0f83ff578d",
            "leftCorner": {
              "x": 21.339,
              "y": 8.2257,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.229,
              "y": 8.2255,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540732700"
          },
          {
            "id": "679afb3d3d9bab0f83ff578e",
            "leftCorner": {
              "x": 21.229,
              "y": 8.2255,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.113,
              "y": 8.2254,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540732700"
          },
          {
            "id": "679afb3d3d9bab0f83ff578f",
            "leftCorner": {
              "x": 21.113,
              "y": 8.2254,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 21.009,
              "y": 8.2252,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540732625"
          },
          {
            "id": "679afb3d3d9bab0f83ff5790",
            "leftCorner": {
              "x": 21.009,
              "y": 8.2252,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 20.896,
              "y": 8.2251,
              "z": 0.55034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000014"
          },
          {
            "id": "679afb3d3d9bab0f83ff5791",
            "leftCorner": {
              "x": 20.896,
              "y": 8.2251,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 20.799,
              "y": 8.2249,
              "z": 0.55034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216213868"
          },
          {
            "id": "679afb3d3d9bab0f83ff5788",
            "leftCorner": {
              "x": 20.799,
              "y": 8.2249,
              "z": 0.55034
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.2248,
              "z": 0.55034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216213868"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac30",
        "height": 0.88411,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57bc",
            "leftCorner": {
              "x": 21.733,
              "y": 8.2181,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.607,
              "y": 8.218,
              "z": 0.88411
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57be",
            "leftCorner": {
              "x": 21.607,
              "y": 8.218,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.447,
              "y": 8.2178,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57bf",
            "leftCorner": {
              "x": 21.447,
              "y": 8.2178,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.319,
              "y": 8.2176,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c0",
            "leftCorner": {
              "x": 21.319,
              "y": 8.2176,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.211,
              "y": 8.2174,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447122824"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c1",
            "leftCorner": {
              "x": 21.211,
              "y": 8.2174,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.184,
              "y": 8.2174,
              "z": 0.88411
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447122824"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c2",
            "leftCorner": {
              "x": 21.184,
              "y": 8.2174,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 21.068,
              "y": 8.2172,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c3",
            "leftCorner": {
              "x": 21.068,
              "y": 8.2172,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 20.976,
              "y": 8.2171,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c4",
            "leftCorner": {
              "x": 20.976,
              "y": 8.2171,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 20.886,
              "y": 8.217,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447093285"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c5",
            "leftCorner": {
              "x": 20.886,
              "y": 8.217,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 20.792,
              "y": 8.2169,
              "z": 0.88411
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447093285"
          },
          {
            "id": "679afb3d3d9bab0f83ff57bd",
            "leftCorner": {
              "x": 20.792,
              "y": 8.2169,
              "z": 0.88411
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.2168,
              "z": 0.88411
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac2c",
        "height": 1.1803,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5792",
            "leftCorner": {
              "x": 21.733,
              "y": 8.221,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.684,
              "y": 8.2209,
              "z": 1.1803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5794",
            "leftCorner": {
              "x": 21.684,
              "y": 8.2209,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.544,
              "y": 8.2207,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661661995"
          },
          {
            "id": "679afb3d3d9bab0f83ff5795",
            "leftCorner": {
              "x": 21.544,
              "y": 8.2207,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.404,
              "y": 8.2205,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661661995"
          },
          {
            "id": "679afb3d3d9bab0f83ff5796",
            "leftCorner": {
              "x": 21.404,
              "y": 8.2205,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.27,
              "y": 8.2203,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5797",
            "leftCorner": {
              "x": 21.27,
              "y": 8.2203,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.242,
              "y": 8.2203,
              "z": 1.1803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661680811"
          },
          {
            "id": "679afb3d3d9bab0f83ff5798",
            "leftCorner": {
              "x": 21.242,
              "y": 8.2203,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.106,
              "y": 8.2201,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661680811"
          },
          {
            "id": "679afb3d3d9bab0f83ff5799",
            "leftCorner": {
              "x": 21.106,
              "y": 8.2201,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 21.006,
              "y": 8.22,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661500324"
          },
          {
            "id": "679afb3d3d9bab0f83ff579a",
            "leftCorner": {
              "x": 21.006,
              "y": 8.22,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 20.906,
              "y": 8.2199,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661500324"
          },
          {
            "id": "679afb3d3d9bab0f83ff579b",
            "leftCorner": {
              "x": 20.906,
              "y": 8.2199,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 20.802,
              "y": 8.2197,
              "z": 1.1803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661661940"
          },
          {
            "id": "679afb3d3d9bab0f83ff5793",
            "leftCorner": {
              "x": 20.802,
              "y": 8.2197,
              "z": 1.1803
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.2196,
              "z": 1.1803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661661940"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac2f",
        "height": 1.4765,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57b4",
            "leftCorner": {
              "x": 21.727,
              "y": 8.2128,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.589,
              "y": 8.2126,
              "z": 1.4765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661482187"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b5",
            "leftCorner": {
              "x": 21.589,
              "y": 8.2126,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.432,
              "y": 8.2124,
              "z": 1.4765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661482187"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b6",
            "leftCorner": {
              "x": 21.432,
              "y": 8.2124,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.301,
              "y": 8.2123,
              "z": 1.4765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661482187"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b7",
            "leftCorner": {
              "x": 21.301,
              "y": 8.2123,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.275,
              "y": 8.2122,
              "z": 1.4765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b8",
            "leftCorner": {
              "x": 21.275,
              "y": 8.2122,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.161,
              "y": 8.2121,
              "z": 1.4765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661482194"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b9",
            "leftCorner": {
              "x": 21.161,
              "y": 8.2121,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 21.133,
              "y": 8.212,
              "z": 1.4765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ba",
            "leftCorner": {
              "x": 21.133,
              "y": 8.212,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 20.993,
              "y": 8.2118,
              "z": 1.4765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661486321"
          },
          {
            "id": "679afb3d3d9bab0f83ff57bb",
            "leftCorner": {
              "x": 20.993,
              "y": 8.2118,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 20.848,
              "y": 8.2117,
              "z": 1.4765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661486314"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b3",
            "leftCorner": {
              "x": 20.848,
              "y": 8.2117,
              "z": 1.4765
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.2115,
              "z": 1.4765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661486314"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac2e",
        "height": 1.7721,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57a3",
            "leftCorner": {
              "x": 21.733,
              "y": 8.2075,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.693,
              "y": 8.2075,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a5",
            "leftCorner": {
              "x": 21.693,
              "y": 8.2075,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.55,
              "y": 8.2073,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540689110"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a6",
            "leftCorner": {
              "x": 21.55,
              "y": 8.2073,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.397,
              "y": 8.2071,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540689271"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a7",
            "leftCorner": {
              "x": 21.397,
              "y": 8.2071,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.334,
              "y": 8.207,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661776644"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a8",
            "leftCorner": {
              "x": 21.334,
              "y": 8.207,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.307,
              "y": 8.207,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661776644"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a9",
            "leftCorner": {
              "x": 21.307,
              "y": 8.207,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.258,
              "y": 8.2069,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661776699"
          },
          {
            "id": "679afb3d3d9bab0f83ff57aa",
            "leftCorner": {
              "x": 21.258,
              "y": 8.2069,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.229,
              "y": 8.2069,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000022"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ab",
            "leftCorner": {
              "x": 21.229,
              "y": 8.2069,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.182,
              "y": 8.2068,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661776729"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ac",
            "leftCorner": {
              "x": 21.182,
              "y": 8.2068,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.155,
              "y": 8.2068,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661776729"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ad",
            "leftCorner": {
              "x": 21.155,
              "y": 8.2068,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.086,
              "y": 8.2067,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796073393"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ae",
            "leftCorner": {
              "x": 21.086,
              "y": 8.2067,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 21.016,
              "y": 8.2066,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796073416"
          },
          {
            "id": "679afb3d3d9bab0f83ff57af",
            "leftCorner": {
              "x": 21.016,
              "y": 8.2066,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 20.946,
              "y": 8.2065,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796073430"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b0",
            "leftCorner": {
              "x": 20.946,
              "y": 8.2065,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 20.892,
              "y": 8.2064,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366471"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b1",
            "leftCorner": {
              "x": 20.892,
              "y": 8.2064,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 20.842,
              "y": 8.2063,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366495"
          },
          {
            "id": "679afb3d3d9bab0f83ff57b2",
            "leftCorner": {
              "x": 20.842,
              "y": 8.2063,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 20.79,
              "y": 8.2063,
              "z": 1.7721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366518"
          },
          {
            "id": "679afb3d3d9bab0f83ff57a4",
            "leftCorner": {
              "x": 20.79,
              "y": 8.2063,
              "z": 1.7721
            },
            "rightCorner": {
              "x": 20.733,
              "y": 8.2062,
              "z": 1.7721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447068252"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 41,
      "unknownStockCount": 21
    },
    "name": "JZYK",
    "leftNeighborShelfId": "T4J1"
  },
  {
    "id": "KKXB",
    "x": 33.289,
    "y": 7.278,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42553,
      "w": 0.90495
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac35",
        "height": 0.19547,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57f9",
            "leftCorner": {
              "x": 33.387,
              "y": 7.1967,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.414,
              "y": 7.2297,
              "z": 0.19547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004191016518"
          },
          {
            "id": "679afb3d3d9bab0f83ff57fb",
            "leftCorner": {
              "x": 33.414,
              "y": 7.2297,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.457,
              "y": 7.2815,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191016525"
          },
          {
            "id": "679afb3d3d9bab0f83ff57fc",
            "leftCorner": {
              "x": 33.457,
              "y": 7.2815,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.505,
              "y": 7.3393,
              "z": 0.19547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004191008445"
          },
          {
            "id": "679afb3d3d9bab0f83ff57fd",
            "leftCorner": {
              "x": 33.505,
              "y": 7.3393,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.558,
              "y": 7.4037,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004194008404"
          },
          {
            "id": "679afb3d3d9bab0f83ff57fe",
            "leftCorner": {
              "x": 33.558,
              "y": 7.4037,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.606,
              "y": 7.4616,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004194008404"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ff",
            "leftCorner": {
              "x": 33.606,
              "y": 7.4616,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.659,
              "y": 7.5252,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191016563"
          },
          {
            "id": "679afb3d3d9bab0f83ff5800",
            "leftCorner": {
              "x": 33.659,
              "y": 7.5252,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.743,
              "y": 7.6265,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027007344"
          },
          {
            "id": "679afb3d3d9bab0f83ff5801",
            "leftCorner": {
              "x": 33.743,
              "y": 7.6265,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.829,
              "y": 7.7308,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027010207"
          },
          {
            "id": "679afb3d3d9bab0f83ff5802",
            "leftCorner": {
              "x": 33.829,
              "y": 7.7308,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.922,
              "y": 7.8425,
              "z": 0.19547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027007238"
          },
          {
            "id": "679afb3d3d9bab0f83ff5803",
            "leftCorner": {
              "x": 33.922,
              "y": 7.8425,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 33.971,
              "y": 7.9022,
              "z": 0.19547
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4009932134117"
          },
          {
            "id": "679afb3d3d9bab0f83ff57fa",
            "leftCorner": {
              "x": 33.971,
              "y": 7.9022,
              "z": 0.19547
            },
            "rightCorner": {
              "x": 34.025,
              "y": 7.9669,
              "z": 0.19547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8710428019677"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac33",
        "height": 0.54728,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57e0",
            "leftCorner": {
              "x": 33.316,
              "y": 7.282,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.368,
              "y": 7.3448,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131598"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e1",
            "leftCorner": {
              "x": 33.368,
              "y": 7.3448,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.419,
              "y": 7.4072,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233111605"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e2",
            "leftCorner": {
              "x": 33.419,
              "y": 7.4072,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.473,
              "y": 7.4726,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087442059"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e3",
            "leftCorner": {
              "x": 33.473,
              "y": 7.4726,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.508,
              "y": 7.515,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260488132334"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e4",
            "leftCorner": {
              "x": 33.508,
              "y": 7.515,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.558,
              "y": 7.575,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070101"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e5",
            "leftCorner": {
              "x": 33.558,
              "y": 7.575,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.629,
              "y": 7.661,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447416541"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e6",
            "leftCorner": {
              "x": 33.629,
              "y": 7.661,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.683,
              "y": 7.7252,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172777790"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e7",
            "leftCorner": {
              "x": 33.683,
              "y": 7.7252,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.735,
              "y": 7.789,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695032"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e8",
            "leftCorner": {
              "x": 33.735,
              "y": 7.789,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.776,
              "y": 7.8381,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447249378"
          },
          {
            "id": "679afb3d3d9bab0f83ff57e9",
            "leftCorner": {
              "x": 33.776,
              "y": 7.8381,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.799,
              "y": 7.8657,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447249378"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ea",
            "leftCorner": {
              "x": 33.799,
              "y": 7.8657,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.821,
              "y": 7.892,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57eb",
            "leftCorner": {
              "x": 33.821,
              "y": 7.892,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.864,
              "y": 7.9443,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027007887"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ec",
            "leftCorner": {
              "x": 33.864,
              "y": 7.9443,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.884,
              "y": 7.9687,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027007436"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ed",
            "leftCorner": {
              "x": 33.884,
              "y": 7.9687,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.905,
              "y": 7.9944,
              "z": 0.54728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027007436"
          },
          {
            "id": "679afb3d3d9bab0f83ff57df",
            "leftCorner": {
              "x": 33.905,
              "y": 7.9944,
              "z": 0.54728
            },
            "rightCorner": {
              "x": 33.94,
              "y": 8.0366,
              "z": 0.54728
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010160001164"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac32",
        "height": 0.79628,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57d2",
            "leftCorner": {
              "x": 33.302,
              "y": 7.2671,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.369,
              "y": 7.3483,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087430650"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d3",
            "leftCorner": {
              "x": 33.369,
              "y": 7.3483,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.416,
              "y": 7.4056,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172937088"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d4",
            "leftCorner": {
              "x": 33.416,
              "y": 7.4056,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.474,
              "y": 7.4755,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932006025"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d5",
            "leftCorner": {
              "x": 33.474,
              "y": 7.4755,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.53,
              "y": 7.5431,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932002454"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d6",
            "leftCorner": {
              "x": 33.53,
              "y": 7.5431,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.589,
              "y": 7.6137,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4270001024602"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d7",
            "leftCorner": {
              "x": 33.589,
              "y": 7.6137,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.613,
              "y": 7.6437,
              "z": 0.79628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233033037"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d8",
            "leftCorner": {
              "x": 33.613,
              "y": 7.6437,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.663,
              "y": 7.7034,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233033037"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d9",
            "leftCorner": {
              "x": 33.663,
              "y": 7.7034,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.701,
              "y": 7.75,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233175324"
          },
          {
            "id": "679afb3d3d9bab0f83ff57da",
            "leftCorner": {
              "x": 33.701,
              "y": 7.75,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.729,
              "y": 7.7838,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff57db",
            "leftCorner": {
              "x": 33.729,
              "y": 7.7838,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.783,
              "y": 7.8479,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260609512076"
          },
          {
            "id": "679afb3d3d9bab0f83ff57dc",
            "leftCorner": {
              "x": 33.783,
              "y": 7.8479,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.845,
              "y": 7.9235,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447394870"
          },
          {
            "id": "679afb3d3d9bab0f83ff57dd",
            "leftCorner": {
              "x": 33.845,
              "y": 7.9235,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.866,
              "y": 7.9485,
              "z": 0.79628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447219517"
          },
          {
            "id": "679afb3d3d9bab0f83ff57de",
            "leftCorner": {
              "x": 33.866,
              "y": 7.9485,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.9,
              "y": 7.9899,
              "z": 0.79628
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219517"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d1",
            "leftCorner": {
              "x": 33.9,
              "y": 7.9899,
              "z": 0.79628
            },
            "rightCorner": {
              "x": 33.939,
              "y": 8.0374,
              "z": 0.79628
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447219371"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac31",
        "height": 1.0451,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57c6",
            "leftCorner": {
              "x": 33.295,
              "y": 7.2729,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.34,
              "y": 7.3272,
              "z": 1.0451
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003087400059"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c8",
            "leftCorner": {
              "x": 33.34,
              "y": 7.3272,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.405,
              "y": 7.4065,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087400158"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c9",
            "leftCorner": {
              "x": 33.405,
              "y": 7.4065,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.458,
              "y": 7.4695,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752201873"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ca",
            "leftCorner": {
              "x": 33.458,
              "y": 7.4695,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.505,
              "y": 7.5263,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491104159"
          },
          {
            "id": "679afb3d3d9bab0f83ff57cb",
            "leftCorner": {
              "x": 33.505,
              "y": 7.5263,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.559,
              "y": 7.5924,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447248715"
          },
          {
            "id": "679afb3d3d9bab0f83ff57cc",
            "leftCorner": {
              "x": 33.559,
              "y": 7.5924,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.639,
              "y": 7.689,
              "z": 1.0451
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005120202019"
          },
          {
            "id": "679afb3d3d9bab0f83ff57cd",
            "leftCorner": {
              "x": 33.639,
              "y": 7.689,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.721,
              "y": 7.7873,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455036113"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ce",
            "leftCorner": {
              "x": 33.721,
              "y": 7.7873,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.793,
              "y": 7.874,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309878"
          },
          {
            "id": "679afb3d3d9bab0f83ff57cf",
            "leftCorner": {
              "x": 33.793,
              "y": 7.874,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.849,
              "y": 7.9417,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260729421517"
          },
          {
            "id": "679afb3d3d9bab0f83ff57d0",
            "leftCorner": {
              "x": 33.849,
              "y": 7.9417,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.897,
              "y": 8.0004,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260729420749"
          },
          {
            "id": "679afb3d3d9bab0f83ff57c7",
            "leftCorner": {
              "x": 33.897,
              "y": 8.0004,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 33.933,
              "y": 8.043,
              "z": 1.0451
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581536054"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac34",
        "height": 1.2996,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff57ef",
            "leftCorner": {
              "x": 33.293,
              "y": 7.2666,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.338,
              "y": 7.3213,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172922138"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f0",
            "leftCorner": {
              "x": 33.338,
              "y": 7.3213,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.392,
              "y": 7.3862,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932136272"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f1",
            "leftCorner": {
              "x": 33.392,
              "y": 7.3862,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.457,
              "y": 7.4656,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573800219"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f2",
            "leftCorner": {
              "x": 33.457,
              "y": 7.4656,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.496,
              "y": 7.5117,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491108607"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f3",
            "leftCorner": {
              "x": 33.496,
              "y": 7.5117,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.539,
              "y": 7.5644,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491108683"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f4",
            "leftCorner": {
              "x": 33.539,
              "y": 7.5644,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.608,
              "y": 7.6472,
              "z": 1.2996
            },
            "stockLevel": "UNKNOWN",
            "gtin": "2050000040306"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f5",
            "leftCorner": {
              "x": 33.608,
              "y": 7.6472,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.667,
              "y": 7.7182,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491105026"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f6",
            "leftCorner": {
              "x": 33.667,
              "y": 7.7182,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.766,
              "y": 7.8388,
              "z": 1.2996
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008491103558"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f7",
            "leftCorner": {
              "x": 33.766,
              "y": 7.8388,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.849,
              "y": 7.9384,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752204546"
          },
          {
            "id": "679afb3d3d9bab0f83ff57f8",
            "leftCorner": {
              "x": 33.849,
              "y": 7.9384,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.906,
              "y": 8.0078,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932137217"
          },
          {
            "id": "679afb3d3d9bab0f83ff57ee",
            "leftCorner": {
              "x": 33.906,
              "y": 8.0078,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 33.934,
              "y": 8.0416,
              "z": 1.2996
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172694080"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac36",
        "height": 1.512,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5804",
            "leftCorner": {
              "x": 33.302,
              "y": 7.2673,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.335,
              "y": 7.3076,
              "z": 1.512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260488132280"
          },
          {
            "id": "679afb3d3d9bab0f83ff5806",
            "leftCorner": {
              "x": 33.335,
              "y": 7.3076,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.387,
              "y": 7.371,
              "z": 1.512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260488132303"
          },
          {
            "id": "679afb3d3d9bab0f83ff5807",
            "leftCorner": {
              "x": 33.387,
              "y": 7.371,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.441,
              "y": 7.4351,
              "z": 1.512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260488132495"
          },
          {
            "id": "679afb3d3d9bab0f83ff5808",
            "leftCorner": {
              "x": 33.441,
              "y": 7.4351,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.489,
              "y": 7.4934,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447248869"
          },
          {
            "id": "679afb3d3d9bab0f83ff5809",
            "leftCorner": {
              "x": 33.489,
              "y": 7.4934,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.539,
              "y": 7.5536,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491276283"
          },
          {
            "id": "679afb3d3d9bab0f83ff580a",
            "leftCorner": {
              "x": 33.539,
              "y": 7.5536,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.601,
              "y": 7.629,
              "z": 1.512
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4009932004908"
          },
          {
            "id": "679afb3d3d9bab0f83ff580b",
            "leftCorner": {
              "x": 33.601,
              "y": 7.629,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.657,
              "y": 7.6968,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000015"
          },
          {
            "id": "679afb3d3d9bab0f83ff580c",
            "leftCorner": {
              "x": 33.657,
              "y": 7.6968,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.715,
              "y": 7.767,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009241527006"
          },
          {
            "id": "679afb3d3d9bab0f83ff580d",
            "leftCorner": {
              "x": 33.715,
              "y": 7.767,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.775,
              "y": 7.8384,
              "z": 1.512
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4250752204560"
          },
          {
            "id": "679afb3d3d9bab0f83ff580e",
            "leftCorner": {
              "x": 33.775,
              "y": 7.8384,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.849,
              "y": 7.9289,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010160001287"
          },
          {
            "id": "679afb3d3d9bab0f83ff5805",
            "leftCorner": {
              "x": 33.849,
              "y": 7.9289,
              "z": 1.512
            },
            "rightCorner": {
              "x": 33.939,
              "y": 8.0374,
              "z": 1.512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010160001232"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac37",
        "height": 1.725,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5810",
            "leftCorner": {
              "x": 33.298,
              "y": 7.2712,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.367,
              "y": 7.3539,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752203204"
          },
          {
            "id": "679afb3d3d9bab0f83ff5811",
            "leftCorner": {
              "x": 33.367,
              "y": 7.3539,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.436,
              "y": 7.438,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752203204"
          },
          {
            "id": "679afb3d3d9bab0f83ff5812",
            "leftCorner": {
              "x": 33.436,
              "y": 7.438,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.503,
              "y": 7.5187,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491108447"
          },
          {
            "id": "679afb3d3d9bab0f83ff5813",
            "leftCorner": {
              "x": 33.503,
              "y": 7.5187,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.576,
              "y": 7.6066,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932132632"
          },
          {
            "id": "679afb3d3d9bab0f83ff5814",
            "leftCorner": {
              "x": 33.576,
              "y": 7.6066,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.625,
              "y": 7.6665,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131161"
          },
          {
            "id": "679afb3d3d9bab0f83ff5815",
            "leftCorner": {
              "x": 33.625,
              "y": 7.6665,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.688,
              "y": 7.7416,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133769"
          },
          {
            "id": "679afb3d3d9bab0f83ff5816",
            "leftCorner": {
              "x": 33.688,
              "y": 7.7416,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.727,
              "y": 7.7894,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133127"
          },
          {
            "id": "679afb3d3d9bab0f83ff5817",
            "leftCorner": {
              "x": 33.727,
              "y": 7.7894,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.759,
              "y": 7.8273,
              "z": 1.725
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932133127"
          },
          {
            "id": "679afb3d3d9bab0f83ff5818",
            "leftCorner": {
              "x": 33.759,
              "y": 7.8273,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.831,
              "y": 7.9147,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447788952"
          },
          {
            "id": "679afb3d3d9bab0f83ff5819",
            "leftCorner": {
              "x": 33.831,
              "y": 7.9147,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.854,
              "y": 7.9419,
              "z": 1.725
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491132916"
          },
          {
            "id": "679afb3d3d9bab0f83ff581a",
            "leftCorner": {
              "x": 33.854,
              "y": 7.9419,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.888,
              "y": 7.9841,
              "z": 1.725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491132916"
          },
          {
            "id": "679afb3d3d9bab0f83ff580f",
            "leftCorner": {
              "x": 33.888,
              "y": 7.9841,
              "z": 1.725
            },
            "rightCorner": {
              "x": 33.935,
              "y": 8.0407,
              "z": 1.725
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491104142"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 62,
      "unknownStockCount": 19
    },
    "name": "KKXB",
    "leftNeighborShelfId": "BY8E",
    "rightNeighborShelfId": "3LN7"
  },
  {
    "id": "FAGG",
    "x": 20.676,
    "y": 10.281,
    "width": 1,
    "height": 1.8,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0022138,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac3b",
        "height": 0.19619,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5836",
            "leftCorner": {
              "x": 20.677,
              "y": 10.177,
              "z": 0.19619
            },
            "rightCorner": {
              "x": 20.828,
              "y": 10.177,
              "z": 0.19619
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506440"
          },
          {
            "id": "679afb3d3d9bab0f83ff5838",
            "leftCorner": {
              "x": 20.828,
              "y": 10.177,
              "z": 0.19619
            },
            "rightCorner": {
              "x": 21.325,
              "y": 10.18,
              "z": 0.19619
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506570"
          },
          {
            "id": "679afb3d3d9bab0f83ff5839",
            "leftCorner": {
              "x": 21.325,
              "y": 10.18,
              "z": 0.19619
            },
            "rightCorner": {
              "x": 21.658,
              "y": 10.181,
              "z": 0.19619
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447638745"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac39",
        "height": 0.58693,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5825",
            "leftCorner": {
              "x": 20.676,
              "y": 10.29,
              "z": 0.58693
            },
            "rightCorner": {
              "x": 20.792,
              "y": 10.29,
              "z": 0.58693
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5826",
            "leftCorner": {
              "x": 20.792,
              "y": 10.29,
              "z": 0.58693
            },
            "rightCorner": {
              "x": 21.027,
              "y": 10.291,
              "z": 0.58693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746280"
          },
          {
            "id": "679afb3d3d9bab0f83ff5827",
            "leftCorner": {
              "x": 21.027,
              "y": 10.291,
              "z": 0.58693
            },
            "rightCorner": {
              "x": 21.27,
              "y": 10.292,
              "z": 0.58693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746280"
          },
          {
            "id": "679afb3d3d9bab0f83ff5828",
            "leftCorner": {
              "x": 21.27,
              "y": 10.292,
              "z": 0.58693
            },
            "rightCorner": {
              "x": 21.51,
              "y": 10.293,
              "z": 0.58693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447746303"
          },
          {
            "id": "679afb3d3d9bab0f83ff5829",
            "leftCorner": {
              "x": 21.51,
              "y": 10.293,
              "z": 0.58693
            },
            "rightCorner": {
              "x": 21.712,
              "y": 10.294,
              "z": 0.58693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746303"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac38",
        "height": 0.96372,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff581b",
            "leftCorner": {
              "x": 20.676,
              "y": 10.289,
              "z": 0.96372
            },
            "rightCorner": {
              "x": 20.739,
              "y": 10.289,
              "z": 0.96372
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000032"
          },
          {
            "id": "679afb3d3d9bab0f83ff581d",
            "leftCorner": {
              "x": 20.739,
              "y": 10.289,
              "z": 0.96372
            },
            "rightCorner": {
              "x": 21.016,
              "y": 10.29,
              "z": 0.96372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216793438"
          },
          {
            "id": "679afb3d3d9bab0f83ff581e",
            "leftCorner": {
              "x": 21.016,
              "y": 10.29,
              "z": 0.96372
            },
            "rightCorner": {
              "x": 21.228,
              "y": 10.291,
              "z": 0.96372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216334914"
          },
          {
            "id": "679afb3d3d9bab0f83ff581f",
            "leftCorner": {
              "x": 21.228,
              "y": 10.291,
              "z": 0.96372
            },
            "rightCorner": {
              "x": 21.469,
              "y": 10.292,
              "z": 0.96372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216713139"
          },
          {
            "id": "679afb3d3d9bab0f83ff5820",
            "leftCorner": {
              "x": 21.469,
              "y": 10.292,
              "z": 0.96372
            },
            "rightCorner": {
              "x": 21.761,
              "y": 10.294,
              "z": 0.96372
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216334952"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac3a",
        "height": 1.4271,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff582f",
            "leftCorner": {
              "x": 20.676,
              "y": 10.289,
              "z": 1.4271
            },
            "rightCorner": {
              "x": 20.881,
              "y": 10.29,
              "z": 1.4271
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216207461"
          },
          {
            "id": "679afb3d3d9bab0f83ff5831",
            "leftCorner": {
              "x": 20.881,
              "y": 10.29,
              "z": 1.4271
            },
            "rightCorner": {
              "x": 21.089,
              "y": 10.291,
              "z": 1.4271
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216664752"
          },
          {
            "id": "679afb3d3d9bab0f83ff5832",
            "leftCorner": {
              "x": 21.089,
              "y": 10.291,
              "z": 1.4271
            },
            "rightCorner": {
              "x": 21.542,
              "y": 10.293,
              "z": 1.4271
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216207386"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac3c",
        "height": 1.7672,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff583f",
            "leftCorner": {
              "x": 20.676,
              "y": 10.287,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 20.721,
              "y": 10.287,
              "z": 1.7672
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4897097261539"
          },
          {
            "id": "679afb3d3d9bab0f83ff5841",
            "leftCorner": {
              "x": 20.721,
              "y": 10.287,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 20.95,
              "y": 10.288,
              "z": 1.7672
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5842",
            "leftCorner": {
              "x": 20.95,
              "y": 10.288,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 21.165,
              "y": 10.289,
              "z": 1.7672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4895248004820"
          },
          {
            "id": "679afb3d3d9bab0f83ff5843",
            "leftCorner": {
              "x": 21.165,
              "y": 10.289,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 21.352,
              "y": 10.29,
              "z": 1.7672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447114287"
          },
          {
            "id": "679afb3d3d9bab0f83ff5844",
            "leftCorner": {
              "x": 21.352,
              "y": 10.29,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 21.562,
              "y": 10.291,
              "z": 1.7672
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447114300"
          },
          {
            "id": "679afb3d3d9bab0f83ff5845",
            "leftCorner": {
              "x": 21.562,
              "y": 10.291,
              "z": 1.7672
            },
            "rightCorner": {
              "x": 21.733,
              "y": 10.291,
              "z": 1.7672
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000016"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 10,
      "unknownStockCount": 11,
      "shelfCategory": "FOOD"
    },
    "name": "FAGG",
    "leftNeighborShelfId": "FPWP"
  },
  {
    "id": "FPWP",
    "x": 21.7,
    "y": 10.283,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0073571,
      "w": 0.99997
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac3e",
        "height": 0.19436,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff583a",
            "leftCorner": {
              "x": 21.658,
              "y": 10.181,
              "z": 0.19619
            },
            "rightCorner": {
              "x": 21.873,
              "y": 10.182,
              "z": 0.19619
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447745467"
          },
          {
            "id": "679afb3d3d9bab0f83ff583b",
            "leftCorner": {
              "x": 21.897,
              "y": 10.188,
              "z": 0.19436
            },
            "rightCorner": {
              "x": 22.078,
              "y": 10.191,
              "z": 0.19436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796027211"
          },
          {
            "id": "679afb3d3d9bab0f83ff583c",
            "leftCorner": {
              "x": 22.078,
              "y": 10.191,
              "z": 0.19436
            },
            "rightCorner": {
              "x": 22.281,
              "y": 10.194,
              "z": 0.19436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010415510075"
          },
          {
            "id": "679afb3d3d9bab0f83ff583d",
            "leftCorner": {
              "x": 22.281,
              "y": 10.194,
              "z": 0.19436
            },
            "rightCorner": {
              "x": 22.472,
              "y": 10.197,
              "z": 0.19436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447185287"
          },
          {
            "id": "679afb3d3d9bab0f83ff583e",
            "leftCorner": {
              "x": 22.472,
              "y": 10.197,
              "z": 0.19436
            },
            "rightCorner": {
              "x": 22.649,
              "y": 10.199,
              "z": 0.19436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447185287"
          },
          {
            "id": "679afb3d3d9bab0f83ff5837",
            "leftCorner": {
              "x": 22.649,
              "y": 10.199,
              "z": 0.19436
            },
            "rightCorner": {
              "x": 22.701,
              "y": 10.2,
              "z": 0.19436
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac40",
        "height": 0.59481,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff582a",
            "leftCorner": {
              "x": 21.735,
              "y": 10.295,
              "z": 0.59481
            },
            "rightCorner": {
              "x": 21.928,
              "y": 10.298,
              "z": 0.59481
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff582b",
            "leftCorner": {
              "x": 21.928,
              "y": 10.298,
              "z": 0.59481
            },
            "rightCorner": {
              "x": 21.969,
              "y": 10.299,
              "z": 0.59481
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff582c",
            "leftCorner": {
              "x": 21.969,
              "y": 10.299,
              "z": 0.59481
            },
            "rightCorner": {
              "x": 22.243,
              "y": 10.303,
              "z": 0.59481
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746327"
          },
          {
            "id": "679afb3d3d9bab0f83ff582d",
            "leftCorner": {
              "x": 22.243,
              "y": 10.303,
              "z": 0.59481
            },
            "rightCorner": {
              "x": 22.49,
              "y": 10.306,
              "z": 0.59481
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff582e",
            "leftCorner": {
              "x": 22.49,
              "y": 10.306,
              "z": 0.59481
            },
            "rightCorner": {
              "x": 22.695,
              "y": 10.309,
              "z": 0.59481
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000017"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac3d",
        "height": 0.9643,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5821",
            "leftCorner": {
              "x": 21.784,
              "y": 10.3,
              "z": 0.9643
            },
            "rightCorner": {
              "x": 22.007,
              "y": 10.303,
              "z": 0.9643
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216812672"
          },
          {
            "id": "679afb3d3d9bab0f83ff5822",
            "leftCorner": {
              "x": 22.007,
              "y": 10.303,
              "z": 0.9643
            },
            "rightCorner": {
              "x": 22.193,
              "y": 10.306,
              "z": 0.9643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216713160"
          },
          {
            "id": "679afb3d3d9bab0f83ff5823",
            "leftCorner": {
              "x": 22.193,
              "y": 10.306,
              "z": 0.9643
            },
            "rightCorner": {
              "x": 22.493,
              "y": 10.31,
              "z": 0.9643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216812726"
          },
          {
            "id": "679afb3d3d9bab0f83ff5824",
            "leftCorner": {
              "x": 22.493,
              "y": 10.31,
              "z": 0.9643
            },
            "rightCorner": {
              "x": 22.65,
              "y": 10.313,
              "z": 0.9643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216713436"
          },
          {
            "id": "679afb3d3d9bab0f83ff581c",
            "leftCorner": {
              "x": 22.65,
              "y": 10.313,
              "z": 0.9643
            },
            "rightCorner": {
              "x": 22.699,
              "y": 10.313,
              "z": 0.9643
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac3f",
        "height": 1.4297,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5833",
            "leftCorner": {
              "x": 21.542,
              "y": 10.293,
              "z": 1.4271
            },
            "rightCorner": {
              "x": 21.925,
              "y": 10.294,
              "z": 1.4271
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216207379"
          },
          {
            "id": "679afb3d3d9bab0f83ff5834",
            "leftCorner": {
              "x": 21.948,
              "y": 10.305,
              "z": 1.4297
            },
            "rightCorner": {
              "x": 22.338,
              "y": 10.311,
              "z": 1.4297
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216207324"
          },
          {
            "id": "679afb3d3d9bab0f83ff5835",
            "leftCorner": {
              "x": 22.338,
              "y": 10.311,
              "z": 1.4297
            },
            "rightCorner": {
              "x": 22.509,
              "y": 10.314,
              "z": 1.4297
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216664370"
          },
          {
            "id": "679afb3d3d9bab0f83ff5830",
            "leftCorner": {
              "x": 22.509,
              "y": 10.314,
              "z": 1.4297
            },
            "rightCorner": {
              "x": 22.699,
              "y": 10.317,
              "z": 1.4297
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216664370"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac41",
        "height": 1.7676,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5846",
            "leftCorner": {
              "x": 21.757,
              "y": 10.303,
              "z": 1.7676
            },
            "rightCorner": {
              "x": 21.97,
              "y": 10.306,
              "z": 1.7676
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447114324"
          },
          {
            "id": "679afb3d3d9bab0f83ff5847",
            "leftCorner": {
              "x": 21.97,
              "y": 10.306,
              "z": 1.7676
            },
            "rightCorner": {
              "x": 22.206,
              "y": 10.31,
              "z": 1.7676
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447114348"
          },
          {
            "id": "679afb3d3d9bab0f83ff5848",
            "leftCorner": {
              "x": 22.206,
              "y": 10.31,
              "z": 1.7676
            },
            "rightCorner": {
              "x": 22.426,
              "y": 10.313,
              "z": 1.7676
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064612"
          },
          {
            "id": "679afb3d3d9bab0f83ff5849",
            "leftCorner": {
              "x": 22.426,
              "y": 10.313,
              "z": 1.7676
            },
            "rightCorner": {
              "x": 22.62,
              "y": 10.316,
              "z": 1.7676
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447353501"
          },
          {
            "id": "679afb3d3d9bab0f83ff5840",
            "leftCorner": {
              "x": 22.62,
              "y": 10.316,
              "z": 1.7676
            },
            "rightCorner": {
              "x": 22.699,
              "y": 10.317,
              "z": 1.7676
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 16,
      "unknownStockCount": 9,
      "shelfCategory": "FOOD"
    },
    "name": "FPWP",
    "leftNeighborShelfId": "AQ5L",
    "rightNeighborShelfId": "FAGG"
  },
  {
    "id": "AQ5L",
    "x": 23.667,
    "y": 10.3,
    "width": 1,
    "height": 1.8,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0047501,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac45",
        "height": 0.1982,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff585a",
            "leftCorner": {
              "x": 23.668,
              "y": 10.199,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 23.71,
              "y": 10.199,
              "z": 0.1982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff585c",
            "leftCorner": {
              "x": 23.71,
              "y": 10.199,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 23.901,
              "y": 10.201,
              "z": 0.1982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668650"
          },
          {
            "id": "679afb3d3d9bab0f83ff585d",
            "leftCorner": {
              "x": 23.901,
              "y": 10.201,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 24.093,
              "y": 10.203,
              "z": 0.1982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000019"
          },
          {
            "id": "679afb3d3d9bab0f83ff585e",
            "leftCorner": {
              "x": 24.093,
              "y": 10.203,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 24.325,
              "y": 10.205,
              "z": 0.1982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447668674"
          },
          {
            "id": "679afb3d3d9bab0f83ff585f",
            "leftCorner": {
              "x": 24.325,
              "y": 10.205,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 24.551,
              "y": 10.207,
              "z": 0.1982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668674"
          },
          {
            "id": "679afb3d3d9bab0f83ff585b",
            "leftCorner": {
              "x": 24.551,
              "y": 10.207,
              "z": 0.1982
            },
            "rightCorner": {
              "x": 24.668,
              "y": 10.208,
              "z": 0.1982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac42",
        "height": 0.5911,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff584a",
            "leftCorner": {
              "x": 23.667,
              "y": 10.305,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 23.759,
              "y": 10.305,
              "z": 0.5911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff584c",
            "leftCorner": {
              "x": 23.759,
              "y": 10.305,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 23.934,
              "y": 10.307,
              "z": 0.5911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668599"
          },
          {
            "id": "679afb3d3d9bab0f83ff584d",
            "leftCorner": {
              "x": 23.934,
              "y": 10.307,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 24.157,
              "y": 10.309,
              "z": 0.5911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668612"
          },
          {
            "id": "679afb3d3d9bab0f83ff584e",
            "leftCorner": {
              "x": 24.157,
              "y": 10.309,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 24.342,
              "y": 10.311,
              "z": 0.5911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668612"
          },
          {
            "id": "679afb3d3d9bab0f83ff584f",
            "leftCorner": {
              "x": 24.342,
              "y": 10.311,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 24.534,
              "y": 10.313,
              "z": 0.5911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668636"
          },
          {
            "id": "679afb3d3d9bab0f83ff584b",
            "leftCorner": {
              "x": 24.534,
              "y": 10.313,
              "z": 0.5911
            },
            "rightCorner": {
              "x": 24.667,
              "y": 10.314,
              "z": 0.5911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447668636"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac44",
        "height": 0.96432,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5856",
            "leftCorner": {
              "x": 23.667,
              "y": 10.303,
              "z": 0.96432
            },
            "rightCorner": {
              "x": 23.775,
              "y": 10.304,
              "z": 0.96432
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5858",
            "leftCorner": {
              "x": 23.775,
              "y": 10.304,
              "z": 0.96432
            },
            "rightCorner": {
              "x": 24.088,
              "y": 10.307,
              "z": 0.96432
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216241595"
          },
          {
            "id": "679afb3d3d9bab0f83ff5859",
            "leftCorner": {
              "x": 24.088,
              "y": 10.307,
              "z": 0.96432
            },
            "rightCorner": {
              "x": 24.437,
              "y": 10.311,
              "z": 0.96432
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216241564"
          },
          {
            "id": "679afb3d3d9bab0f83ff5857",
            "leftCorner": {
              "x": 24.437,
              "y": 10.311,
              "z": 0.96432
            },
            "rightCorner": {
              "x": 24.667,
              "y": 10.313,
              "z": 0.96432
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216241526"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac43",
        "height": 1.4328,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5850",
            "leftCorner": {
              "x": 23.667,
              "y": 10.305,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 23.777,
              "y": 10.306,
              "z": 1.4328
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5852",
            "leftCorner": {
              "x": 23.777,
              "y": 10.306,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 23.977,
              "y": 10.308,
              "z": 1.4328
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216670500"
          },
          {
            "id": "679afb3d3d9bab0f83ff5853",
            "leftCorner": {
              "x": 23.977,
              "y": 10.308,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 24.161,
              "y": 10.309,
              "z": 1.4328
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216670685"
          },
          {
            "id": "679afb3d3d9bab0f83ff5854",
            "leftCorner": {
              "x": 24.161,
              "y": 10.309,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 24.376,
              "y": 10.311,
              "z": 1.4328
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216670647"
          },
          {
            "id": "679afb3d3d9bab0f83ff5855",
            "leftCorner": {
              "x": 24.376,
              "y": 10.311,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 24.535,
              "y": 10.313,
              "z": 1.4328
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5851",
            "leftCorner": {
              "x": 24.535,
              "y": 10.313,
              "z": 1.4328
            },
            "rightCorner": {
              "x": 24.667,
              "y": 10.314,
              "z": 1.4328
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540711477"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac46",
        "height": 1.7699,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5861",
            "leftCorner": {
              "x": 23.687,
              "y": 10.305,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 23.813,
              "y": 10.306,
              "z": 1.7699
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674200"
          },
          {
            "id": "679afb3d3d9bab0f83ff5862",
            "leftCorner": {
              "x": 23.813,
              "y": 10.306,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 23.93,
              "y": 10.307,
              "z": 1.7699
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674200"
          },
          {
            "id": "679afb3d3d9bab0f83ff5863",
            "leftCorner": {
              "x": 23.93,
              "y": 10.307,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.036,
              "y": 10.308,
              "z": 1.7699
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674224"
          },
          {
            "id": "679afb3d3d9bab0f83ff5864",
            "leftCorner": {
              "x": 24.036,
              "y": 10.308,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.185,
              "y": 10.31,
              "z": 1.7699
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674224"
          },
          {
            "id": "679afb3d3d9bab0f83ff5865",
            "leftCorner": {
              "x": 24.185,
              "y": 10.31,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.317,
              "y": 10.311,
              "z": 1.7699
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053527598"
          },
          {
            "id": "679afb3d3d9bab0f83ff5866",
            "leftCorner": {
              "x": 24.317,
              "y": 10.311,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.455,
              "y": 10.312,
              "z": 1.7699
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053527574"
          },
          {
            "id": "679afb3d3d9bab0f83ff5867",
            "leftCorner": {
              "x": 24.455,
              "y": 10.312,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.587,
              "y": 10.314,
              "z": 1.7699
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053527581"
          },
          {
            "id": "679afb3d3d9bab0f83ff5860",
            "leftCorner": {
              "x": 24.587,
              "y": 10.314,
              "z": 1.7699
            },
            "rightCorner": {
              "x": 24.667,
              "y": 10.314,
              "z": 1.7699
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053527604"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 17,
      "unknownStockCount": 13,
      "shelfCategory": "FOOD"
    },
    "name": "AQ5L",
    "leftNeighborShelfId": "ASWH"
  },
  {
    "id": "HMHR",
    "x": 23.664,
    "y": 11.766,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": -0.003423
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac4c",
        "height": 0.19705,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58d2",
            "leftCorner": {
              "x": 23.663,
              "y": 11.864,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.625,
              "y": 11.864,
              "z": 0.19705
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d4",
            "leftCorner": {
              "x": 23.625,
              "y": 11.864,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.529,
              "y": 11.863,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300325111"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d5",
            "leftCorner": {
              "x": 23.529,
              "y": 11.863,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.439,
              "y": 11.863,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300325050"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d6",
            "leftCorner": {
              "x": 23.439,
              "y": 11.863,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.287,
              "y": 11.862,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447087727"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d7",
            "leftCorner": {
              "x": 23.287,
              "y": 11.862,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.147,
              "y": 11.861,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796082272"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d8",
            "leftCorner": {
              "x": 23.147,
              "y": 11.861,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 23.013,
              "y": 11.86,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447349801"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d9",
            "leftCorner": {
              "x": 23.013,
              "y": 11.86,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 22.876,
              "y": 11.859,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447349801"
          },
          {
            "id": "679afb3d3d9bab0f83ff58da",
            "leftCorner": {
              "x": 22.876,
              "y": 11.859,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 22.726,
              "y": 11.858,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001723"
          },
          {
            "id": "679afb3d3d9bab0f83ff58db",
            "leftCorner": {
              "x": 22.726,
              "y": 11.858,
              "z": 0.19705
            },
            "rightCorner": {
              "x": 22.562,
              "y": 11.857,
              "z": 0.19705
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001723"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac4a",
        "height": 0.4613,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58aa",
            "leftCorner": {
              "x": 23.631,
              "y": 11.753,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.553,
              "y": 11.753,
              "z": 0.4613
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447658248"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ab",
            "leftCorner": {
              "x": 23.553,
              "y": 11.753,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.466,
              "y": 11.752,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447658248"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ac",
            "leftCorner": {
              "x": 23.466,
              "y": 11.752,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.382,
              "y": 11.752,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300278547"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ad",
            "leftCorner": {
              "x": 23.382,
              "y": 11.752,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.298,
              "y": 11.751,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300342811"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ae",
            "leftCorner": {
              "x": 23.298,
              "y": 11.751,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.22,
              "y": 11.751,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300278578"
          },
          {
            "id": "679afb3d3d9bab0f83ff58af",
            "leftCorner": {
              "x": 23.22,
              "y": 11.751,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.139,
              "y": 11.75,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300432123"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b0",
            "leftCorner": {
              "x": 23.139,
              "y": 11.75,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 23.059,
              "y": 11.749,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300278530"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b1",
            "leftCorner": {
              "x": 23.059,
              "y": 11.749,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 22.931,
              "y": 11.749,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584110"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b2",
            "leftCorner": {
              "x": 22.931,
              "y": 11.749,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 22.799,
              "y": 11.748,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584110"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b3",
            "leftCorner": {
              "x": 22.799,
              "y": 11.748,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 22.655,
              "y": 11.747,
              "z": 0.4613
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447584110"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac48",
        "height": 0.67129,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5885",
            "leftCorner": {
              "x": 23.664,
              "y": 11.753,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.62,
              "y": 11.752,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260133232723"
          },
          {
            "id": "679afb3d3d9bab0f83ff5887",
            "leftCorner": {
              "x": 23.62,
              "y": 11.752,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.526,
              "y": 11.752,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232723"
          },
          {
            "id": "679afb3d3d9bab0f83ff5888",
            "leftCorner": {
              "x": 23.526,
              "y": 11.752,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.443,
              "y": 11.751,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231870"
          },
          {
            "id": "679afb3d3d9bab0f83ff5889",
            "leftCorner": {
              "x": 23.443,
              "y": 11.751,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.362,
              "y": 11.75,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232501"
          },
          {
            "id": "679afb3d3d9bab0f83ff588a",
            "leftCorner": {
              "x": 23.362,
              "y": 11.75,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.23,
              "y": 11.75,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff588b",
            "leftCorner": {
              "x": 23.23,
              "y": 11.75,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.109,
              "y": 11.749,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4018852036630"
          },
          {
            "id": "679afb3d3d9bab0f83ff588c",
            "leftCorner": {
              "x": 23.109,
              "y": 11.749,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 23.003,
              "y": 11.748,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232341"
          },
          {
            "id": "679afb3d3d9bab0f83ff588d",
            "leftCorner": {
              "x": 23.003,
              "y": 11.748,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 22.895,
              "y": 11.747,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232341"
          },
          {
            "id": "679afb3d3d9bab0f83ff588e",
            "leftCorner": {
              "x": 22.895,
              "y": 11.747,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 22.751,
              "y": 11.746,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac4b",
        "height": 0.87894,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58bb",
            "leftCorner": {
              "x": 23.642,
              "y": 11.757,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.558,
              "y": 11.756,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235175"
          },
          {
            "id": "679afb3d3d9bab0f83ff58bc",
            "leftCorner": {
              "x": 23.558,
              "y": 11.756,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.479,
              "y": 11.756,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235175"
          },
          {
            "id": "679afb3d3d9bab0f83ff58bd",
            "leftCorner": {
              "x": 23.479,
              "y": 11.756,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.401,
              "y": 11.755,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235205"
          },
          {
            "id": "679afb3d3d9bab0f83ff58be",
            "leftCorner": {
              "x": 23.401,
              "y": 11.755,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.318,
              "y": 11.754,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235199"
          },
          {
            "id": "679afb3d3d9bab0f83ff58bf",
            "leftCorner": {
              "x": 23.318,
              "y": 11.754,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.239,
              "y": 11.754,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133235199"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c0",
            "leftCorner": {
              "x": 23.239,
              "y": 11.754,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.157,
              "y": 11.753,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232648"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c1",
            "leftCorner": {
              "x": 23.157,
              "y": 11.753,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 23.077,
              "y": 11.753,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232648"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c2",
            "leftCorner": {
              "x": 23.077,
              "y": 11.753,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 22.997,
              "y": 11.752,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232587"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c3",
            "leftCorner": {
              "x": 22.997,
              "y": 11.752,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 22.915,
              "y": 11.752,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231900"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c4",
            "leftCorner": {
              "x": 22.915,
              "y": 11.752,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 22.834,
              "y": 11.751,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232464"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c5",
            "leftCorner": {
              "x": 22.834,
              "y": 11.751,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 22.745,
              "y": 11.751,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231818"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c6",
            "leftCorner": {
              "x": 22.745,
              "y": 11.751,
              "z": 0.87894
            },
            "rightCorner": {
              "x": 22.62,
              "y": 11.75,
              "z": 0.87894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300446069"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac47",
        "height": 1.0896,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5869",
            "leftCorner": {
              "x": 23.643,
              "y": 11.751,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.564,
              "y": 11.75,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249140103"
          },
          {
            "id": "679afb3d3d9bab0f83ff586a",
            "leftCorner": {
              "x": 23.564,
              "y": 11.75,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.491,
              "y": 11.75,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249147126"
          },
          {
            "id": "679afb3d3d9bab0f83ff586b",
            "leftCorner": {
              "x": 23.491,
              "y": 11.75,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.415,
              "y": 11.749,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249143647"
          },
          {
            "id": "679afb3d3d9bab0f83ff586c",
            "leftCorner": {
              "x": 23.415,
              "y": 11.749,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.336,
              "y": 11.748,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249143647"
          },
          {
            "id": "679afb3d3d9bab0f83ff586d",
            "leftCorner": {
              "x": 23.336,
              "y": 11.748,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.257,
              "y": 11.748,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260618528600"
          },
          {
            "id": "679afb3d3d9bab0f83ff586e",
            "leftCorner": {
              "x": 23.257,
              "y": 11.748,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.18,
              "y": 11.747,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249142329"
          },
          {
            "id": "679afb3d3d9bab0f83ff586f",
            "leftCorner": {
              "x": 23.18,
              "y": 11.747,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.105,
              "y": 11.747,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249142329"
          },
          {
            "id": "679afb3d3d9bab0f83ff5870",
            "leftCorner": {
              "x": 23.105,
              "y": 11.747,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 23.029,
              "y": 11.746,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367681568"
          },
          {
            "id": "679afb3d3d9bab0f83ff5871",
            "leftCorner": {
              "x": 23.029,
              "y": 11.746,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.954,
              "y": 11.746,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367681605"
          },
          {
            "id": "679afb3d3d9bab0f83ff5872",
            "leftCorner": {
              "x": 22.954,
              "y": 11.746,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.872,
              "y": 11.745,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367681582"
          },
          {
            "id": "679afb3d3d9bab0f83ff5873",
            "leftCorner": {
              "x": 22.872,
              "y": 11.745,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.826,
              "y": 11.745,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447114140"
          },
          {
            "id": "679afb3d3d9bab0f83ff5874",
            "leftCorner": {
              "x": 22.826,
              "y": 11.745,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.738,
              "y": 11.744,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447112931"
          },
          {
            "id": "679afb3d3d9bab0f83ff5875",
            "leftCorner": {
              "x": 22.738,
              "y": 11.744,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.662,
              "y": 11.744,
              "z": 1.0896
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355857"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac49",
        "height": 1.2998,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5898",
            "leftCorner": {
              "x": 23.664,
              "y": 11.75,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 23.604,
              "y": 11.749,
              "z": 1.2998
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff589a",
            "leftCorner": {
              "x": 23.604,
              "y": 11.749,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 23.498,
              "y": 11.749,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852028413"
          },
          {
            "id": "679afb3d3d9bab0f83ff589b",
            "leftCorner": {
              "x": 23.498,
              "y": 11.749,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 23.393,
              "y": 11.748,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852028413"
          },
          {
            "id": "679afb3d3d9bab0f83ff589c",
            "leftCorner": {
              "x": 23.393,
              "y": 11.748,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 23.286,
              "y": 11.747,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff589d",
            "leftCorner": {
              "x": 23.286,
              "y": 11.747,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 23.092,
              "y": 11.746,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852016861"
          },
          {
            "id": "679afb3d3d9bab0f83ff589e",
            "leftCorner": {
              "x": 23.092,
              "y": 11.746,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 22.975,
              "y": 11.745,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002409"
          },
          {
            "id": "679afb3d3d9bab0f83ff589f",
            "leftCorner": {
              "x": 22.975,
              "y": 11.745,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 22.863,
              "y": 11.744,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002409"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a0",
            "leftCorner": {
              "x": 22.863,
              "y": 11.744,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 22.729,
              "y": 11.743,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a1",
            "leftCorner": {
              "x": 22.729,
              "y": 11.743,
              "z": 1.2998
            },
            "rightCorner": {
              "x": 22.579,
              "y": 11.742,
              "z": 1.2998
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172783357"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac4d",
        "height": 1.512,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58e1",
            "leftCorner": {
              "x": 23.664,
              "y": 11.751,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.605,
              "y": 11.75,
              "z": 1.512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300289437"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e3",
            "leftCorner": {
              "x": 23.605,
              "y": 11.75,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.493,
              "y": 11.75,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300289437"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e4",
            "leftCorner": {
              "x": 23.493,
              "y": 11.75,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.385,
              "y": 11.749,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300450097"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e5",
            "leftCorner": {
              "x": 23.385,
              "y": 11.749,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.278,
              "y": 11.748,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300450097"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e6",
            "leftCorner": {
              "x": 23.278,
              "y": 11.748,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.17,
              "y": 11.747,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300413597"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e7",
            "leftCorner": {
              "x": 23.17,
              "y": 11.747,
              "z": 1.512
            },
            "rightCorner": {
              "x": 23.056,
              "y": 11.747,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172425820"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e8",
            "leftCorner": {
              "x": 23.056,
              "y": 11.747,
              "z": 1.512
            },
            "rightCorner": {
              "x": 22.942,
              "y": 11.746,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172425820"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e9",
            "leftCorner": {
              "x": 22.942,
              "y": 11.746,
              "z": 1.512
            },
            "rightCorner": {
              "x": 22.801,
              "y": 11.745,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232754"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ea",
            "leftCorner": {
              "x": 22.801,
              "y": 11.745,
              "z": 1.512
            },
            "rightCorner": {
              "x": 22.67,
              "y": 11.744,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac4e",
        "height": 1.7259,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58f3",
            "leftCorner": {
              "x": 23.645,
              "y": 11.752,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.56,
              "y": 11.751,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447711424"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f4",
            "leftCorner": {
              "x": 23.56,
              "y": 11.751,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.476,
              "y": 11.75,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447711424"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f5",
            "leftCorner": {
              "x": 23.476,
              "y": 11.75,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.376,
              "y": 11.75,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796035650"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f6",
            "leftCorner": {
              "x": 23.376,
              "y": 11.75,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.266,
              "y": 11.749,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796035650"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f7",
            "leftCorner": {
              "x": 23.266,
              "y": 11.749,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.166,
              "y": 11.748,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447569988"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f8",
            "leftCorner": {
              "x": 23.166,
              "y": 11.748,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 23.063,
              "y": 11.748,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447569988"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f9",
            "leftCorner": {
              "x": 23.063,
              "y": 11.748,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 22.966,
              "y": 11.747,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251099603900"
          },
          {
            "id": "679afb3d3d9bab0f83ff58fa",
            "leftCorner": {
              "x": 22.966,
              "y": 11.747,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 22.867,
              "y": 11.746,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251099603900"
          },
          {
            "id": "679afb3d3d9bab0f83ff58fb",
            "leftCorner": {
              "x": 22.867,
              "y": 11.746,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 22.766,
              "y": 11.746,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251099707219"
          },
          {
            "id": "679afb3d3d9bab0f83ff58fc",
            "leftCorner": {
              "x": 22.766,
              "y": 11.746,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 22.663,
              "y": 11.745,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251099707219"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 74,
      "unknownStockCount": 6,
      "shelfCategory": "FOOD"
    },
    "name": "HMHR",
    "leftNeighborShelfId": "QUSR"
  },
  {
    "id": "ZZOW",
    "x": 22.693,
    "y": 11.759,
    "width": 1,
    "height": 2,
    "depth": 0.769,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99992,
      "w": -0.012637
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac55",
        "height": 0.19922,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58dc",
            "leftCorner": {
              "x": 22.588,
              "y": 11.86,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 22.454,
              "y": 11.857,
              "z": 0.19922
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208962"
          },
          {
            "id": "679afb3d3d9bab0f83ff58dd",
            "leftCorner": {
              "x": 22.454,
              "y": 11.857,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 22.329,
              "y": 11.854,
              "z": 0.19922
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208962"
          },
          {
            "id": "679afb3d3d9bab0f83ff58de",
            "leftCorner": {
              "x": 22.329,
              "y": 11.854,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 22.151,
              "y": 11.849,
              "z": 0.19922
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260208910891"
          },
          {
            "id": "679afb3d3d9bab0f83ff58df",
            "leftCorner": {
              "x": 22.151,
              "y": 11.849,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 21.966,
              "y": 11.844,
              "z": 0.19922
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260208910891"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e0",
            "leftCorner": {
              "x": 21.966,
              "y": 11.844,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 21.826,
              "y": 11.841,
              "z": 0.19922
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260208910846"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d3",
            "leftCorner": {
              "x": 21.826,
              "y": 11.841,
              "z": 0.19922
            },
            "rightCorner": {
              "x": 21.69,
              "y": 11.838,
              "z": 0.19922
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260208910846"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac50",
        "height": 0.46226,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58b4",
            "leftCorner": {
              "x": 22.655,
              "y": 11.747,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 22.496,
              "y": 11.746,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584097"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b5",
            "leftCorner": {
              "x": 22.524,
              "y": 11.751,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 22.406,
              "y": 11.748,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584097"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b6",
            "leftCorner": {
              "x": 22.406,
              "y": 11.748,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 22.271,
              "y": 11.745,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373257"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b7",
            "leftCorner": {
              "x": 22.271,
              "y": 11.745,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 22.15,
              "y": 11.742,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373257"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b8",
            "leftCorner": {
              "x": 22.15,
              "y": 11.742,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 22.02,
              "y": 11.738,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300376199"
          },
          {
            "id": "679afb3d3d9bab0f83ff58b9",
            "leftCorner": {
              "x": 22.02,
              "y": 11.738,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 21.894,
              "y": 11.735,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ba",
            "leftCorner": {
              "x": 21.894,
              "y": 11.735,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 21.754,
              "y": 11.732,
              "z": 0.46226
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300376182"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a9",
            "leftCorner": {
              "x": 21.754,
              "y": 11.732,
              "z": 0.46226
            },
            "rightCorner": {
              "x": 21.693,
              "y": 11.73,
              "z": 0.46226
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300376182"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac51",
        "height": 0.673,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff588f",
            "leftCorner": {
              "x": 22.751,
              "y": 11.746,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 22.59,
              "y": 11.745,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236387"
          },
          {
            "id": "679afb3d3d9bab0f83ff5890",
            "leftCorner": {
              "x": 22.618,
              "y": 11.751,
              "z": 0.673
            },
            "rightCorner": {
              "x": 22.509,
              "y": 11.748,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236387"
          },
          {
            "id": "679afb3d3d9bab0f83ff5891",
            "leftCorner": {
              "x": 22.509,
              "y": 11.748,
              "z": 0.673
            },
            "rightCorner": {
              "x": 22.393,
              "y": 11.745,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236325"
          },
          {
            "id": "679afb3d3d9bab0f83ff5892",
            "leftCorner": {
              "x": 22.393,
              "y": 11.745,
              "z": 0.673
            },
            "rightCorner": {
              "x": 22.282,
              "y": 11.742,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236127"
          },
          {
            "id": "679afb3d3d9bab0f83ff5893",
            "leftCorner": {
              "x": 22.282,
              "y": 11.742,
              "z": 0.673
            },
            "rightCorner": {
              "x": 22.173,
              "y": 11.74,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236127"
          },
          {
            "id": "679afb3d3d9bab0f83ff5894",
            "leftCorner": {
              "x": 22.173,
              "y": 11.74,
              "z": 0.673
            },
            "rightCorner": {
              "x": 22.059,
              "y": 11.737,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232259"
          },
          {
            "id": "679afb3d3d9bab0f83ff5895",
            "leftCorner": {
              "x": 22.059,
              "y": 11.737,
              "z": 0.673
            },
            "rightCorner": {
              "x": 21.95,
              "y": 11.734,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234550"
          },
          {
            "id": "679afb3d3d9bab0f83ff5896",
            "leftCorner": {
              "x": 21.95,
              "y": 11.734,
              "z": 0.673
            },
            "rightCorner": {
              "x": 21.842,
              "y": 11.731,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234550"
          },
          {
            "id": "679afb3d3d9bab0f83ff5897",
            "leftCorner": {
              "x": 21.842,
              "y": 11.731,
              "z": 0.673
            },
            "rightCorner": {
              "x": 21.73,
              "y": 11.729,
              "z": 0.673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231351"
          },
          {
            "id": "679afb3d3d9bab0f83ff5886",
            "leftCorner": {
              "x": 21.73,
              "y": 11.729,
              "z": 0.673
            },
            "rightCorner": {
              "x": 21.693,
              "y": 11.728,
              "z": 0.673
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260133231351"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac4f",
        "height": 0.88083,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58c7",
            "leftCorner": {
              "x": 22.648,
              "y": 11.757,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.549,
              "y": 11.754,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300362239"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c8",
            "leftCorner": {
              "x": 22.549,
              "y": 11.754,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.446,
              "y": 11.751,
              "z": 0.88083
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062300362277"
          },
          {
            "id": "679afb3d3d9bab0f83ff58c9",
            "leftCorner": {
              "x": 22.446,
              "y": 11.751,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.363,
              "y": 11.749,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300362260"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ca",
            "leftCorner": {
              "x": 22.363,
              "y": 11.749,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.265,
              "y": 11.747,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58cb",
            "leftCorner": {
              "x": 22.265,
              "y": 11.747,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.164,
              "y": 11.744,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300444737"
          },
          {
            "id": "679afb3d3d9bab0f83ff58cc",
            "leftCorner": {
              "x": 22.164,
              "y": 11.744,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 22.078,
              "y": 11.742,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236431"
          },
          {
            "id": "679afb3d3d9bab0f83ff58cd",
            "leftCorner": {
              "x": 22.078,
              "y": 11.742,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 21.99,
              "y": 11.74,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231238"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ce",
            "leftCorner": {
              "x": 21.99,
              "y": 11.74,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 21.907,
              "y": 11.738,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231252"
          },
          {
            "id": "679afb3d3d9bab0f83ff58cf",
            "leftCorner": {
              "x": 21.907,
              "y": 11.738,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 21.798,
              "y": 11.735,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133230750"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d0",
            "leftCorner": {
              "x": 21.798,
              "y": 11.735,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 21.744,
              "y": 11.734,
              "z": 0.88083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231375"
          },
          {
            "id": "679afb3d3d9bab0f83ff58d1",
            "leftCorner": {
              "x": 21.744,
              "y": 11.734,
              "z": 0.88083
            },
            "rightCorner": {
              "x": 21.691,
              "y": 11.732,
              "z": 0.88083
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260133231375"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac54",
        "height": 1.0902,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5876",
            "leftCorner": {
              "x": 22.662,
              "y": 11.744,
              "z": 1.0896
            },
            "rightCorner": {
              "x": 22.584,
              "y": 11.743,
              "z": 1.0896
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447112894"
          },
          {
            "id": "679afb3d3d9bab0f83ff5877",
            "leftCorner": {
              "x": 22.612,
              "y": 11.75,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.564,
              "y": 11.749,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447112894"
          },
          {
            "id": "679afb3d3d9bab0f83ff5878",
            "leftCorner": {
              "x": 22.564,
              "y": 11.749,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.477,
              "y": 11.747,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447416299"
          },
          {
            "id": "679afb3d3d9bab0f83ff5879",
            "leftCorner": {
              "x": 22.477,
              "y": 11.747,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.383,
              "y": 11.744,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447416299"
          },
          {
            "id": "679afb3d3d9bab0f83ff587a",
            "leftCorner": {
              "x": 22.383,
              "y": 11.744,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.288,
              "y": 11.742,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447416299"
          },
          {
            "id": "679afb3d3d9bab0f83ff587b",
            "leftCorner": {
              "x": 22.288,
              "y": 11.742,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.241,
              "y": 11.741,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447191394"
          },
          {
            "id": "679afb3d3d9bab0f83ff587c",
            "leftCorner": {
              "x": 22.241,
              "y": 11.741,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.195,
              "y": 11.74,
              "z": 1.0902
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796161885"
          },
          {
            "id": "679afb3d3d9bab0f83ff587d",
            "leftCorner": {
              "x": 22.195,
              "y": 11.74,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.141,
              "y": 11.738,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796161885"
          },
          {
            "id": "679afb3d3d9bab0f83ff587e",
            "leftCorner": {
              "x": 22.141,
              "y": 11.738,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.088,
              "y": 11.737,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447191370"
          },
          {
            "id": "679afb3d3d9bab0f83ff587f",
            "leftCorner": {
              "x": 22.088,
              "y": 11.737,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 22.042,
              "y": 11.736,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208931"
          },
          {
            "id": "679afb3d3d9bab0f83ff5880",
            "leftCorner": {
              "x": 22.042,
              "y": 11.736,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.992,
              "y": 11.734,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257151"
          },
          {
            "id": "679afb3d3d9bab0f83ff5881",
            "leftCorner": {
              "x": 21.992,
              "y": 11.734,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.945,
              "y": 11.733,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447257168"
          },
          {
            "id": "679afb3d3d9bab0f83ff5882",
            "leftCorner": {
              "x": 21.945,
              "y": 11.733,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.898,
              "y": 11.732,
              "z": 1.0902
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447191363"
          },
          {
            "id": "679afb3d3d9bab0f83ff5883",
            "leftCorner": {
              "x": 21.898,
              "y": 11.732,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.851,
              "y": 11.731,
              "z": 1.0902
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447191363"
          },
          {
            "id": "679afb3d3d9bab0f83ff5884",
            "leftCorner": {
              "x": 21.851,
              "y": 11.731,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.755,
              "y": 11.728,
              "z": 1.0902
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852026969"
          },
          {
            "id": "679afb3d3d9bab0f83ff5868",
            "leftCorner": {
              "x": 21.755,
              "y": 11.728,
              "z": 1.0902
            },
            "rightCorner": {
              "x": 21.693,
              "y": 11.727,
              "z": 1.0902
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4018852029175"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac52",
        "height": 1.3017,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58a2",
            "leftCorner": {
              "x": 22.608,
              "y": 11.748,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 22.464,
              "y": 11.745,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232037"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a3",
            "leftCorner": {
              "x": 22.464,
              "y": 11.745,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 22.344,
              "y": 11.742,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133232037"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a4",
            "leftCorner": {
              "x": 22.344,
              "y": 11.742,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 22.235,
              "y": 11.739,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133230736"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a5",
            "leftCorner": {
              "x": 22.235,
              "y": 11.739,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 22.116,
              "y": 11.736,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133230736"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a6",
            "leftCorner": {
              "x": 22.116,
              "y": 11.736,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 21.988,
              "y": 11.733,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a7",
            "leftCorner": {
              "x": 21.988,
              "y": 11.733,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 21.86,
              "y": 11.729,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133233812"
          },
          {
            "id": "679afb3d3d9bab0f83ff58a8",
            "leftCorner": {
              "x": 21.86,
              "y": 11.729,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 21.741,
              "y": 11.726,
              "z": 1.3017
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120111881518"
          },
          {
            "id": "679afb3d3d9bab0f83ff5899",
            "leftCorner": {
              "x": 21.741,
              "y": 11.726,
              "z": 1.3017
            },
            "rightCorner": {
              "x": 21.693,
              "y": 11.725,
              "z": 1.3017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9120111881518"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac56",
        "height": 1.5144,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58eb",
            "leftCorner": {
              "x": 22.67,
              "y": 11.744,
              "z": 1.512
            },
            "rightCorner": {
              "x": 22.514,
              "y": 11.743,
              "z": 1.512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260249140530"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ec",
            "leftCorner": {
              "x": 22.543,
              "y": 11.75,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 22.425,
              "y": 11.747,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ed",
            "leftCorner": {
              "x": 22.425,
              "y": 11.747,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 22.321,
              "y": 11.744,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367680325"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ee",
            "leftCorner": {
              "x": 22.321,
              "y": 11.744,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 22.222,
              "y": 11.742,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367680325"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ef",
            "leftCorner": {
              "x": 22.222,
              "y": 11.742,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 22.112,
              "y": 11.739,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260618526033"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f0",
            "leftCorner": {
              "x": 22.112,
              "y": 11.739,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 22.007,
              "y": 11.736,
              "z": 1.5144
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260618526033"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f1",
            "leftCorner": {
              "x": 22.007,
              "y": 11.736,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 21.89,
              "y": 11.733,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff58f2",
            "leftCorner": {
              "x": 21.89,
              "y": 11.733,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 21.764,
              "y": 11.73,
              "z": 1.5144
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260618523186"
          },
          {
            "id": "679afb3d3d9bab0f83ff58e2",
            "leftCorner": {
              "x": 21.764,
              "y": 11.73,
              "z": 1.5144
            },
            "rightCorner": {
              "x": 21.693,
              "y": 11.729,
              "z": 1.5144
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac53",
        "height": 1.7282,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff58fd",
            "leftCorner": {
              "x": 22.663,
              "y": 11.745,
              "z": 1.7259
            },
            "rightCorner": {
              "x": 22.491,
              "y": 11.744,
              "z": 1.7259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234918"
          },
          {
            "id": "679afb3d3d9bab0f83ff58fe",
            "leftCorner": {
              "x": 22.52,
              "y": 11.746,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 22.394,
              "y": 11.743,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234918"
          },
          {
            "id": "679afb3d3d9bab0f83ff58ff",
            "leftCorner": {
              "x": 22.394,
              "y": 11.743,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 22.297,
              "y": 11.74,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133231290"
          },
          {
            "id": "679afb3d3d9bab0f83ff5900",
            "leftCorner": {
              "x": 22.297,
              "y": 11.74,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 22.203,
              "y": 11.738,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133236264"
          },
          {
            "id": "679afb3d3d9bab0f83ff5901",
            "leftCorner": {
              "x": 22.203,
              "y": 11.738,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 22.101,
              "y": 11.735,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133233324"
          },
          {
            "id": "679afb3d3d9bab0f83ff5902",
            "leftCorner": {
              "x": 22.101,
              "y": 11.735,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 21.994,
              "y": 11.733,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234789"
          },
          {
            "id": "679afb3d3d9bab0f83ff5903",
            "leftCorner": {
              "x": 21.994,
              "y": 11.733,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 21.897,
              "y": 11.73,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260133234574"
          },
          {
            "id": "679afb3d3d9bab0f83ff5904",
            "leftCorner": {
              "x": 21.897,
              "y": 11.73,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 21.806,
              "y": 11.728,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262367681209"
          },
          {
            "id": "679afb3d3d9bab0f83ff5905",
            "leftCorner": {
              "x": 21.806,
              "y": 11.728,
              "z": 1.7282
            },
            "rightCorner": {
              "x": 21.701,
              "y": 11.725,
              "z": 1.7282
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260311983423"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 63,
      "unknownStockCount": 13,
      "shelfCategory": "FOOD"
    },
    "name": "ZZOW",
    "leftNeighborShelfId": "HMHR"
  },
  {
    "id": "OKVD",
    "x": 21.176,
    "y": 14.02,
    "width": 1.25,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0052264,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac59",
        "height": 0.20903,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5944",
            "leftCorner": {
              "x": 21.177,
              "y": 13.916,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.296,
              "y": 13.917,
              "z": 0.20903
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447175721"
          },
          {
            "id": "679afb3e3d9bab0f83ff5946",
            "leftCorner": {
              "x": 21.296,
              "y": 13.917,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.419,
              "y": 13.918,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175721"
          },
          {
            "id": "679afb3e3d9bab0f83ff5947",
            "leftCorner": {
              "x": 21.419,
              "y": 13.918,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.54,
              "y": 13.919,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175721"
          },
          {
            "id": "679afb3e3d9bab0f83ff5948",
            "leftCorner": {
              "x": 21.54,
              "y": 13.919,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.68,
              "y": 13.921,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447175745"
          },
          {
            "id": "679afb3e3d9bab0f83ff5949",
            "leftCorner": {
              "x": 21.68,
              "y": 13.921,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.815,
              "y": 13.922,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208085"
          },
          {
            "id": "679afb3e3d9bab0f83ff594a",
            "leftCorner": {
              "x": 21.815,
              "y": 13.922,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 21.942,
              "y": 13.924,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208108"
          },
          {
            "id": "679afb3e3d9bab0f83ff594b",
            "leftCorner": {
              "x": 21.942,
              "y": 13.924,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 22.073,
              "y": 13.925,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208108"
          },
          {
            "id": "679afb3e3d9bab0f83ff594c",
            "leftCorner": {
              "x": 22.073,
              "y": 13.925,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 22.201,
              "y": 13.926,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447088120"
          },
          {
            "id": "679afb3e3d9bab0f83ff594d",
            "leftCorner": {
              "x": 22.201,
              "y": 13.926,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 22.33,
              "y": 13.928,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029762"
          },
          {
            "id": "679afb3e3d9bab0f83ff594e",
            "leftCorner": {
              "x": 22.33,
              "y": 13.928,
              "z": 0.20903
            },
            "rightCorner": {
              "x": 22.427,
              "y": 13.929,
              "z": 0.20903
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac58",
        "height": 0.55659,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5923",
            "leftCorner": {
              "x": 21.176,
              "y": 14.023,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.314,
              "y": 14.025,
              "z": 0.55659
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8445290945648"
          },
          {
            "id": "679afb3d3d9bab0f83ff5925",
            "leftCorner": {
              "x": 21.314,
              "y": 14.025,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.371,
              "y": 14.025,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290064868"
          },
          {
            "id": "679afb3d3d9bab0f83ff5926",
            "leftCorner": {
              "x": 21.371,
              "y": 14.025,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.426,
              "y": 14.026,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290064868"
          },
          {
            "id": "679afb3d3d9bab0f83ff5927",
            "leftCorner": {
              "x": 21.426,
              "y": 14.026,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.565,
              "y": 14.027,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290917751"
          },
          {
            "id": "679afb3d3d9bab0f83ff5928",
            "leftCorner": {
              "x": 21.565,
              "y": 14.027,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.723,
              "y": 14.029,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290917607"
          },
          {
            "id": "679afb3d3d9bab0f83ff5929",
            "leftCorner": {
              "x": 21.723,
              "y": 14.029,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.78,
              "y": 14.029,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290064707"
          },
          {
            "id": "679afb3d3d9bab0f83ff592a",
            "leftCorner": {
              "x": 21.78,
              "y": 14.029,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.835,
              "y": 14.03,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290064707"
          },
          {
            "id": "679afb3d3d9bab0f83ff592b",
            "leftCorner": {
              "x": 21.835,
              "y": 14.03,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 21.885,
              "y": 14.031,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290478153"
          },
          {
            "id": "679afb3d3d9bab0f83ff592c",
            "leftCorner": {
              "x": 21.885,
              "y": 14.031,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 22.022,
              "y": 14.032,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291643635"
          },
          {
            "id": "679afb3d3d9bab0f83ff592d",
            "leftCorner": {
              "x": 22.022,
              "y": 14.032,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 22.164,
              "y": 14.033,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291643635"
          },
          {
            "id": "679afb3d3d9bab0f83ff592e",
            "leftCorner": {
              "x": 22.164,
              "y": 14.033,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 22.302,
              "y": 14.035,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463582"
          },
          {
            "id": "679afb3d3d9bab0f83ff592f",
            "leftCorner": {
              "x": 22.302,
              "y": 14.035,
              "z": 0.55659
            },
            "rightCorner": {
              "x": 22.423,
              "y": 14.036,
              "z": 0.55659
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613287226631"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5b",
        "height": 0.84836,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59c0",
            "leftCorner": {
              "x": 21.176,
              "y": 14.026,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.248,
              "y": 14.027,
              "z": 0.84836
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4056631002438"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c2",
            "leftCorner": {
              "x": 21.248,
              "y": 14.027,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.372,
              "y": 14.028,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c3",
            "leftCorner": {
              "x": 21.372,
              "y": 14.028,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.502,
              "y": 14.03,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001240"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c4",
            "leftCorner": {
              "x": 21.502,
              "y": 14.03,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.624,
              "y": 14.031,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001240"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c5",
            "leftCorner": {
              "x": 21.624,
              "y": 14.031,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.784,
              "y": 14.032,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003725"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c6",
            "leftCorner": {
              "x": 21.784,
              "y": 14.032,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 21.925,
              "y": 14.034,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003725"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c7",
            "leftCorner": {
              "x": 21.925,
              "y": 14.034,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 22.061,
              "y": 14.035,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001264"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c8",
            "leftCorner": {
              "x": 22.061,
              "y": 14.035,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 22.191,
              "y": 14.037,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001264"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c9",
            "leftCorner": {
              "x": 22.191,
              "y": 14.037,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 22.321,
              "y": 14.038,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001264"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ca",
            "leftCorner": {
              "x": 22.321,
              "y": 14.038,
              "z": 0.84836
            },
            "rightCorner": {
              "x": 22.425,
              "y": 14.039,
              "z": 0.84836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5c",
        "height": 1.1436,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59e0",
            "leftCorner": {
              "x": 21.176,
              "y": 14.029,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.283,
              "y": 14.03,
              "z": 1.1436
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4056631003398"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e2",
            "leftCorner": {
              "x": 21.283,
              "y": 14.03,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.382,
              "y": 14.031,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003398"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e3",
            "leftCorner": {
              "x": 21.382,
              "y": 14.031,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.497,
              "y": 14.033,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e4",
            "leftCorner": {
              "x": 21.497,
              "y": 14.033,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.616,
              "y": 14.034,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002414"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e5",
            "leftCorner": {
              "x": 21.616,
              "y": 14.034,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.763,
              "y": 14.035,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e6",
            "leftCorner": {
              "x": 21.763,
              "y": 14.035,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 21.902,
              "y": 14.037,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003701"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e7",
            "leftCorner": {
              "x": 21.902,
              "y": 14.037,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 22.044,
              "y": 14.038,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003701"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e8",
            "leftCorner": {
              "x": 22.044,
              "y": 14.038,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 22.192,
              "y": 14.04,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003701"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e9",
            "leftCorner": {
              "x": 22.192,
              "y": 14.04,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 22.315,
              "y": 14.041,
              "z": 1.1436
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4056631001202"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ea",
            "leftCorner": {
              "x": 22.315,
              "y": 14.041,
              "z": 1.1436
            },
            "rightCorner": {
              "x": 22.425,
              "y": 14.042,
              "z": 1.1436
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001202"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac57",
        "height": 1.4393,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5906",
            "leftCorner": {
              "x": 21.176,
              "y": 14.033,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.313,
              "y": 14.034,
              "z": 1.4393
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4056631002223"
          },
          {
            "id": "679afb3d3d9bab0f83ff5908",
            "leftCorner": {
              "x": 21.313,
              "y": 14.034,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.435,
              "y": 14.036,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002223"
          },
          {
            "id": "679afb3d3d9bab0f83ff5909",
            "leftCorner": {
              "x": 21.435,
              "y": 14.036,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.564,
              "y": 14.037,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002209"
          },
          {
            "id": "679afb3d3d9bab0f83ff590a",
            "leftCorner": {
              "x": 21.564,
              "y": 14.037,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.712,
              "y": 14.038,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002209"
          },
          {
            "id": "679afb3d3d9bab0f83ff590b",
            "leftCorner": {
              "x": 21.712,
              "y": 14.038,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.845,
              "y": 14.04,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003541"
          },
          {
            "id": "679afb3d3d9bab0f83ff590c",
            "leftCorner": {
              "x": 21.845,
              "y": 14.04,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 21.974,
              "y": 14.041,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003565"
          },
          {
            "id": "679afb3d3d9bab0f83ff590d",
            "leftCorner": {
              "x": 21.974,
              "y": 14.041,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 22.109,
              "y": 14.043,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003565"
          },
          {
            "id": "679afb3d3d9bab0f83ff590e",
            "leftCorner": {
              "x": 22.109,
              "y": 14.043,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 22.238,
              "y": 14.044,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff590f",
            "leftCorner": {
              "x": 22.238,
              "y": 14.044,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 22.371,
              "y": 14.045,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003435"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5a",
        "height": 1.7364,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5981",
            "leftCorner": {
              "x": 21.176,
              "y": 14.033,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.274,
              "y": 14.034,
              "z": 1.7364
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447218299"
          },
          {
            "id": "679afb3e3d9bab0f83ff5983",
            "leftCorner": {
              "x": 21.274,
              "y": 14.034,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.35,
              "y": 14.034,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447218299"
          },
          {
            "id": "679afb3e3d9bab0f83ff5984",
            "leftCorner": {
              "x": 21.35,
              "y": 14.034,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.422,
              "y": 14.035,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447218312"
          },
          {
            "id": "679afb3e3d9bab0f83ff5985",
            "leftCorner": {
              "x": 21.422,
              "y": 14.035,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.495,
              "y": 14.036,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447218312"
          },
          {
            "id": "679afb3e3d9bab0f83ff5986",
            "leftCorner": {
              "x": 21.495,
              "y": 14.036,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.568,
              "y": 14.037,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5987",
            "leftCorner": {
              "x": 21.568,
              "y": 14.037,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.664,
              "y": 14.038,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447218336"
          },
          {
            "id": "679afb3e3d9bab0f83ff5988",
            "leftCorner": {
              "x": 21.664,
              "y": 14.038,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.754,
              "y": 14.039,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154283"
          },
          {
            "id": "679afb3e3d9bab0f83ff5989",
            "leftCorner": {
              "x": 21.754,
              "y": 14.039,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.831,
              "y": 14.039,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154283"
          },
          {
            "id": "679afb3e3d9bab0f83ff598a",
            "leftCorner": {
              "x": 21.831,
              "y": 14.039,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.911,
              "y": 14.04,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154276"
          },
          {
            "id": "679afb3e3d9bab0f83ff598b",
            "leftCorner": {
              "x": 21.911,
              "y": 14.04,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 21.986,
              "y": 14.041,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154276"
          },
          {
            "id": "679afb3e3d9bab0f83ff598c",
            "leftCorner": {
              "x": 21.986,
              "y": 14.041,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.074,
              "y": 14.042,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300282773"
          },
          {
            "id": "679afb3e3d9bab0f83ff598d",
            "leftCorner": {
              "x": 22.074,
              "y": 14.042,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.152,
              "y": 14.043,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300282773"
          },
          {
            "id": "679afb3e3d9bab0f83ff598e",
            "leftCorner": {
              "x": 22.152,
              "y": 14.043,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.233,
              "y": 14.044,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260347955517"
          },
          {
            "id": "679afb3e3d9bab0f83ff598f",
            "leftCorner": {
              "x": 22.233,
              "y": 14.044,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.313,
              "y": 14.044,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260347955548"
          },
          {
            "id": "679afb3e3d9bab0f83ff5990",
            "leftCorner": {
              "x": 22.313,
              "y": 14.044,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.363,
              "y": 14.045,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172824678"
          },
          {
            "id": "679afb3e3d9bab0f83ff5991",
            "leftCorner": {
              "x": 22.363,
              "y": 14.045,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.411,
              "y": 14.045,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300038639"
          },
          {
            "id": "679afb3e3d9bab0f83ff5992",
            "leftCorner": {
              "x": 22.411,
              "y": 14.045,
              "z": 1.7364
            },
            "rightCorner": {
              "x": 22.46,
              "y": 14.046,
              "z": 1.7364
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300038639"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 61,
      "unknownStockCount": 6
    },
    "name": "OKVD",
    "leftNeighborShelfId": "LQX1"
  },
  {
    "id": "LQX1",
    "x": 22.45,
    "y": 14.021,
    "width": 1.25,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.010651,
      "w": 0.99994
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac61",
        "height": 0.20846,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff594f",
            "leftCorner": {
              "x": 22.452,
              "y": 13.924,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 22.591,
              "y": 13.927,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852031796"
          },
          {
            "id": "679afb3e3d9bab0f83ff5950",
            "leftCorner": {
              "x": 22.591,
              "y": 13.927,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 22.727,
              "y": 13.929,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300437159"
          },
          {
            "id": "679afb3e3d9bab0f83ff5951",
            "leftCorner": {
              "x": 22.727,
              "y": 13.929,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 22.857,
              "y": 13.932,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5952",
            "leftCorner": {
              "x": 22.857,
              "y": 13.932,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 22.989,
              "y": 13.935,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852021063"
          },
          {
            "id": "679afb3e3d9bab0f83ff5953",
            "leftCorner": {
              "x": 22.989,
              "y": 13.935,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.126,
              "y": 13.938,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852021117"
          },
          {
            "id": "679afb3e3d9bab0f83ff5954",
            "leftCorner": {
              "x": 23.126,
              "y": 13.938,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.262,
              "y": 13.941,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852021117"
          },
          {
            "id": "679afb3e3d9bab0f83ff5955",
            "leftCorner": {
              "x": 23.262,
              "y": 13.941,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.391,
              "y": 13.944,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852033745"
          },
          {
            "id": "679afb3e3d9bab0f83ff5956",
            "leftCorner": {
              "x": 23.391,
              "y": 13.944,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.53,
              "y": 13.947,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852033745"
          },
          {
            "id": "679afb3e3d9bab0f83ff5957",
            "leftCorner": {
              "x": 23.53,
              "y": 13.947,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.661,
              "y": 13.949,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001790"
          },
          {
            "id": "679afb3e3d9bab0f83ff5958",
            "leftCorner": {
              "x": 23.661,
              "y": 13.949,
              "z": 0.20846
            },
            "rightCorner": {
              "x": 23.813,
              "y": 13.953,
              "z": 0.20846
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac62",
        "height": 0.55573,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5930",
            "leftCorner": {
              "x": 22.447,
              "y": 14.032,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 22.551,
              "y": 14.035,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463070"
          },
          {
            "id": "679afb3e3d9bab0f83ff5931",
            "leftCorner": {
              "x": 22.551,
              "y": 14.035,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 22.695,
              "y": 14.038,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463070"
          },
          {
            "id": "679afb3e3d9bab0f83ff5932",
            "leftCorner": {
              "x": 22.695,
              "y": 14.038,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 22.831,
              "y": 14.041,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463384"
          },
          {
            "id": "679afb3e3d9bab0f83ff5933",
            "leftCorner": {
              "x": 22.831,
              "y": 14.041,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 22.96,
              "y": 14.043,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613287226679"
          },
          {
            "id": "679afb3e3d9bab0f83ff5934",
            "leftCorner": {
              "x": 22.96,
              "y": 14.043,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.094,
              "y": 14.046,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038464244"
          },
          {
            "id": "679afb3e3d9bab0f83ff5935",
            "leftCorner": {
              "x": 23.094,
              "y": 14.046,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.226,
              "y": 14.049,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038464244"
          },
          {
            "id": "679afb3e3d9bab0f83ff5936",
            "leftCorner": {
              "x": 23.226,
              "y": 14.049,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.279,
              "y": 14.05,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290737601"
          },
          {
            "id": "679afb3e3d9bab0f83ff5937",
            "leftCorner": {
              "x": 23.279,
              "y": 14.05,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.331,
              "y": 14.051,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290737601"
          },
          {
            "id": "679afb3e3d9bab0f83ff5938",
            "leftCorner": {
              "x": 23.331,
              "y": 14.051,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.397,
              "y": 14.053,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291074309"
          },
          {
            "id": "679afb3e3d9bab0f83ff5939",
            "leftCorner": {
              "x": 23.397,
              "y": 14.053,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.469,
              "y": 14.054,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291074309"
          },
          {
            "id": "679afb3e3d9bab0f83ff593a",
            "leftCorner": {
              "x": 23.469,
              "y": 14.054,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.597,
              "y": 14.057,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463353"
          },
          {
            "id": "679afb3e3d9bab0f83ff593b",
            "leftCorner": {
              "x": 23.597,
              "y": 14.057,
              "z": 0.55573
            },
            "rightCorner": {
              "x": 23.745,
              "y": 14.06,
              "z": 0.55573
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613038463353"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac60",
        "height": 0.84633,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59cb",
            "leftCorner": {
              "x": 22.449,
              "y": 14.033,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 22.599,
              "y": 14.036,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59cc",
            "leftCorner": {
              "x": 22.599,
              "y": 14.036,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 22.679,
              "y": 14.038,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9001375008951"
          },
          {
            "id": "679afb3e3d9bab0f83ff59cd",
            "leftCorner": {
              "x": 22.679,
              "y": 14.038,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 22.759,
              "y": 14.04,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9001375008951"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ce",
            "leftCorner": {
              "x": 22.759,
              "y": 14.04,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 22.838,
              "y": 14.042,
              "z": 0.84633
            },
            "stockLevel": "NO_STOCK",
            "gtin": "9001375008951"
          },
          {
            "id": "679afb3e3d9bab0f83ff59cf",
            "leftCorner": {
              "x": 22.838,
              "y": 14.042,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 22.973,
              "y": 14.044,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003794"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d0",
            "leftCorner": {
              "x": 22.973,
              "y": 14.044,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.11,
              "y": 14.047,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003794"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d1",
            "leftCorner": {
              "x": 23.11,
              "y": 14.047,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.249,
              "y": 14.05,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003794"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d2",
            "leftCorner": {
              "x": 23.249,
              "y": 14.05,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.377,
              "y": 14.053,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300414310"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d3",
            "leftCorner": {
              "x": 23.377,
              "y": 14.053,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.509,
              "y": 14.056,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300414310"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d4",
            "leftCorner": {
              "x": 23.509,
              "y": 14.056,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.642,
              "y": 14.059,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300414310"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d5",
            "leftCorner": {
              "x": 23.642,
              "y": 14.059,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.679,
              "y": 14.059,
              "z": 0.84633
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5f",
        "height": 1.1422,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59eb",
            "leftCorner": {
              "x": 22.449,
              "y": 14.036,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 22.581,
              "y": 14.039,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001226"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ec",
            "leftCorner": {
              "x": 22.581,
              "y": 14.039,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 22.714,
              "y": 14.042,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001226"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ed",
            "leftCorner": {
              "x": 22.714,
              "y": 14.042,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 22.858,
              "y": 14.045,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003879"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ee",
            "leftCorner": {
              "x": 22.858,
              "y": 14.045,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.004,
              "y": 14.048,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003879"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ef",
            "leftCorner": {
              "x": 23.004,
              "y": 14.048,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.154,
              "y": 14.052,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003879"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f0",
            "leftCorner": {
              "x": 23.154,
              "y": 14.052,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.269,
              "y": 14.054,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300405714"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f1",
            "leftCorner": {
              "x": 23.269,
              "y": 14.054,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.375,
              "y": 14.056,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300405714"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f2",
            "leftCorner": {
              "x": 23.375,
              "y": 14.056,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.511,
              "y": 14.059,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398894"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f3",
            "leftCorner": {
              "x": 23.511,
              "y": 14.059,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.649,
              "y": 14.062,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398894"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f4",
            "leftCorner": {
              "x": 23.649,
              "y": 14.062,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.684,
              "y": 14.063,
              "z": 1.1422
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5e",
        "height": 1.4367,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5910",
            "leftCorner": {
              "x": 22.371,
              "y": 14.045,
              "z": 1.4393
            },
            "rightCorner": {
              "x": 22.48,
              "y": 14.046,
              "z": 1.4393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003459"
          },
          {
            "id": "679afb3d3d9bab0f83ff5911",
            "leftCorner": {
              "x": 22.504,
              "y": 14.037,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 22.646,
              "y": 14.04,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003473"
          },
          {
            "id": "679afb3d3d9bab0f83ff5912",
            "leftCorner": {
              "x": 22.646,
              "y": 14.04,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 22.748,
              "y": 14.042,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003411"
          },
          {
            "id": "679afb3d3d9bab0f83ff5913",
            "leftCorner": {
              "x": 22.748,
              "y": 14.042,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 22.886,
              "y": 14.045,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631000472"
          },
          {
            "id": "679afb3d3d9bab0f83ff5914",
            "leftCorner": {
              "x": 22.886,
              "y": 14.045,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 23.162,
              "y": 14.051,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631000472"
          },
          {
            "id": "679afb3d3d9bab0f83ff5915",
            "leftCorner": {
              "x": 23.162,
              "y": 14.051,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 23.303,
              "y": 14.054,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631000496"
          },
          {
            "id": "679afb3d3d9bab0f83ff5916",
            "leftCorner": {
              "x": 23.303,
              "y": 14.054,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 23.437,
              "y": 14.057,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631000519"
          },
          {
            "id": "679afb3d3d9bab0f83ff5917",
            "leftCorner": {
              "x": 23.437,
              "y": 14.057,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 23.572,
              "y": 14.059,
              "z": 1.4367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631000519"
          },
          {
            "id": "679afb3d3d9bab0f83ff5918",
            "leftCorner": {
              "x": 23.572,
              "y": 14.059,
              "z": 1.4367
            },
            "rightCorner": {
              "x": 23.713,
              "y": 14.062,
              "z": 1.4367
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac5d",
        "height": 1.7324,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5993",
            "leftCorner": {
              "x": 22.484,
              "y": 14.039,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 22.543,
              "y": 14.04,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260477050847"
          },
          {
            "id": "679afb3e3d9bab0f83ff5994",
            "leftCorner": {
              "x": 22.543,
              "y": 14.04,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 22.62,
              "y": 14.042,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260477050830"
          },
          {
            "id": "679afb3e3d9bab0f83ff5995",
            "leftCorner": {
              "x": 22.62,
              "y": 14.042,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 22.754,
              "y": 14.045,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5996",
            "leftCorner": {
              "x": 22.754,
              "y": 14.045,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 22.884,
              "y": 14.048,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5997",
            "leftCorner": {
              "x": 22.884,
              "y": 14.048,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.013,
              "y": 14.05,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5998",
            "leftCorner": {
              "x": 23.013,
              "y": 14.05,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.154,
              "y": 14.053,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003169"
          },
          {
            "id": "679afb3e3d9bab0f83ff5999",
            "leftCorner": {
              "x": 23.154,
              "y": 14.053,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.291,
              "y": 14.056,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003169"
          },
          {
            "id": "679afb3e3d9bab0f83ff599a",
            "leftCorner": {
              "x": 23.291,
              "y": 14.056,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.414,
              "y": 14.059,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260343010166"
          },
          {
            "id": "679afb3e3d9bab0f83ff599b",
            "leftCorner": {
              "x": 23.414,
              "y": 14.059,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.55,
              "y": 14.062,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff599c",
            "leftCorner": {
              "x": 23.55,
              "y": 14.062,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.679,
              "y": 14.065,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff599d",
            "leftCorner": {
              "x": 23.679,
              "y": 14.065,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.714,
              "y": 14.065,
              "z": 1.7324
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 58,
      "unknownStockCount": 3
    },
    "name": "LQX1",
    "leftNeighborShelfId": "UMWH",
    "rightNeighborShelfId": "OKVD"
  },
  {
    "id": "UMWH",
    "x": 23.698,
    "y": 14.045,
    "width": 1.25,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0057675,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac65",
        "height": 0.20826,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5959",
            "leftCorner": {
              "x": 23.811,
              "y": 13.949,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 23.946,
              "y": 13.951,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631001813"
          },
          {
            "id": "679afb3e3d9bab0f83ff595a",
            "leftCorner": {
              "x": 23.946,
              "y": 13.951,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.072,
              "y": 13.952,
              "z": 0.20826
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4056631001813"
          },
          {
            "id": "679afb3e3d9bab0f83ff595b",
            "leftCorner": {
              "x": 24.072,
              "y": 13.952,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.149,
              "y": 13.953,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976091271"
          },
          {
            "id": "679afb3e3d9bab0f83ff595c",
            "leftCorner": {
              "x": 24.149,
              "y": 13.953,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.233,
              "y": 13.954,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976091271"
          },
          {
            "id": "679afb3e3d9bab0f83ff595d",
            "leftCorner": {
              "x": 24.233,
              "y": 13.954,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.322,
              "y": 13.955,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976091271"
          },
          {
            "id": "679afb3e3d9bab0f83ff595e",
            "leftCorner": {
              "x": 24.322,
              "y": 13.955,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.489,
              "y": 13.957,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002513"
          },
          {
            "id": "679afb3e3d9bab0f83ff595f",
            "leftCorner": {
              "x": 24.489,
              "y": 13.957,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.643,
              "y": 13.959,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631003817"
          },
          {
            "id": "679afb3e3d9bab0f83ff5960",
            "leftCorner": {
              "x": 24.643,
              "y": 13.959,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.772,
              "y": 13.96,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796035414"
          },
          {
            "id": "679afb3e3d9bab0f83ff5961",
            "leftCorner": {
              "x": 24.772,
              "y": 13.96,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 24.901,
              "y": 13.962,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355192"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac64",
        "height": 0.55427,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff593c",
            "leftCorner": {
              "x": 23.744,
              "y": 14.054,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 23.89,
              "y": 14.055,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4031244004291"
          },
          {
            "id": "679afb3e3d9bab0f83ff593d",
            "leftCorner": {
              "x": 23.89,
              "y": 14.055,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.01,
              "y": 14.057,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4031244004291"
          },
          {
            "id": "679afb3e3d9bab0f83ff593e",
            "leftCorner": {
              "x": 24.01,
              "y": 14.057,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.164,
              "y": 14.059,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4031244004239"
          },
          {
            "id": "679afb3e3d9bab0f83ff593f",
            "leftCorner": {
              "x": 24.164,
              "y": 14.059,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.301,
              "y": 14.06,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976032861"
          },
          {
            "id": "679afb3e3d9bab0f83ff5940",
            "leftCorner": {
              "x": 24.301,
              "y": 14.06,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.443,
              "y": 14.062,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976032861"
          },
          {
            "id": "679afb3e3d9bab0f83ff5941",
            "leftCorner": {
              "x": 24.443,
              "y": 14.062,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.573,
              "y": 14.063,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976032892"
          },
          {
            "id": "679afb3e3d9bab0f83ff5942",
            "leftCorner": {
              "x": 24.573,
              "y": 14.063,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.704,
              "y": 14.065,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976032892"
          },
          {
            "id": "679afb3e3d9bab0f83ff5943",
            "leftCorner": {
              "x": 24.704,
              "y": 14.065,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.834,
              "y": 14.066,
              "z": 0.55427
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008976032892"
          },
          {
            "id": "679afb3d3d9bab0f83ff5924",
            "leftCorner": {
              "x": 24.834,
              "y": 14.066,
              "z": 0.55427
            },
            "rightCorner": {
              "x": 24.948,
              "y": 14.068,
              "z": 0.55427
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008976032892"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac67",
        "height": 0.84548,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59d6",
            "leftCorner": {
              "x": 23.679,
              "y": 14.059,
              "z": 0.84633
            },
            "rightCorner": {
              "x": 23.785,
              "y": 14.062,
              "z": 0.84633
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300414327"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d7",
            "leftCorner": {
              "x": 23.784,
              "y": 14.057,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 23.89,
              "y": 14.059,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300414327"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d8",
            "leftCorner": {
              "x": 23.89,
              "y": 14.059,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 23.92,
              "y": 14.059,
              "z": 0.84548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59d9",
            "leftCorner": {
              "x": 23.92,
              "y": 14.059,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.041,
              "y": 14.06,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355422"
          },
          {
            "id": "679afb3e3d9bab0f83ff59da",
            "leftCorner": {
              "x": 24.041,
              "y": 14.06,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.168,
              "y": 14.062,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355422"
          },
          {
            "id": "679afb3e3d9bab0f83ff59db",
            "leftCorner": {
              "x": 24.168,
              "y": 14.062,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.304,
              "y": 14.063,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355422"
          },
          {
            "id": "679afb3e3d9bab0f83ff59dc",
            "leftCorner": {
              "x": 24.304,
              "y": 14.063,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.434,
              "y": 14.065,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355439"
          },
          {
            "id": "679afb3e3d9bab0f83ff59dd",
            "leftCorner": {
              "x": 24.434,
              "y": 14.065,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.567,
              "y": 14.066,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355439"
          },
          {
            "id": "679afb3e3d9bab0f83ff59de",
            "leftCorner": {
              "x": 24.567,
              "y": 14.066,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.693,
              "y": 14.068,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355439"
          },
          {
            "id": "679afb3e3d9bab0f83ff59df",
            "leftCorner": {
              "x": 24.693,
              "y": 14.068,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.825,
              "y": 14.069,
              "z": 0.84548
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300355446"
          },
          {
            "id": "679afb3e3d9bab0f83ff59c1",
            "leftCorner": {
              "x": 24.825,
              "y": 14.069,
              "z": 0.84548
            },
            "rightCorner": {
              "x": 24.948,
              "y": 14.071,
              "z": 0.84548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300355446"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac68",
        "height": 1.1415,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59f5",
            "leftCorner": {
              "x": 23.684,
              "y": 14.063,
              "z": 1.1422
            },
            "rightCorner": {
              "x": 23.795,
              "y": 14.065,
              "z": 1.1422
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398900"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f6",
            "leftCorner": {
              "x": 23.794,
              "y": 14.057,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 23.93,
              "y": 14.059,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398900"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f7",
            "leftCorner": {
              "x": 23.93,
              "y": 14.059,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.052,
              "y": 14.06,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398917"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f8",
            "leftCorner": {
              "x": 24.052,
              "y": 14.06,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.175,
              "y": 14.062,
              "z": 1.1415
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062300398917"
          },
          {
            "id": "679afb3e3d9bab0f83ff59f9",
            "leftCorner": {
              "x": 24.175,
              "y": 14.062,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.315,
              "y": 14.063,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398924"
          },
          {
            "id": "679afb3e3d9bab0f83ff59fa",
            "leftCorner": {
              "x": 24.315,
              "y": 14.063,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.443,
              "y": 14.065,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300398924"
          },
          {
            "id": "679afb3e3d9bab0f83ff59fb",
            "leftCorner": {
              "x": 24.443,
              "y": 14.065,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.578,
              "y": 14.067,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300447240"
          },
          {
            "id": "679afb3e3d9bab0f83ff59fc",
            "leftCorner": {
              "x": 24.578,
              "y": 14.067,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.706,
              "y": 14.068,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300447240"
          },
          {
            "id": "679afb3e3d9bab0f83ff59fd",
            "leftCorner": {
              "x": 24.706,
              "y": 14.068,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.835,
              "y": 14.07,
              "z": 1.1415
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300447233"
          },
          {
            "id": "679afb3e3d9bab0f83ff59e1",
            "leftCorner": {
              "x": 24.835,
              "y": 14.07,
              "z": 1.1415
            },
            "rightCorner": {
              "x": 24.948,
              "y": 14.071,
              "z": 1.1415
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300447233"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac66",
        "height": 1.4362,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5919",
            "leftCorner": {
              "x": 23.712,
              "y": 14.056,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 23.849,
              "y": 14.058,
              "z": 1.4362
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062300406254"
          },
          {
            "id": "679afb3d3d9bab0f83ff591a",
            "leftCorner": {
              "x": 23.849,
              "y": 14.058,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 23.946,
              "y": 14.059,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff591b",
            "leftCorner": {
              "x": 23.946,
              "y": 14.059,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 23.979,
              "y": 14.059,
              "z": 1.4362
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300406247"
          },
          {
            "id": "679afb3d3d9bab0f83ff591c",
            "leftCorner": {
              "x": 23.979,
              "y": 14.059,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.101,
              "y": 14.061,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300406247"
          },
          {
            "id": "679afb3d3d9bab0f83ff591d",
            "leftCorner": {
              "x": 24.101,
              "y": 14.061,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.203,
              "y": 14.062,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300403765"
          },
          {
            "id": "679afb3d3d9bab0f83ff591e",
            "leftCorner": {
              "x": 24.203,
              "y": 14.062,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.316,
              "y": 14.063,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300403765"
          },
          {
            "id": "679afb3d3d9bab0f83ff591f",
            "leftCorner": {
              "x": 24.316,
              "y": 14.063,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.447,
              "y": 14.065,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300402782"
          },
          {
            "id": "679afb3d3d9bab0f83ff5920",
            "leftCorner": {
              "x": 24.447,
              "y": 14.065,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.579,
              "y": 14.066,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300402782"
          },
          {
            "id": "679afb3d3d9bab0f83ff5921",
            "leftCorner": {
              "x": 24.579,
              "y": 14.066,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.708,
              "y": 14.068,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300402799"
          },
          {
            "id": "679afb3d3d9bab0f83ff5922",
            "leftCorner": {
              "x": 24.708,
              "y": 14.068,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.838,
              "y": 14.069,
              "z": 1.4362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300402799"
          },
          {
            "id": "679afb3d3d9bab0f83ff5907",
            "leftCorner": {
              "x": 24.838,
              "y": 14.069,
              "z": 1.4362
            },
            "rightCorner": {
              "x": 24.948,
              "y": 14.071,
              "z": 1.4362
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300402805"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac63",
        "height": 1.7324,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff599e",
            "leftCorner": {
              "x": 23.713,
              "y": 14.057,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.798,
              "y": 14.058,
              "z": 1.7324
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796003192"
          },
          {
            "id": "679afb3e3d9bab0f83ff599f",
            "leftCorner": {
              "x": 23.798,
              "y": 14.058,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.836,
              "y": 14.058,
              "z": 1.7324
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447517736"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a0",
            "leftCorner": {
              "x": 23.836,
              "y": 14.058,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 23.954,
              "y": 14.06,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517736"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a1",
            "leftCorner": {
              "x": 23.954,
              "y": 14.06,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.072,
              "y": 14.061,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796033922"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a2",
            "leftCorner": {
              "x": 24.072,
              "y": 14.061,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.195,
              "y": 14.063,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796033922"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a3",
            "leftCorner": {
              "x": 24.195,
              "y": 14.063,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.327,
              "y": 14.064,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796033922"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a4",
            "leftCorner": {
              "x": 24.327,
              "y": 14.064,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.457,
              "y": 14.066,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796033946"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a5",
            "leftCorner": {
              "x": 24.457,
              "y": 14.066,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.585,
              "y": 14.067,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796033946"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a6",
            "leftCorner": {
              "x": 24.585,
              "y": 14.067,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.712,
              "y": 14.069,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a7",
            "leftCorner": {
              "x": 24.712,
              "y": 14.069,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.842,
              "y": 14.07,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300417311"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 49,
      "unknownStockCount": 9
    },
    "name": "UMWH",
    "leftNeighborShelfId": "AD3P",
    "rightNeighborShelfId": "LQX1"
  },
  {
    "id": "AD3P",
    "x": 24.947,
    "y": 14.063,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0035014,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac6f",
        "height": 0.20643,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5962",
            "leftCorner": {
              "x": 24.901,
              "y": 13.962,
              "z": 0.20826
            },
            "rightCorner": {
              "x": 25.032,
              "y": 13.963,
              "z": 0.20826
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355215"
          },
          {
            "id": "679afb3e3d9bab0f83ff5963",
            "leftCorner": {
              "x": 25.031,
              "y": 13.964,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.166,
              "y": 13.965,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447111439"
          },
          {
            "id": "679afb3e3d9bab0f83ff5964",
            "leftCorner": {
              "x": 25.166,
              "y": 13.965,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.298,
              "y": 13.966,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030454"
          },
          {
            "id": "679afb3e3d9bab0f83ff5965",
            "leftCorner": {
              "x": 25.298,
              "y": 13.966,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.43,
              "y": 13.967,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030454"
          },
          {
            "id": "679afb3e3d9bab0f83ff5966",
            "leftCorner": {
              "x": 25.43,
              "y": 13.967,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.57,
              "y": 13.968,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030201"
          },
          {
            "id": "679afb3e3d9bab0f83ff5967",
            "leftCorner": {
              "x": 25.57,
              "y": 13.968,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.702,
              "y": 13.969,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030201"
          },
          {
            "id": "679afb3e3d9bab0f83ff5968",
            "leftCorner": {
              "x": 25.702,
              "y": 13.969,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.824,
              "y": 13.97,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029526"
          },
          {
            "id": "679afb3e3d9bab0f83ff5969",
            "leftCorner": {
              "x": 25.824,
              "y": 13.97,
              "z": 0.20643
            },
            "rightCorner": {
              "x": 25.966,
              "y": 13.971,
              "z": 0.20643
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251099845126"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac6e",
        "height": 0.47035,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a49",
            "leftCorner": {
              "x": 24.947,
              "y": 14.073,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.095,
              "y": 14.074,
              "z": 0.47035
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447532647"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4b",
            "leftCorner": {
              "x": 25.095,
              "y": 14.074,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.215,
              "y": 14.075,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447398649"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4c",
            "leftCorner": {
              "x": 25.215,
              "y": 14.075,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.348,
              "y": 14.076,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447228151"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4d",
            "leftCorner": {
              "x": 25.348,
              "y": 14.076,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.48,
              "y": 14.077,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447363418"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4e",
            "leftCorner": {
              "x": 25.48,
              "y": 14.077,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.613,
              "y": 14.078,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002797"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4f",
            "leftCorner": {
              "x": 25.613,
              "y": 14.078,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.724,
              "y": 14.078,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002834"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a50",
            "leftCorner": {
              "x": 25.724,
              "y": 14.078,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.833,
              "y": 14.079,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002674"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a51",
            "leftCorner": {
              "x": 25.833,
              "y": 14.079,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.871,
              "y": 14.079,
              "z": 0.47035
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4056631002735"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a52",
            "leftCorner": {
              "x": 25.871,
              "y": 14.079,
              "z": 0.47035
            },
            "rightCorner": {
              "x": 25.946,
              "y": 14.08,
              "z": 0.47035
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4056631002735"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac6a",
        "height": 0.80406,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59fe",
            "leftCorner": {
              "x": 24.947,
              "y": 14.074,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.056,
              "y": 14.075,
              "z": 0.80406
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447282627"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a00",
            "leftCorner": {
              "x": 25.056,
              "y": 14.075,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.188,
              "y": 14.075,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300343108"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a01",
            "leftCorner": {
              "x": 25.188,
              "y": 14.075,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.32,
              "y": 14.076,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300344877"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a02",
            "leftCorner": {
              "x": 25.32,
              "y": 14.076,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.454,
              "y": 14.077,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300392366"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a03",
            "leftCorner": {
              "x": 25.454,
              "y": 14.077,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.59,
              "y": 14.078,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300392397"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a04",
            "leftCorner": {
              "x": 25.59,
              "y": 14.078,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.718,
              "y": 14.079,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300367890"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a05",
            "leftCorner": {
              "x": 25.718,
              "y": 14.079,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.84,
              "y": 14.08,
              "z": 0.80406
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000540002508"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ff",
            "leftCorner": {
              "x": 25.84,
              "y": 14.08,
              "z": 0.80406
            },
            "rightCorner": {
              "x": 25.947,
              "y": 14.081,
              "z": 0.80406
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4000540002560"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac6b",
        "height": 1.0956,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a06",
            "leftCorner": {
              "x": 24.947,
              "y": 14.075,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.094,
              "y": 14.076,
              "z": 1.0956
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172438257"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a08",
            "leftCorner": {
              "x": 25.094,
              "y": 14.076,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.218,
              "y": 14.077,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438295"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a09",
            "leftCorner": {
              "x": 25.218,
              "y": 14.077,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.346,
              "y": 14.078,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438059"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a0a",
            "leftCorner": {
              "x": 25.346,
              "y": 14.078,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.476,
              "y": 14.079,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438011"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a0b",
            "leftCorner": {
              "x": 25.476,
              "y": 14.079,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.605,
              "y": 14.08,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438110"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a0c",
            "leftCorner": {
              "x": 25.605,
              "y": 14.08,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.73,
              "y": 14.08,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438158"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a0d",
            "leftCorner": {
              "x": 25.73,
              "y": 14.08,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.855,
              "y": 14.081,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208320"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a0e",
            "leftCorner": {
              "x": 25.855,
              "y": 14.081,
              "z": 1.0956
            },
            "rightCorner": {
              "x": 25.969,
              "y": 14.082,
              "z": 1.0956
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447093247"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac6d",
        "height": 1.3086,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a32",
            "leftCorner": {
              "x": 24.947,
              "y": 14.076,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.096,
              "y": 14.077,
              "z": 1.3086
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300266230"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a34",
            "leftCorner": {
              "x": 25.096,
              "y": 14.077,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.226,
              "y": 14.078,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300261532"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a35",
            "leftCorner": {
              "x": 25.226,
              "y": 14.078,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.357,
              "y": 14.079,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266247"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a36",
            "leftCorner": {
              "x": 25.357,
              "y": 14.079,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.484,
              "y": 14.08,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438097"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a37",
            "leftCorner": {
              "x": 25.484,
              "y": 14.08,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.615,
              "y": 14.081,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438134"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a38",
            "leftCorner": {
              "x": 25.615,
              "y": 14.081,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.738,
              "y": 14.082,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438073"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a39",
            "leftCorner": {
              "x": 25.738,
              "y": 14.082,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.864,
              "y": 14.082,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438035"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a3a",
            "leftCorner": {
              "x": 25.864,
              "y": 14.082,
              "z": 1.3086
            },
            "rightCorner": {
              "x": 25.982,
              "y": 14.083,
              "z": 1.3086
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437915"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac6c",
        "height": 1.5191,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a1c",
            "leftCorner": {
              "x": 24.947,
              "y": 14.069,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.095,
              "y": 14.07,
              "z": 1.5191
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a1e",
            "leftCorner": {
              "x": 25.095,
              "y": 14.07,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.213,
              "y": 14.071,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300271241"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a1f",
            "leftCorner": {
              "x": 25.213,
              "y": 14.071,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.464,
              "y": 14.072,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300381971"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a20",
            "leftCorner": {
              "x": 25.464,
              "y": 14.072,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.603,
              "y": 14.073,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300129443"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a21",
            "leftCorner": {
              "x": 25.603,
              "y": 14.073,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.729,
              "y": 14.074,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300350403"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a22",
            "leftCorner": {
              "x": 25.729,
              "y": 14.074,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.868,
              "y": 14.075,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300379060"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a23",
            "leftCorner": {
              "x": 25.868,
              "y": 14.075,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 25.977,
              "y": 14.076,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266353"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac69",
        "height": 1.7318,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59a8",
            "leftCorner": {
              "x": 24.842,
              "y": 14.07,
              "z": 1.7324
            },
            "rightCorner": {
              "x": 24.975,
              "y": 14.072,
              "z": 1.7324
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070644"
          },
          {
            "id": "679afb3e3d9bab0f83ff59a9",
            "leftCorner": {
              "x": 24.974,
              "y": 14.072,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.098,
              "y": 14.073,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300297036"
          },
          {
            "id": "679afb3e3d9bab0f83ff59aa",
            "leftCorner": {
              "x": 25.098,
              "y": 14.073,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.215,
              "y": 14.073,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300297043"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ab",
            "leftCorner": {
              "x": 25.215,
              "y": 14.073,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.347,
              "y": 14.074,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300379381"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ac",
            "leftCorner": {
              "x": 25.347,
              "y": 14.074,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.375,
              "y": 14.074,
              "z": 1.7318
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260343010166"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ad",
            "leftCorner": {
              "x": 25.375,
              "y": 14.074,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.485,
              "y": 14.075,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300297081"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ae",
            "leftCorner": {
              "x": 25.485,
              "y": 14.075,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.618,
              "y": 14.076,
              "z": 1.7318
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300297104"
          },
          {
            "id": "679afb3e3d9bab0f83ff59af",
            "leftCorner": {
              "x": 25.618,
              "y": 14.076,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.744,
              "y": 14.077,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300290136"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b0",
            "leftCorner": {
              "x": 25.744,
              "y": 14.077,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.876,
              "y": 14.078,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300441170"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b1",
            "leftCorner": {
              "x": 25.876,
              "y": 14.078,
              "z": 1.7318
            },
            "rightCorner": {
              "x": 25.992,
              "y": 14.079,
              "z": 1.7318
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300455153"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 49,
      "unknownStockCount": 9
    },
    "name": "AD3P",
    "leftNeighborShelfId": "PXOT",
    "rightNeighborShelfId": "UMWH"
  },
  {
    "id": "PXOT",
    "x": 25.964,
    "y": 14.072,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0076467,
      "w": 0.99997
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac74",
        "height": 0.20542,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff596a",
            "leftCorner": {
              "x": 25.983,
              "y": 13.974,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.11,
              "y": 13.976,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470819"
          },
          {
            "id": "679afb3e3d9bab0f83ff596b",
            "leftCorner": {
              "x": 26.11,
              "y": 13.976,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.23,
              "y": 13.978,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470758"
          },
          {
            "id": "679afb3e3d9bab0f83ff596c",
            "leftCorner": {
              "x": 26.23,
              "y": 13.978,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.359,
              "y": 13.979,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470772"
          },
          {
            "id": "679afb3e3d9bab0f83ff596d",
            "leftCorner": {
              "x": 26.359,
              "y": 13.979,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.488,
              "y": 13.981,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470796"
          },
          {
            "id": "679afb3e3d9bab0f83ff596e",
            "leftCorner": {
              "x": 26.488,
              "y": 13.981,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.623,
              "y": 13.984,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030560"
          },
          {
            "id": "679afb3e3d9bab0f83ff596f",
            "leftCorner": {
              "x": 26.623,
              "y": 13.984,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.748,
              "y": 13.985,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029359"
          },
          {
            "id": "679afb3e3d9bab0f83ff5970",
            "leftCorner": {
              "x": 26.748,
              "y": 13.985,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 26.875,
              "y": 13.987,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852035671"
          },
          {
            "id": "679afb3e3d9bab0f83ff5971",
            "leftCorner": {
              "x": 26.875,
              "y": 13.987,
              "z": 0.20542
            },
            "rightCorner": {
              "x": 27.012,
              "y": 13.989,
              "z": 0.20542
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470697"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac70",
        "height": 0.46746,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a53",
            "leftCorner": {
              "x": 25.962,
              "y": 14.079,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.103,
              "y": 14.081,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172939709"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a54",
            "leftCorner": {
              "x": 26.103,
              "y": 14.081,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.225,
              "y": 14.083,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172939761"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a55",
            "leftCorner": {
              "x": 26.225,
              "y": 14.083,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.353,
              "y": 14.085,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172939822"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a56",
            "leftCorner": {
              "x": 26.353,
              "y": 14.085,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.479,
              "y": 14.087,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172623714"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a57",
            "leftCorner": {
              "x": 26.479,
              "y": 14.087,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.614,
              "y": 14.089,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411621"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a58",
            "leftCorner": {
              "x": 26.614,
              "y": 14.089,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.739,
              "y": 14.091,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470635"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a59",
            "leftCorner": {
              "x": 26.739,
              "y": 14.091,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 26.868,
              "y": 14.093,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029083"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a5a",
            "leftCorner": {
              "x": 26.868,
              "y": 14.093,
              "z": 0.46746
            },
            "rightCorner": {
              "x": 27,
              "y": 14.095,
              "z": 0.46746
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029250"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac73",
        "height": 0.67679,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a71",
            "leftCorner": {
              "x": 25.964,
              "y": 14.081,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.101,
              "y": 14.083,
              "z": 0.67679
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4018852033295"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a73",
            "leftCorner": {
              "x": 26.101,
              "y": 14.083,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.228,
              "y": 14.085,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029984"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a74",
            "leftCorner": {
              "x": 26.228,
              "y": 14.085,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.356,
              "y": 14.087,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029984"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a75",
            "leftCorner": {
              "x": 26.356,
              "y": 14.087,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.485,
              "y": 14.089,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437816"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a76",
            "leftCorner": {
              "x": 26.485,
              "y": 14.089,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.614,
              "y": 14.091,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437830"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a77",
            "leftCorner": {
              "x": 26.614,
              "y": 14.091,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.737,
              "y": 14.093,
              "z": 0.67679
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172438738"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a78",
            "leftCorner": {
              "x": 26.737,
              "y": 14.093,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.866,
              "y": 14.095,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172869648"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a79",
            "leftCorner": {
              "x": 26.866,
              "y": 14.095,
              "z": 0.67679
            },
            "rightCorner": {
              "x": 26.995,
              "y": 14.097,
              "z": 0.67679
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447626667"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac71",
        "height": 0.88399,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a62",
            "leftCorner": {
              "x": 25.964,
              "y": 14.078,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.101,
              "y": 14.08,
              "z": 0.88399
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4018852028949"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a64",
            "leftCorner": {
              "x": 26.101,
              "y": 14.08,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.23,
              "y": 14.082,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852029229"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a65",
            "leftCorner": {
              "x": 26.23,
              "y": 14.082,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.358,
              "y": 14.084,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300261563"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a66",
            "leftCorner": {
              "x": 26.358,
              "y": 14.084,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.486,
              "y": 14.086,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300024816"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a67",
            "leftCorner": {
              "x": 26.486,
              "y": 14.086,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.622,
              "y": 14.088,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300260795"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a68",
            "leftCorner": {
              "x": 26.622,
              "y": 14.088,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.749,
              "y": 14.09,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300463141"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a69",
            "leftCorner": {
              "x": 26.749,
              "y": 14.09,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 26.875,
              "y": 14.092,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437892"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a6a",
            "leftCorner": {
              "x": 26.875,
              "y": 14.092,
              "z": 0.88399
            },
            "rightCorner": {
              "x": 27.003,
              "y": 14.094,
              "z": 0.88399
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437854"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac75",
        "height": 1.0958,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a0f",
            "leftCorner": {
              "x": 25.985,
              "y": 14.081,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.111,
              "y": 14.083,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438417"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a10",
            "leftCorner": {
              "x": 26.111,
              "y": 14.083,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.233,
              "y": 14.085,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438479"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a11",
            "leftCorner": {
              "x": 26.233,
              "y": 14.085,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.357,
              "y": 14.086,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411607"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a12",
            "leftCorner": {
              "x": 26.357,
              "y": 14.086,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.483,
              "y": 14.088,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411607"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a13",
            "leftCorner": {
              "x": 26.483,
              "y": 14.088,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.618,
              "y": 14.09,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300265813"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a14",
            "leftCorner": {
              "x": 26.618,
              "y": 14.09,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.746,
              "y": 14.092,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300321335"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a15",
            "leftCorner": {
              "x": 26.746,
              "y": 14.092,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 26.874,
              "y": 14.094,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300455887"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a16",
            "leftCorner": {
              "x": 26.874,
              "y": 14.094,
              "z": 1.0958
            },
            "rightCorner": {
              "x": 27.01,
              "y": 14.096,
              "z": 1.0958
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300257689"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac77",
        "height": 1.3057,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a3b",
            "leftCorner": {
              "x": 25.998,
              "y": 14.081,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.122,
              "y": 14.083,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172438172"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a3c",
            "leftCorner": {
              "x": 26.122,
              "y": 14.083,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.244,
              "y": 14.085,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a3d",
            "leftCorner": {
              "x": 26.244,
              "y": 14.085,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.366,
              "y": 14.087,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437939"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a3e",
            "leftCorner": {
              "x": 26.366,
              "y": 14.087,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.497,
              "y": 14.089,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300406476"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a3f",
            "leftCorner": {
              "x": 26.497,
              "y": 14.089,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.631,
              "y": 14.091,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300406483"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a40",
            "leftCorner": {
              "x": 26.631,
              "y": 14.091,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.76,
              "y": 14.093,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300269880"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a41",
            "leftCorner": {
              "x": 26.76,
              "y": 14.093,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 26.892,
              "y": 14.095,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266179"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a42",
            "leftCorner": {
              "x": 26.892,
              "y": 14.095,
              "z": 1.3057
            },
            "rightCorner": {
              "x": 27.029,
              "y": 14.097,
              "z": 1.3057
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300462892"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac72",
        "height": 1.5176,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a24",
            "leftCorner": {
              "x": 25.993,
              "y": 14.076,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.107,
              "y": 14.078,
              "z": 1.5176
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300266346"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a25",
            "leftCorner": {
              "x": 26.107,
              "y": 14.078,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.209,
              "y": 14.079,
              "z": 1.5176
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300025318"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a26",
            "leftCorner": {
              "x": 26.209,
              "y": 14.079,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.235,
              "y": 14.08,
              "z": 1.5176
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a27",
            "leftCorner": {
              "x": 26.235,
              "y": 14.08,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.362,
              "y": 14.082,
              "z": 1.5176
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300015920"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a28",
            "leftCorner": {
              "x": 26.362,
              "y": 14.082,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.493,
              "y": 14.084,
              "z": 1.5176
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300441453"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a29",
            "leftCorner": {
              "x": 26.493,
              "y": 14.084,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.631,
              "y": 14.086,
              "z": 1.5176
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300441422"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a2a",
            "leftCorner": {
              "x": 26.631,
              "y": 14.086,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.758,
              "y": 14.088,
              "z": 1.5176
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300441316"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a2b",
            "leftCorner": {
              "x": 26.758,
              "y": 14.088,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 26.892,
              "y": 14.09,
              "z": 1.5176
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300441316"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a2c",
            "leftCorner": {
              "x": 26.892,
              "y": 14.09,
              "z": 1.5176
            },
            "rightCorner": {
              "x": 27.022,
              "y": 14.092,
              "z": 1.5176
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300439481"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac76",
        "height": 1.7294,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59b2",
            "leftCorner": {
              "x": 26.008,
              "y": 14.079,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.139,
              "y": 14.081,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300441576"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b3",
            "leftCorner": {
              "x": 26.139,
              "y": 14.081,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.264,
              "y": 14.083,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300020313"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b4",
            "leftCorner": {
              "x": 26.264,
              "y": 14.083,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.393,
              "y": 14.085,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300021112"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b5",
            "leftCorner": {
              "x": 26.393,
              "y": 14.085,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.531,
              "y": 14.087,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300269804"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b6",
            "leftCorner": {
              "x": 26.531,
              "y": 14.087,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.664,
              "y": 14.089,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300123175"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b7",
            "leftCorner": {
              "x": 26.664,
              "y": 14.089,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.791,
              "y": 14.091,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300123205"
          },
          {
            "id": "679afb3e3d9bab0f83ff59b8",
            "leftCorner": {
              "x": 26.791,
              "y": 14.091,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 26.93,
              "y": 14.093,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300309784"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 57,
      "unknownStockCount": 6
    },
    "name": "PXOT",
    "leftNeighborShelfId": "QX44",
    "rightNeighborShelfId": "AD3P"
  },
  {
    "id": "QX44",
    "x": 26.973,
    "y": 14.087,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.0081416,
      "w": 0.99997
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac7e",
        "height": 0.20358,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5972",
            "leftCorner": {
              "x": 27.022,
              "y": 13.985,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.146,
              "y": 13.987,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470659"
          },
          {
            "id": "679afb3e3d9bab0f83ff5973",
            "leftCorner": {
              "x": 27.146,
              "y": 13.987,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.276,
              "y": 13.989,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470918"
          },
          {
            "id": "679afb3e3d9bab0f83ff5974",
            "leftCorner": {
              "x": 27.276,
              "y": 13.989,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.407,
              "y": 13.992,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470895"
          },
          {
            "id": "679afb3e3d9bab0f83ff5975",
            "leftCorner": {
              "x": 27.407,
              "y": 13.992,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.538,
              "y": 13.994,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470857"
          },
          {
            "id": "679afb3e3d9bab0f83ff5976",
            "leftCorner": {
              "x": 27.538,
              "y": 13.994,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.666,
              "y": 13.996,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447160901"
          },
          {
            "id": "679afb3e3d9bab0f83ff5977",
            "leftCorner": {
              "x": 27.666,
              "y": 13.996,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.792,
              "y": 13.998,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172425592"
          },
          {
            "id": "679afb3e3d9bab0f83ff5978",
            "leftCorner": {
              "x": 27.792,
              "y": 13.998,
              "z": 0.20358
            },
            "rightCorner": {
              "x": 27.983,
              "y": 14.001,
              "z": 0.20358
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447520613"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac7d",
        "height": 0.4637,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a5b",
            "leftCorner": {
              "x": 27.01,
              "y": 14.095,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.144,
              "y": 14.097,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030249"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a5c",
            "leftCorner": {
              "x": 27.144,
              "y": 14.097,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.273,
              "y": 14.099,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030171"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a5d",
            "leftCorner": {
              "x": 27.273,
              "y": 14.099,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.404,
              "y": 14.101,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852034056"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a5e",
            "leftCorner": {
              "x": 27.404,
              "y": 14.101,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.533,
              "y": 14.103,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852034117"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a5f",
            "leftCorner": {
              "x": 27.533,
              "y": 14.103,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.665,
              "y": 14.106,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030492"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a60",
            "leftCorner": {
              "x": 27.665,
              "y": 14.106,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.795,
              "y": 14.108,
              "z": 0.4637
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4018852030485"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a61",
            "leftCorner": {
              "x": 27.795,
              "y": 14.108,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.821,
              "y": 14.108,
              "z": 0.4637
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a4a",
            "leftCorner": {
              "x": 27.821,
              "y": 14.108,
              "z": 0.4637
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.111,
              "z": 0.4637
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447228854"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac7a",
        "height": 0.67512,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a7a",
            "leftCorner": {
              "x": 27.004,
              "y": 14.097,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.132,
              "y": 14.099,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519143"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a7b",
            "leftCorner": {
              "x": 27.132,
              "y": 14.099,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.261,
              "y": 14.101,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172795497"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a7c",
            "leftCorner": {
              "x": 27.261,
              "y": 14.101,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.388,
              "y": 14.103,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172795459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a7d",
            "leftCorner": {
              "x": 27.388,
              "y": 14.103,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.515,
              "y": 14.105,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519167"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a7e",
            "leftCorner": {
              "x": 27.515,
              "y": 14.105,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.644,
              "y": 14.107,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208368"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a7f",
            "leftCorner": {
              "x": 27.644,
              "y": 14.107,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.773,
              "y": 14.109,
              "z": 0.67512
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519129"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a72",
            "leftCorner": {
              "x": 27.773,
              "y": 14.109,
              "z": 0.67512
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.113,
              "z": 0.67512
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447208382"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac78",
        "height": 0.88238,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a6b",
            "leftCorner": {
              "x": 27.013,
              "y": 14.094,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.142,
              "y": 14.096,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172260223"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a6c",
            "leftCorner": {
              "x": 27.142,
              "y": 14.096,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.268,
              "y": 14.098,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796041101"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a6d",
            "leftCorner": {
              "x": 27.268,
              "y": 14.098,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.396,
              "y": 14.1,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000031"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a6e",
            "leftCorner": {
              "x": 27.396,
              "y": 14.1,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.522,
              "y": 14.102,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172437793"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a6f",
            "leftCorner": {
              "x": 27.522,
              "y": 14.102,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.651,
              "y": 14.105,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172869662"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a70",
            "leftCorner": {
              "x": 27.651,
              "y": 14.105,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.775,
              "y": 14.107,
              "z": 0.88238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a63",
            "leftCorner": {
              "x": 27.775,
              "y": 14.107,
              "z": 0.88238
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.11,
              "z": 0.88238
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172438318"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac7f",
        "height": 1.0965,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a17",
            "leftCorner": {
              "x": 27.019,
              "y": 14.097,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.15,
              "y": 14.099,
              "z": 1.0965
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266117"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a18",
            "leftCorner": {
              "x": 27.15,
              "y": 14.099,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.347,
              "y": 14.103,
              "z": 1.0965
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300265967"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a19",
            "leftCorner": {
              "x": 27.347,
              "y": 14.103,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.476,
              "y": 14.105,
              "z": 1.0965
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300198838"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a1a",
            "leftCorner": {
              "x": 27.476,
              "y": 14.105,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.605,
              "y": 14.107,
              "z": 1.0965
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300462229"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a1b",
            "leftCorner": {
              "x": 27.605,
              "y": 14.107,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.809,
              "y": 14.11,
              "z": 1.0965
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300261303"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a07",
            "leftCorner": {
              "x": 27.809,
              "y": 14.11,
              "z": 1.0965
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.113,
              "z": 1.0965
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300262515"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac79",
        "height": 1.3039,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a43",
            "leftCorner": {
              "x": 27.039,
              "y": 14.097,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.169,
              "y": 14.099,
              "z": 1.3039
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062300463042"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a44",
            "leftCorner": {
              "x": 27.169,
              "y": 14.099,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.301,
              "y": 14.101,
              "z": 1.3039
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062300259638"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a45",
            "leftCorner": {
              "x": 27.301,
              "y": 14.101,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.43,
              "y": 14.104,
              "z": 1.3039
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266087"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a46",
            "leftCorner": {
              "x": 27.43,
              "y": 14.104,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.558,
              "y": 14.106,
              "z": 1.3039
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300265998"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a47",
            "leftCorner": {
              "x": 27.558,
              "y": 14.106,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.7,
              "y": 14.108,
              "z": 1.3039
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300259829"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a48",
            "leftCorner": {
              "x": 27.7,
              "y": 14.108,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.832,
              "y": 14.11,
              "z": 1.3039
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300253735"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a33",
            "leftCorner": {
              "x": 27.832,
              "y": 14.11,
              "z": 1.3039
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.112,
              "z": 1.3039
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300036710"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac7b",
        "height": 1.5167,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a2d",
            "leftCorner": {
              "x": 27.032,
              "y": 14.09,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.165,
              "y": 14.093,
              "z": 1.5167
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300208254"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a2e",
            "leftCorner": {
              "x": 27.165,
              "y": 14.093,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.297,
              "y": 14.095,
              "z": 1.5167
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300208254"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a2f",
            "leftCorner": {
              "x": 27.297,
              "y": 14.095,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.426,
              "y": 14.097,
              "z": 1.5167
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300266148"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a30",
            "leftCorner": {
              "x": 27.426,
              "y": 14.097,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.618,
              "y": 14.1,
              "z": 1.5167
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300409064"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a31",
            "leftCorner": {
              "x": 27.618,
              "y": 14.1,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.815,
              "y": 14.103,
              "z": 1.5167
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300379657"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a1d",
            "leftCorner": {
              "x": 27.815,
              "y": 14.103,
              "z": 1.5167
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.106,
              "z": 1.5167
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300349445"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac7c",
        "height": 1.7302,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff59b9",
            "leftCorner": {
              "x": 26.93,
              "y": 14.093,
              "z": 1.7294
            },
            "rightCorner": {
              "x": 27.062,
              "y": 14.095,
              "z": 1.7294
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300406490"
          },
          {
            "id": "679afb3e3d9bab0f83ff59ba",
            "leftCorner": {
              "x": 27.071,
              "y": 14.099,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.204,
              "y": 14.101,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300367715"
          },
          {
            "id": "679afb3e3d9bab0f83ff59bb",
            "leftCorner": {
              "x": 27.204,
              "y": 14.101,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.338,
              "y": 14.103,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300321366"
          },
          {
            "id": "679afb3e3d9bab0f83ff59bc",
            "leftCorner": {
              "x": 27.338,
              "y": 14.103,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.466,
              "y": 14.105,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300265295"
          },
          {
            "id": "679afb3e3d9bab0f83ff59bd",
            "leftCorner": {
              "x": 27.466,
              "y": 14.105,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.595,
              "y": 14.108,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300262683"
          },
          {
            "id": "679afb3e3d9bab0f83ff59be",
            "leftCorner": {
              "x": 27.595,
              "y": 14.108,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.724,
              "y": 14.11,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062300379503"
          },
          {
            "id": "679afb3e3d9bab0f83ff59bf",
            "leftCorner": {
              "x": 27.724,
              "y": 14.11,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.863,
              "y": 14.112,
              "z": 1.7302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5982",
            "leftCorner": {
              "x": 27.863,
              "y": 14.112,
              "z": 1.7302
            },
            "rightCorner": {
              "x": 27.973,
              "y": 14.114,
              "z": 1.7302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062300262652"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 46,
      "unknownStockCount": 8
    },
    "name": "QX44",
    "leftNeighborShelfId": "0DV8",
    "rightNeighborShelfId": "PXOT"
  },
  {
    "id": "0DV8",
    "x": 27.991,
    "y": 14.103,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.003297,
      "w": 0.99999
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac82",
        "height": 0.20293,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5979",
            "leftCorner": {
              "x": 28,
              "y": 14.001,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.064,
              "y": 14.001,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172542343"
          },
          {
            "id": "679afb3e3d9bab0f83ff597a",
            "leftCorner": {
              "x": 28.064,
              "y": 14.001,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.1,
              "y": 14.002,
              "z": 0.20293
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172542343"
          },
          {
            "id": "679afb3e3d9bab0f83ff597b",
            "leftCorner": {
              "x": 28.1,
              "y": 14.002,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.191,
              "y": 14.002,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172542367"
          },
          {
            "id": "679afb3e3d9bab0f83ff597c",
            "leftCorner": {
              "x": 28.191,
              "y": 14.002,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.286,
              "y": 14.003,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447228939"
          },
          {
            "id": "679afb3e3d9bab0f83ff597d",
            "leftCorner": {
              "x": 28.286,
              "y": 14.003,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.39,
              "y": 14.004,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172462757"
          },
          {
            "id": "679afb3e3d9bab0f83ff597e",
            "leftCorner": {
              "x": 28.39,
              "y": 14.004,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.552,
              "y": 14.005,
              "z": 0.20293
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447413465"
          },
          {
            "id": "679afb3e3d9bab0f83ff597f",
            "leftCorner": {
              "x": 28.552,
              "y": 14.005,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.661,
              "y": 14.005,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447524208"
          },
          {
            "id": "679afb3e3d9bab0f83ff5980",
            "leftCorner": {
              "x": 28.661,
              "y": 14.005,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.809,
              "y": 14.006,
              "z": 0.20293
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447111293"
          },
          {
            "id": "679afb3e3d9bab0f83ff5945",
            "leftCorner": {
              "x": 28.809,
              "y": 14.006,
              "z": 0.20293
            },
            "rightCorner": {
              "x": 28.992,
              "y": 14.008,
              "z": 0.20293
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000024"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac80",
        "height": 0.65983,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac81",
        "height": 0.91082,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac84",
        "height": 1.1651,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a80",
            "leftCorner": {
              "x": 27.991,
              "y": 14.144,
              "z": 1.1651
            },
            "rightCorner": {
              "x": 28.118,
              "y": 14.145,
              "z": 1.1651
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008600398783"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a81",
            "leftCorner": {
              "x": 28.118,
              "y": 14.145,
              "z": 1.1651
            },
            "rightCorner": {
              "x": 28.991,
              "y": 14.151,
              "z": 1.1651
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008600371465"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac83",
        "height": 1.3832,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 6,
      "unknownStockCount": 5
    },
    "name": "0DV8",
    "leftNeighborShelfId": "CL5L",
    "rightNeighborShelfId": "QX44"
  },
  {
    "id": "CL5L",
    "x": 29.994,
    "y": 14.122,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.00029924,
      "w": 1
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac85",
        "height": 0.20924,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a83",
            "leftCorner": {
              "x": 30.006,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.072,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447680850"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a84",
            "leftCorner": {
              "x": 30.072,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.155,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447452921"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a85",
            "leftCorner": {
              "x": 30.155,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.24,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5414959046852"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a86",
            "leftCorner": {
              "x": 30.24,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.32,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5414959063651"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a87",
            "leftCorner": {
              "x": 30.32,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.386,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009049449524"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a88",
            "leftCorner": {
              "x": 30.386,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.469,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009049451084"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a89",
            "leftCorner": {
              "x": 30.469,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.544,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7630135604656"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a8a",
            "leftCorner": {
              "x": 30.544,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.625,
              "y": 14.023,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7630135603901"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a8b",
            "leftCorner": {
              "x": 30.625,
              "y": 14.023,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.695,
              "y": 14.024,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610465862759"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a8c",
            "leftCorner": {
              "x": 30.695,
              "y": 14.024,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.771,
              "y": 14.024,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610465900246"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a8d",
            "leftCorner": {
              "x": 30.771,
              "y": 14.024,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.854,
              "y": 14.024,
              "z": 0.20924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447212006"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a8e",
            "leftCorner": {
              "x": 30.854,
              "y": 14.024,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.89,
              "y": 14.024,
              "z": 0.20924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a82",
            "leftCorner": {
              "x": 30.89,
              "y": 14.024,
              "z": 0.20924
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.024,
              "z": 0.20924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447619591"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac87",
        "height": 0.51689,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a97",
            "leftCorner": {
              "x": 30.019,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.065,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172535796"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a98",
            "leftCorner": {
              "x": 30.065,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.094,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172535796"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a99",
            "leftCorner": {
              "x": 30.094,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.126,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172535796"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9a",
            "leftCorner": {
              "x": 30.126,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.167,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172535796"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9b",
            "leftCorner": {
              "x": 30.167,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.262,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9c",
            "leftCorner": {
              "x": 30.262,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.335,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172535833"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9d",
            "leftCorner": {
              "x": 30.335,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.402,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382945"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9e",
            "leftCorner": {
              "x": 30.402,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.492,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600307877"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a9f",
            "leftCorner": {
              "x": 30.492,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.564,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600432326"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa0",
            "leftCorner": {
              "x": 30.564,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.638,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600441618"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa1",
            "leftCorner": {
              "x": 30.638,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.708,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600382430"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa2",
            "leftCorner": {
              "x": 30.708,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.78,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600311713"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa3",
            "leftCorner": {
              "x": 30.78,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.853,
              "y": 14.128,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600311713"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa4",
            "leftCorner": {
              "x": 30.853,
              "y": 14.128,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.954,
              "y": 14.129,
              "z": 0.51689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600207320"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a96",
            "leftCorner": {
              "x": 30.954,
              "y": 14.129,
              "z": 0.51689
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.129,
              "z": 0.51689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008600432111"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac89",
        "height": 0.80943,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5aab",
            "leftCorner": {
              "x": 29.994,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.033,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aad",
            "leftCorner": {
              "x": 30.033,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.143,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600372639"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aae",
            "leftCorner": {
              "x": 30.143,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.251,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008600251101"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aaf",
            "leftCorner": {
              "x": 30.251,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.367,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600350743"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab0",
            "leftCorner": {
              "x": 30.367,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.486,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600307839"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab1",
            "leftCorner": {
              "x": 30.486,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.588,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600307914"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab2",
            "leftCorner": {
              "x": 30.588,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.681,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600441694"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab3",
            "leftCorner": {
              "x": 30.681,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.804,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710103781837"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab4",
            "leftCorner": {
              "x": 30.804,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.914,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710103781943"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aac",
            "leftCorner": {
              "x": 30.914,
              "y": 14.132,
              "z": 0.80943
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.132,
              "z": 0.80943
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4000821370692"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac8a",
        "height": 1.0606,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ab6",
            "leftCorner": {
              "x": 29.999,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.162,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796077599"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab7",
            "leftCorner": {
              "x": 30.162,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.374,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447442236"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab8",
            "leftCorner": {
              "x": 30.374,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.5,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447442267"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab9",
            "leftCorner": {
              "x": 30.5,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.606,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447442298"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aba",
            "leftCorner": {
              "x": 30.606,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.699,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720294053286"
          },
          {
            "id": "679afb3e3d9bab0f83ff5abb",
            "leftCorner": {
              "x": 30.699,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.794,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5abc",
            "leftCorner": {
              "x": 30.794,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.827,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5abd",
            "leftCorner": {
              "x": 30.827,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.927,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "NO_STOCK",
            "gtin": "8720294053316"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ab5",
            "leftCorner": {
              "x": 30.927,
              "y": 14.132,
              "z": 1.0606
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.132,
              "z": 1.0606
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720294053309"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac88",
        "height": 1.2693,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5aa5",
            "leftCorner": {
              "x": 29.994,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.235,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172603617"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa7",
            "leftCorner": {
              "x": 30.235,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.392,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172603945"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa8",
            "leftCorner": {
              "x": 30.392,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.539,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172786174"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa9",
            "leftCorner": {
              "x": 30.539,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.67,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000042"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aaa",
            "leftCorner": {
              "x": 30.67,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.9,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506815"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aa6",
            "leftCorner": {
              "x": 30.9,
              "y": 14.133,
              "z": 1.2693
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.133,
              "z": 1.2693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172630590"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac86",
        "height": 1.4827,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5a8f",
            "leftCorner": {
              "x": 29.994,
              "y": 14.135,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.096,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517651"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a91",
            "leftCorner": {
              "x": 30.096,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.269,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172832802"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a92",
            "leftCorner": {
              "x": 30.269,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.456,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172972133"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a93",
            "leftCorner": {
              "x": 30.456,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.596,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000821370630"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a94",
            "leftCorner": {
              "x": 30.596,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.728,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000821370630"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a95",
            "leftCorner": {
              "x": 30.728,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.769,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5a90",
            "leftCorner": {
              "x": 30.769,
              "y": 14.136,
              "z": 1.4827
            },
            "rightCorner": {
              "x": 30.994,
              "y": 14.136,
              "z": 1.4827
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447626681"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 44,
      "unknownStockCount": 15
    },
    "name": "CL5L",
    "leftNeighborShelfId": "J2NF",
    "rightNeighborShelfId": "0DV8"
  },
  {
    "id": "6267",
    "x": 35.12,
    "y": 11.038,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.91735,
      "w": -0.39808
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac8c",
        "height": 0.18762,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5acb",
            "leftCorner": {
              "x": 35.049,
              "y": 11.104,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 35.009,
              "y": 11.062,
              "z": 0.18762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447353181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5acd",
            "leftCorner": {
              "x": 35.009,
              "y": 11.062,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.962,
              "y": 11.011,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447353181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ace",
            "leftCorner": {
              "x": 34.962,
              "y": 11.011,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.907,
              "y": 10.953,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260742566011"
          },
          {
            "id": "679afb3e3d9bab0f83ff5acf",
            "leftCorner": {
              "x": 34.907,
              "y": 10.953,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.856,
              "y": 10.898,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796085013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad0",
            "leftCorner": {
              "x": 34.856,
              "y": 10.898,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.802,
              "y": 10.841,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796085013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad1",
            "leftCorner": {
              "x": 34.802,
              "y": 10.841,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.75,
              "y": 10.785,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796085013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad2",
            "leftCorner": {
              "x": 34.75,
              "y": 10.785,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.696,
              "y": 10.727,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447328851"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad3",
            "leftCorner": {
              "x": 34.696,
              "y": 10.727,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.646,
              "y": 10.674,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172287459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad4",
            "leftCorner": {
              "x": 34.646,
              "y": 10.674,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.595,
              "y": 10.619,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172287459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad5",
            "leftCorner": {
              "x": 34.595,
              "y": 10.619,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.461,
              "y": 10.476,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172268717"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad6",
            "leftCorner": {
              "x": 34.461,
              "y": 10.476,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.407,
              "y": 10.418,
              "z": 0.18762
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5acc",
            "leftCorner": {
              "x": 34.407,
              "y": 10.418,
              "z": 0.18762
            },
            "rightCorner": {
              "x": 34.366,
              "y": 10.374,
              "z": 0.18762
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac8b",
        "height": 0.53782,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5abf",
            "leftCorner": {
              "x": 35.115,
              "y": 11.008,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 35.072,
              "y": 10.963,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447518238"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac0",
            "leftCorner": {
              "x": 35.072,
              "y": 10.963,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 35.027,
              "y": 10.915,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674138"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac1",
            "leftCorner": {
              "x": 35.027,
              "y": 10.915,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.983,
              "y": 10.868,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674138"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac2",
            "leftCorner": {
              "x": 34.983,
              "y": 10.868,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.94,
              "y": 10.822,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674107"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac3",
            "leftCorner": {
              "x": 34.94,
              "y": 10.822,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.89,
              "y": 10.768,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac4",
            "leftCorner": {
              "x": 34.89,
              "y": 10.768,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.833,
              "y": 10.707,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac5",
            "leftCorner": {
              "x": 34.833,
              "y": 10.707,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.774,
              "y": 10.644,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac6",
            "leftCorner": {
              "x": 34.774,
              "y": 10.644,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.728,
              "y": 10.595,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143674121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac7",
            "leftCorner": {
              "x": 34.728,
              "y": 10.595,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.67,
              "y": 10.533,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265316"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac8",
            "leftCorner": {
              "x": 34.67,
              "y": 10.533,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.615,
              "y": 10.474,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265316"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ac9",
            "leftCorner": {
              "x": 34.615,
              "y": 10.474,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.561,
              "y": 10.416,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265330"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aca",
            "leftCorner": {
              "x": 34.561,
              "y": 10.416,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.512,
              "y": 10.363,
              "z": 0.53782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265330"
          },
          {
            "id": "679afb3e3d9bab0f83ff5abe",
            "leftCorner": {
              "x": 34.512,
              "y": 10.363,
              "z": 0.53782
            },
            "rightCorner": {
              "x": 34.449,
              "y": 10.296,
              "z": 0.53782
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172788079"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac8d",
        "height": 0.74666,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ad7",
            "leftCorner": {
              "x": 35.134,
              "y": 11.025,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 35.086,
              "y": 10.974,
              "z": 0.74666
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172989308"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad9",
            "leftCorner": {
              "x": 35.086,
              "y": 10.974,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 35.029,
              "y": 10.912,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172989308"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ada",
            "leftCorner": {
              "x": 35.029,
              "y": 10.912,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.97,
              "y": 10.849,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172989308"
          },
          {
            "id": "679afb3e3d9bab0f83ff5adb",
            "leftCorner": {
              "x": 34.97,
              "y": 10.849,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.915,
              "y": 10.791,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172989308"
          },
          {
            "id": "679afb3e3d9bab0f83ff5adc",
            "leftCorner": {
              "x": 34.915,
              "y": 10.791,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.859,
              "y": 10.73,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172989285"
          },
          {
            "id": "679afb3e3d9bab0f83ff5add",
            "leftCorner": {
              "x": 34.859,
              "y": 10.73,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.798,
              "y": 10.665,
              "z": 0.74666
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ade",
            "leftCorner": {
              "x": 34.798,
              "y": 10.665,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.734,
              "y": 10.597,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172943591"
          },
          {
            "id": "679afb3e3d9bab0f83ff5adf",
            "leftCorner": {
              "x": 34.734,
              "y": 10.597,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.674,
              "y": 10.533,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172943591"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae0",
            "leftCorner": {
              "x": 34.674,
              "y": 10.533,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.615,
              "y": 10.47,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796061901"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae1",
            "leftCorner": {
              "x": 34.615,
              "y": 10.47,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.555,
              "y": 10.405,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172814327"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae2",
            "leftCorner": {
              "x": 34.555,
              "y": 10.405,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.494,
              "y": 10.34,
              "z": 0.74666
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172814327"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ad8",
            "leftCorner": {
              "x": 34.494,
              "y": 10.34,
              "z": 0.74666
            },
            "rightCorner": {
              "x": 34.451,
              "y": 10.294,
              "z": 0.74666
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796075892"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac8f",
        "height": 0.99155,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5af0",
            "leftCorner": {
              "x": 35.123,
              "y": 11.012,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 35.065,
              "y": 10.95,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250073450639"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af1",
            "leftCorner": {
              "x": 35.065,
              "y": 10.95,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 35.006,
              "y": 10.887,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250073450639"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af2",
            "leftCorner": {
              "x": 35.006,
              "y": 10.887,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.952,
              "y": 10.829,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250073450653"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af3",
            "leftCorner": {
              "x": 34.952,
              "y": 10.829,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.893,
              "y": 10.766,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250073450653"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af4",
            "leftCorner": {
              "x": 34.893,
              "y": 10.766,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.846,
              "y": 10.716,
              "z": 0.99155
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172266263"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af5",
            "leftCorner": {
              "x": 34.846,
              "y": 10.716,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.797,
              "y": 10.664,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796013702"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af6",
            "leftCorner": {
              "x": 34.797,
              "y": 10.664,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.743,
              "y": 10.605,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447367270"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af7",
            "leftCorner": {
              "x": 34.743,
              "y": 10.605,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.693,
              "y": 10.552,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447367270"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af8",
            "leftCorner": {
              "x": 34.693,
              "y": 10.552,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.651,
              "y": 10.508,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143671168"
          },
          {
            "id": "679afb3e3d9bab0f83ff5af9",
            "leftCorner": {
              "x": 34.651,
              "y": 10.508,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.613,
              "y": 10.467,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7640143671168"
          },
          {
            "id": "679afb3e3d9bab0f83ff5afa",
            "leftCorner": {
              "x": 34.613,
              "y": 10.467,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.57,
              "y": 10.421,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5afb",
            "leftCorner": {
              "x": 34.57,
              "y": 10.421,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.528,
              "y": 10.376,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075359"
          },
          {
            "id": "679afb3e3d9bab0f83ff5afc",
            "leftCorner": {
              "x": 34.528,
              "y": 10.376,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.489,
              "y": 10.334,
              "z": 0.99155
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075359"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aef",
            "leftCorner": {
              "x": 34.489,
              "y": 10.334,
              "z": 0.99155
            },
            "rightCorner": {
              "x": 34.451,
              "y": 10.294,
              "z": 0.99155
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447075335"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac90",
        "height": 1.2079,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5afd",
            "leftCorner": {
              "x": 35.132,
              "y": 11.027,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 35.097,
              "y": 10.989,
              "z": 1.2079
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aff",
            "leftCorner": {
              "x": 35.097,
              "y": 10.989,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 35.046,
              "y": 10.935,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447614503"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b00",
            "leftCorner": {
              "x": 35.046,
              "y": 10.935,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.998,
              "y": 10.883,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796072464"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b01",
            "leftCorner": {
              "x": 34.998,
              "y": 10.883,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.954,
              "y": 10.837,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796072464"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b02",
            "leftCorner": {
              "x": 34.954,
              "y": 10.837,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.916,
              "y": 10.796,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172349287"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b03",
            "leftCorner": {
              "x": 34.916,
              "y": 10.796,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.874,
              "y": 10.751,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172349287"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b04",
            "leftCorner": {
              "x": 34.874,
              "y": 10.751,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.833,
              "y": 10.707,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172349263"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b05",
            "leftCorner": {
              "x": 34.833,
              "y": 10.707,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.781,
              "y": 10.651,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447486155"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b06",
            "leftCorner": {
              "x": 34.781,
              "y": 10.651,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.728,
              "y": 10.595,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447486155"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b07",
            "leftCorner": {
              "x": 34.728,
              "y": 10.595,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.683,
              "y": 10.546,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709605"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b08",
            "leftCorner": {
              "x": 34.683,
              "y": 10.546,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.631,
              "y": 10.491,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447709605"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b09",
            "leftCorner": {
              "x": 34.631,
              "y": 10.491,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.583,
              "y": 10.44,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172921544"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b0a",
            "leftCorner": {
              "x": 34.583,
              "y": 10.44,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.533,
              "y": 10.387,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172921544"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b0b",
            "leftCorner": {
              "x": 34.533,
              "y": 10.387,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.485,
              "y": 10.335,
              "z": 1.2079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796010831"
          },
          {
            "id": "679afb3e3d9bab0f83ff5afe",
            "leftCorner": {
              "x": 34.485,
              "y": 10.335,
              "z": 1.2079
            },
            "rightCorner": {
              "x": 34.449,
              "y": 10.296,
              "z": 1.2079
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796010831"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac8e",
        "height": 1.4163,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ae3",
            "leftCorner": {
              "x": 35.114,
              "y": 10.997,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 35.066,
              "y": 10.945,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447465679"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae4",
            "leftCorner": {
              "x": 35.066,
              "y": 10.945,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 35.014,
              "y": 10.89,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796065558"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae5",
            "leftCorner": {
              "x": 35.014,
              "y": 10.89,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.952,
              "y": 10.823,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447673012"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae6",
            "leftCorner": {
              "x": 34.952,
              "y": 10.823,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.868,
              "y": 10.733,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447717969"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae7",
            "leftCorner": {
              "x": 34.868,
              "y": 10.733,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.819,
              "y": 10.681,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447717969"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae8",
            "leftCorner": {
              "x": 34.819,
              "y": 10.681,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.765,
              "y": 10.623,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ae9",
            "leftCorner": {
              "x": 34.765,
              "y": 10.623,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.714,
              "y": 10.569,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172513978"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aea",
            "leftCorner": {
              "x": 34.714,
              "y": 10.569,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.666,
              "y": 10.517,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070040"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aeb",
            "leftCorner": {
              "x": 34.666,
              "y": 10.517,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.616,
              "y": 10.464,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796066265"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aec",
            "leftCorner": {
              "x": 34.616,
              "y": 10.464,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.567,
              "y": 10.412,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383119"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aed",
            "leftCorner": {
              "x": 34.567,
              "y": 10.412,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.514,
              "y": 10.355,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5aee",
            "leftCorner": {
              "x": 34.514,
              "y": 10.355,
              "z": 1.4163
            },
            "rightCorner": {
              "x": 34.465,
              "y": 10.302,
              "z": 1.4163
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 68,
      "unknownStockCount": 10
    },
    "name": "6267",
    "leftNeighborShelfId": "U1V2",
    "rightNeighborShelfId": "QUSR"
  },
  {
    "id": "7YAR",
    "x": 33.744,
    "y": 9.5706,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.91659,
      "w": -0.39983
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac92",
        "height": 0.19445,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b19",
            "leftCorner": {
              "x": 33.667,
              "y": 9.6413,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.607,
              "y": 9.5759,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339235102"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1a",
            "leftCorner": {
              "x": 33.607,
              "y": 9.5759,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.554,
              "y": 9.5186,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339226209"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1b",
            "leftCorner": {
              "x": 33.554,
              "y": 9.5186,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.496,
              "y": 9.4568,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447758733"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1c",
            "leftCorner": {
              "x": 33.496,
              "y": 9.4568,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.436,
              "y": 9.3918,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172389481"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1d",
            "leftCorner": {
              "x": 33.436,
              "y": 9.3918,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.378,
              "y": 9.3296,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172716232"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1e",
            "leftCorner": {
              "x": 33.378,
              "y": 9.3296,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.325,
              "y": 9.272,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172716232"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b1f",
            "leftCorner": {
              "x": 33.325,
              "y": 9.272,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.242,
              "y": 9.183,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447672688"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b20",
            "leftCorner": {
              "x": 33.242,
              "y": 9.183,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.181,
              "y": 9.1168,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447511109"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b21",
            "leftCorner": {
              "x": 33.181,
              "y": 9.1168,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.118,
              "y": 9.049,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447511109"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b22",
            "leftCorner": {
              "x": 33.118,
              "y": 9.049,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 33.058,
              "y": 8.985,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447511109"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b23",
            "leftCorner": {
              "x": 33.058,
              "y": 8.985,
              "z": 0.19445
            },
            "rightCorner": {
              "x": 32.986,
              "y": 8.9067,
              "z": 0.19445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447510089"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac95",
        "height": 0.41127,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b38",
            "leftCorner": {
              "x": 33.747,
              "y": 9.5678,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.691,
              "y": 9.5069,
              "z": 0.41127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172389528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b39",
            "leftCorner": {
              "x": 33.691,
              "y": 9.5069,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.633,
              "y": 9.4452,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172389528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3a",
            "leftCorner": {
              "x": 33.633,
              "y": 9.4452,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.574,
              "y": 9.3809,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447619911"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3b",
            "leftCorner": {
              "x": 33.574,
              "y": 9.3809,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.516,
              "y": 9.3191,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000045"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3c",
            "leftCorner": {
              "x": 33.516,
              "y": 9.3191,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.461,
              "y": 9.2595,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172389542"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3d",
            "leftCorner": {
              "x": 33.461,
              "y": 9.2595,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.404,
              "y": 9.1981,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447576283"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3e",
            "leftCorner": {
              "x": 33.404,
              "y": 9.1981,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.355,
              "y": 9.1447,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447576283"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b3f",
            "leftCorner": {
              "x": 33.355,
              "y": 9.1447,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.3,
              "y": 9.0858,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172470158"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b40",
            "leftCorner": {
              "x": 33.3,
              "y": 9.0858,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.243,
              "y": 9.0249,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172470158"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b41",
            "leftCorner": {
              "x": 33.243,
              "y": 9.0249,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.191,
              "y": 8.9685,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172389863"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b42",
            "leftCorner": {
              "x": 33.191,
              "y": 8.9685,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.123,
              "y": 8.895,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783278"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b43",
            "leftCorner": {
              "x": 33.123,
              "y": 8.895,
              "z": 0.41127
            },
            "rightCorner": {
              "x": 33.074,
              "y": 8.8427,
              "z": 0.41127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783278"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac97",
        "height": 0.62547,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b4f",
            "leftCorner": {
              "x": 33.745,
              "y": 9.5698,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.653,
              "y": 9.4707,
              "z": 0.62547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172620997"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b50",
            "leftCorner": {
              "x": 33.653,
              "y": 9.4707,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.597,
              "y": 9.4101,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b51",
            "leftCorner": {
              "x": 33.597,
              "y": 9.4101,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.539,
              "y": 9.3479,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b52",
            "leftCorner": {
              "x": 33.539,
              "y": 9.3479,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.485,
              "y": 9.2895,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b53",
            "leftCorner": {
              "x": 33.485,
              "y": 9.2895,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.428,
              "y": 9.228,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b54",
            "leftCorner": {
              "x": 33.428,
              "y": 9.228,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.372,
              "y": 9.168,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327885"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b55",
            "leftCorner": {
              "x": 33.372,
              "y": 9.168,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.315,
              "y": 9.1061,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b56",
            "leftCorner": {
              "x": 33.315,
              "y": 9.1061,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.265,
              "y": 9.0524,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373189"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b57",
            "leftCorner": {
              "x": 33.265,
              "y": 9.0524,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.216,
              "y": 9.0002,
              "z": 0.62547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447373141"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b58",
            "leftCorner": {
              "x": 33.216,
              "y": 9.0002,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.165,
              "y": 8.9443,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373165"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b59",
            "leftCorner": {
              "x": 33.165,
              "y": 8.9443,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.116,
              "y": 8.8914,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339487150"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b5a",
            "leftCorner": {
              "x": 33.116,
              "y": 8.8914,
              "z": 0.62547
            },
            "rightCorner": {
              "x": 33.061,
              "y": 8.8328,
              "z": 0.62547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339487129"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac91",
        "height": 0.91491,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b0c",
            "leftCorner": {
              "x": 33.748,
              "y": 9.5667,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.693,
              "y": 9.5071,
              "z": 0.91491
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260195540293"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b0e",
            "leftCorner": {
              "x": 33.693,
              "y": 9.5071,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.639,
              "y": 9.4493,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260195540286"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b0f",
            "leftCorner": {
              "x": 33.639,
              "y": 9.4493,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.586,
              "y": 9.3914,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260189683609"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b10",
            "leftCorner": {
              "x": 33.586,
              "y": 9.3914,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.533,
              "y": 9.3342,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260189683630"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b11",
            "leftCorner": {
              "x": 33.533,
              "y": 9.3342,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.481,
              "y": 9.2789,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172469558"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b12",
            "leftCorner": {
              "x": 33.481,
              "y": 9.2789,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.43,
              "y": 9.2232,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172469534"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b13",
            "leftCorner": {
              "x": 33.43,
              "y": 9.2232,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.377,
              "y": 9.1664,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172824470"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b14",
            "leftCorner": {
              "x": 33.377,
              "y": 9.1664,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.327,
              "y": 9.1124,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172824470"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b15",
            "leftCorner": {
              "x": 33.327,
              "y": 9.1124,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.275,
              "y": 9.0571,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366204"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b16",
            "leftCorner": {
              "x": 33.275,
              "y": 9.0571,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.224,
              "y": 9.002,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366204"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b17",
            "leftCorner": {
              "x": 33.224,
              "y": 9.002,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.173,
              "y": 8.9469,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447575729"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b18",
            "leftCorner": {
              "x": 33.173,
              "y": 8.9469,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.12,
              "y": 8.8895,
              "z": 0.91491
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447575729"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b0d",
            "leftCorner": {
              "x": 33.12,
              "y": 8.8895,
              "z": 0.91491
            },
            "rightCorner": {
              "x": 33.068,
              "y": 8.8338,
              "z": 0.91491
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172960246"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac93",
        "height": 1.2139,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b24",
            "leftCorner": {
              "x": 33.746,
              "y": 9.5687,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.638,
              "y": 9.4516,
              "z": 1.2139
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4019339641170"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b26",
            "leftCorner": {
              "x": 33.638,
              "y": 9.4516,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.567,
              "y": 9.3758,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646168"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b27",
            "leftCorner": {
              "x": 33.567,
              "y": 9.3758,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.5,
              "y": 9.3027,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646120"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b28",
            "leftCorner": {
              "x": 33.5,
              "y": 9.3027,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.431,
              "y": 9.2285,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646014"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b29",
            "leftCorner": {
              "x": 33.431,
              "y": 9.2285,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.362,
              "y": 9.1546,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646113"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b2a",
            "leftCorner": {
              "x": 33.362,
              "y": 9.1546,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.294,
              "y": 9.0811,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646052"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b2b",
            "leftCorner": {
              "x": 33.294,
              "y": 9.0811,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.227,
              "y": 9.0096,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4019339646007"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b2c",
            "leftCorner": {
              "x": 33.227,
              "y": 9.0096,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.153,
              "y": 8.9292,
              "z": 1.2139
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005394287675"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b25",
            "leftCorner": {
              "x": 33.153,
              "y": 8.9292,
              "z": 1.2139
            },
            "rightCorner": {
              "x": 33.066,
              "y": 8.8357,
              "z": 1.2139
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005394287866"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac96",
        "height": 1.4667,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b44",
            "leftCorner": {
              "x": 33.746,
              "y": 9.5686,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.679,
              "y": 9.4957,
              "z": 1.4667
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506235"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b46",
            "leftCorner": {
              "x": 33.679,
              "y": 9.4957,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.613,
              "y": 9.425,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506235"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b47",
            "leftCorner": {
              "x": 33.613,
              "y": 9.425,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.549,
              "y": 9.3557,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796067101"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b48",
            "leftCorner": {
              "x": 33.549,
              "y": 9.3557,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.485,
              "y": 9.2867,
              "z": 1.4667
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447422603"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b49",
            "leftCorner": {
              "x": 33.485,
              "y": 9.2867,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.421,
              "y": 9.2179,
              "z": 1.4667
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4067796066883"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b4a",
            "leftCorner": {
              "x": 33.421,
              "y": 9.2179,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.361,
              "y": 9.1532,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447470574"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b4b",
            "leftCorner": {
              "x": 33.361,
              "y": 9.1532,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.304,
              "y": 9.0923,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002188"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b4c",
            "leftCorner": {
              "x": 33.304,
              "y": 9.0923,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.25,
              "y": 9.0337,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447580617"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b4d",
            "leftCorner": {
              "x": 33.25,
              "y": 9.0337,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.202,
              "y": 8.9819,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447570007"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b4e",
            "leftCorner": {
              "x": 33.202,
              "y": 8.9819,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.148,
              "y": 8.9237,
              "z": 1.4667
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796066418"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b45",
            "leftCorner": {
              "x": 33.148,
              "y": 8.9237,
              "z": 1.4667
            },
            "rightCorner": {
              "x": 33.066,
              "y": 8.8357,
              "z": 1.4667
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005394287682"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac94",
        "height": 1.6766,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b2d",
            "leftCorner": {
              "x": 33.75,
              "y": 9.5656,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.692,
              "y": 9.5033,
              "z": 1.6766
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447185324"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b2f",
            "leftCorner": {
              "x": 33.692,
              "y": 9.5033,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.646,
              "y": 9.4542,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375886"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b30",
            "leftCorner": {
              "x": 33.646,
              "y": 9.4542,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.569,
              "y": 9.3712,
              "z": 1.6766
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447395976"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b31",
            "leftCorner": {
              "x": 33.569,
              "y": 9.3712,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.521,
              "y": 9.3189,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080599"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b32",
            "leftCorner": {
              "x": 33.521,
              "y": 9.3189,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.451,
              "y": 9.2435,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373103"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b33",
            "leftCorner": {
              "x": 33.451,
              "y": 9.2435,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.363,
              "y": 9.149,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377941"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b34",
            "leftCorner": {
              "x": 33.363,
              "y": 9.149,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.303,
              "y": 9.0842,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014829743006"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b35",
            "leftCorner": {
              "x": 33.303,
              "y": 9.0842,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.25,
              "y": 9.0269,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600612"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b36",
            "leftCorner": {
              "x": 33.25,
              "y": 9.0269,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.196,
              "y": 8.969,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600612"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b37",
            "leftCorner": {
              "x": 33.196,
              "y": 8.969,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.135,
              "y": 8.9036,
              "z": 1.6766
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519662"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b2e",
            "leftCorner": {
              "x": 33.135,
              "y": 8.9036,
              "z": 1.6766
            },
            "rightCorner": {
              "x": 33.069,
              "y": 8.8326,
              "z": 1.6766
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447519662"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 65,
      "unknownStockCount": 13
    },
    "name": "7YAR",
    "leftNeighborShelfId": "CJ5U",
    "rightNeighborShelfId": "84HF"
  },
  {
    "id": "3LN7",
    "x": 31.694,
    "y": 7.383,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.9147,
      "w": -0.40413
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ac9c",
        "height": 0.19506,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff548a",
            "leftCorner": {
              "x": 31.633,
              "y": 7.4674,
              "z": 0.19697
            },
            "rightCorner": {
              "x": 31.581,
              "y": 7.412,
              "z": 0.19697
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411584"
          },
          {
            "id": "679afb3d3d9bab0f83ff548b",
            "leftCorner": {
              "x": 31.576,
              "y": 7.4068,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.524,
              "y": 7.3497,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411584"
          },
          {
            "id": "679afb3d3d9bab0f83ff548c",
            "leftCorner": {
              "x": 31.524,
              "y": 7.3497,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.458,
              "y": 7.2776,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4101530007418"
          },
          {
            "id": "679afb3d3d9bab0f83ff548d",
            "leftCorner": {
              "x": 31.458,
              "y": 7.2776,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.393,
              "y": 7.2067,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4101530007418"
          },
          {
            "id": "679afb3d3d9bab0f83ff548e",
            "leftCorner": {
              "x": 31.393,
              "y": 7.2067,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.328,
              "y": 7.1344,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4101530007401"
          },
          {
            "id": "679afb3d3d9bab0f83ff548f",
            "leftCorner": {
              "x": 31.328,
              "y": 7.1344,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.262,
              "y": 7.0627,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4101530007401"
          },
          {
            "id": "679afb3d3d9bab0f83ff5490",
            "leftCorner": {
              "x": 31.262,
              "y": 7.0627,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.204,
              "y": 6.9991,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506198"
          },
          {
            "id": "679afb3d3d9bab0f83ff5491",
            "leftCorner": {
              "x": 31.204,
              "y": 6.9991,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.147,
              "y": 6.9357,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506198"
          },
          {
            "id": "679afb3d3d9bab0f83ff5492",
            "leftCorner": {
              "x": 31.147,
              "y": 6.9357,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.093,
              "y": 6.8766,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506198"
          },
          {
            "id": "679afb3d3d9bab0f83ff5493",
            "leftCorner": {
              "x": 31.093,
              "y": 6.8766,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 31.041,
              "y": 6.8198,
              "z": 0.19506
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506211"
          },
          {
            "id": "679afb3d3d9bab0f83ff5494",
            "leftCorner": {
              "x": 31.041,
              "y": 6.8198,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 30.99,
              "y": 6.7634,
              "z": 0.19506
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506211"
          },
          {
            "id": "679afb3d3d9bab0f83ff547d",
            "leftCorner": {
              "x": 30.99,
              "y": 6.7634,
              "z": 0.19506
            },
            "rightCorner": {
              "x": 30.944,
              "y": 6.7134,
              "z": 0.19506
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447506211"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac9d",
        "height": 0.4584,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54f8",
            "leftCorner": {
              "x": 31.737,
              "y": 7.4205,
              "z": 0.45454
            },
            "rightCorner": {
              "x": 31.675,
              "y": 7.3546,
              "z": 0.45454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001983"
          },
          {
            "id": "679afb3d3d9bab0f83ff54f9",
            "leftCorner": {
              "x": 31.672,
              "y": 7.35,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.614,
              "y": 7.287,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001983"
          },
          {
            "id": "679afb3d3d9bab0f83ff54fa",
            "leftCorner": {
              "x": 31.614,
              "y": 7.287,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.561,
              "y": 7.2283,
              "z": 0.4584
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4067796001983"
          },
          {
            "id": "679afb3d3d9bab0f83ff54fb",
            "leftCorner": {
              "x": 31.561,
              "y": 7.2283,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.507,
              "y": 7.1692,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564358"
          },
          {
            "id": "679afb3d3d9bab0f83ff54fc",
            "leftCorner": {
              "x": 31.507,
              "y": 7.1692,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.46,
              "y": 7.1178,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564358"
          },
          {
            "id": "679afb3d3d9bab0f83ff54fd",
            "leftCorner": {
              "x": 31.46,
              "y": 7.1178,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.401,
              "y": 7.0524,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564358"
          },
          {
            "id": "679afb3d3d9bab0f83ff54fe",
            "leftCorner": {
              "x": 31.401,
              "y": 7.0524,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.347,
              "y": 6.9938,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ff",
            "leftCorner": {
              "x": 31.347,
              "y": 6.9938,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.292,
              "y": 6.9324,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447123173"
          },
          {
            "id": "679afb3d3d9bab0f83ff5500",
            "leftCorner": {
              "x": 31.292,
              "y": 6.9324,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.254,
              "y": 6.8911,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447123173"
          },
          {
            "id": "679afb3d3d9bab0f83ff5501",
            "leftCorner": {
              "x": 31.254,
              "y": 6.8911,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.236,
              "y": 6.8718,
              "z": 0.4584
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5502",
            "leftCorner": {
              "x": 31.236,
              "y": 6.8718,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.184,
              "y": 6.8147,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5503",
            "leftCorner": {
              "x": 31.184,
              "y": 6.8147,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.129,
              "y": 6.7536,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5504",
            "leftCorner": {
              "x": 31.129,
              "y": 6.7536,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.07,
              "y": 6.6888,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447051506"
          },
          {
            "id": "679afb3d3d9bab0f83ff5505",
            "leftCorner": {
              "x": 31.07,
              "y": 6.6888,
              "z": 0.4584
            },
            "rightCorner": {
              "x": 31.029,
              "y": 6.6439,
              "z": 0.4584
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac98",
        "height": 0.75339,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54b8",
            "leftCorner": {
              "x": 31.669,
              "y": 7.3449,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.616,
              "y": 7.2862,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375026116"
          },
          {
            "id": "679afb3d3d9bab0f83ff54b9",
            "leftCorner": {
              "x": 31.616,
              "y": 7.2862,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.56,
              "y": 7.2249,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375026116"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ba",
            "leftCorner": {
              "x": 31.56,
              "y": 7.2249,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.505,
              "y": 7.165,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375026116"
          },
          {
            "id": "679afb3d3d9bab0f83ff54bb",
            "leftCorner": {
              "x": 31.505,
              "y": 7.165,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.451,
              "y": 7.1056,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375024396"
          },
          {
            "id": "679afb3d3d9bab0f83ff54bc",
            "leftCorner": {
              "x": 31.451,
              "y": 7.1056,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.4,
              "y": 7.0493,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375024396"
          },
          {
            "id": "679afb3d3d9bab0f83ff54bd",
            "leftCorner": {
              "x": 31.4,
              "y": 7.0493,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.348,
              "y": 6.9917,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4038375024396"
          },
          {
            "id": "679afb3d3d9bab0f83ff54be",
            "leftCorner": {
              "x": 31.348,
              "y": 6.9917,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.29,
              "y": 6.929,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54bf",
            "leftCorner": {
              "x": 31.29,
              "y": 6.929,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.233,
              "y": 6.8663,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003488000100"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c0",
            "leftCorner": {
              "x": 31.233,
              "y": 6.8663,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.178,
              "y": 6.8055,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003488000100"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c1",
            "leftCorner": {
              "x": 31.178,
              "y": 6.8055,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.119,
              "y": 6.7408,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003488000100"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c2",
            "leftCorner": {
              "x": 31.119,
              "y": 6.7408,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.064,
              "y": 6.6807,
              "z": 0.75339
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003488000100"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ac",
            "leftCorner": {
              "x": 31.064,
              "y": 6.6807,
              "z": 0.75339
            },
            "rightCorner": {
              "x": 31.026,
              "y": 6.6388,
              "z": 0.75339
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac99",
        "height": 1.0451,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54a1",
            "leftCorner": {
              "x": 31.67,
              "y": 7.3443,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.614,
              "y": 7.2831,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000044"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a2",
            "leftCorner": {
              "x": 31.614,
              "y": 7.2831,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.561,
              "y": 7.2247,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447372694"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a3",
            "leftCorner": {
              "x": 31.561,
              "y": 7.2247,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.507,
              "y": 7.1657,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447372694"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a4",
            "leftCorner": {
              "x": 31.507,
              "y": 7.1657,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.444,
              "y": 7.0965,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485572"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a5",
            "leftCorner": {
              "x": 31.444,
              "y": 7.0965,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.376,
              "y": 7.0213,
              "z": 1.0451
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172485572"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a6",
            "leftCorner": {
              "x": 31.376,
              "y": 7.0213,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.323,
              "y": 6.963,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260248060044"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a7",
            "leftCorner": {
              "x": 31.323,
              "y": 6.963,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.266,
              "y": 6.9009,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260248060044"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a8",
            "leftCorner": {
              "x": 31.266,
              "y": 6.9009,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.21,
              "y": 6.8395,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407950926"
          },
          {
            "id": "679afb3d3d9bab0f83ff54a9",
            "leftCorner": {
              "x": 31.21,
              "y": 6.8395,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.149,
              "y": 6.7721,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407953804"
          },
          {
            "id": "679afb3d3d9bab0f83ff54aa",
            "leftCorner": {
              "x": 31.149,
              "y": 6.7721,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.082,
              "y": 6.6984,
              "z": 1.0451
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407953804"
          },
          {
            "id": "679afb3d3d9bab0f83ff5496",
            "leftCorner": {
              "x": 31.082,
              "y": 6.6984,
              "z": 1.0451
            },
            "rightCorner": {
              "x": 31.027,
              "y": 6.6381,
              "z": 1.0451
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260407953798"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac9a",
        "height": 1.2976,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54cc",
            "leftCorner": {
              "x": 31.757,
              "y": 7.4345,
              "z": 1.2974
            },
            "rightCorner": {
              "x": 31.69,
              "y": 7.3627,
              "z": 1.2974
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172487316"
          },
          {
            "id": "679afb3d3d9bab0f83ff54cd",
            "leftCorner": {
              "x": 31.686,
              "y": 7.3594,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.626,
              "y": 7.2936,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172487316"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ce",
            "leftCorner": {
              "x": 31.626,
              "y": 7.2936,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.567,
              "y": 7.2289,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233049"
          },
          {
            "id": "679afb3d3d9bab0f83ff54cf",
            "leftCorner": {
              "x": 31.567,
              "y": 7.2289,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.466,
              "y": 7.1187,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447232752"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d0",
            "leftCorner": {
              "x": 31.466,
              "y": 7.1187,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.371,
              "y": 7.0142,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447232752"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d1",
            "leftCorner": {
              "x": 31.371,
              "y": 7.0142,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.273,
              "y": 6.9062,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172684159"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d2",
            "leftCorner": {
              "x": 31.273,
              "y": 6.9062,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.165,
              "y": 6.7879,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172684159"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d3",
            "leftCorner": {
              "x": 31.165,
              "y": 6.7879,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.083,
              "y": 6.6975,
              "z": 1.2976
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172928741"
          },
          {
            "id": "679afb3d3d9bab0f83ff54c4",
            "leftCorner": {
              "x": 31.083,
              "y": 6.6975,
              "z": 1.2976
            },
            "rightCorner": {
              "x": 31.028,
              "y": 6.6372,
              "z": 1.2976
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172928741"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac9b",
        "height": 1.6335,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff54e0",
            "leftCorner": {
              "x": 31.684,
              "y": 7.349,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.627,
              "y": 7.2863,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e1",
            "leftCorner": {
              "x": 31.627,
              "y": 7.2863,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.574,
              "y": 7.2279,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260614530218"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e2",
            "leftCorner": {
              "x": 31.574,
              "y": 7.2279,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.519,
              "y": 7.1678,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260614530218"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e3",
            "leftCorner": {
              "x": 31.519,
              "y": 7.1678,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.461,
              "y": 7.1045,
              "z": 1.6335
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251471406778"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e4",
            "leftCorner": {
              "x": 31.461,
              "y": 7.1045,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.408,
              "y": 7.0462,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e5",
            "leftCorner": {
              "x": 31.408,
              "y": 7.0462,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.356,
              "y": 6.9886,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e6",
            "leftCorner": {
              "x": 31.356,
              "y": 6.9886,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.298,
              "y": 6.9251,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e7",
            "leftCorner": {
              "x": 31.298,
              "y": 6.9251,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.251,
              "y": 6.8737,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075540"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e8",
            "leftCorner": {
              "x": 31.251,
              "y": 6.8737,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.203,
              "y": 6.8211,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075540"
          },
          {
            "id": "679afb3d3d9bab0f83ff54e9",
            "leftCorner": {
              "x": 31.203,
              "y": 6.8211,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.156,
              "y": 6.7689,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075526"
          },
          {
            "id": "679afb3d3d9bab0f83ff54ea",
            "leftCorner": {
              "x": 31.156,
              "y": 6.7689,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.106,
              "y": 6.714,
              "z": 1.6335
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447075526"
          },
          {
            "id": "679afb3d3d9bab0f83ff54eb",
            "leftCorner": {
              "x": 31.106,
              "y": 6.714,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.061,
              "y": 6.6653,
              "z": 1.6335
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447415254"
          },
          {
            "id": "679afb3d3d9bab0f83ff54d5",
            "leftCorner": {
              "x": 31.061,
              "y": 6.6653,
              "z": 1.6335
            },
            "rightCorner": {
              "x": 31.032,
              "y": 6.6332,
              "z": 1.6335
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172487330"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 60,
      "unknownStockCount": 9
    },
    "name": "3LN7",
    "leftNeighborShelfId": "KKXB",
    "rightNeighborShelfId": "68B1"
  },
  {
    "id": "RA6K",
    "x": 30.331,
    "y": 5.9057,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.91675,
      "w": -0.39946
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3aca3",
        "height": 0.19234,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b8e",
            "leftCorner": {
              "x": 30.251,
              "y": 5.9795,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 30.219,
              "y": 5.9442,
              "z": 0.19234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b8f",
            "leftCorner": {
              "x": 30.219,
              "y": 5.9442,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 30.156,
              "y": 5.8768,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000381080758"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b90",
            "leftCorner": {
              "x": 30.156,
              "y": 5.8768,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 30.074,
              "y": 5.7891,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260350926528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b91",
            "leftCorner": {
              "x": 30.074,
              "y": 5.7891,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 29.982,
              "y": 5.6901,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260350926528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b92",
            "leftCorner": {
              "x": 29.982,
              "y": 5.6901,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 29.888,
              "y": 5.5888,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260350920885"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b93",
            "leftCorner": {
              "x": 29.888,
              "y": 5.5888,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 29.792,
              "y": 5.4848,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260350920885"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b94",
            "leftCorner": {
              "x": 29.792,
              "y": 5.4848,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 29.687,
              "y": 5.3727,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796083460"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b95",
            "leftCorner": {
              "x": 29.687,
              "y": 5.3727,
              "z": 0.19234
            },
            "rightCorner": {
              "x": 29.576,
              "y": 5.2525,
              "z": 0.19234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260350920878"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac9e",
        "height": 0.45598,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b5b",
            "leftCorner": {
              "x": 30.331,
              "y": 5.9052,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30.28,
              "y": 5.8495,
              "z": 0.45598
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4262354077145"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b5d",
            "leftCorner": {
              "x": 30.28,
              "y": 5.8495,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30.199,
              "y": 5.7623,
              "z": 0.45598
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4262354077046"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b5e",
            "leftCorner": {
              "x": 30.199,
              "y": 5.7623,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30.135,
              "y": 5.6935,
              "z": 0.45598
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407954955"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b5f",
            "leftCorner": {
              "x": 30.135,
              "y": 5.6935,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30.073,
              "y": 5.6273,
              "z": 0.45598
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260407954917"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b60",
            "leftCorner": {
              "x": 30.073,
              "y": 5.6273,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30.054,
              "y": 5.6068,
              "z": 0.45598
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b61",
            "leftCorner": {
              "x": 30.054,
              "y": 5.6068,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 30,
              "y": 5.549,
              "z": 0.45598
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b62",
            "leftCorner": {
              "x": 30,
              "y": 5.549,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 29.923,
              "y": 5.4657,
              "z": 0.45598
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447256628"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b63",
            "leftCorner": {
              "x": 29.923,
              "y": 5.4657,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 29.843,
              "y": 5.3794,
              "z": 0.45598
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b64",
            "leftCorner": {
              "x": 29.843,
              "y": 5.3794,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 29.713,
              "y": 5.2395,
              "z": 0.45598
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796014280"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b5c",
            "leftCorner": {
              "x": 29.713,
              "y": 5.2395,
              "z": 0.45598
            },
            "rightCorner": {
              "x": 29.651,
              "y": 5.1727,
              "z": 0.45598
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796014280"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca1",
        "height": 0.6647,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b79",
            "leftCorner": {
              "x": 30.328,
              "y": 5.8971,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 30.264,
              "y": 5.8285,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7a",
            "leftCorner": {
              "x": 30.264,
              "y": 5.8285,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 30.202,
              "y": 5.7613,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7b",
            "leftCorner": {
              "x": 30.202,
              "y": 5.7613,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 30.142,
              "y": 5.697,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7c",
            "leftCorner": {
              "x": 30.142,
              "y": 5.697,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 30.082,
              "y": 5.6326,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7d",
            "leftCorner": {
              "x": 30.082,
              "y": 5.6326,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 30.017,
              "y": 5.5631,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7e",
            "leftCorner": {
              "x": 30.017,
              "y": 5.5631,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.95,
              "y": 5.4905,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b7f",
            "leftCorner": {
              "x": 29.95,
              "y": 5.4905,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.889,
              "y": 5.4253,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b80",
            "leftCorner": {
              "x": 29.889,
              "y": 5.4253,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.829,
              "y": 5.3605,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b81",
            "leftCorner": {
              "x": 29.829,
              "y": 5.3605,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.767,
              "y": 5.2936,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b82",
            "leftCorner": {
              "x": 29.767,
              "y": 5.2936,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.706,
              "y": 5.2283,
              "z": 0.6647
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485237"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b78",
            "leftCorner": {
              "x": 29.706,
              "y": 5.2283,
              "z": 0.6647
            },
            "rightCorner": {
              "x": 29.653,
              "y": 5.1707,
              "z": 0.6647
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172485237"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca2",
        "height": 0.91489,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b83",
            "leftCorner": {
              "x": 30.331,
              "y": 5.9058,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 30.258,
              "y": 5.8275,
              "z": 0.91489
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b85",
            "leftCorner": {
              "x": 30.258,
              "y": 5.8275,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 30.196,
              "y": 5.7606,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b86",
            "leftCorner": {
              "x": 30.196,
              "y": 5.7606,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 30.134,
              "y": 5.6945,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b87",
            "leftCorner": {
              "x": 30.134,
              "y": 5.6945,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 30.069,
              "y": 5.6241,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b88",
            "leftCorner": {
              "x": 30.069,
              "y": 5.6241,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 30.007,
              "y": 5.5577,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b89",
            "leftCorner": {
              "x": 30.007,
              "y": 5.5577,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.944,
              "y": 5.4893,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b8a",
            "leftCorner": {
              "x": 29.944,
              "y": 5.4893,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.883,
              "y": 5.4241,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b8b",
            "leftCorner": {
              "x": 29.883,
              "y": 5.4241,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.82,
              "y": 5.3565,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b8c",
            "leftCorner": {
              "x": 29.82,
              "y": 5.3565,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.76,
              "y": 5.292,
              "z": 0.91489
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b8d",
            "leftCorner": {
              "x": 29.76,
              "y": 5.292,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.697,
              "y": 5.2246,
              "z": 0.91489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584073"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b84",
            "leftCorner": {
              "x": 29.697,
              "y": 5.2246,
              "z": 0.91489
            },
            "rightCorner": {
              "x": 29.65,
              "y": 5.1734,
              "z": 0.91489
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447584073"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ac9f",
        "height": 1.1721,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b65",
            "leftCorner": {
              "x": 30.333,
              "y": 5.904,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 30.257,
              "y": 5.8225,
              "z": 1.1721
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172485411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b66",
            "leftCorner": {
              "x": 30.257,
              "y": 5.8225,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 30.186,
              "y": 5.7457,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b67",
            "leftCorner": {
              "x": 30.186,
              "y": 5.7457,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 30.107,
              "y": 5.6609,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172485411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b68",
            "leftCorner": {
              "x": 30.107,
              "y": 5.6609,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 30.029,
              "y": 5.5778,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796001457"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b69",
            "leftCorner": {
              "x": 30.029,
              "y": 5.5778,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 29.944,
              "y": 5.4859,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b6a",
            "leftCorner": {
              "x": 29.944,
              "y": 5.4859,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 29.846,
              "y": 5.3805,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231915"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b6b",
            "leftCorner": {
              "x": 29.846,
              "y": 5.3805,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 29.757,
              "y": 5.2842,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231915"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b6c",
            "leftCorner": {
              "x": 29.757,
              "y": 5.2842,
              "z": 1.1721
            },
            "rightCorner": {
              "x": 29.657,
              "y": 5.1772,
              "z": 1.1721
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231915"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca0",
        "height": 1.4238,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b6d",
            "leftCorner": {
              "x": 30.334,
              "y": 5.9026,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 30.31,
              "y": 5.8762,
              "z": 1.4238
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b6f",
            "leftCorner": {
              "x": 30.31,
              "y": 5.8762,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 30.265,
              "y": 5.8283,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b70",
            "leftCorner": {
              "x": 30.265,
              "y": 5.8283,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 30.19,
              "y": 5.7476,
              "z": 1.4238
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447363159"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b71",
            "leftCorner": {
              "x": 30.19,
              "y": 5.7476,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 30.113,
              "y": 5.6641,
              "z": 1.4238
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447363159"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b72",
            "leftCorner": {
              "x": 30.113,
              "y": 5.6641,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 30.029,
              "y": 5.5742,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447200249"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b73",
            "leftCorner": {
              "x": 30.029,
              "y": 5.5742,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.939,
              "y": 5.4773,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447200249"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b74",
            "leftCorner": {
              "x": 29.939,
              "y": 5.4773,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.884,
              "y": 5.4177,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447210224"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b75",
            "leftCorner": {
              "x": 29.884,
              "y": 5.4177,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.83,
              "y": 5.3599,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447210224"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b76",
            "leftCorner": {
              "x": 29.83,
              "y": 5.3599,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.762,
              "y": 5.2867,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7614800261405"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b77",
            "leftCorner": {
              "x": 29.762,
              "y": 5.2867,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.694,
              "y": 5.2138,
              "z": 1.4238
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7614800261443"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b6e",
            "leftCorner": {
              "x": 29.694,
              "y": 5.2138,
              "z": 1.4238
            },
            "rightCorner": {
              "x": 29.653,
              "y": 5.1701,
              "z": 1.4238
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca4",
        "height": 1.6782,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5b96",
            "leftCorner": {
              "x": 30.323,
              "y": 5.8828,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 30.217,
              "y": 5.7696,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796073355"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b97",
            "leftCorner": {
              "x": 30.217,
              "y": 5.7696,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 30.171,
              "y": 5.7201,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b98",
            "leftCorner": {
              "x": 30.171,
              "y": 5.7201,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 30.127,
              "y": 5.6729,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b99",
            "leftCorner": {
              "x": 30.127,
              "y": 5.6729,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 30.078,
              "y": 5.6198,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9a",
            "leftCorner": {
              "x": 30.078,
              "y": 5.6198,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 30.036,
              "y": 5.5742,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9b",
            "leftCorner": {
              "x": 30.036,
              "y": 5.5742,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.987,
              "y": 5.5223,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9c",
            "leftCorner": {
              "x": 29.987,
              "y": 5.5223,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.946,
              "y": 5.478,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9d",
            "leftCorner": {
              "x": 29.946,
              "y": 5.478,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.903,
              "y": 5.4316,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704167"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9e",
            "leftCorner": {
              "x": 29.903,
              "y": 5.4316,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.863,
              "y": 5.3882,
              "z": 1.6782
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447704167"
          },
          {
            "id": "679afb3e3d9bab0f83ff5b9f",
            "leftCorner": {
              "x": 29.863,
              "y": 5.3882,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.821,
              "y": 5.3429,
              "z": 1.6782
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000039"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba0",
            "leftCorner": {
              "x": 29.821,
              "y": 5.3429,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.74,
              "y": 5.2562,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447213126"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba1",
            "leftCorner": {
              "x": 29.74,
              "y": 5.2562,
              "z": 1.6782
            },
            "rightCorner": {
              "x": 29.657,
              "y": 5.1672,
              "z": 1.6782
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447213126"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 54,
      "unknownStockCount": 13
    },
    "name": "RA6K",
    "leftNeighborShelfId": "J0MD",
    "rightNeighborShelfId": "5R7C"
  },
  {
    "id": "TNRU",
    "x": 29.852,
    "y": 3.5291,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.41194,
      "w": 0.91121
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3aca7",
        "height": 0.37482,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca5",
        "height": 0.72909,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ba2",
            "leftCorner": {
              "x": 29.909,
              "y": 3.4789,
              "z": 0.72909
            },
            "rightCorner": {
              "x": 29.988,
              "y": 3.5679,
              "z": 0.72909
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000023"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba3",
            "leftCorner": {
              "x": 29.988,
              "y": 3.5679,
              "z": 0.72909
            },
            "rightCorner": {
              "x": 30.57,
              "y": 4.2297,
              "z": 0.72909
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355854049"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 0,
      "unknownStockCount": 2
    },
    "name": "TNRU",
    "leftNeighborShelfId": "Q3ES",
    "rightNeighborShelfId": "UD1F"
  },
  {
    "id": "1SKP",
    "x": 30.537,
    "y": 4.2848,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.40373,
      "w": 0.91488
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acac",
        "height": 0.19151,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bd4",
            "leftCorner": {
              "x": 30.612,
              "y": 4.2159,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 30.681,
              "y": 4.2919,
              "z": 0.19151
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109658"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd6",
            "leftCorner": {
              "x": 30.681,
              "y": 4.2919,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 30.794,
              "y": 4.4154,
              "z": 0.19151
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447087604"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd7",
            "leftCorner": {
              "x": 30.794,
              "y": 4.4154,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 30.883,
              "y": 4.5126,
              "z": 0.19151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4042441017380"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd8",
            "leftCorner": {
              "x": 30.883,
              "y": 4.5126,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 30.969,
              "y": 4.6073,
              "z": 0.19151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581539727"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd9",
            "leftCorner": {
              "x": 30.969,
              "y": 4.6073,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 31.055,
              "y": 4.7016,
              "z": 0.19151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581531905"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bda",
            "leftCorner": {
              "x": 31.055,
              "y": 4.7016,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 31.147,
              "y": 4.8019,
              "z": 0.19151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581533411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bdb",
            "leftCorner": {
              "x": 31.147,
              "y": 4.8019,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 31.234,
              "y": 4.8976,
              "z": 0.19151
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581528042"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd5",
            "leftCorner": {
              "x": 31.234,
              "y": 4.8976,
              "z": 0.19151
            },
            "rightCorner": {
              "x": 31.286,
              "y": 4.9546,
              "z": 0.19151
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718469200412"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca8",
        "height": 0.49774,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ba4",
            "leftCorner": {
              "x": 30.529,
              "y": 4.2918,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.591,
              "y": 4.3602,
              "z": 0.49774
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581534005"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba6",
            "leftCorner": {
              "x": 30.591,
              "y": 4.3602,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.646,
              "y": 4.4205,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581526949"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba7",
            "leftCorner": {
              "x": 30.646,
              "y": 4.4205,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.693,
              "y": 4.4721,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba8",
            "leftCorner": {
              "x": 30.693,
              "y": 4.4721,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.777,
              "y": 4.5641,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3663555002072"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba9",
            "leftCorner": {
              "x": 30.777,
              "y": 4.5641,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.829,
              "y": 4.6205,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003626111217"
          },
          {
            "id": "679afb3e3d9bab0f83ff5baa",
            "leftCorner": {
              "x": 30.829,
              "y": 4.6205,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.88,
              "y": 4.6764,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003626908114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bab",
            "leftCorner": {
              "x": 30.88,
              "y": 4.6764,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.933,
              "y": 4.7347,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172778131"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bac",
            "leftCorner": {
              "x": 30.933,
              "y": 4.7347,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 30.985,
              "y": 4.7917,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172778131"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bad",
            "leftCorner": {
              "x": 30.985,
              "y": 4.7917,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 31.039,
              "y": 4.8515,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219227"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bae",
            "leftCorner": {
              "x": 31.039,
              "y": 4.8515,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 31.074,
              "y": 4.8894,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695452"
          },
          {
            "id": "679afb3e3d9bab0f83ff5baf",
            "leftCorner": {
              "x": 31.074,
              "y": 4.8894,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 31.11,
              "y": 4.9286,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695452"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb0",
            "leftCorner": {
              "x": 31.11,
              "y": 4.9286,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 31.175,
              "y": 5.0002,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617138822"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ba5",
            "leftCorner": {
              "x": 31.175,
              "y": 5.0002,
              "z": 0.49774
            },
            "rightCorner": {
              "x": 31.203,
              "y": 5.0305,
              "z": 0.49774
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aca9",
        "height": 0.74951,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bb1",
            "leftCorner": {
              "x": 30.524,
              "y": 4.2963,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.58,
              "y": 4.3576,
              "z": 0.74951
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008600433743"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb2",
            "leftCorner": {
              "x": 30.58,
              "y": 4.3576,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.635,
              "y": 4.4179,
              "z": 0.74951
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008600433750"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb3",
            "leftCorner": {
              "x": 30.635,
              "y": 4.4179,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.673,
              "y": 4.4601,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600433729"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb4",
            "leftCorner": {
              "x": 30.673,
              "y": 4.4601,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.691,
              "y": 4.4789,
              "z": 0.74951
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb5",
            "leftCorner": {
              "x": 30.691,
              "y": 4.4789,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.746,
              "y": 4.5394,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600433712"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb6",
            "leftCorner": {
              "x": 30.746,
              "y": 4.5394,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.803,
              "y": 4.6022,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008600433736"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb7",
            "leftCorner": {
              "x": 30.803,
              "y": 4.6022,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.857,
              "y": 4.6613,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4044571221224"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb8",
            "leftCorner": {
              "x": 30.857,
              "y": 4.6613,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.911,
              "y": 4.7209,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4044571240218"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bb9",
            "leftCorner": {
              "x": 30.911,
              "y": 4.7209,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 30.965,
              "y": 4.7801,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4044571221217"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bba",
            "leftCorner": {
              "x": 30.965,
              "y": 4.7801,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 31.021,
              "y": 4.8407,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4044571221248"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bbb",
            "leftCorner": {
              "x": 31.021,
              "y": 4.8407,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 31.07,
              "y": 4.8944,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669412087"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bbc",
            "leftCorner": {
              "x": 31.07,
              "y": 4.8944,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 31.123,
              "y": 4.9531,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669418027"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bbd",
            "leftCorner": {
              "x": 31.123,
              "y": 4.9531,
              "z": 0.74951
            },
            "rightCorner": {
              "x": 31.177,
              "y": 5.0124,
              "z": 0.74951
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669410328"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acaa",
        "height": 0.9972,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bbe",
            "leftCorner": {
              "x": 30.522,
              "y": 4.2978,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.583,
              "y": 4.3643,
              "z": 0.9972
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448190325"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bbf",
            "leftCorner": {
              "x": 30.583,
              "y": 4.3643,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.634,
              "y": 4.4205,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190295"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc0",
            "leftCorner": {
              "x": 30.634,
              "y": 4.4205,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.688,
              "y": 4.4795,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190356"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc1",
            "leftCorner": {
              "x": 30.688,
              "y": 4.4795,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.743,
              "y": 4.5398,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190455"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc2",
            "leftCorner": {
              "x": 30.743,
              "y": 4.5398,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.8,
              "y": 4.6019,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190493"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc3",
            "leftCorner": {
              "x": 30.8,
              "y": 4.6019,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.857,
              "y": 4.6649,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190547"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc4",
            "leftCorner": {
              "x": 30.857,
              "y": 4.6649,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.916,
              "y": 4.7289,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190202"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc5",
            "leftCorner": {
              "x": 30.916,
              "y": 4.7289,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 30.976,
              "y": 4.7948,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448189404"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc6",
            "leftCorner": {
              "x": 30.976,
              "y": 4.7948,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 31.029,
              "y": 4.8529,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669420013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc7",
            "leftCorner": {
              "x": 31.029,
              "y": 4.8529,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 31.082,
              "y": 4.9112,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669410014"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc8",
            "leftCorner": {
              "x": 31.082,
              "y": 4.9112,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 31.134,
              "y": 4.9686,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669418041"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bc9",
            "leftCorner": {
              "x": 31.134,
              "y": 4.9686,
              "z": 0.9972
            },
            "rightCorner": {
              "x": 31.187,
              "y": 5.0266,
              "z": 0.9972
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669418041"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acad",
        "height": 1.2516,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bdc",
            "leftCorner": {
              "x": 30.524,
              "y": 4.2959,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.607,
              "y": 4.3864,
              "z": 1.2516
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260508540330"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bde",
            "leftCorner": {
              "x": 30.607,
              "y": 4.3864,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.658,
              "y": 4.4428,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190189"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bdf",
            "leftCorner": {
              "x": 30.658,
              "y": 4.4428,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.692,
              "y": 4.48,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190646"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be0",
            "leftCorner": {
              "x": 30.692,
              "y": 4.48,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.712,
              "y": 4.5011,
              "z": 1.2516
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448190646"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be1",
            "leftCorner": {
              "x": 30.712,
              "y": 4.5011,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.766,
              "y": 4.5607,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448190523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be2",
            "leftCorner": {
              "x": 30.766,
              "y": 4.5607,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.833,
              "y": 4.6338,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060926404967"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be3",
            "leftCorner": {
              "x": 30.833,
              "y": 4.6338,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.904,
              "y": 4.7121,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448191124"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be4",
            "leftCorner": {
              "x": 30.904,
              "y": 4.7121,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 30.965,
              "y": 4.7787,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251665310317"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be5",
            "leftCorner": {
              "x": 30.965,
              "y": 4.7787,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 31.021,
              "y": 4.8405,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251665310447"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be6",
            "leftCorner": {
              "x": 31.021,
              "y": 4.8405,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 31.077,
              "y": 4.9021,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251665310362"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be7",
            "leftCorner": {
              "x": 31.077,
              "y": 4.9021,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 31.132,
              "y": 4.962,
              "z": 1.2516
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251665310379"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bdd",
            "leftCorner": {
              "x": 31.132,
              "y": 4.962,
              "z": 1.2516
            },
            "rightCorner": {
              "x": 31.198,
              "y": 5.0346,
              "z": 1.2516
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251665310379"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acab",
        "height": 1.5048,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bca",
            "leftCorner": {
              "x": 30.521,
              "y": 4.2985,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 30.581,
              "y": 4.3638,
              "z": 1.5048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5038483962657"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bcc",
            "leftCorner": {
              "x": 30.581,
              "y": 4.3638,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 30.619,
              "y": 4.4051,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448118459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bcd",
            "leftCorner": {
              "x": 30.619,
              "y": 4.4051,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 30.669,
              "y": 4.4604,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5038483962435"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bce",
            "leftCorner": {
              "x": 30.669,
              "y": 4.4604,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 30.719,
              "y": 4.5148,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5038483962466"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bcf",
            "leftCorner": {
              "x": 30.719,
              "y": 4.5148,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 30.853,
              "y": 4.6623,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448135579"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd0",
            "leftCorner": {
              "x": 30.853,
              "y": 4.6623,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 31.002,
              "y": 4.8251,
              "z": 1.5048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448189350"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd1",
            "leftCorner": {
              "x": 31.002,
              "y": 4.8251,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 31.036,
              "y": 4.8619,
              "z": 1.5048
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4001669090070"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd2",
            "leftCorner": {
              "x": 31.036,
              "y": 4.8619,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 31.07,
              "y": 4.8992,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001669091527"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bd3",
            "leftCorner": {
              "x": 31.07,
              "y": 4.8992,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 31.145,
              "y": 4.9821,
              "z": 1.5048
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251460624633"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bcb",
            "leftCorner": {
              "x": 31.145,
              "y": 4.9821,
              "z": 1.5048
            },
            "rightCorner": {
              "x": 31.195,
              "y": 5.0372,
              "z": 1.5048
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5038483428252"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acae",
        "height": 1.7252,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5be9",
            "leftCorner": {
              "x": 30.572,
              "y": 4.2652,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.622,
              "y": 4.321,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841235592"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bea",
            "leftCorner": {
              "x": 30.622,
              "y": 4.321,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.663,
              "y": 4.3651,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5beb",
            "leftCorner": {
              "x": 30.663,
              "y": 4.3651,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.713,
              "y": 4.4197,
              "z": 1.7252
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bec",
            "leftCorner": {
              "x": 30.713,
              "y": 4.4197,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.752,
              "y": 4.4632,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bed",
            "leftCorner": {
              "x": 30.752,
              "y": 4.4632,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.792,
              "y": 4.507,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841704234"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bee",
            "leftCorner": {
              "x": 30.792,
              "y": 4.507,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.816,
              "y": 4.5327,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bef",
            "leftCorner": {
              "x": 30.816,
              "y": 4.5327,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.847,
              "y": 4.567,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841704234"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf0",
            "leftCorner": {
              "x": 30.847,
              "y": 4.567,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.885,
              "y": 4.6091,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf1",
            "leftCorner": {
              "x": 30.885,
              "y": 4.6091,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.931,
              "y": 4.6596,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf2",
            "leftCorner": {
              "x": 30.931,
              "y": 4.6596,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.959,
              "y": 4.69,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf3",
            "leftCorner": {
              "x": 30.959,
              "y": 4.69,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 30.981,
              "y": 4.7139,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005800306105"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf4",
            "leftCorner": {
              "x": 30.981,
              "y": 4.7139,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.014,
              "y": 4.7506,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005800306105"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf5",
            "leftCorner": {
              "x": 31.014,
              "y": 4.7506,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.054,
              "y": 4.7943,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070293"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf6",
            "leftCorner": {
              "x": 31.054,
              "y": 4.7943,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.104,
              "y": 4.8486,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070293"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf7",
            "leftCorner": {
              "x": 31.104,
              "y": 4.8486,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.159,
              "y": 4.9094,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf8",
            "leftCorner": {
              "x": 31.159,
              "y": 4.9094,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.204,
              "y": 4.9588,
              "z": 1.7252
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5be8",
            "leftCorner": {
              "x": 31.204,
              "y": 4.9588,
              "z": 1.7252
            },
            "rightCorner": {
              "x": 31.239,
              "y": 4.9972,
              "z": 1.7252
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000046"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 64,
      "unknownStockCount": 18
    },
    "name": "1SKP",
    "leftNeighborShelfId": "K8RP",
    "rightNeighborShelfId": "8K9F"
  },
  {
    "id": "2V4N",
    "x": 34.818,
    "y": 8.6291,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.91556,
      "w": -0.40219
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acb3",
        "height": 0.2915,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb1",
        "height": 0.5017,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c12",
            "leftCorner": {
              "x": 34.638,
              "y": 8.7606,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.567,
              "y": 8.6827,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932005554"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c13",
            "leftCorner": {
              "x": 34.567,
              "y": 8.6827,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.489,
              "y": 8.598,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "2099999063361"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c14",
            "leftCorner": {
              "x": 34.489,
              "y": 8.598,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.437,
              "y": 8.5409,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003087422150"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c15",
            "leftCorner": {
              "x": 34.437,
              "y": 8.5409,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.379,
              "y": 8.4786,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003087445807"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c16",
            "leftCorner": {
              "x": 34.379,
              "y": 8.4786,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.286,
              "y": 8.3769,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932133165"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c17",
            "leftCorner": {
              "x": 34.286,
              "y": 8.3769,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.229,
              "y": 8.315,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447788426"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c18",
            "leftCorner": {
              "x": 34.229,
              "y": 8.315,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.161,
              "y": 8.2405,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260253660222"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c19",
            "leftCorner": {
              "x": 34.161,
              "y": 8.2405,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.098,
              "y": 8.1725,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932133875"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c1a",
            "leftCorner": {
              "x": 34.098,
              "y": 8.1725,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 34.043,
              "y": 8.1122,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491104562"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c11",
            "leftCorner": {
              "x": 34.043,
              "y": 8.1122,
              "z": 0.5017
            },
            "rightCorner": {
              "x": 33.978,
              "y": 8.0421,
              "z": 0.5017
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172694622"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acaf",
        "height": 0.75414,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5bfa",
            "leftCorner": {
              "x": 34.629,
              "y": 8.7588,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.577,
              "y": 8.7017,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "2099999063354"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bfb",
            "leftCorner": {
              "x": 34.577,
              "y": 8.7017,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.52,
              "y": 8.6395,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447794793"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bfc",
            "leftCorner": {
              "x": 34.52,
              "y": 8.6395,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.463,
              "y": 8.5781,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bfd",
            "leftCorner": {
              "x": 34.463,
              "y": 8.5781,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.401,
              "y": 8.5102,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932131093"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bfe",
            "leftCorner": {
              "x": 34.401,
              "y": 8.5102,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.336,
              "y": 8.44,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491119740"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bff",
            "leftCorner": {
              "x": 34.336,
              "y": 8.44,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.282,
              "y": 8.381,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491119740"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c00",
            "leftCorner": {
              "x": 34.282,
              "y": 8.381,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.225,
              "y": 8.319,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491105385"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c01",
            "leftCorner": {
              "x": 34.225,
              "y": 8.319,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.163,
              "y": 8.2517,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932131253"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c02",
            "leftCorner": {
              "x": 34.163,
              "y": 8.2517,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.093,
              "y": 8.1752,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617040293"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c03",
            "leftCorner": {
              "x": 34.093,
              "y": 8.1752,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 34.031,
              "y": 8.1082,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617121626"
          },
          {
            "id": "679afb3e3d9bab0f83ff5bf9",
            "leftCorner": {
              "x": 34.031,
              "y": 8.1082,
              "z": 0.75414
            },
            "rightCorner": {
              "x": 33.974,
              "y": 8.0459,
              "z": 0.75414
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000047"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb0",
        "height": 1.002,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c05",
            "leftCorner": {
              "x": 34.655,
              "y": 8.7905,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.592,
              "y": 8.7227,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004148313523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c06",
            "leftCorner": {
              "x": 34.592,
              "y": 8.7227,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.549,
              "y": 8.6755,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004148313523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c07",
            "leftCorner": {
              "x": 34.549,
              "y": 8.6755,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.518,
              "y": 8.6422,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796102413"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c08",
            "leftCorner": {
              "x": 34.518,
              "y": 8.6422,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.491,
              "y": 8.6124,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932001983"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c09",
            "leftCorner": {
              "x": 34.491,
              "y": 8.6124,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.438,
              "y": 8.5546,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932008937"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0a",
            "leftCorner": {
              "x": 34.438,
              "y": 8.5546,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.385,
              "y": 8.4971,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932008463"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0b",
            "leftCorner": {
              "x": 34.385,
              "y": 8.4971,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.33,
              "y": 8.4368,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932132243"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0c",
            "leftCorner": {
              "x": 34.33,
              "y": 8.4368,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.264,
              "y": 8.3657,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233042435"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0d",
            "leftCorner": {
              "x": 34.264,
              "y": 8.3657,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.207,
              "y": 8.3035,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003087442257"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0e",
            "leftCorner": {
              "x": 34.207,
              "y": 8.3035,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.15,
              "y": 8.2409,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447412727"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c0f",
            "leftCorner": {
              "x": 34.15,
              "y": 8.2409,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.099,
              "y": 8.1851,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172101311"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c10",
            "leftCorner": {
              "x": 34.099,
              "y": 8.1851,
              "z": 1.002
            },
            "rightCorner": {
              "x": 34.037,
              "y": 8.1183,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932002645"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c04",
            "leftCorner": {
              "x": 34.037,
              "y": 8.1183,
              "z": 1.002
            },
            "rightCorner": {
              "x": 33.972,
              "y": 8.0477,
              "z": 1.002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4026600533614"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb5",
        "height": 1.2548,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c33",
            "leftCorner": {
              "x": 34.649,
              "y": 8.7813,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.597,
              "y": 8.7249,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233177007"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c34",
            "leftCorner": {
              "x": 34.597,
              "y": 8.7249,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.543,
              "y": 8.6662,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172937057"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c35",
            "leftCorner": {
              "x": 34.543,
              "y": 8.6662,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.485,
              "y": 8.603,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172937057"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c36",
            "leftCorner": {
              "x": 34.485,
              "y": 8.603,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.428,
              "y": 8.5416,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447249132"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c37",
            "leftCorner": {
              "x": 34.428,
              "y": 8.5416,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.365,
              "y": 8.4721,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447412758"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c38",
            "leftCorner": {
              "x": 34.365,
              "y": 8.4721,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.309,
              "y": 8.4116,
              "z": 1.2548
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172921933"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c39",
            "leftCorner": {
              "x": 34.309,
              "y": 8.4116,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.25,
              "y": 8.3476,
              "z": 1.2548
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172309335"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c3a",
            "leftCorner": {
              "x": 34.25,
              "y": 8.3476,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.195,
              "y": 8.2875,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172922176"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c3b",
            "leftCorner": {
              "x": 34.195,
              "y": 8.2875,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.136,
              "y": 8.2232,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172922114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c3c",
            "leftCorner": {
              "x": 34.136,
              "y": 8.2232,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.078,
              "y": 8.1597,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447788464"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c3d",
            "leftCorner": {
              "x": 34.078,
              "y": 8.1597,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 34.028,
              "y": 8.1062,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447788464"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c32",
            "leftCorner": {
              "x": 34.028,
              "y": 8.1062,
              "z": 1.2548
            },
            "rightCorner": {
              "x": 33.974,
              "y": 8.0465,
              "z": 1.2548
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172101410"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb2",
        "height": 1.509,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c1b",
            "leftCorner": {
              "x": 34.649,
              "y": 8.7837,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.61,
              "y": 8.7408,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617173960"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c1c",
            "leftCorner": {
              "x": 34.61,
              "y": 8.7408,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.55,
              "y": 8.6752,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617011620"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c1d",
            "leftCorner": {
              "x": 34.55,
              "y": 8.6752,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.48,
              "y": 8.5989,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617011859"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c1e",
            "leftCorner": {
              "x": 34.48,
              "y": 8.5989,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.413,
              "y": 8.5264,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617011859"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c1f",
            "leftCorner": {
              "x": 34.413,
              "y": 8.5264,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.344,
              "y": 8.4518,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c20",
            "leftCorner": {
              "x": 34.344,
              "y": 8.4518,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.283,
              "y": 8.385,
              "z": 1.509
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008617008170"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c21",
            "leftCorner": {
              "x": 34.283,
              "y": 8.385,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.219,
              "y": 8.3151,
              "z": 1.509
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4250752204621"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c22",
            "leftCorner": {
              "x": 34.219,
              "y": 8.3151,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.155,
              "y": 8.2457,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250752204867"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c23",
            "leftCorner": {
              "x": 34.155,
              "y": 8.2457,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.092,
              "y": 8.1773,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491276290"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c24",
            "leftCorner": {
              "x": 34.092,
              "y": 8.1773,
              "z": 1.509
            },
            "rightCorner": {
              "x": 34.035,
              "y": 8.1147,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491110921"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c25",
            "leftCorner": {
              "x": 34.035,
              "y": 8.1147,
              "z": 1.509
            },
            "rightCorner": {
              "x": 33.975,
              "y": 8.0494,
              "z": 1.509
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491101905"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb4",
        "height": 1.7235,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c26",
            "leftCorner": {
              "x": 34.646,
              "y": 8.7866,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.612,
              "y": 8.7501,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932007084"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c28",
            "leftCorner": {
              "x": 34.612,
              "y": 8.7501,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.55,
              "y": 8.6825,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932134100"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c29",
            "leftCorner": {
              "x": 34.55,
              "y": 8.6825,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.486,
              "y": 8.6129,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932131376"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2a",
            "leftCorner": {
              "x": 34.486,
              "y": 8.6129,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.426,
              "y": 8.5467,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932131925"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2b",
            "leftCorner": {
              "x": 34.426,
              "y": 8.5467,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.363,
              "y": 8.4784,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932002560"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2c",
            "leftCorner": {
              "x": 34.363,
              "y": 8.4784,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.305,
              "y": 8.4158,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932001891"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2d",
            "leftCorner": {
              "x": 34.305,
              "y": 8.4158,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.244,
              "y": 8.3486,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932137026"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2e",
            "leftCorner": {
              "x": 34.244,
              "y": 8.3486,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.204,
              "y": 8.3058,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932131291"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c2f",
            "leftCorner": {
              "x": 34.204,
              "y": 8.3058,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.144,
              "y": 8.2398,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932001990"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c30",
            "leftCorner": {
              "x": 34.144,
              "y": 8.2398,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.084,
              "y": 8.1743,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932004731"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c31",
            "leftCorner": {
              "x": 34.084,
              "y": 8.1743,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 34.023,
              "y": 8.1084,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491114622"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c27",
            "leftCorner": {
              "x": 34.023,
              "y": 8.1084,
              "z": 1.7235
            },
            "rightCorner": {
              "x": 33.97,
              "y": 8.0502,
              "z": 1.7235
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491131940"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 0,
      "unknownStockCount": 65
    },
    "name": "2V4N",
    "leftNeighborShelfId": "GS2V",
    "rightNeighborShelfId": "VYWH"
  },
  {
    "id": "J0MD",
    "x": 31.9,
    "y": 5.7778,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.39604,
      "w": 0.91823
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acba",
        "height": 0.19541,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c6a",
            "leftCorner": {
              "x": 31.971,
              "y": 5.7109,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.017,
              "y": 5.76,
              "z": 0.19541
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573089713"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c6c",
            "leftCorner": {
              "x": 32.017,
              "y": 5.76,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.052,
              "y": 5.7969,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617001058"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c6d",
            "leftCorner": {
              "x": 32.052,
              "y": 5.7969,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.098,
              "y": 5.8458,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617001096"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c6e",
            "leftCorner": {
              "x": 32.098,
              "y": 5.8458,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.151,
              "y": 5.9026,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617001096"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c6f",
            "leftCorner": {
              "x": 32.151,
              "y": 5.9026,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.21,
              "y": 5.9642,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617001119"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c70",
            "leftCorner": {
              "x": 32.21,
              "y": 5.9642,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.293,
              "y": 6.0529,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260165270045"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c71",
            "leftCorner": {
              "x": 32.293,
              "y": 6.0529,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.359,
              "y": 6.1222,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932001259"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c72",
            "leftCorner": {
              "x": 32.359,
              "y": 6.1222,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.424,
              "y": 6.1912,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932001037"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c73",
            "leftCorner": {
              "x": 32.424,
              "y": 6.1912,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.489,
              "y": 6.26,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932001037"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c74",
            "leftCorner": {
              "x": 32.489,
              "y": 6.26,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.562,
              "y": 6.3378,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4043027011242"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c75",
            "leftCorner": {
              "x": 32.562,
              "y": 6.3378,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.626,
              "y": 6.4056,
              "z": 0.19541
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932004700"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c6b",
            "leftCorner": {
              "x": 32.626,
              "y": 6.4056,
              "z": 0.19541
            },
            "rightCorner": {
              "x": 32.657,
              "y": 6.4382,
              "z": 0.19541
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932132601"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb6",
        "height": 0.54635,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c3e",
            "leftCorner": {
              "x": 31.893,
              "y": 5.7841,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 31.98,
              "y": 5.8762,
              "z": 0.54635
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573388502"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c40",
            "leftCorner": {
              "x": 31.98,
              "y": 5.8762,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.039,
              "y": 5.9393,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695896"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c41",
            "leftCorner": {
              "x": 32.039,
              "y": 5.9393,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.059,
              "y": 5.9595,
              "z": 0.54635
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172323539"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c42",
            "leftCorner": {
              "x": 32.059,
              "y": 5.9595,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.116,
              "y": 6.0208,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172323539"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c43",
            "leftCorner": {
              "x": 32.116,
              "y": 6.0208,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.185,
              "y": 6.0934,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447656794"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c44",
            "leftCorner": {
              "x": 32.185,
              "y": 6.0934,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.245,
              "y": 6.1567,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796161670"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c45",
            "leftCorner": {
              "x": 32.245,
              "y": 6.1567,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.299,
              "y": 6.2149,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260488132617"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c46",
            "leftCorner": {
              "x": 32.299,
              "y": 6.2149,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.36,
              "y": 6.2791,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932132786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c47",
            "leftCorner": {
              "x": 32.36,
              "y": 6.2791,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.41,
              "y": 6.3319,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233101484"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c48",
            "leftCorner": {
              "x": 32.41,
              "y": 6.3319,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.472,
              "y": 6.398,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932004526"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c49",
            "leftCorner": {
              "x": 32.472,
              "y": 6.398,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.551,
              "y": 6.481,
              "z": 0.54635
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131130"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c3f",
            "leftCorner": {
              "x": 32.551,
              "y": 6.481,
              "z": 0.54635
            },
            "rightCorner": {
              "x": 32.579,
              "y": 6.5114,
              "z": 0.54635
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4026600501002"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb8",
        "height": 0.79595,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c55",
            "leftCorner": {
              "x": 31.888,
              "y": 5.7888,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 31.971,
              "y": 5.8766,
              "z": 0.79595
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932003215"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c57",
            "leftCorner": {
              "x": 31.971,
              "y": 5.8766,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.071,
              "y": 5.9823,
              "z": 0.79595
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932137606"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c58",
            "leftCorner": {
              "x": 32.071,
              "y": 5.9823,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.166,
              "y": 6.0834,
              "z": 0.79595
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172695926"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c59",
            "leftCorner": {
              "x": 32.166,
              "y": 6.0834,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.223,
              "y": 6.1435,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219432"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5a",
            "leftCorner": {
              "x": 32.223,
              "y": 6.1435,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.285,
              "y": 6.2097,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932132069"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5b",
            "leftCorner": {
              "x": 32.285,
              "y": 6.2097,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.336,
              "y": 6.2638,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617027249"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5c",
            "leftCorner": {
              "x": 32.336,
              "y": 6.2638,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.422,
              "y": 6.3543,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752203044"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5d",
            "leftCorner": {
              "x": 32.422,
              "y": 6.3543,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.482,
              "y": 6.4184,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491109406"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5e",
            "leftCorner": {
              "x": 32.482,
              "y": 6.4184,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.548,
              "y": 6.4884,
              "z": 0.79595
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262393840021"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c56",
            "leftCorner": {
              "x": 32.548,
              "y": 6.4884,
              "z": 0.79595
            },
            "rightCorner": {
              "x": 32.574,
              "y": 6.5161,
              "z": 0.79595
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447015225"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb7",
        "height": 1.0448,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c4a",
            "leftCorner": {
              "x": 31.885,
              "y": 5.7919,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 31.953,
              "y": 5.8646,
              "z": 1.0448
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932137187"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c4b",
            "leftCorner": {
              "x": 31.953,
              "y": 5.8646,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.011,
              "y": 5.9262,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219173"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c4c",
            "leftCorner": {
              "x": 32.011,
              "y": 5.9262,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.081,
              "y": 6.0001,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131208"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c4d",
            "leftCorner": {
              "x": 32.081,
              "y": 6.0001,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.147,
              "y": 6.0699,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233124384"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c4e",
            "leftCorner": {
              "x": 32.147,
              "y": 6.0699,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.205,
              "y": 6.1316,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260488132297"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c4f",
            "leftCorner": {
              "x": 32.205,
              "y": 6.1316,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.27,
              "y": 6.2008,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4270002260818"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c50",
            "leftCorner": {
              "x": 32.27,
              "y": 6.2008,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.339,
              "y": 6.2733,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617016137"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c51",
            "leftCorner": {
              "x": 32.339,
              "y": 6.2733,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.385,
              "y": 6.3223,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131703"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c52",
            "leftCorner": {
              "x": 32.385,
              "y": 6.3223,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.446,
              "y": 6.3869,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932138535"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c53",
            "leftCorner": {
              "x": 32.446,
              "y": 6.3869,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.508,
              "y": 6.4527,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133530"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c54",
            "leftCorner": {
              "x": 32.508,
              "y": 6.4527,
              "z": 1.0448
            },
            "rightCorner": {
              "x": 32.564,
              "y": 6.5122,
              "z": 1.0448
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133462"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acbb",
        "height": 1.2996,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c76",
            "leftCorner": {
              "x": 31.886,
              "y": 5.7911,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 31.932,
              "y": 5.8407,
              "z": 1.2996
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260703371982"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c77",
            "leftCorner": {
              "x": 31.932,
              "y": 5.8407,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 31.973,
              "y": 5.8842,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260703371982"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c78",
            "leftCorner": {
              "x": 31.973,
              "y": 5.8842,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.048,
              "y": 5.9628,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447249057"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c79",
            "leftCorner": {
              "x": 32.048,
              "y": 5.9628,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.143,
              "y": 6.0637,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000488301748"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7a",
            "leftCorner": {
              "x": 32.143,
              "y": 6.0637,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.214,
              "y": 6.1391,
              "z": 1.2996
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260159456738"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7b",
            "leftCorner": {
              "x": 32.214,
              "y": 6.1391,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.287,
              "y": 6.216,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447362886"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7c",
            "leftCorner": {
              "x": 32.287,
              "y": 6.216,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.341,
              "y": 6.2733,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262390680002"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7d",
            "leftCorner": {
              "x": 32.341,
              "y": 6.2733,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.398,
              "y": 6.3341,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087422051"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7e",
            "leftCorner": {
              "x": 32.398,
              "y": 6.3341,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.473,
              "y": 6.4132,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010160001850"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c7f",
            "leftCorner": {
              "x": 32.473,
              "y": 6.4132,
              "z": 1.2996
            },
            "rightCorner": {
              "x": 32.552,
              "y": 6.497,
              "z": 1.2996
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131284"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acb9",
        "height": 1.5127,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c60",
            "leftCorner": {
              "x": 31.898,
              "y": 5.8012,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 31.955,
              "y": 5.8609,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581583584"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c61",
            "leftCorner": {
              "x": 31.955,
              "y": 5.8609,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.025,
              "y": 5.9358,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172694974"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c62",
            "leftCorner": {
              "x": 32.025,
              "y": 5.9358,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.101,
              "y": 6.0165,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617403227"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c63",
            "leftCorner": {
              "x": 32.101,
              "y": 6.0165,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.174,
              "y": 6.0939,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233125824"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c64",
            "leftCorner": {
              "x": 32.174,
              "y": 6.0939,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.264,
              "y": 6.1884,
              "z": 1.5127
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447248975"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c65",
            "leftCorner": {
              "x": 32.264,
              "y": 6.1884,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.302,
              "y": 6.2286,
              "z": 1.5127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172323652"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c66",
            "leftCorner": {
              "x": 32.302,
              "y": 6.2286,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.362,
              "y": 6.2923,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233172156"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c67",
            "leftCorner": {
              "x": 32.362,
              "y": 6.2923,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.415,
              "y": 6.349,
              "z": 1.5127
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4026600430005"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c68",
            "leftCorner": {
              "x": 32.415,
              "y": 6.349,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.466,
              "y": 6.4029,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262458340015"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c69",
            "leftCorner": {
              "x": 32.466,
              "y": 6.4029,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.523,
              "y": 6.4633,
              "z": 1.5127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491104098"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c5f",
            "leftCorner": {
              "x": 32.523,
              "y": 6.4633,
              "z": 1.5127
            },
            "rightCorner": {
              "x": 32.574,
              "y": 6.5168,
              "z": 1.5127
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008233175317"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acbc",
        "height": 1.7268,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c81",
            "leftCorner": {
              "x": 31.899,
              "y": 5.8051,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 31.955,
              "y": 5.8644,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c82",
            "leftCorner": {
              "x": 31.955,
              "y": 5.8644,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.135,
              "y": 6.0549,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540273722"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c83",
            "leftCorner": {
              "x": 32.135,
              "y": 6.0549,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.27,
              "y": 6.1981,
              "z": 1.7268
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260457778600"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c84",
            "leftCorner": {
              "x": 32.27,
              "y": 6.1981,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.326,
              "y": 6.2581,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491110211"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c85",
            "leftCorner": {
              "x": 32.326,
              "y": 6.2581,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.379,
              "y": 6.3139,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491110211"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c86",
            "leftCorner": {
              "x": 32.379,
              "y": 6.3139,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.43,
              "y": 6.3675,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932136586"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c87",
            "leftCorner": {
              "x": 32.43,
              "y": 6.3675,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.494,
              "y": 6.4362,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c88",
            "leftCorner": {
              "x": 32.494,
              "y": 6.4362,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.524,
              "y": 6.4674,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932135923"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c89",
            "leftCorner": {
              "x": 32.524,
              "y": 6.4674,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.548,
              "y": 6.4925,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573289052"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c80",
            "leftCorner": {
              "x": 32.548,
              "y": 6.4925,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 32.572,
              "y": 6.5183,
              "z": 1.7268
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573289052"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 58,
      "unknownStockCount": 15
    },
    "name": "J0MD",
    "leftNeighborShelfId": "PKZ7",
    "rightNeighborShelfId": "RA6K"
  },
  {
    "id": "VYWH",
    "x": 34.671,
    "y": 8.7804,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.40147,
      "w": 0.91587
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acc3",
        "height": 0.19256,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d1f",
            "leftCorner": {
              "x": 34.744,
              "y": 8.7134,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 34.786,
              "y": 8.7587,
              "z": 0.19256
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491277297"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d21",
            "leftCorner": {
              "x": 34.786,
              "y": 8.7587,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 34.837,
              "y": 8.8146,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491105224"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d22",
            "leftCorner": {
              "x": 34.837,
              "y": 8.8146,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 34.893,
              "y": 8.8746,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491276276"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d23",
            "leftCorner": {
              "x": 34.893,
              "y": 8.8746,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 34.957,
              "y": 8.944,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617032168"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d24",
            "leftCorner": {
              "x": 34.957,
              "y": 8.944,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 34.989,
              "y": 8.9789,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087446552"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d25",
            "leftCorner": {
              "x": 34.989,
              "y": 8.9789,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.019,
              "y": 9.0116,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087446552"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d26",
            "leftCorner": {
              "x": 35.019,
              "y": 9.0116,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.072,
              "y": 9.069,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796102314"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d27",
            "leftCorner": {
              "x": 35.072,
              "y": 9.069,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.118,
              "y": 9.1195,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447249163"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d28",
            "leftCorner": {
              "x": 35.118,
              "y": 9.1195,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.171,
              "y": 9.1764,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172694400"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d29",
            "leftCorner": {
              "x": 35.171,
              "y": 9.1764,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.231,
              "y": 9.2418,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932136616"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d2a",
            "leftCorner": {
              "x": 35.231,
              "y": 9.2418,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.293,
              "y": 9.3091,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491111317"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d2b",
            "leftCorner": {
              "x": 35.293,
              "y": 9.3091,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.353,
              "y": 9.3745,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932009064"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d2c",
            "leftCorner": {
              "x": 35.353,
              "y": 9.3745,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.396,
              "y": 9.421,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172696183"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acbe",
        "height": 0.50025,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ca0",
            "leftCorner": {
              "x": 34.665,
              "y": 8.7861,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.703,
              "y": 8.8268,
              "z": 0.50025
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932002010"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca2",
            "leftCorner": {
              "x": 34.703,
              "y": 8.8268,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.764,
              "y": 8.893,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447248838"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca3",
            "leftCorner": {
              "x": 34.764,
              "y": 8.893,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.825,
              "y": 8.9598,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133431"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca4",
            "leftCorner": {
              "x": 34.825,
              "y": 8.9598,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.889,
              "y": 9.0283,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131888"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca5",
            "leftCorner": {
              "x": 34.889,
              "y": 9.0283,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.95,
              "y": 9.0952,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617140177"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca6",
            "leftCorner": {
              "x": 34.95,
              "y": 9.0952,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 34.994,
              "y": 9.1426,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617041887"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca7",
            "leftCorner": {
              "x": 34.994,
              "y": 9.1426,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.057,
              "y": 9.211,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617042587"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca8",
            "leftCorner": {
              "x": 35.057,
              "y": 9.211,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.117,
              "y": 9.2761,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087444602"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca9",
            "leftCorner": {
              "x": 35.117,
              "y": 9.2761,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.174,
              "y": 9.3385,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695797"
          },
          {
            "id": "679afb3e3d9bab0f83ff5caa",
            "leftCorner": {
              "x": 35.174,
              "y": 9.3385,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.226,
              "y": 9.3946,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172922039"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cab",
            "leftCorner": {
              "x": 35.226,
              "y": 9.3946,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.314,
              "y": 9.4899,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932008999"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cac",
            "leftCorner": {
              "x": 35.314,
              "y": 9.4899,
              "z": 0.50025
            },
            "rightCorner": {
              "x": 35.343,
              "y": 9.5214,
              "z": 0.50025
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932134483"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acbd",
        "height": 0.75091,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c8b",
            "leftCorner": {
              "x": 34.669,
              "y": 8.7988,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 34.727,
              "y": 8.8616,
              "z": 0.75091
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4009932138382"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c8c",
            "leftCorner": {
              "x": 34.727,
              "y": 8.8616,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 34.779,
              "y": 8.9174,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752201057"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c8d",
            "leftCorner": {
              "x": 34.779,
              "y": 8.9174,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 34.842,
              "y": 8.9868,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617040644"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c8e",
            "leftCorner": {
              "x": 34.842,
              "y": 8.9868,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 34.907,
              "y": 9.0571,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447249002"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c8f",
            "leftCorner": {
              "x": 34.907,
              "y": 9.0571,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 34.964,
              "y": 9.1185,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752205154"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c90",
            "leftCorner": {
              "x": 34.964,
              "y": 9.1185,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.022,
              "y": 9.1816,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491110341"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c91",
            "leftCorner": {
              "x": 35.022,
              "y": 9.1816,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.076,
              "y": 9.2407,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491102995"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c92",
            "leftCorner": {
              "x": 35.076,
              "y": 9.2407,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.13,
              "y": 9.2985,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491103114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c93",
            "leftCorner": {
              "x": 35.13,
              "y": 9.2985,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.187,
              "y": 9.3602,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491108409"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c94",
            "leftCorner": {
              "x": 35.187,
              "y": 9.3602,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.236,
              "y": 9.414,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932133394"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c95",
            "leftCorner": {
              "x": 35.236,
              "y": 9.414,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.288,
              "y": 9.4708,
              "z": 0.75091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932132687"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c96",
            "leftCorner": {
              "x": 35.288,
              "y": 9.4708,
              "z": 0.75091
            },
            "rightCorner": {
              "x": 35.339,
              "y": 9.5254,
              "z": 0.75091
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4262394850012"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acbf",
        "height": 1.0006,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cb7",
            "leftCorner": {
              "x": 34.659,
              "y": 8.7916,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 34.71,
              "y": 8.8468,
              "z": 1.0006
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172936999"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb9",
            "leftCorner": {
              "x": 34.71,
              "y": 8.8468,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 34.778,
              "y": 8.9206,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447015072"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cba",
            "leftCorner": {
              "x": 34.778,
              "y": 8.9206,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 34.849,
              "y": 8.9975,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447248746"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cbb",
            "leftCorner": {
              "x": 34.849,
              "y": 8.9975,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 34.902,
              "y": 9.0544,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447015195"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cbc",
            "leftCorner": {
              "x": 34.902,
              "y": 9.0544,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 34.963,
              "y": 9.1215,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932004533"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cbd",
            "leftCorner": {
              "x": 34.963,
              "y": 9.1215,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.025,
              "y": 9.1886,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752203990"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cbe",
            "leftCorner": {
              "x": 35.025,
              "y": 9.1886,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.082,
              "y": 9.2505,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260639690072"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cbf",
            "leftCorner": {
              "x": 35.082,
              "y": 9.2505,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.145,
              "y": 9.3183,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491276528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc0",
            "leftCorner": {
              "x": 35.145,
              "y": 9.3183,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.192,
              "y": 9.3697,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172922053"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc1",
            "leftCorner": {
              "x": 35.192,
              "y": 9.3697,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.237,
              "y": 9.4179,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000033"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc2",
            "leftCorner": {
              "x": 35.237,
              "y": 9.4179,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.295,
              "y": 9.4813,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447219319"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc3",
            "leftCorner": {
              "x": 35.295,
              "y": 9.4813,
              "z": 1.0006
            },
            "rightCorner": {
              "x": 35.356,
              "y": 9.5481,
              "z": 1.0006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447336986"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc0",
        "height": 1.2544,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cd0",
            "leftCorner": {
              "x": 34.66,
              "y": 8.7908,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.706,
              "y": 8.8405,
              "z": 1.2544
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172694271"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd2",
            "leftCorner": {
              "x": 34.706,
              "y": 8.8405,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.758,
              "y": 8.8973,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172694271"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd3",
            "leftCorner": {
              "x": 34.758,
              "y": 8.8973,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.799,
              "y": 8.9414,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172694493"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd4",
            "leftCorner": {
              "x": 34.799,
              "y": 8.9414,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.857,
              "y": 9.0045,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172921919"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd5",
            "leftCorner": {
              "x": 34.857,
              "y": 9.0045,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.916,
              "y": 9.0684,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087410652"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd6",
            "leftCorner": {
              "x": 34.916,
              "y": 9.0684,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 34.978,
              "y": 9.136,
              "z": 1.2544
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008617037125"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd7",
            "leftCorner": {
              "x": 34.978,
              "y": 9.136,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.041,
              "y": 9.2043,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932135565"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd8",
            "leftCorner": {
              "x": 35.041,
              "y": 9.2043,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.099,
              "y": 9.2668,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932134346"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd9",
            "leftCorner": {
              "x": 35.099,
              "y": 9.2668,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.182,
              "y": 9.357,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491105187"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cda",
            "leftCorner": {
              "x": 35.182,
              "y": 9.357,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.259,
              "y": 9.4411,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087410157"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cdb",
            "leftCorner": {
              "x": 35.259,
              "y": 9.4411,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.333,
              "y": 9.5213,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087410157"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc1",
        "height": 1.5079,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ce9",
            "leftCorner": {
              "x": 34.662,
              "y": 8.789,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.699,
              "y": 8.8286,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4083700301956"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ceb",
            "leftCorner": {
              "x": 34.699,
              "y": 8.8286,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.729,
              "y": 8.8614,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250752201644"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cec",
            "leftCorner": {
              "x": 34.729,
              "y": 8.8614,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.764,
              "y": 8.8995,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447412963"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ced",
            "leftCorner": {
              "x": 34.764,
              "y": 8.8995,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.797,
              "y": 8.9359,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447412963"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cee",
            "leftCorner": {
              "x": 34.797,
              "y": 8.9359,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.849,
              "y": 8.9923,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581583737"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cef",
            "leftCorner": {
              "x": 34.849,
              "y": 8.9923,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.909,
              "y": 9.0573,
              "z": 1.5079
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260613230027"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf0",
            "leftCorner": {
              "x": 34.909,
              "y": 9.0573,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 34.968,
              "y": 9.1215,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003087410850"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf1",
            "leftCorner": {
              "x": 34.968,
              "y": 9.1215,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.024,
              "y": 9.182,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617007975"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf2",
            "leftCorner": {
              "x": 35.024,
              "y": 9.182,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.076,
              "y": 9.2384,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491112901"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf3",
            "leftCorner": {
              "x": 35.076,
              "y": 9.2384,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.14,
              "y": 9.3072,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172777752"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf4",
            "leftCorner": {
              "x": 35.14,
              "y": 9.3072,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.201,
              "y": 9.3734,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796079012"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf5",
            "leftCorner": {
              "x": 35.201,
              "y": 9.3734,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.257,
              "y": 9.4346,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932002546"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf6",
            "leftCorner": {
              "x": 35.257,
              "y": 9.4346,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.31,
              "y": 9.4923,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491119771"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf7",
            "leftCorner": {
              "x": 35.31,
              "y": 9.4923,
              "z": 1.5079
            },
            "rightCorner": {
              "x": 35.373,
              "y": 9.5609,
              "z": 1.5079
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447412789"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc2",
        "height": 1.7204,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d07",
            "leftCorner": {
              "x": 34.677,
              "y": 8.8152,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 34.786,
              "y": 8.9344,
              "z": 1.7204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "2050000040764"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d08",
            "leftCorner": {
              "x": 34.786,
              "y": 8.9344,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 34.85,
              "y": 9.0036,
              "z": 1.7204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4083700302281"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d09",
            "leftCorner": {
              "x": 34.85,
              "y": 9.0036,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 34.907,
              "y": 9.0657,
              "z": 1.7204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491115612"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0a",
            "leftCorner": {
              "x": 34.907,
              "y": 9.0657,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 34.957,
              "y": 9.1201,
              "z": 1.7204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796107128"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0b",
            "leftCorner": {
              "x": 34.957,
              "y": 9.1201,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.022,
              "y": 9.1904,
              "z": 1.7204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172771842"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0c",
            "leftCorner": {
              "x": 35.022,
              "y": 9.1904,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.052,
              "y": 9.2221,
              "z": 1.7204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4026600498005"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0d",
            "leftCorner": {
              "x": 35.052,
              "y": 9.2221,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.11,
              "y": 9.2853,
              "z": 1.7204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491445887"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0e",
            "leftCorner": {
              "x": 35.11,
              "y": 9.2853,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.15,
              "y": 9.3285,
              "z": 1.7204
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42094012"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d0f",
            "leftCorner": {
              "x": 35.15,
              "y": 9.3285,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.275,
              "y": 9.4648,
              "z": 1.7204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5010724538623"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d10",
            "leftCorner": {
              "x": 35.275,
              "y": 9.4648,
              "z": 1.7204
            },
            "rightCorner": {
              "x": 35.296,
              "y": 9.4869,
              "z": 1.7204
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5010724525517"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d11",
            "leftCorner": {
              "x": 35.292,
              "y": 9.4776,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.334,
              "y": 9.5225,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250752203723"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 71,
      "unknownStockCount": 11
    },
    "name": "VYWH",
    "leftNeighborShelfId": "2V4N",
    "rightNeighborShelfId": "U1ST"
  },
  {
    "id": "CJ5U",
    "x": 35.346,
    "y": 9.5062,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.39662,
      "w": 0.91798
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acca",
        "height": 0.19066,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d2d",
            "leftCorner": {
              "x": 35.396,
              "y": 9.421,
              "z": 0.19256
            },
            "rightCorner": {
              "x": 35.457,
              "y": 9.4866,
              "z": 0.19256
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584585"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d2e",
            "leftCorner": {
              "x": 35.455,
              "y": 9.4745,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.524,
              "y": 9.5477,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584585"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d2f",
            "leftCorner": {
              "x": 35.524,
              "y": 9.5477,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.588,
              "y": 9.6159,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617133919"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d30",
            "leftCorner": {
              "x": 35.588,
              "y": 9.6159,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.613,
              "y": 9.6422,
              "z": 0.19066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d31",
            "leftCorner": {
              "x": 35.613,
              "y": 9.6422,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.651,
              "y": 9.6829,
              "z": 0.19066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617133957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d32",
            "leftCorner": {
              "x": 35.651,
              "y": 9.6829,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.67,
              "y": 9.7029,
              "z": 0.19066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617133957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d33",
            "leftCorner": {
              "x": 35.67,
              "y": 9.7029,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.705,
              "y": 9.7399,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617260202"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d34",
            "leftCorner": {
              "x": 35.705,
              "y": 9.7399,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.745,
              "y": 9.7824,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617260202"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d35",
            "leftCorner": {
              "x": 35.745,
              "y": 9.7824,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.809,
              "y": 9.8506,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932131406"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d36",
            "leftCorner": {
              "x": 35.809,
              "y": 9.8506,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.887,
              "y": 9.9337,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231731"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d37",
            "leftCorner": {
              "x": 35.887,
              "y": 9.9337,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 35.956,
              "y": 10.007,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231731"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d38",
            "leftCorner": {
              "x": 35.956,
              "y": 10.007,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 36.021,
              "y": 10.076,
              "z": 0.19066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172658204"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d39",
            "leftCorner": {
              "x": 36.021,
              "y": 10.076,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 36.081,
              "y": 10.139,
              "z": 0.19066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447399127"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d20",
            "leftCorner": {
              "x": 36.081,
              "y": 10.139,
              "z": 0.19066
            },
            "rightCorner": {
              "x": 36.105,
              "y": 10.165,
              "z": 0.19066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc7",
        "height": 0.49888,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cad",
            "leftCorner": {
              "x": 35.339,
              "y": 9.513,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.411,
              "y": 9.5913,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4009932134001"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cae",
            "leftCorner": {
              "x": 35.412,
              "y": 9.5905,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.475,
              "y": 9.6576,
              "z": 0.49888
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617880523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5caf",
            "leftCorner": {
              "x": 35.475,
              "y": 9.6576,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.497,
              "y": 9.6814,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb0",
            "leftCorner": {
              "x": 35.497,
              "y": 9.6814,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.575,
              "y": 9.7644,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006309035015"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb1",
            "leftCorner": {
              "x": 35.575,
              "y": 9.7644,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.649,
              "y": 9.8425,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172695858"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb2",
            "leftCorner": {
              "x": 35.649,
              "y": 9.8425,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.716,
              "y": 9.9139,
              "z": 0.49888
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009932006612"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb3",
            "leftCorner": {
              "x": 35.716,
              "y": 9.9139,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.789,
              "y": 9.9916,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617136651"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb4",
            "leftCorner": {
              "x": 35.789,
              "y": 9.9916,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.839,
              "y": 10.044,
              "z": 0.49888
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5410076765812"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb5",
            "leftCorner": {
              "x": 35.839,
              "y": 10.044,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.903,
              "y": 10.112,
              "z": 0.49888
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015600141004"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb6",
            "leftCorner": {
              "x": 35.903,
              "y": 10.112,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 35.954,
              "y": 10.167,
              "z": 0.49888
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4022167700094"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ca1",
            "leftCorner": {
              "x": 35.954,
              "y": 10.167,
              "z": 0.49888
            },
            "rightCorner": {
              "x": 36.024,
              "y": 10.241,
              "z": 0.49888
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4022167130150"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc9",
        "height": 0.74964,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5c97",
            "leftCorner": {
              "x": 35.336,
              "y": 9.5159,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.359,
              "y": 9.5412,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c98",
            "leftCorner": {
              "x": 35.359,
              "y": 9.5409,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.42,
              "y": 9.6058,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c99",
            "leftCorner": {
              "x": 35.42,
              "y": 9.6058,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.46,
              "y": 9.6482,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9a",
            "leftCorner": {
              "x": 35.46,
              "y": 9.6482,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.587,
              "y": 9.7827,
              "z": 0.74964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447518610"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9b",
            "leftCorner": {
              "x": 35.587,
              "y": 9.7827,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.736,
              "y": 9.9415,
              "z": 0.74964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "2050000040405"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9c",
            "leftCorner": {
              "x": 35.736,
              "y": 9.9415,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.801,
              "y": 10.01,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617136552"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9d",
            "leftCorner": {
              "x": 35.801,
              "y": 10.01,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.856,
              "y": 10.068,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491116138"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9e",
            "leftCorner": {
              "x": 35.856,
              "y": 10.068,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.91,
              "y": 10.126,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491116138"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c9f",
            "leftCorner": {
              "x": 35.91,
              "y": 10.126,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 35.961,
              "y": 10.181,
              "z": 0.74964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491129404"
          },
          {
            "id": "679afb3e3d9bab0f83ff5c8a",
            "leftCorner": {
              "x": 35.961,
              "y": 10.181,
              "z": 0.74964
            },
            "rightCorner": {
              "x": 36.021,
              "y": 10.244,
              "z": 0.74964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447248777"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc5",
        "height": 1.0005,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cc4",
            "leftCorner": {
              "x": 35.353,
              "y": 9.5391,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.398,
              "y": 9.5874,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581583461"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc5",
            "leftCorner": {
              "x": 35.398,
              "y": 9.5874,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.456,
              "y": 9.6487,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617134220"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc6",
            "leftCorner": {
              "x": 35.456,
              "y": 9.6487,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.51,
              "y": 9.706,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617134909"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc7",
            "leftCorner": {
              "x": 35.51,
              "y": 9.706,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.53,
              "y": 9.7275,
              "z": 1.0005
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc8",
            "leftCorner": {
              "x": 35.53,
              "y": 9.7275,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.576,
              "y": 9.7758,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617137092"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cc9",
            "leftCorner": {
              "x": 35.576,
              "y": 9.7758,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.655,
              "y": 9.8602,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617136675"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cca",
            "leftCorner": {
              "x": 35.655,
              "y": 9.8602,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.748,
              "y": 9.9592,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617131113"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ccb",
            "leftCorner": {
              "x": 35.748,
              "y": 9.9592,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.807,
              "y": 10.021,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491115933"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ccc",
            "leftCorner": {
              "x": 35.807,
              "y": 10.021,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.848,
              "y": 10.065,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491223362"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ccd",
            "leftCorner": {
              "x": 35.848,
              "y": 10.065,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.892,
              "y": 10.112,
              "z": 1.0005
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008491111928"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cce",
            "leftCorner": {
              "x": 35.892,
              "y": 10.112,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.936,
              "y": 10.158,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491112581"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ccf",
            "leftCorner": {
              "x": 35.936,
              "y": 10.158,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 35.975,
              "y": 10.2,
              "z": 1.0005
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581583508"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cb8",
            "leftCorner": {
              "x": 35.975,
              "y": 10.2,
              "z": 1.0005
            },
            "rightCorner": {
              "x": 36.019,
              "y": 10.246,
              "z": 1.0005
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250752202962"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc4",
        "height": 1.2543,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cdc",
            "leftCorner": {
              "x": 35.333,
              "y": 9.5213,
              "z": 1.2544
            },
            "rightCorner": {
              "x": 35.395,
              "y": 9.5886,
              "z": 1.2544
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573488486"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cdd",
            "leftCorner": {
              "x": 35.394,
              "y": 9.5776,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.45,
              "y": 9.6369,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617011668"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cde",
            "leftCorner": {
              "x": 35.45,
              "y": 9.6369,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.504,
              "y": 9.6946,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617134404"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cdf",
            "leftCorner": {
              "x": 35.504,
              "y": 9.6946,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.525,
              "y": 9.7168,
              "z": 1.2543
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172695384"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce0",
            "leftCorner": {
              "x": 35.525,
              "y": 9.7168,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.563,
              "y": 9.7576,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695384"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce1",
            "leftCorner": {
              "x": 35.563,
              "y": 9.7576,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.621,
              "y": 9.8185,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172320934"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce2",
            "leftCorner": {
              "x": 35.621,
              "y": 9.8185,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.671,
              "y": 9.8716,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172694912"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce3",
            "leftCorner": {
              "x": 35.671,
              "y": 9.8716,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.725,
              "y": 9.9291,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491444200"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce4",
            "leftCorner": {
              "x": 35.725,
              "y": 9.9291,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.785,
              "y": 9.9926,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491444200"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce5",
            "leftCorner": {
              "x": 35.785,
              "y": 9.9926,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.846,
              "y": 10.058,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172695643"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce6",
            "leftCorner": {
              "x": 35.846,
              "y": 10.058,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.882,
              "y": 10.096,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617141211"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce7",
            "leftCorner": {
              "x": 35.882,
              "y": 10.096,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.92,
              "y": 10.137,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617141297"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ce8",
            "leftCorner": {
              "x": 35.92,
              "y": 10.137,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 35.971,
              "y": 10.19,
              "z": 1.2543
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491225137"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cd1",
            "leftCorner": {
              "x": 35.971,
              "y": 10.19,
              "z": 1.2543
            },
            "rightCorner": {
              "x": 36.021,
              "y": 10.244,
              "z": 1.2543
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448089773"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc8",
        "height": 1.5085,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5cf8",
            "leftCorner": {
              "x": 35.37,
              "y": 9.5519,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.424,
              "y": 9.6093,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617148012"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cf9",
            "leftCorner": {
              "x": 35.424,
              "y": 9.6093,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.479,
              "y": 9.6679,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617148005"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cfa",
            "leftCorner": {
              "x": 35.479,
              "y": 9.6679,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.5,
              "y": 9.6898,
              "z": 1.5085
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617148951"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cfb",
            "leftCorner": {
              "x": 35.5,
              "y": 9.6898,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.545,
              "y": 9.7377,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617148951"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cfc",
            "leftCorner": {
              "x": 35.545,
              "y": 9.7377,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.598,
              "y": 9.794,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617152606"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cfd",
            "leftCorner": {
              "x": 35.598,
              "y": 9.794,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.654,
              "y": 9.8539,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448089735"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cfe",
            "leftCorner": {
              "x": 35.654,
              "y": 9.8539,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.709,
              "y": 9.9125,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448089797"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cff",
            "leftCorner": {
              "x": 35.709,
              "y": 9.9125,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.746,
              "y": 9.9513,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104480465628"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d00",
            "leftCorner": {
              "x": 35.746,
              "y": 9.9513,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.786,
              "y": 9.9937,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104480465826"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d01",
            "leftCorner": {
              "x": 35.786,
              "y": 9.9937,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.841,
              "y": 10.053,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491216494"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d02",
            "leftCorner": {
              "x": 35.841,
              "y": 10.053,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.894,
              "y": 10.109,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491281423"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d03",
            "leftCorner": {
              "x": 35.894,
              "y": 10.109,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.924,
              "y": 10.14,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491112116"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d04",
            "leftCorner": {
              "x": 35.924,
              "y": 10.14,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.958,
              "y": 10.177,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40837086"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d05",
            "leftCorner": {
              "x": 35.958,
              "y": 10.177,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 35.99,
              "y": 10.211,
              "z": 1.5085
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40837116"
          },
          {
            "id": "679afb3e3d9bab0f83ff5cea",
            "leftCorner": {
              "x": 35.99,
              "y": 10.211,
              "z": 1.5085
            },
            "rightCorner": {
              "x": 36.021,
              "y": 10.244,
              "z": 1.5085
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4083700304087"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acc6",
        "height": 1.7219,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d12",
            "leftCorner": {
              "x": 35.334,
              "y": 9.5221,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.375,
              "y": 9.5659,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250752202986"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d13",
            "leftCorner": {
              "x": 35.375,
              "y": 9.5655,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.412,
              "y": 9.6057,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008617023470"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d14",
            "leftCorner": {
              "x": 35.413,
              "y": 9.6053,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.444,
              "y": 9.6382,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617121527"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d15",
            "leftCorner": {
              "x": 35.444,
              "y": 9.6382,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.491,
              "y": 9.6887,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008617256342"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d16",
            "leftCorner": {
              "x": 35.491,
              "y": 9.6887,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.512,
              "y": 9.7107,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491116121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d17",
            "leftCorner": {
              "x": 35.512,
              "y": 9.7107,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.553,
              "y": 9.7547,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491116121"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d18",
            "leftCorner": {
              "x": 35.553,
              "y": 9.7547,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.61,
              "y": 9.8152,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491221870"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d19",
            "leftCorner": {
              "x": 35.61,
              "y": 9.8152,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.664,
              "y": 9.8728,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491312622"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d1a",
            "leftCorner": {
              "x": 35.664,
              "y": 9.8728,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.723,
              "y": 9.9354,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491261708"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d1b",
            "leftCorner": {
              "x": 35.723,
              "y": 9.9354,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.784,
              "y": 10,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172938849"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d1c",
            "leftCorner": {
              "x": 35.784,
              "y": 10,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.848,
              "y": 10.068,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172938863"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d1d",
            "leftCorner": {
              "x": 35.848,
              "y": 10.068,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.909,
              "y": 10.133,
              "z": 1.7219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172938887"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d1e",
            "leftCorner": {
              "x": 35.909,
              "y": 10.133,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 35.965,
              "y": 10.192,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172938900"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d06",
            "leftCorner": {
              "x": 35.965,
              "y": 10.192,
              "z": 1.7219
            },
            "rightCorner": {
              "x": 36.017,
              "y": 10.248,
              "z": 1.7219
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447423129"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 65,
      "unknownStockCount": 25
    },
    "name": "CJ5U",
    "leftNeighborShelfId": "J4M5",
    "rightNeighborShelfId": "7YAR"
  },
  {
    "id": "U1V2",
    "x": 39.237,
    "y": 11.014,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.90807,
      "w": -0.41882
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3accf",
        "height": 0.15474,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d67",
            "leftCorner": {
              "x": 39.159,
              "y": 11.081,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 39.071,
              "y": 10.978,
              "z": 0.15474
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172862908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d68",
            "leftCorner": {
              "x": 39.071,
              "y": 10.978,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 39.027,
              "y": 10.926,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d69",
            "leftCorner": {
              "x": 39.027,
              "y": 10.926,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.983,
              "y": 10.874,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6a",
            "leftCorner": {
              "x": 38.983,
              "y": 10.874,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.933,
              "y": 10.816,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6b",
            "leftCorner": {
              "x": 38.933,
              "y": 10.816,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.892,
              "y": 10.768,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6c",
            "leftCorner": {
              "x": 38.892,
              "y": 10.768,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.842,
              "y": 10.709,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578515"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6d",
            "leftCorner": {
              "x": 38.842,
              "y": 10.709,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.787,
              "y": 10.645,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106237"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6e",
            "leftCorner": {
              "x": 38.787,
              "y": 10.645,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.75,
              "y": 10.602,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106237"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d6f",
            "leftCorner": {
              "x": 38.75,
              "y": 10.602,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.694,
              "y": 10.536,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106350"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d70",
            "leftCorner": {
              "x": 38.694,
              "y": 10.536,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.631,
              "y": 10.462,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106350"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d71",
            "leftCorner": {
              "x": 38.631,
              "y": 10.462,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.584,
              "y": 10.407,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d72",
            "leftCorner": {
              "x": 38.584,
              "y": 10.407,
              "z": 0.15474
            },
            "rightCorner": {
              "x": 38.532,
              "y": 10.346,
              "z": 0.15474
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578553"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd0",
        "height": 0.41644,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d73",
            "leftCorner": {
              "x": 39.236,
              "y": 10.988,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.195,
              "y": 10.939,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106091"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d74",
            "leftCorner": {
              "x": 39.195,
              "y": 10.939,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.174,
              "y": 10.915,
              "z": 0.41644
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d75",
            "leftCorner": {
              "x": 39.174,
              "y": 10.915,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.149,
              "y": 10.886,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d76",
            "leftCorner": {
              "x": 39.149,
              "y": 10.886,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.106,
              "y": 10.836,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d77",
            "leftCorner": {
              "x": 39.106,
              "y": 10.836,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.061,
              "y": 10.782,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d78",
            "leftCorner": {
              "x": 39.061,
              "y": 10.782,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 39.02,
              "y": 10.734,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d79",
            "leftCorner": {
              "x": 39.02,
              "y": 10.734,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.978,
              "y": 10.685,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7a",
            "leftCorner": {
              "x": 38.978,
              "y": 10.685,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.929,
              "y": 10.628,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7b",
            "leftCorner": {
              "x": 38.929,
              "y": 10.628,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.884,
              "y": 10.575,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7c",
            "leftCorner": {
              "x": 38.884,
              "y": 10.575,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.841,
              "y": 10.524,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106114"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7d",
            "leftCorner": {
              "x": 38.841,
              "y": 10.524,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.795,
              "y": 10.471,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7e",
            "leftCorner": {
              "x": 38.795,
              "y": 10.471,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.751,
              "y": 10.419,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578416"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d7f",
            "leftCorner": {
              "x": 38.751,
              "y": 10.419,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.708,
              "y": 10.369,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578416"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d80",
            "leftCorner": {
              "x": 38.708,
              "y": 10.369,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.666,
              "y": 10.32,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578416"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d81",
            "leftCorner": {
              "x": 38.666,
              "y": 10.32,
              "z": 0.41644
            },
            "rightCorner": {
              "x": 38.606,
              "y": 10.249,
              "z": 0.41644
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3accc",
        "height": 0.66844,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d47",
            "leftCorner": {
              "x": 39.248,
              "y": 11.005,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 39.201,
              "y": 10.95,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d48",
            "leftCorner": {
              "x": 39.201,
              "y": 10.95,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 39.134,
              "y": 10.871,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447502848"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d49",
            "leftCorner": {
              "x": 39.134,
              "y": 10.871,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 39.054,
              "y": 10.777,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447579734"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4a",
            "leftCorner": {
              "x": 39.054,
              "y": 10.777,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.946,
              "y": 10.651,
              "z": 0.66844
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447579772"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4b",
            "leftCorner": {
              "x": 38.946,
              "y": 10.651,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.9,
              "y": 10.597,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107319"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4c",
            "leftCorner": {
              "x": 38.9,
              "y": 10.597,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.859,
              "y": 10.549,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107319"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4d",
            "leftCorner": {
              "x": 38.859,
              "y": 10.549,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.816,
              "y": 10.499,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107319"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4e",
            "leftCorner": {
              "x": 38.816,
              "y": 10.499,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.769,
              "y": 10.443,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d4f",
            "leftCorner": {
              "x": 38.769,
              "y": 10.443,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.725,
              "y": 10.392,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107333"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d50",
            "leftCorner": {
              "x": 38.725,
              "y": 10.392,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.682,
              "y": 10.341,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447579697"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d51",
            "leftCorner": {
              "x": 38.682,
              "y": 10.341,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.646,
              "y": 10.299,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447579710"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d52",
            "leftCorner": {
              "x": 38.646,
              "y": 10.299,
              "z": 0.66844
            },
            "rightCorner": {
              "x": 38.6,
              "y": 10.246,
              "z": 0.66844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796119039"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3accb",
        "height": 0.91507,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d3a",
            "leftCorner": {
              "x": 39.25,
              "y": 11.003,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 39.184,
              "y": 10.926,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578096"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d3b",
            "leftCorner": {
              "x": 39.184,
              "y": 10.926,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 39.092,
              "y": 10.818,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578096"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d3c",
            "leftCorner": {
              "x": 39.092,
              "y": 10.818,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 39.045,
              "y": 10.764,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d3d",
            "leftCorner": {
              "x": 39.045,
              "y": 10.764,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 39.002,
              "y": 10.713,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578430"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d3e",
            "leftCorner": {
              "x": 39.002,
              "y": 10.713,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.958,
              "y": 10.662,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578430"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d3f",
            "leftCorner": {
              "x": 38.958,
              "y": 10.662,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.91,
              "y": 10.605,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106152"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d40",
            "leftCorner": {
              "x": 38.91,
              "y": 10.605,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.867,
              "y": 10.555,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447106152"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d41",
            "leftCorner": {
              "x": 38.867,
              "y": 10.555,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.825,
              "y": 10.505,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578577"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d42",
            "leftCorner": {
              "x": 38.825,
              "y": 10.505,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.776,
              "y": 10.449,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578577"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d43",
            "leftCorner": {
              "x": 38.776,
              "y": 10.449,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.73,
              "y": 10.395,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578577"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d44",
            "leftCorner": {
              "x": 38.73,
              "y": 10.395,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.686,
              "y": 10.343,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578577"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d45",
            "leftCorner": {
              "x": 38.686,
              "y": 10.343,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.647,
              "y": 10.298,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578591"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d46",
            "leftCorner": {
              "x": 38.647,
              "y": 10.298,
              "z": 0.91507
            },
            "rightCorner": {
              "x": 38.607,
              "y": 10.25,
              "z": 0.91507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578591"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acce",
        "height": 1.1726,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d5c",
            "leftCorner": {
              "x": 39.251,
              "y": 11.008,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 39.107,
              "y": 10.839,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447577976"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d5d",
            "leftCorner": {
              "x": 39.107,
              "y": 10.839,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.958,
              "y": 10.665,
              "z": 1.1726
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447105957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d5e",
            "leftCorner": {
              "x": 38.958,
              "y": 10.665,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.91,
              "y": 10.609,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578478"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d5f",
            "leftCorner": {
              "x": 38.91,
              "y": 10.609,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.866,
              "y": 10.558,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107210"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d60",
            "leftCorner": {
              "x": 38.866,
              "y": 10.558,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.824,
              "y": 10.508,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107210"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d61",
            "leftCorner": {
              "x": 38.824,
              "y": 10.508,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.783,
              "y": 10.46,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447105797"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d62",
            "leftCorner": {
              "x": 38.783,
              "y": 10.46,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.742,
              "y": 10.412,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578058"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d63",
            "leftCorner": {
              "x": 38.742,
              "y": 10.412,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.705,
              "y": 10.369,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447578072"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d64",
            "leftCorner": {
              "x": 38.705,
              "y": 10.369,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.665,
              "y": 10.321,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447577938"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d65",
            "leftCorner": {
              "x": 38.665,
              "y": 10.321,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.64,
              "y": 10.292,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447577952"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d66",
            "leftCorner": {
              "x": 38.64,
              "y": 10.292,
              "z": 1.1726
            },
            "rightCorner": {
              "x": 38.602,
              "y": 10.247,
              "z": 1.1726
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447105636"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3accd",
        "height": 1.4259,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d53",
            "leftCorner": {
              "x": 39.251,
              "y": 11.002,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 39.11,
              "y": 10.837,
              "z": 1.4259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447639322"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d54",
            "leftCorner": {
              "x": 39.11,
              "y": 10.837,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.882,
              "y": 10.57,
              "z": 1.4259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447639193"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d55",
            "leftCorner": {
              "x": 38.882,
              "y": 10.57,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.815,
              "y": 10.491,
              "z": 1.4259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4083700304582"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d56",
            "leftCorner": {
              "x": 38.815,
              "y": 10.491,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.776,
              "y": 10.446,
              "z": 1.4259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260310412290"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d57",
            "leftCorner": {
              "x": 38.776,
              "y": 10.446,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.758,
              "y": 10.425,
              "z": 1.4259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447107159"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d58",
            "leftCorner": {
              "x": 38.758,
              "y": 10.425,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.736,
              "y": 10.398,
              "z": 1.4259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d59",
            "leftCorner": {
              "x": 38.736,
              "y": 10.398,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.684,
              "y": 10.337,
              "z": 1.4259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172936326"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d5a",
            "leftCorner": {
              "x": 38.684,
              "y": 10.337,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.647,
              "y": 10.294,
              "z": 1.4259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565362"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d5b",
            "leftCorner": {
              "x": 38.647,
              "y": 10.294,
              "z": 1.4259
            },
            "rightCorner": {
              "x": 38.621,
              "y": 10.263,
              "z": 1.4259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107173"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 64,
      "unknownStockCount": 8
    },
    "name": "U1V2",
    "rightNeighborShelfId": "6267"
  },
  {
    "id": "J4M5",
    "x": 37.936,
    "y": 9.4863,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.90466,
      "w": -0.42613
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acd6",
        "height": 0.15761,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e00",
            "leftCorner": {
              "x": 37.855,
              "y": 9.5527,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.823,
              "y": 9.5138,
              "z": 0.15761
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447237627"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e01",
            "leftCorner": {
              "x": 37.823,
              "y": 9.5138,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.771,
              "y": 9.4505,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237627"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e02",
            "leftCorner": {
              "x": 37.771,
              "y": 9.4505,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.711,
              "y": 9.3786,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e03",
            "leftCorner": {
              "x": 37.711,
              "y": 9.3786,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.665,
              "y": 9.3219,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e04",
            "leftCorner": {
              "x": 37.665,
              "y": 9.3219,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.617,
              "y": 9.2649,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447575804"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e05",
            "leftCorner": {
              "x": 37.617,
              "y": 9.2649,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.579,
              "y": 9.2178,
              "z": 0.15761
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447575804"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e06",
            "leftCorner": {
              "x": 37.579,
              "y": 9.2178,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.531,
              "y": 9.1601,
              "z": 0.15761
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447575804"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e07",
            "leftCorner": {
              "x": 37.531,
              "y": 9.1601,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.478,
              "y": 9.0963,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429398"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e08",
            "leftCorner": {
              "x": 37.478,
              "y": 9.0963,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.432,
              "y": 9.0398,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429398"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e09",
            "leftCorner": {
              "x": 37.432,
              "y": 9.0398,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.379,
              "y": 8.976,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429398"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e0a",
            "leftCorner": {
              "x": 37.379,
              "y": 8.976,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.324,
              "y": 8.91,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234633"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e0b",
            "leftCorner": {
              "x": 37.324,
              "y": 8.91,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.272,
              "y": 8.8465,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234633"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e0c",
            "leftCorner": {
              "x": 37.272,
              "y": 8.8465,
              "z": 0.15761
            },
            "rightCorner": {
              "x": 37.204,
              "y": 8.7647,
              "z": 0.15761
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd2",
        "height": 0.416,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d9a",
            "leftCorner": {
              "x": 37.919,
              "y": 9.4544,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.872,
              "y": 9.3972,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714371"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d9b",
            "leftCorner": {
              "x": 37.872,
              "y": 9.3972,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.82,
              "y": 9.334,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714371"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d9c",
            "leftCorner": {
              "x": 37.82,
              "y": 9.334,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.776,
              "y": 9.2807,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714371"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d9d",
            "leftCorner": {
              "x": 37.776,
              "y": 9.2807,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.73,
              "y": 9.2255,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714371"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d9e",
            "leftCorner": {
              "x": 37.73,
              "y": 9.2255,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.685,
              "y": 9.1706,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080933"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d9f",
            "leftCorner": {
              "x": 37.685,
              "y": 9.1706,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.641,
              "y": 9.1174,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080933"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da0",
            "leftCorner": {
              "x": 37.641,
              "y": 9.1174,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.59,
              "y": 9.0561,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da1",
            "leftCorner": {
              "x": 37.59,
              "y": 9.0561,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.538,
              "y": 8.9933,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da2",
            "leftCorner": {
              "x": 37.538,
              "y": 8.9933,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.486,
              "y": 8.9298,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da3",
            "leftCorner": {
              "x": 37.486,
              "y": 8.9298,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.424,
              "y": 8.8547,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da4",
            "leftCorner": {
              "x": 37.424,
              "y": 8.8547,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.377,
              "y": 8.7974,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714395"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da5",
            "leftCorner": {
              "x": 37.377,
              "y": 8.7974,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.327,
              "y": 8.7369,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714395"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da6",
            "leftCorner": {
              "x": 37.327,
              "y": 8.7369,
              "z": 0.416
            },
            "rightCorner": {
              "x": 37.274,
              "y": 8.6732,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714395"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd1",
        "height": 0.67266,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d83",
            "leftCorner": {
              "x": 37.936,
              "y": 9.4726,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.904,
              "y": 9.4345,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447747157"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d84",
            "leftCorner": {
              "x": 37.904,
              "y": 9.4345,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.87,
              "y": 9.393,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447747157"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d85",
            "leftCorner": {
              "x": 37.87,
              "y": 9.393,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.836,
              "y": 9.3524,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238815"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d86",
            "leftCorner": {
              "x": 37.836,
              "y": 9.3524,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.803,
              "y": 9.312,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238815"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d87",
            "leftCorner": {
              "x": 37.803,
              "y": 9.312,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.729,
              "y": 9.223,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238792"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d88",
            "leftCorner": {
              "x": 37.729,
              "y": 9.223,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.642,
              "y": 9.1172,
              "z": 0.67266
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447190977"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d89",
            "leftCorner": {
              "x": 37.642,
              "y": 9.1172,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.591,
              "y": 9.0559,
              "z": 0.67266
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447238839"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d8a",
            "leftCorner": {
              "x": 37.591,
              "y": 9.0559,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.538,
              "y": 8.991,
              "z": 0.67266
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d8b",
            "leftCorner": {
              "x": 37.538,
              "y": 8.991,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.485,
              "y": 8.9274,
              "z": 0.67266
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447238853"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d8c",
            "leftCorner": {
              "x": 37.485,
              "y": 8.9274,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.416,
              "y": 8.8431,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d8d",
            "leftCorner": {
              "x": 37.416,
              "y": 8.8431,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.371,
              "y": 8.7892,
              "z": 0.67266
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447680157"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d8e",
            "leftCorner": {
              "x": 37.371,
              "y": 8.7892,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.314,
              "y": 8.7206,
              "z": 0.67266
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447680157"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd3",
        "height": 0.92219,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5db4",
            "leftCorner": {
              "x": 37.941,
              "y": 9.4797,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.892,
              "y": 9.4197,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900932891"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db5",
            "leftCorner": {
              "x": 37.892,
              "y": 9.4197,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.827,
              "y": 9.3419,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900932891"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db6",
            "leftCorner": {
              "x": 37.827,
              "y": 9.3419,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.782,
              "y": 9.2864,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000137827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db7",
            "leftCorner": {
              "x": 37.782,
              "y": 9.2864,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.735,
              "y": 9.2298,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000137827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db8",
            "leftCorner": {
              "x": 37.735,
              "y": 9.2298,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.686,
              "y": 9.1709,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000137827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db9",
            "leftCorner": {
              "x": 37.686,
              "y": 9.1709,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.638,
              "y": 9.1126,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933034"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dba",
            "leftCorner": {
              "x": 37.638,
              "y": 9.1126,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.589,
              "y": 9.0528,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900939715"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dbb",
            "leftCorner": {
              "x": 37.589,
              "y": 9.0528,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.538,
              "y": 8.9919,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900954558"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dbc",
            "leftCorner": {
              "x": 37.538,
              "y": 8.9919,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.484,
              "y": 8.9259,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933195"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dbd",
            "leftCorner": {
              "x": 37.484,
              "y": 8.9259,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.422,
              "y": 8.8514,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933195"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dbe",
            "leftCorner": {
              "x": 37.422,
              "y": 8.8514,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.364,
              "y": 8.7805,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900944214"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dbf",
            "leftCorner": {
              "x": 37.364,
              "y": 8.7805,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.309,
              "y": 8.7146,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933119"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd5",
        "height": 1.1779,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5de6",
            "leftCorner": {
              "x": 37.942,
              "y": 9.4813,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.878,
              "y": 9.4043,
              "z": 1.1779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181502255"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de8",
            "leftCorner": {
              "x": 37.878,
              "y": 9.4043,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.818,
              "y": 9.3314,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181466373"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de9",
            "leftCorner": {
              "x": 37.818,
              "y": 9.3314,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.758,
              "y": 9.2592,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181466373"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dea",
            "leftCorner": {
              "x": 37.758,
              "y": 9.2592,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.711,
              "y": 9.2015,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181468520"
          },
          {
            "id": "679afb3e3d9bab0f83ff5deb",
            "leftCorner": {
              "x": 37.711,
              "y": 9.2015,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.662,
              "y": 9.1429,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181466526"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dec",
            "leftCorner": {
              "x": 37.662,
              "y": 9.1429,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.61,
              "y": 9.0796,
              "z": 1.1779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181466526"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ded",
            "leftCorner": {
              "x": 37.61,
              "y": 9.0796,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.564,
              "y": 9.0238,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181443459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dee",
            "leftCorner": {
              "x": 37.564,
              "y": 9.0238,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.511,
              "y": 8.9594,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181443459"
          },
          {
            "id": "679afb3e3d9bab0f83ff5def",
            "leftCorner": {
              "x": 37.511,
              "y": 8.9594,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.448,
              "y": 8.8836,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181456855"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df0",
            "leftCorner": {
              "x": 37.448,
              "y": 8.8836,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.392,
              "y": 8.816,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181491948"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df1",
            "leftCorner": {
              "x": 37.392,
              "y": 8.816,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.341,
              "y": 8.7544,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181491948"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df2",
            "leftCorner": {
              "x": 37.341,
              "y": 8.7544,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 37.282,
              "y": 8.6822,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181460029"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd4",
        "height": 1.4313,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5dce",
            "leftCorner": {
              "x": 37.941,
              "y": 9.4784,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.88,
              "y": 9.4053,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040341013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dcf",
            "leftCorner": {
              "x": 37.88,
              "y": 9.4053,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.817,
              "y": 9.328,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040341013"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd0",
            "leftCorner": {
              "x": 37.817,
              "y": 9.328,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.766,
              "y": 9.2667,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040797018"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd1",
            "leftCorner": {
              "x": 37.766,
              "y": 9.2667,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.715,
              "y": 9.2055,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040797018"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd2",
            "leftCorner": {
              "x": 37.715,
              "y": 9.2055,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.664,
              "y": 9.1432,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040908100"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd3",
            "leftCorner": {
              "x": 37.664,
              "y": 9.1432,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.611,
              "y": 9.0792,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040908100"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd4",
            "leftCorner": {
              "x": 37.611,
              "y": 9.0792,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.558,
              "y": 9.0149,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040184153"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd5",
            "leftCorner": {
              "x": 37.558,
              "y": 9.0149,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.504,
              "y": 8.9491,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040184153"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd6",
            "leftCorner": {
              "x": 37.504,
              "y": 8.9491,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.443,
              "y": 8.8753,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006436"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd7",
            "leftCorner": {
              "x": 37.443,
              "y": 8.8753,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.386,
              "y": 8.8071,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006436"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd8",
            "leftCorner": {
              "x": 37.386,
              "y": 8.8071,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.332,
              "y": 8.7409,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591620"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dd9",
            "leftCorner": {
              "x": 37.332,
              "y": 8.7409,
              "z": 1.4313
            },
            "rightCorner": {
              "x": 37.271,
              "y": 8.6678,
              "z": 1.4313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591620"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dda",
            "leftCorner": {
              "x": 37.279,
              "y": 8.674,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 37.227,
              "y": 8.6119,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591620"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 5,
      "hasStockCount": 64,
      "unknownStockCount": 6
    },
    "name": "J4M5",
    "leftNeighborShelfId": "4G76",
    "rightNeighborShelfId": "CJ5U"
  },
  {
    "id": "GS2V",
    "x": 37.301,
    "y": 8.7263,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.90648,
      "w": -0.42225
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acdb",
        "height": 0.15693,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e0d",
            "leftCorner": {
              "x": 37.207,
              "y": 8.7765,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 37.147,
              "y": 8.7054,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e0e",
            "leftCorner": {
              "x": 37.147,
              "y": 8.7054,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 37.097,
              "y": 8.6458,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e0f",
            "leftCorner": {
              "x": 37.097,
              "y": 8.6458,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 37.052,
              "y": 8.5928,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e10",
            "leftCorner": {
              "x": 37.052,
              "y": 8.5928,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 37.008,
              "y": 8.5403,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234695"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e11",
            "leftCorner": {
              "x": 37.008,
              "y": 8.5403,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.96,
              "y": 8.4822,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234695"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e12",
            "leftCorner": {
              "x": 36.96,
              "y": 8.4822,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.932,
              "y": 8.4492,
              "z": 0.15693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e13",
            "leftCorner": {
              "x": 36.932,
              "y": 8.4492,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.913,
              "y": 8.4272,
              "z": 0.15693
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e14",
            "leftCorner": {
              "x": 36.913,
              "y": 8.4272,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.873,
              "y": 8.3789,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e15",
            "leftCorner": {
              "x": 36.873,
              "y": 8.3789,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.827,
              "y": 8.3243,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671889"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e16",
            "leftCorner": {
              "x": 36.827,
              "y": 8.3243,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.78,
              "y": 8.2685,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671889"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e17",
            "leftCorner": {
              "x": 36.78,
              "y": 8.2685,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.733,
              "y": 8.2132,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671889"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e18",
            "leftCorner": {
              "x": 36.733,
              "y": 8.2132,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.682,
              "y": 8.1519,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671889"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e19",
            "leftCorner": {
              "x": 36.682,
              "y": 8.1519,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.637,
              "y": 8.0988,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395303"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e1a",
            "leftCorner": {
              "x": 36.637,
              "y": 8.0988,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.585,
              "y": 8.0362,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447395303"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acdc",
        "height": 0.41703,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5da7",
            "leftCorner": {
              "x": 37.278,
              "y": 8.6824,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.228,
              "y": 8.6223,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da8",
            "leftCorner": {
              "x": 37.228,
              "y": 8.6223,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.181,
              "y": 8.5664,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5da9",
            "leftCorner": {
              "x": 37.181,
              "y": 8.5664,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.134,
              "y": 8.5107,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714357"
          },
          {
            "id": "679afb3e3d9bab0f83ff5daa",
            "leftCorner": {
              "x": 37.134,
              "y": 8.5107,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.09,
              "y": 8.4583,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714357"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dab",
            "leftCorner": {
              "x": 37.09,
              "y": 8.4583,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.047,
              "y": 8.4076,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714357"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dac",
            "leftCorner": {
              "x": 37.047,
              "y": 8.4076,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 37.004,
              "y": 8.3559,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714357"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dad",
            "leftCorner": {
              "x": 37.004,
              "y": 8.3559,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.957,
              "y": 8.3,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dae",
            "leftCorner": {
              "x": 36.957,
              "y": 8.3,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.913,
              "y": 8.2479,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5daf",
            "leftCorner": {
              "x": 36.913,
              "y": 8.2479,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.868,
              "y": 8.1934,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db0",
            "leftCorner": {
              "x": 36.868,
              "y": 8.1934,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.822,
              "y": 8.1397,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714333"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db1",
            "leftCorner": {
              "x": 36.822,
              "y": 8.1397,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.774,
              "y": 8.0816,
              "z": 0.41703
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447714333"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db2",
            "leftCorner": {
              "x": 36.774,
              "y": 8.0816,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.714,
              "y": 8.0104,
              "z": 0.41703
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714333"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d99",
            "leftCorner": {
              "x": 36.714,
              "y": 8.0104,
              "z": 0.41703
            },
            "rightCorner": {
              "x": 36.666,
              "y": 7.9537,
              "z": 0.41703
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447714333"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd7",
        "height": 0.67129,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5d8f",
            "leftCorner": {
              "x": 37.314,
              "y": 8.7206,
              "z": 0.67266
            },
            "rightCorner": {
              "x": 37.271,
              "y": 8.6675,
              "z": 0.67266
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519884"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d90",
            "leftCorner": {
              "x": 37.278,
              "y": 8.674,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 37.24,
              "y": 8.6289,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519884"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d91",
            "leftCorner": {
              "x": 37.24,
              "y": 8.6289,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 37.205,
              "y": 8.587,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447519884"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d92",
            "leftCorner": {
              "x": 37.205,
              "y": 8.587,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 37.156,
              "y": 8.5287,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260437291327"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d93",
            "leftCorner": {
              "x": 37.156,
              "y": 8.5287,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 37.05,
              "y": 8.4028,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260437290450"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d94",
            "leftCorner": {
              "x": 37.05,
              "y": 8.4028,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.938,
              "y": 8.2695,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260437291440"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d95",
            "leftCorner": {
              "x": 36.938,
              "y": 8.2695,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.876,
              "y": 8.1959,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260437291471"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d96",
            "leftCorner": {
              "x": 36.876,
              "y": 8.1959,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.844,
              "y": 8.1571,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d97",
            "leftCorner": {
              "x": 36.844,
              "y": 8.1571,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.785,
              "y": 8.0869,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661384382"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d98",
            "leftCorner": {
              "x": 36.785,
              "y": 8.0869,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.723,
              "y": 8.0134,
              "z": 0.67129
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661384382"
          },
          {
            "id": "679afb3e3d9bab0f83ff5d82",
            "leftCorner": {
              "x": 36.723,
              "y": 8.0134,
              "z": 0.67129
            },
            "rightCorner": {
              "x": 36.67,
              "y": 7.9505,
              "z": 0.67129
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661384382"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd8",
        "height": 0.92093,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5dc0",
            "leftCorner": {
              "x": 37.309,
              "y": 8.7146,
              "z": 0.92219
            },
            "rightCorner": {
              "x": 37.248,
              "y": 8.6408,
              "z": 0.92219
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933232"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc1",
            "leftCorner": {
              "x": 37.257,
              "y": 8.6461,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.209,
              "y": 8.5886,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933232"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc2",
            "leftCorner": {
              "x": 37.209,
              "y": 8.5886,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.158,
              "y": 8.5285,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933157"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc3",
            "leftCorner": {
              "x": 37.158,
              "y": 8.5285,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.126,
              "y": 8.4904,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900932952"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc4",
            "leftCorner": {
              "x": 37.126,
              "y": 8.4904,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.108,
              "y": 8.468,
              "z": 0.92093
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900932952"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc5",
            "leftCorner": {
              "x": 37.108,
              "y": 8.468,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.066,
              "y": 8.4182,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000081045"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc6",
            "leftCorner": {
              "x": 37.066,
              "y": 8.4182,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 37.018,
              "y": 8.3613,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000081045"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc7",
            "leftCorner": {
              "x": 37.018,
              "y": 8.3613,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.971,
              "y": 8.3051,
              "z": 0.92093
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4006000081120"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc8",
            "leftCorner": {
              "x": 36.971,
              "y": 8.3051,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.922,
              "y": 8.2471,
              "z": 0.92093
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4006000081120"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dc9",
            "leftCorner": {
              "x": 36.922,
              "y": 8.2471,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.87,
              "y": 8.1859,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000081083"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dca",
            "leftCorner": {
              "x": 36.87,
              "y": 8.1859,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.822,
              "y": 8.1283,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000081083"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dcb",
            "leftCorner": {
              "x": 36.822,
              "y": 8.1283,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.772,
              "y": 8.0691,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000081083"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dcc",
            "leftCorner": {
              "x": 36.772,
              "y": 8.0691,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.718,
              "y": 8.0044,
              "z": 0.92093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900972750"
          },
          {
            "id": "679afb3e3d9bab0f83ff5db3",
            "leftCorner": {
              "x": 36.718,
              "y": 8.0044,
              "z": 0.92093
            },
            "rightCorner": {
              "x": 36.671,
              "y": 7.9491,
              "z": 0.92093
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900972750"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acd9",
        "height": 1.1765,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5df3",
            "leftCorner": {
              "x": 37.29,
              "y": 8.6882,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.237,
              "y": 8.625,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181531224"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df4",
            "leftCorner": {
              "x": 37.237,
              "y": 8.625,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.19,
              "y": 8.5697,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181465826"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df5",
            "leftCorner": {
              "x": 37.19,
              "y": 8.5697,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.143,
              "y": 8.5138,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181465826"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df6",
            "leftCorner": {
              "x": 37.143,
              "y": 8.5138,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.113,
              "y": 8.4778,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df7",
            "leftCorner": {
              "x": 37.113,
              "y": 8.4778,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.095,
              "y": 8.456,
              "z": 1.1765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260307639938"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df8",
            "leftCorner": {
              "x": 37.095,
              "y": 8.456,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.049,
              "y": 8.4023,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307639938"
          },
          {
            "id": "679afb3e3d9bab0f83ff5df9",
            "leftCorner": {
              "x": 37.049,
              "y": 8.4023,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 37.004,
              "y": 8.3481,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629977"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dfa",
            "leftCorner": {
              "x": 37.004,
              "y": 8.3481,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.958,
              "y": 8.2938,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629977"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dfb",
            "leftCorner": {
              "x": 36.958,
              "y": 8.2938,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.907,
              "y": 8.2325,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dfc",
            "leftCorner": {
              "x": 36.907,
              "y": 8.2325,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.86,
              "y": 8.1774,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629441"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dfd",
            "leftCorner": {
              "x": 36.86,
              "y": 8.1774,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.808,
              "y": 8.1154,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629441"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dfe",
            "leftCorner": {
              "x": 36.808,
              "y": 8.1154,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.759,
              "y": 8.057,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629441"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dff",
            "leftCorner": {
              "x": 36.759,
              "y": 8.057,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.707,
              "y": 7.9947,
              "z": 1.1765
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307628963"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de7",
            "leftCorner": {
              "x": 36.707,
              "y": 7.9947,
              "z": 1.1765
            },
            "rightCorner": {
              "x": 36.67,
              "y": 7.9505,
              "z": 1.1765
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260307628963"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acda",
        "height": 1.4304,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ddb",
            "leftCorner": {
              "x": 37.227,
              "y": 8.6119,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 37.177,
              "y": 8.5532,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591668"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ddc",
            "leftCorner": {
              "x": 37.177,
              "y": 8.5532,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 37.127,
              "y": 8.4933,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591668"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ddd",
            "leftCorner": {
              "x": 37.127,
              "y": 8.4933,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 37.08,
              "y": 8.4372,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591668"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dde",
            "leftCorner": {
              "x": 37.08,
              "y": 8.4372,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 37.035,
              "y": 8.3838,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ddf",
            "leftCorner": {
              "x": 37.035,
              "y": 8.3838,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.988,
              "y": 8.3276,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591644"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de0",
            "leftCorner": {
              "x": 36.988,
              "y": 8.3276,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.929,
              "y": 8.2575,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de1",
            "leftCorner": {
              "x": 36.929,
              "y": 8.2575,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.876,
              "y": 8.1942,
              "z": 1.4304
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447746181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de2",
            "leftCorner": {
              "x": 36.876,
              "y": 8.1942,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.844,
              "y": 8.1562,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de3",
            "leftCorner": {
              "x": 36.844,
              "y": 8.1562,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.808,
              "y": 8.1142,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725254"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de4",
            "leftCorner": {
              "x": 36.808,
              "y": 8.1142,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.776,
              "y": 8.0756,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725254"
          },
          {
            "id": "679afb3e3d9bab0f83ff5de5",
            "leftCorner": {
              "x": 36.776,
              "y": 8.0756,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.724,
              "y": 8.014,
              "z": 1.4304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003086360002"
          },
          {
            "id": "679afb3e3d9bab0f83ff5dcd",
            "leftCorner": {
              "x": 36.724,
              "y": 8.014,
              "z": 1.4304
            },
            "rightCorner": {
              "x": 36.67,
              "y": 7.95,
              "z": 1.4304
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003086360002"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 62,
      "unknownStockCount": 13
    },
    "name": "GS2V",
    "leftNeighborShelfId": "15PT",
    "rightNeighborShelfId": "2V4N"
  },
  {
    "id": "R1N8",
    "x": 36.667,
    "y": 7.967,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.90881,
      "w": -0.41722
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ace1",
        "height": 0.15995,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e1b",
            "leftCorner": {
              "x": 36.585,
              "y": 8.0362,
              "z": 0.15693
            },
            "rightCorner": {
              "x": 36.526,
              "y": 7.9664,
              "z": 0.15693
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447755756"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e1c",
            "leftCorner": {
              "x": 36.534,
              "y": 7.9752,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.48,
              "y": 7.9122,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447755756"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e1d",
            "leftCorner": {
              "x": 36.48,
              "y": 7.9122,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.426,
              "y": 7.8497,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447755756"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e1e",
            "leftCorner": {
              "x": 36.426,
              "y": 7.8497,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.37,
              "y": 7.7838,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769609"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e1f",
            "leftCorner": {
              "x": 36.37,
              "y": 7.7838,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.317,
              "y": 7.7221,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000037"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e20",
            "leftCorner": {
              "x": 36.317,
              "y": 7.7221,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.263,
              "y": 7.6592,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769586"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e21",
            "leftCorner": {
              "x": 36.263,
              "y": 7.6592,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.207,
              "y": 7.5943,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769586"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e22",
            "leftCorner": {
              "x": 36.207,
              "y": 7.5943,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.14,
              "y": 7.5162,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789939803"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e23",
            "leftCorner": {
              "x": 36.14,
              "y": 7.5162,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.077,
              "y": 7.4437,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789939803"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e24",
            "leftCorner": {
              "x": 36.077,
              "y": 7.4437,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 36.014,
              "y": 7.3698,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789946269"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e25",
            "leftCorner": {
              "x": 36.014,
              "y": 7.3698,
              "z": 0.15995
            },
            "rightCorner": {
              "x": 35.952,
              "y": 7.2975,
              "z": 0.15995
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951425163"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace0",
        "height": 0.50617,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e4e",
            "leftCorner": {
              "x": 36.671,
              "y": 7.964,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.619,
              "y": 7.904,
              "z": 0.50617
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951076228"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e50",
            "leftCorner": {
              "x": 36.619,
              "y": 7.904,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.574,
              "y": 7.8519,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951076228"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e51",
            "leftCorner": {
              "x": 36.574,
              "y": 7.8519,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.528,
              "y": 7.7984,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951076181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e52",
            "leftCorner": {
              "x": 36.528,
              "y": 7.7984,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.485,
              "y": 7.7476,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951076181"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e53",
            "leftCorner": {
              "x": 36.485,
              "y": 7.7476,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.439,
              "y": 7.6949,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e54",
            "leftCorner": {
              "x": 36.439,
              "y": 7.6949,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.394,
              "y": 7.6425,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951424647"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e55",
            "leftCorner": {
              "x": 36.394,
              "y": 7.6425,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.348,
              "y": 7.5888,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951427471"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e56",
            "leftCorner": {
              "x": 36.348,
              "y": 7.5888,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.298,
              "y": 7.5306,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951427471"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e57",
            "leftCorner": {
              "x": 36.298,
              "y": 7.5306,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.25,
              "y": 7.4751,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789732916"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e58",
            "leftCorner": {
              "x": 36.25,
              "y": 7.4751,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.205,
              "y": 7.4221,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789732886"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e59",
            "leftCorner": {
              "x": 36.205,
              "y": 7.4221,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.148,
              "y": 7.3561,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162033256"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e5a",
            "leftCorner": {
              "x": 36.148,
              "y": 7.3561,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.099,
              "y": 7.2988,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970056562"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e5b",
            "leftCorner": {
              "x": 36.099,
              "y": 7.2988,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.053,
              "y": 7.2452,
              "z": 0.50617
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970056562"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e4f",
            "leftCorner": {
              "x": 36.053,
              "y": 7.2452,
              "z": 0.50617
            },
            "rightCorner": {
              "x": 36.019,
              "y": 7.2057,
              "z": 0.50617
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008970056579"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acdf",
        "height": 0.79868,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e40",
            "leftCorner": {
              "x": 36.672,
              "y": 7.9628,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.619,
              "y": 7.9014,
              "z": 0.79868
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100427561"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e42",
            "leftCorner": {
              "x": 36.619,
              "y": 7.9014,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.577,
              "y": 7.8527,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e43",
            "leftCorner": {
              "x": 36.577,
              "y": 7.8527,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.536,
              "y": 7.8041,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100427448"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e44",
            "leftCorner": {
              "x": 36.536,
              "y": 7.8041,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.489,
              "y": 7.7505,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100428087"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e45",
            "leftCorner": {
              "x": 36.489,
              "y": 7.7505,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.449,
              "y": 7.703,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045612009313"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e46",
            "leftCorner": {
              "x": 36.449,
              "y": 7.703,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.405,
              "y": 7.6523,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181334030"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e47",
            "leftCorner": {
              "x": 36.405,
              "y": 7.6523,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.355,
              "y": 7.5942,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181334108"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e48",
            "leftCorner": {
              "x": 36.355,
              "y": 7.5942,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.312,
              "y": 7.5444,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181334108"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e49",
            "leftCorner": {
              "x": 36.312,
              "y": 7.5444,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.264,
              "y": 7.488,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181334108"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e4a",
            "leftCorner": {
              "x": 36.264,
              "y": 7.488,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.216,
              "y": 7.4318,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181342868"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e4b",
            "leftCorner": {
              "x": 36.216,
              "y": 7.4318,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.167,
              "y": 7.3759,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181342868"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e4c",
            "leftCorner": {
              "x": 36.167,
              "y": 7.3759,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.099,
              "y": 7.2965,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008268002800"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e4d",
            "leftCorner": {
              "x": 36.099,
              "y": 7.2965,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.049,
              "y": 7.2386,
              "z": 0.79868
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162025473"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e41",
            "leftCorner": {
              "x": 36.049,
              "y": 7.2386,
              "z": 0.79868
            },
            "rightCorner": {
              "x": 36.02,
              "y": 7.2045,
              "z": 0.79868
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013162019236"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acdd",
        "height": 1.0908,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e26",
            "leftCorner": {
              "x": 36.674,
              "y": 7.9609,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.63,
              "y": 7.9097,
              "z": 1.0908
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008970056609"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e28",
            "leftCorner": {
              "x": 36.63,
              "y": 7.9097,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.591,
              "y": 7.8641,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e29",
            "leftCorner": {
              "x": 36.591,
              "y": 7.8641,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.557,
              "y": 7.825,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970056586"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2a",
            "leftCorner": {
              "x": 36.557,
              "y": 7.825,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.525,
              "y": 7.7873,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970058252"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2b",
            "leftCorner": {
              "x": 36.525,
              "y": 7.7873,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.492,
              "y": 7.7486,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970056593"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2c",
            "leftCorner": {
              "x": 36.492,
              "y": 7.7486,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.46,
              "y": 7.7121,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42430902"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2d",
            "leftCorner": {
              "x": 36.46,
              "y": 7.7121,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.427,
              "y": 7.6739,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42430902"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2e",
            "leftCorner": {
              "x": 36.427,
              "y": 7.6739,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.394,
              "y": 7.6348,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42426356"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e2f",
            "leftCorner": {
              "x": 36.394,
              "y": 7.6348,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.361,
              "y": 7.596,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42426356"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e30",
            "leftCorner": {
              "x": 36.361,
              "y": 7.596,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.328,
              "y": 7.5586,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42453031"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e31",
            "leftCorner": {
              "x": 36.328,
              "y": 7.5586,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.278,
              "y": 7.4999,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060968413125"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e32",
            "leftCorner": {
              "x": 36.278,
              "y": 7.4999,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.227,
              "y": 7.4408,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060968413163"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e33",
            "leftCorner": {
              "x": 36.227,
              "y": 7.4408,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.179,
              "y": 7.3849,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060968413132"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e34",
            "leftCorner": {
              "x": 36.179,
              "y": 7.3849,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.132,
              "y": 7.3299,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060968413170"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e35",
            "leftCorner": {
              "x": 36.132,
              "y": 7.3299,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.057,
              "y": 7.2428,
              "z": 1.0908
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447641219"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e27",
            "leftCorner": {
              "x": 36.057,
              "y": 7.2428,
              "z": 1.0908
            },
            "rightCorner": {
              "x": 36.022,
              "y": 7.2026,
              "z": 1.0908
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796157895"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acde",
        "height": 1.3874,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e36",
            "leftCorner": {
              "x": 36.673,
              "y": 7.9616,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.605,
              "y": 7.8815,
              "z": 1.3874
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008970059600"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e37",
            "leftCorner": {
              "x": 36.605,
              "y": 7.8815,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.544,
              "y": 7.8114,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42415787"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e38",
            "leftCorner": {
              "x": 36.544,
              "y": 7.8114,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.491,
              "y": 7.7499,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42424536"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e39",
            "leftCorner": {
              "x": 36.491,
              "y": 7.7499,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.436,
              "y": 7.6854,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42424536"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3a",
            "leftCorner": {
              "x": 36.436,
              "y": 7.6854,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.373,
              "y": 7.6123,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710447217054"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3b",
            "leftCorner": {
              "x": 36.373,
              "y": 7.6123,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.313,
              "y": 7.5425,
              "z": 1.3874
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447719161"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3c",
            "leftCorner": {
              "x": 36.313,
              "y": 7.5425,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.248,
              "y": 7.4662,
              "z": 1.3874
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447719161"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3d",
            "leftCorner": {
              "x": 36.248,
              "y": 7.4662,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.174,
              "y": 7.381,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378375"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3e",
            "leftCorner": {
              "x": 36.174,
              "y": 7.381,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.091,
              "y": 7.2845,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808808243"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e3f",
            "leftCorner": {
              "x": 36.091,
              "y": 7.2845,
              "z": 1.3874
            },
            "rightCorner": {
              "x": 36.037,
              "y": 7.2209,
              "z": 1.3874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492385"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 56,
      "unknownStockCount": 9
    },
    "name": "R1N8",
    "leftNeighborShelfId": "HY2A",
    "rightNeighborShelfId": "V2K7"
  },
  {
    "id": "SV6R",
    "x": 35.685,
    "y": 4.8652,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42322,
      "w": 0.90603
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ace2",
        "height": 0.16528,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e76",
            "leftCorner": {
              "x": 35.761,
              "y": 4.8015,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 35.816,
              "y": 4.8672,
              "z": 0.16528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447314489"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e77",
            "leftCorner": {
              "x": 35.816,
              "y": 4.8674,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 35.864,
              "y": 4.9251,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245554"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e78",
            "leftCorner": {
              "x": 35.864,
              "y": 4.9251,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 35.915,
              "y": 4.9858,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245516"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e79",
            "leftCorner": {
              "x": 35.915,
              "y": 4.9858,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 35.964,
              "y": 5.0442,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "887884"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7a",
            "leftCorner": {
              "x": 35.964,
              "y": 5.0442,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.017,
              "y": 5.1075,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245578"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7b",
            "leftCorner": {
              "x": 36.017,
              "y": 5.1075,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.068,
              "y": 5.168,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245530"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7c",
            "leftCorner": {
              "x": 36.068,
              "y": 5.168,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.13,
              "y": 5.2421,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447343632"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7d",
            "leftCorner": {
              "x": 36.13,
              "y": 5.2421,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.193,
              "y": 5.3182,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381955"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7e",
            "leftCorner": {
              "x": 36.193,
              "y": 5.3182,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.239,
              "y": 5.3724,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382532"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e7f",
            "leftCorner": {
              "x": 36.239,
              "y": 5.3724,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.284,
              "y": 5.4265,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245370"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e80",
            "leftCorner": {
              "x": 36.284,
              "y": 5.4265,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.33,
              "y": 5.481,
              "z": 0.16528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245318"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e81",
            "leftCorner": {
              "x": 36.33,
              "y": 5.481,
              "z": 0.16528
            },
            "rightCorner": {
              "x": 36.403,
              "y": 5.5684,
              "z": 0.16528
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447245318"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace7",
        "height": 0.42898,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6033",
            "leftCorner": {
              "x": 35.674,
              "y": 4.8741,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 35.693,
              "y": 4.8967,
              "z": 0.42898
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260560831063"
          },
          {
            "id": "679afb3e3d9bab0f83ff6034",
            "leftCorner": {
              "x": 35.693,
              "y": 4.8968,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 35.762,
              "y": 4.9797,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260560835740"
          },
          {
            "id": "679afb3e3d9bab0f83ff6035",
            "leftCorner": {
              "x": 35.762,
              "y": 4.9797,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 35.823,
              "y": 5.0527,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447313840"
          },
          {
            "id": "679afb3e3d9bab0f83ff6036",
            "leftCorner": {
              "x": 35.823,
              "y": 5.0527,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 35.886,
              "y": 5.1274,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447313833"
          },
          {
            "id": "679afb3e3d9bab0f83ff6037",
            "leftCorner": {
              "x": 35.886,
              "y": 5.1274,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 35.947,
              "y": 5.2008,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447313857"
          },
          {
            "id": "679afb3e3d9bab0f83ff6038",
            "leftCorner": {
              "x": 35.947,
              "y": 5.2008,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.01,
              "y": 5.2758,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447313871"
          },
          {
            "id": "679afb3e3d9bab0f83ff6039",
            "leftCorner": {
              "x": 36.01,
              "y": 5.2758,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.072,
              "y": 5.3497,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199892305"
          },
          {
            "id": "679afb3e3d9bab0f83ff603a",
            "leftCorner": {
              "x": 36.072,
              "y": 5.3497,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.134,
              "y": 5.4233,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199892473"
          },
          {
            "id": "679afb3e3d9bab0f83ff603b",
            "leftCorner": {
              "x": 36.134,
              "y": 5.4233,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.197,
              "y": 5.4991,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199892503"
          },
          {
            "id": "679afb3e3d9bab0f83ff603c",
            "leftCorner": {
              "x": 36.197,
              "y": 5.4991,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.258,
              "y": 5.572,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199892572"
          },
          {
            "id": "679afb3e3d9bab0f83ff603d",
            "leftCorner": {
              "x": 36.258,
              "y": 5.572,
              "z": 0.42898
            },
            "rightCorner": {
              "x": 36.305,
              "y": 5.6284,
              "z": 0.42898
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199892268"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace4",
        "height": 0.68107,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f30",
            "leftCorner": {
              "x": 35.673,
              "y": 4.8747,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.695,
              "y": 4.9005,
              "z": 0.68107
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573115030"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f31",
            "leftCorner": {
              "x": 35.695,
              "y": 4.9006,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.765,
              "y": 4.984,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260560837652"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f32",
            "leftCorner": {
              "x": 35.765,
              "y": 4.984,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.815,
              "y": 5.044,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000048"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f33",
            "leftCorner": {
              "x": 35.815,
              "y": 5.044,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.872,
              "y": 5.1123,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573124063"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f34",
            "leftCorner": {
              "x": 35.872,
              "y": 5.1123,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.93,
              "y": 5.1813,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573022000"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f35",
            "leftCorner": {
              "x": 35.93,
              "y": 5.1813,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 35.987,
              "y": 5.2491,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573022154"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f36",
            "leftCorner": {
              "x": 35.987,
              "y": 5.2491,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 36.044,
              "y": 5.317,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573022130"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f37",
            "leftCorner": {
              "x": 36.044,
              "y": 5.317,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 36.1,
              "y": 5.3849,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021942"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f38",
            "leftCorner": {
              "x": 36.1,
              "y": 5.3849,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 36.157,
              "y": 5.4527,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573121512"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f39",
            "leftCorner": {
              "x": 36.157,
              "y": 5.4527,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 36.214,
              "y": 5.5206,
              "z": 0.68107
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573121543"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f3a",
            "leftCorner": {
              "x": 36.214,
              "y": 5.5206,
              "z": 0.68107
            },
            "rightCorner": {
              "x": 36.315,
              "y": 5.6416,
              "z": 0.68107
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573021393"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f3b",
            "leftCorner": {
              "x": 36.306,
              "y": 5.6386,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.367,
              "y": 5.7115,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541698482"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace3",
        "height": 0.93409,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ed8",
            "leftCorner": {
              "x": 35.657,
              "y": 4.8574,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.726,
              "y": 4.9394,
              "z": 0.93259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003573020143"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed9",
            "leftCorner": {
              "x": 35.729,
              "y": 4.9425,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 35.784,
              "y": 5.0078,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573020020"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eda",
            "leftCorner": {
              "x": 35.784,
              "y": 5.0078,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 35.849,
              "y": 5.0856,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573023120"
          },
          {
            "id": "679afb3e3d9bab0f83ff5edb",
            "leftCorner": {
              "x": 35.849,
              "y": 5.0856,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 35.913,
              "y": 5.162,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021966"
          },
          {
            "id": "679afb3e3d9bab0f83ff5edc",
            "leftCorner": {
              "x": 35.913,
              "y": 5.162,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 35.951,
              "y": 5.2074,
              "z": 0.93409
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4003573023090"
          },
          {
            "id": "679afb3e3d9bab0f83ff5edd",
            "leftCorner": {
              "x": 35.951,
              "y": 5.2074,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 36.008,
              "y": 5.2754,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573020860"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ede",
            "leftCorner": {
              "x": 36.008,
              "y": 5.2754,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 36.065,
              "y": 5.3442,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573020068"
          },
          {
            "id": "679afb3e3d9bab0f83ff5edf",
            "leftCorner": {
              "x": 36.065,
              "y": 5.3442,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 36.124,
              "y": 5.4137,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021928"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee0",
            "leftCorner": {
              "x": 36.124,
              "y": 5.4137,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 36.18,
              "y": 5.4808,
              "z": 0.93409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005120141035"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee1",
            "leftCorner": {
              "x": 36.18,
              "y": 5.4808,
              "z": 0.93409
            },
            "rightCorner": {
              "x": 36.234,
              "y": 5.545,
              "z": 0.93409
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005120151041"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee2",
            "leftCorner": {
              "x": 36.223,
              "y": 5.543,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.293,
              "y": 5.6267,
              "z": 0.9273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005120412036"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace6",
        "height": 1.1869,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fd7",
            "leftCorner": {
              "x": 35.716,
              "y": 4.9252,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 35.771,
              "y": 4.9903,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573020969"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd8",
            "leftCorner": {
              "x": 35.771,
              "y": 4.9903,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 35.825,
              "y": 5.0558,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021072"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd9",
            "leftCorner": {
              "x": 35.825,
              "y": 5.0558,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 35.891,
              "y": 5.1348,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021737"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fda",
            "leftCorner": {
              "x": 35.891,
              "y": 5.1348,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 35.962,
              "y": 5.2191,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021355"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fdb",
            "leftCorner": {
              "x": 35.962,
              "y": 5.2191,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.027,
              "y": 5.2968,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021331"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fdc",
            "leftCorner": {
              "x": 36.027,
              "y": 5.2968,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.093,
              "y": 5.3754,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573021348"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fdd",
            "leftCorner": {
              "x": 36.093,
              "y": 5.3754,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.173,
              "y": 5.4716,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573121222"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fde",
            "leftCorner": {
              "x": 36.173,
              "y": 5.4716,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.254,
              "y": 5.5684,
              "z": 1.1869
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542545228"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fdf",
            "leftCorner": {
              "x": 36.254,
              "y": 5.5684,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.291,
              "y": 5.6128,
              "z": 1.1869
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542500500"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe0",
            "leftCorner": {
              "x": 36.291,
              "y": 5.6128,
              "z": 1.1869
            },
            "rightCorner": {
              "x": 36.315,
              "y": 5.6414,
              "z": 1.1869
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542500500"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace5",
        "height": 1.4395,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f80",
            "leftCorner": {
              "x": 35.67,
              "y": 4.8773,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 35.753,
              "y": 4.9756,
              "z": 1.4395
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542097024"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f81",
            "leftCorner": {
              "x": 35.753,
              "y": 4.976,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 35.832,
              "y": 5.0706,
              "z": 1.4395
            },
            "stockLevel": "NO_STOCK",
            "gtin": "3600541944664"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f82",
            "leftCorner": {
              "x": 35.832,
              "y": 5.0706,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 35.918,
              "y": 5.1738,
              "z": 1.4395
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541943506"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f83",
            "leftCorner": {
              "x": 35.918,
              "y": 5.1738,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 36.001,
              "y": 5.2727,
              "z": 1.4395
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542383455"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f84",
            "leftCorner": {
              "x": 36.001,
              "y": 5.2727,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 36.081,
              "y": 5.368,
              "z": 1.4395
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542383523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f85",
            "leftCorner": {
              "x": 36.081,
              "y": 5.368,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 36.165,
              "y": 5.469,
              "z": 1.4395
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542383462"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f86",
            "leftCorner": {
              "x": 36.165,
              "y": 5.469,
              "z": 1.4395
            },
            "rightCorner": {
              "x": 36.235,
              "y": 5.5517,
              "z": 1.4395
            },
            "stockLevel": "NO_STOCK",
            "gtin": "3600542569033"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f87",
            "leftCorner": {
              "x": 36.225,
              "y": 5.5491,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.291,
              "y": 5.6278,
              "z": 1.437
            },
            "stockLevel": "NO_STOCK",
            "gtin": "3600542427531"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 49,
      "unknownStockCount": 11
    },
    "name": "SV6R"
  },
  {
    "id": "EFUM",
    "x": 35.384,
    "y": 6.468,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.9086,
      "w": -0.41767
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acee",
        "height": 0.16069,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60a9",
            "leftCorner": {
              "x": 35.287,
              "y": 6.5102,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 35.236,
              "y": 6.451,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738111"
          },
          {
            "id": "679afb3e3d9bab0f83ff60aa",
            "leftCorner": {
              "x": 35.236,
              "y": 6.451,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 35.189,
              "y": 6.3951,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447015287"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ab",
            "leftCorner": {
              "x": 35.189,
              "y": 6.3951,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 35.125,
              "y": 6.3212,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447322460"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ac",
            "leftCorner": {
              "x": 35.125,
              "y": 6.3212,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 35.034,
              "y": 6.2147,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309915"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ad",
            "leftCorner": {
              "x": 35.034,
              "y": 6.2147,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.945,
              "y": 6.1113,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309915"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ae",
            "leftCorner": {
              "x": 34.945,
              "y": 6.1113,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.881,
              "y": 6.0371,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006504"
          },
          {
            "id": "679afb3e3d9bab0f83ff60af",
            "leftCorner": {
              "x": 34.881,
              "y": 6.0371,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.821,
              "y": 5.9664,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233157214"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b0",
            "leftCorner": {
              "x": 34.821,
              "y": 5.9664,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.767,
              "y": 5.9039,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233157214"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b1",
            "leftCorner": {
              "x": 34.767,
              "y": 5.9039,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.71,
              "y": 5.8371,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233172064"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b2",
            "leftCorner": {
              "x": 34.71,
              "y": 5.8371,
              "z": 0.16069
            },
            "rightCorner": {
              "x": 34.654,
              "y": 5.7716,
              "z": 0.16069
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233172064"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aceb",
        "height": 0.50985,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6089",
            "leftCorner": {
              "x": 35.394,
              "y": 6.4591,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.354,
              "y": 6.4116,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233038438"
          },
          {
            "id": "679afb3e3d9bab0f83ff608b",
            "leftCorner": {
              "x": 35.354,
              "y": 6.4116,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.219,
              "y": 6.2546,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512176679"
          },
          {
            "id": "679afb3e3d9bab0f83ff608c",
            "leftCorner": {
              "x": 35.219,
              "y": 6.2546,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.18,
              "y": 6.2093,
              "z": 0.50985
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491283328"
          },
          {
            "id": "679afb3e3d9bab0f83ff608d",
            "leftCorner": {
              "x": 35.18,
              "y": 6.2093,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.139,
              "y": 6.1616,
              "z": 0.50985
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491119405"
          },
          {
            "id": "679afb3e3d9bab0f83ff608e",
            "leftCorner": {
              "x": 35.139,
              "y": 6.1616,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.103,
              "y": 6.1193,
              "z": 0.50985
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491112154"
          },
          {
            "id": "679afb3e3d9bab0f83ff608f",
            "leftCorner": {
              "x": 35.103,
              "y": 6.1193,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 35.06,
              "y": 6.0692,
              "z": 0.50985
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491112154"
          },
          {
            "id": "679afb3e3d9bab0f83ff6090",
            "leftCorner": {
              "x": 35.06,
              "y": 6.0692,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 34.999,
              "y": 5.998,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491103213"
          },
          {
            "id": "679afb3e3d9bab0f83ff6091",
            "leftCorner": {
              "x": 34.999,
              "y": 5.998,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 34.938,
              "y": 5.9272,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491106993"
          },
          {
            "id": "679afb3e3d9bab0f83ff6092",
            "leftCorner": {
              "x": 34.938,
              "y": 5.9272,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 34.874,
              "y": 5.8526,
              "z": 0.50985
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491480420"
          },
          {
            "id": "679afb3e3d9bab0f83ff6093",
            "leftCorner": {
              "x": 34.874,
              "y": 5.8526,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 34.807,
              "y": 5.7745,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512157043"
          },
          {
            "id": "679afb3e3d9bab0f83ff608a",
            "leftCorner": {
              "x": 34.807,
              "y": 5.7745,
              "z": 0.50985
            },
            "rightCorner": {
              "x": 34.743,
              "y": 5.7001,
              "z": 0.50985
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512157371"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acec",
        "height": 0.76013,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6094",
            "leftCorner": {
              "x": 35.397,
              "y": 6.4569,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 35.301,
              "y": 6.3444,
              "z": 0.76013
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233176451"
          },
          {
            "id": "679afb3e3d9bab0f83ff6096",
            "leftCorner": {
              "x": 35.301,
              "y": 6.3444,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 35.241,
              "y": 6.2752,
              "z": 0.76013
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233172439"
          },
          {
            "id": "679afb3e3d9bab0f83ff6097",
            "leftCorner": {
              "x": 35.241,
              "y": 6.2752,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 35.175,
              "y": 6.198,
              "z": 0.76013
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233171388"
          },
          {
            "id": "679afb3e3d9bab0f83ff6098",
            "leftCorner": {
              "x": 35.175,
              "y": 6.198,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 35.111,
              "y": 6.1239,
              "z": 0.76013
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233128009"
          },
          {
            "id": "679afb3e3d9bab0f83ff6099",
            "leftCorner": {
              "x": 35.111,
              "y": 6.1239,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 35.046,
              "y": 6.048,
              "z": 0.76013
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008233153544"
          },
          {
            "id": "679afb3e3d9bab0f83ff609a",
            "leftCorner": {
              "x": 35.046,
              "y": 6.048,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 34.982,
              "y": 5.9731,
              "z": 0.76013
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008233150963"
          },
          {
            "id": "679afb3e3d9bab0f83ff609b",
            "leftCorner": {
              "x": 34.982,
              "y": 5.9731,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 34.921,
              "y": 5.9016,
              "z": 0.76013
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233129761"
          },
          {
            "id": "679afb3e3d9bab0f83ff609c",
            "leftCorner": {
              "x": 34.921,
              "y": 5.9016,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 34.857,
              "y": 5.827,
              "z": 0.76013
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233165301"
          },
          {
            "id": "679afb3e3d9bab0f83ff609d",
            "leftCorner": {
              "x": 34.857,
              "y": 5.827,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 34.794,
              "y": 5.7534,
              "z": 0.76013
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233165240"
          },
          {
            "id": "679afb3e3d9bab0f83ff6095",
            "leftCorner": {
              "x": 34.794,
              "y": 5.7534,
              "z": 0.76013
            },
            "rightCorner": {
              "x": 34.746,
              "y": 5.6979,
              "z": 0.76013
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233046068"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3aced",
        "height": 1.0093,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff609e",
            "leftCorner": {
              "x": 35.398,
              "y": 6.4561,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.324,
              "y": 6.3697,
              "z": 1.0093
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447677065"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a0",
            "leftCorner": {
              "x": 35.324,
              "y": 6.3697,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.272,
              "y": 6.3091,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080452"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a1",
            "leftCorner": {
              "x": 35.272,
              "y": 6.3091,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.217,
              "y": 6.2449,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796080452"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a2",
            "leftCorner": {
              "x": 35.217,
              "y": 6.2449,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.159,
              "y": 6.1775,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064261"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a3",
            "leftCorner": {
              "x": 35.159,
              "y": 6.1775,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.105,
              "y": 6.1152,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796075694"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a4",
            "leftCorner": {
              "x": 35.105,
              "y": 6.1152,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 35.049,
              "y": 6.0497,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447521405"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a5",
            "leftCorner": {
              "x": 35.049,
              "y": 6.0497,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 34.992,
              "y": 5.9835,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796075670"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a6",
            "leftCorner": {
              "x": 34.992,
              "y": 5.9835,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 34.916,
              "y": 5.8944,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307631956"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a7",
            "leftCorner": {
              "x": 34.916,
              "y": 5.8944,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 34.852,
              "y": 5.8203,
              "z": 1.0093
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260307629212"
          },
          {
            "id": "679afb3e3d9bab0f83ff60a8",
            "leftCorner": {
              "x": 34.852,
              "y": 5.8203,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 34.779,
              "y": 5.7346,
              "z": 1.0093
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629533"
          },
          {
            "id": "679afb3e3d9bab0f83ff609f",
            "leftCorner": {
              "x": 34.779,
              "y": 5.7346,
              "z": 1.0093
            },
            "rightCorner": {
              "x": 34.747,
              "y": 5.6971,
              "z": 1.0093
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260307630461"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acea",
        "height": 1.2218,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff607f",
            "leftCorner": {
              "x": 35.394,
              "y": 6.4595,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 35.316,
              "y": 6.369,
              "z": 1.2218
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512203108"
          },
          {
            "id": "679afb3e3d9bab0f83ff6081",
            "leftCorner": {
              "x": 35.316,
              "y": 6.369,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 35.256,
              "y": 6.2992,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4017512201500"
          },
          {
            "id": "679afb3e3d9bab0f83ff6082",
            "leftCorner": {
              "x": 35.256,
              "y": 6.2992,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 35.194,
              "y": 6.2265,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4017512177539"
          },
          {
            "id": "679afb3e3d9bab0f83ff6083",
            "leftCorner": {
              "x": 35.194,
              "y": 6.2265,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 35.126,
              "y": 6.1475,
              "z": 1.2218
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512202903"
          },
          {
            "id": "679afb3e3d9bab0f83ff6084",
            "leftCorner": {
              "x": 35.126,
              "y": 6.1475,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 35.056,
              "y": 6.0654,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4017512155414"
          },
          {
            "id": "679afb3e3d9bab0f83ff6085",
            "leftCorner": {
              "x": 35.056,
              "y": 6.0654,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 34.986,
              "y": 5.9836,
              "z": 1.2218
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4017512176587"
          },
          {
            "id": "679afb3e3d9bab0f83ff6086",
            "leftCorner": {
              "x": 34.986,
              "y": 5.9836,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 34.921,
              "y": 5.9081,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4017512176587"
          },
          {
            "id": "679afb3e3d9bab0f83ff6087",
            "leftCorner": {
              "x": 34.921,
              "y": 5.9081,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 34.853,
              "y": 5.8285,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491113700"
          },
          {
            "id": "679afb3e3d9bab0f83ff6088",
            "leftCorner": {
              "x": 34.853,
              "y": 5.8285,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 34.785,
              "y": 5.75,
              "z": 1.2218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008491113748"
          },
          {
            "id": "679afb3e3d9bab0f83ff6080",
            "leftCorner": {
              "x": 34.785,
              "y": 5.75,
              "z": 1.2218
            },
            "rightCorner": {
              "x": 34.743,
              "y": 5.7005,
              "z": 1.2218
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008491113748"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ace9",
        "height": 1.4325,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6078",
            "leftCorner": {
              "x": 35.397,
              "y": 6.4567,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 35.272,
              "y": 6.3111,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447517880"
          },
          {
            "id": "679afb3e3d9bab0f83ff607a",
            "leftCorner": {
              "x": 35.272,
              "y": 6.3111,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 35.167,
              "y": 6.1886,
              "z": 1.4325
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447676938"
          },
          {
            "id": "679afb3e3d9bab0f83ff607b",
            "leftCorner": {
              "x": 35.167,
              "y": 6.1886,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 35.045,
              "y": 6.0464,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4030651050617"
          },
          {
            "id": "679afb3e3d9bab0f83ff607c",
            "leftCorner": {
              "x": 35.045,
              "y": 6.0464,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 34.938,
              "y": 5.9218,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671940"
          },
          {
            "id": "679afb3e3d9bab0f83ff607d",
            "leftCorner": {
              "x": 34.938,
              "y": 5.9218,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 34.886,
              "y": 5.8614,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447793451"
          },
          {
            "id": "679afb3e3d9bab0f83ff607e",
            "leftCorner": {
              "x": 34.886,
              "y": 5.8614,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 34.834,
              "y": 5.8005,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447793437"
          },
          {
            "id": "679afb3e3d9bab0f83ff6079",
            "leftCorner": {
              "x": 34.834,
              "y": 5.8005,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 34.746,
              "y": 5.6977,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42468882"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 36,
      "unknownStockCount": 19
    },
    "name": "EFUM",
    "leftNeighborShelfId": "KD7C",
    "rightNeighborShelfId": "ABBX"
  },
  {
    "id": "Q3ES",
    "x": 34.42,
    "y": 3.3314,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.43107,
      "w": 0.90232
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acf2",
        "height": 0.16416,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e5c",
            "leftCorner": {
              "x": 34.487,
              "y": 3.2768,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.555,
              "y": 3.3605,
              "z": 0.16416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e5d",
            "leftCorner": {
              "x": 34.555,
              "y": 3.3605,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.62,
              "y": 3.4415,
              "z": 0.16416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e5e",
            "leftCorner": {
              "x": 34.62,
              "y": 3.4415,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.637,
              "y": 3.4617,
              "z": 0.16416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e5f",
            "leftCorner": {
              "x": 34.637,
              "y": 3.4617,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.699,
              "y": 3.5394,
              "z": 0.16416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447375053"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e60",
            "leftCorner": {
              "x": 34.699,
              "y": 3.5394,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.715,
              "y": 3.5593,
              "z": 0.16416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e61",
            "leftCorner": {
              "x": 34.715,
              "y": 3.5593,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.787,
              "y": 3.6474,
              "z": 0.16416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e62",
            "leftCorner": {
              "x": 34.787,
              "y": 3.6474,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.868,
              "y": 3.7485,
              "z": 0.16416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e63",
            "leftCorner": {
              "x": 34.868,
              "y": 3.7485,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 34.946,
              "y": 3.8447,
              "z": 0.16416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172997143"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e64",
            "leftCorner": {
              "x": 34.946,
              "y": 3.8447,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 35.034,
              "y": 3.9534,
              "z": 0.16416
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172997143"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e65",
            "leftCorner": {
              "x": 35.034,
              "y": 3.9534,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 35.084,
              "y": 4.0157,
              "z": 0.16416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365382"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e66",
            "leftCorner": {
              "x": 35.084,
              "y": 4.0157,
              "z": 0.16416
            },
            "rightCorner": {
              "x": 35.141,
              "y": 4.0864,
              "z": 0.16416
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf1",
        "height": 0.38445,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60c7",
            "leftCorner": {
              "x": 34.408,
              "y": 3.3405,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.48,
              "y": 3.4285,
              "z": 0.38445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172996771"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c9",
            "leftCorner": {
              "x": 34.48,
              "y": 3.4285,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.557,
              "y": 3.5246,
              "z": 0.38445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996771"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ca",
            "leftCorner": {
              "x": 34.557,
              "y": 3.5246,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.639,
              "y": 3.626,
              "z": 0.38445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996771"
          },
          {
            "id": "679afb3e3d9bab0f83ff60cb",
            "leftCorner": {
              "x": 34.639,
              "y": 3.626,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.721,
              "y": 3.7275,
              "z": 0.38445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172996771"
          },
          {
            "id": "679afb3e3d9bab0f83ff60cc",
            "leftCorner": {
              "x": 34.721,
              "y": 3.7275,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.784,
              "y": 3.8052,
              "z": 0.38445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60cd",
            "leftCorner": {
              "x": 34.784,
              "y": 3.8052,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.803,
              "y": 3.8286,
              "z": 0.38445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447374544"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ce",
            "leftCorner": {
              "x": 34.803,
              "y": 3.8286,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.874,
              "y": 3.9164,
              "z": 0.38445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374544"
          },
          {
            "id": "679afb3e3d9bab0f83ff60cf",
            "leftCorner": {
              "x": 34.874,
              "y": 3.9164,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 34.951,
              "y": 4.0119,
              "z": 0.38445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c8",
            "leftCorner": {
              "x": 34.951,
              "y": 4.0119,
              "z": 0.38445
            },
            "rightCorner": {
              "x": 35.037,
              "y": 4.1184,
              "z": 0.38445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172997129"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf0",
        "height": 0.59749,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60bf",
            "leftCorner": {
              "x": 34.401,
              "y": 3.3467,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.476,
              "y": 3.4403,
              "z": 0.59749
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661678313"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c1",
            "leftCorner": {
              "x": 34.476,
              "y": 3.4403,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.563,
              "y": 3.5477,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661678313"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c2",
            "leftCorner": {
              "x": 34.563,
              "y": 3.5477,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.634,
              "y": 3.6351,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661726632"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c3",
            "leftCorner": {
              "x": 34.634,
              "y": 3.6351,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.717,
              "y": 3.7383,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661726632"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c4",
            "leftCorner": {
              "x": 34.717,
              "y": 3.7383,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.779,
              "y": 3.8145,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661671789"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c5",
            "leftCorner": {
              "x": 34.779,
              "y": 3.8145,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.874,
              "y": 3.9326,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661671789"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c6",
            "leftCorner": {
              "x": 34.874,
              "y": 3.9326,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 34.953,
              "y": 4.0299,
              "z": 0.59749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900774699"
          },
          {
            "id": "679afb3e3d9bab0f83ff60c0",
            "leftCorner": {
              "x": 34.953,
              "y": 4.0299,
              "z": 0.59749
            },
            "rightCorner": {
              "x": 35.029,
              "y": 4.1246,
              "z": 0.59749
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900983534"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acef",
        "height": 0.76787,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60b3",
            "leftCorner": {
              "x": 34.399,
              "y": 3.348,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.465,
              "y": 3.4298,
              "z": 0.76787
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447313888"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b5",
            "leftCorner": {
              "x": 34.465,
              "y": 3.4298,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.529,
              "y": 3.5087,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796066920"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b6",
            "leftCorner": {
              "x": 34.529,
              "y": 3.5087,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.579,
              "y": 3.5699,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "83078811174"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b7",
            "leftCorner": {
              "x": 34.579,
              "y": 3.5699,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.632,
              "y": 3.636,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "83078811143"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b8",
            "leftCorner": {
              "x": 34.632,
              "y": 3.636,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.671,
              "y": 3.6842,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541698475"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b9",
            "leftCorner": {
              "x": 34.671,
              "y": 3.6842,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.747,
              "y": 3.7784,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900805928"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ba",
            "leftCorner": {
              "x": 34.747,
              "y": 3.7784,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.822,
              "y": 3.8713,
              "z": 0.76787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900805966"
          },
          {
            "id": "679afb3e3d9bab0f83ff60bb",
            "leftCorner": {
              "x": 34.822,
              "y": 3.8713,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.855,
              "y": 3.9119,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429121"
          },
          {
            "id": "679afb3e3d9bab0f83ff60bc",
            "leftCorner": {
              "x": 34.855,
              "y": 3.9119,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.892,
              "y": 3.9579,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234176"
          },
          {
            "id": "679afb3e3d9bab0f83ff60bd",
            "leftCorner": {
              "x": 34.892,
              "y": 3.9579,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.927,
              "y": 4.0018,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234176"
          },
          {
            "id": "679afb3e3d9bab0f83ff60be",
            "leftCorner": {
              "x": 34.927,
              "y": 4.0018,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 34.972,
              "y": 4.0565,
              "z": 0.76787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373455"
          },
          {
            "id": "679afb3e3d9bab0f83ff60b4",
            "leftCorner": {
              "x": 34.972,
              "y": 4.0565,
              "z": 0.76787
            },
            "rightCorner": {
              "x": 35.028,
              "y": 4.1259,
              "z": 0.76787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447373479"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf3",
        "height": 1.1324,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf5",
        "height": 1.3363,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf4",
        "height": 1.5512,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 24,
      "unknownStockCount": 13
    },
    "name": "Q3ES",
    "leftNeighborShelfId": "LH8H",
    "rightNeighborShelfId": "TNRU"
  },
  {
    "id": "K8RP",
    "x": 35.036,
    "y": 4.0981,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42104,
      "w": 0.90704
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3acfb",
        "height": 0.16661,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e67",
            "leftCorner": {
              "x": 35.137,
              "y": 4.0663,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.178,
              "y": 4.1144,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240689"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e68",
            "leftCorner": {
              "x": 35.178,
              "y": 4.1144,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.21,
              "y": 4.153,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341980"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e69",
            "leftCorner": {
              "x": 35.21,
              "y": 4.153,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.231,
              "y": 4.1781,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341966"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6a",
            "leftCorner": {
              "x": 35.231,
              "y": 4.1781,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.265,
              "y": 4.2182,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245233"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6b",
            "leftCorner": {
              "x": 35.265,
              "y": 4.2182,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.297,
              "y": 4.2557,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771756"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6c",
            "leftCorner": {
              "x": 35.297,
              "y": 4.2557,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.321,
              "y": 4.2837,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245219"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6d",
            "leftCorner": {
              "x": 35.321,
              "y": 4.2837,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.371,
              "y": 4.3435,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245431"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6e",
            "leftCorner": {
              "x": 35.371,
              "y": 4.3435,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.425,
              "y": 4.4072,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245455"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e6f",
            "leftCorner": {
              "x": 35.425,
              "y": 4.4072,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.459,
              "y": 4.4471,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231014"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e70",
            "leftCorner": {
              "x": 35.459,
              "y": 4.4471,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.508,
              "y": 4.505,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231014"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e71",
            "leftCorner": {
              "x": 35.508,
              "y": 4.505,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.557,
              "y": 4.5635,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240702"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e72",
            "leftCorner": {
              "x": 35.557,
              "y": 4.5635,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.598,
              "y": 4.6119,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796126051"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e73",
            "leftCorner": {
              "x": 35.598,
              "y": 4.6119,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.652,
              "y": 4.6754,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245479"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e74",
            "leftCorner": {
              "x": 35.652,
              "y": 4.6754,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.704,
              "y": 4.7375,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365405"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e75",
            "leftCorner": {
              "x": 35.704,
              "y": 4.7375,
              "z": 0.16661
            },
            "rightCorner": {
              "x": 35.756,
              "y": 4.799,
              "z": 0.16661
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231038"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acfa",
        "height": 0.42925,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6024",
            "leftCorner": {
              "x": 35.026,
              "y": 4.1069,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.074,
              "y": 4.1637,
              "z": 0.42925
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172738050"
          },
          {
            "id": "679afb3e3d9bab0f83ff6025",
            "leftCorner": {
              "x": 35.074,
              "y": 4.1637,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.11,
              "y": 4.2064,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738050"
          },
          {
            "id": "679afb3e3d9bab0f83ff6026",
            "leftCorner": {
              "x": 35.11,
              "y": 4.2064,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.136,
              "y": 4.2378,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738012"
          },
          {
            "id": "679afb3e3d9bab0f83ff6027",
            "leftCorner": {
              "x": 35.136,
              "y": 4.2378,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.163,
              "y": 4.2691,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738012"
          },
          {
            "id": "679afb3e3d9bab0f83ff6028",
            "leftCorner": {
              "x": 35.163,
              "y": 4.2691,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.188,
              "y": 4.2991,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429107"
          },
          {
            "id": "679afb3e3d9bab0f83ff6029",
            "leftCorner": {
              "x": 35.188,
              "y": 4.2991,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.229,
              "y": 4.3478,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234046"
          },
          {
            "id": "679afb3e3d9bab0f83ff602a",
            "leftCorner": {
              "x": 35.229,
              "y": 4.3478,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.262,
              "y": 4.3867,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382020"
          },
          {
            "id": "679afb3e3d9bab0f83ff602b",
            "leftCorner": {
              "x": 35.262,
              "y": 4.3867,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.323,
              "y": 4.458,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428940"
          },
          {
            "id": "679afb3e3d9bab0f83ff602c",
            "leftCorner": {
              "x": 35.323,
              "y": 4.458,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.365,
              "y": 4.5083,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154924"
          },
          {
            "id": "679afb3e3d9bab0f83ff602d",
            "leftCorner": {
              "x": 35.365,
              "y": 4.5083,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.437,
              "y": 4.5934,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447348477"
          },
          {
            "id": "679afb3e3d9bab0f83ff602e",
            "leftCorner": {
              "x": 35.437,
              "y": 4.5934,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.502,
              "y": 4.6703,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447101898"
          },
          {
            "id": "679afb3e3d9bab0f83ff602f",
            "leftCorner": {
              "x": 35.502,
              "y": 4.6703,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.548,
              "y": 4.7249,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492224"
          },
          {
            "id": "679afb3e3d9bab0f83ff6030",
            "leftCorner": {
              "x": 35.548,
              "y": 4.7249,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.591,
              "y": 4.776,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233728"
          },
          {
            "id": "679afb3e3d9bab0f83ff6031",
            "leftCorner": {
              "x": 35.591,
              "y": 4.776,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.629,
              "y": 4.8204,
              "z": 0.42925
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233766"
          },
          {
            "id": "679afb3e3d9bab0f83ff6032",
            "leftCorner": {
              "x": 35.629,
              "y": 4.8204,
              "z": 0.42925
            },
            "rightCorner": {
              "x": 35.671,
              "y": 4.8707,
              "z": 0.42925
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447234190"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf7",
        "height": 0.68234,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f22",
            "leftCorner": {
              "x": 35.023,
              "y": 4.1092,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.101,
              "y": 4.2008,
              "z": 0.68234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447314540"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f24",
            "leftCorner": {
              "x": 35.101,
              "y": 4.2008,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.124,
              "y": 4.2289,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240375"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f25",
            "leftCorner": {
              "x": 35.124,
              "y": 4.2289,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.155,
              "y": 4.2656,
              "z": 0.68234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447215434"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f26",
            "leftCorner": {
              "x": 35.155,
              "y": 4.2656,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.189,
              "y": 4.3056,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215434"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f27",
            "leftCorner": {
              "x": 35.189,
              "y": 4.3056,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.232,
              "y": 4.3562,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240436"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f28",
            "leftCorner": {
              "x": 35.232,
              "y": 4.3562,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.274,
              "y": 4.4065,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429350"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f29",
            "leftCorner": {
              "x": 35.274,
              "y": 4.4065,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.35,
              "y": 4.4962,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381993"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2a",
            "leftCorner": {
              "x": 35.35,
              "y": 4.4962,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.402,
              "y": 4.5578,
              "z": 0.68234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447244786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2b",
            "leftCorner": {
              "x": 35.402,
              "y": 4.5578,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.453,
              "y": 4.6179,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429183"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2c",
            "leftCorner": {
              "x": 35.453,
              "y": 4.6179,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.521,
              "y": 4.6978,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154962"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2d",
            "leftCorner": {
              "x": 35.521,
              "y": 4.6978,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.594,
              "y": 4.7846,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447101812"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2e",
            "leftCorner": {
              "x": 35.594,
              "y": 4.7846,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.651,
              "y": 4.8522,
              "z": 0.68234
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447101850"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f2f",
            "leftCorner": {
              "x": 35.651,
              "y": 4.8522,
              "z": 0.68234
            },
            "rightCorner": {
              "x": 35.669,
              "y": 4.873,
              "z": 0.68234
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447233926"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf6",
        "height": 0.93259,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ec9",
            "leftCorner": {
              "x": 35.024,
              "y": 4.1085,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.091,
              "y": 4.1881,
              "z": 0.93259
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447216059"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eca",
            "leftCorner": {
              "x": 35.091,
              "y": 4.1881,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.117,
              "y": 4.2192,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447600322"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ecb",
            "leftCorner": {
              "x": 35.117,
              "y": 4.2192,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.143,
              "y": 4.2495,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411409"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ecc",
            "leftCorner": {
              "x": 35.143,
              "y": 4.2495,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.171,
              "y": 4.2827,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215373"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ecd",
            "leftCorner": {
              "x": 35.171,
              "y": 4.2827,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.198,
              "y": 4.3141,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381757"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ece",
            "leftCorner": {
              "x": 35.198,
              "y": 4.3141,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.224,
              "y": 4.3458,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381757"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ecf",
            "leftCorner": {
              "x": 35.224,
              "y": 4.3458,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.253,
              "y": 4.3794,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062892"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed0",
            "leftCorner": {
              "x": 35.253,
              "y": 4.3794,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.299,
              "y": 4.4345,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381863"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed1",
            "leftCorner": {
              "x": 35.299,
              "y": 4.4345,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.346,
              "y": 4.4895,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447216158"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed2",
            "leftCorner": {
              "x": 35.346,
              "y": 4.4895,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.379,
              "y": 4.529,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215939"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed3",
            "leftCorner": {
              "x": 35.379,
              "y": 4.529,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.418,
              "y": 4.5752,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215274"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed4",
            "leftCorner": {
              "x": 35.418,
              "y": 4.5752,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.461,
              "y": 4.6257,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215274"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed5",
            "leftCorner": {
              "x": 35.461,
              "y": 4.6257,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.496,
              "y": 4.6667,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062632"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed6",
            "leftCorner": {
              "x": 35.496,
              "y": 4.6667,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.57,
              "y": 4.7547,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447216134"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ed7",
            "leftCorner": {
              "x": 35.57,
              "y": 4.7547,
              "z": 0.93259
            },
            "rightCorner": {
              "x": 35.657,
              "y": 4.8574,
              "z": 0.93259
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000049"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf9",
        "height": 1.188,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fc7",
            "leftCorner": {
              "x": 35.025,
              "y": 4.1079,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.068,
              "y": 4.1592,
              "z": 1.188
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447215557"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc9",
            "leftCorner": {
              "x": 35.068,
              "y": 4.1592,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.139,
              "y": 4.2431,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215458"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fca",
            "leftCorner": {
              "x": 35.139,
              "y": 4.2431,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.173,
              "y": 4.2832,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438888"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fcb",
            "leftCorner": {
              "x": 35.173,
              "y": 4.2832,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.204,
              "y": 4.3202,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428766"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fcc",
            "leftCorner": {
              "x": 35.204,
              "y": 4.3202,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.228,
              "y": 4.3491,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fcd",
            "leftCorner": {
              "x": 35.228,
              "y": 4.3491,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.264,
              "y": 4.3913,
              "z": 1.188
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447428780"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fce",
            "leftCorner": {
              "x": 35.264,
              "y": 4.3913,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.307,
              "y": 4.4418,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233780"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fcf",
            "leftCorner": {
              "x": 35.307,
              "y": 4.4418,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.349,
              "y": 4.4922,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233780"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd0",
            "leftCorner": {
              "x": 35.349,
              "y": 4.4922,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.396,
              "y": 4.5478,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233841"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd1",
            "leftCorner": {
              "x": 35.396,
              "y": 4.5478,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.473,
              "y": 4.6384,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447244908"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd2",
            "leftCorner": {
              "x": 35.473,
              "y": 4.6384,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.532,
              "y": 4.708,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447321425"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd3",
            "leftCorner": {
              "x": 35.532,
              "y": 4.708,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.584,
              "y": 4.77,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234060"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd4",
            "leftCorner": {
              "x": 35.584,
              "y": 4.77,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.616,
              "y": 4.808,
              "z": 1.188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234084"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd5",
            "leftCorner": {
              "x": 35.616,
              "y": 4.808,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.636,
              "y": 4.8311,
              "z": 1.188
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447234084"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fd6",
            "leftCorner": {
              "x": 35.636,
              "y": 4.8311,
              "z": 1.188
            },
            "rightCorner": {
              "x": 35.713,
              "y": 4.9222,
              "z": 1.188
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acf8",
        "height": 1.4412,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f72",
            "leftCorner": {
              "x": 35.022,
              "y": 4.1098,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.083,
              "y": 4.1817,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245042"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f74",
            "leftCorner": {
              "x": 35.083,
              "y": 4.1817,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.143,
              "y": 4.2522,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428872"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f75",
            "leftCorner": {
              "x": 35.143,
              "y": 4.2522,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.184,
              "y": 4.301,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447428865"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f76",
            "leftCorner": {
              "x": 35.184,
              "y": 4.301,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.213,
              "y": 4.3355,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172701634"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f77",
            "leftCorner": {
              "x": 35.213,
              "y": 4.3355,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.248,
              "y": 4.3769,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382051"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f78",
            "leftCorner": {
              "x": 35.248,
              "y": 4.3769,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.285,
              "y": 4.42,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447244847"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f79",
            "leftCorner": {
              "x": 35.285,
              "y": 4.42,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.328,
              "y": 4.4717,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447101751"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7a",
            "leftCorner": {
              "x": 35.328,
              "y": 4.4717,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.386,
              "y": 4.54,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447101799"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7b",
            "leftCorner": {
              "x": 35.386,
              "y": 4.54,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.46,
              "y": 4.6277,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215809"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7c",
            "leftCorner": {
              "x": 35.46,
              "y": 4.6277,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.514,
              "y": 4.6913,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215762"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7d",
            "leftCorner": {
              "x": 35.514,
              "y": 4.6913,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.557,
              "y": 4.7428,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215786"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7e",
            "leftCorner": {
              "x": 35.557,
              "y": 4.7428,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.601,
              "y": 4.7946,
              "z": 1.4412
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172681554"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f7f",
            "leftCorner": {
              "x": 35.601,
              "y": 4.7946,
              "z": 1.4412
            },
            "rightCorner": {
              "x": 35.668,
              "y": 4.8736,
              "z": 1.4412
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172938207"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 74,
      "unknownStockCount": 12
    },
    "name": "K8RP",
    "leftNeighborShelfId": "QJ5N",
    "rightNeighborShelfId": "1SKP"
  },
  {
    "id": "PKZ7",
    "x": 36.319,
    "y": 5.6276,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42198,
      "w": 0.90661
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad01",
        "height": 0.16362,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e82",
            "leftCorner": {
              "x": 36.393,
              "y": 5.5649,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.45,
              "y": 5.6331,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245356"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e83",
            "leftCorner": {
              "x": 36.451,
              "y": 5.6329,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.558,
              "y": 5.7609,
              "z": 0.16362
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796064469"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e84",
            "leftCorner": {
              "x": 36.558,
              "y": 5.7609,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.601,
              "y": 5.8116,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245295"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e85",
            "leftCorner": {
              "x": 36.601,
              "y": 5.8116,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.646,
              "y": 5.8653,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382341"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e86",
            "leftCorner": {
              "x": 36.646,
              "y": 5.8653,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.71,
              "y": 5.9413,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064100"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e87",
            "leftCorner": {
              "x": 36.71,
              "y": 5.9413,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.776,
              "y": 6.0199,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064131"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e88",
            "leftCorner": {
              "x": 36.776,
              "y": 6.0199,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.845,
              "y": 6.1016,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796064070"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e89",
            "leftCorner": {
              "x": 36.845,
              "y": 6.1016,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.912,
              "y": 6.1814,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447314571"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e8a",
            "leftCorner": {
              "x": 36.912,
              "y": 6.1814,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 36.958,
              "y": 6.236,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796107067"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e8b",
            "leftCorner": {
              "x": 36.958,
              "y": 6.236,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 37.033,
              "y": 6.3254,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260199894521"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad00",
        "height": 0.42569,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff603e",
            "leftCorner": {
              "x": 36.297,
              "y": 5.6243,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.347,
              "y": 5.6835,
              "z": 0.42569
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661692333"
          },
          {
            "id": "679afb3e3d9bab0f83ff603f",
            "leftCorner": {
              "x": 36.347,
              "y": 5.6834,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.383,
              "y": 5.7262,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661690483"
          },
          {
            "id": "679afb3e3d9bab0f83ff6040",
            "leftCorner": {
              "x": 36.383,
              "y": 5.7261,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.478,
              "y": 5.8385,
              "z": 0.42569
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661690520"
          },
          {
            "id": "679afb3e3d9bab0f83ff6041",
            "leftCorner": {
              "x": 36.478,
              "y": 5.8385,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.518,
              "y": 5.8861,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661690537"
          },
          {
            "id": "679afb3e3d9bab0f83ff6042",
            "leftCorner": {
              "x": 36.518,
              "y": 5.8861,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.557,
              "y": 5.9332,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447242539"
          },
          {
            "id": "679afb3e3d9bab0f83ff6043",
            "leftCorner": {
              "x": 36.557,
              "y": 5.9332,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.601,
              "y": 5.9855,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447242553"
          },
          {
            "id": "679afb3e3d9bab0f83ff6044",
            "leftCorner": {
              "x": 36.601,
              "y": 5.9855,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.659,
              "y": 6.0535,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724000434"
          },
          {
            "id": "679afb3e3d9bab0f83ff6045",
            "leftCorner": {
              "x": 36.659,
              "y": 6.0535,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.719,
              "y": 6.1247,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724000328"
          },
          {
            "id": "679afb3e3d9bab0f83ff6046",
            "leftCorner": {
              "x": 36.719,
              "y": 6.1247,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.775,
              "y": 6.1917,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5010724000526"
          },
          {
            "id": "679afb3e3d9bab0f83ff6047",
            "leftCorner": {
              "x": 36.775,
              "y": 6.1917,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.828,
              "y": 6.2551,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448044185"
          },
          {
            "id": "679afb3e3d9bab0f83ff6048",
            "leftCorner": {
              "x": 36.828,
              "y": 6.2551,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.867,
              "y": 6.3017,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448044116"
          },
          {
            "id": "679afb3e3d9bab0f83ff6049",
            "leftCorner": {
              "x": 36.867,
              "y": 6.3017,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.928,
              "y": 6.3732,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4042763424293"
          },
          {
            "id": "679afb3e3d9bab0f83ff604a",
            "leftCorner": {
              "x": 36.928,
              "y": 6.3732,
              "z": 0.42569
            },
            "rightCorner": {
              "x": 36.952,
              "y": 6.402,
              "z": 0.42569
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448068112"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acfc",
        "height": 0.67873,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f3c",
            "leftCorner": {
              "x": 36.367,
              "y": 5.7113,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.509,
              "y": 5.8804,
              "z": 0.67873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542048477"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f3d",
            "leftCorner": {
              "x": 36.509,
              "y": 5.8804,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.544,
              "y": 5.9219,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4084200772901"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f3e",
            "leftCorner": {
              "x": 36.544,
              "y": 5.9219,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.588,
              "y": 5.974,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4084200771904"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f3f",
            "leftCorner": {
              "x": 36.588,
              "y": 5.974,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.628,
              "y": 6.0209,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540885036"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f40",
            "leftCorner": {
              "x": 36.628,
              "y": 6.0209,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.686,
              "y": 6.0897,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542636551"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f41",
            "leftCorner": {
              "x": 36.686,
              "y": 6.0897,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.755,
              "y": 6.1718,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4084200774905"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f42",
            "leftCorner": {
              "x": 36.755,
              "y": 6.1718,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.788,
              "y": 6.211,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540033635"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f43",
            "leftCorner": {
              "x": 36.788,
              "y": 6.211,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.82,
              "y": 6.2489,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542317016"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f44",
            "leftCorner": {
              "x": 36.82,
              "y": 6.2489,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.852,
              "y": 6.2874,
              "z": 0.67873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541895492"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f45",
            "leftCorner": {
              "x": 36.852,
              "y": 6.2874,
              "z": 0.67873
            },
            "rightCorner": {
              "x": 36.898,
              "y": 6.3421,
              "z": 0.67873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3663555005400"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f46",
            "leftCorner": {
              "x": 36.9,
              "y": 6.3456,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 36.951,
              "y": 6.4062,
              "z": 0.67519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542572897"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acfd",
        "height": 0.9273,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ee3",
            "leftCorner": {
              "x": 36.293,
              "y": 5.6265,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.362,
              "y": 5.7083,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541744554"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee4",
            "leftCorner": {
              "x": 36.362,
              "y": 5.7082,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.521,
              "y": 5.8967,
              "z": 0.9273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541594814"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee5",
            "leftCorner": {
              "x": 36.521,
              "y": 5.8967,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.565,
              "y": 5.9495,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542326254"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee6",
            "leftCorner": {
              "x": 36.565,
              "y": 5.9495,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.592,
              "y": 5.9809,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542184687"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee7",
            "leftCorner": {
              "x": 36.592,
              "y": 5.9809,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.639,
              "y": 6.0369,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542619585"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee8",
            "leftCorner": {
              "x": 36.639,
              "y": 6.0369,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.688,
              "y": 6.0958,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542562485"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ee9",
            "leftCorner": {
              "x": 36.688,
              "y": 6.0958,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.739,
              "y": 6.156,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542442893"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eea",
            "leftCorner": {
              "x": 36.739,
              "y": 6.156,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.769,
              "y": 6.1912,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542397568"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eeb",
            "leftCorner": {
              "x": 36.769,
              "y": 6.1912,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.787,
              "y": 6.2133,
              "z": 0.9273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542397568"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eec",
            "leftCorner": {
              "x": 36.787,
              "y": 6.2133,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.832,
              "y": 6.2661,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542453103"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eed",
            "leftCorner": {
              "x": 36.832,
              "y": 6.2661,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.876,
              "y": 6.3183,
              "z": 0.9273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542605625"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eee",
            "leftCorner": {
              "x": 36.876,
              "y": 6.3183,
              "z": 0.9273
            },
            "rightCorner": {
              "x": 36.948,
              "y": 6.4049,
              "z": 0.9273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542449595"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acff",
        "height": 1.1839,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fe1",
            "leftCorner": {
              "x": 36.305,
              "y": 5.639,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.401,
              "y": 5.7534,
              "z": 1.1839
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678789"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe2",
            "leftCorner": {
              "x": 36.401,
              "y": 5.7531,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.541,
              "y": 5.9192,
              "z": 1.1839
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541163638"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe3",
            "leftCorner": {
              "x": 36.541,
              "y": 5.9192,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.586,
              "y": 5.9723,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541163645"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe4",
            "leftCorner": {
              "x": 36.586,
              "y": 5.9723,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.644,
              "y": 6.0418,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000025"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe5",
            "leftCorner": {
              "x": 36.644,
              "y": 6.0418,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.678,
              "y": 6.0819,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542597838"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe6",
            "leftCorner": {
              "x": 36.678,
              "y": 6.0819,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.713,
              "y": 6.1228,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542573061"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe7",
            "leftCorner": {
              "x": 36.713,
              "y": 6.1228,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.743,
              "y": 6.1593,
              "z": 1.1839
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542595971"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe8",
            "leftCorner": {
              "x": 36.743,
              "y": 6.1593,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.78,
              "y": 6.2032,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542442909"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fe9",
            "leftCorner": {
              "x": 36.78,
              "y": 6.2032,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.814,
              "y": 6.2431,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542497916"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fea",
            "leftCorner": {
              "x": 36.814,
              "y": 6.2431,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.847,
              "y": 6.2828,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542453158"
          },
          {
            "id": "679afb3e3d9bab0f83ff5feb",
            "leftCorner": {
              "x": 36.847,
              "y": 6.2828,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.882,
              "y": 6.3239,
              "z": 1.1839
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542541398"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fec",
            "leftCorner": {
              "x": 36.882,
              "y": 6.3239,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.904,
              "y": 6.3498,
              "z": 1.1839
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000111926"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fed",
            "leftCorner": {
              "x": 36.904,
              "y": 6.3498,
              "z": 1.1839
            },
            "rightCorner": {
              "x": 36.949,
              "y": 6.4041,
              "z": 1.1839
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000111926"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3acfe",
        "height": 1.437,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f88",
            "leftCorner": {
              "x": 36.291,
              "y": 5.6276,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.337,
              "y": 5.6822,
              "z": 1.437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678871"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f89",
            "leftCorner": {
              "x": 36.337,
              "y": 5.6821,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.375,
              "y": 5.7276,
              "z": 1.437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678840"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8a",
            "leftCorner": {
              "x": 36.375,
              "y": 5.7275,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.396,
              "y": 5.7523,
              "z": 1.437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678840"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8b",
            "leftCorner": {
              "x": 36.396,
              "y": 5.7522,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.612,
              "y": 6.0084,
              "z": 1.437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260524943054"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8c",
            "leftCorner": {
              "x": 36.612,
              "y": 6.0084,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.668,
              "y": 6.075,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941111"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8d",
            "leftCorner": {
              "x": 36.668,
              "y": 6.075,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.708,
              "y": 6.123,
              "z": 1.437
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4260524942651"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8e",
            "leftCorner": {
              "x": 36.708,
              "y": 6.123,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.748,
              "y": 6.1702,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940169"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f8f",
            "leftCorner": {
              "x": 36.748,
              "y": 6.1702,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.771,
              "y": 6.1974,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940169"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f90",
            "leftCorner": {
              "x": 36.771,
              "y": 6.1974,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.789,
              "y": 6.2193,
              "z": 1.437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260524942682"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f91",
            "leftCorner": {
              "x": 36.789,
              "y": 6.2193,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.827,
              "y": 6.2641,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940282"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f92",
            "leftCorner": {
              "x": 36.827,
              "y": 6.2641,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.865,
              "y": 6.3097,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941487"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f93",
            "leftCorner": {
              "x": 36.865,
              "y": 6.3097,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.904,
              "y": 6.3557,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941258"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f94",
            "leftCorner": {
              "x": 36.904,
              "y": 6.3557,
              "z": 1.437
            },
            "rightCorner": {
              "x": 36.944,
              "y": 6.404,
              "z": 1.437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941135"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 52,
      "unknownStockCount": 19,
      "shelfCategory": "PET"
    },
    "name": "PKZ7",
    "rightNeighborShelfId": "J0MD"
  },
  {
    "id": "YT1C",
    "x": 50.503,
    "y": 8.1517,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.4844,
      "w": 0.87485
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad05",
        "height": 0.15286,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6142",
            "leftCorner": {
              "x": 50.592,
              "y": 8.107,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.614,
              "y": 8.143,
              "z": 0.15286
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6143",
            "leftCorner": {
              "x": 50.614,
              "y": 8.143,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.641,
              "y": 8.1862,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376616"
          },
          {
            "id": "679afb3e3d9bab0f83ff6144",
            "leftCorner": {
              "x": 50.641,
              "y": 8.1862,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.664,
              "y": 8.2225,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447069105"
          },
          {
            "id": "679afb3e3d9bab0f83ff6145",
            "leftCorner": {
              "x": 50.664,
              "y": 8.2225,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.747,
              "y": 8.355,
              "z": 0.15286
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172507311"
          },
          {
            "id": "679afb3e3d9bab0f83ff6146",
            "leftCorner": {
              "x": 50.747,
              "y": 8.355,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.773,
              "y": 8.3966,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172528910"
          },
          {
            "id": "679afb3e3d9bab0f83ff6147",
            "leftCorner": {
              "x": 50.773,
              "y": 8.3966,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.797,
              "y": 8.4352,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172528910"
          },
          {
            "id": "679afb3e3d9bab0f83ff6148",
            "leftCorner": {
              "x": 50.797,
              "y": 8.4352,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.819,
              "y": 8.4699,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172030055"
          },
          {
            "id": "679afb3e3d9bab0f83ff6149",
            "leftCorner": {
              "x": 50.819,
              "y": 8.4699,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.846,
              "y": 8.5121,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191015757"
          },
          {
            "id": "679afb3e3d9bab0f83ff614a",
            "leftCorner": {
              "x": 50.846,
              "y": 8.5121,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.87,
              "y": 8.5504,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000018"
          },
          {
            "id": "679afb3e3d9bab0f83ff614b",
            "leftCorner": {
              "x": 50.87,
              "y": 8.5504,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.904,
              "y": 8.605,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191015757"
          },
          {
            "id": "679afb3e3d9bab0f83ff614c",
            "leftCorner": {
              "x": 50.904,
              "y": 8.605,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.931,
              "y": 8.6483,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff614d",
            "leftCorner": {
              "x": 50.931,
              "y": 8.6483,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 50.956,
              "y": 8.6882,
              "z": 0.15286
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4004191015405"
          },
          {
            "id": "679afb3e3d9bab0f83ff614e",
            "leftCorner": {
              "x": 50.956,
              "y": 8.6882,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 51.049,
              "y": 8.837,
              "z": 0.15286
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004191015849"
          },
          {
            "id": "679afb3e3d9bab0f83ff612b",
            "leftCorner": {
              "x": 51.049,
              "y": 8.837,
              "z": 0.15286
            },
            "rightCorner": {
              "x": 51.118,
              "y": 8.9469,
              "z": 0.15286
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004191012565"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad07",
        "height": 0.41301,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6184",
            "leftCorner": {
              "x": 50.482,
              "y": 8.1296,
              "z": 0.4132
            },
            "rightCorner": {
              "x": 50.503,
              "y": 8.1623,
              "z": 0.4132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016727"
          },
          {
            "id": "679afb3e3d9bab0f83ff6185",
            "leftCorner": {
              "x": 50.497,
              "y": 8.1739,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.523,
              "y": 8.2148,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016727"
          },
          {
            "id": "679afb3e3d9bab0f83ff6186",
            "leftCorner": {
              "x": 50.523,
              "y": 8.2148,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.549,
              "y": 8.257,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016727"
          },
          {
            "id": "679afb3e3d9bab0f83ff6187",
            "leftCorner": {
              "x": 50.549,
              "y": 8.257,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.599,
              "y": 8.3365,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531982113"
          },
          {
            "id": "679afb3e3d9bab0f83ff6188",
            "leftCorner": {
              "x": 50.599,
              "y": 8.3365,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.69,
              "y": 8.4811,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447696653"
          },
          {
            "id": "679afb3e3d9bab0f83ff6189",
            "leftCorner": {
              "x": 50.69,
              "y": 8.4811,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.789,
              "y": 8.64,
              "z": 0.41301
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447696653"
          },
          {
            "id": "679afb3e3d9bab0f83ff618a",
            "leftCorner": {
              "x": 50.789,
              "y": 8.64,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.818,
              "y": 8.6858,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531981239"
          },
          {
            "id": "679afb3e3d9bab0f83ff618b",
            "leftCorner": {
              "x": 50.818,
              "y": 8.6858,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.839,
              "y": 8.7192,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531982175"
          },
          {
            "id": "679afb3e3d9bab0f83ff618c",
            "leftCorner": {
              "x": 50.839,
              "y": 8.7192,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 50.935,
              "y": 8.8724,
              "z": 0.41301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531982137"
          },
          {
            "id": "679afb3e3d9bab0f83ff616e",
            "leftCorner": {
              "x": 50.935,
              "y": 8.8724,
              "z": 0.41301
            },
            "rightCorner": {
              "x": 51.02,
              "y": 9.0082,
              "z": 0.41301
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531982144"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad06",
        "height": 0.66552,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6167",
            "leftCorner": {
              "x": 50.497,
              "y": 8.1751,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.555,
              "y": 8.2665,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "50270279"
          },
          {
            "id": "679afb3e3d9bab0f83ff6168",
            "leftCorner": {
              "x": 50.555,
              "y": 8.2668,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.61,
              "y": 8.3543,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "50051656"
          },
          {
            "id": "679afb3e3d9bab0f83ff6169",
            "leftCorner": {
              "x": 50.61,
              "y": 8.3546,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.761,
              "y": 8.5966,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42275640"
          },
          {
            "id": "679afb3e3d9bab0f83ff616a",
            "leftCorner": {
              "x": 50.761,
              "y": 8.5966,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.781,
              "y": 8.6285,
              "z": 0.66552
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff616b",
            "leftCorner": {
              "x": 50.781,
              "y": 8.6285,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.841,
              "y": 8.7232,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447232097"
          },
          {
            "id": "679afb3e3d9bab0f83ff616c",
            "leftCorner": {
              "x": 50.841,
              "y": 8.7232,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.895,
              "y": 8.8106,
              "z": 0.66552
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447217513"
          },
          {
            "id": "679afb3e3d9bab0f83ff6150",
            "leftCorner": {
              "x": 50.895,
              "y": 8.8106,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 51.019,
              "y": 9.0086,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661006369"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad02",
        "height": 0.87505,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60ea",
            "leftCorner": {
              "x": 50.514,
              "y": 8.1978,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.582,
              "y": 8.3061,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447441987"
          },
          {
            "id": "679afb3e3d9bab0f83ff60eb",
            "leftCorner": {
              "x": 50.582,
              "y": 8.3061,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.648,
              "y": 8.411,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447441987"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ec",
            "leftCorner": {
              "x": 50.648,
              "y": 8.411,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.717,
              "y": 8.5216,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ed",
            "leftCorner": {
              "x": 50.717,
              "y": 8.5216,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.781,
              "y": 8.6243,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382891"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ee",
            "leftCorner": {
              "x": 50.781,
              "y": 8.6243,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.892,
              "y": 8.8002,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540811085"
          },
          {
            "id": "679afb3e3d9bab0f83ff60ef",
            "leftCorner": {
              "x": 50.892,
              "y": 8.8002,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 50.962,
              "y": 8.9125,
              "z": 0.87505
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260678845020"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d1",
            "leftCorner": {
              "x": 50.962,
              "y": 8.9125,
              "z": 0.87505
            },
            "rightCorner": {
              "x": 51.021,
              "y": 9.0073,
              "z": 0.87505
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260678845020"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad03",
        "height": 1.0856,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6105",
            "leftCorner": {
              "x": 50.486,
              "y": 8.1571,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.528,
              "y": 8.2243,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260073005"
          },
          {
            "id": "679afb3e3d9bab0f83ff6106",
            "leftCorner": {
              "x": 50.528,
              "y": 8.2243,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.568,
              "y": 8.2884,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447397253"
          },
          {
            "id": "679afb3e3d9bab0f83ff6107",
            "leftCorner": {
              "x": 50.568,
              "y": 8.2884,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.597,
              "y": 8.3348,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447256659"
          },
          {
            "id": "679afb3e3d9bab0f83ff6108",
            "leftCorner": {
              "x": 50.597,
              "y": 8.3348,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.698,
              "y": 8.4967,
              "z": 1.0856
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447709803"
          },
          {
            "id": "679afb3e3d9bab0f83ff6109",
            "leftCorner": {
              "x": 50.698,
              "y": 8.4967,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.775,
              "y": 8.6186,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638529914"
          },
          {
            "id": "679afb3e3d9bab0f83ff610a",
            "leftCorner": {
              "x": 50.775,
              "y": 8.6186,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.816,
              "y": 8.685,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661491097"
          },
          {
            "id": "679afb3e3d9bab0f83ff610b",
            "leftCorner": {
              "x": 50.816,
              "y": 8.685,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.854,
              "y": 8.7455,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011448001005"
          },
          {
            "id": "679afb3e3d9bab0f83ff610c",
            "leftCorner": {
              "x": 50.854,
              "y": 8.7455,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.884,
              "y": 8.7934,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638091589"
          },
          {
            "id": "679afb3e3d9bab0f83ff610d",
            "leftCorner": {
              "x": 50.884,
              "y": 8.7934,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 50.965,
              "y": 8.9215,
              "z": 1.0856
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40623474"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f1",
            "leftCorner": {
              "x": 50.965,
              "y": 8.9215,
              "z": 1.0856
            },
            "rightCorner": {
              "x": 51.019,
              "y": 9.0087,
              "z": 1.0856
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172996979"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad08",
        "height": 1.2946,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61a0",
            "leftCorner": {
              "x": 50.469,
              "y": 8.1323,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.521,
              "y": 8.2136,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172928291"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a1",
            "leftCorner": {
              "x": 50.52,
              "y": 8.2138,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.639,
              "y": 8.403,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331000989"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a2",
            "leftCorner": {
              "x": 50.639,
              "y": 8.403,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.722,
              "y": 8.5363,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331001009"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a3",
            "leftCorner": {
              "x": 50.722,
              "y": 8.5363,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.759,
              "y": 8.595,
              "z": 1.2946
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a4",
            "leftCorner": {
              "x": 50.759,
              "y": 8.595,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.783,
              "y": 8.6334,
              "z": 1.2946
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001047"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a5",
            "leftCorner": {
              "x": 50.783,
              "y": 8.6334,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.807,
              "y": 8.6709,
              "z": 1.2946
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4065331001047"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a6",
            "leftCorner": {
              "x": 50.807,
              "y": 8.6709,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.842,
              "y": 8.7276,
              "z": 1.2946
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429008"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a7",
            "leftCorner": {
              "x": 50.842,
              "y": 8.7276,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.93,
              "y": 8.868,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42420729"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a8",
            "leftCorner": {
              "x": 50.93,
              "y": 8.868,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 51.009,
              "y": 8.9942,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4065331000927"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad04",
        "height": 1.5065,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6122",
            "leftCorner": {
              "x": 50.497,
              "y": 8.1681,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.557,
              "y": 8.2624,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447579406"
          },
          {
            "id": "679afb3e3d9bab0f83ff6123",
            "leftCorner": {
              "x": 50.556,
              "y": 8.2627,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.6,
              "y": 8.3312,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447579468"
          },
          {
            "id": "679afb3e3d9bab0f83ff6124",
            "leftCorner": {
              "x": 50.599,
              "y": 8.3314,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.64,
              "y": 8.3951,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447577730"
          },
          {
            "id": "679afb3e3d9bab0f83ff6125",
            "leftCorner": {
              "x": 50.639,
              "y": 8.3953,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.794,
              "y": 8.6424,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447105551"
          },
          {
            "id": "679afb3e3d9bab0f83ff6126",
            "leftCorner": {
              "x": 50.794,
              "y": 8.6424,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.816,
              "y": 8.6776,
              "z": 1.5065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447577778"
          },
          {
            "id": "679afb3e3d9bab0f83ff6127",
            "leftCorner": {
              "x": 50.816,
              "y": 8.6776,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.913,
              "y": 8.8322,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447577839"
          },
          {
            "id": "679afb3e3d9bab0f83ff6128",
            "leftCorner": {
              "x": 50.913,
              "y": 8.8322,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 51.003,
              "y": 8.9758,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447639230"
          },
          {
            "id": "679afb3e3d9bab0f83ff6129",
            "leftCorner": {
              "x": 51.003,
              "y": 8.9758,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 51.016,
              "y": 8.9974,
              "z": 1.5065
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 40,
      "unknownStockCount": 25
    },
    "name": "YT1C",
    "rightNeighborShelfId": "J7M1"
  },
  {
    "id": "KD7C",
    "x": 36.963,
    "y": 6.3981,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.4211,
      "w": 0.90701
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad0d",
        "height": 0.1602,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e8c",
            "leftCorner": {
              "x": 37.033,
              "y": 6.3254,
              "z": 0.16362
            },
            "rightCorner": {
              "x": 37.075,
              "y": 6.3754,
              "z": 0.16362
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5902853048329"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e8d",
            "leftCorner": {
              "x": 37.077,
              "y": 6.3789,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.099,
              "y": 6.4048,
              "z": 0.1602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5902853048329"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e8e",
            "leftCorner": {
              "x": 37.099,
              "y": 6.4048,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.147,
              "y": 6.4617,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019963"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e8f",
            "leftCorner": {
              "x": 37.147,
              "y": 6.4617,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.196,
              "y": 6.5197,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000051"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e90",
            "leftCorner": {
              "x": 37.196,
              "y": 6.5197,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.246,
              "y": 6.5781,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000068275"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e91",
            "leftCorner": {
              "x": 37.246,
              "y": 6.5781,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.302,
              "y": 6.6447,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000004471"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e92",
            "leftCorner": {
              "x": 37.302,
              "y": 6.6447,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.354,
              "y": 6.7066,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000004662"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e93",
            "leftCorner": {
              "x": 37.354,
              "y": 6.7066,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.39,
              "y": 6.7493,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019178"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e94",
            "leftCorner": {
              "x": 37.39,
              "y": 6.7493,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.433,
              "y": 6.8004,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019215"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e95",
            "leftCorner": {
              "x": 37.433,
              "y": 6.8004,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.465,
              "y": 6.838,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019253"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e96",
            "leftCorner": {
              "x": 37.465,
              "y": 6.838,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.503,
              "y": 6.8825,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900973962"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e97",
            "leftCorner": {
              "x": 37.503,
              "y": 6.8825,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.537,
              "y": 6.9237,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900973887"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e98",
            "leftCorner": {
              "x": 37.537,
              "y": 6.9237,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.571,
              "y": 6.9635,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900975317"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e99",
            "leftCorner": {
              "x": 37.571,
              "y": 6.9635,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.591,
              "y": 6.9869,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900975317"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e9a",
            "leftCorner": {
              "x": 37.591,
              "y": 6.9869,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.618,
              "y": 7.0186,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900973924"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e9b",
            "leftCorner": {
              "x": 37.618,
              "y": 7.0186,
              "z": 0.1602
            },
            "rightCorner": {
              "x": 37.684,
              "y": 7.0975,
              "z": 0.1602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000110974"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad0e",
        "height": 0.41982,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff604b",
            "leftCorner": {
              "x": 36.954,
              "y": 6.4053,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.019,
              "y": 6.4829,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900880208"
          },
          {
            "id": "679afb3e3d9bab0f83ff604c",
            "leftCorner": {
              "x": 37.019,
              "y": 6.4827,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.091,
              "y": 6.5676,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900701015"
          },
          {
            "id": "679afb3e3d9bab0f83ff604d",
            "leftCorner": {
              "x": 37.091,
              "y": 6.5676,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.132,
              "y": 6.6155,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900823441"
          },
          {
            "id": "679afb3e3d9bab0f83ff604e",
            "leftCorner": {
              "x": 37.132,
              "y": 6.6155,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.175,
              "y": 6.6667,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900823489"
          },
          {
            "id": "679afb3e3d9bab0f83ff604f",
            "leftCorner": {
              "x": 37.175,
              "y": 6.6667,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.256,
              "y": 6.7626,
              "z": 0.41982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005808195862"
          },
          {
            "id": "679afb3e3d9bab0f83ff6050",
            "leftCorner": {
              "x": 37.256,
              "y": 6.7626,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.307,
              "y": 6.8234,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900935540"
          },
          {
            "id": "679afb3e3d9bab0f83ff6051",
            "leftCorner": {
              "x": 37.307,
              "y": 6.8234,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.426,
              "y": 6.9637,
              "z": 0.41982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900935427"
          },
          {
            "id": "679afb3e3d9bab0f83ff6052",
            "leftCorner": {
              "x": 37.426,
              "y": 6.9637,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.538,
              "y": 7.0963,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900682758"
          },
          {
            "id": "679afb3e3d9bab0f83ff6053",
            "leftCorner": {
              "x": 37.538,
              "y": 7.0963,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.577,
              "y": 7.1427,
              "z": 0.41982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900803238"
          },
          {
            "id": "679afb3e3d9bab0f83ff6054",
            "leftCorner": {
              "x": 37.577,
              "y": 7.1427,
              "z": 0.41982
            },
            "rightCorner": {
              "x": 37.599,
              "y": 7.1692,
              "z": 0.41982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900803238"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad0a",
        "height": 0.67519,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f47",
            "leftCorner": {
              "x": 36.951,
              "y": 6.4061,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 36.994,
              "y": 6.4574,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000087719"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f48",
            "leftCorner": {
              "x": 36.994,
              "y": 6.4574,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.102,
              "y": 6.5845,
              "z": 0.67519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000085517"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f49",
            "leftCorner": {
              "x": 37.102,
              "y": 6.5845,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.146,
              "y": 6.6374,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000111735"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4a",
            "leftCorner": {
              "x": 37.146,
              "y": 6.6374,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.209,
              "y": 6.7113,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000111773"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4b",
            "leftCorner": {
              "x": 37.209,
              "y": 6.7113,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.266,
              "y": 6.7784,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085036"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4c",
            "leftCorner": {
              "x": 37.266,
              "y": 6.7784,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.317,
              "y": 6.8391,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085203"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4d",
            "leftCorner": {
              "x": 37.317,
              "y": 6.8391,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.361,
              "y": 6.8914,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085241"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4e",
            "leftCorner": {
              "x": 37.361,
              "y": 6.8914,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.388,
              "y": 6.9231,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085074"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f4f",
            "leftCorner": {
              "x": 37.388,
              "y": 6.9231,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.442,
              "y": 6.987,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085074"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f50",
            "leftCorner": {
              "x": 37.442,
              "y": 6.987,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.509,
              "y": 7.0671,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000066226"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f51",
            "leftCorner": {
              "x": 37.509,
              "y": 7.0671,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.554,
              "y": 7.1196,
              "z": 0.67519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000085128"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f52",
            "leftCorner": {
              "x": 37.554,
              "y": 7.1196,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.579,
              "y": 7.1492,
              "z": 0.67519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000085166"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad09",
        "height": 0.92456,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5eef",
            "leftCorner": {
              "x": 36.96,
              "y": 6.4136,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.061,
              "y": 6.5341,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900853615"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef0",
            "leftCorner": {
              "x": 37.061,
              "y": 6.5341,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.119,
              "y": 6.6019,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900897367"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef1",
            "leftCorner": {
              "x": 37.119,
              "y": 6.6019,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.148,
              "y": 6.6368,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043401"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef2",
            "leftCorner": {
              "x": 37.148,
              "y": 6.6368,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.196,
              "y": 6.6936,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043364"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef3",
            "leftCorner": {
              "x": 37.196,
              "y": 6.6936,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.23,
              "y": 6.7336,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000054858"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef4",
            "leftCorner": {
              "x": 37.23,
              "y": 6.7336,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.257,
              "y": 6.7652,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043203"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef5",
            "leftCorner": {
              "x": 37.257,
              "y": 6.7652,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.318,
              "y": 6.8383,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043128"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef6",
            "leftCorner": {
              "x": 37.318,
              "y": 6.8383,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.366,
              "y": 6.8951,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043289"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef7",
            "leftCorner": {
              "x": 37.366,
              "y": 6.8951,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.417,
              "y": 6.9554,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000054957"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef8",
            "leftCorner": {
              "x": 37.417,
              "y": 6.9554,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.445,
              "y": 6.9877,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043326"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ef9",
            "leftCorner": {
              "x": 37.445,
              "y": 6.9877,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.465,
              "y": 7.0114,
              "z": 0.92456
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000043326"
          },
          {
            "id": "679afb3e3d9bab0f83ff5efa",
            "leftCorner": {
              "x": 37.465,
              "y": 7.0114,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.513,
              "y": 7.0691,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000054919"
          },
          {
            "id": "679afb3e3d9bab0f83ff5efb",
            "leftCorner": {
              "x": 37.513,
              "y": 7.0691,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.559,
              "y": 7.1227,
              "z": 0.92456
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900884107"
          },
          {
            "id": "679afb3e3d9bab0f83ff5efc",
            "leftCorner": {
              "x": 37.559,
              "y": 7.1227,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.585,
              "y": 7.1535,
              "z": 0.92456
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900925770"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad0c",
        "height": 1.1805,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fee",
            "leftCorner": {
              "x": 36.953,
              "y": 6.4064,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.007,
              "y": 6.471,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900954848"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fef",
            "leftCorner": {
              "x": 37.007,
              "y": 6.4709,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.123,
              "y": 6.6076,
              "z": 1.1805
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000154626"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff0",
            "leftCorner": {
              "x": 37.123,
              "y": 6.6076,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.174,
              "y": 6.6689,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000111650"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff1",
            "leftCorner": {
              "x": 37.174,
              "y": 6.6689,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.229,
              "y": 6.7333,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000153490"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff2",
            "leftCorner": {
              "x": 37.229,
              "y": 6.7333,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.276,
              "y": 6.7891,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000012810"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff3",
            "leftCorner": {
              "x": 37.276,
              "y": 6.7891,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.304,
              "y": 6.8221,
              "z": 1.1805
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900933522"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff4",
            "leftCorner": {
              "x": 37.304,
              "y": 6.8221,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.338,
              "y": 6.8619,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933522"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff5",
            "leftCorner": {
              "x": 37.338,
              "y": 6.8619,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.389,
              "y": 6.9227,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900933560"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff6",
            "leftCorner": {
              "x": 37.389,
              "y": 6.9227,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.432,
              "y": 6.9743,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019437"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff7",
            "leftCorner": {
              "x": 37.432,
              "y": 6.9743,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.459,
              "y": 7.006,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000018089"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff8",
            "leftCorner": {
              "x": 37.459,
              "y": 7.006,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.479,
              "y": 7.0294,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000018089"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ff9",
            "leftCorner": {
              "x": 37.479,
              "y": 7.0294,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.521,
              "y": 7.0792,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000019390"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ffa",
            "leftCorner": {
              "x": 37.521,
              "y": 7.0792,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.557,
              "y": 7.1222,
              "z": 1.1805
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000088150"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ffb",
            "leftCorner": {
              "x": 37.557,
              "y": 7.1222,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.585,
              "y": 7.1553,
              "z": 1.1805
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000088198"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad0b",
        "height": 1.4342,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f95",
            "leftCorner": {
              "x": 36.949,
              "y": 6.4054,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 36.994,
              "y": 6.4594,
              "z": 1.4342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260524940190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f96",
            "leftCorner": {
              "x": 36.994,
              "y": 6.4593,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.013,
              "y": 6.4812,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f97",
            "leftCorner": {
              "x": 37.013,
              "y": 6.4812,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.117,
              "y": 6.6047,
              "z": 1.4342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260524941197"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f98",
            "leftCorner": {
              "x": 37.117,
              "y": 6.6047,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.153,
              "y": 6.6475,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940923"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f99",
            "leftCorner": {
              "x": 37.153,
              "y": 6.6475,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.21,
              "y": 6.715,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524940916"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9a",
            "leftCorner": {
              "x": 37.21,
              "y": 6.715,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.248,
              "y": 6.7599,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941227"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9b",
            "leftCorner": {
              "x": 37.248,
              "y": 6.7599,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.334,
              "y": 6.8609,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941210"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9c",
            "leftCorner": {
              "x": 37.334,
              "y": 6.8609,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.4,
              "y": 6.9397,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941548"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9d",
            "leftCorner": {
              "x": 37.4,
              "y": 6.9397,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.434,
              "y": 6.9798,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941401"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9e",
            "leftCorner": {
              "x": 37.434,
              "y": 6.9798,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.456,
              "y": 7.0058,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260524941401"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f9f",
            "leftCorner": {
              "x": 37.456,
              "y": 7.0058,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.497,
              "y": 7.0544,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260544080050"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa0",
            "leftCorner": {
              "x": 37.497,
              "y": 7.0544,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.536,
              "y": 7.1008,
              "z": 1.4342
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260544086649"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa1",
            "leftCorner": {
              "x": 37.536,
              "y": 7.1008,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.558,
              "y": 7.1267,
              "z": 1.4342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260544086649"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa2",
            "leftCorner": {
              "x": 37.558,
              "y": 7.1267,
              "z": 1.4342
            },
            "rightCorner": {
              "x": 37.596,
              "y": 7.1718,
              "z": 1.4342
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5900116036502"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 65,
      "unknownStockCount": 15,
      "shelfCategory": "PET"
    },
    "name": "KD7C",
    "leftNeighborShelfId": "IOFL",
    "rightNeighborShelfId": "EFUM"
  },
  {
    "id": "BY8E",
    "x": 37.613,
    "y": 7.1672,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42507,
      "w": 0.90516
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad14",
        "height": 0.15831,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5e9c",
            "leftCorner": {
              "x": 37.696,
              "y": 7.098,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.745,
              "y": 7.1562,
              "z": 0.15831
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4084200110505"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e9d",
            "leftCorner": {
              "x": 37.745,
              "y": 7.1566,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.8,
              "y": 7.2229,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100203523"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e9e",
            "leftCorner": {
              "x": 37.8,
              "y": 7.2229,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.828,
              "y": 7.2565,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800708"
          },
          {
            "id": "679afb3e3d9bab0f83ff5e9f",
            "leftCorner": {
              "x": 37.828,
              "y": 7.2565,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.868,
              "y": 7.3055,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100801194"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea0",
            "leftCorner": {
              "x": 37.868,
              "y": 7.3055,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.899,
              "y": 7.3421,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100201642"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea1",
            "leftCorner": {
              "x": 37.899,
              "y": 7.3421,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.938,
              "y": 7.3893,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015001014143"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea2",
            "leftCorner": {
              "x": 37.938,
              "y": 7.3893,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.955,
              "y": 7.4096,
              "z": 0.15831
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015001014426"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea3",
            "leftCorner": {
              "x": 37.955,
              "y": 7.4096,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 37.992,
              "y": 7.4543,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015001014426"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea4",
            "leftCorner": {
              "x": 37.992,
              "y": 7.4543,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.041,
              "y": 7.514,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100435405"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea5",
            "leftCorner": {
              "x": 38.041,
              "y": 7.514,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.088,
              "y": 7.5702,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100192032"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea6",
            "leftCorner": {
              "x": 38.088,
              "y": 7.5702,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.137,
              "y": 7.6294,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260189522830"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea7",
            "leftCorner": {
              "x": 38.137,
              "y": 7.6294,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.181,
              "y": 7.6828,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260189522816"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea8",
            "leftCorner": {
              "x": 38.181,
              "y": 7.6828,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.224,
              "y": 7.7342,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260189522847"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ea9",
            "leftCorner": {
              "x": 38.224,
              "y": 7.7342,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.298,
              "y": 7.8233,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717524078492"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eaa",
            "leftCorner": {
              "x": 38.298,
              "y": 7.8233,
              "z": 0.15831
            },
            "rightCorner": {
              "x": 38.335,
              "y": 7.868,
              "z": 0.15831
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040042217"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad12",
        "height": 0.41992,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6055",
            "leftCorner": {
              "x": 37.609,
              "y": 7.1707,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 37.678,
              "y": 7.2533,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717524075316"
          },
          {
            "id": "679afb3e3d9bab0f83ff6056",
            "leftCorner": {
              "x": 37.678,
              "y": 7.2539,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 37.736,
              "y": 7.3249,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717524075255"
          },
          {
            "id": "679afb3e3d9bab0f83ff6057",
            "leftCorner": {
              "x": 37.736,
              "y": 7.3249,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 37.779,
              "y": 7.376,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900108586"
          },
          {
            "id": "679afb3e3d9bab0f83ff6058",
            "leftCorner": {
              "x": 37.779,
              "y": 7.376,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 37.827,
              "y": 7.4335,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900108623"
          },
          {
            "id": "679afb3e3d9bab0f83ff6059",
            "leftCorner": {
              "x": 37.827,
              "y": 7.4335,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 37.955,
              "y": 7.5885,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059729492784"
          },
          {
            "id": "679afb3e3d9bab0f83ff605a",
            "leftCorner": {
              "x": 37.955,
              "y": 7.5885,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 38.062,
              "y": 7.7175,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059729438706"
          },
          {
            "id": "679afb3e3d9bab0f83ff605b",
            "leftCorner": {
              "x": 38.062,
              "y": 7.7175,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 38.108,
              "y": 7.7722,
              "z": 0.41992
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059729438720"
          },
          {
            "id": "679afb3e3d9bab0f83ff605c",
            "leftCorner": {
              "x": 38.108,
              "y": 7.7722,
              "z": 0.41992
            },
            "rightCorner": {
              "x": 38.135,
              "y": 7.8049,
              "z": 0.41992
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8693347001681"
          },
          {
            "id": "679afb3e3d9bab0f83ff605d",
            "leftCorner": {
              "x": 38.148,
              "y": 7.8195,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.185,
              "y": 7.8639,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523464562"
          },
          {
            "id": "679afb3e3d9bab0f83ff605e",
            "leftCorner": {
              "x": 38.184,
              "y": 7.864,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.217,
              "y": 7.9039,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523363278"
          },
          {
            "id": "679afb3e3d9bab0f83ff605f",
            "leftCorner": {
              "x": 38.217,
              "y": 7.904,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.259,
              "y": 7.9537,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523363254"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad0f",
        "height": 0.67214,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f53",
            "leftCorner": {
              "x": 37.579,
              "y": 7.1492,
              "z": 0.67519
            },
            "rightCorner": {
              "x": 37.683,
              "y": 7.2723,
              "z": 0.67519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524069742"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f54",
            "leftCorner": {
              "x": 37.691,
              "y": 7.2749,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 37.733,
              "y": 7.3261,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524069674"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f55",
            "leftCorner": {
              "x": 37.733,
              "y": 7.3261,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 37.782,
              "y": 7.3852,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524169626"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f56",
            "leftCorner": {
              "x": 37.782,
              "y": 7.3852,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 37.839,
              "y": 7.4536,
              "z": 0.67214
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524192020"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f57",
            "leftCorner": {
              "x": 37.839,
              "y": 7.4536,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 37.921,
              "y": 7.5526,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524185428"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f58",
            "leftCorner": {
              "x": 37.921,
              "y": 7.5526,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 37.972,
              "y": 7.6138,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522020837"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f59",
            "leftCorner": {
              "x": 37.972,
              "y": 7.6138,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.019,
              "y": 7.6712,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523183739"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f5a",
            "leftCorner": {
              "x": 38.019,
              "y": 7.6712,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.069,
              "y": 7.7311,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523183746"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f5b",
            "leftCorner": {
              "x": 38.069,
              "y": 7.7311,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.118,
              "y": 7.7903,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523183753"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f5c",
            "leftCorner": {
              "x": 38.118,
              "y": 7.7903,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.164,
              "y": 7.845,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523350186"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f5d",
            "leftCorner": {
              "x": 38.164,
              "y": 7.845,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.21,
              "y": 7.9011,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523428052"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f5e",
            "leftCorner": {
              "x": 38.21,
              "y": 7.9011,
              "z": 0.67214
            },
            "rightCorner": {
              "x": 38.248,
              "y": 7.9468,
              "z": 0.67214
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523428045"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad13",
        "height": 0.92245,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5efd",
            "leftCorner": {
              "x": 37.585,
              "y": 7.1535,
              "z": 0.92456
            },
            "rightCorner": {
              "x": 37.648,
              "y": 7.2279,
              "z": 0.92456
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000052"
          },
          {
            "id": "679afb3e3d9bab0f83ff5efe",
            "leftCorner": {
              "x": 37.656,
              "y": 7.2305,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.696,
              "y": 7.2787,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524189259"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eff",
            "leftCorner": {
              "x": 37.696,
              "y": 7.2787,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.757,
              "y": 7.3524,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523801305"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f00",
            "leftCorner": {
              "x": 37.757,
              "y": 7.3524,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.81,
              "y": 7.417,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523873814"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f01",
            "leftCorner": {
              "x": 37.81,
              "y": 7.417,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.851,
              "y": 7.4657,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524104139"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f02",
            "leftCorner": {
              "x": 37.851,
              "y": 7.4657,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.889,
              "y": 7.5118,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523954919"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f03",
            "leftCorner": {
              "x": 37.889,
              "y": 7.5118,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.937,
              "y": 7.5702,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524025472"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f04",
            "leftCorner": {
              "x": 37.937,
              "y": 7.5702,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 37.987,
              "y": 7.6301,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524070625"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f05",
            "leftCorner": {
              "x": 37.987,
              "y": 7.6301,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 38.042,
              "y": 7.6962,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523985319"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f06",
            "leftCorner": {
              "x": 38.042,
              "y": 7.6962,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 38.095,
              "y": 7.7596,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524003975"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f07",
            "leftCorner": {
              "x": 38.095,
              "y": 7.7596,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 38.138,
              "y": 7.8119,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524197674"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f08",
            "leftCorner": {
              "x": 38.138,
              "y": 7.8119,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 38.198,
              "y": 7.884,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522249238"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f09",
            "leftCorner": {
              "x": 38.198,
              "y": 7.884,
              "z": 0.92245
            },
            "rightCorner": {
              "x": 38.248,
              "y": 7.9439,
              "z": 0.92245
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524055745"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad10",
        "height": 1.1772,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ffc",
            "leftCorner": {
              "x": 37.585,
              "y": 7.1553,
              "z": 1.1805
            },
            "rightCorner": {
              "x": 37.648,
              "y": 7.2289,
              "z": 1.1805
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524119843"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ffd",
            "leftCorner": {
              "x": 37.657,
              "y": 7.2306,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.698,
              "y": 7.2803,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524122669"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ffe",
            "leftCorner": {
              "x": 37.698,
              "y": 7.2803,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.726,
              "y": 7.3145,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524128975"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fff",
            "leftCorner": {
              "x": 37.726,
              "y": 7.3145,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.752,
              "y": 7.3458,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523670659"
          },
          {
            "id": "679afb3e3d9bab0f83ff6000",
            "leftCorner": {
              "x": 37.752,
              "y": 7.3458,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.799,
              "y": 7.4018,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523670611"
          },
          {
            "id": "679afb3e3d9bab0f83ff6001",
            "leftCorner": {
              "x": 37.799,
              "y": 7.4018,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.848,
              "y": 7.4607,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523670642"
          },
          {
            "id": "679afb3e3d9bab0f83ff6002",
            "leftCorner": {
              "x": 37.848,
              "y": 7.4607,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.89,
              "y": 7.5124,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523716487"
          },
          {
            "id": "679afb3e3d9bab0f83ff6003",
            "leftCorner": {
              "x": 37.89,
              "y": 7.5124,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.942,
              "y": 7.5744,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000034"
          },
          {
            "id": "679afb3e3d9bab0f83ff6004",
            "leftCorner": {
              "x": 37.942,
              "y": 7.5744,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 37.989,
              "y": 7.631,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523639458"
          },
          {
            "id": "679afb3e3d9bab0f83ff6005",
            "leftCorner": {
              "x": 37.989,
              "y": 7.631,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.04,
              "y": 7.6926,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523639465"
          },
          {
            "id": "679afb3e3d9bab0f83ff6006",
            "leftCorner": {
              "x": 38.04,
              "y": 7.6926,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.083,
              "y": 7.7441,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4049639436282"
          },
          {
            "id": "679afb3e3d9bab0f83ff6007",
            "leftCorner": {
              "x": 38.083,
              "y": 7.7441,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.136,
              "y": 7.8081,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4049639436329"
          },
          {
            "id": "679afb3e3d9bab0f83ff6008",
            "leftCorner": {
              "x": 38.136,
              "y": 7.8081,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.18,
              "y": 7.8611,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226561"
          },
          {
            "id": "679afb3e3d9bab0f83ff6009",
            "leftCorner": {
              "x": 38.18,
              "y": 7.8611,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.224,
              "y": 7.9141,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229043"
          },
          {
            "id": "679afb3e3d9bab0f83ff600a",
            "leftCorner": {
              "x": 38.224,
              "y": 7.9141,
              "z": 1.1772
            },
            "rightCorner": {
              "x": 38.255,
              "y": 7.9522,
              "z": 1.1772
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130820307"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad11",
        "height": 1.429,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fa3",
            "leftCorner": {
              "x": 37.602,
              "y": 7.1762,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.655,
              "y": 7.2394,
              "z": 1.429
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524129057"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa4",
            "leftCorner": {
              "x": 37.655,
              "y": 7.2399,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.7,
              "y": 7.2943,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523216451"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa5",
            "leftCorner": {
              "x": 37.7,
              "y": 7.2943,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.746,
              "y": 7.35,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523216468"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa6",
            "leftCorner": {
              "x": 37.746,
              "y": 7.35,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.794,
              "y": 7.407,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523242696"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa7",
            "leftCorner": {
              "x": 37.794,
              "y": 7.407,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.836,
              "y": 7.4579,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523814060"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa8",
            "leftCorner": {
              "x": 37.836,
              "y": 7.4579,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.872,
              "y": 7.5014,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523814053"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fa9",
            "leftCorner": {
              "x": 37.872,
              "y": 7.5014,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.924,
              "y": 7.5637,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523970827"
          },
          {
            "id": "679afb3e3d9bab0f83ff5faa",
            "leftCorner": {
              "x": 37.924,
              "y": 7.5637,
              "z": 1.429
            },
            "rightCorner": {
              "x": 37.977,
              "y": 7.6275,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523970834"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fab",
            "leftCorner": {
              "x": 37.977,
              "y": 7.6275,
              "z": 1.429
            },
            "rightCorner": {
              "x": 38.041,
              "y": 7.7051,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4037900440182"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fac",
            "leftCorner": {
              "x": 38.041,
              "y": 7.7051,
              "z": 1.429
            },
            "rightCorner": {
              "x": 38.096,
              "y": 7.7714,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524012618"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fad",
            "leftCorner": {
              "x": 38.096,
              "y": 7.7714,
              "z": 1.429
            },
            "rightCorner": {
              "x": 38.138,
              "y": 7.8218,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524012618"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fae",
            "leftCorner": {
              "x": 38.138,
              "y": 7.8218,
              "z": 1.429
            },
            "rightCorner": {
              "x": 38.19,
              "y": 7.8842,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523525249"
          },
          {
            "id": "679afb3e3d9bab0f83ff5faf",
            "leftCorner": {
              "x": 38.19,
              "y": 7.8842,
              "z": 1.429
            },
            "rightCorner": {
              "x": 38.241,
              "y": 7.9457,
              "z": 1.429
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524066512"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 68,
      "unknownStockCount": 11,
      "shelfCategory": "PET"
    },
    "name": "BY8E",
    "leftNeighborShelfId": "JBAS",
    "rightNeighborShelfId": "KKXB"
  },
  {
    "id": "HY2A",
    "x": 38.267,
    "y": 7.9488,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.42658,
      "w": 0.90445
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad1a",
        "height": 0.15462,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5eab",
            "leftCorner": {
              "x": 38.362,
              "y": 7.8964,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.383,
              "y": 7.922,
              "z": 0.15462
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040041135"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eac",
            "leftCorner": {
              "x": 38.383,
              "y": 7.922,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.404,
              "y": 7.9468,
              "z": 0.15462
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040041135"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ead",
            "leftCorner": {
              "x": 38.404,
              "y": 7.9468,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.42,
              "y": 7.9671,
              "z": 0.15462
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040019776"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eae",
            "leftCorner": {
              "x": 38.42,
              "y": 7.9671,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.466,
              "y": 8.0218,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237764"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eaf",
            "leftCorner": {
              "x": 38.466,
              "y": 8.0218,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.525,
              "y": 8.094,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000053"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb0",
            "leftCorner": {
              "x": 38.525,
              "y": 8.094,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.565,
              "y": 8.1419,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447233964"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb1",
            "leftCorner": {
              "x": 38.565,
              "y": 8.1419,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.593,
              "y": 8.1763,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467758"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb2",
            "leftCorner": {
              "x": 38.593,
              "y": 8.1763,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.637,
              "y": 8.2293,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234022"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb3",
            "leftCorner": {
              "x": 38.637,
              "y": 8.2293,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.698,
              "y": 8.3035,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447429220"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb4",
            "leftCorner": {
              "x": 38.698,
              "y": 8.3035,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.77,
              "y": 8.3917,
              "z": 0.15462
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447382242"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb5",
            "leftCorner": {
              "x": 38.77,
              "y": 8.3917,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.798,
              "y": 8.4257,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241419"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb6",
            "leftCorner": {
              "x": 38.798,
              "y": 8.4257,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.832,
              "y": 8.4664,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468137"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb7",
            "leftCorner": {
              "x": 38.832,
              "y": 8.4664,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.864,
              "y": 8.5051,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468113"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb8",
            "leftCorner": {
              "x": 38.864,
              "y": 8.5051,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.891,
              "y": 8.5382,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468090"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eb9",
            "leftCorner": {
              "x": 38.891,
              "y": 8.5382,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.925,
              "y": 8.5788,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447379150"
          },
          {
            "id": "679afb3e3d9bab0f83ff5eba",
            "leftCorner": {
              "x": 38.925,
              "y": 8.5788,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.958,
              "y": 8.6195,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234008"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ebb",
            "leftCorner": {
              "x": 38.958,
              "y": 8.6195,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 38.985,
              "y": 8.6514,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447236996"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ebc",
            "leftCorner": {
              "x": 38.985,
              "y": 8.6514,
              "z": 0.15462
            },
            "rightCorner": {
              "x": 39.024,
              "y": 8.6994,
              "z": 0.15462
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad18",
        "height": 0.41744,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6060",
            "leftCorner": {
              "x": 38.258,
              "y": 7.9539,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.41,
              "y": 8.1375,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040000019"
          },
          {
            "id": "679afb3e3d9bab0f83ff6061",
            "leftCorner": {
              "x": 38.41,
              "y": 8.1375,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.458,
              "y": 8.1954,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040019752"
          },
          {
            "id": "679afb3e3d9bab0f83ff6062",
            "leftCorner": {
              "x": 38.458,
              "y": 8.1954,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.497,
              "y": 8.2433,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040918390"
          },
          {
            "id": "679afb3e3d9bab0f83ff6063",
            "leftCorner": {
              "x": 38.497,
              "y": 8.2433,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.545,
              "y": 8.3011,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581538744"
          },
          {
            "id": "679afb3e3d9bab0f83ff6064",
            "leftCorner": {
              "x": 38.545,
              "y": 8.3011,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.631,
              "y": 8.4058,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581539062"
          },
          {
            "id": "679afb3e3d9bab0f83ff6065",
            "leftCorner": {
              "x": 38.631,
              "y": 8.4058,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.716,
              "y": 8.5086,
              "z": 0.41744
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600551159607"
          },
          {
            "id": "679afb3e3d9bab0f83ff6066",
            "leftCorner": {
              "x": 38.716,
              "y": 8.5086,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.765,
              "y": 8.5689,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551156682"
          },
          {
            "id": "679afb3e3d9bab0f83ff6067",
            "leftCorner": {
              "x": 38.765,
              "y": 8.5689,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.801,
              "y": 8.6117,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551153032"
          },
          {
            "id": "679afb3e3d9bab0f83ff6068",
            "leftCorner": {
              "x": 38.801,
              "y": 8.6117,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.854,
              "y": 8.6765,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551158464"
          },
          {
            "id": "679afb3e3d9bab0f83ff6069",
            "leftCorner": {
              "x": 38.854,
              "y": 8.6765,
              "z": 0.41744
            },
            "rightCorner": {
              "x": 38.898,
              "y": 8.7294,
              "z": 0.41744
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551156729"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad15",
        "height": 0.66921,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f5f",
            "leftCorner": {
              "x": 38.263,
              "y": 7.9598,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.339,
              "y": 8.0526,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661655611"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f60",
            "leftCorner": {
              "x": 38.339,
              "y": 8.0526,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.43,
              "y": 8.1628,
              "z": 0.66921
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661588353"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f61",
            "leftCorner": {
              "x": 38.43,
              "y": 8.1628,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.482,
              "y": 8.2256,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661430706"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f62",
            "leftCorner": {
              "x": 38.482,
              "y": 8.2256,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.517,
              "y": 8.2678,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661450544"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f63",
            "leftCorner": {
              "x": 38.517,
              "y": 8.2678,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.555,
              "y": 8.3143,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661333625"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f64",
            "leftCorner": {
              "x": 38.555,
              "y": 8.3143,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.612,
              "y": 8.3828,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661332536"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f65",
            "leftCorner": {
              "x": 38.612,
              "y": 8.3828,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.67,
              "y": 8.4537,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661336640"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f66",
            "leftCorner": {
              "x": 38.67,
              "y": 8.4537,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.713,
              "y": 8.5064,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661332628"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f67",
            "leftCorner": {
              "x": 38.713,
              "y": 8.5064,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.758,
              "y": 8.5606,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661651699"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f68",
            "leftCorner": {
              "x": 38.758,
              "y": 8.5606,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.837,
              "y": 8.6561,
              "z": 0.66921
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661651675"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f69",
            "leftCorner": {
              "x": 38.837,
              "y": 8.6561,
              "z": 0.66921
            },
            "rightCorner": {
              "x": 38.895,
              "y": 8.7271,
              "z": 0.66921
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661657387"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad16",
        "height": 0.919,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f0a",
            "leftCorner": {
              "x": 38.261,
              "y": 7.9582,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.313,
              "y": 8.0204,
              "z": 0.919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524055738"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f0b",
            "leftCorner": {
              "x": 38.312,
              "y": 8.0206,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.355,
              "y": 8.0723,
              "z": 0.919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524055721"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f0c",
            "leftCorner": {
              "x": 38.355,
              "y": 8.0724,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.382,
              "y": 8.1051,
              "z": 0.919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661320700"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f0d",
            "leftCorner": {
              "x": 38.382,
              "y": 8.1052,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.506,
              "y": 8.2552,
              "z": 0.919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000041"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f0e",
            "leftCorner": {
              "x": 38.506,
              "y": 8.2552,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.543,
              "y": 8.3002,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661533551"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f0f",
            "leftCorner": {
              "x": 38.543,
              "y": 8.3002,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.584,
              "y": 8.3496,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661554280"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f10",
            "leftCorner": {
              "x": 38.584,
              "y": 8.3496,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.629,
              "y": 8.4045,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661554297"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f11",
            "leftCorner": {
              "x": 38.629,
              "y": 8.4045,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.668,
              "y": 8.4515,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661554709"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f12",
            "leftCorner": {
              "x": 38.668,
              "y": 8.4515,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.73,
              "y": 8.5267,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5999566330483"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f13",
            "leftCorner": {
              "x": 38.73,
              "y": 8.5267,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.761,
              "y": 8.5643,
              "z": 0.919
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5999566330261"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f14",
            "leftCorner": {
              "x": 38.761,
              "y": 8.5643,
              "z": 0.919
            },
            "rightCorner": {
              "x": 38.843,
              "y": 8.6641,
              "z": 0.919
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5999566330223"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f15",
            "leftCorner": {
              "x": 38.866,
              "y": 8.686,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 38.912,
              "y": 8.7419,
              "z": 0.91894
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5999566330643"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad19",
        "height": 1.1749,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff600b",
            "leftCorner": {
              "x": 38.269,
              "y": 7.9665,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.323,
              "y": 8.0322,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229753"
          },
          {
            "id": "679afb3e3d9bab0f83ff600c",
            "leftCorner": {
              "x": 38.323,
              "y": 8.0322,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.345,
              "y": 8.059,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130822691"
          },
          {
            "id": "679afb3e3d9bab0f83ff600d",
            "leftCorner": {
              "x": 38.345,
              "y": 8.059,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.374,
              "y": 8.0948,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130822691"
          },
          {
            "id": "679afb3e3d9bab0f83ff600e",
            "leftCorner": {
              "x": 38.374,
              "y": 8.0948,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.417,
              "y": 8.1465,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130821137"
          },
          {
            "id": "679afb3e3d9bab0f83ff600f",
            "leftCorner": {
              "x": 38.417,
              "y": 8.1465,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.463,
              "y": 8.2022,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229845"
          },
          {
            "id": "679afb3e3d9bab0f83ff6010",
            "leftCorner": {
              "x": 38.463,
              "y": 8.2022,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.508,
              "y": 8.2574,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229814"
          },
          {
            "id": "679afb3e3d9bab0f83ff6011",
            "leftCorner": {
              "x": 38.508,
              "y": 8.2574,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.558,
              "y": 8.3178,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120082220651"
          },
          {
            "id": "679afb3e3d9bab0f83ff6012",
            "leftCorner": {
              "x": 38.558,
              "y": 8.3178,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.612,
              "y": 8.3829,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120082220668"
          },
          {
            "id": "679afb3e3d9bab0f83ff6013",
            "leftCorner": {
              "x": 38.612,
              "y": 8.3829,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.654,
              "y": 8.4342,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112228732"
          },
          {
            "id": "679afb3e3d9bab0f83ff6014",
            "leftCorner": {
              "x": 38.654,
              "y": 8.4342,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.696,
              "y": 8.4848,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112223157"
          },
          {
            "id": "679afb3e3d9bab0f83ff6015",
            "leftCorner": {
              "x": 38.696,
              "y": 8.4848,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.749,
              "y": 8.5494,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226813"
          },
          {
            "id": "679afb3e3d9bab0f83ff6016",
            "leftCorner": {
              "x": 38.749,
              "y": 8.5494,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.795,
              "y": 8.6048,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226783"
          },
          {
            "id": "679afb3e3d9bab0f83ff6017",
            "leftCorner": {
              "x": 38.795,
              "y": 8.6048,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.833,
              "y": 8.6511,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229005"
          },
          {
            "id": "679afb3e3d9bab0f83ff6018",
            "leftCorner": {
              "x": 38.833,
              "y": 8.6511,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.872,
              "y": 8.6981,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226905"
          },
          {
            "id": "679afb3e3d9bab0f83ff6019",
            "leftCorner": {
              "x": 38.872,
              "y": 8.6981,
              "z": 1.1749
            },
            "rightCorner": {
              "x": 38.905,
              "y": 8.7381,
              "z": 1.1749
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226905"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad17",
        "height": 1.428,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fb0",
            "leftCorner": {
              "x": 38.256,
              "y": 7.9583,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.337,
              "y": 8.0562,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524162528"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb1",
            "leftCorner": {
              "x": 38.337,
              "y": 8.0564,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.412,
              "y": 8.1472,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130821267"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb2",
            "leftCorner": {
              "x": 38.412,
              "y": 8.1472,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.465,
              "y": 8.2124,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130821298"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb3",
            "leftCorner": {
              "x": 38.465,
              "y": 8.2124,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.51,
              "y": 8.2668,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130821236"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb4",
            "leftCorner": {
              "x": 38.51,
              "y": 8.2668,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.562,
              "y": 8.3299,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112225526"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb5",
            "leftCorner": {
              "x": 38.562,
              "y": 8.3299,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.615,
              "y": 8.394,
              "z": 1.428
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9120130820253"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb6",
            "leftCorner": {
              "x": 38.615,
              "y": 8.394,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.66,
              "y": 8.4481,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112228824"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb7",
            "leftCorner": {
              "x": 38.66,
              "y": 8.4481,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.707,
              "y": 8.5061,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112225557"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb8",
            "leftCorner": {
              "x": 38.707,
              "y": 8.5061,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.761,
              "y": 8.5708,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112222839"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fb9",
            "leftCorner": {
              "x": 38.761,
              "y": 8.5708,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.813,
              "y": 8.6338,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120058169496"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fba",
            "leftCorner": {
              "x": 38.813,
              "y": 8.6338,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.856,
              "y": 8.6868,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112222891"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fbb",
            "leftCorner": {
              "x": 38.856,
              "y": 8.6868,
              "z": 1.428
            },
            "rightCorner": {
              "x": 38.898,
              "y": 8.7368,
              "z": 1.428
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112226509"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 62,
      "unknownStockCount": 16
    },
    "name": "HY2A",
    "leftNeighborShelfId": "OLCA",
    "rightNeighborShelfId": "R1N8"
  },
  {
    "id": "15PT",
    "x": 38.92,
    "y": 8.724,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.43451,
      "w": 0.90067
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad21",
        "height": 0.1528,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5ebd",
            "leftCorner": {
              "x": 39.032,
              "y": 8.7117,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.108,
              "y": 8.8065,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447208788"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ebe",
            "leftCorner": {
              "x": 39.108,
              "y": 8.8065,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.173,
              "y": 8.8882,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172428234"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ebf",
            "leftCorner": {
              "x": 39.173,
              "y": 8.8882,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.198,
              "y": 8.9202,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447502411"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec0",
            "leftCorner": {
              "x": 39.198,
              "y": 8.9202,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.313,
              "y": 9.0642,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447161519"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec1",
            "leftCorner": {
              "x": 39.313,
              "y": 9.0642,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.347,
              "y": 9.1072,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447302189"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec2",
            "leftCorner": {
              "x": 39.347,
              "y": 9.1072,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.393,
              "y": 9.1649,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000050"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec3",
            "leftCorner": {
              "x": 39.393,
              "y": 9.1649,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.44,
              "y": 9.2247,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447598834"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec4",
            "leftCorner": {
              "x": 39.44,
              "y": 9.2247,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.48,
              "y": 9.275,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107036"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec5",
            "leftCorner": {
              "x": 39.48,
              "y": 9.275,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.519,
              "y": 9.323,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215571"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec6",
            "leftCorner": {
              "x": 39.519,
              "y": 9.323,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.539,
              "y": 9.3486,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172493164"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec7",
            "leftCorner": {
              "x": 39.539,
              "y": 9.3486,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.582,
              "y": 9.403,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237207"
          },
          {
            "id": "679afb3e3d9bab0f83ff5ec8",
            "leftCorner": {
              "x": 39.582,
              "y": 9.403,
              "z": 0.1528
            },
            "rightCorner": {
              "x": 39.614,
              "y": 9.4432,
              "z": 0.1528
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447302097"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad1e",
        "height": 0.416,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff606a",
            "leftCorner": {
              "x": 38.908,
              "y": 8.7375,
              "z": 0.416
            },
            "rightCorner": {
              "x": 38.958,
              "y": 8.7976,
              "z": 0.416
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172996993"
          },
          {
            "id": "679afb3e3d9bab0f83ff606b",
            "leftCorner": {
              "x": 38.957,
              "y": 8.7985,
              "z": 0.416
            },
            "rightCorner": {
              "x": 38.999,
              "y": 8.8503,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447103151"
          },
          {
            "id": "679afb3e3d9bab0f83ff606c",
            "leftCorner": {
              "x": 38.998,
              "y": 8.8511,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.091,
              "y": 8.9678,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447502930"
          },
          {
            "id": "679afb3e3d9bab0f83ff606d",
            "leftCorner": {
              "x": 39.091,
              "y": 8.9678,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.133,
              "y": 9.0205,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172681677"
          },
          {
            "id": "679afb3e3d9bab0f83ff606e",
            "leftCorner": {
              "x": 39.133,
              "y": 9.0205,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.168,
              "y": 9.0637,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000054"
          },
          {
            "id": "679afb3e3d9bab0f83ff606f",
            "leftCorner": {
              "x": 39.168,
              "y": 9.0637,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.21,
              "y": 9.1167,
              "z": 0.416
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447321395"
          },
          {
            "id": "679afb3e3d9bab0f83ff6070",
            "leftCorner": {
              "x": 39.21,
              "y": 9.1167,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.24,
              "y": 9.1548,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447103175"
          },
          {
            "id": "679afb3e3d9bab0f83ff6071",
            "leftCorner": {
              "x": 39.24,
              "y": 9.1548,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.268,
              "y": 9.1894,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447103175"
          },
          {
            "id": "679afb3e3d9bab0f83ff6072",
            "leftCorner": {
              "x": 39.268,
              "y": 9.1894,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.304,
              "y": 9.2357,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447434040"
          },
          {
            "id": "679afb3e3d9bab0f83ff6073",
            "leftCorner": {
              "x": 39.304,
              "y": 9.2357,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.349,
              "y": 9.2924,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172783067"
          },
          {
            "id": "679afb3e3d9bab0f83ff6074",
            "leftCorner": {
              "x": 39.349,
              "y": 9.2924,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.396,
              "y": 9.3507,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447103779"
          },
          {
            "id": "679afb3e3d9bab0f83ff6075",
            "leftCorner": {
              "x": 39.396,
              "y": 9.3507,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.46,
              "y": 9.4309,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447705485"
          },
          {
            "id": "679afb3e3d9bab0f83ff6076",
            "leftCorner": {
              "x": 39.46,
              "y": 9.4309,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.491,
              "y": 9.4707,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215397"
          },
          {
            "id": "679afb3e3d9bab0f83ff6077",
            "leftCorner": {
              "x": 39.491,
              "y": 9.4707,
              "z": 0.416
            },
            "rightCorner": {
              "x": 39.523,
              "y": 9.5109,
              "z": 0.416
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172783173"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad1d",
        "height": 0.66924,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f6a",
            "leftCorner": {
              "x": 38.904,
              "y": 8.7364,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 38.938,
              "y": 8.7772,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f6b",
            "leftCorner": {
              "x": 38.937,
              "y": 8.7778,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.024,
              "y": 8.8877,
              "z": 0.66924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051424570019"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f6c",
            "leftCorner": {
              "x": 39.024,
              "y": 8.8877,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.121,
              "y": 9.0086,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447216028"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f6d",
            "leftCorner": {
              "x": 39.121,
              "y": 9.0086,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.209,
              "y": 9.1201,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447215878"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f6e",
            "leftCorner": {
              "x": 39.209,
              "y": 9.1201,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.26,
              "y": 9.1838,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447215823"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f6f",
            "leftCorner": {
              "x": 39.26,
              "y": 9.1838,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.294,
              "y": 9.2265,
              "z": 0.66924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215854"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f70",
            "leftCorner": {
              "x": 39.294,
              "y": 9.2265,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.329,
              "y": 9.2708,
              "z": 0.66924
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000011"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f71",
            "leftCorner": {
              "x": 39.329,
              "y": 9.2708,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.427,
              "y": 9.3933,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447503265"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f23",
            "leftCorner": {
              "x": 39.427,
              "y": 9.3933,
              "z": 0.66924
            },
            "rightCorner": {
              "x": 39.527,
              "y": 9.5191,
              "z": 0.66924
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447241334"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad1c",
        "height": 0.91894,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5f16",
            "leftCorner": {
              "x": 38.912,
              "y": 8.7427,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 38.97,
              "y": 8.8134,
              "z": 0.91894
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457653508"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f17",
            "leftCorner": {
              "x": 38.969,
              "y": 8.8144,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.005,
              "y": 8.8584,
              "z": 0.91894
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457653492"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f18",
            "leftCorner": {
              "x": 39.004,
              "y": 8.859,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.024,
              "y": 8.883,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457653492"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f19",
            "leftCorner": {
              "x": 39.023,
              "y": 8.8833,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.119,
              "y": 9.0031,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457649235"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1a",
            "leftCorner": {
              "x": 39.119,
              "y": 9.0031,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.163,
              "y": 9.0596,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457649204"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1b",
            "leftCorner": {
              "x": 39.163,
              "y": 9.0596,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.209,
              "y": 9.1166,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457658190"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1c",
            "leftCorner": {
              "x": 39.209,
              "y": 9.1166,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.253,
              "y": 9.1724,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457658220"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1d",
            "leftCorner": {
              "x": 39.253,
              "y": 9.1724,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.297,
              "y": 9.2281,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457635641"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1e",
            "leftCorner": {
              "x": 39.297,
              "y": 9.2281,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.331,
              "y": 9.2701,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457639588"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f1f",
            "leftCorner": {
              "x": 39.331,
              "y": 9.2701,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.375,
              "y": 9.3252,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457658718"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f20",
            "leftCorner": {
              "x": 39.375,
              "y": 9.3252,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.444,
              "y": 9.4118,
              "z": 0.91894
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457658749"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f21",
            "leftCorner": {
              "x": 39.444,
              "y": 9.4118,
              "z": 0.91894
            },
            "rightCorner": {
              "x": 39.524,
              "y": 9.5124,
              "z": 0.91894
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457658770"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad20",
        "height": 1.1753,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff601a",
            "leftCorner": {
              "x": 38.914,
              "y": 8.7466,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 38.934,
              "y": 8.7713,
              "z": 1.1753
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff601b",
            "leftCorner": {
              "x": 38.934,
              "y": 8.7713,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.02,
              "y": 8.879,
              "z": 1.1753
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457649945"
          },
          {
            "id": "679afb3e3d9bab0f83ff601c",
            "leftCorner": {
              "x": 39.02,
              "y": 8.879,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.105,
              "y": 8.9859,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457638369"
          },
          {
            "id": "679afb3e3d9bab0f83ff601d",
            "leftCorner": {
              "x": 39.105,
              "y": 8.9859,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.149,
              "y": 9.0418,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457638338"
          },
          {
            "id": "679afb3e3d9bab0f83ff601e",
            "leftCorner": {
              "x": 39.149,
              "y": 9.0418,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.2,
              "y": 9.1059,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457638512"
          },
          {
            "id": "679afb3e3d9bab0f83ff601f",
            "leftCorner": {
              "x": 39.2,
              "y": 9.1059,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.265,
              "y": 9.1875,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457637478"
          },
          {
            "id": "679afb3e3d9bab0f83ff6020",
            "leftCorner": {
              "x": 39.265,
              "y": 9.1875,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.296,
              "y": 9.2265,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638500050"
          },
          {
            "id": "679afb3e3d9bab0f83ff6021",
            "leftCorner": {
              "x": 39.296,
              "y": 9.2265,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.329,
              "y": 9.2684,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638500050"
          },
          {
            "id": "679afb3e3d9bab0f83ff6022",
            "leftCorner": {
              "x": 39.329,
              "y": 9.2684,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.402,
              "y": 9.3592,
              "z": 1.1753
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457660230"
          },
          {
            "id": "679afb3e3d9bab0f83ff6023",
            "leftCorner": {
              "x": 39.402,
              "y": 9.3592,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.489,
              "y": 9.4693,
              "z": 1.1753
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638590082"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc8",
            "leftCorner": {
              "x": 39.489,
              "y": 9.4693,
              "z": 1.1753
            },
            "rightCorner": {
              "x": 39.528,
              "y": 9.5181,
              "z": 1.1753
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7611916163890"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad1f",
        "height": 1.4288,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff5fbc",
            "leftCorner": {
              "x": 38.905,
              "y": 8.747,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 38.953,
              "y": 8.8047,
              "z": 1.4288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638093989"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fbd",
            "leftCorner": {
              "x": 38.952,
              "y": 8.8055,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 38.984,
              "y": 8.8444,
              "z": 1.4288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638501491"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fbe",
            "leftCorner": {
              "x": 38.983,
              "y": 8.845,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.001,
              "y": 8.8665,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638501491"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fbf",
            "leftCorner": {
              "x": 39,
              "y": 8.8668,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.07,
              "y": 8.9538,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7611916558382"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc0",
            "leftCorner": {
              "x": 39.07,
              "y": 8.9538,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.12,
              "y": 9.0169,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7611916558399"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc1",
            "leftCorner": {
              "x": 39.12,
              "y": 9.0169,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.17,
              "y": 9.0804,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638579995"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc2",
            "leftCorner": {
              "x": 39.17,
              "y": 9.0804,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.223,
              "y": 9.1462,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638580045"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc3",
            "leftCorner": {
              "x": 39.223,
              "y": 9.1462,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.274,
              "y": 9.2106,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638580090"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc4",
            "leftCorner": {
              "x": 39.274,
              "y": 9.2106,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.327,
              "y": 9.2775,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7611916163227"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc5",
            "leftCorner": {
              "x": 39.327,
              "y": 9.2775,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.379,
              "y": 9.3427,
              "z": 1.4288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7611916163234"
          },
          {
            "id": "679afb3e3d9bab0f83ff5fc6",
            "leftCorner": {
              "x": 39.379,
              "y": 9.3427,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.454,
              "y": 9.4371,
              "z": 1.4288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7611916163241"
          },
          {
            "id": "679afb3e3d9bab0f83ff5f73",
            "leftCorner": {
              "x": 39.454,
              "y": 9.4371,
              "z": 1.4288
            },
            "rightCorner": {
              "x": 39.522,
              "y": 9.5227,
              "z": 1.4288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638590105"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 51,
      "unknownStockCount": 18
    },
    "name": "15PT",
    "leftNeighborShelfId": "WZMI",
    "rightNeighborShelfId": "GS2V"
  },
  {
    "id": "FR98",
    "x": 42.466,
    "y": 10.088,
    "width": 0.625,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.87698,
      "w": -0.48052
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad26",
        "height": 0.15911,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61f3",
            "leftCorner": {
              "x": 42.366,
              "y": 10.113,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.33,
              "y": 10.056,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f4",
            "leftCorner": {
              "x": 42.33,
              "y": 10.056,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.314,
              "y": 10.03,
              "z": 0.15911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f5",
            "leftCorner": {
              "x": 42.314,
              "y": 10.03,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.273,
              "y": 9.9664,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377040"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f6",
            "leftCorner": {
              "x": 42.273,
              "y": 9.9664,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.237,
              "y": 9.91,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377040"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f7",
            "leftCorner": {
              "x": 42.237,
              "y": 9.91,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.198,
              "y": 9.8488,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377040"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f8",
            "leftCorner": {
              "x": 42.198,
              "y": 9.8488,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.147,
              "y": 9.7698,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f9",
            "leftCorner": {
              "x": 42.147,
              "y": 9.7698,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.096,
              "y": 9.69,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61fa",
            "leftCorner": {
              "x": 42.096,
              "y": 9.69,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.057,
              "y": 9.6277,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383676"
          },
          {
            "id": "679afb3e3d9bab0f83ff61fb",
            "leftCorner": {
              "x": 42.057,
              "y": 9.6277,
              "z": 0.15911
            },
            "rightCorner": {
              "x": 42.032,
              "y": 9.5896,
              "z": 0.15911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad28",
        "height": 0.42006,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff622e",
            "leftCorner": {
              "x": 42.482,
              "y": 10.078,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.461,
              "y": 10.045,
              "z": 0.42006
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6230",
            "leftCorner": {
              "x": 42.461,
              "y": 10.045,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.412,
              "y": 9.9677,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6231",
            "leftCorner": {
              "x": 42.412,
              "y": 9.9677,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.364,
              "y": 9.8923,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383713"
          },
          {
            "id": "679afb3f3d9bab0f83ff6232",
            "leftCorner": {
              "x": 42.364,
              "y": 9.8923,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.31,
              "y": 9.8082,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383713"
          },
          {
            "id": "679afb3f3d9bab0f83ff6233",
            "leftCorner": {
              "x": 42.31,
              "y": 9.8082,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.262,
              "y": 9.7332,
              "z": 0.42006
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447383713"
          },
          {
            "id": "679afb3f3d9bab0f83ff6234",
            "leftCorner": {
              "x": 42.262,
              "y": 9.7332,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.212,
              "y": 9.6551,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383713"
          },
          {
            "id": "679afb3f3d9bab0f83ff6235",
            "leftCorner": {
              "x": 42.212,
              "y": 9.6551,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.164,
              "y": 9.5799,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383713"
          },
          {
            "id": "679afb3f3d9bab0f83ff6236",
            "leftCorner": {
              "x": 42.164,
              "y": 9.5799,
              "z": 0.42006
            },
            "rightCorner": {
              "x": 42.145,
              "y": 9.5501,
              "z": 0.42006
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad22",
        "height": 0.67373,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61aa",
            "leftCorner": {
              "x": 42.47,
              "y": 10.057,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.424,
              "y": 9.9833,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377101"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ab",
            "leftCorner": {
              "x": 42.424,
              "y": 9.9833,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.371,
              "y": 9.9005,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377101"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ac",
            "leftCorner": {
              "x": 42.371,
              "y": 9.9005,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.324,
              "y": 9.8271,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377101"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ad",
            "leftCorner": {
              "x": 42.324,
              "y": 9.8271,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.273,
              "y": 9.7475,
              "z": 0.67373
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000055"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ae",
            "leftCorner": {
              "x": 42.273,
              "y": 9.7475,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.221,
              "y": 9.6667,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376920"
          },
          {
            "id": "679afb3e3d9bab0f83ff61af",
            "leftCorner": {
              "x": 42.221,
              "y": 9.6667,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.17,
              "y": 9.5857,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376920"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b0",
            "leftCorner": {
              "x": 42.17,
              "y": 9.5857,
              "z": 0.67373
            },
            "rightCorner": {
              "x": 42.136,
              "y": 9.5331,
              "z": 0.67373
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad24",
        "height": 0.92551,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61cd",
            "leftCorner": {
              "x": 42.483,
              "y": 10.077,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.455,
              "y": 10.033,
              "z": 0.92551
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61cf",
            "leftCorner": {
              "x": 42.455,
              "y": 10.033,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.38,
              "y": 9.9144,
              "z": 0.92551
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758417787"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d0",
            "leftCorner": {
              "x": 42.38,
              "y": 9.9144,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.299,
              "y": 9.788,
              "z": 0.92551
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251758417763"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d1",
            "leftCorner": {
              "x": 42.299,
              "y": 9.788,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.255,
              "y": 9.7186,
              "z": 0.92551
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758417961"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d2",
            "leftCorner": {
              "x": 42.255,
              "y": 9.7186,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.208,
              "y": 9.645,
              "z": 0.92551
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251758417947"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d3",
            "leftCorner": {
              "x": 42.208,
              "y": 9.645,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.162,
              "y": 9.5741,
              "z": 0.92551
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d4",
            "leftCorner": {
              "x": 42.162,
              "y": 9.5741,
              "z": 0.92551
            },
            "rightCorner": {
              "x": 42.145,
              "y": 9.5476,
              "z": 0.92551
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad23",
        "height": 1.1763,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61bd",
            "leftCorner": {
              "x": 42.484,
              "y": 10.078,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.448,
              "y": 10.021,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796137668"
          },
          {
            "id": "679afb3e3d9bab0f83ff61be",
            "leftCorner": {
              "x": 42.448,
              "y": 10.021,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.408,
              "y": 9.96,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796137668"
          },
          {
            "id": "679afb3e3d9bab0f83ff61bf",
            "leftCorner": {
              "x": 42.408,
              "y": 9.96,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.374,
              "y": 9.9064,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447336955"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c0",
            "leftCorner": {
              "x": 42.374,
              "y": 9.9064,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.345,
              "y": 9.8605,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447336955"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c1",
            "leftCorner": {
              "x": 42.345,
              "y": 9.8605,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.306,
              "y": 9.7998,
              "z": 1.1763
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260307631161"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c2",
            "leftCorner": {
              "x": 42.306,
              "y": 9.7998,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.292,
              "y": 9.7776,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307631246"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c3",
            "leftCorner": {
              "x": 42.292,
              "y": 9.7776,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.273,
              "y": 9.7473,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307631246"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c4",
            "leftCorner": {
              "x": 42.273,
              "y": 9.7473,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.235,
              "y": 9.6885,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307631208"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c5",
            "leftCorner": {
              "x": 42.235,
              "y": 9.6885,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.183,
              "y": 9.6065,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c6",
            "leftCorner": {
              "x": 42.183,
              "y": 9.6065,
              "z": 1.1763
            },
            "rightCorner": {
              "x": 42.111,
              "y": 9.4945,
              "z": 1.1763
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376906"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad25",
        "height": 1.4301,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61e2",
            "leftCorner": {
              "x": 42.483,
              "y": 10.076,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.449,
              "y": 10.023,
              "z": 1.4301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800001008"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e3",
            "leftCorner": {
              "x": 42.449,
              "y": 10.023,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.41,
              "y": 9.9619,
              "z": 1.4301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800004603"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e4",
            "leftCorner": {
              "x": 42.41,
              "y": 9.9619,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.307,
              "y": 9.8003,
              "z": 1.4301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704761"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e5",
            "leftCorner": {
              "x": 42.307,
              "y": 9.8003,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.201,
              "y": 9.6347,
              "z": 1.4301
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447704747"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e6",
            "leftCorner": {
              "x": 42.201,
              "y": 9.6347,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.155,
              "y": 9.5616,
              "z": 1.4301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900939616"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e7",
            "leftCorner": {
              "x": 42.155,
              "y": 9.5616,
              "z": 1.4301
            },
            "rightCorner": {
              "x": 42.136,
              "y": 9.5319,
              "z": 1.4301
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900939616"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 39,
      "unknownStockCount": 8
    },
    "name": "FR98",
    "leftNeighborShelfId": "3R6D",
    "rightNeighborShelfId": "S8LF"
  },
  {
    "id": "4G76",
    "x": 42.1,
    "y": 9.5165,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.87974,
      "w": -0.47545
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad2d",
        "height": 0.15835,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61fc",
            "leftCorner": {
              "x": 42.004,
              "y": 9.5456,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.956,
              "y": 9.4726,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61fd",
            "leftCorner": {
              "x": 41.956,
              "y": 9.4726,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.907,
              "y": 9.3981,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61fe",
            "leftCorner": {
              "x": 41.907,
              "y": 9.3981,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.85,
              "y": 9.3096,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ff",
            "leftCorner": {
              "x": 41.85,
              "y": 9.3096,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.784,
              "y": 9.2102,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447377088"
          },
          {
            "id": "679afb3e3d9bab0f83ff6200",
            "leftCorner": {
              "x": 41.784,
              "y": 9.2102,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.731,
              "y": 9.128,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6201",
            "leftCorner": {
              "x": 41.731,
              "y": 9.128,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.671,
              "y": 9.0364,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6202",
            "leftCorner": {
              "x": 41.671,
              "y": 9.0364,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.622,
              "y": 8.9627,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499115998"
          },
          {
            "id": "679afb3f3d9bab0f83ff6203",
            "leftCorner": {
              "x": 41.622,
              "y": 8.9627,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.58,
              "y": 8.8988,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499115998"
          },
          {
            "id": "679afb3f3d9bab0f83ff6204",
            "leftCorner": {
              "x": 41.58,
              "y": 8.8988,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.537,
              "y": 8.8323,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499957482"
          },
          {
            "id": "679afb3f3d9bab0f83ff6205",
            "leftCorner": {
              "x": 41.537,
              "y": 8.8323,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.483,
              "y": 8.7504,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001499111198"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad2e",
        "height": 0.41822,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6237",
            "leftCorner": {
              "x": 42.112,
              "y": 9.5078,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 42.061,
              "y": 9.4296,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447008135"
          },
          {
            "id": "679afb3f3d9bab0f83ff6238",
            "leftCorner": {
              "x": 42.061,
              "y": 9.4296,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 42.012,
              "y": 9.3553,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447008135"
          },
          {
            "id": "679afb3f3d9bab0f83ff6239",
            "leftCorner": {
              "x": 42.012,
              "y": 9.3553,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.962,
              "y": 9.2789,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff623a",
            "leftCorner": {
              "x": 41.962,
              "y": 9.2789,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.913,
              "y": 9.2042,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769685"
          },
          {
            "id": "679afb3f3d9bab0f83ff623b",
            "leftCorner": {
              "x": 41.913,
              "y": 9.2042,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.859,
              "y": 9.122,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769685"
          },
          {
            "id": "679afb3f3d9bab0f83ff623c",
            "leftCorner": {
              "x": 41.859,
              "y": 9.122,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.807,
              "y": 9.0416,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769685"
          },
          {
            "id": "679afb3f3d9bab0f83ff623d",
            "leftCorner": {
              "x": 41.807,
              "y": 9.0416,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.76,
              "y": 8.9709,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769685"
          },
          {
            "id": "679afb3f3d9bab0f83ff623e",
            "leftCorner": {
              "x": 41.76,
              "y": 8.9709,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.711,
              "y": 8.8954,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769708"
          },
          {
            "id": "679afb3f3d9bab0f83ff623f",
            "leftCorner": {
              "x": 41.711,
              "y": 8.8954,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.661,
              "y": 8.8194,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769708"
          },
          {
            "id": "679afb3f3d9bab0f83ff6240",
            "leftCorner": {
              "x": 41.661,
              "y": 8.8194,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.613,
              "y": 8.7456,
              "z": 0.41822
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447769708"
          },
          {
            "id": "679afb3f3d9bab0f83ff622f",
            "leftCorner": {
              "x": 41.613,
              "y": 8.7456,
              "z": 0.41822
            },
            "rightCorner": {
              "x": 41.564,
              "y": 8.6719,
              "z": 0.41822
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447769708"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad29",
        "height": 0.6738,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61b1",
            "leftCorner": {
              "x": 42.101,
              "y": 9.4918,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 42.068,
              "y": 9.4412,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b2",
            "leftCorner": {
              "x": 42.068,
              "y": 9.4412,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 42.033,
              "y": 9.3884,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796125092"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b3",
            "leftCorner": {
              "x": 42.033,
              "y": 9.3884,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 42,
              "y": 9.3369,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796125092"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b4",
            "leftCorner": {
              "x": 42,
              "y": 9.3369,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.955,
              "y": 9.2685,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000388179004"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b5",
            "leftCorner": {
              "x": 41.955,
              "y": 9.2685,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.902,
              "y": 9.1875,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808807017"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b6",
            "leftCorner": {
              "x": 41.902,
              "y": 9.1875,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.843,
              "y": 9.0979,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808807017"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b7",
            "leftCorner": {
              "x": 41.843,
              "y": 9.0979,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.777,
              "y": 8.9962,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260307629779"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b8",
            "leftCorner": {
              "x": 41.777,
              "y": 8.9962,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.717,
              "y": 8.9058,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448101901"
          },
          {
            "id": "679afb3e3d9bab0f83ff61b9",
            "leftCorner": {
              "x": 41.717,
              "y": 8.9058,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.657,
              "y": 8.8135,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448101901"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ba",
            "leftCorner": {
              "x": 41.657,
              "y": 8.8135,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.627,
              "y": 8.7683,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4400086010133"
          },
          {
            "id": "679afb3e3d9bab0f83ff61bb",
            "leftCorner": {
              "x": 41.627,
              "y": 8.7683,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.594,
              "y": 8.7177,
              "z": 0.6738
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4400086010133"
          },
          {
            "id": "679afb3e3d9bab0f83ff61a9",
            "leftCorner": {
              "x": 41.594,
              "y": 8.7177,
              "z": 0.6738
            },
            "rightCorner": {
              "x": 41.564,
              "y": 8.672,
              "z": 0.6738
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4400086010133"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad2a",
        "height": 0.9237,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61d5",
            "leftCorner": {
              "x": 42.111,
              "y": 9.5056,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 42.065,
              "y": 9.4344,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448101635"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d6",
            "leftCorner": {
              "x": 42.065,
              "y": 9.4344,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 42.018,
              "y": 9.3622,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808807000"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d7",
            "leftCorner": {
              "x": 42.018,
              "y": 9.3622,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.971,
              "y": 9.2917,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808807000"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d8",
            "leftCorner": {
              "x": 41.971,
              "y": 9.2917,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.933,
              "y": 9.2337,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378313"
          },
          {
            "id": "679afb3e3d9bab0f83ff61d9",
            "leftCorner": {
              "x": 41.933,
              "y": 9.2337,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.893,
              "y": 9.1723,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378313"
          },
          {
            "id": "679afb3e3d9bab0f83ff61da",
            "leftCorner": {
              "x": 41.893,
              "y": 9.1723,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.837,
              "y": 9.0872,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374278"
          },
          {
            "id": "679afb3e3d9bab0f83ff61db",
            "leftCorner": {
              "x": 41.837,
              "y": 9.0872,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.781,
              "y": 9.0012,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374278"
          },
          {
            "id": "679afb3e3d9bab0f83ff61dc",
            "leftCorner": {
              "x": 41.781,
              "y": 9.0012,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.735,
              "y": 8.9307,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383690"
          },
          {
            "id": "679afb3e3d9bab0f83ff61dd",
            "leftCorner": {
              "x": 41.735,
              "y": 8.9307,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.708,
              "y": 8.89,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383690"
          },
          {
            "id": "679afb3e3d9bab0f83ff61de",
            "leftCorner": {
              "x": 41.708,
              "y": 8.89,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.667,
              "y": 8.8276,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4036581537440"
          },
          {
            "id": "679afb3e3d9bab0f83ff61df",
            "leftCorner": {
              "x": 41.667,
              "y": 8.8276,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.626,
              "y": 8.7637,
              "z": 0.9237
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581536337"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e0",
            "leftCorner": {
              "x": 41.626,
              "y": 8.7637,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.59,
              "y": 8.7089,
              "z": 0.9237
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062196149839"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ce",
            "leftCorner": {
              "x": 41.59,
              "y": 8.7089,
              "z": 0.9237
            },
            "rightCorner": {
              "x": 41.565,
              "y": 8.6715,
              "z": 0.9237
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062196149839"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad2b",
        "height": 1.1779,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61c7",
            "leftCorner": {
              "x": 42.072,
              "y": 9.4559,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.93,
              "y": 9.2384,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591781"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c8",
            "leftCorner": {
              "x": 41.93,
              "y": 9.2384,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.863,
              "y": 9.1366,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237948"
          },
          {
            "id": "679afb3e3d9bab0f83ff61c9",
            "leftCorner": {
              "x": 41.863,
              "y": 9.1366,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.804,
              "y": 9.0464,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237948"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ca",
            "leftCorner": {
              "x": 41.804,
              "y": 9.0464,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.746,
              "y": 8.9588,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237948"
          },
          {
            "id": "679afb3e3d9bab0f83ff61cb",
            "leftCorner": {
              "x": 41.746,
              "y": 8.9588,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.697,
              "y": 8.8839,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040030986"
          },
          {
            "id": "679afb3e3d9bab0f83ff61cc",
            "leftCorner": {
              "x": 41.697,
              "y": 8.8839,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.645,
              "y": 8.8032,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040524010"
          },
          {
            "id": "679afb3e3d9bab0f83ff61bc",
            "leftCorner": {
              "x": 41.645,
              "y": 8.8032,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 41.56,
              "y": 8.6746,
              "z": 1.1779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000056"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad2c",
        "height": 1.4298,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff61e8",
            "leftCorner": {
              "x": 42.099,
              "y": 9.4919,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 42.05,
              "y": 9.417,
              "z": 1.4298
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4045612009412"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e9",
            "leftCorner": {
              "x": 42.05,
              "y": 9.417,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.997,
              "y": 9.3369,
              "z": 1.4298
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4045612009412"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ea",
            "leftCorner": {
              "x": 41.997,
              "y": 9.3369,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.948,
              "y": 9.2616,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789700069"
          },
          {
            "id": "679afb3e3d9bab0f83ff61eb",
            "leftCorner": {
              "x": 41.948,
              "y": 9.2616,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.898,
              "y": 9.185,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789700045"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ec",
            "leftCorner": {
              "x": 41.898,
              "y": 9.185,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.824,
              "y": 9.0721,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181481239"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ed",
            "leftCorner": {
              "x": 41.824,
              "y": 9.0721,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.788,
              "y": 9.0173,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048363"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ee",
            "leftCorner": {
              "x": 41.788,
              "y": 9.0173,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.754,
              "y": 8.9659,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040302014"
          },
          {
            "id": "679afb3e3d9bab0f83ff61ef",
            "leftCorner": {
              "x": 41.754,
              "y": 8.9659,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.717,
              "y": 8.9088,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447313611"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f0",
            "leftCorner": {
              "x": 41.717,
              "y": 8.9088,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.668,
              "y": 8.8347,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800005204"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f1",
            "leftCorner": {
              "x": 41.668,
              "y": 8.8347,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.623,
              "y": 8.7649,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447380545"
          },
          {
            "id": "679afb3e3d9bab0f83ff61e1",
            "leftCorner": {
              "x": 41.623,
              "y": 8.7649,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 41.562,
              "y": 8.6732,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447380545"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 56,
      "unknownStockCount": 6
    },
    "name": "4G76",
    "leftNeighborShelfId": "MF11",
    "rightNeighborShelfId": "J4M5"
  },
  {
    "id": "WZMI",
    "x": 41.557,
    "y": 8.6733,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.88234,
      "w": -0.47061
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad33",
        "height": 0.15866,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6206",
            "leftCorner": {
              "x": 41.483,
              "y": 8.7504,
              "z": 0.15835
            },
            "rightCorner": {
              "x": 41.447,
              "y": 8.6951,
              "z": 0.15835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181414282"
          },
          {
            "id": "679afb3f3d9bab0f83ff6207",
            "leftCorner": {
              "x": 41.444,
              "y": 8.6949,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.407,
              "y": 8.6387,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181085666"
          },
          {
            "id": "679afb3f3d9bab0f83ff6208",
            "leftCorner": {
              "x": 41.407,
              "y": 8.6387,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.369,
              "y": 8.5819,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181085642"
          },
          {
            "id": "679afb3f3d9bab0f83ff6209",
            "leftCorner": {
              "x": 41.369,
              "y": 8.5819,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.33,
              "y": 8.5249,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181085659"
          },
          {
            "id": "679afb3f3d9bab0f83ff620a",
            "leftCorner": {
              "x": 41.33,
              "y": 8.5249,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.293,
              "y": 8.4686,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000057"
          },
          {
            "id": "679afb3f3d9bab0f83ff620b",
            "leftCorner": {
              "x": 41.293,
              "y": 8.4686,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.254,
              "y": 8.4117,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181085710"
          },
          {
            "id": "679afb3f3d9bab0f83ff620c",
            "leftCorner": {
              "x": 41.254,
              "y": 8.4117,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.218,
              "y": 8.3582,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717163693162"
          },
          {
            "id": "679afb3f3d9bab0f83ff620d",
            "leftCorner": {
              "x": 41.218,
              "y": 8.3582,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.178,
              "y": 8.2984,
              "z": 0.15866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447670684"
          },
          {
            "id": "679afb3f3d9bab0f83ff620e",
            "leftCorner": {
              "x": 41.178,
              "y": 8.2984,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.141,
              "y": 8.2424,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378238"
          },
          {
            "id": "679afb3f3d9bab0f83ff620f",
            "leftCorner": {
              "x": 41.141,
              "y": 8.2424,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.106,
              "y": 8.1905,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378238"
          },
          {
            "id": "679afb3f3d9bab0f83ff6210",
            "leftCorner": {
              "x": 41.106,
              "y": 8.1905,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.065,
              "y": 8.1297,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366181"
          },
          {
            "id": "679afb3f3d9bab0f83ff6211",
            "leftCorner": {
              "x": 41.065,
              "y": 8.1297,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.037,
              "y": 8.0875,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366181"
          },
          {
            "id": "679afb3f3d9bab0f83ff6212",
            "leftCorner": {
              "x": 41.037,
              "y": 8.0875,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 41.004,
              "y": 8.0386,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467598"
          },
          {
            "id": "679afb3f3d9bab0f83ff6213",
            "leftCorner": {
              "x": 41.004,
              "y": 8.0386,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 40.976,
              "y": 7.9969,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467598"
          },
          {
            "id": "679afb3f3d9bab0f83ff6214",
            "leftCorner": {
              "x": 40.976,
              "y": 7.9969,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 40.94,
              "y": 7.9436,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447703016"
          },
          {
            "id": "679afb3f3d9bab0f83ff6215",
            "leftCorner": {
              "x": 40.94,
              "y": 7.9436,
              "z": 0.15866
            },
            "rightCorner": {
              "x": 40.907,
              "y": 7.8943,
              "z": 0.15866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad2f",
        "height": 0.46066,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6241",
            "leftCorner": {
              "x": 41.562,
              "y": 8.6698,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.512,
              "y": 8.5942,
              "z": 0.46066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541334496"
          },
          {
            "id": "679afb3f3d9bab0f83ff6243",
            "leftCorner": {
              "x": 41.512,
              "y": 8.5942,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.462,
              "y": 8.5207,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540299178"
          },
          {
            "id": "679afb3f3d9bab0f83ff6244",
            "leftCorner": {
              "x": 41.462,
              "y": 8.5207,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.412,
              "y": 8.4463,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541334458"
          },
          {
            "id": "679afb3f3d9bab0f83ff6245",
            "leftCorner": {
              "x": 41.412,
              "y": 8.4463,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.31,
              "y": 8.2933,
              "z": 0.46066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541544024"
          },
          {
            "id": "679afb3f3d9bab0f83ff6246",
            "leftCorner": {
              "x": 41.31,
              "y": 8.2933,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.208,
              "y": 8.1418,
              "z": 0.46066
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008970059990"
          },
          {
            "id": "679afb3f3d9bab0f83ff6247",
            "leftCorner": {
              "x": 41.208,
              "y": 8.1418,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.149,
              "y": 8.0542,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970005607"
          },
          {
            "id": "679afb3f3d9bab0f83ff6248",
            "leftCorner": {
              "x": 41.149,
              "y": 8.0542,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.115,
              "y": 8.0024,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401735196"
          },
          {
            "id": "679afb3f3d9bab0f83ff6249",
            "leftCorner": {
              "x": 41.115,
              "y": 8.0024,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.086,
              "y": 7.9597,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702189113"
          },
          {
            "id": "679afb3f3d9bab0f83ff624a",
            "leftCorner": {
              "x": 41.086,
              "y": 7.9597,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.057,
              "y": 7.9167,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702189076"
          },
          {
            "id": "679afb3f3d9bab0f83ff624b",
            "leftCorner": {
              "x": 41.057,
              "y": 7.9167,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 41.029,
              "y": 7.8748,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447672268"
          },
          {
            "id": "679afb3f3d9bab0f83ff624c",
            "leftCorner": {
              "x": 41.029,
              "y": 7.8748,
              "z": 0.46066
            },
            "rightCorner": {
              "x": 40.992,
              "y": 7.8198,
              "z": 0.46066
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447672268"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad31",
        "height": 0.75356,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6289",
            "leftCorner": {
              "x": 41.564,
              "y": 8.6687,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.525,
              "y": 8.6104,
              "z": 0.75356
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638500852"
          },
          {
            "id": "679afb3f3d9bab0f83ff628b",
            "leftCorner": {
              "x": 41.525,
              "y": 8.6104,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.49,
              "y": 8.5584,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638500807"
          },
          {
            "id": "679afb3f3d9bab0f83ff628c",
            "leftCorner": {
              "x": 41.49,
              "y": 8.5584,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.454,
              "y": 8.5053,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638500814"
          },
          {
            "id": "679afb3f3d9bab0f83ff628d",
            "leftCorner": {
              "x": 41.454,
              "y": 8.5053,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.425,
              "y": 8.4614,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523928"
          },
          {
            "id": "679afb3f3d9bab0f83ff628e",
            "leftCorner": {
              "x": 41.425,
              "y": 8.4614,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.396,
              "y": 8.4189,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447354317"
          },
          {
            "id": "679afb3f3d9bab0f83ff628f",
            "leftCorner": {
              "x": 41.396,
              "y": 8.4189,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.324,
              "y": 8.3109,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447354331"
          },
          {
            "id": "679afb3f3d9bab0f83ff6290",
            "leftCorner": {
              "x": 41.324,
              "y": 8.3109,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.234,
              "y": 8.1763,
              "z": 0.75356
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008233161266"
          },
          {
            "id": "679afb3f3d9bab0f83ff6291",
            "leftCorner": {
              "x": 41.234,
              "y": 8.1763,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.124,
              "y": 8.0131,
              "z": 0.75356
            },
            "stockLevel": "UNKNOWN",
            "gtin": "6001159111375"
          },
          {
            "id": "679afb3f3d9bab0f83ff6292",
            "leftCorner": {
              "x": 41.124,
              "y": 8.0131,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 41.003,
              "y": 7.8317,
              "z": 0.75356
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4045612009627"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad30",
        "height": 1.0457,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6265",
            "leftCorner": {
              "x": 41.564,
              "y": 8.6689,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.524,
              "y": 8.6095,
              "z": 1.0457
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447235791"
          },
          {
            "id": "679afb3f3d9bab0f83ff6267",
            "leftCorner": {
              "x": 41.524,
              "y": 8.6095,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.487,
              "y": 8.5541,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447354645"
          },
          {
            "id": "679afb3f3d9bab0f83ff6268",
            "leftCorner": {
              "x": 41.487,
              "y": 8.5541,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.45,
              "y": 8.4993,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523836"
          },
          {
            "id": "679afb3f3d9bab0f83ff6269",
            "leftCorner": {
              "x": 41.45,
              "y": 8.4993,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.413,
              "y": 8.445,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447787658"
          },
          {
            "id": "679afb3f3d9bab0f83ff626a",
            "leftCorner": {
              "x": 41.413,
              "y": 8.445,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.375,
              "y": 8.3885,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447787658"
          },
          {
            "id": "679afb3f3d9bab0f83ff626b",
            "leftCorner": {
              "x": 41.375,
              "y": 8.3885,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.285,
              "y": 8.2543,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447396553"
          },
          {
            "id": "679afb3f3d9bab0f83ff626c",
            "leftCorner": {
              "x": 41.285,
              "y": 8.2543,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.188,
              "y": 8.1087,
              "z": 1.0457
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447354232"
          },
          {
            "id": "679afb3f3d9bab0f83ff626d",
            "leftCorner": {
              "x": 41.188,
              "y": 8.1087,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.16,
              "y": 8.068,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447592160"
          },
          {
            "id": "679afb3f3d9bab0f83ff626e",
            "leftCorner": {
              "x": 41.16,
              "y": 8.068,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.129,
              "y": 8.0212,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff626f",
            "leftCorner": {
              "x": 41.129,
              "y": 8.0212,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.065,
              "y": 7.9252,
              "z": 1.0457
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447785548"
          },
          {
            "id": "679afb3f3d9bab0f83ff6270",
            "leftCorner": {
              "x": 41.065,
              "y": 7.9252,
              "z": 1.0457
            },
            "rightCorner": {
              "x": 41.007,
              "y": 7.8385,
              "z": 1.0457
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523812"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad32",
        "height": 1.3437,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62a8",
            "leftCorner": {
              "x": 41.562,
              "y": 8.6698,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.52,
              "y": 8.6071,
              "z": 1.3437
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457660322"
          },
          {
            "id": "679afb3f3d9bab0f83ff62aa",
            "leftCorner": {
              "x": 41.52,
              "y": 8.6071,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.485,
              "y": 8.5548,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457637485"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ab",
            "leftCorner": {
              "x": 41.485,
              "y": 8.5548,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.451,
              "y": 8.504,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457637416"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ac",
            "leftCorner": {
              "x": 41.451,
              "y": 8.504,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.416,
              "y": 8.4523,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457637416"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ad",
            "leftCorner": {
              "x": 41.416,
              "y": 8.4523,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.376,
              "y": 8.3918,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638529372"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ae",
            "leftCorner": {
              "x": 41.376,
              "y": 8.3918,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.337,
              "y": 8.3344,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638529396"
          },
          {
            "id": "679afb3f3d9bab0f83ff62af",
            "leftCorner": {
              "x": 41.337,
              "y": 8.3344,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.298,
              "y": 8.2752,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638529389"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b0",
            "leftCorner": {
              "x": 41.298,
              "y": 8.2752,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.251,
              "y": 8.2052,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638526708"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b1",
            "leftCorner": {
              "x": 41.251,
              "y": 8.2052,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.194,
              "y": 8.1203,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447235210"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b2",
            "leftCorner": {
              "x": 41.194,
              "y": 8.1203,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.152,
              "y": 8.0581,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551033204"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b3",
            "leftCorner": {
              "x": 41.152,
              "y": 8.0581,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.107,
              "y": 7.9909,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551033129"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b4",
            "leftCorner": {
              "x": 41.107,
              "y": 7.9909,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.066,
              "y": 7.9305,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551101750"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b5",
            "leftCorner": {
              "x": 41.066,
              "y": 7.9305,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 41.026,
              "y": 7.8704,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551101750"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b6",
            "leftCorner": {
              "x": 41.026,
              "y": 7.8704,
              "z": 1.3437
            },
            "rightCorner": {
              "x": 40.993,
              "y": 7.8214,
              "z": 1.3437
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 49,
      "unknownStockCount": 12
    },
    "name": "WZMI",
    "leftNeighborShelfId": "MM45",
    "rightNeighborShelfId": "15PT"
  },
  {
    "id": "OLCA",
    "x": 40.996,
    "y": 7.8274,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.88186,
      "w": -0.47151
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad37",
        "height": 0.15775,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6216",
            "leftCorner": {
              "x": 40.903,
              "y": 7.8793,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.837,
              "y": 7.7808,
              "z": 0.15775
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109436"
          },
          {
            "id": "679afb3f3d9bab0f83ff6217",
            "leftCorner": {
              "x": 40.837,
              "y": 7.7808,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.772,
              "y": 7.6834,
              "z": 0.15775
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109436"
          },
          {
            "id": "679afb3f3d9bab0f83ff6218",
            "leftCorner": {
              "x": 40.772,
              "y": 7.6834,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.742,
              "y": 7.6393,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277050"
          },
          {
            "id": "679afb3f3d9bab0f83ff6219",
            "leftCorner": {
              "x": 40.742,
              "y": 7.6393,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.71,
              "y": 7.5917,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670752"
          },
          {
            "id": "679afb3f3d9bab0f83ff621a",
            "leftCorner": {
              "x": 40.71,
              "y": 7.5917,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.679,
              "y": 7.5445,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670752"
          },
          {
            "id": "679afb3f3d9bab0f83ff621b",
            "leftCorner": {
              "x": 40.679,
              "y": 7.5445,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.648,
              "y": 7.4986,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670752"
          },
          {
            "id": "679afb3f3d9bab0f83ff621c",
            "leftCorner": {
              "x": 40.648,
              "y": 7.4986,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.618,
              "y": 7.453,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670752"
          },
          {
            "id": "679afb3f3d9bab0f83ff621d",
            "leftCorner": {
              "x": 40.618,
              "y": 7.453,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.591,
              "y": 7.4133,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670745"
          },
          {
            "id": "679afb3f3d9bab0f83ff621e",
            "leftCorner": {
              "x": 40.591,
              "y": 7.4133,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.56,
              "y": 7.3661,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670745"
          },
          {
            "id": "679afb3f3d9bab0f83ff621f",
            "leftCorner": {
              "x": 40.56,
              "y": 7.3661,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.513,
              "y": 7.2963,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109450"
          },
          {
            "id": "679afb3f3d9bab0f83ff6220",
            "leftCorner": {
              "x": 40.513,
              "y": 7.2963,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.457,
              "y": 7.2121,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366082"
          },
          {
            "id": "679afb3f3d9bab0f83ff6221",
            "leftCorner": {
              "x": 40.457,
              "y": 7.2121,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.406,
              "y": 7.1366,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366020"
          },
          {
            "id": "679afb3f3d9bab0f83ff6222",
            "leftCorner": {
              "x": 40.406,
              "y": 7.1366,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.359,
              "y": 7.065,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366020"
          },
          {
            "id": "679afb3f3d9bab0f83ff6223",
            "leftCorner": {
              "x": 40.359,
              "y": 7.065,
              "z": 0.15775
            },
            "rightCorner": {
              "x": 40.324,
              "y": 7.0128,
              "z": 0.15775
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad38",
        "height": 0.46149,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff624d",
            "leftCorner": {
              "x": 40.987,
              "y": 7.8057,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.947,
              "y": 7.7461,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670578"
          },
          {
            "id": "679afb3f3d9bab0f83ff624e",
            "leftCorner": {
              "x": 40.947,
              "y": 7.7461,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.919,
              "y": 7.7039,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670578"
          },
          {
            "id": "679afb3f3d9bab0f83ff624f",
            "leftCorner": {
              "x": 40.919,
              "y": 7.7039,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.887,
              "y": 7.6561,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671964"
          },
          {
            "id": "679afb3f3d9bab0f83ff6250",
            "leftCorner": {
              "x": 40.887,
              "y": 7.6561,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.853,
              "y": 7.6062,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671964"
          },
          {
            "id": "679afb3f3d9bab0f83ff6251",
            "leftCorner": {
              "x": 40.853,
              "y": 7.6062,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.82,
              "y": 7.5566,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439915"
          },
          {
            "id": "679afb3f3d9bab0f83ff6252",
            "leftCorner": {
              "x": 40.82,
              "y": 7.5566,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.783,
              "y": 7.5004,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439601"
          },
          {
            "id": "679afb3f3d9bab0f83ff6253",
            "leftCorner": {
              "x": 40.783,
              "y": 7.5004,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.746,
              "y": 7.4455,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439564"
          },
          {
            "id": "679afb3f3d9bab0f83ff6254",
            "leftCorner": {
              "x": 40.746,
              "y": 7.4455,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.706,
              "y": 7.3861,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439564"
          },
          {
            "id": "679afb3f3d9bab0f83ff6255",
            "leftCorner": {
              "x": 40.706,
              "y": 7.3861,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.657,
              "y": 7.3128,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447787993"
          },
          {
            "id": "679afb3f3d9bab0f83ff6256",
            "leftCorner": {
              "x": 40.657,
              "y": 7.3128,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.631,
              "y": 7.2729,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447672275"
          },
          {
            "id": "679afb3f3d9bab0f83ff6257",
            "leftCorner": {
              "x": 40.631,
              "y": 7.2729,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.6,
              "y": 7.227,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447672275"
          },
          {
            "id": "679afb3f3d9bab0f83ff6258",
            "leftCorner": {
              "x": 40.6,
              "y": 7.227,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.543,
              "y": 7.1408,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109535"
          },
          {
            "id": "679afb3f3d9bab0f83ff6259",
            "leftCorner": {
              "x": 40.543,
              "y": 7.1408,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.481,
              "y": 7.049,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000058"
          },
          {
            "id": "679afb3f3d9bab0f83ff625a",
            "leftCorner": {
              "x": 40.481,
              "y": 7.049,
              "z": 0.46149
            },
            "rightCorner": {
              "x": 40.412,
              "y": 6.9453,
              "z": 0.46149
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109474"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad35",
        "height": 0.7553,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6293",
            "leftCorner": {
              "x": 41.003,
              "y": 7.8317,
              "z": 0.75356
            },
            "rightCorner": {
              "x": 40.959,
              "y": 7.7673,
              "z": 0.75356
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162025534"
          },
          {
            "id": "679afb3f3d9bab0f83ff6294",
            "leftCorner": {
              "x": 40.953,
              "y": 7.7539,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.909,
              "y": 7.6891,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008268002817"
          },
          {
            "id": "679afb3f3d9bab0f83ff6295",
            "leftCorner": {
              "x": 40.909,
              "y": 7.6891,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.865,
              "y": 7.6219,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100291025"
          },
          {
            "id": "679afb3f3d9bab0f83ff6296",
            "leftCorner": {
              "x": 40.865,
              "y": 7.6219,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.822,
              "y": 7.5576,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661751603"
          },
          {
            "id": "679afb3f3d9bab0f83ff6297",
            "leftCorner": {
              "x": 40.822,
              "y": 7.5576,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.784,
              "y": 7.5008,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661750521"
          },
          {
            "id": "679afb3f3d9bab0f83ff6298",
            "leftCorner": {
              "x": 40.784,
              "y": 7.5008,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.745,
              "y": 7.4428,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661751627"
          },
          {
            "id": "679afb3f3d9bab0f83ff6299",
            "leftCorner": {
              "x": 40.745,
              "y": 7.4428,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.706,
              "y": 7.3843,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661783390"
          },
          {
            "id": "679afb3f3d9bab0f83ff629a",
            "leftCorner": {
              "x": 40.706,
              "y": 7.3843,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.637,
              "y": 7.2819,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661785318"
          },
          {
            "id": "679afb3f3d9bab0f83ff629b",
            "leftCorner": {
              "x": 40.637,
              "y": 7.2819,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.572,
              "y": 7.1833,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42429050"
          },
          {
            "id": "679afb3f3d9bab0f83ff629c",
            "leftCorner": {
              "x": 40.572,
              "y": 7.1833,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.515,
              "y": 7.0986,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42397748"
          },
          {
            "id": "679afb3f3d9bab0f83ff629d",
            "leftCorner": {
              "x": 40.515,
              "y": 7.0986,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.456,
              "y": 7.0101,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917133"
          },
          {
            "id": "679afb3f3d9bab0f83ff629e",
            "leftCorner": {
              "x": 40.456,
              "y": 7.0101,
              "z": 0.7553
            },
            "rightCorner": {
              "x": 40.416,
              "y": 6.9496,
              "z": 0.7553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917133"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad34",
        "height": 1.044,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6271",
            "leftCorner": {
              "x": 40.997,
              "y": 7.8175,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.945,
              "y": 7.7385,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008233174587"
          },
          {
            "id": "679afb3f3d9bab0f83ff6272",
            "leftCorner": {
              "x": 40.945,
              "y": 7.7385,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.909,
              "y": 7.6858,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040306012"
          },
          {
            "id": "679afb3f3d9bab0f83ff6273",
            "leftCorner": {
              "x": 40.909,
              "y": 7.6858,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.869,
              "y": 7.6256,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040902146"
          },
          {
            "id": "679afb3f3d9bab0f83ff6274",
            "leftCorner": {
              "x": 40.869,
              "y": 7.6256,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.827,
              "y": 7.5627,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040002150"
          },
          {
            "id": "679afb3f3d9bab0f83ff6275",
            "leftCorner": {
              "x": 40.827,
              "y": 7.5627,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.795,
              "y": 7.515,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006825"
          },
          {
            "id": "679afb3f3d9bab0f83ff6276",
            "leftCorner": {
              "x": 40.795,
              "y": 7.515,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.752,
              "y": 7.4508,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006443"
          },
          {
            "id": "679afb3f3d9bab0f83ff6277",
            "leftCorner": {
              "x": 40.752,
              "y": 7.4508,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.709,
              "y": 7.386,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240306"
          },
          {
            "id": "679afb3f3d9bab0f83ff6278",
            "leftCorner": {
              "x": 40.709,
              "y": 7.386,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.664,
              "y": 7.3186,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237900"
          },
          {
            "id": "679afb3f3d9bab0f83ff6279",
            "leftCorner": {
              "x": 40.664,
              "y": 7.3186,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.618,
              "y": 7.2494,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237900"
          },
          {
            "id": "679afb3f3d9bab0f83ff627a",
            "leftCorner": {
              "x": 40.618,
              "y": 7.2494,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.557,
              "y": 7.1577,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591545"
          },
          {
            "id": "679afb3f3d9bab0f83ff627b",
            "leftCorner": {
              "x": 40.557,
              "y": 7.1577,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.487,
              "y": 7.0535,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447078428"
          },
          {
            "id": "679afb3f3d9bab0f83ff627c",
            "leftCorner": {
              "x": 40.487,
              "y": 7.0535,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.445,
              "y": 6.9908,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439892"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad36",
        "height": 1.3425,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62b7",
            "leftCorner": {
              "x": 40.987,
              "y": 7.8075,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.946,
              "y": 7.7461,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551033082"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b8",
            "leftCorner": {
              "x": 40.946,
              "y": 7.7461,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.916,
              "y": 7.7002,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551057705"
          },
          {
            "id": "679afb3f3d9bab0f83ff62b9",
            "leftCorner": {
              "x": 40.916,
              "y": 7.7002,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.863,
              "y": 7.6217,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551068749"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ba",
            "leftCorner": {
              "x": 40.863,
              "y": 7.6217,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.804,
              "y": 7.5329,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551147307"
          },
          {
            "id": "679afb3f3d9bab0f83ff62bb",
            "leftCorner": {
              "x": 40.804,
              "y": 7.5329,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.751,
              "y": 7.4534,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551124803"
          },
          {
            "id": "679afb3f3d9bab0f83ff62bc",
            "leftCorner": {
              "x": 40.751,
              "y": 7.4534,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.698,
              "y": 7.3737,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551057712"
          },
          {
            "id": "679afb3f3d9bab0f83ff62bd",
            "leftCorner": {
              "x": 40.698,
              "y": 7.3737,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.644,
              "y": 7.2932,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551101408"
          },
          {
            "id": "679afb3f3d9bab0f83ff62be",
            "leftCorner": {
              "x": 40.644,
              "y": 7.2932,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.569,
              "y": 7.1816,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900927545"
          },
          {
            "id": "679afb3f3d9bab0f83ff62bf",
            "leftCorner": {
              "x": 40.569,
              "y": 7.1816,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.477,
              "y": 7.0433,
              "z": 1.3425
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109597"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c0",
            "leftCorner": {
              "x": 40.477,
              "y": 7.0433,
              "z": 1.3425
            },
            "rightCorner": {
              "x": 40.447,
              "y": 6.9983,
              "z": 1.3425
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083476"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c1",
            "leftCorner": {
              "x": 40.438,
              "y": 6.976,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.394,
              "y": 6.9108,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083476"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 60,
      "unknownStockCount": 3
    },
    "name": "OLCA",
    "leftNeighborShelfId": "J7M1",
    "rightNeighborShelfId": "HY2A"
  },
  {
    "id": "JBAS",
    "x": 40.428,
    "y": 6.9759,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.88137,
      "w": -0.47242
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad3d",
        "height": 0.15842,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6224",
            "leftCorner": {
              "x": 40.317,
              "y": 6.989,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.265,
              "y": 6.9119,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366044"
          },
          {
            "id": "679afb3f3d9bab0f83ff6225",
            "leftCorner": {
              "x": 40.265,
              "y": 6.9119,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.217,
              "y": 6.8394,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796067088"
          },
          {
            "id": "679afb3f3d9bab0f83ff6226",
            "leftCorner": {
              "x": 40.217,
              "y": 6.8394,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.167,
              "y": 6.7639,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796067088"
          },
          {
            "id": "679afb3f3d9bab0f83ff6227",
            "leftCorner": {
              "x": 40.167,
              "y": 6.7639,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.116,
              "y": 6.6866,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366105"
          },
          {
            "id": "679afb3f3d9bab0f83ff6228",
            "leftCorner": {
              "x": 40.116,
              "y": 6.6866,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.069,
              "y": 6.6162,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366105"
          },
          {
            "id": "679afb3f3d9bab0f83ff6229",
            "leftCorner": {
              "x": 40.069,
              "y": 6.6162,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 40.02,
              "y": 6.543,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366129"
          },
          {
            "id": "679afb3f3d9bab0f83ff622a",
            "leftCorner": {
              "x": 40.02,
              "y": 6.543,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 39.972,
              "y": 6.4709,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000059"
          },
          {
            "id": "679afb3f3d9bab0f83ff622b",
            "leftCorner": {
              "x": 39.972,
              "y": 6.4709,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 39.925,
              "y": 6.3998,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378214"
          },
          {
            "id": "679afb3f3d9bab0f83ff622c",
            "leftCorner": {
              "x": 39.925,
              "y": 6.3998,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 39.877,
              "y": 6.3272,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378214"
          },
          {
            "id": "679afb3f3d9bab0f83ff622d",
            "leftCorner": {
              "x": 39.877,
              "y": 6.3272,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 39.828,
              "y": 6.2543,
              "z": 0.15842
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366068"
          },
          {
            "id": "679afb3e3d9bab0f83ff61f2",
            "leftCorner": {
              "x": 39.828,
              "y": 6.2543,
              "z": 0.15842
            },
            "rightCorner": {
              "x": 39.791,
              "y": 6.1986,
              "z": 0.15842
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447366068"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad3b",
        "height": 0.4613,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff625b",
            "leftCorner": {
              "x": 40.403,
              "y": 6.923,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.336,
              "y": 6.8226,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109559"
          },
          {
            "id": "679afb3f3d9bab0f83ff625c",
            "leftCorner": {
              "x": 40.336,
              "y": 6.8226,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.299,
              "y": 6.7674,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109559"
          },
          {
            "id": "679afb3f3d9bab0f83ff625d",
            "leftCorner": {
              "x": 40.299,
              "y": 6.7674,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.271,
              "y": 6.725,
              "z": 0.4613
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796067750"
          },
          {
            "id": "679afb3f3d9bab0f83ff625e",
            "leftCorner": {
              "x": 40.271,
              "y": 6.725,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.244,
              "y": 6.6838,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796067750"
          },
          {
            "id": "679afb3f3d9bab0f83ff625f",
            "leftCorner": {
              "x": 40.244,
              "y": 6.6838,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.198,
              "y": 6.6141,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447722697"
          },
          {
            "id": "679afb3f3d9bab0f83ff6260",
            "leftCorner": {
              "x": 40.198,
              "y": 6.6141,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.153,
              "y": 6.5476,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447722697"
          },
          {
            "id": "679afb3f3d9bab0f83ff6261",
            "leftCorner": {
              "x": 40.153,
              "y": 6.5476,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.1,
              "y": 6.4676,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000196001146"
          },
          {
            "id": "679afb3f3d9bab0f83ff6262",
            "leftCorner": {
              "x": 40.1,
              "y": 6.4676,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 40.047,
              "y": 6.3869,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109399"
          },
          {
            "id": "679afb3f3d9bab0f83ff6263",
            "leftCorner": {
              "x": 40.047,
              "y": 6.3869,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 39.992,
              "y": 6.3043,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109399"
          },
          {
            "id": "679afb3f3d9bab0f83ff6264",
            "leftCorner": {
              "x": 39.992,
              "y": 6.3043,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 39.938,
              "y": 6.224,
              "z": 0.4613
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447109412"
          },
          {
            "id": "679afb3f3d9bab0f83ff6242",
            "leftCorner": {
              "x": 39.938,
              "y": 6.224,
              "z": 0.4613
            },
            "rightCorner": {
              "x": 39.881,
              "y": 6.1385,
              "z": 0.4613
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109412"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad3a",
        "height": 0.75733,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff629f",
            "leftCorner": {
              "x": 40.407,
              "y": 6.9267,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.349,
              "y": 6.8395,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917171"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a0",
            "leftCorner": {
              "x": 40.349,
              "y": 6.8395,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.282,
              "y": 6.7376,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917218"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a1",
            "leftCorner": {
              "x": 40.282,
              "y": 6.7376,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.235,
              "y": 6.6668,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900964526"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a2",
            "leftCorner": {
              "x": 40.235,
              "y": 6.6668,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.189,
              "y": 6.5987,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900980687"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a3",
            "leftCorner": {
              "x": 40.189,
              "y": 6.5987,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.141,
              "y": 6.5263,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900964441"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a4",
            "leftCorner": {
              "x": 40.141,
              "y": 6.5263,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.086,
              "y": 6.4431,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900964441"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a5",
            "leftCorner": {
              "x": 40.086,
              "y": 6.4431,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 40.034,
              "y": 6.3649,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900964403"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a6",
            "leftCorner": {
              "x": 40.034,
              "y": 6.3649,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 39.985,
              "y": 6.2918,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42316459"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a7",
            "leftCorner": {
              "x": 39.985,
              "y": 6.2918,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 39.937,
              "y": 6.2198,
              "z": 0.75733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42269915"
          },
          {
            "id": "679afb3f3d9bab0f83ff628a",
            "leftCorner": {
              "x": 39.937,
              "y": 6.2198,
              "z": 0.75733
            },
            "rightCorner": {
              "x": 39.883,
              "y": 6.1377,
              "z": 0.75733
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42269915"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad39",
        "height": 1.0471,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff627d",
            "leftCorner": {
              "x": 40.445,
              "y": 6.9908,
              "z": 1.044
            },
            "rightCorner": {
              "x": 40.418,
              "y": 6.9497,
              "z": 1.044
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808802623"
          },
          {
            "id": "679afb3f3d9bab0f83ff627e",
            "leftCorner": {
              "x": 40.408,
              "y": 6.9279,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.365,
              "y": 6.8637,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808911110"
          },
          {
            "id": "679afb3f3d9bab0f83ff627f",
            "leftCorner": {
              "x": 40.365,
              "y": 6.8637,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.323,
              "y": 6.7999,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083162"
          },
          {
            "id": "679afb3f3d9bab0f83ff6280",
            "leftCorner": {
              "x": 40.323,
              "y": 6.7999,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.277,
              "y": 6.7313,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6281",
            "leftCorner": {
              "x": 40.277,
              "y": 6.7313,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.236,
              "y": 6.6696,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6282",
            "leftCorner": {
              "x": 40.236,
              "y": 6.6696,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.192,
              "y": 6.6024,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083650"
          },
          {
            "id": "679afb3f3d9bab0f83ff6283",
            "leftCorner": {
              "x": 40.192,
              "y": 6.6024,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.152,
              "y": 6.5425,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083650"
          },
          {
            "id": "679afb3f3d9bab0f83ff6284",
            "leftCorner": {
              "x": 40.152,
              "y": 6.5425,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.106,
              "y": 6.474,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083353"
          },
          {
            "id": "679afb3f3d9bab0f83ff6285",
            "leftCorner": {
              "x": 40.106,
              "y": 6.474,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.065,
              "y": 6.4125,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083353"
          },
          {
            "id": "679afb3f3d9bab0f83ff6286",
            "leftCorner": {
              "x": 40.065,
              "y": 6.4125,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 40.021,
              "y": 6.3451,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900637086"
          },
          {
            "id": "679afb3f3d9bab0f83ff6287",
            "leftCorner": {
              "x": 40.021,
              "y": 6.3451,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 39.983,
              "y": 6.2889,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083513"
          },
          {
            "id": "679afb3f3d9bab0f83ff6288",
            "leftCorner": {
              "x": 39.983,
              "y": 6.2889,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 39.941,
              "y": 6.2257,
              "z": 1.0471
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083698"
          },
          {
            "id": "679afb3f3d9bab0f83ff6266",
            "leftCorner": {
              "x": 39.941,
              "y": 6.2257,
              "z": 1.0471
            },
            "rightCorner": {
              "x": 39.883,
              "y": 6.1377,
              "z": 1.0471
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000083698"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad3c",
        "height": 1.344,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62c2",
            "leftCorner": {
              "x": 40.394,
              "y": 6.9108,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.358,
              "y": 6.8555,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900981271"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c3",
            "leftCorner": {
              "x": 40.358,
              "y": 6.8555,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.314,
              "y": 6.7901,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083735"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c4",
            "leftCorner": {
              "x": 40.314,
              "y": 6.7901,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.276,
              "y": 6.732,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000083599"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c5",
            "leftCorner": {
              "x": 40.276,
              "y": 6.732,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.234,
              "y": 6.6689,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000016375"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c6",
            "leftCorner": {
              "x": 40.234,
              "y": 6.6689,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.188,
              "y": 6.6,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900811615"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c7",
            "leftCorner": {
              "x": 40.188,
              "y": 6.6,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.138,
              "y": 6.5243,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043487"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c8",
            "leftCorner": {
              "x": 40.138,
              "y": 6.5243,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.088,
              "y": 6.4505,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000043524"
          },
          {
            "id": "679afb3f3d9bab0f83ff62c9",
            "leftCorner": {
              "x": 40.088,
              "y": 6.4505,
              "z": 1.344
            },
            "rightCorner": {
              "x": 40.036,
              "y": 6.3716,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000038896"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ca",
            "leftCorner": {
              "x": 40.036,
              "y": 6.3716,
              "z": 1.344
            },
            "rightCorner": {
              "x": 39.981,
              "y": 6.2895,
              "z": 1.344
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4006000038896"
          },
          {
            "id": "679afb3f3d9bab0f83ff62cb",
            "leftCorner": {
              "x": 39.981,
              "y": 6.2895,
              "z": 1.344
            },
            "rightCorner": {
              "x": 39.93,
              "y": 6.212,
              "z": 1.344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000122571"
          },
          {
            "id": "679afb3f3d9bab0f83ff62a9",
            "leftCorner": {
              "x": 39.93,
              "y": 6.212,
              "z": 1.344
            },
            "rightCorner": {
              "x": 39.881,
              "y": 6.1387,
              "z": 1.344
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000122571"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 49,
      "unknownStockCount": 6
    },
    "name": "JBAS",
    "leftNeighborShelfId": "A299",
    "rightNeighborShelfId": "BY8E"
  },
  {
    "id": "MM45",
    "x": 43.164,
    "y": 8.9276,
    "width": 0.625,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.5061,
      "w": 0.86247
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad3e",
        "height": 0.25829,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad43",
        "height": 0.46376,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6306",
            "leftCorner": {
              "x": 43.108,
              "y": 8.9723,
              "z": 0.46376
            },
            "rightCorner": {
              "x": 43.303,
              "y": 9.3222,
              "z": 0.46376
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6307",
            "leftCorner": {
              "x": 43.303,
              "y": 9.3222,
              "z": 0.46376
            },
            "rightCorner": {
              "x": 43.316,
              "y": 9.3463,
              "z": 0.46376
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6308",
            "leftCorner": {
              "x": 43.316,
              "y": 9.3463,
              "z": 0.46376
            },
            "rightCorner": {
              "x": 43.355,
              "y": 9.4156,
              "z": 0.46376
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531875453"
          },
          {
            "id": "679afb3f3d9bab0f83ff6309",
            "leftCorner": {
              "x": 43.355,
              "y": 9.4156,
              "z": 0.46376
            },
            "rightCorner": {
              "x": 43.393,
              "y": 9.484,
              "z": 0.46376
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009839495823"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad3f",
        "height": 0.71011,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62cc",
            "leftCorner": {
              "x": 43.096,
              "y": 8.9656,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.205,
              "y": 9.1617,
              "z": 0.71011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447289558"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ce",
            "leftCorner": {
              "x": 43.205,
              "y": 9.1617,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.242,
              "y": 9.2276,
              "z": 0.71011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447289558"
          },
          {
            "id": "679afb3f3d9bab0f83ff62cf",
            "leftCorner": {
              "x": 43.242,
              "y": 9.2276,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.287,
              "y": 9.3076,
              "z": 0.71011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000040"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d0",
            "leftCorner": {
              "x": 43.287,
              "y": 9.3076,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.325,
              "y": 9.3764,
              "z": 0.71011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006293733218"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d1",
            "leftCorner": {
              "x": 43.325,
              "y": 9.3764,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.359,
              "y": 9.4367,
              "z": 0.71011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006293733218"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d2",
            "leftCorner": {
              "x": 43.359,
              "y": 9.4367,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.403,
              "y": 9.5159,
              "z": 0.71011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447011364"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d3",
            "leftCorner": {
              "x": 43.403,
              "y": 9.5159,
              "z": 0.71011
            },
            "rightCorner": {
              "x": 43.417,
              "y": 9.5417,
              "z": 0.71011
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad40",
        "height": 0.91323,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62dc",
            "leftCorner": {
              "x": 43.1,
              "y": 8.9629,
              "z": 0.91323
            },
            "rightCorner": {
              "x": 43.174,
              "y": 9.0942,
              "z": 0.91323
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690919"
          },
          {
            "id": "679afb3f3d9bab0f83ff62de",
            "leftCorner": {
              "x": 43.174,
              "y": 9.0942,
              "z": 0.91323
            },
            "rightCorner": {
              "x": 43.237,
              "y": 9.2081,
              "z": 0.91323
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531691015"
          },
          {
            "id": "679afb3f3d9bab0f83ff62df",
            "leftCorner": {
              "x": 43.237,
              "y": 9.2081,
              "z": 0.91323
            },
            "rightCorner": {
              "x": 43.412,
              "y": 9.5206,
              "z": 0.91323
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad42",
        "height": 1.2127,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62f7",
            "leftCorner": {
              "x": 43.09,
              "y": 8.9689,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.135,
              "y": 9.0493,
              "z": 1.2127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f9",
            "leftCorner": {
              "x": 43.135,
              "y": 9.0493,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.147,
              "y": 9.0718,
              "z": 1.2127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62fa",
            "leftCorner": {
              "x": 43.147,
              "y": 9.0718,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.177,
              "y": 9.1253,
              "z": 1.2127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000060"
          },
          {
            "id": "679afb3f3d9bab0f83ff62fb",
            "leftCorner": {
              "x": 43.177,
              "y": 9.1253,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.21,
              "y": 9.184,
              "z": 1.2127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690834"
          },
          {
            "id": "679afb3f3d9bab0f83ff62fc",
            "leftCorner": {
              "x": 43.21,
              "y": 9.184,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.294,
              "y": 9.3347,
              "z": 1.2127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62fd",
            "leftCorner": {
              "x": 43.294,
              "y": 9.3347,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.381,
              "y": 9.4902,
              "z": 1.2127
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531691152"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad41",
        "height": 1.4657,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62e9",
            "leftCorner": {
              "x": 43.098,
              "y": 8.9645,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.158,
              "y": 9.0717,
              "z": 1.4657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62eb",
            "leftCorner": {
              "x": 43.158,
              "y": 9.0717,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.186,
              "y": 9.1222,
              "z": 1.4657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ec",
            "leftCorner": {
              "x": 43.186,
              "y": 9.1222,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.225,
              "y": 9.1918,
              "z": 1.4657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690841"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ed",
            "leftCorner": {
              "x": 43.225,
              "y": 9.1918,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.313,
              "y": 9.3497,
              "z": 1.4657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690766"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ee",
            "leftCorner": {
              "x": 43.313,
              "y": 9.3497,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.397,
              "y": 9.5009,
              "z": 1.4657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531691145"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ef",
            "leftCorner": {
              "x": 43.397,
              "y": 9.5009,
              "z": 1.4657
            },
            "rightCorner": {
              "x": 43.427,
              "y": 9.5538,
              "z": 1.4657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 11,
      "unknownStockCount": 14
    },
    "name": "MM45",
    "leftNeighborShelfId": "OH53",
    "rightNeighborShelfId": "WZMI"
  },
  {
    "id": "MF11",
    "x": 43.443,
    "y": 9.562,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.49355,
      "w": 0.86972
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad46",
        "height": 0.2618,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad47",
        "height": 0.44901,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff630b",
            "leftCorner": {
              "x": 43.445,
              "y": 9.5744,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.489,
              "y": 9.6486,
              "z": 0.44901
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447457070"
          },
          {
            "id": "679afb3f3d9bab0f83ff630c",
            "leftCorner": {
              "x": 43.489,
              "y": 9.6486,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.507,
              "y": 9.6786,
              "z": 0.44901
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447402100"
          },
          {
            "id": "679afb3f3d9bab0f83ff630d",
            "leftCorner": {
              "x": 43.507,
              "y": 9.6786,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.54,
              "y": 9.7345,
              "z": 0.44901
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447402100"
          },
          {
            "id": "679afb3f3d9bab0f83ff630e",
            "leftCorner": {
              "x": 43.54,
              "y": 9.7345,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.591,
              "y": 9.8191,
              "z": 0.44901
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4014531012230"
          },
          {
            "id": "679afb3f3d9bab0f83ff630f",
            "leftCorner": {
              "x": 43.591,
              "y": 9.8191,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.673,
              "y": 9.9572,
              "z": 0.44901
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447499711"
          },
          {
            "id": "679afb3f3d9bab0f83ff6310",
            "leftCorner": {
              "x": 43.673,
              "y": 9.9572,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.82,
              "y": 10.203,
              "z": 0.44901
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447499681"
          },
          {
            "id": "679afb3f3d9bab0f83ff6311",
            "leftCorner": {
              "x": 43.82,
              "y": 10.203,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.898,
              "y": 10.333,
              "z": 0.44901
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8711603455990"
          },
          {
            "id": "679afb3f3d9bab0f83ff6312",
            "leftCorner": {
              "x": 43.898,
              "y": 10.333,
              "z": 0.44901
            },
            "rightCorner": {
              "x": 43.952,
              "y": 10.423,
              "z": 0.44901
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad44",
        "height": 0.70313,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62d4",
            "leftCorner": {
              "x": 43.454,
              "y": 9.596,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.472,
              "y": 9.6255,
              "z": 0.70313
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d5",
            "leftCorner": {
              "x": 43.472,
              "y": 9.6255,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.541,
              "y": 9.7422,
              "z": 0.70313
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447715835"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d6",
            "leftCorner": {
              "x": 43.541,
              "y": 9.7422,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.605,
              "y": 9.849,
              "z": 0.70313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690025"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d7",
            "leftCorner": {
              "x": 43.605,
              "y": 9.849,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.655,
              "y": 9.933,
              "z": 0.70313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531691046"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d8",
            "leftCorner": {
              "x": 43.655,
              "y": 9.933,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.709,
              "y": 10.022,
              "z": 0.70313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531691053"
          },
          {
            "id": "679afb3f3d9bab0f83ff62d9",
            "leftCorner": {
              "x": 43.709,
              "y": 10.022,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.793,
              "y": 10.163,
              "z": 0.70313
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531681696"
          },
          {
            "id": "679afb3f3d9bab0f83ff62da",
            "leftCorner": {
              "x": 43.793,
              "y": 10.163,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.811,
              "y": 10.193,
              "z": 0.70313
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62db",
            "leftCorner": {
              "x": 43.811,
              "y": 10.193,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.899,
              "y": 10.342,
              "z": 0.70313
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447399578"
          },
          {
            "id": "679afb3f3d9bab0f83ff62cd",
            "leftCorner": {
              "x": 43.899,
              "y": 10.342,
              "z": 0.70313
            },
            "rightCorner": {
              "x": 43.949,
              "y": 10.425,
              "z": 0.70313
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447513011"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad45",
        "height": 0.91126,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62e0",
            "leftCorner": {
              "x": 43.445,
              "y": 9.5767,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.536,
              "y": 9.7287,
              "z": 0.91126
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531011066"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e1",
            "leftCorner": {
              "x": 43.536,
              "y": 9.7287,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.577,
              "y": 9.7974,
              "z": 0.91126
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690957"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e2",
            "leftCorner": {
              "x": 43.577,
              "y": 9.7974,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.618,
              "y": 9.8654,
              "z": 0.91126
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690964"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e3",
            "leftCorner": {
              "x": 43.618,
              "y": 9.8654,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.687,
              "y": 9.9821,
              "z": 0.91126
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690971"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e4",
            "leftCorner": {
              "x": 43.687,
              "y": 9.9821,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.776,
              "y": 10.131,
              "z": 0.91126
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690971"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e5",
            "leftCorner": {
              "x": 43.776,
              "y": 10.131,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.801,
              "y": 10.173,
              "z": 0.91126
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e6",
            "leftCorner": {
              "x": 43.801,
              "y": 10.173,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.818,
              "y": 10.201,
              "z": 0.91126
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447327472"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e7",
            "leftCorner": {
              "x": 43.818,
              "y": 10.201,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.842,
              "y": 10.241,
              "z": 0.91126
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447327472"
          },
          {
            "id": "679afb3f3d9bab0f83ff62e8",
            "leftCorner": {
              "x": 43.842,
              "y": 10.241,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.901,
              "y": 10.339,
              "z": 0.91126
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447327441"
          },
          {
            "id": "679afb3f3d9bab0f83ff62dd",
            "leftCorner": {
              "x": 43.901,
              "y": 10.339,
              "z": 0.91126
            },
            "rightCorner": {
              "x": 43.951,
              "y": 10.423,
              "z": 0.91126
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447327441"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad48",
        "height": 1.2082,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62fe",
            "leftCorner": {
              "x": 43.381,
              "y": 9.4902,
              "z": 1.2127
            },
            "rightCorner": {
              "x": 43.485,
              "y": 9.6759,
              "z": 1.2127
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000038"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ff",
            "leftCorner": {
              "x": 43.533,
              "y": 9.7236,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.565,
              "y": 9.7777,
              "z": 1.2082
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4014531691039"
          },
          {
            "id": "679afb3f3d9bab0f83ff6300",
            "leftCorner": {
              "x": 43.565,
              "y": 9.7777,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.585,
              "y": 9.8105,
              "z": 1.2082
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6301",
            "leftCorner": {
              "x": 43.585,
              "y": 9.8105,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.63,
              "y": 9.8859,
              "z": 1.2082
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690988"
          },
          {
            "id": "679afb3f3d9bab0f83ff6302",
            "leftCorner": {
              "x": 43.63,
              "y": 9.8859,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.676,
              "y": 9.9631,
              "z": 1.2082
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690711"
          },
          {
            "id": "679afb3f3d9bab0f83ff6303",
            "leftCorner": {
              "x": 43.676,
              "y": 9.9631,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.765,
              "y": 10.112,
              "z": 1.2082
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690704"
          },
          {
            "id": "679afb3f3d9bab0f83ff6304",
            "leftCorner": {
              "x": 43.765,
              "y": 10.112,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.78,
              "y": 10.138,
              "z": 1.2082
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690704"
          },
          {
            "id": "679afb3f3d9bab0f83ff6305",
            "leftCorner": {
              "x": 43.78,
              "y": 10.138,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.875,
              "y": 10.297,
              "z": 1.2082
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f8",
            "leftCorner": {
              "x": 43.875,
              "y": 10.297,
              "z": 1.2082
            },
            "rightCorner": {
              "x": 43.951,
              "y": 10.424,
              "z": 1.2082
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531689937"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad49",
        "height": 1.4602,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff62f0",
            "leftCorner": {
              "x": 43.467,
              "y": 9.6059,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.484,
              "y": 9.6344,
              "z": 1.4602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690803"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f1",
            "leftCorner": {
              "x": 43.484,
              "y": 9.6344,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.609,
              "y": 9.8436,
              "z": 1.4602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531682631"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f2",
            "leftCorner": {
              "x": 43.609,
              "y": 9.8436,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.679,
              "y": 9.9607,
              "z": 1.4602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531691022"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f3",
            "leftCorner": {
              "x": 43.679,
              "y": 9.9607,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.728,
              "y": 10.044,
              "z": 1.4602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690995"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f4",
            "leftCorner": {
              "x": 43.728,
              "y": 10.044,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.77,
              "y": 10.113,
              "z": 1.4602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690728"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f5",
            "leftCorner": {
              "x": 43.77,
              "y": 10.113,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.784,
              "y": 10.136,
              "z": 1.4602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff62f6",
            "leftCorner": {
              "x": 43.784,
              "y": 10.136,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.892,
              "y": 10.318,
              "z": 1.4602
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4014531690698"
          },
          {
            "id": "679afb3f3d9bab0f83ff62ea",
            "leftCorner": {
              "x": 43.892,
              "y": 10.318,
              "z": 1.4602
            },
            "rightCorner": {
              "x": 43.954,
              "y": 10.421,
              "z": 1.4602
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4014531690698"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 18,
      "unknownStockCount": 23
    },
    "name": "MF11",
    "leftNeighborShelfId": "85BT",
    "rightNeighborShelfId": "4G76"
  },
  {
    "id": "3R6D",
    "x": 44.005,
    "y": 10.367,
    "width": 1,
    "height": 1.6,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.50339,
      "w": 0.86406
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad4e",
        "height": 0.2641,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad4d",
        "height": 0.45232,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6313",
            "leftCorner": {
              "x": 43.965,
              "y": 10.389,
              "z": 0.45232
            },
            "rightCorner": {
              "x": 44.035,
              "y": 10.505,
              "z": 0.45232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678550"
          },
          {
            "id": "679afb3f3d9bab0f83ff6314",
            "leftCorner": {
              "x": 44.032,
              "y": 10.507,
              "z": 0.45232
            },
            "rightCorner": {
              "x": 44.157,
              "y": 10.728,
              "z": 0.45232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447414462"
          },
          {
            "id": "679afb3f3d9bab0f83ff6315",
            "leftCorner": {
              "x": 44.157,
              "y": 10.728,
              "z": 0.45232
            },
            "rightCorner": {
              "x": 44.276,
              "y": 10.937,
              "z": 0.45232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447678499"
          },
          {
            "id": "679afb3f3d9bab0f83ff6316",
            "leftCorner": {
              "x": 44.276,
              "y": 10.937,
              "z": 0.45232
            },
            "rightCorner": {
              "x": 44.373,
              "y": 11.107,
              "z": 0.45232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447414349"
          },
          {
            "id": "679afb3f3d9bab0f83ff630a",
            "leftCorner": {
              "x": 44.373,
              "y": 11.107,
              "z": 0.45232
            },
            "rightCorner": {
              "x": 44.459,
              "y": 11.259,
              "z": 0.45232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad4a",
        "height": 0.92956,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad4c",
        "height": 1.224,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6317",
            "leftCorner": {
              "x": 43.979,
              "y": 10.381,
              "z": 1.224
            },
            "rightCorner": {
              "x": 44.448,
              "y": 11.209,
              "z": 1.224
            },
            "stockLevel": "UNKNOWN",
            "gtin": "01000028"
          },
          {
            "id": "679afb3f3d9bab0f83ff6318",
            "leftCorner": {
              "x": 44.448,
              "y": 11.209,
              "z": 1.224
            },
            "rightCorner": {
              "x": 44.472,
              "y": 11.251,
              "z": 1.224
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4003626153019"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad4b",
        "height": 1.561,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 1,
      "unknownStockCount": 6
    },
    "name": "3R6D",
    "leftNeighborShelfId": "5FV2",
    "rightNeighborShelfId": "FR98"
  },
  {
    "id": "85BT",
    "x": 45.96,
    "y": 9.341,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.87539,
      "w": -0.48341
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad53",
        "height": 0.16281,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f24",
            "leftCorner": {
              "x": 45.827,
              "y": 9.3134,
              "z": 0.16281
            },
            "rightCorner": {
              "x": 45.72,
              "y": 9.1433,
              "z": 0.16281
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447787597"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f25",
            "leftCorner": {
              "x": 45.72,
              "y": 9.1433,
              "z": 0.16281
            },
            "rightCorner": {
              "x": 45.611,
              "y": 8.9692,
              "z": 0.16281
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447716641"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f26",
            "leftCorner": {
              "x": 45.611,
              "y": 8.9692,
              "z": 0.16281
            },
            "rightCorner": {
              "x": 45.493,
              "y": 8.7825,
              "z": 0.16281
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447776515"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f27",
            "leftCorner": {
              "x": 45.493,
              "y": 8.7825,
              "z": 0.16281
            },
            "rightCorner": {
              "x": 45.38,
              "y": 8.6025,
              "z": 0.16281
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447711769"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f28",
            "leftCorner": {
              "x": 45.38,
              "y": 8.6025,
              "z": 0.16281
            },
            "rightCorner": {
              "x": 45.34,
              "y": 8.5393,
              "z": 0.16281
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad4f",
        "height": 0.46799,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ef0",
            "leftCorner": {
              "x": 45.973,
              "y": 9.3331,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.94,
              "y": 9.2814,
              "z": 0.46799
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4102963010365"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef1",
            "leftCorner": {
              "x": 45.94,
              "y": 9.2812,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.831,
              "y": 9.1073,
              "z": 0.46799
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540946930"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef2",
            "leftCorner": {
              "x": 45.831,
              "y": 9.1073,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.727,
              "y": 8.9436,
              "z": 0.46799
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540947050"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef3",
            "leftCorner": {
              "x": 45.727,
              "y": 8.9436,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.618,
              "y": 8.7697,
              "z": 0.46799
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563191397"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef4",
            "leftCorner": {
              "x": 45.618,
              "y": 8.7697,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.507,
              "y": 8.5925,
              "z": 0.46799
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563191458"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef5",
            "leftCorner": {
              "x": 45.507,
              "y": 8.5925,
              "z": 0.46799
            },
            "rightCorner": {
              "x": 45.408,
              "y": 8.436,
              "z": 0.46799
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "01000043"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad52",
        "height": 0.7188,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ed3",
            "leftCorner": {
              "x": 45.968,
              "y": 9.3209,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.875,
              "y": 9.1723,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666860002"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed4",
            "leftCorner": {
              "x": 45.875,
              "y": 9.1723,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.778,
              "y": 9.0189,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666830982"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed5",
            "leftCorner": {
              "x": 45.778,
              "y": 9.0189,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.749,
              "y": 8.9728,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8017331095386"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed6",
            "leftCorner": {
              "x": 45.749,
              "y": 8.9728,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.715,
              "y": 8.919,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8017331095386"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed7",
            "leftCorner": {
              "x": 45.715,
              "y": 8.919,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.613,
              "y": 8.757,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666830012"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed8",
            "leftCorner": {
              "x": 45.613,
              "y": 8.757,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.569,
              "y": 8.6862,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666830074"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ed9",
            "leftCorner": {
              "x": 45.569,
              "y": 8.6862,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.53,
              "y": 8.6245,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666830074"
          },
          {
            "id": "679afb3c3d9bab0f83ff4eda",
            "leftCorner": {
              "x": 45.53,
              "y": 8.6245,
              "z": 0.7188
            },
            "rightCorner": {
              "x": 45.438,
              "y": 8.4789,
              "z": 0.7188
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666830005"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad51",
        "height": 0.96844,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f09",
            "leftCorner": {
              "x": 45.957,
              "y": 9.2976,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.888,
              "y": 9.1889,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448017172"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f0a",
            "leftCorner": {
              "x": 45.888,
              "y": 9.1889,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.821,
              "y": 9.0824,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172333842"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f0b",
            "leftCorner": {
              "x": 45.821,
              "y": 9.0824,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.727,
              "y": 8.9334,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563209290"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f0c",
            "leftCorner": {
              "x": 45.727,
              "y": 8.9334,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.63,
              "y": 8.7779,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563209238"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f0d",
            "leftCorner": {
              "x": 45.63,
              "y": 8.7779,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.528,
              "y": 8.6169,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563209269"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f0e",
            "leftCorner": {
              "x": 45.528,
              "y": 8.6169,
              "z": 0.96844
            },
            "rightCorner": {
              "x": 45.442,
              "y": 8.4804,
              "z": 0.96844
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563186188"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad50",
        "height": 1.222,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6319",
            "leftCorner": {
              "x": 45.97,
              "y": 9.3345,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.872,
              "y": 9.1784,
              "z": 1.222
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951419902"
          },
          {
            "id": "679afb3f3d9bab0f83ff631a",
            "leftCorner": {
              "x": 45.872,
              "y": 9.1784,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.779,
              "y": 9.0304,
              "z": 1.222
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951419902"
          },
          {
            "id": "679afb3f3d9bab0f83ff631b",
            "leftCorner": {
              "x": 45.779,
              "y": 9.0304,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.683,
              "y": 8.8786,
              "z": 1.222
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563210180"
          },
          {
            "id": "679afb3f3d9bab0f83ff631c",
            "leftCorner": {
              "x": 45.683,
              "y": 8.8786,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.586,
              "y": 8.7234,
              "z": 1.222
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563099587"
          },
          {
            "id": "679afb3f3d9bab0f83ff631d",
            "leftCorner": {
              "x": 45.586,
              "y": 8.7234,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.485,
              "y": 8.5638,
              "z": 1.222
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563154187"
          },
          {
            "id": "679afb3f3d9bab0f83ff631e",
            "leftCorner": {
              "x": 45.485,
              "y": 8.5638,
              "z": 1.222
            },
            "rightCorner": {
              "x": 45.415,
              "y": 8.4525,
              "z": 1.222
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563129567"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad54",
        "height": 1.475,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6324",
            "leftCorner": {
              "x": 45.974,
              "y": 9.3319,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.877,
              "y": 9.1769,
              "z": 1.475
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951570412"
          },
          {
            "id": "679afb3f3d9bab0f83ff6326",
            "leftCorner": {
              "x": 45.877,
              "y": 9.1769,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.784,
              "y": 9.0293,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951080041"
          },
          {
            "id": "679afb3f3d9bab0f83ff6327",
            "leftCorner": {
              "x": 45.784,
              "y": 9.0293,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.688,
              "y": 8.8771,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108053568"
          },
          {
            "id": "679afb3f3d9bab0f83ff6328",
            "leftCorner": {
              "x": 45.688,
              "y": 8.8771,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.591,
              "y": 8.7227,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108047536"
          },
          {
            "id": "679afb3f3d9bab0f83ff6329",
            "leftCorner": {
              "x": 45.591,
              "y": 8.7227,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.551,
              "y": 8.659,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108059317"
          },
          {
            "id": "679afb3f3d9bab0f83ff632a",
            "leftCorner": {
              "x": 45.551,
              "y": 8.659,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.511,
              "y": 8.5963,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108059317"
          },
          {
            "id": "679afb3f3d9bab0f83ff632b",
            "leftCorner": {
              "x": 45.511,
              "y": 8.5963,
              "z": 1.475
            },
            "rightCorner": {
              "x": 45.426,
              "y": 8.4614,
              "z": 1.475
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108059287"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 33,
      "unknownStockCount": 4
    },
    "name": "85BT",
    "leftNeighborShelfId": "ODNS",
    "rightNeighborShelfId": "MF11"
  },
  {
    "id": "OH53",
    "x": 45.408,
    "y": 8.4857,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.87471,
      "w": -0.48465
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad58",
        "height": 0.16454,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f29",
            "leftCorner": {
              "x": 45.323,
              "y": 8.5284,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.279,
              "y": 8.457,
              "z": 0.16454
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447750867"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2a",
            "leftCorner": {
              "x": 45.279,
              "y": 8.457,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.216,
              "y": 8.3558,
              "z": 0.16454
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172925931"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2b",
            "leftCorner": {
              "x": 45.216,
              "y": 8.3558,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.169,
              "y": 8.2815,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "1000035"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2c",
            "leftCorner": {
              "x": 45.169,
              "y": 8.2815,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.122,
              "y": 8.2069,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2d",
            "leftCorner": {
              "x": 45.122,
              "y": 8.2069,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.075,
              "y": 8.1317,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447580211"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2e",
            "leftCorner": {
              "x": 45.075,
              "y": 8.1317,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 45.026,
              "y": 8.0525,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447705515"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f2f",
            "leftCorner": {
              "x": 45.026,
              "y": 8.0525,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 44.978,
              "y": 7.9761,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447705515"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f30",
            "leftCorner": {
              "x": 44.978,
              "y": 7.9761,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 44.92,
              "y": 7.8838,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951483729"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f31",
            "leftCorner": {
              "x": 44.92,
              "y": 7.8838,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 44.861,
              "y": 7.7886,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951483668"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f32",
            "leftCorner": {
              "x": 44.861,
              "y": 7.7886,
              "z": 0.16454
            },
            "rightCorner": {
              "x": 44.813,
              "y": 7.712,
              "z": 0.16454
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563101105"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad56",
        "height": 0.47148,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4ef6",
            "leftCorner": {
              "x": 45.39,
              "y": 8.4262,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.305,
              "y": 8.2906,
              "z": 0.47148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8718951035461"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef7",
            "leftCorner": {
              "x": 45.305,
              "y": 8.2906,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.283,
              "y": 8.2551,
              "z": 0.47148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef8",
            "leftCorner": {
              "x": 45.283,
              "y": 8.2551,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.224,
              "y": 8.161,
              "z": 0.47148
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951031876"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ef9",
            "leftCorner": {
              "x": 45.224,
              "y": 8.161,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.168,
              "y": 8.0707,
              "z": 0.47148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181323539"
          },
          {
            "id": "679afb3c3d9bab0f83ff4efa",
            "leftCorner": {
              "x": 45.168,
              "y": 8.0707,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.111,
              "y": 7.9794,
              "z": 0.47148
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181323546"
          },
          {
            "id": "679afb3c3d9bab0f83ff4efb",
            "leftCorner": {
              "x": 45.111,
              "y": 7.9794,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 45.053,
              "y": 7.8865,
              "z": 0.47148
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100185294"
          },
          {
            "id": "679afb3c3d9bab0f83ff4efc",
            "leftCorner": {
              "x": 45.053,
              "y": 7.8865,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 44.973,
              "y": 7.7588,
              "z": 0.47148
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100295986"
          },
          {
            "id": "679afb3c3d9bab0f83ff4efd",
            "leftCorner": {
              "x": 44.973,
              "y": 7.7588,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 44.94,
              "y": 7.707,
              "z": 0.47148
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260486335744"
          },
          {
            "id": "679afb3c3d9bab0f83ff4efe",
            "leftCorner": {
              "x": 44.94,
              "y": 7.707,
              "z": 0.47148
            },
            "rightCorner": {
              "x": 44.909,
              "y": 7.6572,
              "z": 0.47148
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260486335744"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5a",
        "height": 0.72288,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4edb",
            "leftCorner": {
              "x": 45.421,
              "y": 8.4691,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.315,
              "y": 8.3008,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108056316"
          },
          {
            "id": "679afb3c3d9bab0f83ff4edc",
            "leftCorner": {
              "x": 45.315,
              "y": 8.3008,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.271,
              "y": 8.2299,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951032644"
          },
          {
            "id": "679afb3c3d9bab0f83ff4edd",
            "leftCorner": {
              "x": 45.271,
              "y": 8.2299,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.229,
              "y": 8.1632,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951032644"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ede",
            "leftCorner": {
              "x": 45.229,
              "y": 8.1632,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.186,
              "y": 8.0943,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4edf",
            "leftCorner": {
              "x": 45.186,
              "y": 8.0943,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.168,
              "y": 8.066,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260457770710"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee0",
            "leftCorner": {
              "x": 45.168,
              "y": 8.066,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 45.093,
              "y": 7.9446,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108053421"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ee1",
            "leftCorner": {
              "x": 45.093,
              "y": 7.9446,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 44.988,
              "y": 7.7769,
              "z": 0.72288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951453395"
          },
          {
            "id": "679afb3c3d9bab0f83ff4ec9",
            "leftCorner": {
              "x": 44.988,
              "y": 7.7769,
              "z": 0.72288
            },
            "rightCorner": {
              "x": 44.894,
              "y": 7.6276,
              "z": 0.72288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4007965015557"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad59",
        "height": 0.97158,
        "facings": [
          {
            "id": "679afb3c3d9bab0f83ff4f0f",
            "leftCorner": {
              "x": 45.421,
              "y": 8.4727,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 45.33,
              "y": 8.3265,
              "z": 0.97158
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563153463"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f10",
            "leftCorner": {
              "x": 45.33,
              "y": 8.3265,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 45.312,
              "y": 8.2974,
              "z": 0.97158
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f11",
            "leftCorner": {
              "x": 45.312,
              "y": 8.2974,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 45.255,
              "y": 8.2071,
              "z": 0.97158
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563207296"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f12",
            "leftCorner": {
              "x": 45.255,
              "y": 8.2071,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 45.183,
              "y": 8.0924,
              "z": 0.97158
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216000185"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f13",
            "leftCorner": {
              "x": 45.183,
              "y": 8.0924,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 45.098,
              "y": 7.9551,
              "z": 0.97158
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216106658"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f14",
            "leftCorner": {
              "x": 45.098,
              "y": 7.9551,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 44.993,
              "y": 7.788,
              "z": 0.97158
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4016369466100"
          },
          {
            "id": "679afb3c3d9bab0f83ff4f15",
            "leftCorner": {
              "x": 44.993,
              "y": 7.788,
              "z": 0.97158
            },
            "rightCorner": {
              "x": 44.897,
              "y": 7.6337,
              "z": 0.97158
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4016369461495"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad57",
        "height": 1.2243,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff631f",
            "leftCorner": {
              "x": 45.396,
              "y": 8.4434,
              "z": 1.2243
            },
            "rightCorner": {
              "x": 45.289,
              "y": 8.2719,
              "z": 1.2243
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5054563949363"
          },
          {
            "id": "679afb3f3d9bab0f83ff6320",
            "leftCorner": {
              "x": 45.289,
              "y": 8.2719,
              "z": 1.2243
            },
            "rightCorner": {
              "x": 45.199,
              "y": 8.1279,
              "z": 1.2243
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563949486"
          },
          {
            "id": "679afb3f3d9bab0f83ff6321",
            "leftCorner": {
              "x": 45.199,
              "y": 8.1279,
              "z": 1.2243
            },
            "rightCorner": {
              "x": 45.107,
              "y": 7.9802,
              "z": 1.2243
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563949424"
          },
          {
            "id": "679afb3f3d9bab0f83ff6322",
            "leftCorner": {
              "x": 45.107,
              "y": 7.9802,
              "z": 1.2243
            },
            "rightCorner": {
              "x": 45.007,
              "y": 7.821,
              "z": 1.2243
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563177421"
          },
          {
            "id": "679afb3f3d9bab0f83ff6323",
            "leftCorner": {
              "x": 45.007,
              "y": 7.821,
              "z": 1.2243
            },
            "rightCorner": {
              "x": 44.907,
              "y": 7.6605,
              "z": 1.2243
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5054563949516"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad55",
        "height": 1.4786,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff632c",
            "leftCorner": {
              "x": 45.404,
              "y": 8.4543,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.316,
              "y": 8.3123,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610108059249"
          },
          {
            "id": "679afb3f3d9bab0f83ff632d",
            "leftCorner": {
              "x": 45.316,
              "y": 8.3123,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.292,
              "y": 8.2744,
              "z": 1.4786
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff632e",
            "leftCorner": {
              "x": 45.292,
              "y": 8.2744,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.202,
              "y": 8.1299,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951115446"
          },
          {
            "id": "679afb3f3d9bab0f83ff632f",
            "leftCorner": {
              "x": 45.202,
              "y": 8.1299,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.166,
              "y": 8.0738,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951560772"
          },
          {
            "id": "679afb3f3d9bab0f83ff6330",
            "leftCorner": {
              "x": 45.166,
              "y": 8.0738,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.129,
              "y": 8.0141,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951560772"
          },
          {
            "id": "679afb3f3d9bab0f83ff6331",
            "leftCorner": {
              "x": 45.129,
              "y": 8.0141,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 45.024,
              "y": 7.8467,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789921006"
          },
          {
            "id": "679afb3f3d9bab0f83ff6332",
            "leftCorner": {
              "x": 45.024,
              "y": 7.8467,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 44.922,
              "y": 7.6836,
              "z": 1.4786
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951454613"
          },
          {
            "id": "679afb3f3d9bab0f83ff6325",
            "leftCorner": {
              "x": 44.922,
              "y": 7.6836,
              "z": 1.4786
            },
            "rightCorner": {
              "x": 44.889,
              "y": 7.6307,
              "z": 1.4786
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 35,
      "unknownStockCount": 11
    },
    "name": "OH53",
    "leftNeighborShelfId": "YT1C",
    "rightNeighborShelfId": "MM45"
  },
  {
    "id": "N3JI",
    "x": 51.558,
    "y": 3.9662,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99996,
      "w": -0.0093213
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad61",
        "height": 0.16345,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5563",
            "leftCorner": {
              "x": 51.541,
              "y": 4.0706,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 51.302,
              "y": 4.0661,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447091762"
          },
          {
            "id": "679afb3d3d9bab0f83ff5564",
            "leftCorner": {
              "x": 51.302,
              "y": 4.0661,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 51.215,
              "y": 4.0645,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447091748"
          },
          {
            "id": "679afb3d3d9bab0f83ff5565",
            "leftCorner": {
              "x": 51.215,
              "y": 4.0645,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 51.169,
              "y": 4.0637,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917669"
          },
          {
            "id": "679afb3d3d9bab0f83ff5566",
            "leftCorner": {
              "x": 51.169,
              "y": 4.0637,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 51.136,
              "y": 4.0631,
              "z": 0.16345
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900917669"
          },
          {
            "id": "679afb3d3d9bab0f83ff5567",
            "leftCorner": {
              "x": 51.136,
              "y": 4.0631,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 51.062,
              "y": 4.0617,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917706"
          },
          {
            "id": "679afb3d3d9bab0f83ff5568",
            "leftCorner": {
              "x": 51.062,
              "y": 4.0617,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.972,
              "y": 4.06,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718034"
          },
          {
            "id": "679afb3d3d9bab0f83ff5569",
            "leftCorner": {
              "x": 50.972,
              "y": 4.06,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.884,
              "y": 4.0584,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718058"
          },
          {
            "id": "679afb3d3d9bab0f83ff556a",
            "leftCorner": {
              "x": 50.884,
              "y": 4.0584,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.786,
              "y": 4.0565,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100717754"
          },
          {
            "id": "679afb3d3d9bab0f83ff556b",
            "leftCorner": {
              "x": 50.786,
              "y": 4.0565,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.709,
              "y": 4.0551,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816440"
          },
          {
            "id": "679afb3d3d9bab0f83ff556c",
            "leftCorner": {
              "x": 50.709,
              "y": 4.0551,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.622,
              "y": 4.0535,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816464"
          },
          {
            "id": "679afb3d3d9bab0f83ff556d",
            "leftCorner": {
              "x": 50.622,
              "y": 4.0535,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.562,
              "y": 4.0523,
              "z": 0.16345
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816488"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad60",
        "height": 0.42153,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6397",
            "leftCorner": {
              "x": 51.554,
              "y": 3.9589,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 51.507,
              "y": 3.958,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638589574"
          },
          {
            "id": "679afb3f3d9bab0f83ff6398",
            "leftCorner": {
              "x": 51.507,
              "y": 3.958,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 51.416,
              "y": 3.9563,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638086561"
          },
          {
            "id": "679afb3f3d9bab0f83ff6399",
            "leftCorner": {
              "x": 51.416,
              "y": 3.9563,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 51.229,
              "y": 3.9528,
              "z": 0.42153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447501179"
          },
          {
            "id": "679afb3f3d9bab0f83ff639a",
            "leftCorner": {
              "x": 51.229,
              "y": 3.9528,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 51.125,
              "y": 3.9509,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172879609"
          },
          {
            "id": "679afb3f3d9bab0f83ff639b",
            "leftCorner": {
              "x": 51.125,
              "y": 3.9509,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 51.072,
              "y": 3.9499,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584530"
          },
          {
            "id": "679afb3f3d9bab0f83ff639c",
            "leftCorner": {
              "x": 51.072,
              "y": 3.9499,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.997,
              "y": 3.9485,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245165"
          },
          {
            "id": "679afb3f3d9bab0f83ff639d",
            "leftCorner": {
              "x": 50.997,
              "y": 3.9485,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.944,
              "y": 3.9475,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172508578"
          },
          {
            "id": "679afb3f3d9bab0f83ff639e",
            "leftCorner": {
              "x": 50.944,
              "y": 3.9475,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.89,
              "y": 3.9465,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172508578"
          },
          {
            "id": "679afb3f3d9bab0f83ff639f",
            "leftCorner": {
              "x": 50.89,
              "y": 3.9465,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.815,
              "y": 3.9451,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447245134"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a0",
            "leftCorner": {
              "x": 50.815,
              "y": 3.9451,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.745,
              "y": 3.9438,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447382211"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a1",
            "leftCorner": {
              "x": 50.745,
              "y": 3.9438,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.657,
              "y": 3.9421,
              "z": 0.42153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "1000020"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a2",
            "leftCorner": {
              "x": 50.657,
              "y": 3.9421,
              "z": 0.42153
            },
            "rightCorner": {
              "x": 50.498,
              "y": 3.9392,
              "z": 0.42153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447245103"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5b",
        "height": 0.67649,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6334",
            "leftCorner": {
              "x": 51.558,
              "y": 3.9575,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 51.482,
              "y": 3.9561,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172923913"
          },
          {
            "id": "679afb3f3d9bab0f83ff6335",
            "leftCorner": {
              "x": 51.482,
              "y": 3.9561,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 51.291,
              "y": 3.9525,
              "z": 0.67649
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172508554"
          },
          {
            "id": "679afb3f3d9bab0f83ff6336",
            "leftCorner": {
              "x": 51.291,
              "y": 3.9525,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 51.128,
              "y": 3.9495,
              "z": 0.67649
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172508493"
          },
          {
            "id": "679afb3f3d9bab0f83ff6337",
            "leftCorner": {
              "x": 51.128,
              "y": 3.9495,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 51.093,
              "y": 3.9488,
              "z": 0.67649
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172773440"
          },
          {
            "id": "679afb3f3d9bab0f83ff6338",
            "leftCorner": {
              "x": 51.093,
              "y": 3.9488,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.994,
              "y": 3.947,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172937811"
          },
          {
            "id": "679afb3f3d9bab0f83ff6339",
            "leftCorner": {
              "x": 50.994,
              "y": 3.947,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.901,
              "y": 3.9453,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447314519"
          },
          {
            "id": "679afb3f3d9bab0f83ff633a",
            "leftCorner": {
              "x": 50.901,
              "y": 3.9453,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.847,
              "y": 3.9443,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172823084"
          },
          {
            "id": "679afb3f3d9bab0f83ff633b",
            "leftCorner": {
              "x": 50.847,
              "y": 3.9443,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.797,
              "y": 3.9433,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447584554"
          },
          {
            "id": "679afb3f3d9bab0f83ff633c",
            "leftCorner": {
              "x": 50.797,
              "y": 3.9433,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.747,
              "y": 3.9424,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492200"
          },
          {
            "id": "679afb3f3d9bab0f83ff633d",
            "leftCorner": {
              "x": 50.747,
              "y": 3.9424,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.697,
              "y": 3.9415,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492200"
          },
          {
            "id": "679afb3f3d9bab0f83ff633e",
            "leftCorner": {
              "x": 50.697,
              "y": 3.9415,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.614,
              "y": 3.9399,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277081"
          },
          {
            "id": "679afb3f3d9bab0f83ff6333",
            "leftCorner": {
              "x": 50.614,
              "y": 3.9399,
              "z": 0.67649
            },
            "rightCorner": {
              "x": 50.558,
              "y": 3.9389,
              "z": 0.67649
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172624056"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5e",
        "height": 0.92478,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff636e",
            "leftCorner": {
              "x": 51.524,
              "y": 3.9558,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 51.454,
              "y": 3.9545,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000107622"
          },
          {
            "id": "679afb3f3d9bab0f83ff636f",
            "leftCorner": {
              "x": 51.454,
              "y": 3.9545,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 51.397,
              "y": 3.9535,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000107585"
          },
          {
            "id": "679afb3f3d9bab0f83ff6370",
            "leftCorner": {
              "x": 51.397,
              "y": 3.9535,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 51.204,
              "y": 3.9499,
              "z": 0.92478
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000002217"
          },
          {
            "id": "679afb3f3d9bab0f83ff6371",
            "leftCorner": {
              "x": 51.204,
              "y": 3.9499,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 51.005,
              "y": 3.9461,
              "z": 0.92478
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000080888"
          },
          {
            "id": "679afb3f3d9bab0f83ff6372",
            "leftCorner": {
              "x": 51.005,
              "y": 3.9461,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.943,
              "y": 3.945,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000080925"
          },
          {
            "id": "679afb3f3d9bab0f83ff6373",
            "leftCorner": {
              "x": 50.943,
              "y": 3.945,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.884,
              "y": 3.9439,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000082646"
          },
          {
            "id": "679afb3f3d9bab0f83ff6374",
            "leftCorner": {
              "x": 50.884,
              "y": 3.9439,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.824,
              "y": 3.9428,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900801869"
          },
          {
            "id": "679afb3f3d9bab0f83ff6375",
            "leftCorner": {
              "x": 50.824,
              "y": 3.9428,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.729,
              "y": 3.941,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900107305"
          },
          {
            "id": "679afb3f3d9bab0f83ff6376",
            "leftCorner": {
              "x": 50.729,
              "y": 3.941,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.664,
              "y": 3.9398,
              "z": 0.92478
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005808802555"
          },
          {
            "id": "679afb3f3d9bab0f83ff636d",
            "leftCorner": {
              "x": 50.664,
              "y": 3.9398,
              "z": 0.92478
            },
            "rightCorner": {
              "x": 50.558,
              "y": 3.9378,
              "z": 0.92478
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4037900600029"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5c",
        "height": 1.179,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff633f",
            "leftCorner": {
              "x": 51.558,
              "y": 3.9588,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.458,
              "y": 3.957,
              "z": 1.179
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600522233039"
          },
          {
            "id": "679afb3f3d9bab0f83ff6340",
            "leftCorner": {
              "x": 51.458,
              "y": 3.957,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.403,
              "y": 3.9559,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524071004"
          },
          {
            "id": "679afb3f3d9bab0f83ff6341",
            "leftCorner": {
              "x": 51.403,
              "y": 3.9559,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.351,
              "y": 3.955,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524070793"
          },
          {
            "id": "679afb3f3d9bab0f83ff6342",
            "leftCorner": {
              "x": 51.351,
              "y": 3.955,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.298,
              "y": 3.954,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524070762"
          },
          {
            "id": "679afb3f3d9bab0f83ff6343",
            "leftCorner": {
              "x": 51.298,
              "y": 3.954,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.242,
              "y": 3.9529,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524070779"
          },
          {
            "id": "679afb3f3d9bab0f83ff6344",
            "leftCorner": {
              "x": 51.242,
              "y": 3.9529,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.203,
              "y": 3.9522,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524195670"
          },
          {
            "id": "679afb3f3d9bab0f83ff6345",
            "leftCorner": {
              "x": 51.203,
              "y": 3.9522,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.129,
              "y": 3.9508,
              "z": 1.179
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524070755"
          },
          {
            "id": "679afb3f3d9bab0f83ff6346",
            "leftCorner": {
              "x": 51.129,
              "y": 3.9508,
              "z": 1.179
            },
            "rightCorner": {
              "x": 51.026,
              "y": 3.9489,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523950102"
          },
          {
            "id": "679afb3f3d9bab0f83ff6347",
            "leftCorner": {
              "x": 51.026,
              "y": 3.9489,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.97,
              "y": 3.9479,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524074494"
          },
          {
            "id": "679afb3f3d9bab0f83ff6348",
            "leftCorner": {
              "x": 50.97,
              "y": 3.9479,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.898,
              "y": 3.9465,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524181345"
          },
          {
            "id": "679afb3f3d9bab0f83ff6349",
            "leftCorner": {
              "x": 50.898,
              "y": 3.9465,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.846,
              "y": 3.9456,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524075712"
          },
          {
            "id": "679afb3f3d9bab0f83ff634a",
            "leftCorner": {
              "x": 50.846,
              "y": 3.9456,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.79,
              "y": 3.9445,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524125752"
          },
          {
            "id": "679afb3f3d9bab0f83ff634b",
            "leftCorner": {
              "x": 50.79,
              "y": 3.9445,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.732,
              "y": 3.9434,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524190439"
          },
          {
            "id": "679afb3f3d9bab0f83ff634c",
            "leftCorner": {
              "x": 50.732,
              "y": 3.9434,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.684,
              "y": 3.9425,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524191047"
          },
          {
            "id": "679afb3f3d9bab0f83ff634d",
            "leftCorner": {
              "x": 50.684,
              "y": 3.9425,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.587,
              "y": 3.9407,
              "z": 1.179
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523718207"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5d",
        "height": 1.4311,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6360",
            "leftCorner": {
              "x": 51.558,
              "y": 3.959,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 51.481,
              "y": 3.9575,
              "z": 1.4311
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447107050"
          },
          {
            "id": "679afb3f3d9bab0f83ff6362",
            "leftCorner": {
              "x": 51.481,
              "y": 3.9575,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 51.441,
              "y": 3.9568,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447302301"
          },
          {
            "id": "679afb3f3d9bab0f83ff6363",
            "leftCorner": {
              "x": 51.441,
              "y": 3.9568,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 51.393,
              "y": 3.9559,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447353822"
          },
          {
            "id": "679afb3f3d9bab0f83ff6364",
            "leftCorner": {
              "x": 51.393,
              "y": 3.9559,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 51.201,
              "y": 3.9523,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060896573571"
          },
          {
            "id": "679afb3f3d9bab0f83ff6365",
            "leftCorner": {
              "x": 51.201,
              "y": 3.9523,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 51.046,
              "y": 3.9494,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060896576893"
          },
          {
            "id": "679afb3f3d9bab0f83ff6366",
            "leftCorner": {
              "x": 51.046,
              "y": 3.9494,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.957,
              "y": 3.9478,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341881"
          },
          {
            "id": "679afb3f3d9bab0f83ff6367",
            "leftCorner": {
              "x": 50.957,
              "y": 3.9478,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.865,
              "y": 3.9461,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277241"
          },
          {
            "id": "679afb3f3d9bab0f83ff6368",
            "leftCorner": {
              "x": 50.865,
              "y": 3.9461,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.809,
              "y": 3.945,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447053579"
          },
          {
            "id": "679afb3f3d9bab0f83ff6369",
            "leftCorner": {
              "x": 50.809,
              "y": 3.945,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.747,
              "y": 3.9438,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069204"
          },
          {
            "id": "679afb3f3d9bab0f83ff636a",
            "leftCorner": {
              "x": 50.747,
              "y": 3.9438,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.703,
              "y": 3.943,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341416"
          },
          {
            "id": "679afb3f3d9bab0f83ff636b",
            "leftCorner": {
              "x": 50.703,
              "y": 3.943,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.655,
              "y": 3.9421,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff636c",
            "leftCorner": {
              "x": 50.655,
              "y": 3.9421,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.612,
              "y": 3.9413,
              "z": 1.4311
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447239577"
          },
          {
            "id": "679afb3f3d9bab0f83ff6361",
            "leftCorner": {
              "x": 50.612,
              "y": 3.9413,
              "z": 1.4311
            },
            "rightCorner": {
              "x": 50.558,
              "y": 3.9403,
              "z": 1.4311
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260380014134"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad5f",
        "height": 1.6836,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6377",
            "leftCorner": {
              "x": 51.565,
              "y": 3.9569,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.457,
              "y": 3.9549,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524062651"
          },
          {
            "id": "679afb3f3d9bab0f83ff6378",
            "leftCorner": {
              "x": 51.457,
              "y": 3.9549,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.402,
              "y": 3.9538,
              "z": 1.6836
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523526109"
          },
          {
            "id": "679afb3f3d9bab0f83ff6379",
            "leftCorner": {
              "x": 51.402,
              "y": 3.9538,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.327,
              "y": 3.9525,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523816262"
          },
          {
            "id": "679afb3f3d9bab0f83ff637a",
            "leftCorner": {
              "x": 51.327,
              "y": 3.9525,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.209,
              "y": 3.9503,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841693934"
          },
          {
            "id": "679afb3f3d9bab0f83ff637b",
            "leftCorner": {
              "x": 51.209,
              "y": 3.9503,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.082,
              "y": 3.9479,
              "z": 1.6836
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540470374"
          },
          {
            "id": "679afb3f3d9bab0f83ff637c",
            "leftCorner": {
              "x": 51.082,
              "y": 3.9479,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 51.028,
              "y": 3.9469,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341867"
          },
          {
            "id": "679afb3f3d9bab0f83ff637d",
            "leftCorner": {
              "x": 51.028,
              "y": 3.9469,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.982,
              "y": 3.946,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447341317"
          },
          {
            "id": "679afb3f3d9bab0f83ff637e",
            "leftCorner": {
              "x": 50.982,
              "y": 3.946,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.935,
              "y": 3.9451,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172432088"
          },
          {
            "id": "679afb3f3d9bab0f83ff637f",
            "leftCorner": {
              "x": 50.935,
              "y": 3.9451,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.761,
              "y": 3.9419,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172936357"
          },
          {
            "id": "679afb3f3d9bab0f83ff6380",
            "leftCorner": {
              "x": 50.761,
              "y": 3.9419,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.72,
              "y": 3.9411,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107135"
          },
          {
            "id": "679afb3f3d9bab0f83ff6381",
            "leftCorner": {
              "x": 50.72,
              "y": 3.9411,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.675,
              "y": 3.9403,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260380010679"
          },
          {
            "id": "679afb3f3d9bab0f83ff6382",
            "leftCorner": {
              "x": 50.675,
              "y": 3.9403,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.622,
              "y": 3.9393,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260380010662"
          },
          {
            "id": "679afb3f3d9bab0f83ff6383",
            "leftCorner": {
              "x": 50.622,
              "y": 3.9393,
              "z": 1.6836
            },
            "rightCorner": {
              "x": 50.58,
              "y": 3.9385,
              "z": 1.6836
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260380010655"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 70,
      "unknownStockCount": 16
    },
    "name": "N3JI",
    "leftNeighborShelfId": "LHJE",
    "rightNeighborShelfId": "NDX2"
  },
  {
    "id": "ODNS",
    "x": 46.983,
    "y": 8.9813,
    "width": 0.8,
    "height": 1.6,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.47901,
      "w": 0.87781
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad66",
        "height": 0.16513,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63e4",
            "leftCorner": {
              "x": 47.063,
              "y": 8.9297,
              "z": 0.16513
            },
            "rightCorner": {
              "x": 47.183,
              "y": 9.1157,
              "z": 0.16513
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172286346"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e5",
            "leftCorner": {
              "x": 47.183,
              "y": 9.1157,
              "z": 0.16513
            },
            "rightCorner": {
              "x": 47.303,
              "y": 9.3022,
              "z": 0.16513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172286346"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e6",
            "leftCorner": {
              "x": 47.303,
              "y": 9.3022,
              "z": 0.16513
            },
            "rightCorner": {
              "x": 47.423,
              "y": 9.4888,
              "z": 0.16513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172286346"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad62",
        "height": 0.55625,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63c2",
            "leftCorner": {
              "x": 47.059,
              "y": 8.9326,
              "z": 0.55625
            },
            "rightCorner": {
              "x": 47.146,
              "y": 9.0683,
              "z": 0.55625
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447603248"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c4",
            "leftCorner": {
              "x": 47.146,
              "y": 9.0683,
              "z": 0.55625
            },
            "rightCorner": {
              "x": 47.212,
              "y": 9.1705,
              "z": 0.55625
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447603248"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c5",
            "leftCorner": {
              "x": 47.212,
              "y": 9.1705,
              "z": 0.55625
            },
            "rightCorner": {
              "x": 47.364,
              "y": 9.4068,
              "z": 0.55625
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447484571"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c3",
            "leftCorner": {
              "x": 47.364,
              "y": 9.4068,
              "z": 0.55625
            },
            "rightCorner": {
              "x": 47.491,
              "y": 9.6053,
              "z": 0.55625
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5029053579290"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad65",
        "height": 0.97382,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63de",
            "leftCorner": {
              "x": 47.058,
              "y": 8.9333,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.145,
              "y": 9.07,
              "z": 0.97382
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e0",
            "leftCorner": {
              "x": 47.145,
              "y": 9.07,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.213,
              "y": 9.1753,
              "z": 0.97382
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172932212"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e1",
            "leftCorner": {
              "x": 47.213,
              "y": 9.1753,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.281,
              "y": 9.2809,
              "z": 0.97382
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e2",
            "leftCorner": {
              "x": 47.281,
              "y": 9.2809,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.347,
              "y": 9.3828,
              "z": 0.97382
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e3",
            "leftCorner": {
              "x": 47.347,
              "y": 9.3828,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.41,
              "y": 9.4814,
              "z": 0.97382
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172932434"
          },
          {
            "id": "679afb3f3d9bab0f83ff63df",
            "leftCorner": {
              "x": 47.41,
              "y": 9.4814,
              "z": 0.97382
            },
            "rightCorner": {
              "x": 47.49,
              "y": 9.606,
              "z": 0.97382
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad64",
        "height": 1.2689,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63d4",
            "leftCorner": {
              "x": 47.054,
              "y": 8.9356,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.113,
              "y": 9.0273,
              "z": 1.2689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d6",
            "leftCorner": {
              "x": 47.113,
              "y": 9.0273,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.146,
              "y": 9.079,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054316"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d7",
            "leftCorner": {
              "x": 47.146,
              "y": 9.079,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.182,
              "y": 9.1345,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d8",
            "leftCorner": {
              "x": 47.182,
              "y": 9.1345,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.227,
              "y": 9.2039,
              "z": 1.2689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447490619"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d9",
            "leftCorner": {
              "x": 47.227,
              "y": 9.2039,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.268,
              "y": 9.2678,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447490619"
          },
          {
            "id": "679afb3f3d9bab0f83ff63da",
            "leftCorner": {
              "x": 47.268,
              "y": 9.2678,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.311,
              "y": 9.3351,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447490619"
          },
          {
            "id": "679afb3f3d9bab0f83ff63db",
            "leftCorner": {
              "x": 47.311,
              "y": 9.3351,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.36,
              "y": 9.4115,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016758"
          },
          {
            "id": "679afb3f3d9bab0f83ff63dc",
            "leftCorner": {
              "x": 47.36,
              "y": 9.4115,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.406,
              "y": 9.4829,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016758"
          },
          {
            "id": "679afb3f3d9bab0f83ff63dd",
            "leftCorner": {
              "x": 47.406,
              "y": 9.4829,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.446,
              "y": 9.5453,
              "z": 1.2689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996511"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d5",
            "leftCorner": {
              "x": 47.446,
              "y": 9.5453,
              "z": 1.2689
            },
            "rightCorner": {
              "x": 47.487,
              "y": 9.6083,
              "z": 1.2689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172996511"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad63",
        "height": 1.48,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63c6",
            "leftCorner": {
              "x": 47.056,
              "y": 8.9343,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.089,
              "y": 8.9852,
              "z": 1.48
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c8",
            "leftCorner": {
              "x": 47.089,
              "y": 8.9852,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.119,
              "y": 9.0324,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c9",
            "leftCorner": {
              "x": 47.119,
              "y": 9.0324,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.148,
              "y": 9.0774,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ca",
            "leftCorner": {
              "x": 47.148,
              "y": 9.0774,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.177,
              "y": 9.1229,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63cb",
            "leftCorner": {
              "x": 47.177,
              "y": 9.1229,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.207,
              "y": 9.1693,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63cc",
            "leftCorner": {
              "x": 47.207,
              "y": 9.1693,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.239,
              "y": 9.219,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054330"
          },
          {
            "id": "679afb3f3d9bab0f83ff63cd",
            "leftCorner": {
              "x": 47.239,
              "y": 9.219,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.269,
              "y": 9.2656,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054279"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ce",
            "leftCorner": {
              "x": 47.269,
              "y": 9.2656,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.3,
              "y": 9.3132,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054279"
          },
          {
            "id": "679afb3f3d9bab0f83ff63cf",
            "leftCorner": {
              "x": 47.3,
              "y": 9.3132,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.334,
              "y": 9.366,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054279"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d0",
            "leftCorner": {
              "x": 47.334,
              "y": 9.366,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.363,
              "y": 9.4113,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054279"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d1",
            "leftCorner": {
              "x": 47.363,
              "y": 9.4113,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.392,
              "y": 9.4572,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447054279"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d2",
            "leftCorner": {
              "x": 47.392,
              "y": 9.4572,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.422,
              "y": 9.5029,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63d3",
            "leftCorner": {
              "x": 47.422,
              "y": 9.5029,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.449,
              "y": 9.5448,
              "z": 1.48
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172309595"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c7",
            "leftCorner": {
              "x": 47.449,
              "y": 9.5448,
              "z": 1.48
            },
            "rightCorner": {
              "x": 47.489,
              "y": 9.6071,
              "z": 1.48
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 27,
      "unknownStockCount": 10
    },
    "name": "ODNS",
    "leftNeighborShelfId": "NB3C",
    "rightNeighborShelfId": "85BT"
  },
  {
    "id": "7CLW",
    "x": 47.399,
    "y": 9.6281,
    "width": 1,
    "height": 1.6,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.48877,
      "w": 0.87241
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad67",
        "height": 0.16467,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63e7",
            "leftCorner": {
              "x": 47.423,
              "y": 9.4888,
              "z": 0.16513
            },
            "rightCorner": {
              "x": 47.564,
              "y": 9.7077,
              "z": 0.16513
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172286360"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e8",
            "leftCorner": {
              "x": 47.546,
              "y": 9.6851,
              "z": 0.16467
            },
            "rightCorner": {
              "x": 47.669,
              "y": 9.8869,
              "z": 0.16467
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172286360"
          },
          {
            "id": "679afb3f3d9bab0f83ff63e9",
            "leftCorner": {
              "x": 47.669,
              "y": 9.8869,
              "z": 0.16467
            },
            "rightCorner": {
              "x": 47.827,
              "y": 10.145,
              "z": 0.16467
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4046871010546"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ea",
            "leftCorner": {
              "x": 47.827,
              "y": 10.145,
              "z": 0.16467
            },
            "rightCorner": {
              "x": 47.993,
              "y": 10.416,
              "z": 0.16467
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4046871010546"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad68",
        "height": 0.54289,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad6b",
        "height": 0.83407,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad69",
        "height": 1.1024,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63eb",
            "leftCorner": {
              "x": 47.474,
              "y": 9.582,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.577,
              "y": 9.7502,
              "z": 1.1024
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172932540"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ed",
            "leftCorner": {
              "x": 47.577,
              "y": 9.7502,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.667,
              "y": 9.8964,
              "z": 1.1024
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172932540"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ee",
            "leftCorner": {
              "x": 47.667,
              "y": 9.8964,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.762,
              "y": 10.052,
              "z": 1.1024
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996238"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ef",
            "leftCorner": {
              "x": 47.762,
              "y": 10.052,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.832,
              "y": 10.166,
              "z": 1.1024
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996238"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f0",
            "leftCorner": {
              "x": 47.832,
              "y": 10.166,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.9,
              "y": 10.277,
              "z": 1.1024
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355918666"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ec",
            "leftCorner": {
              "x": 47.9,
              "y": 10.277,
              "z": 1.1024
            },
            "rightCorner": {
              "x": 47.997,
              "y": 10.435,
              "z": 1.1024
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad6a",
        "height": 1.3944,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63f1",
            "leftCorner": {
              "x": 47.472,
              "y": 9.5833,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.539,
              "y": 9.6928,
              "z": 1.3944
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172928352"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f3",
            "leftCorner": {
              "x": 47.539,
              "y": 9.6928,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.649,
              "y": 9.8719,
              "z": 1.3944
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996252"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f4",
            "leftCorner": {
              "x": 47.649,
              "y": 9.8719,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.727,
              "y": 9.999,
              "z": 1.3944
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172996276"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f5",
            "leftCorner": {
              "x": 47.727,
              "y": 9.999,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.802,
              "y": 10.122,
              "z": 1.3944
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996290"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f6",
            "leftCorner": {
              "x": 47.802,
              "y": 10.122,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.861,
              "y": 10.219,
              "z": 1.3944
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172996191"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f7",
            "leftCorner": {
              "x": 47.861,
              "y": 10.219,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.913,
              "y": 10.303,
              "z": 1.3944
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260620680143"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f8",
            "leftCorner": {
              "x": 47.913,
              "y": 10.303,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.964,
              "y": 10.386,
              "z": 1.3944
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447016710"
          },
          {
            "id": "679afb3f3d9bab0f83ff63f2",
            "leftCorner": {
              "x": 47.964,
              "y": 10.386,
              "z": 1.3944
            },
            "rightCorner": {
              "x": 47.994,
              "y": 10.436,
              "z": 1.3944
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447016710"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 11,
      "unknownStockCount": 6
    },
    "name": "7CLW"
  },
  {
    "id": "J2NF",
    "x": 50.489,
    "y": 14.193,
    "width": 1,
    "height": 2,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.017742,
      "w": 0.99984
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad6e",
        "height": 0.30978,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6416",
            "leftCorner": {
              "x": 50.489,
              "y": 14.191,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.579,
              "y": 14.194,
              "z": 0.30978
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011700740000"
          },
          {
            "id": "679afb3f3d9bab0f83ff6417",
            "leftCorner": {
              "x": 50.579,
              "y": 14.194,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.616,
              "y": 14.195,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700740154"
          },
          {
            "id": "679afb3f3d9bab0f83ff6418",
            "leftCorner": {
              "x": 50.616,
              "y": 14.195,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.664,
              "y": 14.197,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700740154"
          },
          {
            "id": "679afb3f3d9bab0f83ff6419",
            "leftCorner": {
              "x": 50.664,
              "y": 14.197,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.723,
              "y": 14.199,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700740079"
          },
          {
            "id": "679afb3f3d9bab0f83ff641a",
            "leftCorner": {
              "x": 50.723,
              "y": 14.199,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.797,
              "y": 14.202,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700313143"
          },
          {
            "id": "679afb3f3d9bab0f83ff641b",
            "leftCorner": {
              "x": 50.797,
              "y": 14.202,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.877,
              "y": 14.204,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3607346511107"
          },
          {
            "id": "679afb3f3d9bab0f83ff641c",
            "leftCorner": {
              "x": 50.877,
              "y": 14.204,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 50.948,
              "y": 14.207,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3607346516737"
          },
          {
            "id": "679afb3f3d9bab0f83ff641d",
            "leftCorner": {
              "x": 50.948,
              "y": 14.207,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.016,
              "y": 14.209,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "35017008947"
          },
          {
            "id": "679afb3f3d9bab0f83ff641e",
            "leftCorner": {
              "x": 51.016,
              "y": 14.209,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.087,
              "y": 14.212,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8005610325569"
          },
          {
            "id": "679afb3f3d9bab0f83ff641f",
            "leftCorner": {
              "x": 51.087,
              "y": 14.212,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.159,
              "y": 14.214,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5050456079773"
          },
          {
            "id": "679afb3f3d9bab0f83ff6420",
            "leftCorner": {
              "x": 51.159,
              "y": 14.214,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.214,
              "y": 14.216,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5050456053827"
          },
          {
            "id": "679afb3f3d9bab0f83ff6421",
            "leftCorner": {
              "x": 51.214,
              "y": 14.216,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.266,
              "y": 14.218,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3326240005320"
          },
          {
            "id": "679afb3f3d9bab0f83ff6422",
            "leftCorner": {
              "x": 51.266,
              "y": 14.218,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.342,
              "y": 14.221,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3326240036690"
          },
          {
            "id": "679afb3f3d9bab0f83ff6423",
            "leftCorner": {
              "x": 51.342,
              "y": 14.221,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.414,
              "y": 14.223,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3326240003814"
          },
          {
            "id": "679afb3f3d9bab0f83ff6424",
            "leftCorner": {
              "x": 51.414,
              "y": 14.223,
              "z": 0.30978
            },
            "rightCorner": {
              "x": 51.486,
              "y": 14.226,
              "z": 0.30978
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3326240005368"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad6c",
        "height": 0.54952,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63f9",
            "leftCorner": {
              "x": 50.489,
              "y": 14.182,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.587,
              "y": 14.186,
              "z": 0.54952
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9120058162534"
          },
          {
            "id": "679afb3f3d9bab0f83ff63fb",
            "leftCorner": {
              "x": 50.587,
              "y": 14.186,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.672,
              "y": 14.189,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112222754"
          },
          {
            "id": "679afb3f3d9bab0f83ff63fc",
            "leftCorner": {
              "x": 50.672,
              "y": 14.189,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.76,
              "y": 14.192,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63fd",
            "leftCorner": {
              "x": 50.76,
              "y": 14.192,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.845,
              "y": 14.195,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130820321"
          },
          {
            "id": "679afb3f3d9bab0f83ff63fe",
            "leftCorner": {
              "x": 50.845,
              "y": 14.195,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.905,
              "y": 14.197,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112227919"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ff",
            "leftCorner": {
              "x": 50.905,
              "y": 14.197,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 50.961,
              "y": 14.199,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112227919"
          },
          {
            "id": "679afb3f3d9bab0f83ff6400",
            "leftCorner": {
              "x": 50.961,
              "y": 14.199,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.015,
              "y": 14.201,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112227919"
          },
          {
            "id": "679afb3f3d9bab0f83ff6401",
            "leftCorner": {
              "x": 51.015,
              "y": 14.201,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.072,
              "y": 14.203,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6402",
            "leftCorner": {
              "x": 51.072,
              "y": 14.203,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.127,
              "y": 14.205,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112221320"
          },
          {
            "id": "679afb3f3d9bab0f83ff6403",
            "leftCorner": {
              "x": 51.127,
              "y": 14.205,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.182,
              "y": 14.207,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229432"
          },
          {
            "id": "679afb3f3d9bab0f83ff6404",
            "leftCorner": {
              "x": 51.182,
              "y": 14.207,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.239,
              "y": 14.209,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120082226899"
          },
          {
            "id": "679afb3f3d9bab0f83ff6405",
            "leftCorner": {
              "x": 51.239,
              "y": 14.209,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.306,
              "y": 14.211,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6406",
            "leftCorner": {
              "x": 51.306,
              "y": 14.211,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.369,
              "y": 14.214,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5903719643276"
          },
          {
            "id": "679afb3f3d9bab0f83ff6407",
            "leftCorner": {
              "x": 51.369,
              "y": 14.214,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.442,
              "y": 14.216,
              "z": 0.54952
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5903719643481"
          },
          {
            "id": "679afb3f3d9bab0f83ff63fa",
            "leftCorner": {
              "x": 51.442,
              "y": 14.216,
              "z": 0.54952
            },
            "rightCorner": {
              "x": 51.489,
              "y": 14.218,
              "z": 0.54952
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5903719643481"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad6d",
        "height": 0.79982,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6408",
            "leftCorner": {
              "x": 50.489,
              "y": 14.19,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.567,
              "y": 14.193,
              "z": 0.79982
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011700747801"
          },
          {
            "id": "679afb3f3d9bab0f83ff6409",
            "leftCorner": {
              "x": 50.567,
              "y": 14.193,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.633,
              "y": 14.196,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700749232"
          },
          {
            "id": "679afb3f3d9bab0f83ff640a",
            "leftCorner": {
              "x": 50.633,
              "y": 14.196,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.696,
              "y": 14.198,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970057811"
          },
          {
            "id": "679afb3f3d9bab0f83ff640b",
            "leftCorner": {
              "x": 50.696,
              "y": 14.198,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.767,
              "y": 14.2,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8008970058634"
          },
          {
            "id": "679afb3f3d9bab0f83ff640c",
            "leftCorner": {
              "x": 50.767,
              "y": 14.2,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.847,
              "y": 14.203,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112229227"
          },
          {
            "id": "679afb3f3d9bab0f83ff640d",
            "leftCorner": {
              "x": 50.847,
              "y": 14.203,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.931,
              "y": 14.206,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112225809"
          },
          {
            "id": "679afb3f3d9bab0f83ff640e",
            "leftCorner": {
              "x": 50.931,
              "y": 14.206,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 50.992,
              "y": 14.208,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172230127"
          },
          {
            "id": "679afb3f3d9bab0f83ff640f",
            "leftCorner": {
              "x": 50.992,
              "y": 14.208,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.051,
              "y": 14.21,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172229350"
          },
          {
            "id": "679afb3f3d9bab0f83ff6410",
            "leftCorner": {
              "x": 51.051,
              "y": 14.21,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.11,
              "y": 14.212,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172229299"
          },
          {
            "id": "679afb3f3d9bab0f83ff6411",
            "leftCorner": {
              "x": 51.11,
              "y": 14.212,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.186,
              "y": 14.215,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395241116"
          },
          {
            "id": "679afb3f3d9bab0f83ff6412",
            "leftCorner": {
              "x": 51.186,
              "y": 14.215,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.273,
              "y": 14.218,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395251108"
          },
          {
            "id": "679afb3f3d9bab0f83ff6413",
            "leftCorner": {
              "x": 51.273,
              "y": 14.218,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.339,
              "y": 14.221,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395251115"
          },
          {
            "id": "679afb3f3d9bab0f83ff6414",
            "leftCorner": {
              "x": 51.339,
              "y": 14.221,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.412,
              "y": 14.223,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395261114"
          },
          {
            "id": "679afb3f3d9bab0f83ff6415",
            "leftCorner": {
              "x": 51.412,
              "y": 14.223,
              "z": 0.79982
            },
            "rightCorner": {
              "x": 51.477,
              "y": 14.226,
              "z": 0.79982
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395281129"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad71",
        "height": 1.0523,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6443",
            "leftCorner": {
              "x": 50.489,
              "y": 14.189,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.572,
              "y": 14.192,
              "z": 1.0523
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011700310449"
          },
          {
            "id": "679afb3f3d9bab0f83ff6444",
            "leftCorner": {
              "x": 50.572,
              "y": 14.192,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.637,
              "y": 14.194,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6445",
            "leftCorner": {
              "x": 50.637,
              "y": 14.194,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.707,
              "y": 14.197,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6446",
            "leftCorner": {
              "x": 50.707,
              "y": 14.197,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.759,
              "y": 14.198,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6447",
            "leftCorner": {
              "x": 50.759,
              "y": 14.198,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.844,
              "y": 14.201,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700855001"
          },
          {
            "id": "679afb3f3d9bab0f83ff6448",
            "leftCorner": {
              "x": 50.844,
              "y": 14.201,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.933,
              "y": 14.205,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6449",
            "leftCorner": {
              "x": 50.933,
              "y": 14.205,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 50.986,
              "y": 14.206,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700855032"
          },
          {
            "id": "679afb3f3d9bab0f83ff644a",
            "leftCorner": {
              "x": 50.986,
              "y": 14.206,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.047,
              "y": 14.209,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700886005"
          },
          {
            "id": "679afb3f3d9bab0f83ff644b",
            "leftCorner": {
              "x": 51.047,
              "y": 14.209,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.108,
              "y": 14.211,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700886029"
          },
          {
            "id": "679afb3f3d9bab0f83ff644c",
            "leftCorner": {
              "x": 51.108,
              "y": 14.211,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.177,
              "y": 14.213,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff644d",
            "leftCorner": {
              "x": 51.177,
              "y": 14.213,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.246,
              "y": 14.216,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff644e",
            "leftCorner": {
              "x": 51.246,
              "y": 14.216,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.322,
              "y": 14.218,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395171130"
          },
          {
            "id": "679afb3f3d9bab0f83ff644f",
            "leftCorner": {
              "x": 51.322,
              "y": 14.218,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.4,
              "y": 14.221,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395141133"
          },
          {
            "id": "679afb3f3d9bab0f83ff6450",
            "leftCorner": {
              "x": 51.4,
              "y": 14.221,
              "z": 1.0523
            },
            "rightCorner": {
              "x": 51.477,
              "y": 14.224,
              "z": 1.0523
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395171116"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad70",
        "height": 1.3011,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6435",
            "leftCorner": {
              "x": 50.489,
              "y": 14.19,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.581,
              "y": 14.193,
              "z": 1.3011
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4011700337118"
          },
          {
            "id": "679afb3f3d9bab0f83ff6436",
            "leftCorner": {
              "x": 50.581,
              "y": 14.193,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.653,
              "y": 14.195,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700339006"
          },
          {
            "id": "679afb3f3d9bab0f83ff6437",
            "leftCorner": {
              "x": 50.653,
              "y": 14.195,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.728,
              "y": 14.198,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700339006"
          },
          {
            "id": "679afb3f3d9bab0f83ff6438",
            "leftCorner": {
              "x": 50.728,
              "y": 14.198,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.805,
              "y": 14.201,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700339006"
          },
          {
            "id": "679afb3f3d9bab0f83ff6439",
            "leftCorner": {
              "x": 50.805,
              "y": 14.201,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.879,
              "y": 14.203,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700341009"
          },
          {
            "id": "679afb3f3d9bab0f83ff643a",
            "leftCorner": {
              "x": 50.879,
              "y": 14.203,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 50.96,
              "y": 14.206,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700820054"
          },
          {
            "id": "679afb3f3d9bab0f83ff643b",
            "leftCorner": {
              "x": 50.96,
              "y": 14.206,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.034,
              "y": 14.209,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700820054"
          },
          {
            "id": "679afb3f3d9bab0f83ff643c",
            "leftCorner": {
              "x": 51.034,
              "y": 14.209,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.081,
              "y": 14.211,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff643d",
            "leftCorner": {
              "x": 51.081,
              "y": 14.211,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.15,
              "y": 14.213,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff643e",
            "leftCorner": {
              "x": 51.15,
              "y": 14.213,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.222,
              "y": 14.216,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700822010"
          },
          {
            "id": "679afb3f3d9bab0f83ff643f",
            "leftCorner": {
              "x": 51.222,
              "y": 14.216,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.307,
              "y": 14.219,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700896011"
          },
          {
            "id": "679afb3f3d9bab0f83ff6440",
            "leftCorner": {
              "x": 51.307,
              "y": 14.219,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.371,
              "y": 14.221,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700879052"
          },
          {
            "id": "679afb3f3d9bab0f83ff6441",
            "leftCorner": {
              "x": 51.371,
              "y": 14.221,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.429,
              "y": 14.223,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700879045"
          },
          {
            "id": "679afb3f3d9bab0f83ff6442",
            "leftCorner": {
              "x": 51.429,
              "y": 14.223,
              "z": 1.3011
            },
            "rightCorner": {
              "x": 51.477,
              "y": 14.225,
              "z": 1.3011
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616305169068"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad6f",
        "height": 1.5553,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6425",
            "leftCorner": {
              "x": 50.489,
              "y": 14.186,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.555,
              "y": 14.188,
              "z": 1.5553
            },
            "stockLevel": "UNKNOWN",
            "gtin": "719346643870"
          },
          {
            "id": "679afb3f3d9bab0f83ff6426",
            "leftCorner": {
              "x": 50.555,
              "y": 14.188,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.607,
              "y": 14.19,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6427",
            "leftCorner": {
              "x": 50.607,
              "y": 14.19,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.657,
              "y": 14.192,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6428",
            "leftCorner": {
              "x": 50.657,
              "y": 14.192,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.709,
              "y": 14.194,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6429",
            "leftCorner": {
              "x": 50.709,
              "y": 14.194,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.761,
              "y": 14.196,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346260404"
          },
          {
            "id": "679afb3f3d9bab0f83ff642a",
            "leftCorner": {
              "x": 50.761,
              "y": 14.196,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.814,
              "y": 14.197,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346251235"
          },
          {
            "id": "679afb3f3d9bab0f83ff642b",
            "leftCorner": {
              "x": 50.814,
              "y": 14.197,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.864,
              "y": 14.199,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346251228"
          },
          {
            "id": "679afb3f3d9bab0f83ff642c",
            "leftCorner": {
              "x": 50.864,
              "y": 14.199,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.919,
              "y": 14.201,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346251228"
          },
          {
            "id": "679afb3f3d9bab0f83ff642d",
            "leftCorner": {
              "x": 50.919,
              "y": 14.201,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 50.979,
              "y": 14.203,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346295499"
          },
          {
            "id": "679afb3f3d9bab0f83ff642e",
            "leftCorner": {
              "x": 50.979,
              "y": 14.203,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.028,
              "y": 14.205,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff642f",
            "leftCorner": {
              "x": 51.028,
              "y": 14.205,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.088,
              "y": 14.207,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "719346298117"
          },
          {
            "id": "679afb3f3d9bab0f83ff6430",
            "leftCorner": {
              "x": 51.088,
              "y": 14.207,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.148,
              "y": 14.209,
              "z": 1.5553
            },
            "stockLevel": "UNKNOWN",
            "gtin": "719346298117"
          },
          {
            "id": "679afb3f3d9bab0f83ff6431",
            "leftCorner": {
              "x": 51.148,
              "y": 14.209,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.244,
              "y": 14.213,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4051395511158"
          },
          {
            "id": "679afb3f3d9bab0f83ff6432",
            "leftCorner": {
              "x": 51.244,
              "y": 14.213,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.331,
              "y": 14.216,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700848003"
          },
          {
            "id": "679afb3f3d9bab0f83ff6433",
            "leftCorner": {
              "x": 51.331,
              "y": 14.216,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.417,
              "y": 14.219,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4011700848010"
          },
          {
            "id": "679afb3f3d9bab0f83ff6434",
            "leftCorner": {
              "x": 51.417,
              "y": 14.219,
              "z": 1.5553
            },
            "rightCorner": {
              "x": 51.481,
              "y": 14.221,
              "z": 1.5553
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616305169471"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 80,
      "unknownStockCount": 8
    },
    "name": "J2NF",
    "rightNeighborShelfId": "CL5L"
  },
  {
    "id": "J7M1",
    "x": 49.062,
    "y": 7.8203,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.88201,
      "w": -0.47124
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad75",
        "height": 0.15981,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6475",
            "leftCorner": {
              "x": 48.984,
              "y": 7.8724,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.94,
              "y": 7.807,
              "z": 0.15981
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796148763"
          },
          {
            "id": "679afb3f3d9bab0f83ff6477",
            "leftCorner": {
              "x": 48.94,
              "y": 7.807,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.914,
              "y": 7.7685,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796148763"
          },
          {
            "id": "679afb3f3d9bab0f83ff6478",
            "leftCorner": {
              "x": 48.914,
              "y": 7.7685,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.888,
              "y": 7.7286,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411140"
          },
          {
            "id": "679afb3f3d9bab0f83ff6479",
            "leftCorner": {
              "x": 48.888,
              "y": 7.7286,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.846,
              "y": 7.6659,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447411140"
          },
          {
            "id": "679afb3f3d9bab0f83ff647a",
            "leftCorner": {
              "x": 48.846,
              "y": 7.6659,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.808,
              "y": 7.6095,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff647b",
            "leftCorner": {
              "x": 48.808,
              "y": 7.6095,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.783,
              "y": 7.5723,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff647c",
            "leftCorner": {
              "x": 48.783,
              "y": 7.5723,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.754,
              "y": 7.5286,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff647d",
            "leftCorner": {
              "x": 48.754,
              "y": 7.5286,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.729,
              "y": 7.4917,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff647e",
            "leftCorner": {
              "x": 48.729,
              "y": 7.4917,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.691,
              "y": 7.434,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff647f",
            "leftCorner": {
              "x": 48.691,
              "y": 7.434,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.655,
              "y": 7.3808,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6480",
            "leftCorner": {
              "x": 48.655,
              "y": 7.3808,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.628,
              "y": 7.3402,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439939"
          },
          {
            "id": "679afb3f3d9bab0f83ff6481",
            "leftCorner": {
              "x": 48.628,
              "y": 7.3402,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.603,
              "y": 7.3025,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439939"
          },
          {
            "id": "679afb3f3d9bab0f83ff6482",
            "leftCorner": {
              "x": 48.603,
              "y": 7.3025,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.584,
              "y": 7.2742,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6483",
            "leftCorner": {
              "x": 48.584,
              "y": 7.2742,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.546,
              "y": 7.2169,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6484",
            "leftCorner": {
              "x": 48.546,
              "y": 7.2169,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.501,
              "y": 7.1504,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6485",
            "leftCorner": {
              "x": 48.501,
              "y": 7.1504,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.475,
              "y": 7.1119,
              "z": 0.15981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6476",
            "leftCorner": {
              "x": 48.475,
              "y": 7.1119,
              "z": 0.15981
            },
            "rightCorner": {
              "x": 48.428,
              "y": 7.0411,
              "z": 0.15981
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad77",
        "height": 0.41815,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6492",
            "leftCorner": {
              "x": 49.08,
              "y": 7.8079,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 49.047,
              "y": 7.7579,
              "z": 0.41815
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6494",
            "leftCorner": {
              "x": 49.047,
              "y": 7.7579,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.903,
              "y": 7.5426,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447231052"
          },
          {
            "id": "679afb3f3d9bab0f83ff6495",
            "leftCorner": {
              "x": 48.903,
              "y": 7.5426,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.884,
              "y": 7.5147,
              "z": 0.41815
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447377125"
          },
          {
            "id": "679afb3f3d9bab0f83ff6496",
            "leftCorner": {
              "x": 48.884,
              "y": 7.5147,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.831,
              "y": 7.4359,
              "z": 0.41815
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447377125"
          },
          {
            "id": "679afb3f3d9bab0f83ff6497",
            "leftCorner": {
              "x": 48.831,
              "y": 7.4359,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.806,
              "y": 7.3977,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6498",
            "leftCorner": {
              "x": 48.806,
              "y": 7.3977,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.75,
              "y": 7.3143,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6499",
            "leftCorner": {
              "x": 48.75,
              "y": 7.3143,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.722,
              "y": 7.2717,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375947"
          },
          {
            "id": "679afb3f3d9bab0f83ff649a",
            "leftCorner": {
              "x": 48.722,
              "y": 7.2717,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.696,
              "y": 7.2337,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff649b",
            "leftCorner": {
              "x": 48.696,
              "y": 7.2337,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.673,
              "y": 7.1984,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff649c",
            "leftCorner": {
              "x": 48.673,
              "y": 7.1984,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.612,
              "y": 7.1082,
              "z": 0.41815
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447231076"
          },
          {
            "id": "679afb3f3d9bab0f83ff649d",
            "leftCorner": {
              "x": 48.612,
              "y": 7.1082,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.558,
              "y": 7.0272,
              "z": 0.41815
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6493",
            "leftCorner": {
              "x": 48.558,
              "y": 7.0272,
              "z": 0.41815
            },
            "rightCorner": {
              "x": 48.524,
              "y": 6.9766,
              "z": 0.41815
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad74",
        "height": 0.67128,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff646a",
            "leftCorner": {
              "x": 49.08,
              "y": 7.8078,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 49.026,
              "y": 7.7264,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045612009993"
          },
          {
            "id": "679afb3f3d9bab0f83ff646c",
            "leftCorner": {
              "x": 49.026,
              "y": 7.7264,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.958,
              "y": 7.6254,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045612007036"
          },
          {
            "id": "679afb3f3d9bab0f83ff646d",
            "leftCorner": {
              "x": 48.958,
              "y": 7.6254,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.884,
              "y": 7.5137,
              "z": 0.67128
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013718021898"
          },
          {
            "id": "679afb3f3d9bab0f83ff646e",
            "leftCorner": {
              "x": 48.884,
              "y": 7.5137,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.835,
              "y": 7.4414,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000196031099"
          },
          {
            "id": "679afb3f3d9bab0f83ff646f",
            "leftCorner": {
              "x": 48.835,
              "y": 7.4414,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.786,
              "y": 7.3678,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6470",
            "leftCorner": {
              "x": 48.786,
              "y": 7.3678,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.735,
              "y": 7.2907,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4000196031136"
          },
          {
            "id": "679afb3f3d9bab0f83ff6471",
            "leftCorner": {
              "x": 48.735,
              "y": 7.2907,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.663,
              "y": 7.183,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000057927"
          },
          {
            "id": "679afb3f3d9bab0f83ff6472",
            "leftCorner": {
              "x": 48.663,
              "y": 7.183,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.637,
              "y": 7.1452,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100302936"
          },
          {
            "id": "679afb3f3d9bab0f83ff6473",
            "leftCorner": {
              "x": 48.637,
              "y": 7.1452,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.616,
              "y": 7.1134,
              "z": 0.67128
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100302936"
          },
          {
            "id": "679afb3f3d9bab0f83ff6474",
            "leftCorner": {
              "x": 48.616,
              "y": 7.1134,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.571,
              "y": 7.0458,
              "z": 0.67128
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5704947015138"
          },
          {
            "id": "679afb3f3d9bab0f83ff646b",
            "leftCorner": {
              "x": 48.571,
              "y": 7.0458,
              "z": 0.67128
            },
            "rightCorner": {
              "x": 48.525,
              "y": 6.9765,
              "z": 0.67128
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5704947015138"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad73",
        "height": 0.92445,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff645f",
            "leftCorner": {
              "x": 49.076,
              "y": 7.8106,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 49.024,
              "y": 7.7326,
              "z": 0.92445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260602123026"
          },
          {
            "id": "679afb3f3d9bab0f83ff6461",
            "leftCorner": {
              "x": 49.024,
              "y": 7.7326,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.905,
              "y": 7.5541,
              "z": 0.92445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8008970060200"
          },
          {
            "id": "679afb3f3d9bab0f83ff6462",
            "leftCorner": {
              "x": 48.905,
              "y": 7.5541,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.77,
              "y": 7.352,
              "z": 0.92445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42390039"
          },
          {
            "id": "679afb3f3d9bab0f83ff6463",
            "leftCorner": {
              "x": 48.77,
              "y": 7.352,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.743,
              "y": 7.3118,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42417514"
          },
          {
            "id": "679afb3f3d9bab0f83ff6464",
            "leftCorner": {
              "x": 48.743,
              "y": 7.3118,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.718,
              "y": 7.2747,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42398172"
          },
          {
            "id": "679afb3f3d9bab0f83ff6465",
            "leftCorner": {
              "x": 48.718,
              "y": 7.2747,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.692,
              "y": 7.2354,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42398172"
          },
          {
            "id": "679afb3f3d9bab0f83ff6466",
            "leftCorner": {
              "x": 48.692,
              "y": 7.2354,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.668,
              "y": 7.2,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661687049"
          },
          {
            "id": "679afb3f3d9bab0f83ff6467",
            "leftCorner": {
              "x": 48.668,
              "y": 7.2,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.644,
              "y": 7.1648,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661687018"
          },
          {
            "id": "679afb3f3d9bab0f83ff6468",
            "leftCorner": {
              "x": 48.644,
              "y": 7.1648,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.61,
              "y": 7.1135,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661685977"
          },
          {
            "id": "679afb3f3d9bab0f83ff6469",
            "leftCorner": {
              "x": 48.61,
              "y": 7.1135,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.565,
              "y": 7.0464,
              "z": 0.92445
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661685977"
          },
          {
            "id": "679afb3f3d9bab0f83ff6460",
            "leftCorner": {
              "x": 48.565,
              "y": 7.0464,
              "z": 0.92445
            },
            "rightCorner": {
              "x": 48.52,
              "y": 6.9793,
              "z": 0.92445
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661685977"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad76",
        "height": 1.1816,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6486",
            "leftCorner": {
              "x": 49.075,
              "y": 7.8112,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 49.012,
              "y": 7.7169,
              "z": 1.1816
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447348507"
          },
          {
            "id": "679afb3f3d9bab0f83ff6488",
            "leftCorner": {
              "x": 49.012,
              "y": 7.7169,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.954,
              "y": 7.6305,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447348507"
          },
          {
            "id": "679afb3f3d9bab0f83ff6489",
            "leftCorner": {
              "x": 48.954,
              "y": 7.6305,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.897,
              "y": 7.5447,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447078589"
          },
          {
            "id": "679afb3f3d9bab0f83ff648a",
            "leftCorner": {
              "x": 48.897,
              "y": 7.5447,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.839,
              "y": 7.4574,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447078589"
          },
          {
            "id": "679afb3f3d9bab0f83ff648b",
            "leftCorner": {
              "x": 48.839,
              "y": 7.4574,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.775,
              "y": 7.3618,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668032"
          },
          {
            "id": "679afb3f3d9bab0f83ff648c",
            "leftCorner": {
              "x": 48.775,
              "y": 7.3618,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.742,
              "y": 7.3122,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181090899"
          },
          {
            "id": "679afb3f3d9bab0f83ff648d",
            "leftCorner": {
              "x": 48.742,
              "y": 7.3122,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.716,
              "y": 7.2743,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600551043203"
          },
          {
            "id": "679afb3f3d9bab0f83ff648e",
            "leftCorner": {
              "x": 48.716,
              "y": 7.2743,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.688,
              "y": 7.2319,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040909763"
          },
          {
            "id": "679afb3f3d9bab0f83ff648f",
            "leftCorner": {
              "x": 48.688,
              "y": 7.2319,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.663,
              "y": 7.1952,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040909763"
          },
          {
            "id": "679afb3f3d9bab0f83ff6490",
            "leftCorner": {
              "x": 48.663,
              "y": 7.1952,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.572,
              "y": 7.0584,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276688"
          },
          {
            "id": "679afb3f3d9bab0f83ff6491",
            "leftCorner": {
              "x": 48.572,
              "y": 7.0584,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.548,
              "y": 7.0219,
              "z": 1.1816
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6487",
            "leftCorner": {
              "x": 48.548,
              "y": 7.0219,
              "z": 1.1816
            },
            "rightCorner": {
              "x": 48.519,
              "y": 6.9799,
              "z": 1.1816
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad72",
        "height": 1.4325,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6451",
            "leftCorner": {
              "x": 49.078,
              "y": 7.8093,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 49.044,
              "y": 7.7584,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42485339"
          },
          {
            "id": "679afb3f3d9bab0f83ff6452",
            "leftCorner": {
              "x": 49.044,
              "y": 7.7584,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 49.02,
              "y": 7.7217,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "1000036"
          },
          {
            "id": "679afb3f3d9bab0f83ff6453",
            "leftCorner": {
              "x": 49.02,
              "y": 7.7217,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.996,
              "y": 7.6858,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42468073"
          },
          {
            "id": "679afb3f3d9bab0f83ff6454",
            "leftCorner": {
              "x": 48.996,
              "y": 7.6858,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.9,
              "y": 7.5429,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447787979"
          },
          {
            "id": "679afb3f3d9bab0f83ff6455",
            "leftCorner": {
              "x": 48.9,
              "y": 7.5429,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.877,
              "y": 7.5082,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447787979"
          },
          {
            "id": "679afb3f3d9bab0f83ff6456",
            "leftCorner": {
              "x": 48.877,
              "y": 7.5082,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.743,
              "y": 7.3077,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260560835955"
          },
          {
            "id": "679afb3f3d9bab0f83ff6457",
            "leftCorner": {
              "x": 48.743,
              "y": 7.3077,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.718,
              "y": 7.2705,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457645022"
          },
          {
            "id": "679afb3f3d9bab0f83ff6458",
            "leftCorner": {
              "x": 48.718,
              "y": 7.2705,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.704,
              "y": 7.2495,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6459",
            "leftCorner": {
              "x": 48.704,
              "y": 7.2495,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.683,
              "y": 7.2176,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089081289"
          },
          {
            "id": "679afb3f3d9bab0f83ff645a",
            "leftCorner": {
              "x": 48.683,
              "y": 7.2176,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.659,
              "y": 7.1828,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089081319"
          },
          {
            "id": "679afb3f3d9bab0f83ff645b",
            "leftCorner": {
              "x": 48.659,
              "y": 7.1828,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.627,
              "y": 7.1347,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638523028"
          },
          {
            "id": "679afb3f3d9bab0f83ff645c",
            "leftCorner": {
              "x": 48.627,
              "y": 7.1347,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.587,
              "y": 7.0741,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638088459"
          },
          {
            "id": "679afb3f3d9bab0f83ff645d",
            "leftCorner": {
              "x": 48.587,
              "y": 7.0741,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.558,
              "y": 7.0311,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff645e",
            "leftCorner": {
              "x": 48.558,
              "y": 7.0311,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 48.54,
              "y": 7.0044,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 56,
      "unknownStockCount": 21
    },
    "name": "J7M1",
    "rightNeighborShelfId": "OLCA"
  },
  {
    "id": "IOFL",
    "x": 49.457,
    "y": 6.4493,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.48969,
      "w": 0.8719
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad79",
        "height": 0.15696,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff612a",
            "leftCorner": {
              "x": 49.542,
              "y": 6.3974,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.575,
              "y": 6.4508,
              "z": 0.15696
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4013162018024"
          },
          {
            "id": "679afb3e3d9bab0f83ff612c",
            "leftCorner": {
              "x": 49.575,
              "y": 6.4508,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.611,
              "y": 6.5104,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162018024"
          },
          {
            "id": "679afb3e3d9bab0f83ff612d",
            "leftCorner": {
              "x": 49.611,
              "y": 6.5104,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.638,
              "y": 6.5548,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162018024"
          },
          {
            "id": "679afb3e3d9bab0f83ff612e",
            "leftCorner": {
              "x": 49.638,
              "y": 6.5548,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.66,
              "y": 6.5901,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162008216"
          },
          {
            "id": "679afb3e3d9bab0f83ff612f",
            "leftCorner": {
              "x": 49.66,
              "y": 6.5901,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.693,
              "y": 6.6452,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162008216"
          },
          {
            "id": "679afb3e3d9bab0f83ff6130",
            "leftCorner": {
              "x": 49.693,
              "y": 6.6452,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.743,
              "y": 6.7268,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008455606613"
          },
          {
            "id": "679afb3e3d9bab0f83ff6131",
            "leftCorner": {
              "x": 49.743,
              "y": 6.7268,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.797,
              "y": 6.8148,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7322540840612"
          },
          {
            "id": "679afb3e3d9bab0f83ff6132",
            "leftCorner": {
              "x": 49.797,
              "y": 6.8148,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.863,
              "y": 6.9236,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447375039"
          },
          {
            "id": "679afb3e3d9bab0f83ff6133",
            "leftCorner": {
              "x": 49.863,
              "y": 6.9236,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.948,
              "y": 7.0628,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172770227"
          },
          {
            "id": "679afb3e3d9bab0f83ff6134",
            "leftCorner": {
              "x": 49.948,
              "y": 7.0628,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.973,
              "y": 7.1046,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172895067"
          },
          {
            "id": "679afb3e3d9bab0f83ff6135",
            "leftCorner": {
              "x": 49.973,
              "y": 7.1046,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 49.997,
              "y": 7.1437,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172895067"
          },
          {
            "id": "679afb3e3d9bab0f83ff6136",
            "leftCorner": {
              "x": 49.997,
              "y": 7.1437,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 50.021,
              "y": 7.1831,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172895067"
          },
          {
            "id": "679afb3e3d9bab0f83ff6137",
            "leftCorner": {
              "x": 50.021,
              "y": 7.1831,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 50.046,
              "y": 7.2234,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172895067"
          },
          {
            "id": "679afb3e3d9bab0f83ff6138",
            "leftCorner": {
              "x": 50.046,
              "y": 7.2234,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 50.06,
              "y": 7.2467,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7a",
        "height": 0.41249,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff616d",
            "leftCorner": {
              "x": 49.449,
              "y": 6.4539,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.48,
              "y": 6.5041,
              "z": 0.41249
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff616f",
            "leftCorner": {
              "x": 49.48,
              "y": 6.5041,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.516,
              "y": 6.563,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6170",
            "leftCorner": {
              "x": 49.516,
              "y": 6.563,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.54,
              "y": 6.6025,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6171",
            "leftCorner": {
              "x": 49.54,
              "y": 6.6025,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.562,
              "y": 6.6386,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6172",
            "leftCorner": {
              "x": 49.562,
              "y": 6.6386,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.577,
              "y": 6.6634,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6173",
            "leftCorner": {
              "x": 49.577,
              "y": 6.6634,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.6,
              "y": 6.7019,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925696"
          },
          {
            "id": "679afb3e3d9bab0f83ff6174",
            "leftCorner": {
              "x": 49.6,
              "y": 6.7019,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.62,
              "y": 6.7335,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925696"
          },
          {
            "id": "679afb3e3d9bab0f83ff6175",
            "leftCorner": {
              "x": 49.62,
              "y": 6.7335,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.645,
              "y": 6.7754,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925757"
          },
          {
            "id": "679afb3e3d9bab0f83ff6176",
            "leftCorner": {
              "x": 49.645,
              "y": 6.7754,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.669,
              "y": 6.8149,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925757"
          },
          {
            "id": "679afb3e3d9bab0f83ff6177",
            "leftCorner": {
              "x": 49.669,
              "y": 6.8149,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.7,
              "y": 6.8651,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800383207"
          },
          {
            "id": "679afb3e3d9bab0f83ff6178",
            "leftCorner": {
              "x": 49.7,
              "y": 6.8651,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.736,
              "y": 6.9239,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42269663"
          },
          {
            "id": "679afb3e3d9bab0f83ff6179",
            "leftCorner": {
              "x": 49.736,
              "y": 6.9239,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.769,
              "y": 6.9778,
              "z": 0.41249
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42269663"
          },
          {
            "id": "679afb3e3d9bab0f83ff617a",
            "leftCorner": {
              "x": 49.769,
              "y": 6.9778,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.799,
              "y": 7.0271,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239553"
          },
          {
            "id": "679afb3e3d9bab0f83ff617b",
            "leftCorner": {
              "x": 49.799,
              "y": 7.0271,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.836,
              "y": 7.088,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239553"
          },
          {
            "id": "679afb3e3d9bab0f83ff617c",
            "leftCorner": {
              "x": 49.836,
              "y": 7.088,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.873,
              "y": 7.1486,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239553"
          },
          {
            "id": "679afb3e3d9bab0f83ff617d",
            "leftCorner": {
              "x": 49.873,
              "y": 7.1486,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.897,
              "y": 7.1879,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717163767092"
          },
          {
            "id": "679afb3e3d9bab0f83ff617e",
            "leftCorner": {
              "x": 49.897,
              "y": 7.1879,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.922,
              "y": 7.2295,
              "z": 0.41249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717163767092"
          },
          {
            "id": "679afb3e3d9bab0f83ff617f",
            "leftCorner": {
              "x": 49.922,
              "y": 7.2295,
              "z": 0.41249
            },
            "rightCorner": {
              "x": 49.97,
              "y": 7.3079,
              "z": 0.41249
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42429173"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7b",
        "height": 0.66792,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff614f",
            "leftCorner": {
              "x": 49.45,
              "y": 6.4535,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.473,
              "y": 6.4912,
              "z": 0.66792
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6151",
            "leftCorner": {
              "x": 49.473,
              "y": 6.4912,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.509,
              "y": 6.5501,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6152",
            "leftCorner": {
              "x": 49.509,
              "y": 6.5501,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.527,
              "y": 6.5803,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6153",
            "leftCorner": {
              "x": 49.527,
              "y": 6.5803,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.554,
              "y": 6.6237,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6154",
            "leftCorner": {
              "x": 49.554,
              "y": 6.6237,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.578,
              "y": 6.6643,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6155",
            "leftCorner": {
              "x": 49.578,
              "y": 6.6643,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.6,
              "y": 6.7004,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6156",
            "leftCorner": {
              "x": 49.6,
              "y": 6.7004,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.622,
              "y": 6.7351,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6157",
            "leftCorner": {
              "x": 49.622,
              "y": 6.7351,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.644,
              "y": 6.7721,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234374"
          },
          {
            "id": "679afb3e3d9bab0f83ff6158",
            "leftCorner": {
              "x": 49.644,
              "y": 6.7721,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.666,
              "y": 6.8083,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234374"
          },
          {
            "id": "679afb3e3d9bab0f83ff6159",
            "leftCorner": {
              "x": 49.666,
              "y": 6.8083,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.689,
              "y": 6.8455,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714418"
          },
          {
            "id": "679afb3e3d9bab0f83ff615a",
            "leftCorner": {
              "x": 49.689,
              "y": 6.8455,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.712,
              "y": 6.8828,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447714418"
          },
          {
            "id": "679afb3e3d9bab0f83ff615b",
            "leftCorner": {
              "x": 49.712,
              "y": 6.8828,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.738,
              "y": 6.9259,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42429166"
          },
          {
            "id": "679afb3e3d9bab0f83ff615c",
            "leftCorner": {
              "x": 49.738,
              "y": 6.9259,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.766,
              "y": 6.9714,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42429166"
          },
          {
            "id": "679afb3e3d9bab0f83ff615d",
            "leftCorner": {
              "x": 49.766,
              "y": 6.9714,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.789,
              "y": 7.0106,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42429166"
          },
          {
            "id": "679afb3e3d9bab0f83ff615e",
            "leftCorner": {
              "x": 49.789,
              "y": 7.0106,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.817,
              "y": 7.0558,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181505515"
          },
          {
            "id": "679afb3e3d9bab0f83ff615f",
            "leftCorner": {
              "x": 49.817,
              "y": 7.0558,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.855,
              "y": 7.1189,
              "z": 0.66792
            },
            "stockLevel": "NO_STOCK",
            "gtin": "8720181505515"
          },
          {
            "id": "679afb3e3d9bab0f83ff6160",
            "leftCorner": {
              "x": 49.855,
              "y": 7.1189,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.889,
              "y": 7.1733,
              "z": 0.66792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42471141"
          },
          {
            "id": "679afb3e3d9bab0f83ff6161",
            "leftCorner": {
              "x": 49.889,
              "y": 7.1733,
              "z": 0.66792
            },
            "rightCorner": {
              "x": 49.97,
              "y": 7.3075,
              "z": 0.66792
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42418627"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad78",
        "height": 0.87793,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60d0",
            "leftCorner": {
              "x": 49.446,
              "y": 6.4559,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.482,
              "y": 6.5155,
              "z": 0.87793
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d2",
            "leftCorner": {
              "x": 49.482,
              "y": 6.5155,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.503,
              "y": 6.5486,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d3",
            "leftCorner": {
              "x": 49.503,
              "y": 6.5486,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.524,
              "y": 6.5835,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d4",
            "leftCorner": {
              "x": 49.524,
              "y": 6.5835,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.549,
              "y": 6.6246,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d5",
            "leftCorner": {
              "x": 49.549,
              "y": 6.6246,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.572,
              "y": 6.6618,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d6",
            "leftCorner": {
              "x": 49.572,
              "y": 6.6618,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.598,
              "y": 6.7051,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447793505"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d7",
            "leftCorner": {
              "x": 49.598,
              "y": 6.7051,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.636,
              "y": 6.768,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237801"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d8",
            "leftCorner": {
              "x": 49.636,
              "y": 6.768,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.658,
              "y": 6.8028,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237801"
          },
          {
            "id": "679afb3e3d9bab0f83ff60d9",
            "leftCorner": {
              "x": 49.658,
              "y": 6.8028,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.688,
              "y": 6.8519,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040802019"
          },
          {
            "id": "679afb3e3d9bab0f83ff60da",
            "leftCorner": {
              "x": 49.688,
              "y": 6.8519,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.716,
              "y": 6.8981,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040802019"
          },
          {
            "id": "679afb3e3d9bab0f83ff60db",
            "leftCorner": {
              "x": 49.716,
              "y": 6.8981,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.744,
              "y": 6.9454,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040802019"
          },
          {
            "id": "679afb3e3d9bab0f83ff60dc",
            "leftCorner": {
              "x": 49.744,
              "y": 6.9454,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.773,
              "y": 6.9921,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040790019"
          },
          {
            "id": "679afb3e3d9bab0f83ff60dd",
            "leftCorner": {
              "x": 49.773,
              "y": 6.9921,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.803,
              "y": 7.0409,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040790019"
          },
          {
            "id": "679afb3e3d9bab0f83ff60de",
            "leftCorner": {
              "x": 49.803,
              "y": 7.0409,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.832,
              "y": 7.0893,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60df",
            "leftCorner": {
              "x": 49.832,
              "y": 7.0893,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.854,
              "y": 7.1255,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366006"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e0",
            "leftCorner": {
              "x": 49.854,
              "y": 7.1255,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.876,
              "y": 7.1616,
              "z": 0.87793
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447366006"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e1",
            "leftCorner": {
              "x": 49.876,
              "y": 7.1616,
              "z": 0.87793
            },
            "rightCorner": {
              "x": 49.902,
              "y": 7.2032,
              "z": 0.87793
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447109498"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e2",
            "leftCorner": {
              "x": 49.893,
              "y": 7.1985,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 49.924,
              "y": 7.2488,
              "z": 0.87545
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172449192"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e3",
            "leftCorner": {
              "x": 49.924,
              "y": 7.2483,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 49.967,
              "y": 7.3178,
              "z": 0.87545
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42269670"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7c",
        "height": 1.0947,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60f0",
            "leftCorner": {
              "x": 49.45,
              "y": 6.4537,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.495,
              "y": 6.5278,
              "z": 1.0947
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f2",
            "leftCorner": {
              "x": 49.495,
              "y": 6.5278,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.532,
              "y": 6.5886,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f3",
            "leftCorner": {
              "x": 49.532,
              "y": 6.5886,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.557,
              "y": 6.6287,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f4",
            "leftCorner": {
              "x": 49.557,
              "y": 6.6287,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.583,
              "y": 6.6717,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f5",
            "leftCorner": {
              "x": 49.583,
              "y": 6.6717,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.618,
              "y": 6.729,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365504"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f6",
            "leftCorner": {
              "x": 49.618,
              "y": 6.729,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.64,
              "y": 6.7656,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f7",
            "leftCorner": {
              "x": 49.64,
              "y": 6.7656,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.656,
              "y": 6.792,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378818"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f8",
            "leftCorner": {
              "x": 49.656,
              "y": 6.792,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.708,
              "y": 6.8771,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378818"
          },
          {
            "id": "679afb3e3d9bab0f83ff60f9",
            "leftCorner": {
              "x": 49.708,
              "y": 6.8771,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.736,
              "y": 6.9229,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331417"
          },
          {
            "id": "679afb3e3d9bab0f83ff60fa",
            "leftCorner": {
              "x": 49.736,
              "y": 6.9229,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.758,
              "y": 6.9591,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331417"
          },
          {
            "id": "679afb3e3d9bab0f83ff60fb",
            "leftCorner": {
              "x": 49.758,
              "y": 6.9591,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.807,
              "y": 7.0392,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331431"
          },
          {
            "id": "679afb3e3d9bab0f83ff60fc",
            "leftCorner": {
              "x": 49.807,
              "y": 7.0392,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.868,
              "y": 7.1404,
              "z": 1.0947
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008666700940"
          },
          {
            "id": "679afb3e3d9bab0f83ff60fd",
            "leftCorner": {
              "x": 49.868,
              "y": 7.1404,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.896,
              "y": 7.1851,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216260497"
          },
          {
            "id": "679afb3e3d9bab0f83ff60fe",
            "leftCorner": {
              "x": 49.896,
              "y": 7.1851,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 49.97,
              "y": 7.3076,
              "z": 1.0947
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090735126"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7d",
        "height": 1.3002,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff618d",
            "leftCorner": {
              "x": 49.45,
              "y": 6.4535,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.559,
              "y": 6.6323,
              "z": 1.3002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff618e",
            "leftCorner": {
              "x": 49.559,
              "y": 6.6323,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.583,
              "y": 6.6717,
              "z": 1.3002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff618f",
            "leftCorner": {
              "x": 49.583,
              "y": 6.6717,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.617,
              "y": 6.7276,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4007965016097"
          },
          {
            "id": "679afb3e3d9bab0f83ff6190",
            "leftCorner": {
              "x": 49.617,
              "y": 6.7276,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.636,
              "y": 6.758,
              "z": 1.3002
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6191",
            "leftCorner": {
              "x": 49.636,
              "y": 6.758,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.678,
              "y": 6.8274,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951313767"
          },
          {
            "id": "679afb3e3d9bab0f83ff6192",
            "leftCorner": {
              "x": 49.678,
              "y": 6.8274,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.737,
              "y": 6.9235,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718951471955"
          },
          {
            "id": "679afb3e3d9bab0f83ff6193",
            "leftCorner": {
              "x": 49.737,
              "y": 6.9235,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.79,
              "y": 7.0109,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6194",
            "leftCorner": {
              "x": 49.79,
              "y": 7.0109,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.814,
              "y": 7.0499,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771671"
          },
          {
            "id": "679afb3e3d9bab0f83ff6195",
            "leftCorner": {
              "x": 49.814,
              "y": 7.0499,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.84,
              "y": 7.093,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771671"
          },
          {
            "id": "679afb3e3d9bab0f83ff6196",
            "leftCorner": {
              "x": 49.84,
              "y": 7.093,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.865,
              "y": 7.134,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771671"
          },
          {
            "id": "679afb3e3d9bab0f83ff6197",
            "leftCorner": {
              "x": 49.865,
              "y": 7.134,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.889,
              "y": 7.174,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771671"
          },
          {
            "id": "679afb3e3d9bab0f83ff6198",
            "leftCorner": {
              "x": 49.889,
              "y": 7.174,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.905,
              "y": 7.2,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4007965133800"
          },
          {
            "id": "679afb3e3d9bab0f83ff6199",
            "leftCorner": {
              "x": 49.905,
              "y": 7.2,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 49.929,
              "y": 7.2394,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4007965133800"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7e",
        "height": 1.5108,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff610e",
            "leftCorner": {
              "x": 49.445,
              "y": 6.4566,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.551,
              "y": 6.6303,
              "z": 1.5108
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff610f",
            "leftCorner": {
              "x": 49.551,
              "y": 6.6303,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.629,
              "y": 6.7584,
              "z": 1.5108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6110",
            "leftCorner": {
              "x": 49.629,
              "y": 6.7584,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.708,
              "y": 6.8876,
              "z": 1.5108
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6111",
            "leftCorner": {
              "x": 49.708,
              "y": 6.8876,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.788,
              "y": 7.02,
              "z": 1.5108
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6112",
            "leftCorner": {
              "x": 49.788,
              "y": 7.02,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.812,
              "y": 7.0589,
              "z": 1.5108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff6113",
            "leftCorner": {
              "x": 49.812,
              "y": 7.0589,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.837,
              "y": 7.0993,
              "z": 1.5108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661730943"
          },
          {
            "id": "679afb3e3d9bab0f83ff6114",
            "leftCorner": {
              "x": 49.837,
              "y": 7.0993,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.872,
              "y": 7.1571,
              "z": 1.5108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661730943"
          },
          {
            "id": "679afb3e3d9bab0f83ff6115",
            "leftCorner": {
              "x": 49.872,
              "y": 7.1571,
              "z": 1.5108
            },
            "rightCorner": {
              "x": 49.948,
              "y": 7.2818,
              "z": 1.5108
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661745008"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 84,
      "unknownStockCount": 19
    },
    "name": "IOFL",
    "rightNeighborShelfId": "KD7C"
  },
  {
    "id": "A299",
    "x": 49.975,
    "y": 7.2945,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.48202,
      "w": 0.87616
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad82",
        "height": 0.15183,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6139",
            "leftCorner": {
              "x": 50.06,
              "y": 7.2467,
              "z": 0.15696
            },
            "rightCorner": {
              "x": 50.094,
              "y": 7.303,
              "z": 0.15696
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447195170"
          },
          {
            "id": "679afb3e3d9bab0f83ff613a",
            "leftCorner": {
              "x": 50.091,
              "y": 7.2923,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.166,
              "y": 7.41,
              "z": 0.15183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448079088"
          },
          {
            "id": "679afb3e3d9bab0f83ff613b",
            "leftCorner": {
              "x": 50.166,
              "y": 7.41,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.255,
              "y": 7.5515,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581536306"
          },
          {
            "id": "679afb3e3d9bab0f83ff613c",
            "leftCorner": {
              "x": 50.255,
              "y": 7.5515,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.315,
              "y": 7.6461,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172320828"
          },
          {
            "id": "679afb3e3d9bab0f83ff613d",
            "leftCorner": {
              "x": 50.315,
              "y": 7.6461,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.34,
              "y": 7.685,
              "z": 0.15183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3e3d9bab0f83ff613e",
            "leftCorner": {
              "x": 50.34,
              "y": 7.685,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.364,
              "y": 7.7232,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172926440"
          },
          {
            "id": "679afb3e3d9bab0f83ff613f",
            "leftCorner": {
              "x": 50.364,
              "y": 7.7232,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.418,
              "y": 7.8074,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447383805"
          },
          {
            "id": "679afb3e3d9bab0f83ff6140",
            "leftCorner": {
              "x": 50.418,
              "y": 7.8074,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.526,
              "y": 7.9787,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810745"
          },
          {
            "id": "679afb3e3d9bab0f83ff6141",
            "leftCorner": {
              "x": 50.526,
              "y": 7.9787,
              "z": 0.15183
            },
            "rightCorner": {
              "x": 50.594,
              "y": 8.0858,
              "z": 0.15183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4064666045092"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad85",
        "height": 0.4132,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6180",
            "leftCorner": {
              "x": 49.959,
              "y": 7.3044,
              "z": 0.4132
            },
            "rightCorner": {
              "x": 50.053,
              "y": 7.4595,
              "z": 0.4132
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738951"
          },
          {
            "id": "679afb3e3d9bab0f83ff6181",
            "leftCorner": {
              "x": 50.056,
              "y": 7.4578,
              "z": 0.4132
            },
            "rightCorner": {
              "x": 50.224,
              "y": 7.7234,
              "z": 0.4132
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42389583"
          },
          {
            "id": "679afb3e3d9bab0f83ff6182",
            "leftCorner": {
              "x": 50.224,
              "y": 7.7234,
              "z": 0.4132
            },
            "rightCorner": {
              "x": 50.368,
              "y": 7.9499,
              "z": 0.4132
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3616302035403"
          },
          {
            "id": "679afb3e3d9bab0f83ff6183",
            "leftCorner": {
              "x": 50.368,
              "y": 7.9499,
              "z": 0.4132
            },
            "rightCorner": {
              "x": 50.482,
              "y": 8.1296,
              "z": 0.4132
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008666211224"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad7f",
        "height": 0.66724,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6162",
            "leftCorner": {
              "x": 49.958,
              "y": 7.3052,
              "z": 0.66724
            },
            "rightCorner": {
              "x": 50.039,
              "y": 7.4384,
              "z": 0.66724
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42471479"
          },
          {
            "id": "679afb3e3d9bab0f83ff6163",
            "leftCorner": {
              "x": 50.041,
              "y": 7.437,
              "z": 0.66724
            },
            "rightCorner": {
              "x": 50.361,
              "y": 7.942,
              "z": 0.66724
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447410501"
          },
          {
            "id": "679afb3e3d9bab0f83ff6164",
            "leftCorner": {
              "x": 50.361,
              "y": 7.942,
              "z": 0.66724
            },
            "rightCorner": {
              "x": 50.411,
              "y": 8.0199,
              "z": 0.66724
            },
            "stockLevel": "UNKNOWN",
            "gtin": "59096085"
          },
          {
            "id": "679afb3e3d9bab0f83ff6165",
            "leftCorner": {
              "x": 50.407,
              "y": 8.0307,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.448,
              "y": 8.0952,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "59097785"
          },
          {
            "id": "679afb3e3d9bab0f83ff6166",
            "leftCorner": {
              "x": 50.447,
              "y": 8.0954,
              "z": 0.66552
            },
            "rightCorner": {
              "x": 50.498,
              "y": 8.1749,
              "z": 0.66552
            },
            "stockLevel": "UNKNOWN",
            "gtin": "80830511"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad81",
        "height": 0.87545,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60e4",
            "leftCorner": {
              "x": 49.968,
              "y": 7.3171,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.014,
              "y": 7.3928,
              "z": 0.87545
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42429784"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e5",
            "leftCorner": {
              "x": 50.016,
              "y": 7.392,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.177,
              "y": 7.6472,
              "z": 0.87545
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447380026"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e6",
            "leftCorner": {
              "x": 50.177,
              "y": 7.6472,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.221,
              "y": 7.7156,
              "z": 0.87545
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239232"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e7",
            "leftCorner": {
              "x": 50.221,
              "y": 7.7156,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.291,
              "y": 7.827,
              "z": 0.87545
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378634"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e8",
            "leftCorner": {
              "x": 50.291,
              "y": 7.827,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.426,
              "y": 8.0399,
              "z": 0.87545
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447758665"
          },
          {
            "id": "679afb3e3d9bab0f83ff60e9",
            "leftCorner": {
              "x": 50.426,
              "y": 8.0399,
              "z": 0.87545
            },
            "rightCorner": {
              "x": 50.519,
              "y": 8.1864,
              "z": 0.87545
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172801440"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad83",
        "height": 1.0897,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff60ff",
            "leftCorner": {
              "x": 49.957,
              "y": 7.3055,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.023,
              "y": 7.4135,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42428947"
          },
          {
            "id": "679afb3e3d9bab0f83ff6100",
            "leftCorner": {
              "x": 50.025,
              "y": 7.4123,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.194,
              "y": 7.6789,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796002737"
          },
          {
            "id": "679afb3e3d9bab0f83ff6101",
            "leftCorner": {
              "x": 50.194,
              "y": 7.6789,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.235,
              "y": 7.7445,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156288704"
          },
          {
            "id": "679afb3e3d9bab0f83ff6102",
            "leftCorner": {
              "x": 50.235,
              "y": 7.7445,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.327,
              "y": 7.8889,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156288698"
          },
          {
            "id": "679afb3e3d9bab0f83ff6103",
            "leftCorner": {
              "x": 50.327,
              "y": 7.8889,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.45,
              "y": 8.0838,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "41042656"
          },
          {
            "id": "679afb3e3d9bab0f83ff6104",
            "leftCorner": {
              "x": 50.45,
              "y": 8.0838,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 50.49,
              "y": 8.1462,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42071389"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad84",
        "height": 1.2956,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff619a",
            "leftCorner": {
              "x": 49.929,
              "y": 7.2394,
              "z": 1.3002
            },
            "rightCorner": {
              "x": 50.012,
              "y": 7.3753,
              "z": 1.3002
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447374551"
          },
          {
            "id": "679afb3e3d9bab0f83ff619b",
            "leftCorner": {
              "x": 49.998,
              "y": 7.3738,
              "z": 1.2956
            },
            "rightCorner": {
              "x": 50.284,
              "y": 7.8258,
              "z": 1.2956
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429596"
          },
          {
            "id": "679afb3e3d9bab0f83ff619c",
            "leftCorner": {
              "x": 50.284,
              "y": 7.8258,
              "z": 1.2956
            },
            "rightCorner": {
              "x": 50.325,
              "y": 7.8901,
              "z": 1.2956
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447591903"
          },
          {
            "id": "679afb3e3d9bab0f83ff619d",
            "leftCorner": {
              "x": 50.324,
              "y": 7.8995,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.367,
              "y": 7.9674,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429633"
          },
          {
            "id": "679afb3e3d9bab0f83ff619e",
            "leftCorner": {
              "x": 50.366,
              "y": 7.9676,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.408,
              "y": 8.034,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429619"
          },
          {
            "id": "679afb3e3d9bab0f83ff619f",
            "leftCorner": {
              "x": 50.408,
              "y": 8.0342,
              "z": 1.2946
            },
            "rightCorner": {
              "x": 50.47,
              "y": 8.132,
              "z": 1.2946
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447465501"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad80",
        "height": 1.5073,
        "facings": [
          {
            "id": "679afb3e3d9bab0f83ff6116",
            "leftCorner": {
              "x": 49.938,
              "y": 7.2777,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 49.989,
              "y": 7.3616,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581534654"
          },
          {
            "id": "679afb3e3d9bab0f83ff6117",
            "leftCorner": {
              "x": 49.991,
              "y": 7.3607,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.04,
              "y": 7.4416,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062196135122"
          },
          {
            "id": "679afb3e3d9bab0f83ff6118",
            "leftCorner": {
              "x": 50.041,
              "y": 7.4407,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.098,
              "y": 7.5338,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447378290"
          },
          {
            "id": "679afb3e3d9bab0f83ff6119",
            "leftCorner": {
              "x": 50.1,
              "y": 7.5328,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.144,
              "y": 7.6057,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448128991"
          },
          {
            "id": "679afb3e3d9bab0f83ff611a",
            "leftCorner": {
              "x": 50.145,
              "y": 7.6049,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.176,
              "y": 7.6542,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002448128274"
          },
          {
            "id": "679afb3e3d9bab0f83ff611b",
            "leftCorner": {
              "x": 50.176,
              "y": 7.6537,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.195,
              "y": 7.6844,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42485322"
          },
          {
            "id": "679afb3e3d9bab0f83ff611c",
            "leftCorner": {
              "x": 50.196,
              "y": 7.6841,
              "z": 1.5073
            },
            "rightCorner": {
              "x": 50.266,
              "y": 7.7944,
              "z": 1.5073
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4000196031150"
          },
          {
            "id": "679afb3e3d9bab0f83ff611d",
            "leftCorner": {
              "x": 50.268,
              "y": 7.8015,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.311,
              "y": 7.8697,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447429305"
          },
          {
            "id": "679afb3e3d9bab0f83ff611e",
            "leftCorner": {
              "x": 50.31,
              "y": 7.8699,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.359,
              "y": 7.9471,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447378276"
          },
          {
            "id": "679afb3e3d9bab0f83ff611f",
            "leftCorner": {
              "x": 50.359,
              "y": 7.9474,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.402,
              "y": 8.0152,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447375961"
          },
          {
            "id": "679afb3e3d9bab0f83ff6120",
            "leftCorner": {
              "x": 50.401,
              "y": 8.0154,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.438,
              "y": 8.0737,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3574661687025"
          },
          {
            "id": "679afb3e3d9bab0f83ff6121",
            "leftCorner": {
              "x": 50.438,
              "y": 8.0739,
              "z": 1.5065
            },
            "rightCorner": {
              "x": 50.498,
              "y": 8.1678,
              "z": 1.5065
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42417309"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 13,
      "unknownStockCount": 35
    },
    "name": "A299",
    "rightNeighborShelfId": "JBAS"
  },
  {
    "id": "NB3C",
    "x": 51.038,
    "y": 9.0051,
    "width": 1,
    "height": 1.8,
    "depth": 0.555,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.47754,
      "w": 0.87861
    },
    "layers": [],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 0,
      "unknownStockCount": 0
    },
    "name": "NB3C",
    "rightNeighborShelfId": "ODNS"
  },
  {
    "id": "LHJE",
    "x": 52.545,
    "y": 3.9769,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": -0.0045779
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad8c",
        "height": 0.16409,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5559",
            "leftCorner": {
              "x": 52.521,
              "y": 4.0768,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.466,
              "y": 4.0763,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413076"
          },
          {
            "id": "679afb3d3d9bab0f83ff555a",
            "leftCorner": {
              "x": 52.466,
              "y": 4.0763,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.409,
              "y": 4.0758,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413076"
          },
          {
            "id": "679afb3d3d9bab0f83ff555b",
            "leftCorner": {
              "x": 52.409,
              "y": 4.0758,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.354,
              "y": 4.0753,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413076"
          },
          {
            "id": "679afb3d3d9bab0f83ff555c",
            "leftCorner": {
              "x": 52.354,
              "y": 4.0753,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.304,
              "y": 4.0748,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172784316"
          },
          {
            "id": "679afb3d3d9bab0f83ff555d",
            "leftCorner": {
              "x": 52.304,
              "y": 4.0748,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.241,
              "y": 4.0743,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172784316"
          },
          {
            "id": "679afb3d3d9bab0f83ff555e",
            "leftCorner": {
              "x": 52.241,
              "y": 4.0743,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.183,
              "y": 4.0737,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447439229"
          },
          {
            "id": "679afb3d3d9bab0f83ff555f",
            "leftCorner": {
              "x": 52.183,
              "y": 4.0737,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 52.028,
              "y": 4.0723,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413090"
          },
          {
            "id": "679afb3d3d9bab0f83ff5560",
            "leftCorner": {
              "x": 52.028,
              "y": 4.0723,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 51.87,
              "y": 4.0709,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413106"
          },
          {
            "id": "679afb3d3d9bab0f83ff5561",
            "leftCorner": {
              "x": 51.87,
              "y": 4.0709,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 51.704,
              "y": 4.0694,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413113"
          },
          {
            "id": "679afb3d3d9bab0f83ff5562",
            "leftCorner": {
              "x": 51.704,
              "y": 4.0694,
              "z": 0.16409
            },
            "rightCorner": {
              "x": 51.53,
              "y": 4.0678,
              "z": 0.16409
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447413083"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad8b",
        "height": 0.42218,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6385",
            "leftCorner": {
              "x": 52.551,
              "y": 3.9668,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.474,
              "y": 3.9661,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447349337"
          },
          {
            "id": "679afb3f3d9bab0f83ff6386",
            "leftCorner": {
              "x": 52.474,
              "y": 3.9661,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.382,
              "y": 3.9653,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447349337"
          },
          {
            "id": "679afb3f3d9bab0f83ff6387",
            "leftCorner": {
              "x": 52.382,
              "y": 3.9653,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.309,
              "y": 3.9646,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616303440800"
          },
          {
            "id": "679afb3f3d9bab0f83ff6388",
            "leftCorner": {
              "x": 52.309,
              "y": 3.9646,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.254,
              "y": 3.9641,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276862"
          },
          {
            "id": "679afb3f3d9bab0f83ff6389",
            "leftCorner": {
              "x": 52.254,
              "y": 3.9641,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.196,
              "y": 3.9636,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276886"
          },
          {
            "id": "679afb3f3d9bab0f83ff638a",
            "leftCorner": {
              "x": 52.196,
              "y": 3.9636,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.141,
              "y": 3.9631,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276886"
          },
          {
            "id": "679afb3f3d9bab0f83ff638b",
            "leftCorner": {
              "x": 52.141,
              "y": 3.9631,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.083,
              "y": 3.9625,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276848"
          },
          {
            "id": "679afb3f3d9bab0f83ff638c",
            "leftCorner": {
              "x": 52.083,
              "y": 3.9625,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 52.029,
              "y": 3.962,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447276848"
          },
          {
            "id": "679afb3f3d9bab0f83ff638d",
            "leftCorner": {
              "x": 52.029,
              "y": 3.962,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.982,
              "y": 3.9616,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100428988"
          },
          {
            "id": "679afb3f3d9bab0f83ff638e",
            "leftCorner": {
              "x": 51.982,
              "y": 3.9616,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.937,
              "y": 3.9612,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100428988"
          },
          {
            "id": "679afb3f3d9bab0f83ff638f",
            "leftCorner": {
              "x": 51.937,
              "y": 3.9612,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.889,
              "y": 3.9608,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100429008"
          },
          {
            "id": "679afb3f3d9bab0f83ff6390",
            "leftCorner": {
              "x": 51.889,
              "y": 3.9608,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.842,
              "y": 3.9603,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540786116"
          },
          {
            "id": "679afb3f3d9bab0f83ff6391",
            "leftCorner": {
              "x": 51.842,
              "y": 3.9603,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.795,
              "y": 3.9599,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540786116"
          },
          {
            "id": "679afb3f3d9bab0f83ff6392",
            "leftCorner": {
              "x": 51.795,
              "y": 3.9599,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.748,
              "y": 3.9595,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540786451"
          },
          {
            "id": "679afb3f3d9bab0f83ff6393",
            "leftCorner": {
              "x": 51.748,
              "y": 3.9595,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.698,
              "y": 3.959,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540786451"
          },
          {
            "id": "679afb3f3d9bab0f83ff6394",
            "leftCorner": {
              "x": 51.698,
              "y": 3.959,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.651,
              "y": 3.9586,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6395",
            "leftCorner": {
              "x": 51.651,
              "y": 3.9586,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.601,
              "y": 3.9581,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015000718479"
          },
          {
            "id": "679afb3f3d9bab0f83ff6396",
            "leftCorner": {
              "x": 51.601,
              "y": 3.9581,
              "z": 0.42218
            },
            "rightCorner": {
              "x": 51.542,
              "y": 3.9576,
              "z": 0.42218
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717524074968"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad88",
        "height": 0.71673,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff64be",
            "leftCorner": {
              "x": 52.545,
              "y": 3.9653,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.493,
              "y": 3.9648,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000094212"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c0",
            "leftCorner": {
              "x": 52.493,
              "y": 3.9648,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.355,
              "y": 3.9635,
              "z": 0.71673
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000094137"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c1",
            "leftCorner": {
              "x": 52.355,
              "y": 3.9635,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.306,
              "y": 3.9631,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000004037"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c2",
            "leftCorner": {
              "x": 52.306,
              "y": 3.9631,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.248,
              "y": 3.9626,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000004037"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c3",
            "leftCorner": {
              "x": 52.248,
              "y": 3.9626,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.197,
              "y": 3.9621,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000094175"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c4",
            "leftCorner": {
              "x": 52.197,
              "y": 3.9621,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.149,
              "y": 3.9617,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000094175"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c5",
            "leftCorner": {
              "x": 52.149,
              "y": 3.9617,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.097,
              "y": 3.9612,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035465"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c6",
            "leftCorner": {
              "x": 52.097,
              "y": 3.9612,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 52.043,
              "y": 3.9607,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035465"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c7",
            "leftCorner": {
              "x": 52.043,
              "y": 3.9607,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.991,
              "y": 3.9602,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035397"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c8",
            "leftCorner": {
              "x": 51.991,
              "y": 3.9602,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.939,
              "y": 3.9597,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035397"
          },
          {
            "id": "679afb3f3d9bab0f83ff64c9",
            "leftCorner": {
              "x": 51.939,
              "y": 3.9597,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.887,
              "y": 3.9593,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035397"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ca",
            "leftCorner": {
              "x": 51.887,
              "y": 3.9593,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.836,
              "y": 3.9588,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035427"
          },
          {
            "id": "679afb3f3d9bab0f83ff64cb",
            "leftCorner": {
              "x": 51.836,
              "y": 3.9588,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.784,
              "y": 3.9583,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035427"
          },
          {
            "id": "679afb3f3d9bab0f83ff64cc",
            "leftCorner": {
              "x": 51.784,
              "y": 3.9583,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.725,
              "y": 3.9578,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035458"
          },
          {
            "id": "679afb3f3d9bab0f83ff64cd",
            "leftCorner": {
              "x": 51.725,
              "y": 3.9578,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.666,
              "y": 3.9572,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035458"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ce",
            "leftCorner": {
              "x": 51.666,
              "y": 3.9572,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.613,
              "y": 3.9568,
              "z": 0.71673
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3616302035410"
          },
          {
            "id": "679afb3f3d9bab0f83ff64bf",
            "leftCorner": {
              "x": 51.613,
              "y": 3.9568,
              "z": 0.71673
            },
            "rightCorner": {
              "x": 51.545,
              "y": 3.9561,
              "z": 0.71673
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3616302035410"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad8a",
        "height": 0.96657,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff64df",
            "leftCorner": {
              "x": 52.545,
              "y": 3.9634,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.455,
              "y": 3.9626,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8712561254595"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e1",
            "leftCorner": {
              "x": 52.455,
              "y": 3.9626,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.32,
              "y": 3.9613,
              "z": 0.96657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8710447493915"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e2",
            "leftCorner": {
              "x": 52.32,
              "y": 3.9613,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.274,
              "y": 3.9609,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438752"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e3",
            "leftCorner": {
              "x": 52.274,
              "y": 3.9609,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.221,
              "y": 3.9604,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438752"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e4",
            "leftCorner": {
              "x": 52.221,
              "y": 3.9604,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.17,
              "y": 3.96,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438752"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e5",
            "leftCorner": {
              "x": 52.17,
              "y": 3.96,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.125,
              "y": 3.9595,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438769"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e6",
            "leftCorner": {
              "x": 52.125,
              "y": 3.9595,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.077,
              "y": 3.9591,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438769"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e7",
            "leftCorner": {
              "x": 52.077,
              "y": 3.9591,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 52.03,
              "y": 3.9587,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e8",
            "leftCorner": {
              "x": 52.03,
              "y": 3.9587,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.983,
              "y": 3.9582,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438738"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e9",
            "leftCorner": {
              "x": 51.983,
              "y": 3.9582,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.938,
              "y": 3.9578,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181438738"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ea",
            "leftCorner": {
              "x": 51.938,
              "y": 3.9578,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.888,
              "y": 3.9574,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523715473"
          },
          {
            "id": "679afb3f3d9bab0f83ff64eb",
            "leftCorner": {
              "x": 51.888,
              "y": 3.9574,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.841,
              "y": 3.9569,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524076672"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ec",
            "leftCorner": {
              "x": 51.841,
              "y": 3.9569,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.793,
              "y": 3.9565,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524076672"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ed",
            "leftCorner": {
              "x": 51.793,
              "y": 3.9565,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.741,
              "y": 3.956,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523715435"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ee",
            "leftCorner": {
              "x": 51.741,
              "y": 3.956,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.688,
              "y": 3.9555,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5050456006793"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ef",
            "leftCorner": {
              "x": 51.688,
              "y": 3.9555,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.634,
              "y": 3.955,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5050456006793"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f0",
            "leftCorner": {
              "x": 51.634,
              "y": 3.955,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.581,
              "y": 3.9546,
              "z": 0.96657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5050456006823"
          },
          {
            "id": "679afb3f3d9bab0f83ff64e0",
            "leftCorner": {
              "x": 51.581,
              "y": 3.9546,
              "z": 0.96657
            },
            "rightCorner": {
              "x": 51.545,
              "y": 3.9542,
              "z": 0.96657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5050456006823"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad86",
        "height": 1.2195,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff649f",
            "leftCorner": {
              "x": 52.543,
              "y": 3.9667,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.491,
              "y": 3.9662,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181297601"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a0",
            "leftCorner": {
              "x": 52.491,
              "y": 3.9662,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.439,
              "y": 3.9657,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181418396"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a1",
            "leftCorner": {
              "x": 52.439,
              "y": 3.9657,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.395,
              "y": 3.9653,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181297564"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a2",
            "leftCorner": {
              "x": 52.395,
              "y": 3.9653,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.331,
              "y": 3.9647,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181297687"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a3",
            "leftCorner": {
              "x": 52.331,
              "y": 3.9647,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.28,
              "y": 3.9643,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181418402"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a4",
            "leftCorner": {
              "x": 52.28,
              "y": 3.9643,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.221,
              "y": 3.9637,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181418402"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a5",
            "leftCorner": {
              "x": 52.221,
              "y": 3.9637,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.166,
              "y": 3.9632,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181436710"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a6",
            "leftCorner": {
              "x": 52.166,
              "y": 3.9632,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.107,
              "y": 3.9627,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710447484265"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a7",
            "leftCorner": {
              "x": 52.107,
              "y": 3.9627,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.055,
              "y": 3.9622,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717163640777"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a8",
            "leftCorner": {
              "x": 52.055,
              "y": 3.9622,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 52.002,
              "y": 3.9617,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8717163640777"
          },
          {
            "id": "679afb3f3d9bab0f83ff64a9",
            "leftCorner": {
              "x": 52.002,
              "y": 3.9617,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.949,
              "y": 3.9612,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff64aa",
            "leftCorner": {
              "x": 51.949,
              "y": 3.9612,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.898,
              "y": 3.9608,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710447484296"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ab",
            "leftCorner": {
              "x": 51.898,
              "y": 3.9608,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.846,
              "y": 3.9603,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181434518"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ac",
            "leftCorner": {
              "x": 51.846,
              "y": 3.9603,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.796,
              "y": 3.9598,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8710522368541"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ad",
            "leftCorner": {
              "x": 51.796,
              "y": 3.9598,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.744,
              "y": 3.9593,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ae",
            "leftCorner": {
              "x": 51.744,
              "y": 3.9593,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.688,
              "y": 3.9588,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181192098"
          },
          {
            "id": "679afb3f3d9bab0f83ff64af",
            "leftCorner": {
              "x": 51.688,
              "y": 3.9588,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.636,
              "y": 3.9584,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181205378"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b0",
            "leftCorner": {
              "x": 51.636,
              "y": 3.9584,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.583,
              "y": 3.9579,
              "z": 1.2195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181425943"
          },
          {
            "id": "679afb3f3d9bab0f83ff649e",
            "leftCorner": {
              "x": 51.583,
              "y": 3.9579,
              "z": 1.2195
            },
            "rightCorner": {
              "x": 51.545,
              "y": 3.9575,
              "z": 1.2195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8720181425943"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad87",
        "height": 1.4733,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff64b1",
            "leftCorner": {
              "x": 52.524,
              "y": 3.9685,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 52.405,
              "y": 3.9674,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181334580"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b2",
            "leftCorner": {
              "x": 52.405,
              "y": 3.9674,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 52.322,
              "y": 3.9666,
              "z": 1.4733
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172754876"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b3",
            "leftCorner": {
              "x": 52.322,
              "y": 3.9666,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 52.223,
              "y": 3.9657,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447750645"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b4",
            "leftCorner": {
              "x": 52.223,
              "y": 3.9657,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 52.124,
              "y": 3.9648,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172738999"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b5",
            "leftCorner": {
              "x": 52.124,
              "y": 3.9648,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 52.028,
              "y": 3.9639,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447750652"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b6",
            "leftCorner": {
              "x": 52.028,
              "y": 3.9639,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.929,
              "y": 3.963,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523741465"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b7",
            "leftCorner": {
              "x": 51.929,
              "y": 3.963,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.829,
              "y": 3.9621,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523741427"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b8",
            "leftCorner": {
              "x": 51.829,
              "y": 3.9621,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.786,
              "y": 3.9617,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42419358"
          },
          {
            "id": "679afb3f3d9bab0f83ff64b9",
            "leftCorner": {
              "x": 51.786,
              "y": 3.9617,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.747,
              "y": 3.9613,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42419358"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ba",
            "leftCorner": {
              "x": 51.747,
              "y": 3.9613,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.703,
              "y": 3.9609,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42419402"
          },
          {
            "id": "679afb3f3d9bab0f83ff64bb",
            "leftCorner": {
              "x": 51.703,
              "y": 3.9609,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.658,
              "y": 3.9605,
              "z": 1.4733
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42419402"
          },
          {
            "id": "679afb3f3d9bab0f83ff64bc",
            "leftCorner": {
              "x": 51.658,
              "y": 3.9605,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.615,
              "y": 3.9601,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42419334"
          },
          {
            "id": "679afb3f3d9bab0f83ff64bd",
            "leftCorner": {
              "x": 51.615,
              "y": 3.9601,
              "z": 1.4733
            },
            "rightCorner": {
              "x": 51.572,
              "y": 3.9597,
              "z": 1.4733
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42419334"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad89",
        "height": 1.7268,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff64cf",
            "leftCorner": {
              "x": 52.545,
              "y": 3.9665,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.432,
              "y": 3.9654,
              "z": 1.7268
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447710755"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d1",
            "leftCorner": {
              "x": 52.432,
              "y": 3.9654,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.377,
              "y": 3.9649,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565874"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d2",
            "leftCorner": {
              "x": 52.377,
              "y": 3.9649,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.331,
              "y": 3.9645,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447330892"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d3",
            "leftCorner": {
              "x": 52.331,
              "y": 3.9645,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.272,
              "y": 3.964,
              "z": 1.7268
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42428893"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d4",
            "leftCorner": {
              "x": 52.272,
              "y": 3.964,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.196,
              "y": 3.9633,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216203838"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d5",
            "leftCorner": {
              "x": 52.196,
              "y": 3.9633,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.131,
              "y": 3.9627,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841923727"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d6",
            "leftCorner": {
              "x": 52.131,
              "y": 3.9627,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 52.062,
              "y": 3.9621,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841923765"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d7",
            "leftCorner": {
              "x": 52.062,
              "y": 3.9621,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.998,
              "y": 3.9615,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841923840"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d8",
            "leftCorner": {
              "x": 51.998,
              "y": 3.9615,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.932,
              "y": 3.9609,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841923802"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d9",
            "leftCorner": {
              "x": 51.932,
              "y": 3.9609,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.876,
              "y": 3.9604,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "59097914"
          },
          {
            "id": "679afb3f3d9bab0f83ff64da",
            "leftCorner": {
              "x": 51.876,
              "y": 3.9604,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.819,
              "y": 3.9598,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "59097990"
          },
          {
            "id": "679afb3f3d9bab0f83ff64db",
            "leftCorner": {
              "x": 51.819,
              "y": 3.9598,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.753,
              "y": 3.9592,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8718114202402"
          },
          {
            "id": "679afb3f3d9bab0f83ff64dc",
            "leftCorner": {
              "x": 51.753,
              "y": 3.9592,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.707,
              "y": 3.9588,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8720181452604"
          },
          {
            "id": "679afb3f3d9bab0f83ff64dd",
            "leftCorner": {
              "x": 51.707,
              "y": 3.9588,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.657,
              "y": 3.9584,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "59097730"
          },
          {
            "id": "679afb3f3d9bab0f83ff64de",
            "leftCorner": {
              "x": 51.657,
              "y": 3.9584,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.612,
              "y": 3.9579,
              "z": 1.7268
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "59092575"
          },
          {
            "id": "679afb3f3d9bab0f83ff64d0",
            "leftCorner": {
              "x": 51.612,
              "y": 3.9579,
              "z": 1.7268
            },
            "rightCorner": {
              "x": 51.545,
              "y": 3.9573,
              "z": 1.7268
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006000088587"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 101,
      "unknownStockCount": 10
    },
    "name": "LHJE",
    "rightNeighborShelfId": "N3JI"
  },
  {
    "id": "NDX2",
    "x": 50.555,
    "y": 3.9501,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99995,
      "w": -0.009873
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad93",
        "height": 0.16172,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff556e",
            "leftCorner": {
              "x": 50.562,
              "y": 4.0523,
              "z": 0.16345
            },
            "rightCorner": {
              "x": 50.497,
              "y": 4.0511,
              "z": 0.16345
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027800020157"
          },
          {
            "id": "679afb3d3d9bab0f83ff556f",
            "leftCorner": {
              "x": 50.494,
              "y": 4.0541,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 50.466,
              "y": 4.0536,
              "z": 0.16172
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027800020157"
          },
          {
            "id": "679afb3d3d9bab0f83ff5570",
            "leftCorner": {
              "x": 50.466,
              "y": 4.0536,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 50.391,
              "y": 4.0521,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800551101"
          },
          {
            "id": "679afb3d3d9bab0f83ff5571",
            "leftCorner": {
              "x": 50.391,
              "y": 4.0521,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 50.323,
              "y": 4.0508,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002448189596"
          },
          {
            "id": "679afb3d3d9bab0f83ff5572",
            "leftCorner": {
              "x": 50.323,
              "y": 4.0508,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 50.228,
              "y": 4.0489,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9300631115434"
          },
          {
            "id": "679afb3d3d9bab0f83ff5573",
            "leftCorner": {
              "x": 50.228,
              "y": 4.0489,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 50.04,
              "y": 4.0452,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172926327"
          },
          {
            "id": "679afb3d3d9bab0f83ff5574",
            "leftCorner": {
              "x": 50.04,
              "y": 4.0452,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 49.854,
              "y": 4.0415,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3015810608817"
          },
          {
            "id": "679afb3d3d9bab0f83ff5575",
            "leftCorner": {
              "x": 49.854,
              "y": 4.0415,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 49.663,
              "y": 4.0377,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900613516"
          },
          {
            "id": "679afb3d3d9bab0f83ff5576",
            "leftCorner": {
              "x": 49.663,
              "y": 4.0377,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 49.555,
              "y": 4.0356,
              "z": 0.16172
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216695527"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad8d",
        "height": 0.4242,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63a3",
            "leftCorner": {
              "x": 50.495,
              "y": 3.9453,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.47,
              "y": 3.9448,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a4",
            "leftCorner": {
              "x": 50.47,
              "y": 3.9448,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.433,
              "y": 3.944,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a5",
            "leftCorner": {
              "x": 50.433,
              "y": 3.944,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.331,
              "y": 3.942,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900918666"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a6",
            "leftCorner": {
              "x": 50.331,
              "y": 3.942,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.275,
              "y": 3.9409,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900918666"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a7",
            "leftCorner": {
              "x": 50.275,
              "y": 3.9409,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.212,
              "y": 3.9397,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789849164"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a8",
            "leftCorner": {
              "x": 50.212,
              "y": 3.9397,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.148,
              "y": 3.9384,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8714789849164"
          },
          {
            "id": "679afb3f3d9bab0f83ff63a9",
            "leftCorner": {
              "x": 50.148,
              "y": 3.9384,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.09,
              "y": 3.9373,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800324903"
          },
          {
            "id": "679afb3f3d9bab0f83ff63aa",
            "leftCorner": {
              "x": 50.09,
              "y": 3.9373,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 50.034,
              "y": 3.9362,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800324903"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ab",
            "leftCorner": {
              "x": 50.034,
              "y": 3.9362,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.975,
              "y": 3.935,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925719"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ac",
            "leftCorner": {
              "x": 49.975,
              "y": 3.935,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.918,
              "y": 3.9339,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925719"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ad",
            "leftCorner": {
              "x": 49.918,
              "y": 3.9339,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.865,
              "y": 3.9328,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925719"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ae",
            "leftCorner": {
              "x": 49.865,
              "y": 3.9328,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.811,
              "y": 3.9318,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63af",
            "leftCorner": {
              "x": 49.811,
              "y": 3.9318,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.756,
              "y": 3.9307,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925733"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b0",
            "leftCorner": {
              "x": 49.756,
              "y": 3.9307,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.69,
              "y": 3.9294,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925733"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b1",
            "leftCorner": {
              "x": 49.69,
              "y": 3.9294,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.636,
              "y": 3.9283,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925733"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b2",
            "leftCorner": {
              "x": 49.636,
              "y": 3.9283,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.574,
              "y": 3.9271,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925733"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b3",
            "leftCorner": {
              "x": 49.574,
              "y": 3.9271,
              "z": 0.4242
            },
            "rightCorner": {
              "x": 49.518,
              "y": 3.926,
              "z": 0.4242
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad8e",
        "height": 0.71725,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff64f1",
            "leftCorner": {
              "x": 50.555,
              "y": 3.9451,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.493,
              "y": 3.9439,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900918628"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f3",
            "leftCorner": {
              "x": 50.493,
              "y": 3.9439,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.438,
              "y": 3.9428,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900918666"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f4",
            "leftCorner": {
              "x": 50.438,
              "y": 3.9428,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.341,
              "y": 3.9409,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7702018620371"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f5",
            "leftCorner": {
              "x": 50.341,
              "y": 3.9409,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.277,
              "y": 3.9396,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7702018621255"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f6",
            "leftCorner": {
              "x": 50.277,
              "y": 3.9396,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.214,
              "y": 3.9384,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7702018621293"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f7",
            "leftCorner": {
              "x": 50.214,
              "y": 3.9384,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.163,
              "y": 3.9374,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216013291"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f8",
            "leftCorner": {
              "x": 50.163,
              "y": 3.9374,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.103,
              "y": 3.9362,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216013345"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f9",
            "leftCorner": {
              "x": 50.103,
              "y": 3.9362,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 50.049,
              "y": 3.9351,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800001763"
          },
          {
            "id": "679afb3f3d9bab0f83ff64fa",
            "leftCorner": {
              "x": 50.049,
              "y": 3.9351,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.999,
              "y": 3.9342,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800001701"
          },
          {
            "id": "679afb3f3d9bab0f83ff64fb",
            "leftCorner": {
              "x": 49.999,
              "y": 3.9342,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.906,
              "y": 3.9323,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800003927"
          },
          {
            "id": "679afb3f3d9bab0f83ff64fc",
            "leftCorner": {
              "x": 49.906,
              "y": 3.9323,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.839,
              "y": 3.931,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4009800001855"
          },
          {
            "id": "679afb3f3d9bab0f83ff64fd",
            "leftCorner": {
              "x": 49.839,
              "y": 3.931,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.785,
              "y": 3.9299,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638098809"
          },
          {
            "id": "679afb3f3d9bab0f83ff64fe",
            "leftCorner": {
              "x": 49.785,
              "y": 3.9299,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.717,
              "y": 3.9286,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638098816"
          },
          {
            "id": "679afb3f3d9bab0f83ff64ff",
            "leftCorner": {
              "x": 49.717,
              "y": 3.9286,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.603,
              "y": 3.9263,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638095747"
          },
          {
            "id": "679afb3f3d9bab0f83ff6500",
            "leftCorner": {
              "x": 49.603,
              "y": 3.9263,
              "z": 0.71725
            },
            "rightCorner": {
              "x": 49.555,
              "y": 3.9254,
              "z": 0.71725
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447354591"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad90",
        "height": 0.96802,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff650d",
            "leftCorner": {
              "x": 50.555,
              "y": 3.9445,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 50.413,
              "y": 3.9417,
              "z": 0.96802
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216036788"
          },
          {
            "id": "679afb3f3d9bab0f83ff650f",
            "leftCorner": {
              "x": 50.413,
              "y": 3.9417,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 50.3,
              "y": 3.9395,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090272706"
          },
          {
            "id": "679afb3f3d9bab0f83ff6510",
            "leftCorner": {
              "x": 50.3,
              "y": 3.9395,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 50.174,
              "y": 3.937,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216450966"
          },
          {
            "id": "679afb3f3d9bab0f83ff6511",
            "leftCorner": {
              "x": 50.174,
              "y": 3.937,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 50.06,
              "y": 3.9348,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090565129"
          },
          {
            "id": "679afb3f3d9bab0f83ff6512",
            "leftCorner": {
              "x": 50.06,
              "y": 3.9348,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 49.942,
              "y": 3.9324,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090456687"
          },
          {
            "id": "679afb3f3d9bab0f83ff6513",
            "leftCorner": {
              "x": 49.942,
              "y": 3.9324,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 49.83,
              "y": 3.9302,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090419774"
          },
          {
            "id": "679afb3f3d9bab0f83ff6514",
            "leftCorner": {
              "x": 49.83,
              "y": 3.9302,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 49.712,
              "y": 3.9279,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090419231"
          },
          {
            "id": "679afb3f3d9bab0f83ff6515",
            "leftCorner": {
              "x": 49.712,
              "y": 3.9279,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 49.594,
              "y": 3.9256,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540951477"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad92",
        "height": 1.1787,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff634e",
            "leftCorner": {
              "x": 50.587,
              "y": 3.9407,
              "z": 1.179
            },
            "rightCorner": {
              "x": 50.402,
              "y": 3.9373,
              "z": 1.179
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216036887"
          },
          {
            "id": "679afb3f3d9bab0f83ff634f",
            "leftCorner": {
              "x": 50.399,
              "y": 3.9467,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 50.284,
              "y": 3.9444,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090272201"
          },
          {
            "id": "679afb3f3d9bab0f83ff6350",
            "leftCorner": {
              "x": 50.284,
              "y": 3.9444,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 50.163,
              "y": 3.942,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090562630"
          },
          {
            "id": "679afb3f3d9bab0f83ff6351",
            "leftCorner": {
              "x": 50.163,
              "y": 3.942,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 50.049,
              "y": 3.9398,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090456427"
          },
          {
            "id": "679afb3f3d9bab0f83ff6352",
            "leftCorner": {
              "x": 50.049,
              "y": 3.9398,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 49.933,
              "y": 3.9375,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090419552"
          },
          {
            "id": "679afb3f3d9bab0f83ff6353",
            "leftCorner": {
              "x": 49.933,
              "y": 3.9375,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 49.82,
              "y": 3.9353,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090418395"
          },
          {
            "id": "679afb3f3d9bab0f83ff6354",
            "leftCorner": {
              "x": 49.82,
              "y": 3.9353,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 49.7,
              "y": 3.9329,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540951460"
          },
          {
            "id": "679afb3f3d9bab0f83ff6355",
            "leftCorner": {
              "x": 49.7,
              "y": 3.9329,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 49.59,
              "y": 3.9307,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090422521"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad8f",
        "height": 1.3865,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad91",
        "height": 1.6832,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 50,
      "unknownStockCount": 7
    },
    "name": "NDX2",
    "leftNeighborShelfId": "N3JI",
    "rightNeighborShelfId": "HGZJ"
  },
  {
    "id": "HGZJ",
    "x": 49.556,
    "y": 3.9377,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": -0.0052111
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ad9a",
        "height": 0.16023,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5577",
            "leftCorner": {
              "x": 49.555,
              "y": 4.0356,
              "z": 0.16172
            },
            "rightCorner": {
              "x": 49.453,
              "y": 4.0336,
              "z": 0.16172
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800400201"
          },
          {
            "id": "679afb3d3d9bab0f83ff5578",
            "leftCorner": {
              "x": 49.455,
              "y": 4.0353,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 49.351,
              "y": 4.0342,
              "z": 0.16023
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800400201"
          },
          {
            "id": "679afb3d3d9bab0f83ff5579",
            "leftCorner": {
              "x": 49.351,
              "y": 4.0342,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 49.265,
              "y": 4.0333,
              "z": 0.16023
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800106806"
          },
          {
            "id": "679afb3d3d9bab0f83ff557a",
            "leftCorner": {
              "x": 49.265,
              "y": 4.0333,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 49.176,
              "y": 4.0323,
              "z": 0.16023
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800106806"
          },
          {
            "id": "679afb3d3d9bab0f83ff557b",
            "leftCorner": {
              "x": 49.176,
              "y": 4.0323,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 49.091,
              "y": 4.0314,
              "z": 0.16023
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800080137"
          },
          {
            "id": "679afb3d3d9bab0f83ff557c",
            "leftCorner": {
              "x": 49.091,
              "y": 4.0314,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 49.014,
              "y": 4.0307,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027800080137"
          },
          {
            "id": "679afb3d3d9bab0f83ff557d",
            "leftCorner": {
              "x": 49.014,
              "y": 4.0307,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.92,
              "y": 4.0297,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796158205"
          },
          {
            "id": "679afb3d3d9bab0f83ff557e",
            "leftCorner": {
              "x": 48.92,
              "y": 4.0297,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.816,
              "y": 4.0286,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796158205"
          },
          {
            "id": "679afb3d3d9bab0f83ff557f",
            "leftCorner": {
              "x": 48.816,
              "y": 4.0286,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.73,
              "y": 4.0277,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447044430"
          },
          {
            "id": "679afb3d3d9bab0f83ff5580",
            "leftCorner": {
              "x": 48.73,
              "y": 4.0277,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.652,
              "y": 4.0269,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447044430"
          },
          {
            "id": "679afb3d3d9bab0f83ff5581",
            "leftCorner": {
              "x": 48.652,
              "y": 4.0269,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.564,
              "y": 4.026,
              "z": 0.16023
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447044430"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad96",
        "height": 0.42241,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff63b4",
            "leftCorner": {
              "x": 49.519,
              "y": 3.9287,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.462,
              "y": 3.9281,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b5",
            "leftCorner": {
              "x": 49.462,
              "y": 3.9281,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.407,
              "y": 3.9275,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376104"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b6",
            "leftCorner": {
              "x": 49.407,
              "y": 3.9275,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.349,
              "y": 3.9269,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376104"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b7",
            "leftCorner": {
              "x": 49.349,
              "y": 3.9269,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.264,
              "y": 3.926,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b8",
            "leftCorner": {
              "x": 49.264,
              "y": 3.926,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.165,
              "y": 3.925,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925672"
          },
          {
            "id": "679afb3f3d9bab0f83ff63b9",
            "leftCorner": {
              "x": 49.165,
              "y": 3.925,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.103,
              "y": 3.9244,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172925672"
          },
          {
            "id": "679afb3f3d9bab0f83ff63ba",
            "leftCorner": {
              "x": 49.103,
              "y": 3.9244,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 49.045,
              "y": 3.9238,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff63bb",
            "leftCorner": {
              "x": 49.045,
              "y": 3.9238,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.986,
              "y": 3.9231,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277463"
          },
          {
            "id": "679afb3f3d9bab0f83ff63bc",
            "leftCorner": {
              "x": 48.986,
              "y": 3.9231,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.926,
              "y": 3.9225,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277463"
          },
          {
            "id": "679afb3f3d9bab0f83ff63bd",
            "leftCorner": {
              "x": 48.926,
              "y": 3.9225,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.867,
              "y": 3.9219,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277463"
          },
          {
            "id": "679afb3f3d9bab0f83ff63be",
            "leftCorner": {
              "x": 48.867,
              "y": 3.9219,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.803,
              "y": 3.9212,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447277463"
          },
          {
            "id": "679afb3f3d9bab0f83ff63bf",
            "leftCorner": {
              "x": 48.803,
              "y": 3.9212,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.742,
              "y": 3.9206,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376333"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c0",
            "leftCorner": {
              "x": 48.742,
              "y": 3.9206,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.684,
              "y": 3.92,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376333"
          },
          {
            "id": "679afb3f3d9bab0f83ff63c1",
            "leftCorner": {
              "x": 48.684,
              "y": 3.92,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.618,
              "y": 3.9193,
              "z": 0.42241
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376333"
          },
          {
            "id": "679afb3f3d9bab0f83ff6384",
            "leftCorner": {
              "x": 48.618,
              "y": 3.9193,
              "z": 0.42241
            },
            "rightCorner": {
              "x": 48.556,
              "y": 3.9187,
              "z": 0.42241
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447376333"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad95",
        "height": 0.71546,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6501",
            "leftCorner": {
              "x": 49.556,
              "y": 3.9274,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.502,
              "y": 3.9264,
              "z": 0.71546
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172926341"
          },
          {
            "id": "679afb3f3d9bab0f83ff6502",
            "leftCorner": {
              "x": 49.502,
              "y": 3.9269,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.452,
              "y": 3.9263,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800325405"
          },
          {
            "id": "679afb3f3d9bab0f83ff6503",
            "leftCorner": {
              "x": 49.452,
              "y": 3.9263,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.37,
              "y": 3.9255,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900614049"
          },
          {
            "id": "679afb3f3d9bab0f83ff6504",
            "leftCorner": {
              "x": 49.37,
              "y": 3.9255,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.286,
              "y": 3.9246,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006000079356"
          },
          {
            "id": "679afb3f3d9bab0f83ff6505",
            "leftCorner": {
              "x": 49.286,
              "y": 3.9246,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.19,
              "y": 3.9236,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900612663"
          },
          {
            "id": "679afb3f3d9bab0f83ff6506",
            "leftCorner": {
              "x": 49.19,
              "y": 3.9236,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.107,
              "y": 3.9227,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355351043"
          },
          {
            "id": "679afb3f3d9bab0f83ff6507",
            "leftCorner": {
              "x": 49.107,
              "y": 3.9227,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 49.049,
              "y": 3.9221,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355351012"
          },
          {
            "id": "679afb3f3d9bab0f83ff6508",
            "leftCorner": {
              "x": 49.049,
              "y": 3.9221,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.985,
              "y": 3.9215,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172181559"
          },
          {
            "id": "679afb3f3d9bab0f83ff6509",
            "leftCorner": {
              "x": 48.985,
              "y": 3.9215,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.916,
              "y": 3.9207,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506280"
          },
          {
            "id": "679afb3f3d9bab0f83ff650a",
            "leftCorner": {
              "x": 48.916,
              "y": 3.9207,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.852,
              "y": 3.9201,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506273"
          },
          {
            "id": "679afb3f3d9bab0f83ff650b",
            "leftCorner": {
              "x": 48.852,
              "y": 3.9201,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.782,
              "y": 3.9194,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447506259"
          },
          {
            "id": "679afb3f3d9bab0f83ff650c",
            "leftCorner": {
              "x": 48.782,
              "y": 3.9194,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.672,
              "y": 3.9182,
              "z": 0.71546
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7350113020710"
          },
          {
            "id": "679afb3f3d9bab0f83ff64f2",
            "leftCorner": {
              "x": 48.672,
              "y": 3.9182,
              "z": 0.71546
            },
            "rightCorner": {
              "x": 48.556,
              "y": 3.917,
              "z": 0.71546
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7350113020727"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad94",
        "height": 0.9656,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6516",
            "leftCorner": {
              "x": 49.594,
              "y": 3.9256,
              "z": 0.96802
            },
            "rightCorner": {
              "x": 49.479,
              "y": 3.9233,
              "z": 0.96802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090423023"
          },
          {
            "id": "679afb3f3d9bab0f83ff6517",
            "leftCorner": {
              "x": 49.48,
              "y": 3.9257,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 49.366,
              "y": 3.9245,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090560858"
          },
          {
            "id": "679afb3f3d9bab0f83ff6518",
            "leftCorner": {
              "x": 49.366,
              "y": 3.9245,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 49.257,
              "y": 3.9234,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060896573946"
          },
          {
            "id": "679afb3f3d9bab0f83ff6519",
            "leftCorner": {
              "x": 49.257,
              "y": 3.9234,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 49.154,
              "y": 3.9223,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800402373"
          },
          {
            "id": "679afb3f3d9bab0f83ff651a",
            "leftCorner": {
              "x": 49.154,
              "y": 3.9223,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 49.05,
              "y": 3.9212,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7702018417759"
          },
          {
            "id": "679afb3f3d9bab0f83ff651b",
            "leftCorner": {
              "x": 49.05,
              "y": 3.9212,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 48.956,
              "y": 3.9202,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800882168"
          },
          {
            "id": "679afb3f3d9bab0f83ff651c",
            "leftCorner": {
              "x": 48.956,
              "y": 3.9202,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 48.853,
              "y": 3.9192,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447119442"
          },
          {
            "id": "679afb3f3d9bab0f83ff651d",
            "leftCorner": {
              "x": 48.853,
              "y": 3.9192,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 48.749,
              "y": 3.9181,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562903"
          },
          {
            "id": "679afb3f3d9bab0f83ff651e",
            "leftCorner": {
              "x": 48.749,
              "y": 3.9181,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 48.646,
              "y": 3.917,
              "z": 0.9656
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562903"
          },
          {
            "id": "679afb3f3d9bab0f83ff650e",
            "leftCorner": {
              "x": 48.646,
              "y": 3.917,
              "z": 0.9656
            },
            "rightCorner": {
              "x": 48.556,
              "y": 3.9161,
              "z": 0.9656
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447562842"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad97",
        "height": 1.1781,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6356",
            "leftCorner": {
              "x": 49.59,
              "y": 3.9307,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 49.475,
              "y": 3.9285,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090423092"
          },
          {
            "id": "679afb3f3d9bab0f83ff6357",
            "leftCorner": {
              "x": 49.476,
              "y": 3.9285,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 49.376,
              "y": 3.9275,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800513109"
          },
          {
            "id": "679afb3f3d9bab0f83ff6358",
            "leftCorner": {
              "x": 49.376,
              "y": 3.9275,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 49.262,
              "y": 3.9263,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5060144646361"
          },
          {
            "id": "679afb3f3d9bab0f83ff6359",
            "leftCorner": {
              "x": 49.262,
              "y": 3.9263,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 49.162,
              "y": 3.9252,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800143801"
          },
          {
            "id": "679afb3f3d9bab0f83ff635a",
            "leftCorner": {
              "x": 49.162,
              "y": 3.9252,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 49.061,
              "y": 3.9242,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800892266"
          },
          {
            "id": "679afb3f3d9bab0f83ff635b",
            "leftCorner": {
              "x": 49.061,
              "y": 3.9242,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 48.965,
              "y": 3.9232,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027800373406"
          },
          {
            "id": "679afb3f3d9bab0f83ff635c",
            "leftCorner": {
              "x": 48.965,
              "y": 3.9232,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 48.866,
              "y": 3.9221,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447119428"
          },
          {
            "id": "679afb3f3d9bab0f83ff635d",
            "leftCorner": {
              "x": 48.866,
              "y": 3.9221,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 48.769,
              "y": 3.9211,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517286"
          },
          {
            "id": "679afb3f3d9bab0f83ff635e",
            "leftCorner": {
              "x": 48.769,
              "y": 3.9211,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 48.671,
              "y": 3.9201,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562897"
          },
          {
            "id": "679afb3f3d9bab0f83ff635f",
            "leftCorner": {
              "x": 48.671,
              "y": 3.9201,
              "z": 1.1781
            },
            "rightCorner": {
              "x": 48.575,
              "y": 3.9191,
              "z": 1.1781
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562835"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad98",
        "height": 1.3887,
        "facings": []
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad99",
        "height": 1.6825,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 49,
      "unknownStockCount": 10
    },
    "name": "HGZJ",
    "leftNeighborShelfId": "NDX2",
    "rightNeighborShelfId": "EG13"
  },
  {
    "id": "EG13",
    "x": 48.551,
    "y": 3.9274,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99997,
      "w": -0.007665
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ada0",
        "height": 0.1626,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5582",
            "leftCorner": {
              "x": 48.564,
              "y": 4.026,
              "z": 0.16023
            },
            "rightCorner": {
              "x": 48.512,
              "y": 4.0254,
              "z": 0.16023
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810189"
          },
          {
            "id": "679afb3d3d9bab0f83ff5583",
            "leftCorner": {
              "x": 48.506,
              "y": 4.0323,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.452,
              "y": 4.0315,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810189"
          },
          {
            "id": "679afb3d3d9bab0f83ff5584",
            "leftCorner": {
              "x": 48.452,
              "y": 4.0315,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.396,
              "y": 4.0307,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810165"
          },
          {
            "id": "679afb3d3d9bab0f83ff5585",
            "leftCorner": {
              "x": 48.396,
              "y": 4.0307,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.346,
              "y": 4.0299,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810165"
          },
          {
            "id": "679afb3d3d9bab0f83ff5586",
            "leftCorner": {
              "x": 48.346,
              "y": 4.0299,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.288,
              "y": 4.029,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810066"
          },
          {
            "id": "679afb3d3d9bab0f83ff5587",
            "leftCorner": {
              "x": 48.288,
              "y": 4.029,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.235,
              "y": 4.0282,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810066"
          },
          {
            "id": "679afb3d3d9bab0f83ff5588",
            "leftCorner": {
              "x": 48.235,
              "y": 4.0282,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.182,
              "y": 4.0274,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810240"
          },
          {
            "id": "679afb3d3d9bab0f83ff5589",
            "leftCorner": {
              "x": 48.182,
              "y": 4.0274,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.13,
              "y": 4.0266,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810240"
          },
          {
            "id": "679afb3d3d9bab0f83ff558a",
            "leftCorner": {
              "x": 48.13,
              "y": 4.0266,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.08,
              "y": 4.0258,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810141"
          },
          {
            "id": "679afb3d3d9bab0f83ff558b",
            "leftCorner": {
              "x": 48.08,
              "y": 4.0258,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 48.031,
              "y": 4.0251,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810141"
          },
          {
            "id": "679afb3d3d9bab0f83ff558c",
            "leftCorner": {
              "x": 48.031,
              "y": 4.0251,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.981,
              "y": 4.0243,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810448"
          },
          {
            "id": "679afb3d3d9bab0f83ff558d",
            "leftCorner": {
              "x": 47.981,
              "y": 4.0243,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.93,
              "y": 4.0235,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810448"
          },
          {
            "id": "679afb3d3d9bab0f83ff558e",
            "leftCorner": {
              "x": 47.93,
              "y": 4.0235,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.875,
              "y": 4.0227,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810486"
          },
          {
            "id": "679afb3d3d9bab0f83ff558f",
            "leftCorner": {
              "x": 47.875,
              "y": 4.0227,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.817,
              "y": 4.0218,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810486"
          },
          {
            "id": "679afb3d3d9bab0f83ff5590",
            "leftCorner": {
              "x": 47.817,
              "y": 4.0218,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.756,
              "y": 4.0209,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810462"
          },
          {
            "id": "679afb3d3d9bab0f83ff5591",
            "leftCorner": {
              "x": 47.756,
              "y": 4.0209,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.706,
              "y": 4.0201,
              "z": 0.1626
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810462"
          },
          {
            "id": "679afb3d3d9bab0f83ff5592",
            "leftCorner": {
              "x": 47.706,
              "y": 4.0201,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.655,
              "y": 4.0193,
              "z": 0.1626
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810585"
          },
          {
            "id": "679afb3d3d9bab0f83ff5593",
            "leftCorner": {
              "x": 47.655,
              "y": 4.0193,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.599,
              "y": 4.0184,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810585"
          },
          {
            "id": "679afb3d3d9bab0f83ff5594",
            "leftCorner": {
              "x": 47.599,
              "y": 4.0184,
              "z": 0.1626
            },
            "rightCorner": {
              "x": 47.544,
              "y": 4.0176,
              "z": 0.1626
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada1",
        "height": 0.46768,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff565a",
            "leftCorner": {
              "x": 48.551,
              "y": 3.9228,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.509,
              "y": 3.9222,
              "z": 0.46768
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447294835"
          },
          {
            "id": "679afb3d3d9bab0f83ff565c",
            "leftCorner": {
              "x": 48.509,
              "y": 3.9222,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.453,
              "y": 3.9213,
              "z": 0.46768
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447294835"
          },
          {
            "id": "679afb3d3d9bab0f83ff565d",
            "leftCorner": {
              "x": 48.453,
              "y": 3.9213,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.398,
              "y": 3.9205,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447294835"
          },
          {
            "id": "679afb3d3d9bab0f83ff565e",
            "leftCorner": {
              "x": 48.398,
              "y": 3.9205,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.34,
              "y": 3.9196,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447294835"
          },
          {
            "id": "679afb3d3d9bab0f83ff565f",
            "leftCorner": {
              "x": 48.34,
              "y": 3.9196,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.255,
              "y": 3.9183,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376654"
          },
          {
            "id": "679afb3d3d9bab0f83ff5660",
            "leftCorner": {
              "x": 48.255,
              "y": 3.9183,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.166,
              "y": 3.9169,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069617"
          },
          {
            "id": "679afb3d3d9bab0f83ff5661",
            "leftCorner": {
              "x": 48.166,
              "y": 3.9169,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.112,
              "y": 3.9161,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069617"
          },
          {
            "id": "679afb3d3d9bab0f83ff5662",
            "leftCorner": {
              "x": 48.112,
              "y": 3.9161,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.058,
              "y": 3.9153,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376692"
          },
          {
            "id": "679afb3d3d9bab0f83ff5663",
            "leftCorner": {
              "x": 48.058,
              "y": 3.9153,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 48.004,
              "y": 3.9144,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376692"
          },
          {
            "id": "679afb3d3d9bab0f83ff5664",
            "leftCorner": {
              "x": 48.004,
              "y": 3.9144,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.948,
              "y": 3.9136,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376692"
          },
          {
            "id": "679afb3d3d9bab0f83ff5665",
            "leftCorner": {
              "x": 47.948,
              "y": 3.9136,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.893,
              "y": 3.9127,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376692"
          },
          {
            "id": "679afb3d3d9bab0f83ff5666",
            "leftCorner": {
              "x": 47.893,
              "y": 3.9127,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.824,
              "y": 3.9117,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376715"
          },
          {
            "id": "679afb3d3d9bab0f83ff5667",
            "leftCorner": {
              "x": 47.824,
              "y": 3.9117,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.763,
              "y": 3.9107,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376715"
          },
          {
            "id": "679afb3d3d9bab0f83ff5668",
            "leftCorner": {
              "x": 47.763,
              "y": 3.9107,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.709,
              "y": 3.9099,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376715"
          },
          {
            "id": "679afb3d3d9bab0f83ff5669",
            "leftCorner": {
              "x": 47.709,
              "y": 3.9099,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.653,
              "y": 3.9091,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376715"
          },
          {
            "id": "679afb3d3d9bab0f83ff566a",
            "leftCorner": {
              "x": 47.653,
              "y": 3.9091,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.572,
              "y": 3.9078,
              "z": 0.46768
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376753"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad9d",
        "height": 0.80169,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56b5",
            "leftCorner": {
              "x": 48.551,
              "y": 3.9193,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.506,
              "y": 3.9187,
              "z": 0.80169
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100800562"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b7",
            "leftCorner": {
              "x": 48.506,
              "y": 3.9187,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.449,
              "y": 3.9178,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800562"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b8",
            "leftCorner": {
              "x": 48.449,
              "y": 3.9178,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.391,
              "y": 3.9169,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800524"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b9",
            "leftCorner": {
              "x": 48.391,
              "y": 3.9169,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.333,
              "y": 3.916,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800524"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ba",
            "leftCorner": {
              "x": 48.333,
              "y": 3.916,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.272,
              "y": 3.9151,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190465"
          },
          {
            "id": "679afb3d3d9bab0f83ff56bb",
            "leftCorner": {
              "x": 48.272,
              "y": 3.9151,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.212,
              "y": 3.9142,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190465"
          },
          {
            "id": "679afb3d3d9bab0f83ff56bc",
            "leftCorner": {
              "x": 48.212,
              "y": 3.9142,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.15,
              "y": 3.9132,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190199"
          },
          {
            "id": "679afb3d3d9bab0f83ff56bd",
            "leftCorner": {
              "x": 48.15,
              "y": 3.9132,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.093,
              "y": 3.9123,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190199"
          },
          {
            "id": "679afb3d3d9bab0f83ff56be",
            "leftCorner": {
              "x": 48.093,
              "y": 3.9123,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 48.033,
              "y": 3.9114,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190533"
          },
          {
            "id": "679afb3d3d9bab0f83ff56bf",
            "leftCorner": {
              "x": 48.033,
              "y": 3.9114,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 47.973,
              "y": 3.9105,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190434"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c0",
            "leftCorner": {
              "x": 47.973,
              "y": 3.9105,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 47.916,
              "y": 3.9096,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190434"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c1",
            "leftCorner": {
              "x": 47.916,
              "y": 3.9096,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 47.843,
              "y": 3.9085,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100190502"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c2",
            "leftCorner": {
              "x": 47.843,
              "y": 3.9085,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 47.719,
              "y": 3.9066,
              "z": 0.80169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847924"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c3",
            "leftCorner": {
              "x": 47.719,
              "y": 3.9066,
              "z": 0.80169
            },
            "rightCorner": {
              "x": 47.551,
              "y": 3.904,
              "z": 0.80169
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4064666847917"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad9e",
        "height": 1.1384,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55e6",
            "leftCorner": {
              "x": 48.551,
              "y": 3.9204,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.464,
              "y": 3.9191,
              "z": 1.1384
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447384352"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e7",
            "leftCorner": {
              "x": 48.464,
              "y": 3.9191,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.39,
              "y": 3.9179,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811001"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e8",
            "leftCorner": {
              "x": 48.39,
              "y": 3.9179,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.321,
              "y": 3.9169,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811063"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e9",
            "leftCorner": {
              "x": 48.321,
              "y": 3.9169,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.244,
              "y": 3.9157,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810905"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ea",
            "leftCorner": {
              "x": 48.244,
              "y": 3.9157,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.171,
              "y": 3.9146,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810943"
          },
          {
            "id": "679afb3d3d9bab0f83ff55eb",
            "leftCorner": {
              "x": 48.171,
              "y": 3.9146,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.095,
              "y": 3.9134,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810820"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ec",
            "leftCorner": {
              "x": 48.095,
              "y": 3.9134,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 48.027,
              "y": 3.9124,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800326"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ed",
            "leftCorner": {
              "x": 48.027,
              "y": 3.9124,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.974,
              "y": 3.9116,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800401"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ee",
            "leftCorner": {
              "x": 47.974,
              "y": 3.9116,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.891,
              "y": 3.9103,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800388"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ef",
            "leftCorner": {
              "x": 47.891,
              "y": 3.9103,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.802,
              "y": 3.9089,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800548"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f0",
            "leftCorner": {
              "x": 47.802,
              "y": 3.9089,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.736,
              "y": 3.9079,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "830372000434"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f1",
            "leftCorner": {
              "x": 47.736,
              "y": 3.9079,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.665,
              "y": 3.9068,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "830372000434"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f2",
            "leftCorner": {
              "x": 47.665,
              "y": 3.9068,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.589,
              "y": 3.9057,
              "z": 1.1384
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "830372000441"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad9b",
        "height": 1.3034,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff651f",
            "leftCorner": {
              "x": 48.551,
              "y": 3.92,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.466,
              "y": 3.9187,
              "z": 1.3034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600522471691"
          },
          {
            "id": "679afb3f3d9bab0f83ff6521",
            "leftCorner": {
              "x": 48.466,
              "y": 3.9187,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.389,
              "y": 3.9176,
              "z": 1.3034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447384468"
          },
          {
            "id": "679afb3f3d9bab0f83ff6522",
            "leftCorner": {
              "x": 48.389,
              "y": 3.9176,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.308,
              "y": 3.9163,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260064539"
          },
          {
            "id": "679afb3f3d9bab0f83ff6523",
            "leftCorner": {
              "x": 48.308,
              "y": 3.9163,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.231,
              "y": 3.9151,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900137432"
          },
          {
            "id": "679afb3f3d9bab0f83ff6524",
            "leftCorner": {
              "x": 48.231,
              "y": 3.9151,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.156,
              "y": 3.914,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900183828"
          },
          {
            "id": "679afb3f3d9bab0f83ff6525",
            "leftCorner": {
              "x": 48.156,
              "y": 3.914,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.084,
              "y": 3.9129,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355247193"
          },
          {
            "id": "679afb3f3d9bab0f83ff6526",
            "leftCorner": {
              "x": 48.084,
              "y": 3.9129,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 48.01,
              "y": 3.9118,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447079296"
          },
          {
            "id": "679afb3f3d9bab0f83ff6527",
            "leftCorner": {
              "x": 48.01,
              "y": 3.9118,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.938,
              "y": 3.9106,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355247216"
          },
          {
            "id": "679afb3f3d9bab0f83ff6528",
            "leftCorner": {
              "x": 47.938,
              "y": 3.9106,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.862,
              "y": 3.9095,
              "z": 1.3034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447383768"
          },
          {
            "id": "679afb3f3d9bab0f83ff6529",
            "leftCorner": {
              "x": 47.862,
              "y": 3.9095,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.786,
              "y": 3.9083,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342215"
          },
          {
            "id": "679afb3f3d9bab0f83ff652a",
            "leftCorner": {
              "x": 47.786,
              "y": 3.9083,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.718,
              "y": 3.9073,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384505"
          },
          {
            "id": "679afb3f3d9bab0f83ff652b",
            "leftCorner": {
              "x": 47.718,
              "y": 3.9073,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.656,
              "y": 3.9063,
              "z": 1.3034
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4255599601077"
          },
          {
            "id": "679afb3f3d9bab0f83ff6520",
            "leftCorner": {
              "x": 47.656,
              "y": 3.9063,
              "z": 1.3034
            },
            "rightCorner": {
              "x": 47.551,
              "y": 3.9047,
              "z": 1.3034
            },
            "stockLevel": "UNKNOWN",
            "gtin": "745178575799"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad9c",
        "height": 1.5153,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff652c",
            "leftCorner": {
              "x": 48.551,
              "y": 3.9236,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.495,
              "y": 3.9228,
              "z": 1.5153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810844"
          },
          {
            "id": "679afb3f3d9bab0f83ff652e",
            "leftCorner": {
              "x": 48.495,
              "y": 3.9228,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.439,
              "y": 3.9219,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810844"
          },
          {
            "id": "679afb3f3d9bab0f83ff652f",
            "leftCorner": {
              "x": 48.439,
              "y": 3.9219,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.387,
              "y": 3.9211,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811049"
          },
          {
            "id": "679afb3f3d9bab0f83ff6530",
            "leftCorner": {
              "x": 48.387,
              "y": 3.9211,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.336,
              "y": 3.9203,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810967"
          },
          {
            "id": "679afb3f3d9bab0f83ff6531",
            "leftCorner": {
              "x": 48.336,
              "y": 3.9203,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.279,
              "y": 3.9195,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811025"
          },
          {
            "id": "679afb3f3d9bab0f83ff6532",
            "leftCorner": {
              "x": 48.279,
              "y": 3.9195,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.228,
              "y": 3.9187,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811025"
          },
          {
            "id": "679afb3f3d9bab0f83ff6533",
            "leftCorner": {
              "x": 48.228,
              "y": 3.9187,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.175,
              "y": 3.9179,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810882"
          },
          {
            "id": "679afb3f3d9bab0f83ff6534",
            "leftCorner": {
              "x": 48.175,
              "y": 3.9179,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.127,
              "y": 3.9171,
              "z": 1.5153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810882"
          },
          {
            "id": "679afb3f3d9bab0f83ff6535",
            "leftCorner": {
              "x": 48.127,
              "y": 3.9171,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.08,
              "y": 3.9164,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800500"
          },
          {
            "id": "679afb3f3d9bab0f83ff6536",
            "leftCorner": {
              "x": 48.08,
              "y": 3.9164,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 48.035,
              "y": 3.9157,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800067"
          },
          {
            "id": "679afb3f3d9bab0f83ff6537",
            "leftCorner": {
              "x": 48.035,
              "y": 3.9157,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 47.98,
              "y": 3.9149,
              "z": 1.5153
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260064522"
          },
          {
            "id": "679afb3f3d9bab0f83ff6538",
            "leftCorner": {
              "x": 47.98,
              "y": 3.9149,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 47.761,
              "y": 3.9115,
              "z": 1.5153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796082036"
          },
          {
            "id": "679afb3f3d9bab0f83ff6539",
            "leftCorner": {
              "x": 47.761,
              "y": 3.9115,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 47.598,
              "y": 3.909,
              "z": 1.5153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447563931"
          },
          {
            "id": "679afb3f3d9bab0f83ff652d",
            "leftCorner": {
              "x": 47.598,
              "y": 3.909,
              "z": 1.5153
            },
            "rightCorner": {
              "x": 47.551,
              "y": 3.9083,
              "z": 1.5153
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447438666"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ad9f",
        "height": 1.7288,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5633",
            "leftCorner": {
              "x": 48.551,
              "y": 3.9216,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.487,
              "y": 3.9206,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162025183"
          },
          {
            "id": "679afb3d3d9bab0f83ff5635",
            "leftCorner": {
              "x": 48.487,
              "y": 3.9206,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.417,
              "y": 3.9196,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4013162032815"
          },
          {
            "id": "679afb3d3d9bab0f83ff5636",
            "leftCorner": {
              "x": 48.417,
              "y": 3.9196,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.368,
              "y": 3.9188,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447110982"
          },
          {
            "id": "679afb3d3d9bab0f83ff5637",
            "leftCorner": {
              "x": 48.368,
              "y": 3.9188,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.316,
              "y": 3.918,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447110982"
          },
          {
            "id": "679afb3d3d9bab0f83ff5638",
            "leftCorner": {
              "x": 48.316,
              "y": 3.918,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.262,
              "y": 3.9172,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5639",
            "leftCorner": {
              "x": 48.262,
              "y": 3.9172,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.212,
              "y": 3.9164,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492149"
          },
          {
            "id": "679afb3d3d9bab0f83ff563a",
            "leftCorner": {
              "x": 48.212,
              "y": 3.9164,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.162,
              "y": 3.9156,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492149"
          },
          {
            "id": "679afb3d3d9bab0f83ff563b",
            "leftCorner": {
              "x": 48.162,
              "y": 3.9156,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.107,
              "y": 3.9148,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384314"
          },
          {
            "id": "679afb3d3d9bab0f83ff563c",
            "leftCorner": {
              "x": 48.107,
              "y": 3.9148,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.059,
              "y": 3.9141,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384314"
          },
          {
            "id": "679afb3d3d9bab0f83ff563d",
            "leftCorner": {
              "x": 48.059,
              "y": 3.9141,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 48.009,
              "y": 3.9133,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447110968"
          },
          {
            "id": "679afb3d3d9bab0f83ff563e",
            "leftCorner": {
              "x": 48.009,
              "y": 3.9133,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 47.791,
              "y": 3.91,
              "z": 1.7288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172737916"
          },
          {
            "id": "679afb3d3d9bab0f83ff563f",
            "leftCorner": {
              "x": 47.791,
              "y": 3.91,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 47.608,
              "y": 3.9072,
              "z": 1.7288
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3614226254283"
          },
          {
            "id": "679afb3d3d9bab0f83ff5640",
            "leftCorner": {
              "x": 47.608,
              "y": 3.9072,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 47.543,
              "y": 3.9062,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 84,
      "unknownStockCount": 18
    },
    "name": "EG13",
    "leftNeighborShelfId": "HGZJ",
    "rightNeighborShelfId": "R92R"
  },
  {
    "id": "R92R",
    "x": 47.569,
    "y": 3.91,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99995,
      "w": -0.009797
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3ada4",
        "height": 0.1657,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5595",
            "leftCorner": {
              "x": 47.567,
              "y": 4.0063,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.42,
              "y": 4.004,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810547"
          },
          {
            "id": "679afb3d3d9bab0f83ff5596",
            "leftCorner": {
              "x": 47.42,
              "y": 4.0034,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.273,
              "y": 4.0005,
              "z": 0.1657
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810523"
          },
          {
            "id": "679afb3d3d9bab0f83ff5597",
            "leftCorner": {
              "x": 47.273,
              "y": 4.0005,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.223,
              "y": 3.9995,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815641"
          },
          {
            "id": "679afb3d3d9bab0f83ff5598",
            "leftCorner": {
              "x": 47.223,
              "y": 3.9995,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.177,
              "y": 3.9986,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100809961"
          },
          {
            "id": "679afb3d3d9bab0f83ff5599",
            "leftCorner": {
              "x": 47.177,
              "y": 3.9986,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.131,
              "y": 3.9977,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100809961"
          },
          {
            "id": "679afb3d3d9bab0f83ff559a",
            "leftCorner": {
              "x": 47.131,
              "y": 3.9977,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.078,
              "y": 3.9967,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100809985"
          },
          {
            "id": "679afb3d3d9bab0f83ff559b",
            "leftCorner": {
              "x": 47.078,
              "y": 3.9967,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 47.028,
              "y": 3.9957,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100809985"
          },
          {
            "id": "679afb3d3d9bab0f83ff559c",
            "leftCorner": {
              "x": 47.028,
              "y": 3.9957,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.977,
              "y": 3.9947,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810103"
          },
          {
            "id": "679afb3d3d9bab0f83ff559d",
            "leftCorner": {
              "x": 46.977,
              "y": 3.9947,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.928,
              "y": 3.9937,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810080"
          },
          {
            "id": "679afb3d3d9bab0f83ff559e",
            "leftCorner": {
              "x": 46.928,
              "y": 3.9937,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.881,
              "y": 3.9928,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810080"
          },
          {
            "id": "679afb3d3d9bab0f83ff559f",
            "leftCorner": {
              "x": 46.881,
              "y": 3.9928,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.832,
              "y": 3.9919,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810028"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a0",
            "leftCorner": {
              "x": 46.832,
              "y": 3.9919,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.784,
              "y": 3.9909,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810028"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a1",
            "leftCorner": {
              "x": 46.784,
              "y": 3.9909,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.729,
              "y": 3.9899,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796083118"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a2",
            "leftCorner": {
              "x": 46.729,
              "y": 3.9899,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.676,
              "y": 3.9888,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796083118"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a3",
            "leftCorner": {
              "x": 46.676,
              "y": 3.9888,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.622,
              "y": 3.9877,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376838"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a4",
            "leftCorner": {
              "x": 46.622,
              "y": 3.9877,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.567,
              "y": 3.9867,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376838"
          },
          {
            "id": "679afb3d3d9bab0f83ff55a5",
            "leftCorner": {
              "x": 46.567,
              "y": 3.9867,
              "z": 0.1657
            },
            "rightCorner": {
              "x": 46.527,
              "y": 3.9859,
              "z": 0.1657
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada2",
        "height": 0.46791,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff566b",
            "leftCorner": {
              "x": 47.572,
              "y": 3.9078,
              "z": 0.46768
            },
            "rightCorner": {
              "x": 47.389,
              "y": 3.905,
              "z": 0.46768
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447599930"
          },
          {
            "id": "679afb3d3d9bab0f83ff566c",
            "leftCorner": {
              "x": 47.407,
              "y": 3.8843,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 47.255,
              "y": 3.8813,
              "z": 0.46791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447376678"
          },
          {
            "id": "679afb3d3d9bab0f83ff566d",
            "leftCorner": {
              "x": 47.255,
              "y": 3.8813,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 47.199,
              "y": 3.8802,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376791"
          },
          {
            "id": "679afb3d3d9bab0f83ff566e",
            "leftCorner": {
              "x": 47.199,
              "y": 3.8802,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 47.145,
              "y": 3.8792,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376791"
          },
          {
            "id": "679afb3d3d9bab0f83ff566f",
            "leftCorner": {
              "x": 47.145,
              "y": 3.8792,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 47.091,
              "y": 3.8781,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376791"
          },
          {
            "id": "679afb3d3d9bab0f83ff5670",
            "leftCorner": {
              "x": 47.091,
              "y": 3.8781,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 47.038,
              "y": 3.8771,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447376883"
          },
          {
            "id": "679afb3d3d9bab0f83ff5671",
            "leftCorner": {
              "x": 47.038,
              "y": 3.8771,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.98,
              "y": 3.8759,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540650318"
          },
          {
            "id": "679afb3d3d9bab0f83ff5672",
            "leftCorner": {
              "x": 46.98,
              "y": 3.8759,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.925,
              "y": 3.8749,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522471684"
          },
          {
            "id": "679afb3d3d9bab0f83ff5673",
            "leftCorner": {
              "x": 46.925,
              "y": 3.8749,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.871,
              "y": 3.8738,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522471684"
          },
          {
            "id": "679afb3d3d9bab0f83ff5674",
            "leftCorner": {
              "x": 46.871,
              "y": 3.8738,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.825,
              "y": 3.8729,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522471714"
          },
          {
            "id": "679afb3d3d9bab0f83ff5675",
            "leftCorner": {
              "x": 46.825,
              "y": 3.8729,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.78,
              "y": 3.872,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522471714"
          },
          {
            "id": "679afb3d3d9bab0f83ff5676",
            "leftCorner": {
              "x": 46.78,
              "y": 3.872,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.729,
              "y": 3.871,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749444"
          },
          {
            "id": "679afb3d3d9bab0f83ff5677",
            "leftCorner": {
              "x": 46.729,
              "y": 3.871,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.678,
              "y": 3.87,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749444"
          },
          {
            "id": "679afb3d3d9bab0f83ff5678",
            "leftCorner": {
              "x": 46.678,
              "y": 3.87,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.622,
              "y": 3.8689,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749604"
          },
          {
            "id": "679afb3d3d9bab0f83ff5679",
            "leftCorner": {
              "x": 46.622,
              "y": 3.8689,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.571,
              "y": 3.8679,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749406"
          },
          {
            "id": "679afb3d3d9bab0f83ff567a",
            "leftCorner": {
              "x": 46.571,
              "y": 3.8679,
              "z": 0.46791
            },
            "rightCorner": {
              "x": 46.535,
              "y": 3.8672,
              "z": 0.46791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900749406"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada3",
        "height": 0.80379,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56c4",
            "leftCorner": {
              "x": 47.569,
              "y": 3.888,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.509,
              "y": 3.8871,
              "z": 0.80379
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4064666847900"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c5",
            "leftCorner": {
              "x": 47.509,
              "y": 3.8868,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.343,
              "y": 3.8835,
              "z": 0.80379
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4064666847894"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c6",
            "leftCorner": {
              "x": 47.343,
              "y": 3.8835,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.293,
              "y": 3.8826,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847948"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c7",
            "leftCorner": {
              "x": 47.293,
              "y": 3.8826,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.241,
              "y": 3.8816,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847948"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c8",
            "leftCorner": {
              "x": 47.241,
              "y": 3.8816,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.19,
              "y": 3.8805,
              "z": 0.80379
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4064666847870"
          },
          {
            "id": "679afb3d3d9bab0f83ff56c9",
            "leftCorner": {
              "x": 47.19,
              "y": 3.8805,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.139,
              "y": 3.8795,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847870"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ca",
            "leftCorner": {
              "x": 47.139,
              "y": 3.8795,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.085,
              "y": 3.8785,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847955"
          },
          {
            "id": "679afb3d3d9bab0f83ff56cb",
            "leftCorner": {
              "x": 47.085,
              "y": 3.8785,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 47.027,
              "y": 3.8774,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4064666847955"
          },
          {
            "id": "679afb3d3d9bab0f83ff56cc",
            "leftCorner": {
              "x": 47.027,
              "y": 3.8774,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.97,
              "y": 3.8762,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728675"
          },
          {
            "id": "679afb3d3d9bab0f83ff56cd",
            "leftCorner": {
              "x": 46.97,
              "y": 3.8762,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.918,
              "y": 3.8752,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728620"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ce",
            "leftCorner": {
              "x": 46.918,
              "y": 3.8752,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.864,
              "y": 3.8742,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728620"
          },
          {
            "id": "679afb3d3d9bab0f83ff56cf",
            "leftCorner": {
              "x": 46.864,
              "y": 3.8742,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.811,
              "y": 3.8731,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3614229728637"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d0",
            "leftCorner": {
              "x": 46.811,
              "y": 3.8731,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.76,
              "y": 3.8721,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524163785"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d1",
            "leftCorner": {
              "x": 46.76,
              "y": 3.8721,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.708,
              "y": 3.8711,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522910015"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d2",
            "leftCorner": {
              "x": 46.708,
              "y": 3.8711,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.655,
              "y": 3.8701,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524164614"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d3",
            "leftCorner": {
              "x": 46.655,
              "y": 3.8701,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.602,
              "y": 3.869,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524164614"
          },
          {
            "id": "679afb3d3d9bab0f83ff56d4",
            "leftCorner": {
              "x": 46.602,
              "y": 3.869,
              "z": 0.80379
            },
            "rightCorner": {
              "x": 46.565,
              "y": 3.8683,
              "z": 0.80379
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7610099050423"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada6",
        "height": 1.1419,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55f3",
            "leftCorner": {
              "x": 47.589,
              "y": 3.9057,
              "z": 1.1384
            },
            "rightCorner": {
              "x": 47.431,
              "y": 3.9032,
              "z": 1.1384
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447376890"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f4",
            "leftCorner": {
              "x": 47.449,
              "y": 3.8864,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.328,
              "y": 3.884,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800449"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f5",
            "leftCorner": {
              "x": 47.328,
              "y": 3.884,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.276,
              "y": 3.883,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811698"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f6",
            "leftCorner": {
              "x": 47.276,
              "y": 3.883,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.234,
              "y": 3.8822,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3760104912315"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f7",
            "leftCorner": {
              "x": 47.234,
              "y": 3.8822,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.193,
              "y": 3.8814,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120112221771"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f8",
            "leftCorner": {
              "x": 47.193,
              "y": 3.8814,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.151,
              "y": 3.8806,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120130822318"
          },
          {
            "id": "679afb3d3d9bab0f83ff55f9",
            "leftCorner": {
              "x": 47.151,
              "y": 3.8806,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 47.108,
              "y": 3.8797,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120082229296"
          },
          {
            "id": "679afb3d3d9bab0f83ff55fa",
            "leftCorner": {
              "x": 47.108,
              "y": 3.8797,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.973,
              "y": 3.8771,
              "z": 1.1419
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3760104916573"
          },
          {
            "id": "679afb3d3d9bab0f83ff55fb",
            "leftCorner": {
              "x": 46.973,
              "y": 3.8771,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.839,
              "y": 3.8745,
              "z": 1.1419
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4063528078551"
          },
          {
            "id": "679afb3d3d9bab0f83ff55fc",
            "leftCorner": {
              "x": 46.839,
              "y": 3.8745,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.795,
              "y": 3.8736,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078551"
          },
          {
            "id": "679afb3d3d9bab0f83ff55fd",
            "leftCorner": {
              "x": 46.795,
              "y": 3.8736,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.747,
              "y": 3.8727,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078643"
          },
          {
            "id": "679afb3d3d9bab0f83ff55fe",
            "leftCorner": {
              "x": 46.747,
              "y": 3.8727,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.695,
              "y": 3.8716,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078612"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ff",
            "leftCorner": {
              "x": 46.695,
              "y": 3.8716,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.643,
              "y": 3.8706,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078582"
          },
          {
            "id": "679afb3d3d9bab0f83ff5600",
            "leftCorner": {
              "x": 46.643,
              "y": 3.8706,
              "z": 1.1419
            },
            "rightCorner": {
              "x": 46.594,
              "y": 3.8697,
              "z": 1.1419
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078674"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada5",
        "height": 1.4353,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5612",
            "leftCorner": {
              "x": 47.569,
              "y": 3.8899,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.444,
              "y": 3.8875,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447563917"
          },
          {
            "id": "679afb3d3d9bab0f83ff5614",
            "leftCorner": {
              "x": 47.444,
              "y": 3.8875,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.354,
              "y": 3.8857,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800180"
          },
          {
            "id": "679afb3d3d9bab0f83ff5615",
            "leftCorner": {
              "x": 47.354,
              "y": 3.8857,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.313,
              "y": 3.8849,
              "z": 1.4353
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100810684"
          },
          {
            "id": "679afb3d3d9bab0f83ff5616",
            "leftCorner": {
              "x": 47.313,
              "y": 3.8849,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.264,
              "y": 3.884,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069570"
          },
          {
            "id": "679afb3d3d9bab0f83ff5617",
            "leftCorner": {
              "x": 47.264,
              "y": 3.884,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.215,
              "y": 3.883,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796069570"
          },
          {
            "id": "679afb3d3d9bab0f83ff5618",
            "leftCorner": {
              "x": 47.215,
              "y": 3.883,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.124,
              "y": 3.8812,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100743098"
          },
          {
            "id": "679afb3d3d9bab0f83ff5619",
            "leftCorner": {
              "x": 47.124,
              "y": 3.8812,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.077,
              "y": 3.8803,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447438802"
          },
          {
            "id": "679afb3d3d9bab0f83ff561a",
            "leftCorner": {
              "x": 47.077,
              "y": 3.8803,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 47.015,
              "y": 3.8791,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800609"
          },
          {
            "id": "679afb3d3d9bab0f83ff561b",
            "leftCorner": {
              "x": 47.015,
              "y": 3.8791,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.929,
              "y": 3.8774,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810981"
          },
          {
            "id": "679afb3d3d9bab0f83ff561c",
            "leftCorner": {
              "x": 46.929,
              "y": 3.8774,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.854,
              "y": 3.8759,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342079"
          },
          {
            "id": "679afb3d3d9bab0f83ff561d",
            "leftCorner": {
              "x": 46.854,
              "y": 3.8759,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.791,
              "y": 3.8747,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240825"
          },
          {
            "id": "679afb3d3d9bab0f83ff561e",
            "leftCorner": {
              "x": 46.791,
              "y": 3.8747,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.724,
              "y": 3.8734,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384567"
          },
          {
            "id": "679afb3d3d9bab0f83ff561f",
            "leftCorner": {
              "x": 46.724,
              "y": 3.8734,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.68,
              "y": 3.8725,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447384567"
          },
          {
            "id": "679afb3d3d9bab0f83ff5620",
            "leftCorner": {
              "x": 46.68,
              "y": 3.8725,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.64,
              "y": 3.8717,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383843"
          },
          {
            "id": "679afb3d3d9bab0f83ff5621",
            "leftCorner": {
              "x": 46.64,
              "y": 3.8717,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.595,
              "y": 3.8708,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447342277"
          },
          {
            "id": "679afb3d3d9bab0f83ff5622",
            "leftCorner": {
              "x": 46.595,
              "y": 3.8708,
              "z": 1.4353
            },
            "rightCorner": {
              "x": 46.568,
              "y": 3.8703,
              "z": 1.4353
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796150766"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada7",
        "height": 1.7312,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5641",
            "leftCorner": {
              "x": 47.543,
              "y": 3.9062,
              "z": 1.7288
            },
            "rightCorner": {
              "x": 47.394,
              "y": 3.9039,
              "z": 1.7288
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3030050185874"
          },
          {
            "id": "679afb3d3d9bab0f83ff5642",
            "leftCorner": {
              "x": 47.413,
              "y": 3.8856,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 47.167,
              "y": 3.8807,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3030050185867"
          },
          {
            "id": "679afb3d3d9bab0f83ff5643",
            "leftCorner": {
              "x": 47.167,
              "y": 3.8807,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.986,
              "y": 3.8772,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008496877461"
          },
          {
            "id": "679afb3d3d9bab0f83ff5644",
            "leftCorner": {
              "x": 46.986,
              "y": 3.8772,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.932,
              "y": 3.8761,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810264"
          },
          {
            "id": "679afb3d3d9bab0f83ff5645",
            "leftCorner": {
              "x": 46.932,
              "y": 3.8761,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.859,
              "y": 3.8747,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100810400"
          },
          {
            "id": "679afb3d3d9bab0f83ff5646",
            "leftCorner": {
              "x": 46.859,
              "y": 3.8747,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.791,
              "y": 3.8734,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523966714"
          },
          {
            "id": "679afb3d3d9bab0f83ff5647",
            "leftCorner": {
              "x": 46.791,
              "y": 3.8734,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.745,
              "y": 3.8725,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100800128"
          },
          {
            "id": "679afb3d3d9bab0f83ff5648",
            "leftCorner": {
              "x": 46.745,
              "y": 3.8725,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.693,
              "y": 3.8715,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522280774"
          },
          {
            "id": "679afb3d3d9bab0f83ff5649",
            "leftCorner": {
              "x": 46.693,
              "y": 3.8715,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.646,
              "y": 3.8705,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100802139"
          },
          {
            "id": "679afb3d3d9bab0f83ff564a",
            "leftCorner": {
              "x": 46.646,
              "y": 3.8705,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.597,
              "y": 3.8696,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383829"
          },
          {
            "id": "679afb3d3d9bab0f83ff564b",
            "leftCorner": {
              "x": 46.597,
              "y": 3.8696,
              "z": 1.7312
            },
            "rightCorner": {
              "x": 46.565,
              "y": 3.869,
              "z": 1.7312
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447383829"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 81,
      "unknownStockCount": 10
    },
    "name": "R92R",
    "leftNeighborShelfId": "EG13",
    "rightNeighborShelfId": "RI2E"
  },
  {
    "id": "DIVG",
    "x": 45.553,
    "y": 3.8813,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.9999,
      "w": -0.01436
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3adad",
        "height": 0.16083,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55b7",
            "leftCorner": {
              "x": 45.484,
              "y": 3.9762,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.396,
              "y": 3.9737,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100336566"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b8",
            "leftCorner": {
              "x": 45.396,
              "y": 3.9737,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.313,
              "y": 3.9713,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100336580"
          },
          {
            "id": "679afb3d3d9bab0f83ff55b9",
            "leftCorner": {
              "x": 45.313,
              "y": 3.9713,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.226,
              "y": 3.9688,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100336689"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ba",
            "leftCorner": {
              "x": 45.226,
              "y": 3.9688,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.171,
              "y": 3.9672,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100726862"
          },
          {
            "id": "679afb3d3d9bab0f83ff55bb",
            "leftCorner": {
              "x": 45.171,
              "y": 3.9672,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.09,
              "y": 3.9649,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100336702"
          },
          {
            "id": "679afb3d3d9bab0f83ff55bc",
            "leftCorner": {
              "x": 45.09,
              "y": 3.9649,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 45.007,
              "y": 3.9625,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100336702"
          },
          {
            "id": "679afb3d3d9bab0f83ff55bd",
            "leftCorner": {
              "x": 45.007,
              "y": 3.9625,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.949,
              "y": 3.9609,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9000101666366"
          },
          {
            "id": "679afb3d3d9bab0f83ff55be",
            "leftCorner": {
              "x": 44.949,
              "y": 3.9609,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.859,
              "y": 3.9583,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100744651"
          },
          {
            "id": "679afb3d3d9bab0f83ff55bf",
            "leftCorner": {
              "x": 44.859,
              "y": 3.9583,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.781,
              "y": 3.956,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814859"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c0",
            "leftCorner": {
              "x": 44.781,
              "y": 3.956,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.71,
              "y": 3.954,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814859"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c1",
            "leftCorner": {
              "x": 44.71,
              "y": 3.954,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.658,
              "y": 3.9525,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121435"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c2",
            "leftCorner": {
              "x": 44.658,
              "y": 3.9525,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.611,
              "y": 3.9511,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702181865"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c3",
            "leftCorner": {
              "x": 44.611,
              "y": 3.9511,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.569,
              "y": 3.9499,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702181933"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c4",
            "leftCorner": {
              "x": 44.569,
              "y": 3.9499,
              "z": 0.16083
            },
            "rightCorner": {
              "x": 44.52,
              "y": 3.9485,
              "z": 0.16083
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702181933"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adab",
        "height": 0.46463,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff568a",
            "leftCorner": {
              "x": 45.439,
              "y": 3.865,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 45.308,
              "y": 3.8612,
              "z": 0.46463
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447793529"
          },
          {
            "id": "679afb3d3d9bab0f83ff568b",
            "leftCorner": {
              "x": 45.308,
              "y": 3.8612,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 45.24,
              "y": 3.8593,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447763782"
          },
          {
            "id": "679afb3d3d9bab0f83ff568c",
            "leftCorner": {
              "x": 45.24,
              "y": 3.8593,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 45.178,
              "y": 3.8575,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447763782"
          },
          {
            "id": "679afb3d3d9bab0f83ff568d",
            "leftCorner": {
              "x": 45.178,
              "y": 3.8575,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 45.115,
              "y": 3.8557,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447765441"
          },
          {
            "id": "679afb3d3d9bab0f83ff568e",
            "leftCorner": {
              "x": 45.115,
              "y": 3.8557,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 45.053,
              "y": 3.8539,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447765441"
          },
          {
            "id": "679afb3d3d9bab0f83ff568f",
            "leftCorner": {
              "x": 45.053,
              "y": 3.8539,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.991,
              "y": 3.8521,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661563312"
          },
          {
            "id": "679afb3d3d9bab0f83ff5690",
            "leftCorner": {
              "x": 44.991,
              "y": 3.8521,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.904,
              "y": 3.8496,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3574661799438"
          },
          {
            "id": "679afb3d3d9bab0f83ff5691",
            "leftCorner": {
              "x": 44.904,
              "y": 3.8496,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.825,
              "y": 3.8473,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "22796976123"
          },
          {
            "id": "679afb3d3d9bab0f83ff5692",
            "leftCorner": {
              "x": 44.825,
              "y": 3.8473,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.746,
              "y": 3.8451,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "22796976123"
          },
          {
            "id": "679afb3d3d9bab0f83ff5693",
            "leftCorner": {
              "x": 44.746,
              "y": 3.8451,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.666,
              "y": 3.8428,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "22796976703"
          },
          {
            "id": "679afb3d3d9bab0f83ff5694",
            "leftCorner": {
              "x": 44.666,
              "y": 3.8428,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.63,
              "y": 3.8417,
              "z": 0.46463
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff5695",
            "leftCorner": {
              "x": 44.63,
              "y": 3.8417,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.583,
              "y": 3.8404,
              "z": 0.46463
            },
            "stockLevel": "UNKNOWN",
            "gtin": "22796976710"
          },
          {
            "id": "679afb3d3d9bab0f83ff5696",
            "leftCorner": {
              "x": 44.583,
              "y": 3.8404,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.549,
              "y": 3.8394,
              "z": 0.46463
            },
            "stockLevel": "UNKNOWN",
            "gtin": "22796976710"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adac",
        "height": 0.79849,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56e6",
            "leftCorner": {
              "x": 45.554,
              "y": 3.8643,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45.433,
              "y": 3.8642,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238891"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e7",
            "leftCorner": {
              "x": 45.433,
              "y": 3.8609,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45.268,
              "y": 3.8562,
              "z": 0.79849
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447238952"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e8",
            "leftCorner": {
              "x": 45.268,
              "y": 3.8562,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45.183,
              "y": 3.8537,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238877"
          },
          {
            "id": "679afb3d3d9bab0f83ff56e9",
            "leftCorner": {
              "x": 45.183,
              "y": 3.8537,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45.118,
              "y": 3.8518,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238877"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ea",
            "leftCorner": {
              "x": 45.118,
              "y": 3.8518,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45.058,
              "y": 3.8501,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238938"
          },
          {
            "id": "679afb3d3d9bab0f83ff56eb",
            "leftCorner": {
              "x": 45.058,
              "y": 3.8501,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 45,
              "y": 3.8484,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238938"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ec",
            "leftCorner": {
              "x": 45,
              "y": 3.8484,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.959,
              "y": 3.8473,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154863"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ed",
            "leftCorner": {
              "x": 44.959,
              "y": 3.8473,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.876,
              "y": 3.8449,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239072"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ee",
            "leftCorner": {
              "x": 44.876,
              "y": 3.8449,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.811,
              "y": 3.843,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239133"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ef",
            "leftCorner": {
              "x": 44.811,
              "y": 3.843,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.751,
              "y": 3.8413,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239133"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f0",
            "leftCorner": {
              "x": 44.751,
              "y": 3.8413,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.69,
              "y": 3.8395,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447239157"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f1",
            "leftCorner": {
              "x": 44.69,
              "y": 3.8395,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.654,
              "y": 3.8385,
              "z": 0.79849
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447239157"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f2",
            "leftCorner": {
              "x": 44.654,
              "y": 3.8385,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.624,
              "y": 3.8377,
              "z": 0.79849
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f3",
            "leftCorner": {
              "x": 44.624,
              "y": 3.8377,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.575,
              "y": 3.8362,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704709"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f4",
            "leftCorner": {
              "x": 44.575,
              "y": 3.8362,
              "z": 0.79849
            },
            "rightCorner": {
              "x": 44.526,
              "y": 3.8348,
              "z": 0.79849
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447704709"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada8",
        "height": 1.0923,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff653a",
            "leftCorner": {
              "x": 45.554,
              "y": 3.8647,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.442,
              "y": 3.8615,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260045736"
          },
          {
            "id": "679afb3f3d9bab0f83ff653c",
            "leftCorner": {
              "x": 45.442,
              "y": 3.8615,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.33,
              "y": 3.8582,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172920684"
          },
          {
            "id": "679afb3f3d9bab0f83ff653d",
            "leftCorner": {
              "x": 45.33,
              "y": 3.8582,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.275,
              "y": 3.8567,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241679"
          },
          {
            "id": "679afb3f3d9bab0f83ff653e",
            "leftCorner": {
              "x": 45.275,
              "y": 3.8567,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.219,
              "y": 3.8551,
              "z": 1.0923
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447241679"
          },
          {
            "id": "679afb3f3d9bab0f83ff653f",
            "leftCorner": {
              "x": 45.219,
              "y": 3.8551,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.129,
              "y": 3.8525,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241693"
          },
          {
            "id": "679afb3f3d9bab0f83ff6540",
            "leftCorner": {
              "x": 45.129,
              "y": 3.8525,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.058,
              "y": 3.8504,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241723"
          },
          {
            "id": "679afb3f3d9bab0f83ff6541",
            "leftCorner": {
              "x": 45.058,
              "y": 3.8504,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 45.003,
              "y": 3.8489,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172831386"
          },
          {
            "id": "679afb3f3d9bab0f83ff6542",
            "leftCorner": {
              "x": 45.003,
              "y": 3.8489,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.95,
              "y": 3.8473,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172831386"
          },
          {
            "id": "679afb3f3d9bab0f83ff6543",
            "leftCorner": {
              "x": 44.95,
              "y": 3.8473,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.897,
              "y": 3.8458,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238228"
          },
          {
            "id": "679afb3f3d9bab0f83ff6544",
            "leftCorner": {
              "x": 44.897,
              "y": 3.8458,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.843,
              "y": 3.8443,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796150643"
          },
          {
            "id": "679afb3f3d9bab0f83ff6545",
            "leftCorner": {
              "x": 44.843,
              "y": 3.8443,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.794,
              "y": 3.8428,
              "z": 1.0923
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172920684"
          },
          {
            "id": "679afb3f3d9bab0f83ff6546",
            "leftCorner": {
              "x": 44.794,
              "y": 3.8428,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.707,
              "y": 3.8403,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002621"
          },
          {
            "id": "679afb3f3d9bab0f83ff6547",
            "leftCorner": {
              "x": 44.707,
              "y": 3.8403,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.616,
              "y": 3.8377,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796002584"
          },
          {
            "id": "679afb3f3d9bab0f83ff6548",
            "leftCorner": {
              "x": 44.616,
              "y": 3.8377,
              "z": 1.0923
            },
            "rightCorner": {
              "x": 44.527,
              "y": 3.8352,
              "z": 1.0923
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172702150"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3ada9",
        "height": 1.3866,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6559",
            "leftCorner": {
              "x": 45.554,
              "y": 3.8664,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 45.387,
              "y": 3.8616,
              "z": 1.3866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540154151"
          },
          {
            "id": "679afb3f3d9bab0f83ff655b",
            "leftCorner": {
              "x": 45.387,
              "y": 3.8616,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 45.149,
              "y": 3.8548,
              "z": 1.3866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841217055"
          },
          {
            "id": "679afb3f3d9bab0f83ff655c",
            "leftCorner": {
              "x": 45.149,
              "y": 3.8548,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 45.059,
              "y": 3.8522,
              "z": 1.3866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841214832"
          },
          {
            "id": "679afb3f3d9bab0f83ff655d",
            "leftCorner": {
              "x": 45.059,
              "y": 3.8522,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.974,
              "y": 3.8497,
              "z": 1.3866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841228488"
          },
          {
            "id": "679afb3f3d9bab0f83ff655e",
            "leftCorner": {
              "x": 44.974,
              "y": 3.8497,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.892,
              "y": 3.8474,
              "z": 1.3866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4897097266329"
          },
          {
            "id": "679afb3f3d9bab0f83ff655f",
            "leftCorner": {
              "x": 44.892,
              "y": 3.8474,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.812,
              "y": 3.8451,
              "z": 1.3866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4897097266329"
          },
          {
            "id": "679afb3f3d9bab0f83ff6560",
            "leftCorner": {
              "x": 44.812,
              "y": 3.8451,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.732,
              "y": 3.8428,
              "z": 1.3866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4897097266404"
          },
          {
            "id": "679afb3f3d9bab0f83ff6561",
            "leftCorner": {
              "x": 44.732,
              "y": 3.8428,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.632,
              "y": 3.8399,
              "z": 1.3866
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4897097266312"
          },
          {
            "id": "679afb3f3d9bab0f83ff6562",
            "leftCorner": {
              "x": 44.632,
              "y": 3.8399,
              "z": 1.3866
            },
            "rightCorner": {
              "x": 44.554,
              "y": 3.8377,
              "z": 1.3866
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4897097266398"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adaa",
        "height": 1.6792,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6572",
            "leftCorner": {
              "x": 45.554,
              "y": 3.8647,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.465,
              "y": 3.8621,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078285"
          },
          {
            "id": "679afb3f3d9bab0f83ff6574",
            "leftCorner": {
              "x": 45.465,
              "y": 3.8621,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.375,
              "y": 3.8596,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6575",
            "leftCorner": {
              "x": 45.375,
              "y": 3.8596,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.305,
              "y": 3.8575,
              "z": 1.6792
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4063528078346"
          },
          {
            "id": "679afb3f3d9bab0f83ff6576",
            "leftCorner": {
              "x": 45.305,
              "y": 3.8575,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.202,
              "y": 3.8546,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078193"
          },
          {
            "id": "679afb3f3d9bab0f83ff6577",
            "leftCorner": {
              "x": 45.202,
              "y": 3.8546,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.085,
              "y": 3.8512,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078254"
          },
          {
            "id": "679afb3f3d9bab0f83ff6578",
            "leftCorner": {
              "x": 45.085,
              "y": 3.8512,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 45.026,
              "y": 3.8495,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078377"
          },
          {
            "id": "679afb3f3d9bab0f83ff6579",
            "leftCorner": {
              "x": 45.026,
              "y": 3.8495,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.976,
              "y": 3.8481,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078407"
          },
          {
            "id": "679afb3f3d9bab0f83ff657a",
            "leftCorner": {
              "x": 44.976,
              "y": 3.8481,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.925,
              "y": 3.8466,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078438"
          },
          {
            "id": "679afb3f3d9bab0f83ff657b",
            "leftCorner": {
              "x": 44.925,
              "y": 3.8466,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.874,
              "y": 3.8452,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078490"
          },
          {
            "id": "679afb3f3d9bab0f83ff657c",
            "leftCorner": {
              "x": 44.874,
              "y": 3.8452,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.823,
              "y": 3.8437,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078490"
          },
          {
            "id": "679afb3f3d9bab0f83ff657d",
            "leftCorner": {
              "x": 44.823,
              "y": 3.8437,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.778,
              "y": 3.8424,
              "z": 1.6792
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528078520"
          },
          {
            "id": "679afb3f3d9bab0f83ff657e",
            "leftCorner": {
              "x": 44.778,
              "y": 3.8424,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.665,
              "y": 3.8392,
              "z": 1.6792
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4063528086334"
          },
          {
            "id": "679afb3f3d9bab0f83ff657f",
            "leftCorner": {
              "x": 44.665,
              "y": 3.8392,
              "z": 1.6792
            },
            "rightCorner": {
              "x": 44.554,
              "y": 3.836,
              "z": 1.6792
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4063528086303"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 61,
      "unknownStockCount": 16
    },
    "name": "DIVG",
    "leftNeighborShelfId": "RI2E",
    "rightNeighborShelfId": "FGUG"
  },
  {
    "id": "FGUG",
    "x": 44.551,
    "y": 3.8513,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99995,
      "w": -0.0098944
    },
    "layers": [
      {
        "id": "679aebdb1f3fd8b81ad3adb3",
        "height": 0.16051,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55c5",
            "leftCorner": {
              "x": 44.518,
              "y": 3.9545,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.465,
              "y": 3.9535,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260702181902"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c6",
            "leftCorner": {
              "x": 44.465,
              "y": 3.9535,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.414,
              "y": 3.9525,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401731730"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c7",
            "leftCorner": {
              "x": 44.414,
              "y": 3.9525,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.358,
              "y": 3.9513,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401731686"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c8",
            "leftCorner": {
              "x": 44.358,
              "y": 3.9513,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.308,
              "y": 3.9504,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401731716"
          },
          {
            "id": "679afb3d3d9bab0f83ff55c9",
            "leftCorner": {
              "x": 44.308,
              "y": 3.9504,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.254,
              "y": 3.9493,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121404"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ca",
            "leftCorner": {
              "x": 44.254,
              "y": 3.9493,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.2,
              "y": 3.9482,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121466"
          },
          {
            "id": "679afb3d3d9bab0f83ff55cb",
            "leftCorner": {
              "x": 44.2,
              "y": 3.9482,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.147,
              "y": 3.9472,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121510"
          },
          {
            "id": "679afb3d3d9bab0f83ff55cc",
            "leftCorner": {
              "x": 44.147,
              "y": 3.9472,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.105,
              "y": 3.9463,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401733253"
          },
          {
            "id": "679afb3d3d9bab0f83ff55cd",
            "leftCorner": {
              "x": 44.105,
              "y": 3.9463,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.058,
              "y": 3.9454,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121497"
          },
          {
            "id": "679afb3d3d9bab0f83ff55ce",
            "leftCorner": {
              "x": 44.058,
              "y": 3.9454,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 44.006,
              "y": 3.9444,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260602121497"
          },
          {
            "id": "679afb3d3d9bab0f83ff55cf",
            "leftCorner": {
              "x": 44.006,
              "y": 3.9444,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.954,
              "y": 3.9433,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401732935"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d0",
            "leftCorner": {
              "x": 43.954,
              "y": 3.9433,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.901,
              "y": 3.9423,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401732959"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d1",
            "leftCorner": {
              "x": 43.901,
              "y": 3.9423,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.856,
              "y": 3.9414,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401732522"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d2",
            "leftCorner": {
              "x": 43.856,
              "y": 3.9414,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.809,
              "y": 3.9405,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262401732560"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d3",
            "leftCorner": {
              "x": 43.809,
              "y": 3.9405,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.742,
              "y": 3.9391,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796083507"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d4",
            "leftCorner": {
              "x": 43.742,
              "y": 3.9391,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.674,
              "y": 3.9378,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107371"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d5",
            "leftCorner": {
              "x": 43.674,
              "y": 3.9378,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.616,
              "y": 3.9367,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331271"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d6",
            "leftCorner": {
              "x": 43.616,
              "y": 3.9367,
              "z": 0.16051
            },
            "rightCorner": {
              "x": 43.5,
              "y": 3.9344,
              "z": 0.16051
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331356"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adaf",
        "height": 0.46438,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff5697",
            "leftCorner": {
              "x": 44.549,
              "y": 3.8394,
              "z": 0.46463
            },
            "rightCorner": {
              "x": 44.466,
              "y": 3.837,
              "z": 0.46463
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "22796977519"
          },
          {
            "id": "679afb3d3d9bab0f83ff5698",
            "leftCorner": {
              "x": 44.462,
              "y": 3.8458,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.382,
              "y": 3.8442,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600703304"
          },
          {
            "id": "679afb3d3d9bab0f83ff5699",
            "leftCorner": {
              "x": 44.382,
              "y": 3.8442,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.33,
              "y": 3.8432,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600703403"
          },
          {
            "id": "679afb3d3d9bab0f83ff569a",
            "leftCorner": {
              "x": 44.33,
              "y": 3.8432,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.252,
              "y": 3.8416,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600720219"
          },
          {
            "id": "679afb3d3d9bab0f83ff569b",
            "leftCorner": {
              "x": 44.252,
              "y": 3.8416,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.204,
              "y": 3.8407,
              "z": 0.46438
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4072600720226"
          },
          {
            "id": "679afb3d3d9bab0f83ff569c",
            "leftCorner": {
              "x": 44.204,
              "y": 3.8407,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.117,
              "y": 3.839,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282281"
          },
          {
            "id": "679afb3d3d9bab0f83ff569d",
            "leftCorner": {
              "x": 44.117,
              "y": 3.839,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 44.062,
              "y": 3.8379,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282298"
          },
          {
            "id": "679afb3d3d9bab0f83ff569e",
            "leftCorner": {
              "x": 44.062,
              "y": 3.8379,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.984,
              "y": 3.8363,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282304"
          },
          {
            "id": "679afb3d3d9bab0f83ff569f",
            "leftCorner": {
              "x": 43.984,
              "y": 3.8363,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.903,
              "y": 3.8347,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282199"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a0",
            "leftCorner": {
              "x": 43.903,
              "y": 3.8347,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.823,
              "y": 3.8331,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282458"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a1",
            "leftCorner": {
              "x": 43.823,
              "y": 3.8331,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.742,
              "y": 3.8315,
              "z": 0.46438
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4072600282458"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a2",
            "leftCorner": {
              "x": 43.742,
              "y": 3.8315,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.676,
              "y": 3.8302,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282465"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a3",
            "leftCorner": {
              "x": 43.676,
              "y": 3.8302,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.596,
              "y": 3.8286,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282373"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a4",
            "leftCorner": {
              "x": 43.596,
              "y": 3.8286,
              "z": 0.46438
            },
            "rightCorner": {
              "x": 43.446,
              "y": 3.8257,
              "z": 0.46438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282380"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adae",
        "height": 0.79857,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56f5",
            "leftCorner": {
              "x": 44.522,
              "y": 3.8435,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.479,
              "y": 3.8427,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164343166"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f6",
            "leftCorner": {
              "x": 44.479,
              "y": 3.8427,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.419,
              "y": 3.8415,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164343166"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f7",
            "leftCorner": {
              "x": 44.419,
              "y": 3.8415,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.368,
              "y": 3.8405,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164302064"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f8",
            "leftCorner": {
              "x": 44.368,
              "y": 3.8405,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.267,
              "y": 3.8385,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164333068"
          },
          {
            "id": "679afb3d3d9bab0f83ff56f9",
            "leftCorner": {
              "x": 44.267,
              "y": 3.8385,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.209,
              "y": 3.8373,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164393178"
          },
          {
            "id": "679afb3d3d9bab0f83ff56fa",
            "leftCorner": {
              "x": 44.209,
              "y": 3.8373,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.152,
              "y": 3.8362,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164304211"
          },
          {
            "id": "679afb3d3d9bab0f83ff56fb",
            "leftCorner": {
              "x": 44.152,
              "y": 3.8362,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 44.051,
              "y": 3.8342,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164393970"
          },
          {
            "id": "679afb3d3d9bab0f83ff56fc",
            "leftCorner": {
              "x": 44.051,
              "y": 3.8342,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.993,
              "y": 3.8331,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164304112"
          },
          {
            "id": "679afb3d3d9bab0f83ff56fd",
            "leftCorner": {
              "x": 43.993,
              "y": 3.8331,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.944,
              "y": 3.8321,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "71164363317"
          },
          {
            "id": "679afb3d3d9bab0f83ff56fe",
            "leftCorner": {
              "x": 43.944,
              "y": 3.8321,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.859,
              "y": 3.8304,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600283172"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ff",
            "leftCorner": {
              "x": 43.859,
              "y": 3.8304,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.776,
              "y": 3.8288,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282427"
          },
          {
            "id": "679afb3d3d9bab0f83ff5700",
            "leftCorner": {
              "x": 43.776,
              "y": 3.8288,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.719,
              "y": 3.8276,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282441"
          },
          {
            "id": "679afb3d3d9bab0f83ff5701",
            "leftCorner": {
              "x": 43.719,
              "y": 3.8276,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.628,
              "y": 3.8258,
              "z": 0.79857
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282205"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b6",
            "leftCorner": {
              "x": 43.628,
              "y": 3.8258,
              "z": 0.79857
            },
            "rightCorner": {
              "x": 43.551,
              "y": 3.8243,
              "z": 0.79857
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4072600282274"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb1",
        "height": 1.0916,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6549",
            "leftCorner": {
              "x": 44.523,
              "y": 3.8418,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.442,
              "y": 3.8402,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156271546"
          },
          {
            "id": "679afb3f3d9bab0f83ff654a",
            "leftCorner": {
              "x": 44.442,
              "y": 3.8402,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.388,
              "y": 3.8392,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156286427"
          },
          {
            "id": "679afb3f3d9bab0f83ff654b",
            "leftCorner": {
              "x": 44.388,
              "y": 3.8392,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.335,
              "y": 3.8381,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225365"
          },
          {
            "id": "679afb3f3d9bab0f83ff654c",
            "leftCorner": {
              "x": 44.335,
              "y": 3.8381,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.285,
              "y": 3.8371,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156263961"
          },
          {
            "id": "679afb3f3d9bab0f83ff654d",
            "leftCorner": {
              "x": 44.285,
              "y": 3.8371,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.223,
              "y": 3.8359,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "50002993"
          },
          {
            "id": "679afb3f3d9bab0f83ff654e",
            "leftCorner": {
              "x": 44.223,
              "y": 3.8359,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.173,
              "y": 3.8349,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156285321"
          },
          {
            "id": "679afb3f3d9bab0f83ff654f",
            "leftCorner": {
              "x": 44.173,
              "y": 3.8349,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.125,
              "y": 3.8339,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156285352"
          },
          {
            "id": "679afb3f3d9bab0f83ff6550",
            "leftCorner": {
              "x": 44.125,
              "y": 3.8339,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.082,
              "y": 3.8331,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156293432"
          },
          {
            "id": "679afb3f3d9bab0f83ff6551",
            "leftCorner": {
              "x": 44.082,
              "y": 3.8331,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 44.022,
              "y": 3.8319,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156285383"
          },
          {
            "id": "679afb3f3d9bab0f83ff6552",
            "leftCorner": {
              "x": 44.022,
              "y": 3.8319,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.972,
              "y": 3.8309,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156292985"
          },
          {
            "id": "679afb3f3d9bab0f83ff6553",
            "leftCorner": {
              "x": 43.972,
              "y": 3.8309,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.921,
              "y": 3.8299,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156267907"
          },
          {
            "id": "679afb3f3d9bab0f83ff6554",
            "leftCorner": {
              "x": 43.921,
              "y": 3.8299,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.869,
              "y": 3.8289,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225044"
          },
          {
            "id": "679afb3f3d9bab0f83ff6555",
            "leftCorner": {
              "x": 43.869,
              "y": 3.8289,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.818,
              "y": 3.8279,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225051"
          },
          {
            "id": "679afb3f3d9bab0f83ff6556",
            "leftCorner": {
              "x": 43.818,
              "y": 3.8279,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.776,
              "y": 3.827,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156278125"
          },
          {
            "id": "679afb3f3d9bab0f83ff6557",
            "leftCorner": {
              "x": 43.776,
              "y": 3.827,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.739,
              "y": 3.8263,
              "z": 1.0916
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600720080"
          },
          {
            "id": "679afb3f3d9bab0f83ff6558",
            "leftCorner": {
              "x": 43.739,
              "y": 3.8263,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.656,
              "y": 3.8247,
              "z": 1.0916
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4072600720097"
          },
          {
            "id": "679afb3f3d9bab0f83ff653b",
            "leftCorner": {
              "x": 43.656,
              "y": 3.8247,
              "z": 1.0916
            },
            "rightCorner": {
              "x": 43.551,
              "y": 3.8226,
              "z": 1.0916
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4072600710135"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb2",
        "height": 1.3883,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6563",
            "leftCorner": {
              "x": 44.551,
              "y": 3.8429,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.508,
              "y": 3.8417,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225440"
          },
          {
            "id": "679afb3f3d9bab0f83ff6564",
            "leftCorner": {
              "x": 44.508,
              "y": 3.842,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.431,
              "y": 3.8405,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225457"
          },
          {
            "id": "679afb3f3d9bab0f83ff6565",
            "leftCorner": {
              "x": 44.431,
              "y": 3.8405,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.378,
              "y": 3.8395,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225471"
          },
          {
            "id": "679afb3f3d9bab0f83ff6566",
            "leftCorner": {
              "x": 44.378,
              "y": 3.8395,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.324,
              "y": 3.8384,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225471"
          },
          {
            "id": "679afb3f3d9bab0f83ff6567",
            "leftCorner": {
              "x": 44.324,
              "y": 3.8384,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.266,
              "y": 3.8373,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225464"
          },
          {
            "id": "679afb3f3d9bab0f83ff6568",
            "leftCorner": {
              "x": 44.266,
              "y": 3.8373,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.214,
              "y": 3.8362,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225488"
          },
          {
            "id": "679afb3f3d9bab0f83ff6569",
            "leftCorner": {
              "x": 44.214,
              "y": 3.8362,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.163,
              "y": 3.8352,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225495"
          },
          {
            "id": "679afb3f3d9bab0f83ff656a",
            "leftCorner": {
              "x": 44.163,
              "y": 3.8352,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.081,
              "y": 3.8336,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156254273"
          },
          {
            "id": "679afb3f3d9bab0f83ff656b",
            "leftCorner": {
              "x": 44.081,
              "y": 3.8336,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 44.013,
              "y": 3.8322,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225518"
          },
          {
            "id": "679afb3f3d9bab0f83ff656c",
            "leftCorner": {
              "x": 44.013,
              "y": 3.8322,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.962,
              "y": 3.8312,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225525"
          },
          {
            "id": "679afb3f3d9bab0f83ff656d",
            "leftCorner": {
              "x": 43.962,
              "y": 3.8312,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.907,
              "y": 3.8301,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225587"
          },
          {
            "id": "679afb3f3d9bab0f83ff656e",
            "leftCorner": {
              "x": 43.907,
              "y": 3.8301,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.853,
              "y": 3.8291,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156225587"
          },
          {
            "id": "679afb3f3d9bab0f83ff656f",
            "leftCorner": {
              "x": 43.853,
              "y": 3.8291,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.801,
              "y": 3.828,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156294255"
          },
          {
            "id": "679afb3f3d9bab0f83ff6570",
            "leftCorner": {
              "x": 43.801,
              "y": 3.828,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.749,
              "y": 3.827,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156294262"
          },
          {
            "id": "679afb3f3d9bab0f83ff6571",
            "leftCorner": {
              "x": 43.749,
              "y": 3.827,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.669,
              "y": 3.8254,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156275292"
          },
          {
            "id": "679afb3f3d9bab0f83ff655a",
            "leftCorner": {
              "x": 43.669,
              "y": 3.8254,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 43.551,
              "y": 3.8231,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5037156279450"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb0",
        "height": 1.6811,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6580",
            "leftCorner": {
              "x": 44.551,
              "y": 3.8423,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.492,
              "y": 3.8406,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262825"
          },
          {
            "id": "679afb3f3d9bab0f83ff6581",
            "leftCorner": {
              "x": 44.492,
              "y": 3.8411,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.376,
              "y": 3.8388,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262849"
          },
          {
            "id": "679afb3f3d9bab0f83ff6582",
            "leftCorner": {
              "x": 44.376,
              "y": 3.8388,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.29,
              "y": 3.8371,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262849"
          },
          {
            "id": "679afb3f3d9bab0f83ff6583",
            "leftCorner": {
              "x": 44.29,
              "y": 3.8371,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.222,
              "y": 3.8358,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216212786"
          },
          {
            "id": "679afb3f3d9bab0f83ff6584",
            "leftCorner": {
              "x": 44.222,
              "y": 3.8358,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.171,
              "y": 3.8348,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216210546"
          },
          {
            "id": "679afb3f3d9bab0f83ff6585",
            "leftCorner": {
              "x": 44.171,
              "y": 3.8348,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.103,
              "y": 3.8334,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216212847"
          },
          {
            "id": "679afb3f3d9bab0f83ff6586",
            "leftCorner": {
              "x": 44.103,
              "y": 3.8334,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 44.053,
              "y": 3.8324,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216210607"
          },
          {
            "id": "679afb3f3d9bab0f83ff6587",
            "leftCorner": {
              "x": 44.053,
              "y": 3.8324,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.966,
              "y": 3.8307,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216227018"
          },
          {
            "id": "679afb3f3d9bab0f83ff6588",
            "leftCorner": {
              "x": 43.966,
              "y": 3.8307,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.894,
              "y": 3.8293,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216212748"
          },
          {
            "id": "679afb3f3d9bab0f83ff6589",
            "leftCorner": {
              "x": 43.894,
              "y": 3.8293,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.823,
              "y": 3.8279,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216212748"
          },
          {
            "id": "679afb3f3d9bab0f83ff658a",
            "leftCorner": {
              "x": 43.823,
              "y": 3.8279,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.768,
              "y": 3.8268,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216210508"
          },
          {
            "id": "679afb3f3d9bab0f83ff658b",
            "leftCorner": {
              "x": 43.768,
              "y": 3.8268,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.675,
              "y": 3.8249,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216212724"
          },
          {
            "id": "679afb3f3d9bab0f83ff658c",
            "leftCorner": {
              "x": 43.675,
              "y": 3.8249,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.602,
              "y": 3.8235,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216309653"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 87,
      "unknownStockCount": 3
    },
    "name": "FGUG",
    "leftNeighborShelfId": "DIVG",
    "rightNeighborShelfId": "QJ5N"
  },
  {
    "id": "QJ5N",
    "x": 43.53,
    "y": 3.8293,
    "width": 1,
    "height": 2,
    "depth": 0.448,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99994,
      "w": 0.011318
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adba",
        "height": 0.1587,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff55d7",
            "leftCorner": {
              "x": 43.484,
              "y": 3.9354,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.417,
              "y": 3.9369,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447235777"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d8",
            "leftCorner": {
              "x": 43.417,
              "y": 3.9369,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.353,
              "y": 3.9384,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447592085"
          },
          {
            "id": "679afb3d3d9bab0f83ff55d9",
            "leftCorner": {
              "x": 43.353,
              "y": 3.9384,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.241,
              "y": 3.9409,
              "z": 0.1587
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447330915"
          },
          {
            "id": "679afb3d3d9bab0f83ff55da",
            "leftCorner": {
              "x": 43.241,
              "y": 3.9409,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.147,
              "y": 3.943,
              "z": 0.1587
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447330953"
          },
          {
            "id": "679afb3d3d9bab0f83ff55db",
            "leftCorner": {
              "x": 43.147,
              "y": 3.943,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.086,
              "y": 3.9444,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332308"
          },
          {
            "id": "679afb3d3d9bab0f83ff55dc",
            "leftCorner": {
              "x": 43.086,
              "y": 3.9444,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 43.018,
              "y": 3.946,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332322"
          },
          {
            "id": "679afb3d3d9bab0f83ff55dd",
            "leftCorner": {
              "x": 43.018,
              "y": 3.946,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.964,
              "y": 3.9472,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331240"
          },
          {
            "id": "679afb3d3d9bab0f83ff55de",
            "leftCorner": {
              "x": 42.964,
              "y": 3.9472,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.924,
              "y": 3.9481,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332285"
          },
          {
            "id": "679afb3d3d9bab0f83ff55df",
            "leftCorner": {
              "x": 42.924,
              "y": 3.9481,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.872,
              "y": 3.9493,
              "z": 0.1587
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447331226"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e0",
            "leftCorner": {
              "x": 42.872,
              "y": 3.9493,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.846,
              "y": 3.9498,
              "z": 0.1587
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331226"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e1",
            "leftCorner": {
              "x": 42.846,
              "y": 3.9498,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.816,
              "y": 3.9505,
              "z": 0.1587
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447331226"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e2",
            "leftCorner": {
              "x": 42.816,
              "y": 3.9505,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.79,
              "y": 3.9511,
              "z": 0.1587
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331226"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e3",
            "leftCorner": {
              "x": 42.79,
              "y": 3.9511,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.729,
              "y": 3.9525,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523621"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e4",
            "leftCorner": {
              "x": 42.729,
              "y": 3.9525,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.672,
              "y": 3.9538,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523621"
          },
          {
            "id": "679afb3d3d9bab0f83ff55e5",
            "leftCorner": {
              "x": 42.672,
              "y": 3.9538,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.607,
              "y": 3.9552,
              "z": 0.1587
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447107357"
          },
          {
            "id": "679afb3d3d9bab0f83ff5558",
            "leftCorner": {
              "x": 42.607,
              "y": 3.9552,
              "z": 0.1587
            },
            "rightCorner": {
              "x": 42.533,
              "y": 3.9569,
              "z": 0.1587
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447107357"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb4",
        "height": 0.45964,
        "facings": [
          {
            "id": "679afb3d3d9bab0f83ff56a5",
            "leftCorner": {
              "x": 43.425,
              "y": 3.8228,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.358,
              "y": 3.8243,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331332"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a6",
            "leftCorner": {
              "x": 43.358,
              "y": 3.8243,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.298,
              "y": 3.8257,
              "z": 0.45964
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447523584"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a7",
            "leftCorner": {
              "x": 43.298,
              "y": 3.8257,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.24,
              "y": 3.827,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523584"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a8",
            "leftCorner": {
              "x": 43.24,
              "y": 3.827,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.207,
              "y": 3.8278,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331202"
          },
          {
            "id": "679afb3d3d9bab0f83ff56a9",
            "leftCorner": {
              "x": 43.207,
              "y": 3.8278,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.174,
              "y": 3.8285,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331202"
          },
          {
            "id": "679afb3d3d9bab0f83ff56aa",
            "leftCorner": {
              "x": 43.174,
              "y": 3.8285,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.138,
              "y": 3.8293,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331202"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ab",
            "leftCorner": {
              "x": 43.138,
              "y": 3.8293,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.104,
              "y": 3.8301,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331202"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ac",
            "leftCorner": {
              "x": 43.104,
              "y": 3.8301,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.059,
              "y": 3.8311,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796102857"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ad",
            "leftCorner": {
              "x": 43.059,
              "y": 3.8311,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 43.006,
              "y": 3.8323,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796102857"
          },
          {
            "id": "679afb3d3d9bab0f83ff56ae",
            "leftCorner": {
              "x": 43.006,
              "y": 3.8323,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.959,
              "y": 3.8334,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523942"
          },
          {
            "id": "679afb3d3d9bab0f83ff56af",
            "leftCorner": {
              "x": 42.959,
              "y": 3.8334,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.907,
              "y": 3.8345,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523942"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b0",
            "leftCorner": {
              "x": 42.907,
              "y": 3.8345,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.852,
              "y": 3.8358,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331172"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b1",
            "leftCorner": {
              "x": 42.852,
              "y": 3.8358,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.79,
              "y": 3.8372,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331226"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b2",
            "leftCorner": {
              "x": 42.79,
              "y": 3.8372,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.725,
              "y": 3.8387,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796081992"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b3",
            "leftCorner": {
              "x": 42.725,
              "y": 3.8387,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.672,
              "y": 3.8399,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070064"
          },
          {
            "id": "679afb3d3d9bab0f83ff56b4",
            "leftCorner": {
              "x": 42.672,
              "y": 3.8399,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.607,
              "y": 3.8413,
              "z": 0.45964
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447235333"
          },
          {
            "id": "679afb3d3d9bab0f83ff565b",
            "leftCorner": {
              "x": 42.607,
              "y": 3.8413,
              "z": 0.45964
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8431,
              "z": 0.45964
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447235333"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb5",
        "height": 0.75367,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff659b",
            "leftCorner": {
              "x": 43.53,
              "y": 3.8183,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.433,
              "y": 3.8205,
              "z": 0.75367
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4021457655144"
          },
          {
            "id": "679afb3f3d9bab0f83ff659d",
            "leftCorner": {
              "x": 43.433,
              "y": 3.8205,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.375,
              "y": 3.8218,
              "z": 0.75367
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4021457655151"
          },
          {
            "id": "679afb3f3d9bab0f83ff659e",
            "leftCorner": {
              "x": 43.375,
              "y": 3.8218,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.259,
              "y": 3.8244,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655113"
          },
          {
            "id": "679afb3f3d9bab0f83ff659f",
            "leftCorner": {
              "x": 43.259,
              "y": 3.8244,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.149,
              "y": 3.8269,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655120"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a0",
            "leftCorner": {
              "x": 43.149,
              "y": 3.8269,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.091,
              "y": 3.8282,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655120"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a1",
            "leftCorner": {
              "x": 43.091,
              "y": 3.8282,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 43.032,
              "y": 3.8296,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655281"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a2",
            "leftCorner": {
              "x": 43.032,
              "y": 3.8296,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.973,
              "y": 3.8309,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655106"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a3",
            "leftCorner": {
              "x": 42.973,
              "y": 3.8309,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.913,
              "y": 3.8323,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655106"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a4",
            "leftCorner": {
              "x": 42.913,
              "y": 3.8323,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.852,
              "y": 3.8337,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655137"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a5",
            "leftCorner": {
              "x": 42.852,
              "y": 3.8337,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.798,
              "y": 3.8349,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655137"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a6",
            "leftCorner": {
              "x": 42.798,
              "y": 3.8349,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.737,
              "y": 3.8363,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331295"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a7",
            "leftCorner": {
              "x": 42.737,
              "y": 3.8363,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.667,
              "y": 3.8378,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331295"
          },
          {
            "id": "679afb3f3d9bab0f83ff65a8",
            "leftCorner": {
              "x": 42.667,
              "y": 3.8378,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.606,
              "y": 3.8392,
              "z": 0.75367
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447523669"
          },
          {
            "id": "679afb3f3d9bab0f83ff659c",
            "leftCorner": {
              "x": 42.606,
              "y": 3.8392,
              "z": 0.75367
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8409,
              "z": 0.75367
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447523669"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb6",
        "height": 1.0439,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65a9",
            "leftCorner": {
              "x": 43.53,
              "y": 3.8163,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 43.445,
              "y": 3.8182,
              "z": 1.0439
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260556675831"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ab",
            "leftCorner": {
              "x": 43.445,
              "y": 3.8182,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 43.215,
              "y": 3.8234,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4055297220088"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ac",
            "leftCorner": {
              "x": 43.215,
              "y": 3.8234,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 43.015,
              "y": 3.828,
              "z": 1.0439
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4055297220804"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ad",
            "leftCorner": {
              "x": 43.015,
              "y": 3.828,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.975,
              "y": 3.8289,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4055297220804"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ae",
            "leftCorner": {
              "x": 42.975,
              "y": 3.8289,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.922,
              "y": 3.8301,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4055297220446"
          },
          {
            "id": "679afb3f3d9bab0f83ff65af",
            "leftCorner": {
              "x": 42.922,
              "y": 3.8301,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.873,
              "y": 3.8312,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4055297220446"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b0",
            "leftCorner": {
              "x": 42.873,
              "y": 3.8312,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.823,
              "y": 3.8323,
              "z": 1.0439
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638530378"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b1",
            "leftCorner": {
              "x": 42.823,
              "y": 3.8323,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.786,
              "y": 3.8331,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638580779"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b2",
            "leftCorner": {
              "x": 42.786,
              "y": 3.8331,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.703,
              "y": 3.835,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638095716"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b3",
            "leftCorner": {
              "x": 42.703,
              "y": 3.835,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.62,
              "y": 3.8369,
              "z": 1.0439
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4001638093620"
          },
          {
            "id": "679afb3f3d9bab0f83ff65aa",
            "leftCorner": {
              "x": 42.62,
              "y": 3.8369,
              "z": 1.0439
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8389,
              "z": 1.0439
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4001638093620"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb7",
        "height": 1.2981,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65b4",
            "leftCorner": {
              "x": 43.53,
              "y": 3.814,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 43.406,
              "y": 3.8168,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542571739"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b6",
            "leftCorner": {
              "x": 43.406,
              "y": 3.8168,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 43.323,
              "y": 3.8186,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542571333"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b7",
            "leftCorner": {
              "x": 43.323,
              "y": 3.8186,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 43.218,
              "y": 3.821,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542590631"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b8",
            "leftCorner": {
              "x": 43.218,
              "y": 3.821,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 43.095,
              "y": 3.8238,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542585996"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b9",
            "leftCorner": {
              "x": 43.095,
              "y": 3.8238,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 43.014,
              "y": 3.8256,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524196561"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ba",
            "leftCorner": {
              "x": 43.014,
              "y": 3.8256,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.957,
              "y": 3.8269,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524196561"
          },
          {
            "id": "679afb3f3d9bab0f83ff65bb",
            "leftCorner": {
              "x": 42.957,
              "y": 3.8269,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.907,
              "y": 3.8281,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524189983"
          },
          {
            "id": "679afb3f3d9bab0f83ff65bc",
            "leftCorner": {
              "x": 42.907,
              "y": 3.8281,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.86,
              "y": 3.8291,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524189983"
          },
          {
            "id": "679afb3f3d9bab0f83ff65bd",
            "leftCorner": {
              "x": 42.86,
              "y": 3.8291,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.816,
              "y": 3.8301,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524189921"
          },
          {
            "id": "679afb3f3d9bab0f83ff65be",
            "leftCorner": {
              "x": 42.816,
              "y": 3.8301,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.753,
              "y": 3.8315,
              "z": 1.2981
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542020053"
          },
          {
            "id": "679afb3f3d9bab0f83ff65bf",
            "leftCorner": {
              "x": 42.753,
              "y": 3.8315,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.677,
              "y": 3.8333,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542020060"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c0",
            "leftCorner": {
              "x": 42.677,
              "y": 3.8333,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.605,
              "y": 3.8349,
              "z": 1.2981
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542020060"
          },
          {
            "id": "679afb3f3d9bab0f83ff65b5",
            "leftCorner": {
              "x": 42.605,
              "y": 3.8349,
              "z": 1.2981
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8366,
              "z": 1.2981
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541550445"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adb9",
        "height": 1.5502,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65c1",
            "leftCorner": {
              "x": 43.53,
              "y": 3.8164,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.478,
              "y": 3.8176,
              "z": 1.5502
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447452792"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c3",
            "leftCorner": {
              "x": 43.478,
              "y": 3.8176,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.397,
              "y": 3.8194,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447452792"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c4",
            "leftCorner": {
              "x": 43.397,
              "y": 3.8194,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.329,
              "y": 3.821,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447452792"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c5",
            "leftCorner": {
              "x": 43.329,
              "y": 3.821,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.26,
              "y": 3.8225,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674880"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c6",
            "leftCorner": {
              "x": 43.26,
              "y": 3.8225,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.187,
              "y": 3.8242,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447452778"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c7",
            "leftCorner": {
              "x": 43.187,
              "y": 3.8242,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.116,
              "y": 3.8258,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447452778"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c8",
            "leftCorner": {
              "x": 43.116,
              "y": 3.8258,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.055,
              "y": 3.8272,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c9",
            "leftCorner": {
              "x": 43.055,
              "y": 3.8272,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 43.016,
              "y": 3.8281,
              "z": 1.5502
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796070606"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ca",
            "leftCorner": {
              "x": 43.016,
              "y": 3.8281,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.98,
              "y": 3.8289,
              "z": 1.5502
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796070606"
          },
          {
            "id": "679afb3f3d9bab0f83ff65cb",
            "leftCorner": {
              "x": 42.98,
              "y": 3.8289,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.92,
              "y": 3.8302,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070583"
          },
          {
            "id": "679afb3f3d9bab0f83ff65cc",
            "leftCorner": {
              "x": 42.92,
              "y": 3.8302,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.855,
              "y": 3.8317,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070583"
          },
          {
            "id": "679afb3f3d9bab0f83ff65cd",
            "leftCorner": {
              "x": 42.855,
              "y": 3.8317,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.792,
              "y": 3.8331,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796070620"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ce",
            "leftCorner": {
              "x": 42.792,
              "y": 3.8331,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.732,
              "y": 3.8345,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215892"
          },
          {
            "id": "679afb3f3d9bab0f83ff65cf",
            "leftCorner": {
              "x": 42.732,
              "y": 3.8345,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.671,
              "y": 3.8359,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215892"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d0",
            "leftCorner": {
              "x": 42.671,
              "y": 3.8359,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.605,
              "y": 3.8374,
              "z": 1.5502
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447215915"
          },
          {
            "id": "679afb3f3d9bab0f83ff65c2",
            "leftCorner": {
              "x": 42.605,
              "y": 3.8374,
              "z": 1.5502
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8391,
              "z": 1.5502
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447215915"
          }
        ]
      },
      {
        "id": "679aebdb1f3fd8b81ad3adb8",
        "height": 1.6809,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff658d",
            "leftCorner": {
              "x": 43.602,
              "y": 3.8235,
              "z": 1.6811
            },
            "rightCorner": {
              "x": 43.426,
              "y": 3.82,
              "z": 1.6811
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528071545"
          },
          {
            "id": "679afb3f3d9bab0f83ff658e",
            "leftCorner": {
              "x": 43.404,
              "y": 3.8144,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.334,
              "y": 3.816,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528071361"
          },
          {
            "id": "679afb3f3d9bab0f83ff658f",
            "leftCorner": {
              "x": 43.334,
              "y": 3.816,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.259,
              "y": 3.8177,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100426908"
          },
          {
            "id": "679afb3f3d9bab0f83ff6590",
            "leftCorner": {
              "x": 43.259,
              "y": 3.8177,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.196,
              "y": 3.8191,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089085041"
          },
          {
            "id": "679afb3f3d9bab0f83ff6591",
            "leftCorner": {
              "x": 43.196,
              "y": 3.8191,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.135,
              "y": 3.8205,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089085041"
          },
          {
            "id": "679afb3f3d9bab0f83ff6592",
            "leftCorner": {
              "x": 43.135,
              "y": 3.8205,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.076,
              "y": 3.8218,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655397"
          },
          {
            "id": "679afb3f3d9bab0f83ff6593",
            "leftCorner": {
              "x": 43.076,
              "y": 3.8218,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 43.003,
              "y": 3.8235,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4021457655397"
          },
          {
            "id": "679afb3f3d9bab0f83ff6594",
            "leftCorner": {
              "x": 43.003,
              "y": 3.8235,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.94,
              "y": 3.8249,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4262414871324"
          },
          {
            "id": "679afb3f3d9bab0f83ff6595",
            "leftCorner": {
              "x": 42.94,
              "y": 3.8249,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.883,
              "y": 3.8262,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260739996395"
          },
          {
            "id": "679afb3f3d9bab0f83ff6596",
            "leftCorner": {
              "x": 42.883,
              "y": 3.8262,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.818,
              "y": 3.8277,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260739996395"
          },
          {
            "id": "679afb3f3d9bab0f83ff6597",
            "leftCorner": {
              "x": 42.818,
              "y": 3.8277,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.766,
              "y": 3.8289,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528084460"
          },
          {
            "id": "679afb3f3d9bab0f83ff6598",
            "leftCorner": {
              "x": 42.766,
              "y": 3.8289,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.71,
              "y": 3.8301,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528084491"
          },
          {
            "id": "679afb3f3d9bab0f83ff6599",
            "leftCorner": {
              "x": 42.71,
              "y": 3.8301,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.649,
              "y": 3.8315,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528084408"
          },
          {
            "id": "679afb3f3d9bab0f83ff659a",
            "leftCorner": {
              "x": 42.649,
              "y": 3.8315,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.591,
              "y": 3.8328,
              "z": 1.6809
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4063528084408"
          },
          {
            "id": "679afb3f3d9bab0f83ff6573",
            "leftCorner": {
              "x": 42.591,
              "y": 3.8328,
              "z": 1.6809
            },
            "rightCorner": {
              "x": 42.53,
              "y": 3.8342,
              "z": 1.6809
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4063528084439"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 4,
      "hasStockCount": 74,
      "unknownStockCount": 24
    },
    "name": "QJ5N",
    "leftNeighborShelfId": "FGUG",
    "rightNeighborShelfId": "JCQ9"
  },
  {
    "id": "JCQ9",
    "x": 42.449,
    "y": 3.4671,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99982,
      "w": -0.01895
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adbb",
        "height": 0.16263,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65d1",
            "leftCorner": {
              "x": 42.446,
              "y": 3.5593,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.38,
              "y": 3.5568,
              "z": 0.16263
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542461030"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d3",
            "leftCorner": {
              "x": 42.38,
              "y": 3.5568,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.328,
              "y": 3.5549,
              "z": 0.16263
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542461030"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d4",
            "leftCorner": {
              "x": 42.328,
              "y": 3.5549,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.234,
              "y": 3.5513,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542617741"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d5",
            "leftCorner": {
              "x": 42.234,
              "y": 3.5513,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.148,
              "y": 3.548,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542462150"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d6",
            "leftCorner": {
              "x": 42.148,
              "y": 3.548,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.083,
              "y": 3.5456,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542567329"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d7",
            "leftCorner": {
              "x": 42.083,
              "y": 3.5456,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 42.022,
              "y": 3.5433,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812398"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d8",
            "leftCorner": {
              "x": 42.022,
              "y": 3.5433,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.953,
              "y": 3.5407,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812251"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d9",
            "leftCorner": {
              "x": 41.953,
              "y": 3.5407,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.905,
              "y": 3.5388,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813418"
          },
          {
            "id": "679afb3f3d9bab0f83ff65da",
            "leftCorner": {
              "x": 41.905,
              "y": 3.5388,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.852,
              "y": 3.5368,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff65db",
            "leftCorner": {
              "x": 41.852,
              "y": 3.5368,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.783,
              "y": 3.5342,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812374"
          },
          {
            "id": "679afb3f3d9bab0f83ff65dc",
            "leftCorner": {
              "x": 41.783,
              "y": 3.5342,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.726,
              "y": 3.5321,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813494"
          },
          {
            "id": "679afb3f3d9bab0f83ff65dd",
            "leftCorner": {
              "x": 41.726,
              "y": 3.5321,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.653,
              "y": 3.5293,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812510"
          },
          {
            "id": "679afb3f3d9bab0f83ff65de",
            "leftCorner": {
              "x": 41.653,
              "y": 3.5293,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.575,
              "y": 3.5263,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812312"
          },
          {
            "id": "679afb3f3d9bab0f83ff65df",
            "leftCorner": {
              "x": 41.575,
              "y": 3.5263,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.526,
              "y": 3.5245,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813456"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e0",
            "leftCorner": {
              "x": 41.526,
              "y": 3.5245,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.488,
              "y": 3.523,
              "z": 0.16263
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100813111"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e1",
            "leftCorner": {
              "x": 41.488,
              "y": 3.523,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.457,
              "y": 3.5218,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813111"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e2",
            "leftCorner": {
              "x": 41.457,
              "y": 3.5218,
              "z": 0.16263
            },
            "rightCorner": {
              "x": 41.391,
              "y": 3.5194,
              "z": 0.16263
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adbd",
        "height": 0.46596,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6660",
            "leftCorner": {
              "x": 42.45,
              "y": 3.4458,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 42.36,
              "y": 3.4424,
              "z": 0.46596
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6662",
            "leftCorner": {
              "x": 42.36,
              "y": 3.4424,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 42.275,
              "y": 3.4392,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6663",
            "leftCorner": {
              "x": 42.275,
              "y": 3.4392,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 42.182,
              "y": 3.4357,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6664",
            "leftCorner": {
              "x": 42.182,
              "y": 3.4357,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 42.091,
              "y": 3.4322,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461115"
          },
          {
            "id": "679afb3f3d9bab0f83ff6665",
            "leftCorner": {
              "x": 42.091,
              "y": 3.4322,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 42.04,
              "y": 3.4303,
              "z": 0.46596
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6666",
            "leftCorner": {
              "x": 42.04,
              "y": 3.4303,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.981,
              "y": 3.4281,
              "z": 0.46596
            },
            "stockLevel": "NO_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6667",
            "leftCorner": {
              "x": 41.981,
              "y": 3.4281,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.888,
              "y": 3.4245,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6668",
            "leftCorner": {
              "x": 41.888,
              "y": 3.4245,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.806,
              "y": 3.4214,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542462839"
          },
          {
            "id": "679afb3f3d9bab0f83ff6669",
            "leftCorner": {
              "x": 41.806,
              "y": 3.4214,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.716,
              "y": 3.418,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542462839"
          },
          {
            "id": "679afb3f3d9bab0f83ff666a",
            "leftCorner": {
              "x": 41.716,
              "y": 3.418,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.614,
              "y": 3.4141,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542512466"
          },
          {
            "id": "679afb3f3d9bab0f83ff666b",
            "leftCorner": {
              "x": 41.614,
              "y": 3.4141,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.522,
              "y": 3.4106,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542572026"
          },
          {
            "id": "679afb3f3d9bab0f83ff666c",
            "leftCorner": {
              "x": 41.522,
              "y": 3.4106,
              "z": 0.46596
            },
            "rightCorner": {
              "x": 41.399,
              "y": 3.406,
              "z": 0.46596
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542572156"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adbc",
        "height": 0.80321,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff661a",
            "leftCorner": {
              "x": 42.45,
              "y": 3.4447,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 42.362,
              "y": 3.4413,
              "z": 0.80321
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff661c",
            "leftCorner": {
              "x": 42.362,
              "y": 3.4413,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 42.265,
              "y": 3.4377,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff661d",
            "leftCorner": {
              "x": 42.265,
              "y": 3.4377,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 42.176,
              "y": 3.4343,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542509572"
          },
          {
            "id": "679afb3f3d9bab0f83ff661e",
            "leftCorner": {
              "x": 42.176,
              "y": 3.4343,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 42.085,
              "y": 3.4308,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461450"
          },
          {
            "id": "679afb3f3d9bab0f83ff661f",
            "leftCorner": {
              "x": 42.085,
              "y": 3.4308,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.983,
              "y": 3.427,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542617710"
          },
          {
            "id": "679afb3f3d9bab0f83ff6620",
            "leftCorner": {
              "x": 41.983,
              "y": 3.427,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.896,
              "y": 3.4237,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461658"
          },
          {
            "id": "679afb3f3d9bab0f83ff6621",
            "leftCorner": {
              "x": 41.896,
              "y": 3.4237,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.808,
              "y": 3.4203,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461658"
          },
          {
            "id": "679afb3f3d9bab0f83ff6622",
            "leftCorner": {
              "x": 41.808,
              "y": 3.4203,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.717,
              "y": 3.4169,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461313"
          },
          {
            "id": "679afb3f3d9bab0f83ff6623",
            "leftCorner": {
              "x": 41.717,
              "y": 3.4169,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.608,
              "y": 3.4128,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461856"
          },
          {
            "id": "679afb3f3d9bab0f83ff6624",
            "leftCorner": {
              "x": 41.608,
              "y": 3.4128,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.515,
              "y": 3.4092,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542461900"
          },
          {
            "id": "679afb3f3d9bab0f83ff6625",
            "leftCorner": {
              "x": 41.515,
              "y": 3.4092,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.441,
              "y": 3.4064,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adbf",
        "height": 1.0947,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66e8",
            "leftCorner": {
              "x": 42.45,
              "y": 3.4478,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 42.359,
              "y": 3.4444,
              "z": 1.0947
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e9",
            "leftCorner": {
              "x": 42.359,
              "y": 3.4444,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 42.265,
              "y": 3.4408,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ea",
            "leftCorner": {
              "x": 42.265,
              "y": 3.4408,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 42.179,
              "y": 3.4376,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66eb",
            "leftCorner": {
              "x": 42.179,
              "y": 3.4376,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 42.071,
              "y": 3.4335,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ec",
            "leftCorner": {
              "x": 42.071,
              "y": 3.4335,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.959,
              "y": 3.4292,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ed",
            "leftCorner": {
              "x": 41.959,
              "y": 3.4292,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.859,
              "y": 3.4254,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ee",
            "leftCorner": {
              "x": 41.859,
              "y": 3.4254,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.824,
              "y": 3.4241,
              "z": 1.0947
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ef",
            "leftCorner": {
              "x": 41.824,
              "y": 3.4241,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.748,
              "y": 3.4212,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f0",
            "leftCorner": {
              "x": 41.748,
              "y": 3.4212,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.613,
              "y": 3.4161,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f1",
            "leftCorner": {
              "x": 41.613,
              "y": 3.4161,
              "z": 1.0947
            },
            "rightCorner": {
              "x": 41.448,
              "y": 3.4098,
              "z": 1.0947
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523749188"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adbe",
        "height": 1.393,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66a3",
            "leftCorner": {
              "x": 42.45,
              "y": 3.4441,
              "z": 1.393
            },
            "rightCorner": {
              "x": 42.372,
              "y": 3.4411,
              "z": 1.393
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a5",
            "leftCorner": {
              "x": 42.372,
              "y": 3.4411,
              "z": 1.393
            },
            "rightCorner": {
              "x": 42.28,
              "y": 3.4376,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a6",
            "leftCorner": {
              "x": 42.28,
              "y": 3.4376,
              "z": 1.393
            },
            "rightCorner": {
              "x": 42.207,
              "y": 3.4349,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a7",
            "leftCorner": {
              "x": 42.207,
              "y": 3.4349,
              "z": 1.393
            },
            "rightCorner": {
              "x": 42.135,
              "y": 3.4321,
              "z": 1.393
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a8",
            "leftCorner": {
              "x": 42.135,
              "y": 3.4321,
              "z": 1.393
            },
            "rightCorner": {
              "x": 42.062,
              "y": 3.4294,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a9",
            "leftCorner": {
              "x": 42.062,
              "y": 3.4294,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.991,
              "y": 3.4267,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542430289"
          },
          {
            "id": "679afb3f3d9bab0f83ff66aa",
            "leftCorner": {
              "x": 41.991,
              "y": 3.4267,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.921,
              "y": 3.424,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542430289"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ab",
            "leftCorner": {
              "x": 41.921,
              "y": 3.424,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.851,
              "y": 3.4214,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542040129"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ac",
            "leftCorner": {
              "x": 41.851,
              "y": 3.4214,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.788,
              "y": 3.419,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542039994"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ad",
            "leftCorner": {
              "x": 41.788,
              "y": 3.419,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.706,
              "y": 3.4159,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542040037"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ae",
            "leftCorner": {
              "x": 41.706,
              "y": 3.4159,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.634,
              "y": 3.4132,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542039970"
          },
          {
            "id": "679afb3f3d9bab0f83ff66af",
            "leftCorner": {
              "x": 41.634,
              "y": 3.4132,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.561,
              "y": 3.4104,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138660"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b0",
            "leftCorner": {
              "x": 41.561,
              "y": 3.4104,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.486,
              "y": 3.4075,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138660"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b1",
            "leftCorner": {
              "x": 41.486,
              "y": 3.4075,
              "z": 1.393
            },
            "rightCorner": {
              "x": 41.407,
              "y": 3.4045,
              "z": 1.393
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524173562"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc0",
        "height": 1.689,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6727",
            "leftCorner": {
              "x": 42.45,
              "y": 3.45,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.363,
              "y": 3.4467,
              "z": 1.689
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6728",
            "leftCorner": {
              "x": 42.363,
              "y": 3.4467,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.276,
              "y": 3.4434,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6729",
            "leftCorner": {
              "x": 42.276,
              "y": 3.4434,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.215,
              "y": 3.4411,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672a",
            "leftCorner": {
              "x": 42.215,
              "y": 3.4411,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.14,
              "y": 3.4383,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672b",
            "leftCorner": {
              "x": 42.14,
              "y": 3.4383,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.078,
              "y": 3.4359,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672c",
            "leftCorner": {
              "x": 42.078,
              "y": 3.4359,
              "z": 1.689
            },
            "rightCorner": {
              "x": 42.017,
              "y": 3.4336,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672d",
            "leftCorner": {
              "x": 42.017,
              "y": 3.4336,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.955,
              "y": 3.4312,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672e",
            "leftCorner": {
              "x": 41.955,
              "y": 3.4312,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.896,
              "y": 3.429,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff672f",
            "leftCorner": {
              "x": 41.896,
              "y": 3.429,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.823,
              "y": 3.4262,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6730",
            "leftCorner": {
              "x": 41.823,
              "y": 3.4262,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.763,
              "y": 3.424,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6731",
            "leftCorner": {
              "x": 41.763,
              "y": 3.424,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.693,
              "y": 3.4213,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6732",
            "leftCorner": {
              "x": 41.693,
              "y": 3.4213,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.617,
              "y": 3.4184,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137380"
          },
          {
            "id": "679afb3f3d9bab0f83ff6733",
            "leftCorner": {
              "x": 41.617,
              "y": 3.4184,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.542,
              "y": 3.4156,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137380"
          },
          {
            "id": "679afb3f3d9bab0f83ff6734",
            "leftCorner": {
              "x": 41.542,
              "y": 3.4156,
              "z": 1.689
            },
            "rightCorner": {
              "x": 41.464,
              "y": 3.4126,
              "z": 1.689
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137380"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 66,
      "unknownStockCount": 10
    },
    "name": "JCQ9",
    "rightNeighborShelfId": "U3I0"
  },
  {
    "id": "U3I0",
    "x": 41.445,
    "y": 3.4297,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": 0.0039869
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adc5",
        "height": 0.16333,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65e3",
            "leftCorner": {
              "x": 41.39,
              "y": 3.5327,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 41.29,
              "y": 3.5335,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812350"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e4",
            "leftCorner": {
              "x": 41.29,
              "y": 3.5335,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 41.226,
              "y": 3.534,
              "z": 0.16333
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100813395"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e5",
            "leftCorner": {
              "x": 41.226,
              "y": 3.534,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 41.149,
              "y": 3.5346,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812435"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e6",
            "leftCorner": {
              "x": 41.149,
              "y": 3.5346,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 41.079,
              "y": 3.5352,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812435"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e7",
            "leftCorner": {
              "x": 41.079,
              "y": 3.5352,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 41.004,
              "y": 3.5358,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812275"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e8",
            "leftCorner": {
              "x": 41.004,
              "y": 3.5358,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.958,
              "y": 3.5362,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813470"
          },
          {
            "id": "679afb3f3d9bab0f83ff65e9",
            "leftCorner": {
              "x": 40.958,
              "y": 3.5362,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.907,
              "y": 3.5366,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814095"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ea",
            "leftCorner": {
              "x": 40.907,
              "y": 3.5366,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.857,
              "y": 3.537,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813890"
          },
          {
            "id": "679afb3f3d9bab0f83ff65eb",
            "leftCorner": {
              "x": 40.857,
              "y": 3.537,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.792,
              "y": 3.5375,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813135"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ec",
            "leftCorner": {
              "x": 40.792,
              "y": 3.5375,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.726,
              "y": 3.538,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813135"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ed",
            "leftCorner": {
              "x": 40.726,
              "y": 3.538,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.648,
              "y": 3.5386,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813098"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ee",
            "leftCorner": {
              "x": 40.648,
              "y": 3.5386,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.571,
              "y": 3.5392,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100812336"
          },
          {
            "id": "679afb3f3d9bab0f83ff65ef",
            "leftCorner": {
              "x": 40.571,
              "y": 3.5392,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.488,
              "y": 3.5399,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813357"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc6",
        "height": 0.46655,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff666d",
            "leftCorner": {
              "x": 41.392,
              "y": 3.4193,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 41.267,
              "y": 3.4203,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff666e",
            "leftCorner": {
              "x": 41.267,
              "y": 3.4203,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 41.185,
              "y": 3.421,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff666f",
            "leftCorner": {
              "x": 41.185,
              "y": 3.421,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 41.138,
              "y": 3.4213,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813814"
          },
          {
            "id": "679afb3f3d9bab0f83ff6670",
            "leftCorner": {
              "x": 41.138,
              "y": 3.4213,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 41.093,
              "y": 3.4217,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813999"
          },
          {
            "id": "679afb3f3d9bab0f83ff6671",
            "leftCorner": {
              "x": 41.093,
              "y": 3.4217,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 41.043,
              "y": 3.4221,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813951"
          },
          {
            "id": "679afb3f3d9bab0f83ff6672",
            "leftCorner": {
              "x": 41.043,
              "y": 3.4221,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.995,
              "y": 3.4225,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813791"
          },
          {
            "id": "679afb3f3d9bab0f83ff6673",
            "leftCorner": {
              "x": 40.995,
              "y": 3.4225,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.958,
              "y": 3.4228,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814118"
          },
          {
            "id": "679afb3f3d9bab0f83ff6674",
            "leftCorner": {
              "x": 40.958,
              "y": 3.4228,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.911,
              "y": 3.4231,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816747"
          },
          {
            "id": "679afb3f3d9bab0f83ff6675",
            "leftCorner": {
              "x": 40.911,
              "y": 3.4231,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.861,
              "y": 3.4235,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813319"
          },
          {
            "id": "679afb3f3d9bab0f83ff6676",
            "leftCorner": {
              "x": 40.861,
              "y": 3.4235,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.765,
              "y": 3.4243,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813517"
          },
          {
            "id": "679afb3f3d9bab0f83ff6677",
            "leftCorner": {
              "x": 40.765,
              "y": 3.4243,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.669,
              "y": 3.4251,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100813913"
          },
          {
            "id": "679afb3f3d9bab0f83ff6678",
            "leftCorner": {
              "x": 40.669,
              "y": 3.4251,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.536,
              "y": 3.4261,
              "z": 0.46655
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814019"
          },
          {
            "id": "679afb3f3d9bab0f83ff6679",
            "leftCorner": {
              "x": 40.536,
              "y": 3.4261,
              "z": 0.46655
            },
            "rightCorner": {
              "x": 40.444,
              "y": 3.4269,
              "z": 0.46655
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100814071"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc1",
        "height": 0.80062,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6626",
            "leftCorner": {
              "x": 41.441,
              "y": 3.4064,
              "z": 0.80321
            },
            "rightCorner": {
              "x": 41.363,
              "y": 3.4035,
              "z": 0.80321
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524139698"
          },
          {
            "id": "679afb3f3d9bab0f83ff6627",
            "leftCorner": {
              "x": 41.356,
              "y": 3.4166,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 41.289,
              "y": 3.4171,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524139636"
          },
          {
            "id": "679afb3f3d9bab0f83ff6628",
            "leftCorner": {
              "x": 41.289,
              "y": 3.4171,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 41.228,
              "y": 3.4176,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524142995"
          },
          {
            "id": "679afb3f3d9bab0f83ff6629",
            "leftCorner": {
              "x": 41.228,
              "y": 3.4176,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 41.153,
              "y": 3.4182,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138110"
          },
          {
            "id": "679afb3f3d9bab0f83ff662a",
            "leftCorner": {
              "x": 41.153,
              "y": 3.4182,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 41.082,
              "y": 3.4188,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138110"
          },
          {
            "id": "679afb3f3d9bab0f83ff662b",
            "leftCorner": {
              "x": 41.082,
              "y": 3.4188,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 41.008,
              "y": 3.4193,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138011"
          },
          {
            "id": "679afb3f3d9bab0f83ff662c",
            "leftCorner": {
              "x": 41.008,
              "y": 3.4193,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.939,
              "y": 3.4199,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524141936"
          },
          {
            "id": "679afb3f3d9bab0f83ff662d",
            "leftCorner": {
              "x": 40.939,
              "y": 3.4199,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.869,
              "y": 3.4205,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138776"
          },
          {
            "id": "679afb3f3d9bab0f83ff662e",
            "leftCorner": {
              "x": 40.869,
              "y": 3.4205,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.795,
              "y": 3.421,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138776"
          },
          {
            "id": "679afb3f3d9bab0f83ff662f",
            "leftCorner": {
              "x": 40.795,
              "y": 3.421,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.732,
              "y": 3.4215,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524138400"
          },
          {
            "id": "679afb3f3d9bab0f83ff6630",
            "leftCorner": {
              "x": 40.732,
              "y": 3.4215,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.657,
              "y": 3.4221,
              "z": 0.80062
            },
            "stockLevel": "NO_STOCK",
            "gtin": "3600524141820"
          },
          {
            "id": "679afb3f3d9bab0f83ff6631",
            "leftCorner": {
              "x": 40.657,
              "y": 3.4221,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.592,
              "y": 3.4227,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524139155"
          },
          {
            "id": "679afb3f3d9bab0f83ff6632",
            "leftCorner": {
              "x": 40.592,
              "y": 3.4227,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.511,
              "y": 3.4233,
              "z": 0.80062
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524160517"
          },
          {
            "id": "679afb3f3d9bab0f83ff6633",
            "leftCorner": {
              "x": 40.511,
              "y": 3.4233,
              "z": 0.80062
            },
            "rightCorner": {
              "x": 40.444,
              "y": 3.4238,
              "z": 0.80062
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524142735"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc2",
        "height": 1.0937,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66f2",
            "leftCorner": {
              "x": 41.444,
              "y": 3.4159,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.283,
              "y": 3.4098,
              "z": 1.0937
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523734955"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f3",
            "leftCorner": {
              "x": 41.283,
              "y": 3.4172,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.224,
              "y": 3.4177,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524034160"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f4",
            "leftCorner": {
              "x": 41.224,
              "y": 3.4177,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.178,
              "y": 3.418,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524030865"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f5",
            "leftCorner": {
              "x": 41.178,
              "y": 3.418,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.126,
              "y": 3.4184,
              "z": 1.0937
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524105563"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f6",
            "leftCorner": {
              "x": 41.126,
              "y": 3.4184,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.072,
              "y": 3.4189,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522191087"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f7",
            "leftCorner": {
              "x": 41.072,
              "y": 3.4189,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 41.009,
              "y": 3.4194,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4037900021503"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f8",
            "leftCorner": {
              "x": 41.009,
              "y": 3.4194,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.915,
              "y": 3.4201,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524078584"
          },
          {
            "id": "679afb3f3d9bab0f83ff66f9",
            "leftCorner": {
              "x": 40.915,
              "y": 3.4201,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.816,
              "y": 3.4209,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524021948"
          },
          {
            "id": "679afb3f3d9bab0f83ff66fa",
            "leftCorner": {
              "x": 40.816,
              "y": 3.4209,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.716,
              "y": 3.4217,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523899869"
          },
          {
            "id": "679afb3f3d9bab0f83ff66fb",
            "leftCorner": {
              "x": 40.716,
              "y": 3.4217,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.622,
              "y": 3.4225,
              "z": 1.0937
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524035860"
          },
          {
            "id": "679afb3f3d9bab0f83ff66fc",
            "leftCorner": {
              "x": 40.622,
              "y": 3.4225,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.511,
              "y": 3.4233,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523965045"
          },
          {
            "id": "679afb3f3d9bab0f83ff66fd",
            "leftCorner": {
              "x": 40.511,
              "y": 3.4233,
              "z": 1.0937
            },
            "rightCorner": {
              "x": 40.413,
              "y": 3.4241,
              "z": 1.0937
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523965014"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc3",
        "height": 1.3883,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66b2",
            "leftCorner": {
              "x": 41.401,
              "y": 3.4154,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 41.327,
              "y": 3.416,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524139032"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b3",
            "leftCorner": {
              "x": 41.327,
              "y": 3.416,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 41.254,
              "y": 3.4166,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524142469"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b4",
            "leftCorner": {
              "x": 41.254,
              "y": 3.4166,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 41.186,
              "y": 3.4171,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524142469"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b5",
            "leftCorner": {
              "x": 41.186,
              "y": 3.4171,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 41.128,
              "y": 3.4176,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523709946"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b6",
            "leftCorner": {
              "x": 41.128,
              "y": 3.4176,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 41.054,
              "y": 3.4181,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137731"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b7",
            "leftCorner": {
              "x": 41.054,
              "y": 3.4181,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.978,
              "y": 3.4188,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137731"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b8",
            "leftCorner": {
              "x": 40.978,
              "y": 3.4188,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.889,
              "y": 3.4195,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524173098"
          },
          {
            "id": "679afb3f3d9bab0f83ff66b9",
            "leftCorner": {
              "x": 40.889,
              "y": 3.4195,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.83,
              "y": 3.4199,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137618"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ba",
            "leftCorner": {
              "x": 40.83,
              "y": 3.4199,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.755,
              "y": 3.4205,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524142124"
          },
          {
            "id": "679afb3f3d9bab0f83ff66bb",
            "leftCorner": {
              "x": 40.755,
              "y": 3.4205,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.681,
              "y": 3.4211,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524137854"
          },
          {
            "id": "679afb3f3d9bab0f83ff66bc",
            "leftCorner": {
              "x": 40.681,
              "y": 3.4211,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.619,
              "y": 3.4216,
              "z": 1.3883
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524139414"
          },
          {
            "id": "679afb3f3d9bab0f83ff66bd",
            "leftCorner": {
              "x": 40.619,
              "y": 3.4216,
              "z": 1.3883
            },
            "rightCorner": {
              "x": 40.566,
              "y": 3.422,
              "z": 1.3883
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524139704"
          },
          {
            "id": "679afb3f3d9bab0f83ff66be",
            "leftCorner": {
              "x": 40.557,
              "y": 3.4344,
              "z": 1.387
            },
            "rightCorner": {
              "x": 40.49,
              "y": 3.4349,
              "z": 1.387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524075453"
          },
          {
            "id": "679afb3f3d9bab0f83ff66bf",
            "leftCorner": {
              "x": 40.49,
              "y": 3.4326,
              "z": 1.387
            },
            "rightCorner": {
              "x": 40.426,
              "y": 3.4331,
              "z": 1.387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841212203"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc4",
        "height": 1.6837,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6735",
            "leftCorner": {
              "x": 41.444,
              "y": 3.4144,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.33,
              "y": 3.4101,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524173579"
          },
          {
            "id": "679afb3f3d9bab0f83ff6736",
            "leftCorner": {
              "x": 41.33,
              "y": 3.4154,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.24,
              "y": 3.4161,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524144104"
          },
          {
            "id": "679afb3f3d9bab0f83ff6737",
            "leftCorner": {
              "x": 41.24,
              "y": 3.4161,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.212,
              "y": 3.4163,
              "z": 1.6837
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524142384"
          },
          {
            "id": "679afb3f3d9bab0f83ff6738",
            "leftCorner": {
              "x": 41.212,
              "y": 3.4163,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.163,
              "y": 3.4167,
              "z": 1.6837
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6739",
            "leftCorner": {
              "x": 41.163,
              "y": 3.4167,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.095,
              "y": 3.4172,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524140045"
          },
          {
            "id": "679afb3f3d9bab0f83ff673a",
            "leftCorner": {
              "x": 41.095,
              "y": 3.4172,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 41.033,
              "y": 3.4177,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524140045"
          },
          {
            "id": "679afb3f3d9bab0f83ff673b",
            "leftCorner": {
              "x": 41.033,
              "y": 3.4177,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.955,
              "y": 3.4184,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524142261"
          },
          {
            "id": "679afb3f3d9bab0f83ff673c",
            "leftCorner": {
              "x": 40.955,
              "y": 3.4184,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.912,
              "y": 3.4187,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524135553"
          },
          {
            "id": "679afb3f3d9bab0f83ff673d",
            "leftCorner": {
              "x": 40.912,
              "y": 3.4187,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.85,
              "y": 3.4192,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524128005"
          },
          {
            "id": "679afb3f3d9bab0f83ff673e",
            "leftCorner": {
              "x": 40.85,
              "y": 3.4192,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.808,
              "y": 3.4195,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524144036"
          },
          {
            "id": "679afb3f3d9bab0f83ff673f",
            "leftCorner": {
              "x": 40.808,
              "y": 3.4195,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.761,
              "y": 3.4199,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524135430"
          },
          {
            "id": "679afb3f3d9bab0f83ff6740",
            "leftCorner": {
              "x": 40.761,
              "y": 3.4199,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.707,
              "y": 3.4203,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524128500"
          },
          {
            "id": "679afb3f3d9bab0f83ff6741",
            "leftCorner": {
              "x": 40.707,
              "y": 3.4203,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.652,
              "y": 3.4208,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524074517"
          },
          {
            "id": "679afb3f3d9bab0f83ff6742",
            "leftCorner": {
              "x": 40.652,
              "y": 3.4208,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.613,
              "y": 3.4211,
              "z": 1.6837
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524074791"
          },
          {
            "id": "679afb3f3d9bab0f83ff6743",
            "leftCorner": {
              "x": 40.613,
              "y": 3.4211,
              "z": 1.6837
            },
            "rightCorner": {
              "x": 40.444,
              "y": 3.4224,
              "z": 1.6837
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524074654"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 68,
      "unknownStockCount": 11
    },
    "name": "U3I0",
    "leftNeighborShelfId": "JCQ9",
    "rightNeighborShelfId": "T8WX"
  },
  {
    "id": "T8WX",
    "x": 40.436,
    "y": 3.4384,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99991,
      "w": -0.0134
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adcc",
        "height": 0.16114,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65f0",
            "leftCorner": {
              "x": 40.488,
              "y": 3.5399,
              "z": 0.16333
            },
            "rightCorner": {
              "x": 40.374,
              "y": 3.5408,
              "z": 0.16333
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100747904"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f1",
            "leftCorner": {
              "x": 40.361,
              "y": 3.538,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 40.279,
              "y": 3.5358,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100747928"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f2",
            "leftCorner": {
              "x": 40.279,
              "y": 3.5358,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 40.227,
              "y": 3.5344,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100805024"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f3",
            "leftCorner": {
              "x": 40.227,
              "y": 3.5344,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 40.175,
              "y": 3.533,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815559"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f4",
            "leftCorner": {
              "x": 40.175,
              "y": 3.533,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 40.128,
              "y": 3.5317,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815511"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f5",
            "leftCorner": {
              "x": 40.128,
              "y": 3.5317,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 40.023,
              "y": 3.5289,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100717716"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f6",
            "leftCorner": {
              "x": 40.023,
              "y": 3.5289,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.994,
              "y": 3.5281,
              "z": 0.16114
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f7",
            "leftCorner": {
              "x": 39.994,
              "y": 3.5281,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.938,
              "y": 3.5266,
              "z": 0.16114
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100718317"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f8",
            "leftCorner": {
              "x": 39.938,
              "y": 3.5266,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.91,
              "y": 3.5259,
              "z": 0.16114
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff65f9",
            "leftCorner": {
              "x": 39.91,
              "y": 3.5259,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.816,
              "y": 3.5234,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718799"
          },
          {
            "id": "679afb3f3d9bab0f83ff65fa",
            "leftCorner": {
              "x": 39.816,
              "y": 3.5234,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.733,
              "y": 3.5211,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718195"
          },
          {
            "id": "679afb3f3d9bab0f83ff65fb",
            "leftCorner": {
              "x": 39.733,
              "y": 3.5211,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.679,
              "y": 3.5197,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100805048"
          },
          {
            "id": "679afb3f3d9bab0f83ff65fc",
            "leftCorner": {
              "x": 39.679,
              "y": 3.5197,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.635,
              "y": 3.5185,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815498"
          },
          {
            "id": "679afb3f3d9bab0f83ff65fd",
            "leftCorner": {
              "x": 39.635,
              "y": 3.5185,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.532,
              "y": 3.5157,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100719192"
          },
          {
            "id": "679afb3f3d9bab0f83ff65fe",
            "leftCorner": {
              "x": 39.532,
              "y": 3.5157,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.437,
              "y": 3.5132,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100719215"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adca",
        "height": 0.46303,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff667a",
            "leftCorner": {
              "x": 40.436,
              "y": 3.4327,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.4,
              "y": 3.433,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff667b",
            "leftCorner": {
              "x": 40.401,
              "y": 3.4317,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.328,
              "y": 3.4298,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573025025"
          },
          {
            "id": "679afb3f3d9bab0f83ff667c",
            "leftCorner": {
              "x": 40.328,
              "y": 3.4298,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.257,
              "y": 3.4279,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573025018"
          },
          {
            "id": "679afb3f3d9bab0f83ff667d",
            "leftCorner": {
              "x": 40.257,
              "y": 3.4279,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.184,
              "y": 3.4259,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4003573025001"
          },
          {
            "id": "679afb3f3d9bab0f83ff667e",
            "leftCorner": {
              "x": 40.184,
              "y": 3.4259,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.115,
              "y": 3.4241,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900910141"
          },
          {
            "id": "679afb3f3d9bab0f83ff667f",
            "leftCorner": {
              "x": 40.115,
              "y": 3.4241,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 40.047,
              "y": 3.4223,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917744"
          },
          {
            "id": "679afb3f3d9bab0f83ff6680",
            "leftCorner": {
              "x": 40.047,
              "y": 3.4223,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.982,
              "y": 3.4205,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917829"
          },
          {
            "id": "679afb3f3d9bab0f83ff6681",
            "leftCorner": {
              "x": 39.982,
              "y": 3.4205,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.952,
              "y": 3.4197,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6682",
            "leftCorner": {
              "x": 39.952,
              "y": 3.4197,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.906,
              "y": 3.4185,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900910066"
          },
          {
            "id": "679afb3f3d9bab0f83ff6683",
            "leftCorner": {
              "x": 39.906,
              "y": 3.4185,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.877,
              "y": 3.4177,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900910066"
          },
          {
            "id": "679afb3f3d9bab0f83ff6684",
            "leftCorner": {
              "x": 39.877,
              "y": 3.4177,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.827,
              "y": 3.4164,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6685",
            "leftCorner": {
              "x": 39.827,
              "y": 3.4164,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.797,
              "y": 3.4156,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6686",
            "leftCorner": {
              "x": 39.797,
              "y": 3.4156,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.732,
              "y": 3.4138,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917867"
          },
          {
            "id": "679afb3f3d9bab0f83ff6687",
            "leftCorner": {
              "x": 39.732,
              "y": 3.4138,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.67,
              "y": 3.4121,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917867"
          },
          {
            "id": "679afb3f3d9bab0f83ff6688",
            "leftCorner": {
              "x": 39.67,
              "y": 3.4121,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.596,
              "y": 3.4102,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917959"
          },
          {
            "id": "679afb3f3d9bab0f83ff6689",
            "leftCorner": {
              "x": 39.596,
              "y": 3.4102,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.533,
              "y": 3.4085,
              "z": 0.46303
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4005900917959"
          },
          {
            "id": "679afb3f3d9bab0f83ff668a",
            "leftCorner": {
              "x": 39.533,
              "y": 3.4085,
              "z": 0.46303
            },
            "rightCorner": {
              "x": 39.436,
              "y": 3.4059,
              "z": 0.46303
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4005900910301"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc8",
        "height": 0.79899,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6634",
            "leftCorner": {
              "x": 40.436,
              "y": 3.4306,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40.401,
              "y": 3.4309,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523682775"
          },
          {
            "id": "679afb3f3d9bab0f83ff6635",
            "leftCorner": {
              "x": 40.401,
              "y": 3.4296,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40.259,
              "y": 3.4258,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523900664"
          },
          {
            "id": "679afb3f3d9bab0f83ff6636",
            "leftCorner": {
              "x": 40.259,
              "y": 3.4258,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40.178,
              "y": 3.4237,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447234213"
          },
          {
            "id": "679afb3f3d9bab0f83ff6637",
            "leftCorner": {
              "x": 40.178,
              "y": 3.4237,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40.117,
              "y": 3.422,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814750"
          },
          {
            "id": "679afb3f3d9bab0f83ff6638",
            "leftCorner": {
              "x": 40.117,
              "y": 3.422,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40.066,
              "y": 3.4207,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815764"
          },
          {
            "id": "679afb3f3d9bab0f83ff6639",
            "leftCorner": {
              "x": 40.066,
              "y": 3.4207,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 40,
              "y": 3.4189,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260074804"
          },
          {
            "id": "679afb3f3d9bab0f83ff663a",
            "leftCorner": {
              "x": 40,
              "y": 3.4189,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.934,
              "y": 3.4171,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260074804"
          },
          {
            "id": "679afb3f3d9bab0f83ff663b",
            "leftCorner": {
              "x": 39.934,
              "y": 3.4171,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.906,
              "y": 3.4164,
              "z": 0.79899
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4104260074811"
          },
          {
            "id": "679afb3f3d9bab0f83ff663c",
            "leftCorner": {
              "x": 39.906,
              "y": 3.4164,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.872,
              "y": 3.4155,
              "z": 0.79899
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4104260074811"
          },
          {
            "id": "679afb3f3d9bab0f83ff663d",
            "leftCorner": {
              "x": 39.872,
              "y": 3.4155,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.845,
              "y": 3.4148,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260074866"
          },
          {
            "id": "679afb3f3d9bab0f83ff663e",
            "leftCorner": {
              "x": 39.845,
              "y": 3.4148,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.802,
              "y": 3.4136,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260074866"
          },
          {
            "id": "679afb3f3d9bab0f83ff663f",
            "leftCorner": {
              "x": 39.802,
              "y": 3.4136,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.726,
              "y": 3.4116,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282250"
          },
          {
            "id": "679afb3f3d9bab0f83ff6640",
            "leftCorner": {
              "x": 39.726,
              "y": 3.4116,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.677,
              "y": 3.4102,
              "z": 0.79899
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4072600282267"
          },
          {
            "id": "679afb3f3d9bab0f83ff6641",
            "leftCorner": {
              "x": 39.677,
              "y": 3.4102,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.514,
              "y": 3.4059,
              "z": 0.79899
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447806809"
          },
          {
            "id": "679afb3f3d9bab0f83ff6642",
            "leftCorner": {
              "x": 39.514,
              "y": 3.4059,
              "z": 0.79899
            },
            "rightCorner": {
              "x": 39.436,
              "y": 3.4038,
              "z": 0.79899
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447365603"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc9",
        "height": 1.0913,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66fe",
            "leftCorner": {
              "x": 40.405,
              "y": 3.4301,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 40.257,
              "y": 3.4262,
              "z": 1.0913
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523965038"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ff",
            "leftCorner": {
              "x": 40.257,
              "y": 3.4262,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 40.147,
              "y": 3.4232,
              "z": 1.0913
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841890012"
          },
          {
            "id": "679afb3f3d9bab0f83ff6700",
            "leftCorner": {
              "x": 40.147,
              "y": 3.4232,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 40.061,
              "y": 3.4209,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540497401"
          },
          {
            "id": "679afb3f3d9bab0f83ff6701",
            "leftCorner": {
              "x": 40.061,
              "y": 3.4209,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.984,
              "y": 3.4189,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216178402"
          },
          {
            "id": "679afb3f3d9bab0f83ff6702",
            "leftCorner": {
              "x": 39.984,
              "y": 3.4189,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.953,
              "y": 3.418,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216181556"
          },
          {
            "id": "679afb3f3d9bab0f83ff6703",
            "leftCorner": {
              "x": 39.953,
              "y": 3.418,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.895,
              "y": 3.4165,
              "z": 1.0913
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5410076529674"
          },
          {
            "id": "679afb3f3d9bab0f83ff6704",
            "leftCorner": {
              "x": 39.895,
              "y": 3.4165,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.868,
              "y": 3.4158,
              "z": 1.0913
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6705",
            "leftCorner": {
              "x": 39.868,
              "y": 3.4158,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.8,
              "y": 3.4139,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090369437"
          },
          {
            "id": "679afb3f3d9bab0f83ff6706",
            "leftCorner": {
              "x": 39.8,
              "y": 3.4139,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.703,
              "y": 3.4113,
              "z": 1.0913
            },
            "stockLevel": "NO_STOCK",
            "gtin": "8700216173261"
          },
          {
            "id": "679afb3f3d9bab0f83ff6707",
            "leftCorner": {
              "x": 39.703,
              "y": 3.4113,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.611,
              "y": 3.4089,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216173476"
          },
          {
            "id": "679afb3f3d9bab0f83ff6708",
            "leftCorner": {
              "x": 39.611,
              "y": 3.4089,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.519,
              "y": 3.4064,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216173315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6709",
            "leftCorner": {
              "x": 39.519,
              "y": 3.4064,
              "z": 1.0913
            },
            "rightCorner": {
              "x": 39.422,
              "y": 3.4038,
              "z": 1.0913
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4084500390089"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adc7",
        "height": 1.387,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66c0",
            "leftCorner": {
              "x": 40.426,
              "y": 3.4309,
              "z": 1.387
            },
            "rightCorner": {
              "x": 40.346,
              "y": 3.4315,
              "z": 1.387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841212081"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c1",
            "leftCorner": {
              "x": 40.346,
              "y": 3.4287,
              "z": 1.387
            },
            "rightCorner": {
              "x": 40.132,
              "y": 3.423,
              "z": 1.387
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216343909"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c2",
            "leftCorner": {
              "x": 40.132,
              "y": 3.423,
              "z": 1.387
            },
            "rightCorner": {
              "x": 40.079,
              "y": 3.4216,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216343992"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c3",
            "leftCorner": {
              "x": 40.079,
              "y": 3.4216,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.996,
              "y": 3.4194,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170345"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c4",
            "leftCorner": {
              "x": 39.996,
              "y": 3.4194,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.927,
              "y": 3.4175,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170321"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c5",
            "leftCorner": {
              "x": 39.927,
              "y": 3.4175,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.89,
              "y": 3.4165,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170321"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c6",
            "leftCorner": {
              "x": 39.89,
              "y": 3.4165,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.855,
              "y": 3.4156,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216151443"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c7",
            "leftCorner": {
              "x": 39.855,
              "y": 3.4156,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.808,
              "y": 3.4143,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170390"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c8",
            "leftCorner": {
              "x": 39.808,
              "y": 3.4143,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.748,
              "y": 3.4127,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216151382"
          },
          {
            "id": "679afb3f3d9bab0f83ff66c9",
            "leftCorner": {
              "x": 39.748,
              "y": 3.4127,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.692,
              "y": 3.4112,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170239"
          },
          {
            "id": "679afb3f3d9bab0f83ff66ca",
            "leftCorner": {
              "x": 39.692,
              "y": 3.4112,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.647,
              "y": 3.41,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216151344"
          },
          {
            "id": "679afb3f3d9bab0f83ff66cb",
            "leftCorner": {
              "x": 39.647,
              "y": 3.41,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.56,
              "y": 3.4077,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216170291"
          },
          {
            "id": "679afb3f3d9bab0f83ff66cc",
            "leftCorner": {
              "x": 39.56,
              "y": 3.4077,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.516,
              "y": 3.4065,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216151504"
          },
          {
            "id": "679afb3f3d9bab0f83ff66cd",
            "leftCorner": {
              "x": 39.516,
              "y": 3.4065,
              "z": 1.387
            },
            "rightCorner": {
              "x": 39.438,
              "y": 3.4044,
              "z": 1.387
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540849385"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adcb",
        "height": 1.6807,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6744",
            "leftCorner": {
              "x": 40.436,
              "y": 3.4329,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 40.362,
              "y": 3.4335,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524075576"
          },
          {
            "id": "679afb3f3d9bab0f83ff6745",
            "leftCorner": {
              "x": 40.362,
              "y": 3.431,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 40.154,
              "y": 3.4254,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841212388"
          },
          {
            "id": "679afb3f3d9bab0f83ff6746",
            "leftCorner": {
              "x": 40.154,
              "y": 3.4254,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 40.067,
              "y": 3.423,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841212388"
          },
          {
            "id": "679afb3f3d9bab0f83ff6747",
            "leftCorner": {
              "x": 40.067,
              "y": 3.423,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 40.019,
              "y": 3.4217,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540513972"
          },
          {
            "id": "679afb3f3d9bab0f83ff6748",
            "leftCorner": {
              "x": 40.019,
              "y": 3.4217,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.993,
              "y": 3.4211,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6749",
            "leftCorner": {
              "x": 39.993,
              "y": 3.4211,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.941,
              "y": 3.4197,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540513972"
          },
          {
            "id": "679afb3f3d9bab0f83ff674a",
            "leftCorner": {
              "x": 39.941,
              "y": 3.4197,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.873,
              "y": 3.4178,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841212265"
          },
          {
            "id": "679afb3f3d9bab0f83ff674b",
            "leftCorner": {
              "x": 39.873,
              "y": 3.4178,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.829,
              "y": 3.4167,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841212296"
          },
          {
            "id": "679afb3f3d9bab0f83ff674c",
            "leftCorner": {
              "x": 39.829,
              "y": 3.4167,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.803,
              "y": 3.416,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841212296"
          },
          {
            "id": "679afb3f3d9bab0f83ff674d",
            "leftCorner": {
              "x": 39.803,
              "y": 3.416,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.751,
              "y": 3.4146,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841216065"
          },
          {
            "id": "679afb3f3d9bab0f83ff674e",
            "leftCorner": {
              "x": 39.751,
              "y": 3.4146,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.679,
              "y": 3.4126,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540206843"
          },
          {
            "id": "679afb3f3d9bab0f83ff674f",
            "leftCorner": {
              "x": 39.679,
              "y": 3.4126,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.609,
              "y": 3.4107,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540206843"
          },
          {
            "id": "679afb3f3d9bab0f83ff6750",
            "leftCorner": {
              "x": 39.609,
              "y": 3.4107,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.575,
              "y": 3.4099,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540514009"
          },
          {
            "id": "679afb3f3d9bab0f83ff6751",
            "leftCorner": {
              "x": 39.575,
              "y": 3.4099,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.535,
              "y": 3.4088,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8006540514009"
          },
          {
            "id": "679afb3f3d9bab0f83ff6752",
            "leftCorner": {
              "x": 39.535,
              "y": 3.4088,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.509,
              "y": 3.4081,
              "z": 1.6807
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6753",
            "leftCorner": {
              "x": 39.509,
              "y": 3.4081,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.453,
              "y": 3.4066,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841212173"
          },
          {
            "id": "679afb3f3d9bab0f83ff6754",
            "leftCorner": {
              "x": 39.453,
              "y": 3.4066,
              "z": 1.6807
            },
            "rightCorner": {
              "x": 39.419,
              "y": 3.4057,
              "z": 1.6807
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001841216188"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 62,
      "unknownStockCount": 27
    },
    "name": "T8WX",
    "leftNeighborShelfId": "U3I0",
    "rightNeighborShelfId": "B2HX"
  },
  {
    "id": "B2HX",
    "x": 39.412,
    "y": 3.4163,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": 0.0039319
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3add1",
        "height": 0.16169,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff65ff",
            "leftCorner": {
              "x": 39.437,
              "y": 3.5132,
              "z": 0.16114
            },
            "rightCorner": {
              "x": 39.369,
              "y": 3.5114,
              "z": 0.16114
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718232"
          },
          {
            "id": "679afb3f3d9bab0f83ff6600",
            "leftCorner": {
              "x": 39.349,
              "y": 3.5196,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 39.254,
              "y": 3.5204,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100864991"
          },
          {
            "id": "679afb3f3d9bab0f83ff6601",
            "leftCorner": {
              "x": 39.254,
              "y": 3.5204,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 39.151,
              "y": 3.5212,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718256"
          },
          {
            "id": "679afb3f3d9bab0f83ff6602",
            "leftCorner": {
              "x": 39.151,
              "y": 3.5212,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 39.058,
              "y": 3.5219,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718157"
          },
          {
            "id": "679afb3f3d9bab0f83ff6603",
            "leftCorner": {
              "x": 39.058,
              "y": 3.5219,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.97,
              "y": 3.5226,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100718072"
          },
          {
            "id": "679afb3f3d9bab0f83ff6604",
            "leftCorner": {
              "x": 38.97,
              "y": 3.5226,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.885,
              "y": 3.5233,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237429"
          },
          {
            "id": "679afb3f3d9bab0f83ff6605",
            "leftCorner": {
              "x": 38.885,
              "y": 3.5233,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.805,
              "y": 3.5239,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237429"
          },
          {
            "id": "679afb3f3d9bab0f83ff6606",
            "leftCorner": {
              "x": 38.805,
              "y": 3.5239,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.735,
              "y": 3.5245,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468052"
          },
          {
            "id": "679afb3f3d9bab0f83ff6607",
            "leftCorner": {
              "x": 38.735,
              "y": 3.5245,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.657,
              "y": 3.5251,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468052"
          },
          {
            "id": "679afb3f3d9bab0f83ff6608",
            "leftCorner": {
              "x": 38.657,
              "y": 3.5251,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.583,
              "y": 3.5257,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468076"
          },
          {
            "id": "679afb3f3d9bab0f83ff6609",
            "leftCorner": {
              "x": 38.583,
              "y": 3.5257,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.517,
              "y": 3.5262,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447719499"
          },
          {
            "id": "679afb3f3d9bab0f83ff660a",
            "leftCorner": {
              "x": 38.517,
              "y": 3.5262,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.443,
              "y": 3.5268,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468014"
          },
          {
            "id": "679afb3f3d9bab0f83ff660b",
            "leftCorner": {
              "x": 38.443,
              "y": 3.5268,
              "z": 0.16169
            },
            "rightCorner": {
              "x": 38.339,
              "y": 3.5276,
              "z": 0.16169
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468014"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adce",
        "height": 0.46407,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff668b",
            "leftCorner": {
              "x": 39.412,
              "y": 3.4117,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 39.355,
              "y": 3.4102,
              "z": 0.46407
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447237467"
          },
          {
            "id": "679afb3f3d9bab0f83ff668c",
            "leftCorner": {
              "x": 39.355,
              "y": 3.4122,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 39.16,
              "y": 3.4137,
              "z": 0.46407
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447240740"
          },
          {
            "id": "679afb3f3d9bab0f83ff668d",
            "leftCorner": {
              "x": 39.16,
              "y": 3.4137,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 39.069,
              "y": 3.4144,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447665598"
          },
          {
            "id": "679afb3f3d9bab0f83ff668e",
            "leftCorner": {
              "x": 39.069,
              "y": 3.4144,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.979,
              "y": 3.4151,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241068"
          },
          {
            "id": "679afb3f3d9bab0f83ff668f",
            "leftCorner": {
              "x": 38.979,
              "y": 3.4151,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.893,
              "y": 3.4158,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240924"
          },
          {
            "id": "679afb3f3d9bab0f83ff6690",
            "leftCorner": {
              "x": 38.893,
              "y": 3.4158,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.826,
              "y": 3.4163,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447154832"
          },
          {
            "id": "679afb3f3d9bab0f83ff6691",
            "leftCorner": {
              "x": 38.826,
              "y": 3.4163,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.772,
              "y": 3.4168,
              "z": 0.46407
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447237481"
          },
          {
            "id": "679afb3f3d9bab0f83ff6692",
            "leftCorner": {
              "x": 38.772,
              "y": 3.4168,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.716,
              "y": 3.4172,
              "z": 0.46407
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447237481"
          },
          {
            "id": "679afb3f3d9bab0f83ff6693",
            "leftCorner": {
              "x": 38.716,
              "y": 3.4172,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.67,
              "y": 3.4176,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6694",
            "leftCorner": {
              "x": 38.67,
              "y": 3.4176,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.623,
              "y": 3.4179,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6695",
            "leftCorner": {
              "x": 38.623,
              "y": 3.4179,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.556,
              "y": 3.4185,
              "z": 0.46407
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447237016"
          },
          {
            "id": "679afb3f3d9bab0f83ff6696",
            "leftCorner": {
              "x": 38.556,
              "y": 3.4185,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.457,
              "y": 3.4192,
              "z": 0.46407
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447237443"
          },
          {
            "id": "679afb3f3d9bab0f83ff6697",
            "leftCorner": {
              "x": 38.457,
              "y": 3.4192,
              "z": 0.46407
            },
            "rightCorner": {
              "x": 38.362,
              "y": 3.42,
              "z": 0.46407
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447467871"
          },
          {
            "id": "679afb3f3d9bab0f83ff6698",
            "leftCorner": {
              "x": 38.392,
              "y": 3.4098,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 38.33,
              "y": 3.4123,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467871"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add2",
        "height": 0.79818,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6643",
            "leftCorner": {
              "x": 39.412,
              "y": 3.4131,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 39.328,
              "y": 3.4108,
              "z": 0.79818
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447591804"
          },
          {
            "id": "679afb3f3d9bab0f83ff6644",
            "leftCorner": {
              "x": 39.328,
              "y": 3.4138,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 39.201,
              "y": 3.4148,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447591828"
          },
          {
            "id": "679afb3f3d9bab0f83ff6645",
            "leftCorner": {
              "x": 39.201,
              "y": 3.4148,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 39.078,
              "y": 3.4157,
              "z": 0.79818
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447785449"
          },
          {
            "id": "679afb3f3d9bab0f83ff6646",
            "leftCorner": {
              "x": 39.078,
              "y": 3.4157,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 39,
              "y": 3.4163,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467536"
          },
          {
            "id": "679afb3f3d9bab0f83ff6647",
            "leftCorner": {
              "x": 39,
              "y": 3.4163,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.915,
              "y": 3.417,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447703900"
          },
          {
            "id": "679afb3f3d9bab0f83ff6648",
            "leftCorner": {
              "x": 38.915,
              "y": 3.417,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.86,
              "y": 3.4174,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447703924"
          },
          {
            "id": "679afb3f3d9bab0f83ff6649",
            "leftCorner": {
              "x": 38.86,
              "y": 3.4174,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.816,
              "y": 3.4178,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447785470"
          },
          {
            "id": "679afb3f3d9bab0f83ff664a",
            "leftCorner": {
              "x": 38.816,
              "y": 3.4178,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.773,
              "y": 3.4181,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447785470"
          },
          {
            "id": "679afb3f3d9bab0f83ff664b",
            "leftCorner": {
              "x": 38.773,
              "y": 3.4181,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.681,
              "y": 3.4188,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241167"
          },
          {
            "id": "679afb3f3d9bab0f83ff664c",
            "leftCorner": {
              "x": 38.681,
              "y": 3.4188,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.639,
              "y": 3.4192,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241198"
          },
          {
            "id": "679afb3f3d9bab0f83ff664d",
            "leftCorner": {
              "x": 38.639,
              "y": 3.4192,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.598,
              "y": 3.4195,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241198"
          },
          {
            "id": "679afb3f3d9bab0f83ff664e",
            "leftCorner": {
              "x": 38.598,
              "y": 3.4195,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.559,
              "y": 3.4198,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365467"
          },
          {
            "id": "679afb3f3d9bab0f83ff664f",
            "leftCorner": {
              "x": 38.559,
              "y": 3.4198,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.519,
              "y": 3.4201,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365467"
          },
          {
            "id": "679afb3f3d9bab0f83ff6650",
            "leftCorner": {
              "x": 38.519,
              "y": 3.4201,
              "z": 0.79818
            },
            "rightCorner": {
              "x": 38.426,
              "y": 3.4208,
              "z": 0.79818
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365740"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add0",
        "height": 1.091,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff670a",
            "leftCorner": {
              "x": 39.398,
              "y": 3.4125,
              "z": 1.091
            },
            "rightCorner": {
              "x": 39.315,
              "y": 3.4131,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806786"
          },
          {
            "id": "679afb3f3d9bab0f83ff670b",
            "leftCorner": {
              "x": 39.315,
              "y": 3.4131,
              "z": 1.091
            },
            "rightCorner": {
              "x": 39.166,
              "y": 3.4143,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365443"
          },
          {
            "id": "679afb3f3d9bab0f83ff670c",
            "leftCorner": {
              "x": 39.166,
              "y": 3.4143,
              "z": 1.091
            },
            "rightCorner": {
              "x": 39.066,
              "y": 3.4151,
              "z": 1.091
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447783476"
          },
          {
            "id": "679afb3f3d9bab0f83ff670d",
            "leftCorner": {
              "x": 39.066,
              "y": 3.4151,
              "z": 1.091
            },
            "rightCorner": {
              "x": 39.016,
              "y": 3.4155,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783490"
          },
          {
            "id": "679afb3f3d9bab0f83ff670e",
            "leftCorner": {
              "x": 39.016,
              "y": 3.4155,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.966,
              "y": 3.4159,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783490"
          },
          {
            "id": "679afb3f3d9bab0f83ff670f",
            "leftCorner": {
              "x": 38.966,
              "y": 3.4159,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.916,
              "y": 3.4162,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378771"
          },
          {
            "id": "679afb3f3d9bab0f83ff6710",
            "leftCorner": {
              "x": 38.916,
              "y": 3.4162,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.867,
              "y": 3.4166,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447378771"
          },
          {
            "id": "679afb3f3d9bab0f83ff6711",
            "leftCorner": {
              "x": 38.867,
              "y": 3.4166,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.827,
              "y": 3.4169,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365887"
          },
          {
            "id": "679afb3f3d9bab0f83ff6712",
            "leftCorner": {
              "x": 38.827,
              "y": 3.4169,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.785,
              "y": 3.4173,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668292"
          },
          {
            "id": "679afb3f3d9bab0f83ff6713",
            "leftCorner": {
              "x": 38.785,
              "y": 3.4173,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.743,
              "y": 3.4176,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668292"
          },
          {
            "id": "679afb3f3d9bab0f83ff6714",
            "leftCorner": {
              "x": 38.743,
              "y": 3.4176,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.694,
              "y": 3.418,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783537"
          },
          {
            "id": "679afb3f3d9bab0f83ff6715",
            "leftCorner": {
              "x": 38.694,
              "y": 3.418,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.643,
              "y": 3.4184,
              "z": 1.091
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447783537"
          },
          {
            "id": "679afb3f3d9bab0f83ff6716",
            "leftCorner": {
              "x": 38.643,
              "y": 3.4184,
              "z": 1.091
            },
            "rightCorner": {
              "x": 38.572,
              "y": 3.419,
              "z": 1.091
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447783551"
          },
          {
            "id": "679afb3f3d9bab0f83ff6717",
            "leftCorner": {
              "x": 38.602,
              "y": 3.4019,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.532,
              "y": 3.4024,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447783551"
          },
          {
            "id": "679afb3f3d9bab0f83ff6718",
            "leftCorner": {
              "x": 38.532,
              "y": 3.4047,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.444,
              "y": 3.4054,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447365825"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adcf",
        "height": 1.3873,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66ce",
            "leftCorner": {
              "x": 39.414,
              "y": 3.4159,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 39.307,
              "y": 3.4167,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540532867"
          },
          {
            "id": "679afb3f3d9bab0f83ff66cf",
            "leftCorner": {
              "x": 39.307,
              "y": 3.4167,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 39.084,
              "y": 3.4185,
              "z": 1.3873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447342031"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d0",
            "leftCorner": {
              "x": 39.084,
              "y": 3.4185,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.923,
              "y": 3.4197,
              "z": 1.3873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447365665"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d1",
            "leftCorner": {
              "x": 38.923,
              "y": 3.4197,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.87,
              "y": 3.4202,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447365689"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d2",
            "leftCorner": {
              "x": 38.87,
              "y": 3.4202,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.819,
              "y": 3.4206,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241235"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d3",
            "leftCorner": {
              "x": 38.819,
              "y": 3.4206,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.768,
              "y": 3.421,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241235"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d4",
            "leftCorner": {
              "x": 38.768,
              "y": 3.421,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.716,
              "y": 3.4214,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241082"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d5",
            "leftCorner": {
              "x": 38.716,
              "y": 3.4214,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.665,
              "y": 3.4218,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241082"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d6",
            "leftCorner": {
              "x": 38.665,
              "y": 3.4218,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.613,
              "y": 3.4222,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806823"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d7",
            "leftCorner": {
              "x": 38.613,
              "y": 3.4222,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.512,
              "y": 3.423,
              "z": 1.3873
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806823"
          },
          {
            "id": "679afb3f3d9bab0f83ff66d8",
            "leftCorner": {
              "x": 38.512,
              "y": 3.423,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.412,
              "y": 3.4238,
              "z": 1.3873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447240887"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adcd",
        "height": 1.6803,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6755",
            "leftCorner": {
              "x": 39.396,
              "y": 3.4174,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 39.321,
              "y": 3.418,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540206812"
          },
          {
            "id": "679afb3f3d9bab0f83ff6756",
            "leftCorner": {
              "x": 39.321,
              "y": 3.418,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 39.151,
              "y": 3.4194,
              "z": 1.6803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001841212234"
          },
          {
            "id": "679afb3f3d9bab0f83ff6757",
            "leftCorner": {
              "x": 39.151,
              "y": 3.4194,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 39.002,
              "y": 3.4205,
              "z": 1.6803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447241211"
          },
          {
            "id": "679afb3f3d9bab0f83ff6758",
            "leftCorner": {
              "x": 39.002,
              "y": 3.4205,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.916,
              "y": 3.4212,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806724"
          },
          {
            "id": "679afb3f3d9bab0f83ff6759",
            "leftCorner": {
              "x": 38.916,
              "y": 3.4212,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.865,
              "y": 3.4216,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806724"
          },
          {
            "id": "679afb3f3d9bab0f83ff675a",
            "leftCorner": {
              "x": 38.865,
              "y": 3.4216,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.815,
              "y": 3.422,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240948"
          },
          {
            "id": "679afb3f3d9bab0f83ff675b",
            "leftCorner": {
              "x": 38.815,
              "y": 3.422,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.763,
              "y": 3.4224,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240948"
          },
          {
            "id": "679afb3f3d9bab0f83ff675c",
            "leftCorner": {
              "x": 38.763,
              "y": 3.4224,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.712,
              "y": 3.4228,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241129"
          },
          {
            "id": "679afb3f3d9bab0f83ff675d",
            "leftCorner": {
              "x": 38.712,
              "y": 3.4228,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.659,
              "y": 3.4232,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241129"
          },
          {
            "id": "679afb3f3d9bab0f83ff675e",
            "leftCorner": {
              "x": 38.659,
              "y": 3.4232,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.611,
              "y": 3.4236,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241143"
          },
          {
            "id": "679afb3f3d9bab0f83ff675f",
            "leftCorner": {
              "x": 38.611,
              "y": 3.4236,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.56,
              "y": 3.424,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241143"
          },
          {
            "id": "679afb3f3d9bab0f83ff6760",
            "leftCorner": {
              "x": 38.56,
              "y": 3.424,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.531,
              "y": 3.4242,
              "z": 1.6803
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6761",
            "leftCorner": {
              "x": 38.531,
              "y": 3.4242,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.479,
              "y": 3.4246,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240801"
          },
          {
            "id": "679afb3f3d9bab0f83ff6762",
            "leftCorner": {
              "x": 38.479,
              "y": 3.4246,
              "z": 1.6803
            },
            "rightCorner": {
              "x": 38.412,
              "y": 3.4252,
              "z": 1.6803
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240788"
          },
          {
            "id": "679afb3f3d9bab0f83ff6763",
            "leftCorner": {
              "x": 38.443,
              "y": 3.4104,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 38.304,
              "y": 3.4115,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447240788"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 64,
      "unknownStockCount": 17
    },
    "name": "B2HX",
    "leftNeighborShelfId": "T8WX",
    "rightNeighborShelfId": "LH8H"
  },
  {
    "id": "LH8H",
    "x": 38.443,
    "y": 3.42,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.9998,
      "w": 0.020152
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3add7",
        "height": 0.15745,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff660c",
            "leftCorner": {
              "x": 38.373,
              "y": 3.5185,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 38.301,
              "y": 3.5214,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468038"
          },
          {
            "id": "679afb3f3d9bab0f83ff660d",
            "leftCorner": {
              "x": 38.301,
              "y": 3.5214,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 38.235,
              "y": 3.524,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447745443"
          },
          {
            "id": "679afb3f3d9bab0f83ff660e",
            "leftCorner": {
              "x": 38.235,
              "y": 3.524,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 38.169,
              "y": 3.5267,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447745443"
          },
          {
            "id": "679afb3f3d9bab0f83ff660f",
            "leftCorner": {
              "x": 38.169,
              "y": 3.5267,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 38.1,
              "y": 3.5295,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468175"
          },
          {
            "id": "679afb3f3d9bab0f83ff6610",
            "leftCorner": {
              "x": 38.1,
              "y": 3.5295,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 38.028,
              "y": 3.5324,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447468175"
          },
          {
            "id": "679afb3f3d9bab0f83ff6611",
            "leftCorner": {
              "x": 38.028,
              "y": 3.5324,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.952,
              "y": 3.5355,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467970"
          },
          {
            "id": "679afb3f3d9bab0f83ff6612",
            "leftCorner": {
              "x": 37.952,
              "y": 3.5355,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.88,
              "y": 3.5384,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467994"
          },
          {
            "id": "679afb3f3d9bab0f83ff6613",
            "leftCorner": {
              "x": 37.88,
              "y": 3.5384,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.808,
              "y": 3.5413,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467932"
          },
          {
            "id": "679afb3f3d9bab0f83ff6614",
            "leftCorner": {
              "x": 37.808,
              "y": 3.5413,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.741,
              "y": 3.5439,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467932"
          },
          {
            "id": "679afb3f3d9bab0f83ff6615",
            "leftCorner": {
              "x": 37.741,
              "y": 3.5439,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.672,
              "y": 3.5467,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467956"
          },
          {
            "id": "679afb3f3d9bab0f83ff6616",
            "leftCorner": {
              "x": 37.672,
              "y": 3.5467,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.617,
              "y": 3.5489,
              "z": 0.15745
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447467956"
          },
          {
            "id": "679afb3f3d9bab0f83ff6617",
            "leftCorner": {
              "x": 37.617,
              "y": 3.5489,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.582,
              "y": 3.5504,
              "z": 0.15745
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6618",
            "leftCorner": {
              "x": 37.582,
              "y": 3.5504,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.555,
              "y": 3.5514,
              "z": 0.15745
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447467918"
          },
          {
            "id": "679afb3f3d9bab0f83ff6619",
            "leftCorner": {
              "x": 37.555,
              "y": 3.5514,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.515,
              "y": 3.5531,
              "z": 0.15745
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447467918"
          },
          {
            "id": "679afb3f3d9bab0f83ff65d2",
            "leftCorner": {
              "x": 37.515,
              "y": 3.5531,
              "z": 0.15745
            },
            "rightCorner": {
              "x": 37.448,
              "y": 3.5558,
              "z": 0.15745
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add4",
        "height": 0.46164,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6699",
            "leftCorner": {
              "x": 38.33,
              "y": 3.4123,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 38.253,
              "y": 3.4154,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447626841"
          },
          {
            "id": "679afb3f3d9bab0f83ff669a",
            "leftCorner": {
              "x": 38.253,
              "y": 3.4154,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 38.179,
              "y": 3.4184,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447626841"
          },
          {
            "id": "679afb3f3d9bab0f83ff669b",
            "leftCorner": {
              "x": 38.179,
              "y": 3.4184,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 38.11,
              "y": 3.4212,
              "z": 0.46164
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447746693"
          },
          {
            "id": "679afb3f3d9bab0f83ff669c",
            "leftCorner": {
              "x": 38.11,
              "y": 3.4212,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 38.038,
              "y": 3.424,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746716"
          },
          {
            "id": "679afb3f3d9bab0f83ff669d",
            "leftCorner": {
              "x": 38.038,
              "y": 3.424,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.966,
              "y": 3.427,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447746716"
          },
          {
            "id": "679afb3f3d9bab0f83ff669e",
            "leftCorner": {
              "x": 37.966,
              "y": 3.427,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.898,
              "y": 3.4297,
              "z": 0.46164
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447785425"
          },
          {
            "id": "679afb3f3d9bab0f83ff669f",
            "leftCorner": {
              "x": 37.898,
              "y": 3.4297,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.842,
              "y": 3.432,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668278"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a0",
            "leftCorner": {
              "x": 37.842,
              "y": 3.432,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.717,
              "y": 3.437,
              "z": 0.46164
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447230895"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a1",
            "leftCorner": {
              "x": 37.717,
              "y": 3.437,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.609,
              "y": 3.4414,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260076501"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a2",
            "leftCorner": {
              "x": 37.609,
              "y": 3.4414,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.529,
              "y": 3.4446,
              "z": 0.46164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666204608"
          },
          {
            "id": "679afb3f3d9bab0f83ff6661",
            "leftCorner": {
              "x": 37.529,
              "y": 3.4446,
              "z": 0.46164
            },
            "rightCorner": {
              "x": 37.443,
              "y": 3.448,
              "z": 0.46164
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4104260076501"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add6",
        "height": 0.79629,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6651",
            "leftCorner": {
              "x": 38.456,
              "y": 3.4066,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 38.374,
              "y": 3.4073,
              "z": 0.79629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447679007"
          },
          {
            "id": "679afb3f3d9bab0f83ff6652",
            "leftCorner": {
              "x": 38.374,
              "y": 3.41,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 38.331,
              "y": 3.4103,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447241105"
          },
          {
            "id": "679afb3f3d9bab0f83ff6653",
            "leftCorner": {
              "x": 38.331,
              "y": 3.4117,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 38.151,
              "y": 3.419,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447806700"
          },
          {
            "id": "679afb3f3d9bab0f83ff6654",
            "leftCorner": {
              "x": 38.151,
              "y": 3.419,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 38.069,
              "y": 3.4223,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048967"
          },
          {
            "id": "679afb3f3d9bab0f83ff6655",
            "leftCorner": {
              "x": 38.069,
              "y": 3.4223,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 38.003,
              "y": 3.4249,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048943"
          },
          {
            "id": "679afb3f3d9bab0f83ff6656",
            "leftCorner": {
              "x": 38.003,
              "y": 3.4249,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.921,
              "y": 3.4282,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048905"
          },
          {
            "id": "679afb3f3d9bab0f83ff6657",
            "leftCorner": {
              "x": 37.921,
              "y": 3.4282,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.856,
              "y": 3.4308,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048882"
          },
          {
            "id": "679afb3f3d9bab0f83ff6658",
            "leftCorner": {
              "x": 37.856,
              "y": 3.4308,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.785,
              "y": 3.4337,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040047168"
          },
          {
            "id": "679afb3f3d9bab0f83ff6659",
            "leftCorner": {
              "x": 37.785,
              "y": 3.4337,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.759,
              "y": 3.4348,
              "z": 0.79629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040048868"
          },
          {
            "id": "679afb3f3d9bab0f83ff665a",
            "leftCorner": {
              "x": 37.759,
              "y": 3.4348,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.728,
              "y": 3.436,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040048868"
          },
          {
            "id": "679afb3f3d9bab0f83ff665b",
            "leftCorner": {
              "x": 37.728,
              "y": 3.436,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.703,
              "y": 3.437,
              "z": 0.79629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4103040019349"
          },
          {
            "id": "679afb3f3d9bab0f83ff665c",
            "leftCorner": {
              "x": 37.703,
              "y": 3.437,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.666,
              "y": 3.4385,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4103040019349"
          },
          {
            "id": "679afb3f3d9bab0f83ff665d",
            "leftCorner": {
              "x": 37.666,
              "y": 3.4385,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.617,
              "y": 3.4405,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006429"
          },
          {
            "id": "679afb3f3d9bab0f83ff665e",
            "leftCorner": {
              "x": 37.617,
              "y": 3.4405,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.548,
              "y": 3.4433,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006405"
          },
          {
            "id": "679afb3f3d9bab0f83ff665f",
            "leftCorner": {
              "x": 37.548,
              "y": 3.4433,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.5,
              "y": 3.4452,
              "z": 0.79629
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008890006085"
          },
          {
            "id": "679afb3f3d9bab0f83ff661b",
            "leftCorner": {
              "x": 37.5,
              "y": 3.4452,
              "z": 0.79629
            },
            "rightCorner": {
              "x": 37.443,
              "y": 3.4475,
              "z": 0.79629
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008890006085"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add5",
        "height": 1.0897,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6719",
            "leftCorner": {
              "x": 38.444,
              "y": 3.4083,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.363,
              "y": 3.4089,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008666750389"
          },
          {
            "id": "679afb3f3d9bab0f83ff671a",
            "leftCorner": {
              "x": 38.363,
              "y": 3.4115,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.122,
              "y": 3.4213,
              "z": 1.0897
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008666704559"
          },
          {
            "id": "679afb3f3d9bab0f83ff671b",
            "leftCorner": {
              "x": 38.122,
              "y": 3.4213,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.067,
              "y": 3.4235,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666704207"
          },
          {
            "id": "679afb3f3d9bab0f83ff671c",
            "leftCorner": {
              "x": 38.067,
              "y": 3.4235,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 38.022,
              "y": 3.4253,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666704702"
          },
          {
            "id": "679afb3f3d9bab0f83ff671d",
            "leftCorner": {
              "x": 38.022,
              "y": 3.4253,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.966,
              "y": 3.4276,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666709547"
          },
          {
            "id": "679afb3f3d9bab0f83ff671e",
            "leftCorner": {
              "x": 37.966,
              "y": 3.4276,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.91,
              "y": 3.4298,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666705006"
          },
          {
            "id": "679afb3f3d9bab0f83ff671f",
            "leftCorner": {
              "x": 37.91,
              "y": 3.4298,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.86,
              "y": 3.4318,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666705013"
          },
          {
            "id": "679afb3f3d9bab0f83ff6720",
            "leftCorner": {
              "x": 37.86,
              "y": 3.4318,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.808,
              "y": 3.4339,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666701602"
          },
          {
            "id": "679afb3f3d9bab0f83ff6721",
            "leftCorner": {
              "x": 37.808,
              "y": 3.4339,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.758,
              "y": 3.4359,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666700001"
          },
          {
            "id": "679afb3f3d9bab0f83ff6722",
            "leftCorner": {
              "x": 37.758,
              "y": 3.4359,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.702,
              "y": 3.4382,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666700001"
          },
          {
            "id": "679afb3f3d9bab0f83ff6723",
            "leftCorner": {
              "x": 37.702,
              "y": 3.4382,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.661,
              "y": 3.4398,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666752314"
          },
          {
            "id": "679afb3f3d9bab0f83ff6724",
            "leftCorner": {
              "x": 37.661,
              "y": 3.4398,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.609,
              "y": 3.442,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666700902"
          },
          {
            "id": "679afb3f3d9bab0f83ff6725",
            "leftCorner": {
              "x": 37.609,
              "y": 3.442,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.54,
              "y": 3.4447,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666700407"
          },
          {
            "id": "679afb3f3d9bab0f83ff6726",
            "leftCorner": {
              "x": 37.54,
              "y": 3.4447,
              "z": 1.0897
            },
            "rightCorner": {
              "x": 37.477,
              "y": 3.4473,
              "z": 1.0897
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008666701787"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add3",
        "height": 1.3845,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff66d9",
            "leftCorner": {
              "x": 38.412,
              "y": 3.4238,
              "z": 1.3873
            },
            "rightCorner": {
              "x": 38.334,
              "y": 3.4244,
              "z": 1.3873
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216328609"
          },
          {
            "id": "679afb3f3d9bab0f83ff66da",
            "leftCorner": {
              "x": 38.365,
              "y": 3.4134,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 38.318,
              "y": 3.4137,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216495981"
          },
          {
            "id": "679afb3f3d9bab0f83ff66db",
            "leftCorner": {
              "x": 38.318,
              "y": 3.4152,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 38.281,
              "y": 3.4155,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216496032"
          },
          {
            "id": "679afb3f3d9bab0f83ff66dc",
            "leftCorner": {
              "x": 38.281,
              "y": 3.4167,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 38.14,
              "y": 3.4225,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216496056"
          },
          {
            "id": "679afb3f3d9bab0f83ff66dd",
            "leftCorner": {
              "x": 38.14,
              "y": 3.4225,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 38.075,
              "y": 3.425,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090890528"
          },
          {
            "id": "679afb3f3d9bab0f83ff66de",
            "leftCorner": {
              "x": 38.075,
              "y": 3.425,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 38.015,
              "y": 3.4275,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216404303"
          },
          {
            "id": "679afb3f3d9bab0f83ff66df",
            "leftCorner": {
              "x": 38.015,
              "y": 3.4275,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.935,
              "y": 3.4307,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090896049"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e0",
            "leftCorner": {
              "x": 37.935,
              "y": 3.4307,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.869,
              "y": 3.4334,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090891334"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e1",
            "leftCorner": {
              "x": 37.869,
              "y": 3.4334,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.809,
              "y": 3.4358,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216404358"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e2",
            "leftCorner": {
              "x": 37.809,
              "y": 3.4358,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.732,
              "y": 3.4389,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090896735"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e3",
            "leftCorner": {
              "x": 37.732,
              "y": 3.4389,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.665,
              "y": 3.4416,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090896735"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e4",
            "leftCorner": {
              "x": 37.665,
              "y": 3.4416,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.611,
              "y": 3.4438,
              "z": 1.3845
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090894991"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e5",
            "leftCorner": {
              "x": 37.611,
              "y": 3.4438,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.576,
              "y": 3.4452,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090894991"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e6",
            "leftCorner": {
              "x": 37.576,
              "y": 3.4452,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.533,
              "y": 3.4469,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8700216517669"
          },
          {
            "id": "679afb3f3d9bab0f83ff66e7",
            "leftCorner": {
              "x": 37.533,
              "y": 3.4469,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.484,
              "y": 3.4489,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090895349"
          },
          {
            "id": "679afb3f3d9bab0f83ff66a4",
            "leftCorner": {
              "x": 37.484,
              "y": 3.4489,
              "z": 1.3845
            },
            "rightCorner": {
              "x": 37.444,
              "y": 3.4505,
              "z": 1.3845
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090895349"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add8",
        "height": 1.6789,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6764",
            "leftCorner": {
              "x": 38.304,
              "y": 3.416,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 38.195,
              "y": 3.4204,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540903346"
          },
          {
            "id": "679afb3f3d9bab0f83ff6765",
            "leftCorner": {
              "x": 38.195,
              "y": 3.4204,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 38.137,
              "y": 3.4227,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216328661"
          },
          {
            "id": "679afb3f3d9bab0f83ff6766",
            "leftCorner": {
              "x": 38.137,
              "y": 3.4227,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 38.089,
              "y": 3.4247,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216328760"
          },
          {
            "id": "679afb3f3d9bab0f83ff6767",
            "leftCorner": {
              "x": 38.089,
              "y": 3.4247,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 38.04,
              "y": 3.4267,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8006540423202"
          },
          {
            "id": "679afb3f3d9bab0f83ff6768",
            "leftCorner": {
              "x": 38.04,
              "y": 3.4267,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.956,
              "y": 3.4301,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090896315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6769",
            "leftCorner": {
              "x": 37.956,
              "y": 3.4301,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.892,
              "y": 3.4327,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090896315"
          },
          {
            "id": "679afb3f3d9bab0f83ff676a",
            "leftCorner": {
              "x": 37.892,
              "y": 3.4327,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.825,
              "y": 3.4353,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090890054"
          },
          {
            "id": "679afb3f3d9bab0f83ff676b",
            "leftCorner": {
              "x": 37.825,
              "y": 3.4353,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.759,
              "y": 3.438,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216404365"
          },
          {
            "id": "679afb3f3d9bab0f83ff676c",
            "leftCorner": {
              "x": 37.759,
              "y": 3.438,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.701,
              "y": 3.4403,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090892843"
          },
          {
            "id": "679afb3f3d9bab0f83ff676d",
            "leftCorner": {
              "x": 37.701,
              "y": 3.4403,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.639,
              "y": 3.4428,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090894878"
          },
          {
            "id": "679afb3f3d9bab0f83ff676e",
            "leftCorner": {
              "x": 37.639,
              "y": 3.4428,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.592,
              "y": 3.4447,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8700216301749"
          },
          {
            "id": "679afb3f3d9bab0f83ff676f",
            "leftCorner": {
              "x": 37.592,
              "y": 3.4447,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.525,
              "y": 3.4474,
              "z": 1.6789
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8001090941848"
          },
          {
            "id": "679afb3f3d9bab0f83ff6770",
            "leftCorner": {
              "x": 37.525,
              "y": 3.4474,
              "z": 1.6789
            },
            "rightCorner": {
              "x": 37.471,
              "y": 3.4496,
              "z": 1.6789
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8001090894366"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 63,
      "unknownStockCount": 22
    },
    "name": "LH8H",
    "leftNeighborShelfId": "B2HX",
    "rightNeighborShelfId": "Q3ES"
  },
  {
    "id": "8746",
    "x": 36.767,
    "y": 2.8157,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.71101,
      "w": 0.70319
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adde",
        "height": 0.16178,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67d5",
            "leftCorner": {
              "x": 36.674,
              "y": 2.8167,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.674,
              "y": 2.7372,
              "z": 0.16178
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816204"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d7",
            "leftCorner": {
              "x": 36.674,
              "y": 2.7372,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.673,
              "y": 2.6481,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816204"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d8",
            "leftCorner": {
              "x": 36.673,
              "y": 2.6481,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.672,
              "y": 2.5526,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815900"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d9",
            "leftCorner": {
              "x": 36.672,
              "y": 2.5526,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.67,
              "y": 2.4569,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816167"
          },
          {
            "id": "679afb3f3d9bab0f83ff67da",
            "leftCorner": {
              "x": 36.67,
              "y": 2.4569,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.669,
              "y": 2.3611,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816082"
          },
          {
            "id": "679afb3f3d9bab0f83ff67db",
            "leftCorner": {
              "x": 36.669,
              "y": 2.3611,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.668,
              "y": 2.2603,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816129"
          },
          {
            "id": "679afb3f3d9bab0f83ff67dc",
            "leftCorner": {
              "x": 36.668,
              "y": 2.2603,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.667,
              "y": 2.1653,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565164"
          },
          {
            "id": "679afb3f3d9bab0f83ff67dd",
            "leftCorner": {
              "x": 36.667,
              "y": 2.1653,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.666,
              "y": 2.0747,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565225"
          },
          {
            "id": "679afb3f3d9bab0f83ff67de",
            "leftCorner": {
              "x": 36.666,
              "y": 2.0747,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.665,
              "y": 1.9831,
              "z": 0.16178
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447669091"
          },
          {
            "id": "679afb3f3d9bab0f83ff67df",
            "leftCorner": {
              "x": 36.665,
              "y": 1.9831,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.664,
              "y": 1.8917,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564983"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e0",
            "leftCorner": {
              "x": 36.664,
              "y": 1.8917,
              "z": 0.16178
            },
            "rightCorner": {
              "x": 36.663,
              "y": 1.7697,
              "z": 0.16178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565041"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adda",
        "height": 0.42369,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6785",
            "leftCorner": {
              "x": 36.79,
              "y": 2.8154,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.7319,
              "z": 0.42369
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816068"
          },
          {
            "id": "679afb3f3d9bab0f83ff6787",
            "leftCorner": {
              "x": 36.789,
              "y": 2.7319,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.788,
              "y": 2.6419,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816006"
          },
          {
            "id": "679afb3f3d9bab0f83ff6788",
            "leftCorner": {
              "x": 36.788,
              "y": 2.6419,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.787,
              "y": 2.5487,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816181"
          },
          {
            "id": "679afb3f3d9bab0f83ff6789",
            "leftCorner": {
              "x": 36.787,
              "y": 2.5487,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.786,
              "y": 2.4522,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816266"
          },
          {
            "id": "679afb3f3d9bab0f83ff678a",
            "leftCorner": {
              "x": 36.786,
              "y": 2.4522,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.785,
              "y": 2.3558,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815962"
          },
          {
            "id": "679afb3f3d9bab0f83ff678b",
            "leftCorner": {
              "x": 36.785,
              "y": 2.3558,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.784,
              "y": 2.256,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816327"
          },
          {
            "id": "679afb3f3d9bab0f83ff678c",
            "leftCorner": {
              "x": 36.784,
              "y": 2.256,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.783,
              "y": 2.1631,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565102"
          },
          {
            "id": "679afb3f3d9bab0f83ff678d",
            "leftCorner": {
              "x": 36.783,
              "y": 2.1631,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.782,
              "y": 2.0697,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447669008"
          },
          {
            "id": "679afb3f3d9bab0f83ff678e",
            "leftCorner": {
              "x": 36.782,
              "y": 2.0697,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.9754,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447669039"
          },
          {
            "id": "679afb3f3d9bab0f83ff678f",
            "leftCorner": {
              "x": 36.781,
              "y": 1.9754,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.78,
              "y": 1.8868,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565287"
          },
          {
            "id": "679afb3f3d9bab0f83ff6790",
            "leftCorner": {
              "x": 36.78,
              "y": 1.8868,
              "z": 0.42369
            },
            "rightCorner": {
              "x": 36.778,
              "y": 1.7543,
              "z": 0.42369
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447669060"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3add9",
        "height": 0.67583,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6771",
            "leftCorner": {
              "x": 36.793,
              "y": 2.8154,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.792,
              "y": 2.743,
              "z": 0.67583
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816105"
          },
          {
            "id": "679afb3f3d9bab0f83ff6773",
            "leftCorner": {
              "x": 36.792,
              "y": 2.743,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.791,
              "y": 2.6538,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816525"
          },
          {
            "id": "679afb3f3d9bab0f83ff6774",
            "leftCorner": {
              "x": 36.791,
              "y": 2.6538,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.79,
              "y": 2.5587,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816044"
          },
          {
            "id": "679afb3f3d9bab0f83ff6775",
            "leftCorner": {
              "x": 36.79,
              "y": 2.5587,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.4632,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816242"
          },
          {
            "id": "679afb3f3d9bab0f83ff6776",
            "leftCorner": {
              "x": 36.789,
              "y": 2.4632,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.788,
              "y": 2.371,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816280"
          },
          {
            "id": "679afb3f3d9bab0f83ff6777",
            "leftCorner": {
              "x": 36.788,
              "y": 2.371,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.787,
              "y": 2.2721,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815825"
          },
          {
            "id": "679afb3f3d9bab0f83ff6778",
            "leftCorner": {
              "x": 36.787,
              "y": 2.2721,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.786,
              "y": 2.1759,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447616330"
          },
          {
            "id": "679afb3f3d9bab0f83ff6779",
            "leftCorner": {
              "x": 36.786,
              "y": 2.1759,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.785,
              "y": 2.0868,
              "z": 0.67583
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447706833"
          },
          {
            "id": "679afb3f3d9bab0f83ff677a",
            "leftCorner": {
              "x": 36.785,
              "y": 2.0868,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.9925,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447706802"
          },
          {
            "id": "679afb3f3d9bab0f83ff677b",
            "leftCorner": {
              "x": 36.784,
              "y": 1.9925,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.9019,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565256"
          },
          {
            "id": "679afb3f3d9bab0f83ff677c",
            "leftCorner": {
              "x": 36.783,
              "y": 1.9019,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.8098,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565195"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3addb",
        "height": 0.92611,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff679a",
            "leftCorner": {
              "x": 36.792,
              "y": 2.8154,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.791,
              "y": 2.7253,
              "z": 0.92611
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523714537"
          },
          {
            "id": "679afb3f3d9bab0f83ff679c",
            "leftCorner": {
              "x": 36.791,
              "y": 2.7253,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.79,
              "y": 2.6247,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714407"
          },
          {
            "id": "679afb3f3d9bab0f83ff679d",
            "leftCorner": {
              "x": 36.79,
              "y": 2.6247,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.5205,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714490"
          },
          {
            "id": "679afb3f3d9bab0f83ff679e",
            "leftCorner": {
              "x": 36.789,
              "y": 2.5205,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.788,
              "y": 2.4136,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714476"
          },
          {
            "id": "679afb3f3d9bab0f83ff679f",
            "leftCorner": {
              "x": 36.788,
              "y": 2.4136,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.787,
              "y": 2.2981,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714544"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a0",
            "leftCorner": {
              "x": 36.787,
              "y": 2.2981,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.786,
              "y": 2.1969,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523738137"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a1",
            "leftCorner": {
              "x": 36.786,
              "y": 2.1969,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.784,
              "y": 2.0914,
              "z": 0.92611
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523991495"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a2",
            "leftCorner": {
              "x": 36.784,
              "y": 2.0914,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.9882,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523789832"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a3",
            "leftCorner": {
              "x": 36.783,
              "y": 1.9882,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.8916,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776290"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a4",
            "leftCorner": {
              "x": 36.782,
              "y": 1.8916,
              "z": 0.92611
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.7576,
              "z": 0.92611
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524015107"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3addc",
        "height": 1.1806,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67ad",
            "leftCorner": {
              "x": 36.79,
              "y": 2.8155,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.72,
              "z": 1.1806
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523714513"
          },
          {
            "id": "679afb3f3d9bab0f83ff67af",
            "leftCorner": {
              "x": 36.789,
              "y": 2.72,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.788,
              "y": 2.6205,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714438"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b0",
            "leftCorner": {
              "x": 36.788,
              "y": 2.6205,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.786,
              "y": 2.5178,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714506"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b1",
            "leftCorner": {
              "x": 36.786,
              "y": 2.5178,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.785,
              "y": 2.411,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714452"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b2",
            "leftCorner": {
              "x": 36.785,
              "y": 2.411,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.784,
              "y": 2.3043,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714445"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b3",
            "leftCorner": {
              "x": 36.784,
              "y": 2.3043,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.783,
              "y": 2.1926,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523714414"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b4",
            "leftCorner": {
              "x": 36.783,
              "y": 2.1926,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.782,
              "y": 2.0926,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523789863"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b5",
            "leftCorner": {
              "x": 36.782,
              "y": 2.0926,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.78,
              "y": 1.9814,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "30178120"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b6",
            "leftCorner": {
              "x": 36.78,
              "y": 1.9814,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.779,
              "y": 1.8872,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523789849"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b7",
            "leftCorner": {
              "x": 36.779,
              "y": 1.8872,
              "z": 1.1806
            },
            "rightCorner": {
              "x": 36.778,
              "y": 1.7566,
              "z": 1.1806
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776368"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3addd",
        "height": 1.433,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67c1",
            "leftCorner": {
              "x": 36.792,
              "y": 2.8154,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.791,
              "y": 2.7105,
              "z": 1.433
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523941162"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c3",
            "leftCorner": {
              "x": 36.791,
              "y": 2.7105,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.79,
              "y": 2.6107,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523941117"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c4",
            "leftCorner": {
              "x": 36.79,
              "y": 2.6107,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.5049,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523941063"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c5",
            "leftCorner": {
              "x": 36.789,
              "y": 2.5049,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.787,
              "y": 2.4018,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523941018"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c6",
            "leftCorner": {
              "x": 36.787,
              "y": 2.4018,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.786,
              "y": 2.2877,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523940967"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c7",
            "leftCorner": {
              "x": 36.786,
              "y": 2.2877,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.785,
              "y": 2.1941,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523947133"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c8",
            "leftCorner": {
              "x": 36.785,
              "y": 2.1941,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.784,
              "y": 2.087,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523947034"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c9",
            "leftCorner": {
              "x": 36.784,
              "y": 2.087,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.984,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523946938"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ca",
            "leftCorner": {
              "x": 36.783,
              "y": 1.984,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.8877,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776429"
          },
          {
            "id": "679afb3f3d9bab0f83ff67cb",
            "leftCorner": {
              "x": 36.782,
              "y": 1.8877,
              "z": 1.433
            },
            "rightCorner": {
              "x": 36.78,
              "y": 1.7457,
              "z": 1.433
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776382"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3addf",
        "height": 1.6847,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67e8",
            "leftCorner": {
              "x": 36.795,
              "y": 2.8154,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.794,
              "y": 2.7228,
              "z": 1.6847
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524000127"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ea",
            "leftCorner": {
              "x": 36.794,
              "y": 2.7228,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.793,
              "y": 2.6224,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524000110"
          },
          {
            "id": "679afb3f3d9bab0f83ff67eb",
            "leftCorner": {
              "x": 36.793,
              "y": 2.6224,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.792,
              "y": 2.5139,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524000073"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ec",
            "leftCorner": {
              "x": 36.792,
              "y": 2.5139,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.79,
              "y": 2.4082,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522864943"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ed",
            "leftCorner": {
              "x": 36.79,
              "y": 2.4082,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.789,
              "y": 2.2988,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522864974"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ee",
            "leftCorner": {
              "x": 36.789,
              "y": 2.2988,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.788,
              "y": 2.1843,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600522864967"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ef",
            "leftCorner": {
              "x": 36.788,
              "y": 2.1843,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.787,
              "y": 2.0826,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776474"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f0",
            "leftCorner": {
              "x": 36.787,
              "y": 2.0826,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.786,
              "y": 1.9796,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776320"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f1",
            "leftCorner": {
              "x": 36.786,
              "y": 1.9796,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.785,
              "y": 1.8775,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776306"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f2",
            "leftCorner": {
              "x": 36.785,
              "y": 1.8775,
              "z": 1.6847
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.7473,
              "z": 1.6847
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776450"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 63,
      "unknownStockCount": 8
    },
    "name": "8746"
  },
  {
    "id": "OPMA",
    "x": 36.755,
    "y": 1.8468,
    "width": 0.8,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": -0.70233,
      "w": 0.71185
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ade4",
        "height": 0.1576,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67e1",
            "leftCorner": {
              "x": 36.665,
              "y": 1.7985,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.666,
              "y": 1.7109,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447564952"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e2",
            "leftCorner": {
              "x": 36.666,
              "y": 1.7109,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.667,
              "y": 1.6299,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100334029"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e3",
            "leftCorner": {
              "x": 36.667,
              "y": 1.6299,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.668,
              "y": 1.5516,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100334128"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e4",
            "leftCorner": {
              "x": 36.668,
              "y": 1.5516,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.669,
              "y": 1.4584,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441020261"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e5",
            "leftCorner": {
              "x": 36.669,
              "y": 1.4584,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.67,
              "y": 1.3653,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540244901"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e6",
            "leftCorner": {
              "x": 36.67,
              "y": 1.3653,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.672,
              "y": 1.2716,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441020056"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e7",
            "leftCorner": {
              "x": 36.672,
              "y": 1.2716,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.673,
              "y": 1.1686,
              "z": 0.1576
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542389877"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d6",
            "leftCorner": {
              "x": 36.673,
              "y": 1.1686,
              "z": 0.1576
            },
            "rightCorner": {
              "x": 36.675,
              "y": 1.0457,
              "z": 0.1576
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541043046"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade3",
        "height": 0.4202,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6791",
            "leftCorner": {
              "x": 36.771,
              "y": 1.7858,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.772,
              "y": 1.6979,
              "z": 0.4202
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447565010"
          },
          {
            "id": "679afb3f3d9bab0f83ff6792",
            "leftCorner": {
              "x": 36.772,
              "y": 1.6979,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.773,
              "y": 1.6178,
              "z": 0.4202
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100333961"
          },
          {
            "id": "679afb3f3d9bab0f83ff6793",
            "leftCorner": {
              "x": 36.773,
              "y": 1.6178,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.774,
              "y": 1.5838,
              "z": 0.4202
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100334005"
          },
          {
            "id": "679afb3f3d9bab0f83ff6794",
            "leftCorner": {
              "x": 36.774,
              "y": 1.5838,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.774,
              "y": 1.5372,
              "z": 0.4202
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100334005"
          },
          {
            "id": "679afb3f3d9bab0f83ff6795",
            "leftCorner": {
              "x": 36.774,
              "y": 1.5372,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.775,
              "y": 1.4964,
              "z": 0.4202
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002441020193"
          },
          {
            "id": "679afb3f3d9bab0f83ff6796",
            "leftCorner": {
              "x": 36.775,
              "y": 1.4964,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.775,
              "y": 1.4427,
              "z": 0.4202
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002441020193"
          },
          {
            "id": "679afb3f3d9bab0f83ff6797",
            "leftCorner": {
              "x": 36.775,
              "y": 1.4427,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.777,
              "y": 1.3448,
              "z": 0.4202
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541900141"
          },
          {
            "id": "679afb3f3d9bab0f83ff6798",
            "leftCorner": {
              "x": 36.777,
              "y": 1.3448,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.778,
              "y": 1.2515,
              "z": 0.4202
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441020278"
          },
          {
            "id": "679afb3f3d9bab0f83ff6799",
            "leftCorner": {
              "x": 36.778,
              "y": 1.2515,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.779,
              "y": 1.1557,
              "z": 0.4202
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541375369"
          },
          {
            "id": "679afb3f3d9bab0f83ff6786",
            "leftCorner": {
              "x": 36.779,
              "y": 1.1557,
              "z": 0.4202
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.0471,
              "z": 0.4202
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541375369"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade1",
        "height": 0.67438,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff677d",
            "leftCorner": {
              "x": 36.782,
              "y": 1.8098,
              "z": 0.67583
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.6909,
              "z": 0.67583
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668971"
          },
          {
            "id": "679afb3f3d9bab0f83ff677e",
            "leftCorner": {
              "x": 36.778,
              "y": 1.7226,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.779,
              "y": 1.6398,
              "z": 0.67438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100801972"
          },
          {
            "id": "679afb3f3d9bab0f83ff677f",
            "leftCorner": {
              "x": 36.779,
              "y": 1.6398,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.5419,
              "z": 0.67438
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100334067"
          },
          {
            "id": "679afb3f3d9bab0f83ff6780",
            "leftCorner": {
              "x": 36.781,
              "y": 1.5419,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.5048,
              "z": 0.67438
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600540604415"
          },
          {
            "id": "679afb3f3d9bab0f83ff6781",
            "leftCorner": {
              "x": 36.781,
              "y": 1.5048,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.4608,
              "z": 0.67438
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600540604415"
          },
          {
            "id": "679afb3f3d9bab0f83ff6782",
            "leftCorner": {
              "x": 36.782,
              "y": 1.4608,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.3651,
              "z": 0.67438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542466547"
          },
          {
            "id": "679afb3f3d9bab0f83ff6783",
            "leftCorner": {
              "x": 36.783,
              "y": 1.3651,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.2693,
              "z": 0.67438
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441020308"
          },
          {
            "id": "679afb3f3d9bab0f83ff6784",
            "leftCorner": {
              "x": 36.784,
              "y": 1.2693,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.786,
              "y": 1.1456,
              "z": 0.67438
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542169950"
          },
          {
            "id": "679afb3f3d9bab0f83ff6772",
            "leftCorner": {
              "x": 36.786,
              "y": 1.1456,
              "z": 0.67438
            },
            "rightCorner": {
              "x": 36.787,
              "y": 1.0472,
              "z": 0.67438
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade2",
        "height": 0.92497,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67a5",
            "leftCorner": {
              "x": 36.781,
              "y": 1.7893,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.6884,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524015060"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a6",
            "leftCorner": {
              "x": 36.782,
              "y": 1.6884,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.5979,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441512"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a7",
            "leftCorner": {
              "x": 36.784,
              "y": 1.5979,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.565,
              "z": 0.92497
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100441369"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a8",
            "leftCorner": {
              "x": 36.784,
              "y": 1.565,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.785,
              "y": 1.5039,
              "z": 0.92497
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100441369"
          },
          {
            "id": "679afb3f3d9bab0f83ff67a9",
            "leftCorner": {
              "x": 36.785,
              "y": 1.5039,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.786,
              "y": 1.4115,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441659"
          },
          {
            "id": "679afb3f3d9bab0f83ff67aa",
            "leftCorner": {
              "x": 36.786,
              "y": 1.4115,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.787,
              "y": 1.3173,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441710"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ab",
            "leftCorner": {
              "x": 36.787,
              "y": 1.3173,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.789,
              "y": 1.2215,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441697"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ac",
            "leftCorner": {
              "x": 36.789,
              "y": 1.2215,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.79,
              "y": 1.1277,
              "z": 0.92497
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441673"
          },
          {
            "id": "679afb3f3d9bab0f83ff679b",
            "leftCorner": {
              "x": 36.79,
              "y": 1.1277,
              "z": 0.92497
            },
            "rightCorner": {
              "x": 36.791,
              "y": 1.0473,
              "z": 0.92497
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100441673"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade5",
        "height": 1.1791,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67b8",
            "leftCorner": {
              "x": 36.78,
              "y": 1.7883,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.6941,
              "z": 1.1791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776337"
          },
          {
            "id": "679afb3f3d9bab0f83ff67b9",
            "leftCorner": {
              "x": 36.782,
              "y": 1.6941,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.606,
              "z": 1.1791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262665"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ba",
            "leftCorner": {
              "x": 36.783,
              "y": 1.606,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.574,
              "z": 1.1791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff67bb",
            "leftCorner": {
              "x": 36.783,
              "y": 1.574,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.5144,
              "z": 1.1791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262689"
          },
          {
            "id": "679afb3f3d9bab0f83ff67bc",
            "leftCorner": {
              "x": 36.784,
              "y": 1.5144,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.4733,
              "z": 1.1791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262696"
          },
          {
            "id": "679afb3f3d9bab0f83ff67bd",
            "leftCorner": {
              "x": 36.784,
              "y": 1.4733,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.785,
              "y": 1.4189,
              "z": 1.1791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262696"
          },
          {
            "id": "679afb3f3d9bab0f83ff67be",
            "leftCorner": {
              "x": 36.785,
              "y": 1.4189,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.787,
              "y": 1.3232,
              "z": 1.1791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100815030"
          },
          {
            "id": "679afb3f3d9bab0f83ff67bf",
            "leftCorner": {
              "x": 36.787,
              "y": 1.3232,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.788,
              "y": 1.2329,
              "z": 1.1791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441574"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c0",
            "leftCorner": {
              "x": 36.788,
              "y": 1.2329,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.789,
              "y": 1.1395,
              "z": 1.1791
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441772"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ae",
            "leftCorner": {
              "x": 36.789,
              "y": 1.1395,
              "z": 1.1791
            },
            "rightCorner": {
              "x": 36.79,
              "y": 1.0472,
              "z": 1.1791
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100441772"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade0",
        "height": 1.4325,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67cc",
            "leftCorner": {
              "x": 36.777,
              "y": 1.7774,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.778,
              "y": 1.6942,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523789856"
          },
          {
            "id": "679afb3f3d9bab0f83ff67cd",
            "leftCorner": {
              "x": 36.778,
              "y": 1.6942,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.779,
              "y": 1.6068,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262641"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ce",
            "leftCorner": {
              "x": 36.779,
              "y": 1.6068,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.78,
              "y": 1.5755,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262658"
          },
          {
            "id": "679afb3f3d9bab0f83ff67cf",
            "leftCorner": {
              "x": 36.78,
              "y": 1.5755,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.78,
              "y": 1.52,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262658"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d0",
            "leftCorner": {
              "x": 36.78,
              "y": 1.52,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.781,
              "y": 1.4809,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262672"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d1",
            "leftCorner": {
              "x": 36.781,
              "y": 1.4809,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.782,
              "y": 1.4302,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262672"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d2",
            "leftCorner": {
              "x": 36.782,
              "y": 1.4302,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.3324,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441499"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d3",
            "leftCorner": {
              "x": 36.783,
              "y": 1.3324,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.784,
              "y": 1.2371,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100443141"
          },
          {
            "id": "679afb3f3d9bab0f83ff67d4",
            "leftCorner": {
              "x": 36.784,
              "y": 1.2371,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.785,
              "y": 1.1475,
              "z": 1.4325
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff67c2",
            "leftCorner": {
              "x": 36.785,
              "y": 1.1475,
              "z": 1.4325
            },
            "rightCorner": {
              "x": 36.787,
              "y": 1.0472,
              "z": 1.4325
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade6",
        "height": 1.6861,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67f3",
            "leftCorner": {
              "x": 36.782,
              "y": 1.779,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.783,
              "y": 1.684,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523776405"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f4",
            "leftCorner": {
              "x": 36.783,
              "y": 1.684,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.785,
              "y": 1.5944,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262610"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f5",
            "leftCorner": {
              "x": 36.785,
              "y": 1.5944,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.786,
              "y": 1.5004,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260625262627"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f6",
            "leftCorner": {
              "x": 36.786,
              "y": 1.5004,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.786,
              "y": 1.4594,
              "z": 1.6861
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262634"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f7",
            "leftCorner": {
              "x": 36.786,
              "y": 1.4594,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.787,
              "y": 1.4057,
              "z": 1.6861
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260625262634"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f8",
            "leftCorner": {
              "x": 36.787,
              "y": 1.4057,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.788,
              "y": 1.3152,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441321"
          },
          {
            "id": "679afb3f3d9bab0f83ff67f9",
            "leftCorner": {
              "x": 36.788,
              "y": 1.3152,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.79,
              "y": 1.2144,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100441451"
          },
          {
            "id": "679afb3f3d9bab0f83ff67fa",
            "leftCorner": {
              "x": 36.79,
              "y": 1.2144,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.791,
              "y": 1.1196,
              "z": 1.6861
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff67e9",
            "leftCorner": {
              "x": 36.791,
              "y": 1.1196,
              "z": 1.6861
            },
            "rightCorner": {
              "x": 36.792,
              "y": 1.0473,
              "z": 1.6861
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 38,
      "unknownStockCount": 27
    },
    "name": "OPMA"
  },
  {
    "id": "QIPB",
    "x": 36.479,
    "y": 0.97121,
    "width": 1.25,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99998,
      "w": -0.0062802
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ade7",
        "height": 0.16302,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff67fb",
            "leftCorner": {
              "x": 36.477,
              "y": 1.0725,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 36.389,
              "y": 1.0714,
              "z": 0.16302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541043015"
          },
          {
            "id": "679afb3f3d9bab0f83ff67fd",
            "leftCorner": {
              "x": 36.389,
              "y": 1.0714,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 36.293,
              "y": 1.0702,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542389822"
          },
          {
            "id": "679afb3f3d9bab0f83ff67fe",
            "leftCorner": {
              "x": 36.293,
              "y": 1.0702,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 36.197,
              "y": 1.069,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542574709"
          },
          {
            "id": "679afb3f3d9bab0f83ff67ff",
            "leftCorner": {
              "x": 36.197,
              "y": 1.069,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 36.07,
              "y": 1.0674,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542518970"
          },
          {
            "id": "679afb3f3d9bab0f83ff6800",
            "leftCorner": {
              "x": 36.07,
              "y": 1.0674,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.973,
              "y": 1.0662,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542574686"
          },
          {
            "id": "679afb3f3d9bab0f83ff6801",
            "leftCorner": {
              "x": 35.973,
              "y": 1.0662,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.881,
              "y": 1.065,
              "z": 0.16302
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100814293"
          },
          {
            "id": "679afb3f3d9bab0f83ff6802",
            "leftCorner": {
              "x": 35.881,
              "y": 1.065,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.786,
              "y": 1.0638,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814279"
          },
          {
            "id": "679afb3f3d9bab0f83ff6803",
            "leftCorner": {
              "x": 35.786,
              "y": 1.0638,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.715,
              "y": 1.0629,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332063"
          },
          {
            "id": "679afb3f3d9bab0f83ff6804",
            "leftCorner": {
              "x": 35.715,
              "y": 1.0629,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.641,
              "y": 1.062,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332124"
          },
          {
            "id": "679afb3f3d9bab0f83ff6805",
            "leftCorner": {
              "x": 35.641,
              "y": 1.062,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.568,
              "y": 1.0611,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332124"
          },
          {
            "id": "679afb3f3d9bab0f83ff6806",
            "leftCorner": {
              "x": 35.568,
              "y": 1.0611,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.484,
              "y": 1.06,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441018459"
          },
          {
            "id": "679afb3f3d9bab0f83ff6807",
            "leftCorner": {
              "x": 35.484,
              "y": 1.06,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.396,
              "y": 1.0589,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540023391"
          },
          {
            "id": "679afb3f3d9bab0f83ff6808",
            "leftCorner": {
              "x": 35.396,
              "y": 1.0589,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.316,
              "y": 1.0579,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600520982496"
          },
          {
            "id": "679afb3f3d9bab0f83ff6809",
            "leftCorner": {
              "x": 35.316,
              "y": 1.0579,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.244,
              "y": 1.057,
              "z": 0.16302
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600520982472"
          },
          {
            "id": "679afb3f3d9bab0f83ff680a",
            "leftCorner": {
              "x": 35.244,
              "y": 1.057,
              "z": 0.16302
            },
            "rightCorner": {
              "x": 35.196,
              "y": 1.0564,
              "z": 0.16302
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adea",
        "height": 0.42118,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff684e",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95731,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 36.385,
              "y": 0.95612,
              "z": 0.42118
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002441020292"
          },
          {
            "id": "679afb3f3d9bab0f83ff6850",
            "leftCorner": {
              "x": 36.385,
              "y": 0.95612,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 36.276,
              "y": 0.95476,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540871565"
          },
          {
            "id": "679afb3f3d9bab0f83ff6851",
            "leftCorner": {
              "x": 36.276,
              "y": 0.95476,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 36.19,
              "y": 0.95368,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542524698"
          },
          {
            "id": "679afb3f3d9bab0f83ff6852",
            "leftCorner": {
              "x": 36.19,
              "y": 0.95368,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 36.097,
              "y": 0.95251,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542519014"
          },
          {
            "id": "679afb3f3d9bab0f83ff6853",
            "leftCorner": {
              "x": 36.097,
              "y": 0.95251,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.98,
              "y": 0.95104,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542518994"
          },
          {
            "id": "679afb3f3d9bab0f83ff6854",
            "leftCorner": {
              "x": 35.98,
              "y": 0.95104,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.879,
              "y": 0.94977,
              "z": 0.42118
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100814330"
          },
          {
            "id": "679afb3f3d9bab0f83ff6855",
            "leftCorner": {
              "x": 35.879,
              "y": 0.94977,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.794,
              "y": 0.94871,
              "z": 0.42118
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100814330"
          },
          {
            "id": "679afb3f3d9bab0f83ff6856",
            "leftCorner": {
              "x": 35.794,
              "y": 0.94871,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.724,
              "y": 0.94782,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332216"
          },
          {
            "id": "679afb3f3d9bab0f83ff6857",
            "leftCorner": {
              "x": 35.724,
              "y": 0.94782,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.651,
              "y": 0.94691,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332094"
          },
          {
            "id": "679afb3f3d9bab0f83ff6858",
            "leftCorner": {
              "x": 35.651,
              "y": 0.94691,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.565,
              "y": 0.94583,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600540615947"
          },
          {
            "id": "679afb3f3d9bab0f83ff6859",
            "leftCorner": {
              "x": 35.565,
              "y": 0.94583,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.478,
              "y": 0.94474,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441018350"
          },
          {
            "id": "679afb3f3d9bab0f83ff685a",
            "leftCorner": {
              "x": 35.478,
              "y": 0.94474,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.389,
              "y": 0.94361,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600520982519"
          },
          {
            "id": "679afb3f3d9bab0f83ff685b",
            "leftCorner": {
              "x": 35.389,
              "y": 0.94361,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.307,
              "y": 0.94258,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600521365632"
          },
          {
            "id": "679afb3f3d9bab0f83ff685c",
            "leftCorner": {
              "x": 35.307,
              "y": 0.94258,
              "z": 0.42118
            },
            "rightCorner": {
              "x": 35.209,
              "y": 0.94135,
              "z": 0.42118
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600520982502"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade8",
        "height": 0.67372,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6814",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95624,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 36.381,
              "y": 0.95501,
              "z": 0.67372
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4002441020209"
          },
          {
            "id": "679afb3f3d9bab0f83ff6816",
            "leftCorner": {
              "x": 36.381,
              "y": 0.95501,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 36.282,
              "y": 0.95377,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541901759"
          },
          {
            "id": "679afb3f3d9bab0f83ff6817",
            "leftCorner": {
              "x": 36.282,
              "y": 0.95377,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 36.177,
              "y": 0.95245,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542519076"
          },
          {
            "id": "679afb3f3d9bab0f83ff6818",
            "leftCorner": {
              "x": 36.177,
              "y": 0.95245,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 36.07,
              "y": 0.9511,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542574723"
          },
          {
            "id": "679afb3f3d9bab0f83ff6819",
            "leftCorner": {
              "x": 36.07,
              "y": 0.9511,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.953,
              "y": 0.94964,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542519052"
          },
          {
            "id": "679afb3f3d9bab0f83ff681a",
            "leftCorner": {
              "x": 35.953,
              "y": 0.94964,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.863,
              "y": 0.9485,
              "z": 0.67372
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100814255"
          },
          {
            "id": "679afb3f3d9bab0f83ff681b",
            "leftCorner": {
              "x": 35.863,
              "y": 0.9485,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.768,
              "y": 0.94732,
              "z": 0.67372
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100814231"
          },
          {
            "id": "679afb3f3d9bab0f83ff681c",
            "leftCorner": {
              "x": 35.768,
              "y": 0.94732,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.695,
              "y": 0.9464,
              "z": 0.67372
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447332186"
          },
          {
            "id": "679afb3f3d9bab0f83ff681d",
            "leftCorner": {
              "x": 35.695,
              "y": 0.9464,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.623,
              "y": 0.9455,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332186"
          },
          {
            "id": "679afb3f3d9bab0f83ff681e",
            "leftCorner": {
              "x": 35.623,
              "y": 0.9455,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.546,
              "y": 0.94453,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332155"
          },
          {
            "id": "679afb3f3d9bab0f83ff681f",
            "leftCorner": {
              "x": 35.546,
              "y": 0.94453,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.466,
              "y": 0.94352,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4002441018268"
          },
          {
            "id": "679afb3f3d9bab0f83ff6820",
            "leftCorner": {
              "x": 35.466,
              "y": 0.94352,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.38,
              "y": 0.94244,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541152328"
          },
          {
            "id": "679afb3f3d9bab0f83ff6821",
            "leftCorner": {
              "x": 35.38,
              "y": 0.94244,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.302,
              "y": 0.94146,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600521188217"
          },
          {
            "id": "679afb3f3d9bab0f83ff6822",
            "leftCorner": {
              "x": 35.302,
              "y": 0.94146,
              "z": 0.67372
            },
            "rightCorner": {
              "x": 35.208,
              "y": 0.94028,
              "z": 0.67372
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600520982557"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ade9",
        "height": 0.92344,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6830",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95721,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.408,
              "y": 0.95632,
              "z": 0.92344
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100324822"
          },
          {
            "id": "679afb3f3d9bab0f83ff6832",
            "leftCorner": {
              "x": 36.408,
              "y": 0.95632,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.336,
              "y": 0.95541,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324822"
          },
          {
            "id": "679afb3f3d9bab0f83ff6833",
            "leftCorner": {
              "x": 36.336,
              "y": 0.95541,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.262,
              "y": 0.95449,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324389"
          },
          {
            "id": "679afb3f3d9bab0f83ff6834",
            "leftCorner": {
              "x": 36.262,
              "y": 0.95449,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.19,
              "y": 0.95359,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100802313"
          },
          {
            "id": "679afb3f3d9bab0f83ff6835",
            "leftCorner": {
              "x": 36.19,
              "y": 0.95359,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.121,
              "y": 0.95272,
              "z": 0.92344
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015100324020"
          },
          {
            "id": "679afb3f3d9bab0f83ff6836",
            "leftCorner": {
              "x": 36.121,
              "y": 0.95272,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 36.023,
              "y": 0.95149,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100311150"
          },
          {
            "id": "679afb3f3d9bab0f83ff6837",
            "leftCorner": {
              "x": 36.023,
              "y": 0.95149,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.932,
              "y": 0.95034,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100311150"
          },
          {
            "id": "679afb3f3d9bab0f83ff6838",
            "leftCorner": {
              "x": 35.932,
              "y": 0.95034,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.837,
              "y": 0.94915,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100339895"
          },
          {
            "id": "679afb3f3d9bab0f83ff6839",
            "leftCorner": {
              "x": 35.837,
              "y": 0.94915,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.743,
              "y": 0.94797,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100311013"
          },
          {
            "id": "679afb3f3d9bab0f83ff683a",
            "leftCorner": {
              "x": 35.743,
              "y": 0.94797,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.638,
              "y": 0.94665,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250703"
          },
          {
            "id": "679afb3f3d9bab0f83ff683b",
            "leftCorner": {
              "x": 35.638,
              "y": 0.94665,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.527,
              "y": 0.94525,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250406"
          },
          {
            "id": "679afb3f3d9bab0f83ff683c",
            "leftCorner": {
              "x": 35.527,
              "y": 0.94525,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.421,
              "y": 0.94392,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542222693"
          },
          {
            "id": "679afb3f3d9bab0f83ff683d",
            "leftCorner": {
              "x": 35.421,
              "y": 0.94392,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.322,
              "y": 0.94268,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250253"
          },
          {
            "id": "679afb3f3d9bab0f83ff683e",
            "leftCorner": {
              "x": 35.322,
              "y": 0.94268,
              "z": 0.92344
            },
            "rightCorner": {
              "x": 35.212,
              "y": 0.9413,
              "z": 0.92344
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250154"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adec",
        "height": 1.1784,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6886",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95891,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.411,
              "y": 0.95806,
              "z": 1.1784
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100814897"
          },
          {
            "id": "679afb3f3d9bab0f83ff6888",
            "leftCorner": {
              "x": 36.411,
              "y": 0.95806,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.335,
              "y": 0.95711,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100814897"
          },
          {
            "id": "679afb3f3d9bab0f83ff6889",
            "leftCorner": {
              "x": 36.335,
              "y": 0.95711,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.264,
              "y": 0.95621,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324105"
          },
          {
            "id": "679afb3f3d9bab0f83ff688a",
            "leftCorner": {
              "x": 36.264,
              "y": 0.95621,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.191,
              "y": 0.95529,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324549"
          },
          {
            "id": "679afb3f3d9bab0f83ff688b",
            "leftCorner": {
              "x": 36.191,
              "y": 0.95529,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.112,
              "y": 0.95431,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324549"
          },
          {
            "id": "679afb3f3d9bab0f83ff688c",
            "leftCorner": {
              "x": 36.112,
              "y": 0.95431,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 36.038,
              "y": 0.95338,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324440"
          },
          {
            "id": "679afb3f3d9bab0f83ff688d",
            "leftCorner": {
              "x": 36.038,
              "y": 0.95338,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.952,
              "y": 0.95229,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100310979"
          },
          {
            "id": "679afb3f3d9bab0f83ff688e",
            "leftCorner": {
              "x": 35.952,
              "y": 0.95229,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.853,
              "y": 0.95105,
              "z": 1.1784
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100311174"
          },
          {
            "id": "679afb3f3d9bab0f83ff688f",
            "leftCorner": {
              "x": 35.853,
              "y": 0.95105,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.758,
              "y": 0.94985,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100311037"
          },
          {
            "id": "679afb3f3d9bab0f83ff6890",
            "leftCorner": {
              "x": 35.758,
              "y": 0.94985,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.652,
              "y": 0.94853,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250505"
          },
          {
            "id": "679afb3f3d9bab0f83ff6891",
            "leftCorner": {
              "x": 35.652,
              "y": 0.94853,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.544,
              "y": 0.94717,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541593718"
          },
          {
            "id": "679afb3f3d9bab0f83ff6892",
            "leftCorner": {
              "x": 35.544,
              "y": 0.94717,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.415,
              "y": 0.94555,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541319271"
          },
          {
            "id": "679afb3f3d9bab0f83ff6893",
            "leftCorner": {
              "x": 35.415,
              "y": 0.94555,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.321,
              "y": 0.94437,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250604"
          },
          {
            "id": "679afb3f3d9bab0f83ff6894",
            "leftCorner": {
              "x": 35.321,
              "y": 0.94437,
              "z": 1.1784
            },
            "rightCorner": {
              "x": 35.219,
              "y": 0.94309,
              "z": 1.1784
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542447461"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adeb",
        "height": 1.4298,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff686a",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95391,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.408,
              "y": 0.95302,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100324006"
          },
          {
            "id": "679afb3f3d9bab0f83ff686c",
            "leftCorner": {
              "x": 36.408,
              "y": 0.95302,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.334,
              "y": 0.9521,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100452273"
          },
          {
            "id": "679afb3f3d9bab0f83ff686d",
            "leftCorner": {
              "x": 36.334,
              "y": 0.9521,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.261,
              "y": 0.95117,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324488"
          },
          {
            "id": "679afb3f3d9bab0f83ff686e",
            "leftCorner": {
              "x": 36.261,
              "y": 0.95117,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.189,
              "y": 0.95028,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100802337"
          },
          {
            "id": "679afb3f3d9bab0f83ff686f",
            "leftCorner": {
              "x": 36.189,
              "y": 0.95028,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.112,
              "y": 0.9493,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324402"
          },
          {
            "id": "679afb3f3d9bab0f83ff6870",
            "leftCorner": {
              "x": 36.112,
              "y": 0.9493,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 36.033,
              "y": 0.94832,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324907"
          },
          {
            "id": "679afb3f3d9bab0f83ff6871",
            "leftCorner": {
              "x": 36.033,
              "y": 0.94832,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.945,
              "y": 0.9472,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100310917"
          },
          {
            "id": "679afb3f3d9bab0f83ff6872",
            "leftCorner": {
              "x": 35.945,
              "y": 0.9472,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.849,
              "y": 0.946,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100311136"
          },
          {
            "id": "679afb3f3d9bab0f83ff6873",
            "leftCorner": {
              "x": 35.849,
              "y": 0.946,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.752,
              "y": 0.94478,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100747829"
          },
          {
            "id": "679afb3f3d9bab0f83ff6874",
            "leftCorner": {
              "x": 35.752,
              "y": 0.94478,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.651,
              "y": 0.94351,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541251007"
          },
          {
            "id": "679afb3f3d9bab0f83ff6875",
            "leftCorner": {
              "x": 35.651,
              "y": 0.94351,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.542,
              "y": 0.94215,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600542541817"
          },
          {
            "id": "679afb3f3d9bab0f83ff6876",
            "leftCorner": {
              "x": 35.542,
              "y": 0.94215,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.431,
              "y": 0.94075,
              "z": 1.4298
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600541250956"
          },
          {
            "id": "679afb3f3d9bab0f83ff6877",
            "leftCorner": {
              "x": 35.431,
              "y": 0.94075,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.327,
              "y": 0.93945,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250857"
          },
          {
            "id": "679afb3f3d9bab0f83ff6878",
            "leftCorner": {
              "x": 35.327,
              "y": 0.93945,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.225,
              "y": 0.93816,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541250758"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3aded",
        "height": 1.6834,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68a1",
            "leftCorner": {
              "x": 36.479,
              "y": 0.95271,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 36.404,
              "y": 0.95177,
              "z": 1.6834
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100324983"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a3",
            "leftCorner": {
              "x": 36.404,
              "y": 0.95177,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 36.328,
              "y": 0.95081,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324983"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a4",
            "leftCorner": {
              "x": 36.328,
              "y": 0.95081,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 36.258,
              "y": 0.94994,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100324983"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a5",
            "leftCorner": {
              "x": 36.258,
              "y": 0.94994,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 36.184,
              "y": 0.94901,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100452297"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a6",
            "leftCorner": {
              "x": 36.184,
              "y": 0.94901,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 36.085,
              "y": 0.94776,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100325065"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a7",
            "leftCorner": {
              "x": 36.085,
              "y": 0.94776,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.993,
              "y": 0.9466,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100310931"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a8",
            "leftCorner": {
              "x": 35.993,
              "y": 0.9466,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.901,
              "y": 0.94545,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100310832"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a9",
            "leftCorner": {
              "x": 35.901,
              "y": 0.94545,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.804,
              "y": 0.94423,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100724103"
          },
          {
            "id": "679afb3f3d9bab0f83ff68aa",
            "leftCorner": {
              "x": 35.804,
              "y": 0.94423,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.701,
              "y": 0.94293,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541910812"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ab",
            "leftCorner": {
              "x": 35.701,
              "y": 0.94293,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.591,
              "y": 0.94155,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600541251052"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ac",
            "leftCorner": {
              "x": 35.591,
              "y": 0.94155,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.488,
              "y": 0.94027,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542574228"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ad",
            "leftCorner": {
              "x": 35.488,
              "y": 0.94027,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.383,
              "y": 0.93894,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542573863"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ae",
            "leftCorner": {
              "x": 35.383,
              "y": 0.93894,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.287,
              "y": 0.93774,
              "z": 1.6834
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524128821"
          },
          {
            "id": "679afb3f3d9bab0f83ff68af",
            "leftCorner": {
              "x": 35.287,
              "y": 0.93774,
              "z": 1.6834
            },
            "rightCorner": {
              "x": 35.229,
              "y": 0.93701,
              "z": 1.6834
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600524128838"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 5,
      "hasStockCount": 80,
      "unknownStockCount": 14
    },
    "name": "QIPB",
    "rightNeighborShelfId": "4JWJ"
  },
  {
    "id": "4JWJ",
    "x": 35.236,
    "y": 0.95291,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99996,
      "w": 0.0091194
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adf4",
        "height": 0.1615,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff680b",
            "leftCorner": {
              "x": 35.206,
              "y": 1.0513,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 35.132,
              "y": 1.0527,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100817065"
          },
          {
            "id": "679afb3f3d9bab0f83ff680c",
            "leftCorner": {
              "x": 35.132,
              "y": 1.0527,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 35.095,
              "y": 1.0533,
              "z": 0.1615
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100817065"
          },
          {
            "id": "679afb3f3d9bab0f83ff680d",
            "leftCorner": {
              "x": 35.095,
              "y": 1.0533,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 35.005,
              "y": 1.055,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816884"
          },
          {
            "id": "679afb3f3d9bab0f83ff680e",
            "leftCorner": {
              "x": 35.005,
              "y": 1.055,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.918,
              "y": 1.0566,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816860"
          },
          {
            "id": "679afb3f3d9bab0f83ff680f",
            "leftCorner": {
              "x": 34.918,
              "y": 1.0566,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.822,
              "y": 1.0583,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5057566628075"
          },
          {
            "id": "679afb3f3d9bab0f83ff6810",
            "leftCorner": {
              "x": 34.822,
              "y": 1.0583,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.712,
              "y": 1.0603,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059186101519"
          },
          {
            "id": "679afb3f3d9bab0f83ff6811",
            "leftCorner": {
              "x": 34.712,
              "y": 1.0603,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.617,
              "y": 1.0621,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4059186101939"
          },
          {
            "id": "679afb3f3d9bab0f83ff6812",
            "leftCorner": {
              "x": 34.617,
              "y": 1.0621,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.518,
              "y": 1.0638,
              "z": 0.1615
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100803068"
          },
          {
            "id": "679afb3f3d9bab0f83ff6813",
            "leftCorner": {
              "x": 34.518,
              "y": 1.0638,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.463,
              "y": 1.0649,
              "z": 0.1615
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015000529136"
          },
          {
            "id": "679afb3f3d9bab0f83ff67fc",
            "leftCorner": {
              "x": 34.463,
              "y": 1.0649,
              "z": 0.1615
            },
            "rightCorner": {
              "x": 34.238,
              "y": 1.069,
              "z": 0.1615
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4015000529150"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf1",
        "height": 0.4195,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff685d",
            "leftCorner": {
              "x": 35.215,
              "y": 0.9406,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 35.132,
              "y": 0.94211,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100763744"
          },
          {
            "id": "679afb3f3d9bab0f83ff685e",
            "leftCorner": {
              "x": 35.132,
              "y": 0.94211,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 35.085,
              "y": 0.94297,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816983"
          },
          {
            "id": "679afb3f3d9bab0f83ff685f",
            "leftCorner": {
              "x": 35.085,
              "y": 0.94297,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 35.057,
              "y": 0.94348,
              "z": 0.4195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816983"
          },
          {
            "id": "679afb3f3d9bab0f83ff6860",
            "leftCorner": {
              "x": 35.057,
              "y": 0.94348,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 35.026,
              "y": 0.94404,
              "z": 0.4195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816983"
          },
          {
            "id": "679afb3f3d9bab0f83ff6861",
            "leftCorner": {
              "x": 35.026,
              "y": 0.94404,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.988,
              "y": 0.94474,
              "z": 0.4195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100816983"
          },
          {
            "id": "679afb3f3d9bab0f83ff6862",
            "leftCorner": {
              "x": 34.988,
              "y": 0.94474,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.918,
              "y": 0.94602,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816969"
          },
          {
            "id": "679afb3f3d9bab0f83ff6863",
            "leftCorner": {
              "x": 34.918,
              "y": 0.94602,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.825,
              "y": 0.94771,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816921"
          },
          {
            "id": "679afb3f3d9bab0f83ff6864",
            "leftCorner": {
              "x": 34.825,
              "y": 0.94771,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.731,
              "y": 0.94943,
              "z": 0.4195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100817164"
          },
          {
            "id": "679afb3f3d9bab0f83ff6865",
            "leftCorner": {
              "x": 34.731,
              "y": 0.94943,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.66,
              "y": 0.95072,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100728880"
          },
          {
            "id": "679afb3f3d9bab0f83ff6866",
            "leftCorner": {
              "x": 34.66,
              "y": 0.95072,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.568,
              "y": 0.9524,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100802948"
          },
          {
            "id": "679afb3f3d9bab0f83ff6867",
            "leftCorner": {
              "x": 34.568,
              "y": 0.9524,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.471,
              "y": 0.95417,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100432275"
          },
          {
            "id": "679afb3f3d9bab0f83ff6868",
            "leftCorner": {
              "x": 34.471,
              "y": 0.95417,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.377,
              "y": 0.95588,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100432312"
          },
          {
            "id": "679afb3f3d9bab0f83ff6869",
            "leftCorner": {
              "x": 34.377,
              "y": 0.95588,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.305,
              "y": 0.9572,
              "z": 0.4195
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100192223"
          },
          {
            "id": "679afb3f3d9bab0f83ff684f",
            "leftCorner": {
              "x": 34.305,
              "y": 0.9572,
              "z": 0.4195
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.95846,
              "z": 0.4195
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100192247"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adee",
        "height": 0.67273,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6823",
            "leftCorner": {
              "x": 35.214,
              "y": 0.9376,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 35.148,
              "y": 0.9388,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447671315"
          },
          {
            "id": "679afb3f3d9bab0f83ff6824",
            "leftCorner": {
              "x": 35.148,
              "y": 0.9388,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 35.101,
              "y": 0.93966,
              "z": 0.67273
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447711462"
          },
          {
            "id": "679afb3f3d9bab0f83ff6825",
            "leftCorner": {
              "x": 35.101,
              "y": 0.93966,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 35.073,
              "y": 0.94018,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447711462"
          },
          {
            "id": "679afb3f3d9bab0f83ff6826",
            "leftCorner": {
              "x": 35.073,
              "y": 0.94018,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 35.033,
              "y": 0.9409,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172934384"
          },
          {
            "id": "679afb3f3d9bab0f83ff6827",
            "leftCorner": {
              "x": 35.033,
              "y": 0.9409,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.987,
              "y": 0.94174,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172934407"
          },
          {
            "id": "679afb3f3d9bab0f83ff6828",
            "leftCorner": {
              "x": 34.987,
              "y": 0.94174,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.915,
              "y": 0.94306,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172934421"
          },
          {
            "id": "679afb3f3d9bab0f83ff6829",
            "leftCorner": {
              "x": 34.915,
              "y": 0.94306,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.783,
              "y": 0.94546,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100215205"
          },
          {
            "id": "679afb3f3d9bab0f83ff682a",
            "leftCorner": {
              "x": 34.783,
              "y": 0.94546,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.658,
              "y": 0.94774,
              "z": 0.67273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100215168"
          },
          {
            "id": "679afb3f3d9bab0f83ff682b",
            "leftCorner": {
              "x": 34.658,
              "y": 0.94774,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.595,
              "y": 0.94889,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100215182"
          },
          {
            "id": "679afb3f3d9bab0f83ff682c",
            "leftCorner": {
              "x": 34.595,
              "y": 0.94889,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.53,
              "y": 0.95009,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260075603"
          },
          {
            "id": "679afb3f3d9bab0f83ff682d",
            "leftCorner": {
              "x": 34.53,
              "y": 0.95009,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.455,
              "y": 0.95144,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260075610"
          },
          {
            "id": "679afb3f3d9bab0f83ff682e",
            "leftCorner": {
              "x": 34.455,
              "y": 0.95144,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.387,
              "y": 0.95269,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4104260075610"
          },
          {
            "id": "679afb3f3d9bab0f83ff682f",
            "leftCorner": {
              "x": 34.387,
              "y": 0.95269,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.308,
              "y": 0.95413,
              "z": 0.67273
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9003877906483"
          },
          {
            "id": "679afb3f3d9bab0f83ff6815",
            "leftCorner": {
              "x": 34.308,
              "y": 0.95413,
              "z": 0.67273
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.95545,
              "z": 0.67273
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9003877906476"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adef",
        "height": 0.9232,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff683f",
            "leftCorner": {
              "x": 35.219,
              "y": 0.93838,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 35.147,
              "y": 0.93968,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816341"
          },
          {
            "id": "679afb3f3d9bab0f83ff6840",
            "leftCorner": {
              "x": 35.147,
              "y": 0.93968,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 35.068,
              "y": 0.94112,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816365"
          },
          {
            "id": "679afb3f3d9bab0f83ff6841",
            "leftCorner": {
              "x": 35.068,
              "y": 0.94112,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.995,
              "y": 0.94245,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816402"
          },
          {
            "id": "679afb3f3d9bab0f83ff6842",
            "leftCorner": {
              "x": 34.995,
              "y": 0.94245,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.921,
              "y": 0.94381,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816426"
          },
          {
            "id": "679afb3f3d9bab0f83ff6843",
            "leftCorner": {
              "x": 34.921,
              "y": 0.94381,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.842,
              "y": 0.94525,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524043834"
          },
          {
            "id": "679afb3f3d9bab0f83ff6844",
            "leftCorner": {
              "x": 34.842,
              "y": 0.94525,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.763,
              "y": 0.94669,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524043636"
          },
          {
            "id": "679afb3f3d9bab0f83ff6845",
            "leftCorner": {
              "x": 34.763,
              "y": 0.94669,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.685,
              "y": 0.94811,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524043537"
          },
          {
            "id": "679afb3f3d9bab0f83ff6846",
            "leftCorner": {
              "x": 34.685,
              "y": 0.94811,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.643,
              "y": 0.94888,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523193189"
          },
          {
            "id": "679afb3f3d9bab0f83ff6847",
            "leftCorner": {
              "x": 34.643,
              "y": 0.94888,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.601,
              "y": 0.94964,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523193196"
          },
          {
            "id": "679afb3f3d9bab0f83ff6848",
            "leftCorner": {
              "x": 34.601,
              "y": 0.94964,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.561,
              "y": 0.95037,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523193202"
          },
          {
            "id": "679afb3f3d9bab0f83ff6849",
            "leftCorner": {
              "x": 34.561,
              "y": 0.95037,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.509,
              "y": 0.95132,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600524026264"
          },
          {
            "id": "679afb3f3d9bab0f83ff684a",
            "leftCorner": {
              "x": 34.509,
              "y": 0.95132,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.46,
              "y": 0.95221,
              "z": 0.9232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "3600523193219"
          },
          {
            "id": "679afb3f3d9bab0f83ff684b",
            "leftCorner": {
              "x": 34.46,
              "y": 0.95221,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.373,
              "y": 0.95381,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600523193226"
          },
          {
            "id": "679afb3f3d9bab0f83ff684c",
            "leftCorner": {
              "x": 34.373,
              "y": 0.95381,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.326,
              "y": 0.95465,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120064451684"
          },
          {
            "id": "679afb3f3d9bab0f83ff684d",
            "leftCorner": {
              "x": 34.326,
              "y": 0.95465,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.28,
              "y": 0.95551,
              "z": 0.9232
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "9120064451677"
          },
          {
            "id": "679afb3f3d9bab0f83ff6831",
            "leftCorner": {
              "x": 34.28,
              "y": 0.95551,
              "z": 0.9232
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.95631,
              "z": 0.9232
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9120064451660"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf3",
        "height": 1.1779,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6895",
            "leftCorner": {
              "x": 35.206,
              "y": 0.94116,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 35.149,
              "y": 0.9422,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089000495"
          },
          {
            "id": "679afb3f3d9bab0f83ff6896",
            "leftCorner": {
              "x": 35.149,
              "y": 0.9422,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 35.079,
              "y": 0.94347,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089000501"
          },
          {
            "id": "679afb3f3d9bab0f83ff6897",
            "leftCorner": {
              "x": 35.079,
              "y": 0.94347,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 35.042,
              "y": 0.94415,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4025089000518"
          },
          {
            "id": "679afb3f3d9bab0f83ff6898",
            "leftCorner": {
              "x": 35.042,
              "y": 0.94415,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 35.009,
              "y": 0.94475,
              "z": 1.1779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4025089000518"
          },
          {
            "id": "679afb3f3d9bab0f83ff6899",
            "leftCorner": {
              "x": 35.009,
              "y": 0.94475,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.898,
              "y": 0.94678,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542563765"
          },
          {
            "id": "679afb3f3d9bab0f83ff689a",
            "leftCorner": {
              "x": 34.898,
              "y": 0.94678,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.782,
              "y": 0.94889,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542563758"
          },
          {
            "id": "679afb3f3d9bab0f83ff689b",
            "leftCorner": {
              "x": 34.782,
              "y": 0.94889,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.671,
              "y": 0.95092,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542563741"
          },
          {
            "id": "679afb3f3d9bab0f83ff689c",
            "leftCorner": {
              "x": 34.671,
              "y": 0.95092,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.557,
              "y": 0.95299,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542563734"
          },
          {
            "id": "679afb3f3d9bab0f83ff689d",
            "leftCorner": {
              "x": 34.557,
              "y": 0.95299,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.433,
              "y": 0.95526,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3600542563727"
          },
          {
            "id": "679afb3f3d9bab0f83ff689e",
            "leftCorner": {
              "x": 34.433,
              "y": 0.95526,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.392,
              "y": 0.95601,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42447603"
          },
          {
            "id": "679afb3f3d9bab0f83ff689f",
            "leftCorner": {
              "x": 34.392,
              "y": 0.95601,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.352,
              "y": 0.95674,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42447603"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a0",
            "leftCorner": {
              "x": 34.352,
              "y": 0.95674,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.315,
              "y": 0.95742,
              "z": 1.1779
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "42447597"
          },
          {
            "id": "679afb3f3d9bab0f83ff6887",
            "leftCorner": {
              "x": 34.315,
              "y": 0.95742,
              "z": 1.1779
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.95886,
              "z": 1.1779
            },
            "stockLevel": "UNKNOWN",
            "gtin": "42447573"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf0",
        "height": 1.4299,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6879",
            "leftCorner": {
              "x": 35.225,
              "y": 0.93816,
              "z": 1.4298
            },
            "rightCorner": {
              "x": 35.147,
              "y": 0.93718,
              "z": 1.4298
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332001"
          },
          {
            "id": "679afb3f3d9bab0f83ff687a",
            "leftCorner": {
              "x": 35.153,
              "y": 0.93787,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 35.075,
              "y": 0.93928,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447332032"
          },
          {
            "id": "679afb3f3d9bab0f83ff687b",
            "leftCorner": {
              "x": 35.075,
              "y": 0.93928,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 35.035,
              "y": 0.94001,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331141"
          },
          {
            "id": "679afb3f3d9bab0f83ff687c",
            "leftCorner": {
              "x": 35.035,
              "y": 0.94001,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 35.003,
              "y": 0.94061,
              "z": 1.4299
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331141"
          },
          {
            "id": "679afb3f3d9bab0f83ff687d",
            "leftCorner": {
              "x": 35.003,
              "y": 0.94061,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.932,
              "y": 0.94189,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331110"
          },
          {
            "id": "679afb3f3d9bab0f83ff687e",
            "leftCorner": {
              "x": 34.932,
              "y": 0.94189,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.865,
              "y": 0.94313,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331974"
          },
          {
            "id": "679afb3f3d9bab0f83ff687f",
            "leftCorner": {
              "x": 34.865,
              "y": 0.94313,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.792,
              "y": 0.94445,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331882"
          },
          {
            "id": "679afb3f3d9bab0f83ff6880",
            "leftCorner": {
              "x": 34.792,
              "y": 0.94445,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.721,
              "y": 0.94575,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331790"
          },
          {
            "id": "679afb3f3d9bab0f83ff6881",
            "leftCorner": {
              "x": 34.721,
              "y": 0.94575,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.652,
              "y": 0.947,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331943"
          },
          {
            "id": "679afb3f3d9bab0f83ff6882",
            "leftCorner": {
              "x": 34.652,
              "y": 0.947,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.583,
              "y": 0.94826,
              "z": 1.4299
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447331769"
          },
          {
            "id": "679afb3f3d9bab0f83ff6883",
            "leftCorner": {
              "x": 34.583,
              "y": 0.94826,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.505,
              "y": 0.94969,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331820"
          },
          {
            "id": "679afb3f3d9bab0f83ff6884",
            "leftCorner": {
              "x": 34.505,
              "y": 0.94969,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.434,
              "y": 0.95098,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331912"
          },
          {
            "id": "679afb3f3d9bab0f83ff6885",
            "leftCorner": {
              "x": 34.434,
              "y": 0.95098,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.361,
              "y": 0.95232,
              "z": 1.4299
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447331851"
          },
          {
            "id": "679afb3f3d9bab0f83ff686b",
            "leftCorner": {
              "x": 34.361,
              "y": 0.95232,
              "z": 1.4299
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.9546,
              "z": 1.4299
            },
            "stockLevel": "UNKNOWN",
            "gtin": "9002422106927"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf2",
        "height": 1.6835,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68b0",
            "leftCorner": {
              "x": 35.235,
              "y": 0.93396,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 35.137,
              "y": 0.93272,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447719192"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b1",
            "leftCorner": {
              "x": 35.137,
              "y": 0.93575,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.763,
              "y": 0.94257,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100738124"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b2",
            "leftCorner": {
              "x": 34.763,
              "y": 0.94257,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.663,
              "y": 0.9444,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100816563"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b3",
            "leftCorner": {
              "x": 34.663,
              "y": 0.9444,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.573,
              "y": 0.94605,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172938344"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b4",
            "leftCorner": {
              "x": 34.573,
              "y": 0.94605,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.475,
              "y": 0.94782,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100811957"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b5",
            "leftCorner": {
              "x": 34.475,
              "y": 0.94782,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.415,
              "y": 0.94892,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100732719"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b6",
            "leftCorner": {
              "x": 34.415,
              "y": 0.94892,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.355,
              "y": 0.95002,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100732757"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b7",
            "leftCorner": {
              "x": 34.355,
              "y": 0.95002,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.299,
              "y": 0.95105,
              "z": 1.6835
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4015100732733"
          },
          {
            "id": "679afb3f3d9bab0f83ff68a2",
            "leftCorner": {
              "x": 34.299,
              "y": 0.95105,
              "z": 1.6835
            },
            "rightCorner": {
              "x": 34.236,
              "y": 0.9522,
              "z": 1.6835
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4015100732771"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 71,
      "unknownStockCount": 16
    },
    "name": "4JWJ",
    "leftNeighborShelfId": "QIPB",
    "rightNeighborShelfId": "MK6Q"
  },
  {
    "id": "MK6Q",
    "x": 33.242,
    "y": 0.97598,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": 0.0037442
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3adf8",
        "height": 0.16267,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68c8",
            "leftCorner": {
              "x": 33.243,
              "y": 1.078,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 33.005,
              "y": 1.0798,
              "z": 0.16267
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447052367"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ca",
            "leftCorner": {
              "x": 33.005,
              "y": 1.0798,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 32.78,
              "y": 1.0815,
              "z": 0.16267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447676525"
          },
          {
            "id": "679afb3f3d9bab0f83ff68cb",
            "leftCorner": {
              "x": 32.78,
              "y": 1.0815,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 32.603,
              "y": 1.0828,
              "z": 0.16267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447562019"
          },
          {
            "id": "679afb3f3d9bab0f83ff68cc",
            "leftCorner": {
              "x": 32.603,
              "y": 1.0828,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 32.438,
              "y": 1.084,
              "z": 0.16267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447676419"
          },
          {
            "id": "679afb3f3d9bab0f83ff68cd",
            "leftCorner": {
              "x": 32.438,
              "y": 1.084,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 32.296,
              "y": 1.0851,
              "z": 0.16267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447505528"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c9",
            "leftCorner": {
              "x": 32.296,
              "y": 1.0851,
              "z": 0.16267
            },
            "rightCorner": {
              "x": 32.243,
              "y": 1.0855,
              "z": 0.16267
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf6",
        "height": 0.5095,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68c0",
            "leftCorner": {
              "x": 33.242,
              "y": 0.96691,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 33.002,
              "y": 0.9687,
              "z": 0.5095
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447380873"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c2",
            "leftCorner": {
              "x": 33.002,
              "y": 0.9687,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 32.788,
              "y": 0.97031,
              "z": 0.5095
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447381283"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c3",
            "leftCorner": {
              "x": 32.788,
              "y": 0.97031,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 32.628,
              "y": 0.97151,
              "z": 0.5095
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447676662"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c4",
            "leftCorner": {
              "x": 32.628,
              "y": 0.97151,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 32.471,
              "y": 0.97268,
              "z": 0.5095
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447485110"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c5",
            "leftCorner": {
              "x": 32.471,
              "y": 0.97268,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 32.334,
              "y": 0.97371,
              "z": 0.5095
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447725933"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c1",
            "leftCorner": {
              "x": 32.334,
              "y": 0.97371,
              "z": 0.5095
            },
            "rightCorner": {
              "x": 32.242,
              "y": 0.9744,
              "z": 0.5095
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172516092"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf5",
        "height": 0.84507,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68b8",
            "leftCorner": {
              "x": 33.242,
              "y": 0.9658,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 33.082,
              "y": 0.967,
              "z": 0.84507
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447052893"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ba",
            "leftCorner": {
              "x": 33.082,
              "y": 0.967,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.949,
              "y": 0.968,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447052787"
          },
          {
            "id": "679afb3f3d9bab0f83ff68bb",
            "leftCorner": {
              "x": 32.949,
              "y": 0.968,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.818,
              "y": 0.96898,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447561890"
          },
          {
            "id": "679afb3f3d9bab0f83ff68bc",
            "leftCorner": {
              "x": 32.818,
              "y": 0.96898,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.653,
              "y": 0.97022,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172791307"
          },
          {
            "id": "679afb3f3d9bab0f83ff68bd",
            "leftCorner": {
              "x": 32.653,
              "y": 0.97022,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.53,
              "y": 0.97114,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447561920"
          },
          {
            "id": "679afb3f3d9bab0f83ff68be",
            "leftCorner": {
              "x": 32.53,
              "y": 0.97114,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.418,
              "y": 0.97198,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447441208"
          },
          {
            "id": "679afb3f3d9bab0f83ff68bf",
            "leftCorner": {
              "x": 32.418,
              "y": 0.97198,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.311,
              "y": 0.97278,
              "z": 0.84507
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447504958"
          },
          {
            "id": "679afb3f3d9bab0f83ff68b9",
            "leftCorner": {
              "x": 32.311,
              "y": 0.97278,
              "z": 0.84507
            },
            "rightCorner": {
              "x": 32.242,
              "y": 0.97329,
              "z": 0.84507
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf9",
        "height": 1.3344,
        "facings": []
      },
      {
        "id": "679aebdc1f3fd8b81ad3adf7",
        "height": 1.5476,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68c6",
            "leftCorner": {
              "x": 33.242,
              "y": 0.94002,
              "z": 1.5476
            },
            "rightCorner": {
              "x": 32.424,
              "y": 0.94614,
              "z": 1.5476
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7638900248357"
          },
          {
            "id": "679afb3f3d9bab0f83ff68c7",
            "leftCorner": {
              "x": 32.424,
              "y": 0.94614,
              "z": 1.5476
            },
            "rightCorner": {
              "x": 32.242,
              "y": 0.94751,
              "z": 1.5476
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7638900379914"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adfa",
        "height": 1.7603,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68ce",
            "leftCorner": {
              "x": 33.242,
              "y": 0.93518,
              "z": 1.7603
            },
            "rightCorner": {
              "x": 33.038,
              "y": 0.9367,
              "z": 1.7603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355237347"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d0",
            "leftCorner": {
              "x": 33.038,
              "y": 0.9367,
              "z": 1.7603
            },
            "rightCorner": {
              "x": 32.947,
              "y": 0.93738,
              "z": 1.7603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff68cf",
            "leftCorner": {
              "x": 32.947,
              "y": 0.93738,
              "z": 1.7603
            },
            "rightCorner": {
              "x": 32.242,
              "y": 0.94267,
              "z": 1.7603
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7638900248333"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adfb",
        "height": 1.9631,
        "facings": []
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 14,
      "unknownStockCount": 11
    },
    "name": "MK6Q",
    "leftNeighborShelfId": "4JWJ",
    "rightNeighborShelfId": "X4KW"
  },
  {
    "id": "X4KW",
    "x": 23.255,
    "y": 1.0276,
    "width": 1,
    "height": 2,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": 0.0023684
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae01",
        "height": 0.20337,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68fb",
            "leftCorner": {
              "x": 23.255,
              "y": 1.127,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 23.124,
              "y": 1.1276,
              "z": 0.20337
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447642285"
          },
          {
            "id": "679afb3f3d9bab0f83ff68fd",
            "leftCorner": {
              "x": 23.124,
              "y": 1.1276,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 22.888,
              "y": 1.1287,
              "z": 0.20337
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447678734"
          },
          {
            "id": "679afb3f3d9bab0f83ff68fe",
            "leftCorner": {
              "x": 22.888,
              "y": 1.1287,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 22.641,
              "y": 1.1299,
              "z": 0.20337
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642308"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ff",
            "leftCorner": {
              "x": 22.641,
              "y": 1.1299,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 22.509,
              "y": 1.1305,
              "z": 0.20337
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447015799"
          },
          {
            "id": "679afb3f3d9bab0f83ff6900",
            "leftCorner": {
              "x": 22.509,
              "y": 1.1305,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 22.382,
              "y": 1.1311,
              "z": 0.20337
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642346"
          },
          {
            "id": "679afb3f3d9bab0f83ff68fc",
            "leftCorner": {
              "x": 22.382,
              "y": 1.1311,
              "z": 0.20337
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.1317,
              "z": 0.20337
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447642322"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae00",
        "height": 0.50812,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68f4",
            "leftCorner": {
              "x": 23.255,
              "y": 1.0152,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 23.148,
              "y": 1.0157,
              "z": 0.50812
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447642049"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f6",
            "leftCorner": {
              "x": 23.148,
              "y": 1.0157,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.998,
              "y": 1.0164,
              "z": 0.50812
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642087"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f7",
            "leftCorner": {
              "x": 22.998,
              "y": 1.0164,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.848,
              "y": 1.0171,
              "z": 0.50812
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642087"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f8",
            "leftCorner": {
              "x": 22.848,
              "y": 1.0171,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.708,
              "y": 1.0178,
              "z": 0.50812
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642162"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f9",
            "leftCorner": {
              "x": 22.708,
              "y": 1.0178,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.553,
              "y": 1.0185,
              "z": 0.50812
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642186"
          },
          {
            "id": "679afb3f3d9bab0f83ff68fa",
            "leftCorner": {
              "x": 22.553,
              "y": 1.0185,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.402,
              "y": 1.0192,
              "z": 0.50812
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447642025"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f5",
            "leftCorner": {
              "x": 22.402,
              "y": 1.0192,
              "z": 0.50812
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.0199,
              "z": 0.50812
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447642063"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adfc",
        "height": 0.80045,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68d1",
            "leftCorner": {
              "x": 23.255,
              "y": 1.0118,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 23.21,
              "y": 1.012,
              "z": 0.80045
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d3",
            "leftCorner": {
              "x": 23.21,
              "y": 1.012,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 23.054,
              "y": 1.0127,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008871215895"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d4",
            "leftCorner": {
              "x": 23.054,
              "y": 1.0127,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.905,
              "y": 1.0134,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008871215871"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d5",
            "leftCorner": {
              "x": 22.905,
              "y": 1.0134,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.752,
              "y": 1.0142,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008871219060"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d6",
            "leftCorner": {
              "x": 22.752,
              "y": 1.0142,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.653,
              "y": 1.0146,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796082067"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d7",
            "leftCorner": {
              "x": 22.653,
              "y": 1.0146,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.546,
              "y": 1.0151,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796082210"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d8",
            "leftCorner": {
              "x": 22.546,
              "y": 1.0151,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.408,
              "y": 1.0158,
              "z": 0.80045
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796082319"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d2",
            "leftCorner": {
              "x": 22.408,
              "y": 1.0158,
              "z": 0.80045
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.0165,
              "z": 0.80045
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796082296"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adfd",
        "height": 1.0939,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68da",
            "leftCorner": {
              "x": 23.239,
              "y": 1.0086,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 23.14,
              "y": 1.009,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045409113063"
          },
          {
            "id": "679afb3f3d9bab0f83ff68db",
            "leftCorner": {
              "x": 23.14,
              "y": 1.009,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.995,
              "y": 1.0097,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045409113148"
          },
          {
            "id": "679afb3f3d9bab0f83ff68dc",
            "leftCorner": {
              "x": 22.995,
              "y": 1.0097,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.841,
              "y": 1.0104,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4045409113186"
          },
          {
            "id": "679afb3f3d9bab0f83ff68dd",
            "leftCorner": {
              "x": 22.841,
              "y": 1.0104,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.744,
              "y": 1.0109,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447187427"
          },
          {
            "id": "679afb3f3d9bab0f83ff68de",
            "leftCorner": {
              "x": 22.744,
              "y": 1.0109,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.66,
              "y": 1.0113,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355406231"
          },
          {
            "id": "679afb3f3d9bab0f83ff68df",
            "leftCorner": {
              "x": 22.66,
              "y": 1.0113,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.568,
              "y": 1.0117,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355406217"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e0",
            "leftCorner": {
              "x": 22.568,
              "y": 1.0117,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.374,
              "y": 1.0127,
              "z": 1.0939
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172507212"
          },
          {
            "id": "679afb3f3d9bab0f83ff68d9",
            "leftCorner": {
              "x": 22.374,
              "y": 1.0127,
              "z": 1.0939
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.0132,
              "z": 1.0939
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447063714"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adff",
        "height": 1.3911,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68e9",
            "leftCorner": {
              "x": 23.255,
              "y": 1.0069,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 23.198,
              "y": 1.0072,
              "z": 1.3911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172881077"
          },
          {
            "id": "679afb3f3d9bab0f83ff68eb",
            "leftCorner": {
              "x": 23.198,
              "y": 1.0072,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 23.137,
              "y": 1.0075,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447771879"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ec",
            "leftCorner": {
              "x": 23.137,
              "y": 1.0075,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.915,
              "y": 1.0085,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447492101"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ed",
            "leftCorner": {
              "x": 22.915,
              "y": 1.0085,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.842,
              "y": 1.0089,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447678987"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ee",
            "leftCorner": {
              "x": 22.842,
              "y": 1.0089,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.73,
              "y": 1.0094,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447707786"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ef",
            "leftCorner": {
              "x": 22.73,
              "y": 1.0094,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.66,
              "y": 1.0097,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172507021"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f0",
            "leftCorner": {
              "x": 22.66,
              "y": 1.0097,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.568,
              "y": 1.0102,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355406255"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f1",
            "leftCorner": {
              "x": 22.568,
              "y": 1.0102,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.468,
              "y": 1.0107,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355697"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f2",
            "leftCorner": {
              "x": 22.468,
              "y": 1.0107,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.397,
              "y": 1.011,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355772"
          },
          {
            "id": "679afb3f3d9bab0f83ff68f3",
            "leftCorner": {
              "x": 22.397,
              "y": 1.011,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.325,
              "y": 1.0113,
              "z": 1.3911
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447355772"
          },
          {
            "id": "679afb3f3d9bab0f83ff68ea",
            "leftCorner": {
              "x": 22.325,
              "y": 1.0113,
              "z": 1.3911
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.0117,
              "z": 1.3911
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447731682"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3adfe",
        "height": 1.7284,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff68e2",
            "leftCorner": {
              "x": 23.25,
              "y": 1.0092,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 23.126,
              "y": 1.0098,
              "z": 1.7284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447668759"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e3",
            "leftCorner": {
              "x": 23.126,
              "y": 1.0098,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 23.025,
              "y": 1.0103,
              "z": 1.7284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006508204335"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e4",
            "leftCorner": {
              "x": 23.025,
              "y": 1.0103,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.896,
              "y": 1.0109,
              "z": 1.7284
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4006508206810"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e5",
            "leftCorner": {
              "x": 22.896,
              "y": 1.0109,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.733,
              "y": 1.0117,
              "z": 1.7284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4006508123834"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e6",
            "leftCorner": {
              "x": 22.733,
              "y": 1.0117,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.602,
              "y": 1.0123,
              "z": 1.7284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447576658"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e7",
            "leftCorner": {
              "x": 22.602,
              "y": 1.0123,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.452,
              "y": 1.013,
              "z": 1.7284
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172566721"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e8",
            "leftCorner": {
              "x": 22.452,
              "y": 1.013,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.352,
              "y": 1.0135,
              "z": 1.7284
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447374049"
          },
          {
            "id": "679afb3f3d9bab0f83ff68e1",
            "leftCorner": {
              "x": 22.352,
              "y": 1.0135,
              "z": 1.7284
            },
            "rightCorner": {
              "x": 22.255,
              "y": 1.0139,
              "z": 1.7284
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4004060420729"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 36,
      "unknownStockCount": 11
    },
    "name": "X4KW",
    "leftNeighborShelfId": "MK6Q",
    "rightNeighborShelfId": "QPMM"
  },
  {
    "id": "QPMM",
    "x": 21.282,
    "y": 1.0343,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99997,
      "w": -0.0076373
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae08",
        "height": 0.20432,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff697a",
            "leftCorner": {
              "x": 21.28,
              "y": 1.1381,
              "z": 0.20432
            },
            "rightCorner": {
              "x": 21.103,
              "y": 1.1354,
              "z": 0.20432
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008429157196"
          },
          {
            "id": "679afb3f3d9bab0f83ff697c",
            "leftCorner": {
              "x": 21.103,
              "y": 1.1354,
              "z": 0.20432
            },
            "rightCorner": {
              "x": 20.908,
              "y": 1.1325,
              "z": 0.20432
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008429155888"
          },
          {
            "id": "679afb3f3d9bab0f83ff697d",
            "leftCorner": {
              "x": 20.908,
              "y": 1.1325,
              "z": 0.20432
            },
            "rightCorner": {
              "x": 20.707,
              "y": 1.1294,
              "z": 0.20432
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3065890155916"
          },
          {
            "id": "679afb3f3d9bab0f83ff697e",
            "leftCorner": {
              "x": 20.707,
              "y": 1.1294,
              "z": 0.20432
            },
            "rightCorner": {
              "x": 20.017,
              "y": 1.1188,
              "z": 0.20432
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172319686"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae05",
        "height": 0.55103,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6933",
            "leftCorner": {
              "x": 21.282,
              "y": 1.0246,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 21.212,
              "y": 1.0235,
              "z": 0.55103
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6935",
            "leftCorner": {
              "x": 21.212,
              "y": 1.0235,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 21.118,
              "y": 1.022,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447120455"
          },
          {
            "id": "679afb3f3d9bab0f83ff6936",
            "leftCorner": {
              "x": 21.118,
              "y": 1.022,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 21.021,
              "y": 1.0206,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355214188"
          },
          {
            "id": "679afb3f3d9bab0f83ff6937",
            "leftCorner": {
              "x": 21.021,
              "y": 1.0206,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.985,
              "y": 1.02,
              "z": 0.55103
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6938",
            "leftCorner": {
              "x": 20.985,
              "y": 1.02,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.926,
              "y": 1.0191,
              "z": 0.55103
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172589430"
          },
          {
            "id": "679afb3f3d9bab0f83ff6939",
            "leftCorner": {
              "x": 20.926,
              "y": 1.0191,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.827,
              "y": 1.0176,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100321"
          },
          {
            "id": "679afb3f3d9bab0f83ff693a",
            "leftCorner": {
              "x": 20.827,
              "y": 1.0176,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.719,
              "y": 1.016,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100321"
          },
          {
            "id": "679afb3f3d9bab0f83ff693b",
            "leftCorner": {
              "x": 20.719,
              "y": 1.016,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.616,
              "y": 1.0144,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100345"
          },
          {
            "id": "679afb3f3d9bab0f83ff693c",
            "leftCorner": {
              "x": 20.616,
              "y": 1.0144,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.513,
              "y": 1.0128,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213563"
          },
          {
            "id": "679afb3f3d9bab0f83ff693d",
            "leftCorner": {
              "x": 20.513,
              "y": 1.0128,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.412,
              "y": 1.0113,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796062571"
          },
          {
            "id": "679afb3f3d9bab0f83ff693e",
            "leftCorner": {
              "x": 20.412,
              "y": 1.0113,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.318,
              "y": 1.0098,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100109"
          },
          {
            "id": "679afb3f3d9bab0f83ff693f",
            "leftCorner": {
              "x": 20.318,
              "y": 1.0098,
              "z": 0.55103
            },
            "rightCorner": {
              "x": 20.248,
              "y": 1.0088,
              "z": 0.55103
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100109"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae04",
        "height": 0.80077,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff691e",
            "leftCorner": {
              "x": 21.282,
              "y": 1.0211,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 21.209,
              "y": 1.02,
              "z": 0.80077
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7613035754942"
          },
          {
            "id": "679afb3f3d9bab0f83ff6920",
            "leftCorner": {
              "x": 21.209,
              "y": 1.02,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 21.121,
              "y": 1.0187,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613035754942"
          },
          {
            "id": "679afb3f3d9bab0f83ff6921",
            "leftCorner": {
              "x": 21.121,
              "y": 1.0187,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 21.041,
              "y": 1.0175,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613035754614"
          },
          {
            "id": "679afb3f3d9bab0f83ff6922",
            "leftCorner": {
              "x": 21.041,
              "y": 1.0175,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.937,
              "y": 1.0159,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260688858843"
          },
          {
            "id": "679afb3f3d9bab0f83ff6923",
            "leftCorner": {
              "x": 20.937,
              "y": 1.0159,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.842,
              "y": 1.0144,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260688858850"
          },
          {
            "id": "679afb3f3d9bab0f83ff6924",
            "leftCorner": {
              "x": 20.842,
              "y": 1.0144,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.734,
              "y": 1.0128,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4260688858829"
          },
          {
            "id": "679afb3f3d9bab0f83ff6925",
            "leftCorner": {
              "x": 20.734,
              "y": 1.0128,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.63,
              "y": 1.0112,
              "z": 0.80077
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447238488"
          },
          {
            "id": "679afb3f3d9bab0f83ff6926",
            "leftCorner": {
              "x": 20.63,
              "y": 1.0112,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.533,
              "y": 1.0097,
              "z": 0.80077
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447238488"
          },
          {
            "id": "679afb3f3d9bab0f83ff6927",
            "leftCorner": {
              "x": 20.533,
              "y": 1.0097,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.436,
              "y": 1.0082,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238501"
          },
          {
            "id": "679afb3f3d9bab0f83ff6928",
            "leftCorner": {
              "x": 20.436,
              "y": 1.0082,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.337,
              "y": 1.0067,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447295092"
          },
          {
            "id": "679afb3f3d9bab0f83ff6929",
            "leftCorner": {
              "x": 20.337,
              "y": 1.0067,
              "z": 0.80077
            },
            "rightCorner": {
              "x": 20.262,
              "y": 1.0056,
              "z": 0.80077
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447295092"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae03",
        "height": 1.0504,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6908",
            "leftCorner": {
              "x": 21.283,
              "y": 1.0176,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 21.198,
              "y": 1.0163,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100741"
          },
          {
            "id": "679afb3f3d9bab0f83ff6909",
            "leftCorner": {
              "x": 21.198,
              "y": 1.0163,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 21.102,
              "y": 1.0148,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100741"
          },
          {
            "id": "679afb3f3d9bab0f83ff690a",
            "leftCorner": {
              "x": 21.102,
              "y": 1.0148,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 21.009,
              "y": 1.0134,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100758"
          },
          {
            "id": "679afb3f3d9bab0f83ff690b",
            "leftCorner": {
              "x": 21.009,
              "y": 1.0134,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.97,
              "y": 1.0128,
              "z": 1.0504
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447747362"
          },
          {
            "id": "679afb3f3d9bab0f83ff690c",
            "leftCorner": {
              "x": 20.97,
              "y": 1.0128,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.916,
              "y": 1.012,
              "z": 1.0504
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447747362"
          },
          {
            "id": "679afb3f3d9bab0f83ff690d",
            "leftCorner": {
              "x": 20.916,
              "y": 1.012,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.835,
              "y": 1.0108,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172589584"
          },
          {
            "id": "679afb3f3d9bab0f83ff690e",
            "leftCorner": {
              "x": 20.835,
              "y": 1.0108,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.751,
              "y": 1.0095,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100161"
          },
          {
            "id": "679afb3f3d9bab0f83ff690f",
            "leftCorner": {
              "x": 20.751,
              "y": 1.0095,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.646,
              "y": 1.0079,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355556943"
          },
          {
            "id": "679afb3f3d9bab0f83ff6910",
            "leftCorner": {
              "x": 20.646,
              "y": 1.0079,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.552,
              "y": 1.0064,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639883"
          },
          {
            "id": "679afb3f3d9bab0f83ff6911",
            "leftCorner": {
              "x": 20.552,
              "y": 1.0064,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.477,
              "y": 1.0053,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447750768"
          },
          {
            "id": "679afb3f3d9bab0f83ff6912",
            "leftCorner": {
              "x": 20.477,
              "y": 1.0053,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.402,
              "y": 1.0041,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447750744"
          },
          {
            "id": "679afb3f3d9bab0f83ff6913",
            "leftCorner": {
              "x": 20.402,
              "y": 1.0041,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.327,
              "y": 1.003,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172589607"
          },
          {
            "id": "679afb3f3d9bab0f83ff6914",
            "leftCorner": {
              "x": 20.327,
              "y": 1.003,
              "z": 1.0504
            },
            "rightCorner": {
              "x": 20.276,
              "y": 1.0022,
              "z": 1.0504
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100284"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae07",
        "height": 1.3028,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6967",
            "leftCorner": {
              "x": 21.289,
              "y": 1.0165,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 21.117,
              "y": 1.0138,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8410136010422"
          },
          {
            "id": "679afb3f3d9bab0f83ff6968",
            "leftCorner": {
              "x": 21.117,
              "y": 1.0138,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 21.085,
              "y": 1.0133,
              "z": 1.3028
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6969",
            "leftCorner": {
              "x": 21.085,
              "y": 1.0133,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 21.016,
              "y": 1.0123,
              "z": 1.3028
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447294996"
          },
          {
            "id": "679afb3f3d9bab0f83ff696a",
            "leftCorner": {
              "x": 21.016,
              "y": 1.0123,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.976,
              "y": 1.0117,
              "z": 1.3028
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447265255"
          },
          {
            "id": "679afb3f3d9bab0f83ff696b",
            "leftCorner": {
              "x": 20.976,
              "y": 1.0117,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.913,
              "y": 1.0107,
              "z": 1.3028
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447265255"
          },
          {
            "id": "679afb3f3d9bab0f83ff696c",
            "leftCorner": {
              "x": 20.913,
              "y": 1.0107,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.818,
              "y": 1.0093,
              "z": 1.3028
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172639746"
          },
          {
            "id": "679afb3f3d9bab0f83ff696d",
            "leftCorner": {
              "x": 20.818,
              "y": 1.0093,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.705,
              "y": 1.0075,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355221032"
          },
          {
            "id": "679afb3f3d9bab0f83ff696e",
            "leftCorner": {
              "x": 20.705,
              "y": 1.0075,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.609,
              "y": 1.0061,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447747133"
          },
          {
            "id": "679afb3f3d9bab0f83ff696f",
            "leftCorner": {
              "x": 20.609,
              "y": 1.0061,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.498,
              "y": 1.0044,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447265279"
          },
          {
            "id": "679afb3f3d9bab0f83ff6970",
            "leftCorner": {
              "x": 20.498,
              "y": 1.0044,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.391,
              "y": 1.0027,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172323935"
          },
          {
            "id": "679afb3f3d9bab0f83ff6971",
            "leftCorner": {
              "x": 20.391,
              "y": 1.0027,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.281,
              "y": 1.0011,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447476026"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae06",
        "height": 1.519,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6954",
            "leftCorner": {
              "x": 21.282,
              "y": 1.0166,
              "z": 1.519
            },
            "rightCorner": {
              "x": 21.208,
              "y": 1.0155,
              "z": 1.519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6956",
            "leftCorner": {
              "x": 21.208,
              "y": 1.0155,
              "z": 1.519
            },
            "rightCorner": {
              "x": 21.134,
              "y": 1.0144,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6957",
            "leftCorner": {
              "x": 21.134,
              "y": 1.0144,
              "z": 1.519
            },
            "rightCorner": {
              "x": 21.106,
              "y": 1.014,
              "z": 1.519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6958",
            "leftCorner": {
              "x": 21.106,
              "y": 1.014,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.95,
              "y": 1.0116,
              "z": 1.519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8710255161792"
          },
          {
            "id": "679afb3f3d9bab0f83ff6959",
            "leftCorner": {
              "x": 20.95,
              "y": 1.0116,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.843,
              "y": 1.0099,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290084750"
          },
          {
            "id": "679afb3f3d9bab0f83ff695a",
            "leftCorner": {
              "x": 20.843,
              "y": 1.0099,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.715,
              "y": 1.008,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290083586"
          },
          {
            "id": "679afb3f3d9bab0f83ff695b",
            "leftCorner": {
              "x": 20.715,
              "y": 1.008,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.617,
              "y": 1.0065,
              "z": 1.519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7613036894869"
          },
          {
            "id": "679afb3f3d9bab0f83ff695c",
            "leftCorner": {
              "x": 20.617,
              "y": 1.0065,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.515,
              "y": 1.0049,
              "z": 1.519
            },
            "stockLevel": "UNKNOWN",
            "gtin": "7613036894784"
          },
          {
            "id": "679afb3f3d9bab0f83ff695d",
            "leftCorner": {
              "x": 20.515,
              "y": 1.0049,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.428,
              "y": 1.0036,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613036631976"
          },
          {
            "id": "679afb3f3d9bab0f83ff695e",
            "leftCorner": {
              "x": 20.428,
              "y": 1.0036,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.337,
              "y": 1.0022,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613036631976"
          },
          {
            "id": "679afb3f3d9bab0f83ff695f",
            "leftCorner": {
              "x": 20.337,
              "y": 1.0022,
              "z": 1.519
            },
            "rightCorner": {
              "x": 20.274,
              "y": 1.0012,
              "z": 1.519
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613036631952"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae02",
        "height": 1.7304,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6901",
            "leftCorner": {
              "x": 21.282,
              "y": 1.0145,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 21.157,
              "y": 1.0126,
              "z": 1.7304
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8710255150529"
          },
          {
            "id": "679afb3f3d9bab0f83ff6903",
            "leftCorner": {
              "x": 21.157,
              "y": 1.0126,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 20.983,
              "y": 1.01,
              "z": 1.7304
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4036581531196"
          },
          {
            "id": "679afb3f3d9bab0f83ff6904",
            "leftCorner": {
              "x": 20.983,
              "y": 1.01,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 20.812,
              "y": 1.0074,
              "z": 1.7304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5900951307553"
          },
          {
            "id": "679afb3f3d9bab0f83ff6905",
            "leftCorner": {
              "x": 20.812,
              "y": 1.0074,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 20.636,
              "y": 1.0047,
              "z": 1.7304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008429160318"
          },
          {
            "id": "679afb3f3d9bab0f83ff6906",
            "leftCorner": {
              "x": 20.636,
              "y": 1.0047,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 20.453,
              "y": 1.0019,
              "z": 1.7304
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5900951307775"
          },
          {
            "id": "679afb3f3d9bab0f83ff6902",
            "leftCorner": {
              "x": 20.453,
              "y": 1.0019,
              "z": 1.7304
            },
            "rightCorner": {
              "x": 20.282,
              "y": 0.99928,
              "z": 1.7304
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008429114663"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 44,
      "unknownStockCount": 24
    },
    "name": "QPMM",
    "leftNeighborShelfId": "X4KW",
    "rightNeighborShelfId": "EMFX"
  },
  {
    "id": "EMFX",
    "x": 20.257,
    "y": 1.0168,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.0028047
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae10",
        "height": 0.20489,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff697f",
            "leftCorner": {
              "x": 19.98,
              "y": 1.1226,
              "z": 0.2041
            },
            "rightCorner": {
              "x": 19.38,
              "y": 1.1134,
              "z": 0.2041
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355474506"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae0c",
        "height": 0.5538,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6940",
            "leftCorner": {
              "x": 20.224,
              "y": 1.0094,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 20.121,
              "y": 1.0089,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172318955"
          },
          {
            "id": "679afb3f3d9bab0f83ff6941",
            "leftCorner": {
              "x": 20.121,
              "y": 1.0089,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 20.015,
              "y": 1.0083,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172318931"
          },
          {
            "id": "679afb3f3d9bab0f83ff6942",
            "leftCorner": {
              "x": 20.015,
              "y": 1.0083,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.908,
              "y": 1.0077,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172319198"
          },
          {
            "id": "679afb3f3d9bab0f83ff6943",
            "leftCorner": {
              "x": 19.908,
              "y": 1.0077,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.81,
              "y": 1.0071,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100529"
          },
          {
            "id": "679afb3f3d9bab0f83ff6944",
            "leftCorner": {
              "x": 19.81,
              "y": 1.0071,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.712,
              "y": 1.0066,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213105"
          },
          {
            "id": "679afb3f3d9bab0f83ff6945",
            "leftCorner": {
              "x": 19.712,
              "y": 1.0066,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.618,
              "y": 1.006,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100482"
          },
          {
            "id": "679afb3f3d9bab0f83ff6946",
            "leftCorner": {
              "x": 19.618,
              "y": 1.006,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.514,
              "y": 1.0054,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213082"
          },
          {
            "id": "679afb3f3d9bab0f83ff6947",
            "leftCorner": {
              "x": 19.514,
              "y": 1.0054,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.406,
              "y": 1.0048,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213129"
          },
          {
            "id": "679afb3f3d9bab0f83ff6948",
            "leftCorner": {
              "x": 19.406,
              "y": 1.0048,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.311,
              "y": 1.0043,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100505"
          },
          {
            "id": "679afb3f3d9bab0f83ff6949",
            "leftCorner": {
              "x": 19.311,
              "y": 1.0043,
              "z": 0.5538
            },
            "rightCorner": {
              "x": 19.25,
              "y": 1.004,
              "z": 0.5538
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447295016"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae0b",
        "height": 0.80267,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff692a",
            "leftCorner": {
              "x": 20.238,
              "y": 1.0066,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 20.137,
              "y": 1.0061,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355209559"
          },
          {
            "id": "679afb3f3d9bab0f83ff692b",
            "leftCorner": {
              "x": 20.137,
              "y": 1.0061,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 20.039,
              "y": 1.0055,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447295115"
          },
          {
            "id": "679afb3f3d9bab0f83ff692c",
            "leftCorner": {
              "x": 20.039,
              "y": 1.0055,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.931,
              "y": 1.0049,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447476040"
          },
          {
            "id": "679afb3f3d9bab0f83ff692d",
            "leftCorner": {
              "x": 19.931,
              "y": 1.0049,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.832,
              "y": 1.0043,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447747409"
          },
          {
            "id": "679afb3f3d9bab0f83ff692e",
            "leftCorner": {
              "x": 19.832,
              "y": 1.0043,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.738,
              "y": 1.0038,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447238600"
          },
          {
            "id": "679afb3f3d9bab0f83ff692f",
            "leftCorner": {
              "x": 19.738,
              "y": 1.0038,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.639,
              "y": 1.0033,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172319587"
          },
          {
            "id": "679afb3f3d9bab0f83ff6930",
            "leftCorner": {
              "x": 19.639,
              "y": 1.0033,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.537,
              "y": 1.0027,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640261"
          },
          {
            "id": "679afb3f3d9bab0f83ff6931",
            "leftCorner": {
              "x": 19.537,
              "y": 1.0027,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.417,
              "y": 1.002,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172319358"
          },
          {
            "id": "679afb3f3d9bab0f83ff6932",
            "leftCorner": {
              "x": 19.417,
              "y": 1.002,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.313,
              "y": 1.0014,
              "z": 0.80267
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447494907"
          },
          {
            "id": "679afb3f3d9bab0f83ff691f",
            "leftCorner": {
              "x": 19.313,
              "y": 1.0014,
              "z": 0.80267
            },
            "rightCorner": {
              "x": 19.257,
              "y": 1.0011,
              "z": 0.80267
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447670660"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae0d",
        "height": 1.0547,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6915",
            "leftCorner": {
              "x": 20.252,
              "y": 1.0013,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 20.148,
              "y": 1.0007,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355508300"
          },
          {
            "id": "679afb3f3d9bab0f83ff6916",
            "leftCorner": {
              "x": 20.148,
              "y": 1.0007,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 20.054,
              "y": 1.0002,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355375230"
          },
          {
            "id": "679afb3f3d9bab0f83ff6917",
            "leftCorner": {
              "x": 20.054,
              "y": 1.0002,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.944,
              "y": 0.99954,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355375230"
          },
          {
            "id": "679afb3f3d9bab0f83ff6918",
            "leftCorner": {
              "x": 19.944,
              "y": 0.99954,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.846,
              "y": 0.99898,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355375216"
          },
          {
            "id": "679afb3f3d9bab0f83ff6919",
            "leftCorner": {
              "x": 19.846,
              "y": 0.99898,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.75,
              "y": 0.99845,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447120479"
          },
          {
            "id": "679afb3f3d9bab0f83ff691a",
            "leftCorner": {
              "x": 19.75,
              "y": 0.99845,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.651,
              "y": 0.99789,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796068399"
          },
          {
            "id": "679afb3f3d9bab0f83ff691b",
            "leftCorner": {
              "x": 19.651,
              "y": 0.99789,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.548,
              "y": 0.99731,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213365"
          },
          {
            "id": "679afb3f3d9bab0f83ff691c",
            "leftCorner": {
              "x": 19.548,
              "y": 0.99731,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.439,
              "y": 0.9967,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172590399"
          },
          {
            "id": "679afb3f3d9bab0f83ff691d",
            "leftCorner": {
              "x": 19.439,
              "y": 0.9967,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.334,
              "y": 0.99612,
              "z": 1.0547
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172590399"
          },
          {
            "id": "679afb3f3d9bab0f83ff6907",
            "leftCorner": {
              "x": 19.334,
              "y": 0.99612,
              "z": 1.0547
            },
            "rightCorner": {
              "x": 19.257,
              "y": 0.99568,
              "z": 1.0547
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796070958"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae0a",
        "height": 1.3084,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6972",
            "leftCorner": {
              "x": 20.281,
              "y": 1.0011,
              "z": 1.3028
            },
            "rightCorner": {
              "x": 20.179,
              "y": 0.99951,
              "z": 1.3028
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172944604"
          },
          {
            "id": "679afb3f3d9bab0f83ff6973",
            "leftCorner": {
              "x": 20.155,
              "y": 1.0017,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 20.045,
              "y": 1.0011,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447517422"
          },
          {
            "id": "679afb3f3d9bab0f83ff6974",
            "leftCorner": {
              "x": 20.045,
              "y": 1.0011,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.907,
              "y": 1.0003,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447370119"
          },
          {
            "id": "679afb3f3d9bab0f83ff6975",
            "leftCorner": {
              "x": 19.907,
              "y": 1.0003,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.798,
              "y": 0.99971,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172324031"
          },
          {
            "id": "679afb3f3d9bab0f83ff6976",
            "leftCorner": {
              "x": 19.798,
              "y": 0.99971,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.676,
              "y": 0.99902,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5998749139677"
          },
          {
            "id": "679afb3f3d9bab0f83ff6977",
            "leftCorner": {
              "x": 19.676,
              "y": 0.99902,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.56,
              "y": 0.99837,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5998749141564"
          },
          {
            "id": "679afb3f3d9bab0f83ff6978",
            "leftCorner": {
              "x": 19.56,
              "y": 0.99837,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.393,
              "y": 0.99744,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5998749108536"
          },
          {
            "id": "679afb3f3d9bab0f83ff6979",
            "leftCorner": {
              "x": 19.393,
              "y": 0.99744,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.303,
              "y": 0.99694,
              "z": 1.3084
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008429011856"
          },
          {
            "id": "679afb3f3d9bab0f83ff6966",
            "leftCorner": {
              "x": 19.303,
              "y": 0.99694,
              "z": 1.3084
            },
            "rightCorner": {
              "x": 19.257,
              "y": 0.99668,
              "z": 1.3084
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae09",
        "height": 1.5191,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6960",
            "leftCorner": {
              "x": 20.249,
              "y": 1.0061,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 20.097,
              "y": 1.0052,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291157026"
          },
          {
            "id": "679afb3f3d9bab0f83ff6961",
            "leftCorner": {
              "x": 20.097,
              "y": 1.0052,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.943,
              "y": 1.0044,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445291157026"
          },
          {
            "id": "679afb3f3d9bab0f83ff6962",
            "leftCorner": {
              "x": 19.943,
              "y": 1.0044,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.794,
              "y": 1.0035,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290494245"
          },
          {
            "id": "679afb3f3d9bab0f83ff6963",
            "leftCorner": {
              "x": 19.794,
              "y": 1.0035,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.64,
              "y": 1.0027,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290494221"
          },
          {
            "id": "679afb3f3d9bab0f83ff6964",
            "leftCorner": {
              "x": 19.64,
              "y": 1.0027,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.484,
              "y": 1.0018,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290494221"
          },
          {
            "id": "679afb3f3d9bab0f83ff6965",
            "leftCorner": {
              "x": 19.484,
              "y": 1.0018,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.366,
              "y": 1.0011,
              "z": 1.5191
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008429162831"
          },
          {
            "id": "679afb3f3d9bab0f83ff6955",
            "leftCorner": {
              "x": 19.366,
              "y": 1.0011,
              "z": 1.5191
            },
            "rightCorner": {
              "x": 19.257,
              "y": 1.0005,
              "z": 1.5191
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008429037986"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae0e",
        "height": 1.7729,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff699b",
            "leftCorner": {
              "x": 20.257,
              "y": 1.0055,
              "z": 1.7729
            },
            "rightCorner": {
              "x": 20.045,
              "y": 1.0043,
              "z": 1.7729
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5900951258589"
          },
          {
            "id": "679afb3f3d9bab0f83ff699d",
            "leftCorner": {
              "x": 20.045,
              "y": 1.0043,
              "z": 1.7729
            },
            "rightCorner": {
              "x": 19.837,
              "y": 1.0032,
              "z": 1.7729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5900951258589"
          },
          {
            "id": "679afb3f3d9bab0f83ff699e",
            "leftCorner": {
              "x": 19.837,
              "y": 1.0032,
              "z": 1.7729
            },
            "rightCorner": {
              "x": 19.64,
              "y": 1.002,
              "z": 1.7729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "7613032727826"
          },
          {
            "id": "679afb3f3d9bab0f83ff699f",
            "leftCorner": {
              "x": 19.64,
              "y": 1.002,
              "z": 1.7729
            },
            "rightCorner": {
              "x": 19.424,
              "y": 1.0008,
              "z": 1.7729
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640353"
          },
          {
            "id": "679afb3f3d9bab0f83ff699c",
            "leftCorner": {
              "x": 19.424,
              "y": 1.0008,
              "z": 1.7729
            },
            "rightCorner": {
              "x": 19.257,
              "y": 0.9999,
              "z": 1.7729
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447598056"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 45,
      "unknownStockCount": 7
    },
    "name": "EMFX",
    "leftNeighborShelfId": "QPMM",
    "rightNeighborShelfId": "RSJQ"
  },
  {
    "id": "RSJQ",
    "x": 19.244,
    "y": 1.0159,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.0026341
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae12",
        "height": 0.2041,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6980",
            "leftCorner": {
              "x": 19.38,
              "y": 1.1194,
              "z": 0.2041
            },
            "rightCorner": {
              "x": 18.57,
              "y": 1.107,
              "z": 0.2041
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447398861"
          },
          {
            "id": "679afb3f3d9bab0f83ff6981",
            "leftCorner": {
              "x": 18.57,
              "y": 1.1151,
              "z": 0.2041
            },
            "rightCorner": {
              "x": 18.383,
              "y": 1.1141,
              "z": 0.2041
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447140224"
          },
          {
            "id": "679afb3f3d9bab0f83ff6982",
            "leftCorner": {
              "x": 18.383,
              "y": 1.1141,
              "z": 0.2041
            },
            "rightCorner": {
              "x": 18.206,
              "y": 1.1132,
              "z": 0.2041
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447140224"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae11",
        "height": 0.55164,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff694a",
            "leftCorner": {
              "x": 19.236,
              "y": 1.0128,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 19.012,
              "y": 1.0116,
              "z": 0.55164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475838"
          },
          {
            "id": "679afb3f3d9bab0f83ff694b",
            "leftCorner": {
              "x": 19.012,
              "y": 1.0116,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 18.776,
              "y": 1.0103,
              "z": 0.55164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475852"
          },
          {
            "id": "679afb3f3d9bab0f83ff694c",
            "leftCorner": {
              "x": 18.776,
              "y": 1.0103,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 18.542,
              "y": 1.0091,
              "z": 0.55164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475821"
          },
          {
            "id": "679afb3f3d9bab0f83ff694d",
            "leftCorner": {
              "x": 18.542,
              "y": 1.0091,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 18.312,
              "y": 1.0079,
              "z": 0.55164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475845"
          },
          {
            "id": "679afb3f3d9bab0f83ff694e",
            "leftCorner": {
              "x": 18.312,
              "y": 1.0079,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 18.255,
              "y": 1.0076,
              "z": 0.55164
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae13",
        "height": 0.88316,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69a0",
            "leftCorner": {
              "x": 19.244,
              "y": 1.0098,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 19.086,
              "y": 1.009,
              "z": 0.88316
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355213501"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a2",
            "leftCorner": {
              "x": 19.086,
              "y": 1.009,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.939,
              "y": 1.0082,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213501"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a3",
            "leftCorner": {
              "x": 18.939,
              "y": 1.0082,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.789,
              "y": 1.0074,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213501"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a4",
            "leftCorner": {
              "x": 18.789,
              "y": 1.0074,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.639,
              "y": 1.0066,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213549"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a5",
            "leftCorner": {
              "x": 18.639,
              "y": 1.0066,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.472,
              "y": 1.0057,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355213549"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a6",
            "leftCorner": {
              "x": 18.472,
              "y": 1.0057,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.322,
              "y": 1.0049,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a7",
            "leftCorner": {
              "x": 18.322,
              "y": 1.0049,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.272,
              "y": 1.0047,
              "z": 0.88316
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172100789"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a8",
            "leftCorner": {
              "x": 18.272,
              "y": 1.0047,
              "z": 0.88316
            },
            "rightCorner": {
              "x": 18.167,
              "y": 1.0041,
              "z": 0.88316
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae15",
        "height": 1.1794,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69bd",
            "leftCorner": {
              "x": 19.244,
              "y": 1.0087,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 19.169,
              "y": 1.0083,
              "z": 1.1794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355556929"
          },
          {
            "id": "679afb3f3d9bab0f83ff69bf",
            "leftCorner": {
              "x": 19.169,
              "y": 1.0083,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 19.089,
              "y": 1.0079,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355556929"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c0",
            "leftCorner": {
              "x": 19.089,
              "y": 1.0079,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.945,
              "y": 1.0072,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355508423"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c1",
            "leftCorner": {
              "x": 18.945,
              "y": 1.0072,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.795,
              "y": 1.0064,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355508423"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c2",
            "leftCorner": {
              "x": 18.795,
              "y": 1.0064,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.646,
              "y": 1.0056,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100642"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c3",
            "leftCorner": {
              "x": 18.646,
              "y": 1.0056,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.487,
              "y": 1.0048,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100642"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c4",
            "leftCorner": {
              "x": 18.487,
              "y": 1.0048,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.393,
              "y": 1.0043,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100581"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c5",
            "leftCorner": {
              "x": 18.393,
              "y": 1.0043,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.297,
              "y": 1.0038,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100581"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c6",
            "leftCorner": {
              "x": 18.297,
              "y": 1.0038,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.252,
              "y": 1.0035,
              "z": 1.1794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c7",
            "leftCorner": {
              "x": 18.252,
              "y": 1.0035,
              "z": 1.1794
            },
            "rightCorner": {
              "x": 18.182,
              "y": 1.0032,
              "z": 1.1794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae16",
        "height": 1.4747,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69d0",
            "leftCorner": {
              "x": 19.244,
              "y": 1.0088,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 19.172,
              "y": 1.0085,
              "z": 1.4747
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355557223"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d2",
            "leftCorner": {
              "x": 19.172,
              "y": 1.0085,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 19.102,
              "y": 1.0081,
              "z": 1.4747
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355557223"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d3",
            "leftCorner": {
              "x": 19.102,
              "y": 1.0081,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 19.038,
              "y": 1.0078,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355557223"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d4",
            "leftCorner": {
              "x": 19.038,
              "y": 1.0078,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.895,
              "y": 1.007,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447195132"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d5",
            "leftCorner": {
              "x": 18.895,
              "y": 1.007,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.751,
              "y": 1.0062,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447195132"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d6",
            "leftCorner": {
              "x": 18.751,
              "y": 1.0062,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.596,
              "y": 1.0054,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447195132"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d7",
            "leftCorner": {
              "x": 18.596,
              "y": 1.0054,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.457,
              "y": 1.0047,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172323973"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d8",
            "leftCorner": {
              "x": 18.457,
              "y": 1.0047,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.313,
              "y": 1.0039,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172323973"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d9",
            "leftCorner": {
              "x": 18.313,
              "y": 1.0039,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.264,
              "y": 1.0037,
              "z": 1.4747
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172222757"
          },
          {
            "id": "679afb3f3d9bab0f83ff69da",
            "leftCorner": {
              "x": 18.264,
              "y": 1.0037,
              "z": 1.4747
            },
            "rightCorner": {
              "x": 18.18,
              "y": 1.0032,
              "z": 1.4747
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172222757"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae14",
        "height": 1.7276,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69ae",
            "leftCorner": {
              "x": 19.244,
              "y": 1.008,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 19.086,
              "y": 1.0072,
              "z": 1.7276
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027600104408"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b0",
            "leftCorner": {
              "x": 19.086,
              "y": 1.0072,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.94,
              "y": 1.0064,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639708"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b1",
            "leftCorner": {
              "x": 18.94,
              "y": 1.0064,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.79,
              "y": 1.0056,
              "z": 1.7276
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172639685"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b2",
            "leftCorner": {
              "x": 18.79,
              "y": 1.0056,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.644,
              "y": 1.0048,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639685"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b3",
            "leftCorner": {
              "x": 18.644,
              "y": 1.0048,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.5,
              "y": 1.0041,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639661"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b4",
            "leftCorner": {
              "x": 18.5,
              "y": 1.0041,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.361,
              "y": 1.0033,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639661"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b5",
            "leftCorner": {
              "x": 18.361,
              "y": 1.0033,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.302,
              "y": 1.003,
              "z": 1.7276
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172319457"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b6",
            "leftCorner": {
              "x": 18.302,
              "y": 1.003,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.257,
              "y": 1.0028,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172319457"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 0,
      "hasStockCount": 32,
      "unknownStockCount": 12
    },
    "name": "RSJQ",
    "leftNeighborShelfId": "EMFX",
    "rightNeighborShelfId": "PBQS"
  },
  {
    "id": "PBQS",
    "x": 18.239,
    "y": 1.0098,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99998,
      "w": -0.0061136
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae18",
        "height": 0.20181,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6983",
            "leftCorner": {
              "x": 18.2,
              "y": 1.1094,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 18.158,
              "y": 1.1089,
              "z": 0.20181
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6984",
            "leftCorner": {
              "x": 18.158,
              "y": 1.1089,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 18.047,
              "y": 1.1075,
              "z": 0.20181
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447424287"
          },
          {
            "id": "679afb3f3d9bab0f83ff6985",
            "leftCorner": {
              "x": 18.047,
              "y": 1.1075,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.915,
              "y": 1.1059,
              "z": 0.20181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172324017"
          },
          {
            "id": "679afb3f3d9bab0f83ff6986",
            "leftCorner": {
              "x": 17.915,
              "y": 1.1059,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.802,
              "y": 1.1045,
              "z": 0.20181
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4066447716801"
          },
          {
            "id": "679afb3f3d9bab0f83ff6987",
            "leftCorner": {
              "x": 17.802,
              "y": 1.1045,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.698,
              "y": 1.1033,
              "z": 0.20181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447716825"
          },
          {
            "id": "679afb3f3d9bab0f83ff6988",
            "leftCorner": {
              "x": 17.698,
              "y": 1.1033,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.571,
              "y": 1.1017,
              "z": 0.20181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6989",
            "leftCorner": {
              "x": 17.571,
              "y": 1.1017,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.429,
              "y": 1.1,
              "z": 0.20181
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172222412"
          },
          {
            "id": "679afb3f3d9bab0f83ff698a",
            "leftCorner": {
              "x": 17.429,
              "y": 1.1,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.295,
              "y": 1.0983,
              "z": 0.20181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172222399"
          },
          {
            "id": "679afb3f3d9bab0f83ff698b",
            "leftCorner": {
              "x": 17.295,
              "y": 1.0983,
              "z": 0.20181
            },
            "rightCorner": {
              "x": 17.177,
              "y": 1.0969,
              "z": 0.20181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172222399"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1b",
        "height": 0.5489,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff694f",
            "leftCorner": {
              "x": 18.255,
              "y": 1.0076,
              "z": 0.55164
            },
            "rightCorner": {
              "x": 18.017,
              "y": 1.0063,
              "z": 0.55164
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447485004"
          },
          {
            "id": "679afb3f3d9bab0f83ff6950",
            "leftCorner": {
              "x": 18.012,
              "y": 1.0007,
              "z": 0.5489
            },
            "rightCorner": {
              "x": 17.864,
              "y": 0.9989,
              "z": 0.5489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475869"
          },
          {
            "id": "679afb3f3d9bab0f83ff6951",
            "leftCorner": {
              "x": 17.864,
              "y": 0.9989,
              "z": 0.5489
            },
            "rightCorner": {
              "x": 17.703,
              "y": 0.99693,
              "z": 0.5489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447475869"
          },
          {
            "id": "679afb3f3d9bab0f83ff6952",
            "leftCorner": {
              "x": 17.703,
              "y": 0.99693,
              "z": 0.5489
            },
            "rightCorner": {
              "x": 17.531,
              "y": 0.99482,
              "z": 0.5489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640285"
          },
          {
            "id": "679afb3f3d9bab0f83ff6953",
            "leftCorner": {
              "x": 17.531,
              "y": 0.99482,
              "z": 0.5489
            },
            "rightCorner": {
              "x": 17.378,
              "y": 0.99296,
              "z": 0.5489
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640285"
          },
          {
            "id": "679afb3f3d9bab0f83ff6934",
            "leftCorner": {
              "x": 17.378,
              "y": 0.99296,
              "z": 0.5489
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.99126,
              "z": 0.5489
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447475876"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1a",
        "height": 0.88181,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69a9",
            "leftCorner": {
              "x": 18.162,
              "y": 1.0008,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 18.028,
              "y": 0.9992,
              "z": 0.88181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69aa",
            "leftCorner": {
              "x": 18.028,
              "y": 0.9992,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 17.879,
              "y": 0.99738,
              "z": 0.88181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355220684"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ab",
            "leftCorner": {
              "x": 17.879,
              "y": 0.99738,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 17.717,
              "y": 0.9954,
              "z": 0.88181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447120516"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ac",
            "leftCorner": {
              "x": 17.717,
              "y": 0.9954,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 17.544,
              "y": 0.99328,
              "z": 0.88181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447252101"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ad",
            "leftCorner": {
              "x": 17.544,
              "y": 0.99328,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 17.383,
              "y": 0.99131,
              "z": 0.88181
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69a1",
            "leftCorner": {
              "x": 17.383,
              "y": 0.99131,
              "z": 0.88181
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.98956,
              "z": 0.88181
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447242676"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1c",
        "height": 1.1787,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69c8",
            "leftCorner": {
              "x": 18.177,
              "y": 1.0008,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 18.093,
              "y": 0.99981,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447732634"
          },
          {
            "id": "679afb3f3d9bab0f83ff69c9",
            "leftCorner": {
              "x": 18.093,
              "y": 0.99981,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 18.06,
              "y": 0.99941,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ca",
            "leftCorner": {
              "x": 18.06,
              "y": 0.99941,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.993,
              "y": 0.99858,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69cb",
            "leftCorner": {
              "x": 17.993,
              "y": 0.99858,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.849,
              "y": 0.99683,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69cc",
            "leftCorner": {
              "x": 17.849,
              "y": 0.99683,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.679,
              "y": 0.99474,
              "z": 1.1787
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008429114588"
          },
          {
            "id": "679afb3f3d9bab0f83ff69cd",
            "leftCorner": {
              "x": 17.679,
              "y": 0.99474,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.524,
              "y": 0.99284,
              "z": 1.1787
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4008429114588"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ce",
            "leftCorner": {
              "x": 17.524,
              "y": 0.99284,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.447,
              "y": 0.99191,
              "z": 1.1787
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4250231598845"
          },
          {
            "id": "679afb3f3d9bab0f83ff69cf",
            "leftCorner": {
              "x": 17.447,
              "y": 0.99191,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.362,
              "y": 0.99087,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4250231598876"
          },
          {
            "id": "679afb3f3d9bab0f83ff69be",
            "leftCorner": {
              "x": 17.362,
              "y": 0.99087,
              "z": 1.1787
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.98937,
              "z": 1.1787
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4260446690203"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae17",
        "height": 1.4731,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69db",
            "leftCorner": {
              "x": 18.175,
              "y": 1.0014,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 18.05,
              "y": 0.99984,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172099908"
          },
          {
            "id": "679afb3f3d9bab0f83ff69dc",
            "leftCorner": {
              "x": 18.05,
              "y": 0.99984,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.839,
              "y": 0.99726,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172222733"
          },
          {
            "id": "679afb3f3d9bab0f83ff69dd",
            "leftCorner": {
              "x": 17.839,
              "y": 0.99726,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.743,
              "y": 0.99609,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172100024"
          },
          {
            "id": "679afb3f3d9bab0f83ff69de",
            "leftCorner": {
              "x": 17.743,
              "y": 0.99609,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.64,
              "y": 0.99482,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172099861"
          },
          {
            "id": "679afb3f3d9bab0f83ff69df",
            "leftCorner": {
              "x": 17.64,
              "y": 0.99482,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.53,
              "y": 0.99348,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172099847"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e0",
            "leftCorner": {
              "x": 17.53,
              "y": 0.99348,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.432,
              "y": 0.99228,
              "z": 1.4731
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670608"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e1",
            "leftCorner": {
              "x": 17.432,
              "y": 0.99228,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.335,
              "y": 0.9911,
              "z": 1.4731
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447295139"
          },
          {
            "id": "679afb3f3d9bab0f83ff69d1",
            "leftCorner": {
              "x": 17.335,
              "y": 0.9911,
              "z": 1.4731
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.98993,
              "z": 1.4731
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447747485"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae19",
        "height": 1.7249,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69b7",
            "leftCorner": {
              "x": 18.257,
              "y": 1.0028,
              "z": 1.7276
            },
            "rightCorner": {
              "x": 18.154,
              "y": 1.0023,
              "z": 1.7276
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172319709"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b8",
            "leftCorner": {
              "x": 18.149,
              "y": 0.99924,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.983,
              "y": 0.99721,
              "z": 1.7249
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4032254748038"
          },
          {
            "id": "679afb3f3d9bab0f83ff69b9",
            "leftCorner": {
              "x": 17.983,
              "y": 0.99721,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.793,
              "y": 0.99489,
              "z": 1.7249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "3065890149328"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ba",
            "leftCorner": {
              "x": 17.793,
              "y": 0.99489,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.638,
              "y": 0.993,
              "z": 1.7249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8410136024184"
          },
          {
            "id": "679afb3f3d9bab0f83ff69bb",
            "leftCorner": {
              "x": 17.638,
              "y": 0.993,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.515,
              "y": 0.99149,
              "z": 1.7249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008429085307"
          },
          {
            "id": "679afb3f3d9bab0f83ff69bc",
            "leftCorner": {
              "x": 17.515,
              "y": 0.99149,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.365,
              "y": 0.98965,
              "z": 1.7249
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "8445290645647"
          },
          {
            "id": "679afb3f3d9bab0f83ff69af",
            "leftCorner": {
              "x": 17.365,
              "y": 0.98965,
              "z": 1.7249
            },
            "rightCorner": {
              "x": 17.24,
              "y": 0.98812,
              "z": 1.7249
            },
            "stockLevel": "UNKNOWN",
            "gtin": "8445290970619"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 3,
      "hasStockCount": 28,
      "unknownStockCount": 14
    },
    "name": "PBQS",
    "leftNeighborShelfId": "RSJQ",
    "rightNeighborShelfId": "2PQJ"
  },
  {
    "id": "2PQJ",
    "x": 17.246,
    "y": 0.99858,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 0.99999,
      "w": -0.0032916
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae20",
        "height": 0.20431,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff698c",
            "leftCorner": {
              "x": 17.185,
              "y": 1.0997,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 17.113,
              "y": 1.0993,
              "z": 0.20431
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251871692801"
          },
          {
            "id": "679afb3f3d9bab0f83ff698d",
            "leftCorner": {
              "x": 17.113,
              "y": 1.0993,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.803,
              "y": 1.0972,
              "z": 0.20431
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251871692801"
          },
          {
            "id": "679afb3f3d9bab0f83ff698e",
            "leftCorner": {
              "x": 16.803,
              "y": 1.0972,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.664,
              "y": 1.0963,
              "z": 0.20431
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff698f",
            "leftCorner": {
              "x": 16.664,
              "y": 1.0963,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.517,
              "y": 1.0954,
              "z": 0.20431
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447252088"
          },
          {
            "id": "679afb3f3d9bab0f83ff6990",
            "leftCorner": {
              "x": 16.517,
              "y": 1.0954,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.38,
              "y": 1.0945,
              "z": 0.20431
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355221964"
          },
          {
            "id": "679afb3f3d9bab0f83ff6991",
            "leftCorner": {
              "x": 16.38,
              "y": 1.0945,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.317,
              "y": 1.094,
              "z": 0.20431
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447398915"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae23",
        "height": 0.51133,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a10",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98912,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 17.093,
              "y": 0.98811,
              "z": 0.51133
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172640391"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a12",
            "leftCorner": {
              "x": 17.093,
              "y": 0.98811,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.967,
              "y": 0.98728,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639609"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a13",
            "leftCorner": {
              "x": 16.967,
              "y": 0.98728,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.843,
              "y": 0.98646,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639609"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a14",
            "leftCorner": {
              "x": 16.843,
              "y": 0.98646,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.726,
              "y": 0.98569,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639609"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a15",
            "leftCorner": {
              "x": 16.726,
              "y": 0.98569,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.602,
              "y": 0.98488,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639586"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a16",
            "leftCorner": {
              "x": 16.602,
              "y": 0.98488,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.484,
              "y": 0.9841,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639586"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a17",
            "leftCorner": {
              "x": 16.484,
              "y": 0.9841,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.372,
              "y": 0.98336,
              "z": 0.51133
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639586"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a11",
            "leftCorner": {
              "x": 16.372,
              "y": 0.98336,
              "z": 0.51133
            },
            "rightCorner": {
              "x": 16.246,
              "y": 0.98254,
              "z": 0.51133
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172639586"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1e",
        "height": 0.76183,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69eb",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98668,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 17.137,
              "y": 0.98596,
              "z": 0.76183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172640247"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ed",
            "leftCorner": {
              "x": 17.137,
              "y": 0.98596,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 17.097,
              "y": 0.9857,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447751079"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ee",
            "leftCorner": {
              "x": 17.097,
              "y": 0.9857,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 17.011,
              "y": 0.98513,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447750133"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ef",
            "leftCorner": {
              "x": 17.011,
              "y": 0.98513,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.89,
              "y": 0.98434,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172772160"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f0",
            "leftCorner": {
              "x": 16.89,
              "y": 0.98434,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.817,
              "y": 0.98386,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355512154"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f1",
            "leftCorner": {
              "x": 16.817,
              "y": 0.98386,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.741,
              "y": 0.98335,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f2",
            "leftCorner": {
              "x": 16.741,
              "y": 0.98335,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.654,
              "y": 0.98278,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355500595"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f3",
            "leftCorner": {
              "x": 16.654,
              "y": 0.98278,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.581,
              "y": 0.9823,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355500595"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f4",
            "leftCorner": {
              "x": 16.581,
              "y": 0.9823,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.43,
              "y": 0.98131,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355512178"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f5",
            "leftCorner": {
              "x": 16.43,
              "y": 0.98131,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.356,
              "y": 0.98082,
              "z": 0.76183
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4010355500533"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f6",
            "leftCorner": {
              "x": 16.356,
              "y": 0.98082,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.305,
              "y": 0.98048,
              "z": 0.76183
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355500557"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ec",
            "leftCorner": {
              "x": 16.305,
              "y": 0.98048,
              "z": 0.76183
            },
            "rightCorner": {
              "x": 16.246,
              "y": 0.9801,
              "z": 0.76183
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355500571"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1d",
        "height": 0.96929,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69e2",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98567,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 17.17,
              "y": 0.98517,
              "z": 0.96929
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4045612003977"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e4",
            "leftCorner": {
              "x": 17.17,
              "y": 0.98517,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 17.061,
              "y": 0.98445,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251276205040"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e5",
            "leftCorner": {
              "x": 17.061,
              "y": 0.98445,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.952,
              "y": 0.98373,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4251276205071"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e6",
            "leftCorner": {
              "x": 16.952,
              "y": 0.98373,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.848,
              "y": 0.98305,
              "z": 0.96929
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4251276204777"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e7",
            "leftCorner": {
              "x": 16.848,
              "y": 0.98305,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.724,
              "y": 0.98223,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5998749146255"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e8",
            "leftCorner": {
              "x": 16.724,
              "y": 0.98223,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.623,
              "y": 0.98157,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5998749120552"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e9",
            "leftCorner": {
              "x": 16.623,
              "y": 0.98157,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.503,
              "y": 0.98078,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447121605"
          },
          {
            "id": "679afb3f3d9bab0f83ff69ea",
            "leftCorner": {
              "x": 16.503,
              "y": 0.98078,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.377,
              "y": 0.97995,
              "z": 0.96929
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447121605"
          },
          {
            "id": "679afb3f3d9bab0f83ff69e3",
            "leftCorner": {
              "x": 16.377,
              "y": 0.97995,
              "z": 0.96929
            },
            "rightCorner": {
              "x": 16.246,
              "y": 0.97909,
              "z": 0.96929
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5998749105214"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae21",
        "height": 1.2648,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69ff",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98505,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 17.118,
              "y": 0.9842,
              "z": 1.2648
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447670646"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a01",
            "leftCorner": {
              "x": 17.118,
              "y": 0.9842,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.989,
              "y": 0.98335,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640452"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a02",
            "leftCorner": {
              "x": 16.989,
              "y": 0.98335,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.864,
              "y": 0.98253,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640452"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a03",
            "leftCorner": {
              "x": 16.864,
              "y": 0.98253,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.756,
              "y": 0.98182,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355178350"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a04",
            "leftCorner": {
              "x": 16.756,
              "y": 0.98182,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.65,
              "y": 0.98112,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a05",
            "leftCorner": {
              "x": 16.65,
              "y": 0.98112,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.545,
              "y": 0.98043,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172640476"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a06",
            "leftCorner": {
              "x": 16.545,
              "y": 0.98043,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.437,
              "y": 0.97972,
              "z": 1.2648
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4010355302168"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a07",
            "leftCorner": {
              "x": 16.437,
              "y": 0.97972,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.34,
              "y": 0.97908,
              "z": 1.2648
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4067796063677"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a00",
            "leftCorner": {
              "x": 16.34,
              "y": 0.97908,
              "z": 1.2648
            },
            "rightCorner": {
              "x": 16.247,
              "y": 0.97846,
              "z": 1.2648
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796069235"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae1f",
        "height": 1.5178,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff69f7",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98891,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 17.095,
              "y": 0.98791,
              "z": 1.5178
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447297850"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f9",
            "leftCorner": {
              "x": 17.095,
              "y": 0.98791,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.963,
              "y": 0.98705,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355508324"
          },
          {
            "id": "679afb3f3d9bab0f83ff69fa",
            "leftCorner": {
              "x": 16.963,
              "y": 0.98705,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.84,
              "y": 0.98624,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447203332"
          },
          {
            "id": "679afb3f3d9bab0f83ff69fb",
            "leftCorner": {
              "x": 16.84,
              "y": 0.98624,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.699,
              "y": 0.98531,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355220325"
          },
          {
            "id": "679afb3f3d9bab0f83ff69fc",
            "leftCorner": {
              "x": 16.699,
              "y": 0.98531,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.6,
              "y": 0.98466,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355375094"
          },
          {
            "id": "679afb3f3d9bab0f83ff69fd",
            "leftCorner": {
              "x": 16.6,
              "y": 0.98466,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.491,
              "y": 0.98394,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447670622"
          },
          {
            "id": "679afb3f3d9bab0f83ff69fe",
            "leftCorner": {
              "x": 16.491,
              "y": 0.98394,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.377,
              "y": 0.98319,
              "z": 1.5178
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048422159032"
          },
          {
            "id": "679afb3f3d9bab0f83ff69f8",
            "leftCorner": {
              "x": 16.377,
              "y": 0.98319,
              "z": 1.5178
            },
            "rightCorner": {
              "x": 16.246,
              "y": 0.98233,
              "z": 1.5178
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4048422159001"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae22",
        "height": 1.7728,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a08",
            "leftCorner": {
              "x": 17.246,
              "y": 0.98736,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 17.059,
              "y": 0.98612,
              "z": 1.7728
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172319754"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0a",
            "leftCorner": {
              "x": 17.059,
              "y": 0.98612,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.912,
              "y": 0.98515,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355220547"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0b",
            "leftCorner": {
              "x": 16.912,
              "y": 0.98515,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.765,
              "y": 0.98419,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048422144632"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0c",
            "leftCorner": {
              "x": 16.765,
              "y": 0.98419,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.626,
              "y": 0.98327,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4048422102472"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0d",
            "leftCorner": {
              "x": 16.626,
              "y": 0.98327,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.503,
              "y": 0.98246,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172639784"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0e",
            "leftCorner": {
              "x": 16.503,
              "y": 0.98246,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.422,
              "y": 0.98193,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355214027"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a0f",
            "leftCorner": {
              "x": 16.422,
              "y": 0.98193,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.335,
              "y": 0.98136,
              "z": 1.7728
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4008239155511"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a09",
            "leftCorner": {
              "x": 16.335,
              "y": 0.98136,
              "z": 1.7728
            },
            "rightCorner": {
              "x": 16.246,
              "y": 0.98077,
              "z": 1.7728
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4008239184382"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 1,
      "hasStockCount": 43,
      "unknownStockCount": 16
    },
    "name": "2PQJ",
    "leftNeighborShelfId": "PBQS",
    "rightNeighborShelfId": "FA84"
  },
  {
    "id": "FA84",
    "x": 16.243,
    "y": 0.99949,
    "width": 1,
    "height": 1.8,
    "depth": 0.662,
    "rotation": {
      "x": 0,
      "y": 0,
      "z": 1,
      "w": -0.0017333
    },
    "layers": [
      {
        "id": "679aebdc1f3fd8b81ad3ae26",
        "height": 0.20608,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6992",
            "leftCorner": {
              "x": 16.317,
              "y": 1.094,
              "z": 0.20431
            },
            "rightCorner": {
              "x": 16.148,
              "y": 1.0929,
              "z": 0.20431
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355492616"
          },
          {
            "id": "679afb3f3d9bab0f83ff6993",
            "leftCorner": {
              "x": 16.145,
              "y": 1.0936,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 16.04,
              "y": 1.0932,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172573682"
          },
          {
            "id": "679afb3f3d9bab0f83ff6994",
            "leftCorner": {
              "x": 16.04,
              "y": 1.0932,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.938,
              "y": 1.0929,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4010355492524"
          },
          {
            "id": "679afb3f3d9bab0f83ff6995",
            "leftCorner": {
              "x": 15.938,
              "y": 1.0929,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.839,
              "y": 1.0925,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447397987"
          },
          {
            "id": "679afb3f3d9bab0f83ff6996",
            "leftCorner": {
              "x": 15.839,
              "y": 1.0925,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.735,
              "y": 1.0922,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700838099"
          },
          {
            "id": "679afb3f3d9bab0f83ff6997",
            "leftCorner": {
              "x": 15.735,
              "y": 1.0922,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.633,
              "y": 1.0918,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172893858"
          },
          {
            "id": "679afb3f3d9bab0f83ff6998",
            "leftCorner": {
              "x": 15.633,
              "y": 1.0918,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.554,
              "y": 1.0915,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6999",
            "leftCorner": {
              "x": 15.554,
              "y": 1.0915,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.462,
              "y": 1.0912,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700673942"
          },
          {
            "id": "679afb3f3d9bab0f83ff699a",
            "leftCorner": {
              "x": 15.462,
              "y": 1.0912,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.376,
              "y": 1.0909,
              "z": 0.20608
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447707182"
          },
          {
            "id": "679afb3f3d9bab0f83ff697b",
            "leftCorner": {
              "x": 15.376,
              "y": 1.0909,
              "z": 0.20608
            },
            "rightCorner": {
              "x": 15.243,
              "y": 1.0905,
              "z": 0.20608
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447242355"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae24",
        "height": 0.55794,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a18",
            "leftCorner": {
              "x": 16.243,
              "y": 0.9862,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 16.112,
              "y": 0.98574,
              "z": 0.55794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027600764718"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1a",
            "leftCorner": {
              "x": 16.112,
              "y": 0.98574,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 16.025,
              "y": 0.98544,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600753408"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1b",
            "leftCorner": {
              "x": 16.025,
              "y": 0.98544,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.894,
              "y": 0.98499,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204305203"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1c",
            "leftCorner": {
              "x": 15.894,
              "y": 0.98499,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.809,
              "y": 0.98469,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172893797"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1d",
            "leftCorner": {
              "x": 15.809,
              "y": 0.98469,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.706,
              "y": 0.98434,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "40276908"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1e",
            "leftCorner": {
              "x": 15.706,
              "y": 0.98434,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.603,
              "y": 0.98398,
              "z": 0.55794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4058172893810"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a1f",
            "leftCorner": {
              "x": 15.603,
              "y": 0.98398,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.524,
              "y": 0.9837,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700437216"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a20",
            "leftCorner": {
              "x": 15.524,
              "y": 0.9837,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.428,
              "y": 0.98337,
              "z": 0.55794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447373318"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a21",
            "leftCorner": {
              "x": 15.428,
              "y": 0.98337,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.333,
              "y": 0.98304,
              "z": 0.55794
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447373318"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a19",
            "leftCorner": {
              "x": 15.333,
              "y": 0.98304,
              "z": 0.55794
            },
            "rightCorner": {
              "x": 15.243,
              "y": 0.98273,
              "z": 0.55794
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4066447373295"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae25",
        "height": 0.84895,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a22",
            "leftCorner": {
              "x": 16.243,
              "y": 0.98378,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 16.177,
              "y": 0.98355,
              "z": 0.84895
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5000204343540"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a24",
            "leftCorner": {
              "x": 16.177,
              "y": 0.98355,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 16.12,
              "y": 0.98335,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204343540"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a25",
            "leftCorner": {
              "x": 16.12,
              "y": 0.98335,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 16.002,
              "y": 0.98294,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204206180"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a26",
            "leftCorner": {
              "x": 16.002,
              "y": 0.98294,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.945,
              "y": 0.98275,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204206210"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a27",
            "leftCorner": {
              "x": 15.945,
              "y": 0.98275,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.837,
              "y": 0.98237,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204373004"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a28",
            "leftCorner": {
              "x": 15.837,
              "y": 0.98237,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.754,
              "y": 0.98208,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204331998"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a29",
            "leftCorner": {
              "x": 15.754,
              "y": 0.98208,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.655,
              "y": 0.98174,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700439029"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a2a",
            "leftCorner": {
              "x": 15.655,
              "y": 0.98174,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.548,
              "y": 0.98137,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700439029"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a2b",
            "leftCorner": {
              "x": 15.548,
              "y": 0.98137,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.431,
              "y": 0.98097,
              "z": 0.84895
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4062700639047"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a2c",
            "leftCorner": {
              "x": 15.431,
              "y": 0.98097,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.359,
              "y": 0.98072,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447674675"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a2d",
            "leftCorner": {
              "x": 15.359,
              "y": 0.98072,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.293,
              "y": 0.98049,
              "z": 0.84895
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "5000204203158"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a23",
            "leftCorner": {
              "x": 15.293,
              "y": 0.98049,
              "z": 0.84895
            },
            "rightCorner": {
              "x": 15.243,
              "y": 0.98031,
              "z": 0.84895
            },
            "stockLevel": "UNKNOWN",
            "gtin": "5000204203158"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae28",
        "height": 1.1874,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a37",
            "leftCorner": {
              "x": 16.243,
              "y": 0.98278,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 16.138,
              "y": 0.98241,
              "z": 1.1874
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4067796084924"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a39",
            "leftCorner": {
              "x": 16.138,
              "y": 0.98241,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 16.036,
              "y": 0.98206,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700836590"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3a",
            "leftCorner": {
              "x": 16.036,
              "y": 0.98206,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.934,
              "y": 0.98171,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700836590"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3b",
            "leftCorner": {
              "x": 15.934,
              "y": 0.98171,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.857,
              "y": 0.98144,
              "z": 1.1874
            },
            "stockLevel": "UNKNOWN",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3c",
            "leftCorner": {
              "x": 15.857,
              "y": 0.98144,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.774,
              "y": 0.98115,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3d",
            "leftCorner": {
              "x": 15.774,
              "y": 0.98115,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.675,
              "y": 0.98081,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600204719"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3e",
            "leftCorner": {
              "x": 15.675,
              "y": 0.98081,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.558,
              "y": 0.9804,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "0"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a3f",
            "leftCorner": {
              "x": 15.558,
              "y": 0.9804,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.43,
              "y": 0.97996,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700436516"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a40",
            "leftCorner": {
              "x": 15.43,
              "y": 0.97996,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.299,
              "y": 0.97951,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700635049"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a38",
            "leftCorner": {
              "x": 15.299,
              "y": 0.97951,
              "z": 1.1874
            },
            "rightCorner": {
              "x": 15.243,
              "y": 0.97931,
              "z": 1.1874
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "742042735334"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae29",
        "height": 1.4802,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a41",
            "leftCorner": {
              "x": 16.243,
              "y": 0.97979,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 16.098,
              "y": 0.97928,
              "z": 1.4802
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062700835012"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a43",
            "leftCorner": {
              "x": 16.098,
              "y": 0.97928,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.997,
              "y": 0.97893,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700835012"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a44",
            "leftCorner": {
              "x": 15.997,
              "y": 0.97893,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.93,
              "y": 0.9787,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600194416"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a45",
            "leftCorner": {
              "x": 15.93,
              "y": 0.9787,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.861,
              "y": 0.97846,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172573583"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a46",
            "leftCorner": {
              "x": 15.861,
              "y": 0.97846,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.734,
              "y": 0.97802,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700837269"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a47",
            "leftCorner": {
              "x": 15.734,
              "y": 0.97802,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.634,
              "y": 0.97767,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600514511"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a48",
            "leftCorner": {
              "x": 15.634,
              "y": 0.97767,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.523,
              "y": 0.97729,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600234402"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a49",
            "leftCorner": {
              "x": 15.523,
              "y": 0.97729,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.448,
              "y": 0.97703,
              "z": 1.4802
            },
            "stockLevel": "NO_STOCK",
            "gtin": "4058172893698"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a4a",
            "leftCorner": {
              "x": 15.448,
              "y": 0.97703,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.363,
              "y": 0.97673,
              "z": 1.4802
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700438107"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a42",
            "leftCorner": {
              "x": 15.363,
              "y": 0.97673,
              "z": 1.4802
            },
            "rightCorner": {
              "x": 15.243,
              "y": 0.97632,
              "z": 1.4802
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4027600484517"
          }
        ]
      },
      {
        "id": "679aebdc1f3fd8b81ad3ae27",
        "height": 1.737,
        "facings": [
          {
            "id": "679afb3f3d9bab0f83ff6a2e",
            "leftCorner": {
              "x": 16.243,
              "y": 0.97886,
              "z": 1.737
            },
            "rightCorner": {
              "x": 16.07,
              "y": 0.97825,
              "z": 1.737
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062700836354"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a30",
            "leftCorner": {
              "x": 16.07,
              "y": 0.97825,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.989,
              "y": 0.97798,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700836293"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a31",
            "leftCorner": {
              "x": 15.989,
              "y": 0.97798,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.888,
              "y": 0.97762,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4027600444405"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a32",
            "leftCorner": {
              "x": 15.888,
              "y": 0.97762,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.791,
              "y": 0.97729,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447757330"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a33",
            "leftCorner": {
              "x": 15.791,
              "y": 0.97729,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.689,
              "y": 0.97694,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447397338"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a34",
            "leftCorner": {
              "x": 15.689,
              "y": 0.97694,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.588,
              "y": 0.97658,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4066447397314"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a35",
            "leftCorner": {
              "x": 15.588,
              "y": 0.97658,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.452,
              "y": 0.97611,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4062700636558"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a36",
            "leftCorner": {
              "x": 15.452,
              "y": 0.97611,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.317,
              "y": 0.97565,
              "z": 1.737
            },
            "stockLevel": "HAS_STOCK",
            "gtin": "4058172737442"
          },
          {
            "id": "679afb3f3d9bab0f83ff6a2f",
            "leftCorner": {
              "x": 15.317,
              "y": 0.97565,
              "z": 1.737
            },
            "rightCorner": {
              "x": 15.243,
              "y": 0.97539,
              "z": 1.737
            },
            "stockLevel": "UNKNOWN",
            "gtin": "4062700836309"
          }
        ]
      }
    ],
    "statistics": {
      "noStockCount": 2,
      "hasStockCount": 46,
      "unknownStockCount": 13
    },
    "name": "FA84",
    "leftNeighborShelfId": "2PQJ"
  }
]